import * as Xe from "react";
import pn, { useState as En, useEffect as Rr, useRef as Mr, forwardRef as G9, createElement as Ac, createContext as V9, useCallback as pa, useMemo as ii, useContext as xo, useLayoutEffect as I8, memo as R8 } from "react";
import { createPortal as M8 } from "react-dom";
var _t = "colors", dn = "sizes", we = "space", x8 = { gap: we, gridGap: we, columnGap: we, gridColumnGap: we, rowGap: we, gridRowGap: we, inset: we, insetBlock: we, insetBlockEnd: we, insetBlockStart: we, insetInline: we, insetInlineEnd: we, insetInlineStart: we, margin: we, marginTop: we, marginRight: we, marginBottom: we, marginLeft: we, marginBlock: we, marginBlockEnd: we, marginBlockStart: we, marginInline: we, marginInlineEnd: we, marginInlineStart: we, padding: we, paddingTop: we, paddingRight: we, paddingBottom: we, paddingLeft: we, paddingBlock: we, paddingBlockEnd: we, paddingBlockStart: we, paddingInline: we, paddingInlineEnd: we, paddingInlineStart: we, top: we, right: we, bottom: we, left: we, scrollMargin: we, scrollMarginTop: we, scrollMarginRight: we, scrollMarginBottom: we, scrollMarginLeft: we, scrollMarginX: we, scrollMarginY: we, scrollMarginBlock: we, scrollMarginBlockEnd: we, scrollMarginBlockStart: we, scrollMarginInline: we, scrollMarginInlineEnd: we, scrollMarginInlineStart: we, scrollPadding: we, scrollPaddingTop: we, scrollPaddingRight: we, scrollPaddingBottom: we, scrollPaddingLeft: we, scrollPaddingX: we, scrollPaddingY: we, scrollPaddingBlock: we, scrollPaddingBlockEnd: we, scrollPaddingBlockStart: we, scrollPaddingInline: we, scrollPaddingInlineEnd: we, scrollPaddingInlineStart: we, fontSize: "fontSizes", background: _t, backgroundColor: _t, backgroundImage: _t, borderImage: _t, border: _t, borderBlock: _t, borderBlockEnd: _t, borderBlockStart: _t, borderBottom: _t, borderBottomColor: _t, borderColor: _t, borderInline: _t, borderInlineEnd: _t, borderInlineStart: _t, borderLeft: _t, borderLeftColor: _t, borderRight: _t, borderRightColor: _t, borderTop: _t, borderTopColor: _t, caretColor: _t, color: _t, columnRuleColor: _t, fill: _t, outline: _t, outlineColor: _t, stroke: _t, textDecorationColor: _t, fontFamily: "fonts", fontWeight: "fontWeights", lineHeight: "lineHeights", letterSpacing: "letterSpacings", blockSize: dn, minBlockSize: dn, maxBlockSize: dn, inlineSize: dn, minInlineSize: dn, maxInlineSize: dn, width: dn, minWidth: dn, maxWidth: dn, height: dn, minHeight: dn, maxHeight: dn, flexBasis: dn, gridTemplateColumns: dn, gridTemplateRows: dn, borderWidth: "borderWidths", borderTopWidth: "borderWidths", borderRightWidth: "borderWidths", borderBottomWidth: "borderWidths", borderLeftWidth: "borderWidths", borderStyle: "borderStyles", borderTopStyle: "borderStyles", borderRightStyle: "borderStyles", borderBottomStyle: "borderStyles", borderLeftStyle: "borderStyles", borderRadius: "radii", borderTopLeftRadius: "radii", borderTopRightRadius: "radii", borderBottomRightRadius: "radii", borderBottomLeftRadius: "radii", boxShadow: "shadows", textShadow: "shadows", transition: "transitions", zIndex: "zIndices" }, k8 = (e, t) => typeof t == "function" ? { "()": Function.prototype.toString.call(t) } : t, oi = () => {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, n, ...r) => {
    const a = ((i) => JSON.stringify(i, k8))(t);
    return a in e ? e[a] : e[a] = n(t, ...r);
  };
}, Ta = Symbol.for("sxs.internal"), Cc = (e, t) => Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)), w0 = (e) => {
  for (const t in e)
    return !0;
  return !1;
}, { hasOwnProperty: P8 } = Object.prototype, Hu = (e) => e.includes("-") ? e : e.replace(/[A-Z]/g, (t) => "-" + t.toLowerCase()), B8 = /\s+(?![^()]*\))/, Ha = (e) => (t) => e(...typeof t == "string" ? String(t).split(B8) : [t]), I0 = { appearance: (e) => ({ WebkitAppearance: e, appearance: e }), backfaceVisibility: (e) => ({ WebkitBackfaceVisibility: e, backfaceVisibility: e }), backdropFilter: (e) => ({ WebkitBackdropFilter: e, backdropFilter: e }), backgroundClip: (e) => ({ WebkitBackgroundClip: e, backgroundClip: e }), boxDecorationBreak: (e) => ({ WebkitBoxDecorationBreak: e, boxDecorationBreak: e }), clipPath: (e) => ({ WebkitClipPath: e, clipPath: e }), content: (e) => ({ content: e.includes('"') || e.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : `"${e}"` }), hyphens: (e) => ({ WebkitHyphens: e, hyphens: e }), maskImage: (e) => ({ WebkitMaskImage: e, maskImage: e }), maskSize: (e) => ({ WebkitMaskSize: e, maskSize: e }), tabSize: (e) => ({ MozTabSize: e, tabSize: e }), textSizeAdjust: (e) => ({ WebkitTextSizeAdjust: e, textSizeAdjust: e }), userSelect: (e) => ({ WebkitUserSelect: e, userSelect: e }), marginBlock: Ha((e, t) => ({ marginBlockStart: e, marginBlockEnd: t || e })), marginInline: Ha((e, t) => ({ marginInlineStart: e, marginInlineEnd: t || e })), maxSize: Ha((e, t) => ({ maxBlockSize: e, maxInlineSize: t || e })), minSize: Ha((e, t) => ({ minBlockSize: e, minInlineSize: t || e })), paddingBlock: Ha((e, t) => ({ paddingBlockStart: e, paddingBlockEnd: t || e })), paddingInline: Ha((e, t) => ({ paddingInlineStart: e, paddingInlineEnd: t || e })) }, Gs = /([\d.]+)([^]*)/, F8 = (e, t) => e.length ? e.reduce((n, r) => (n.push(...t.map((a) => a.includes("&") ? a.replace(/&/g, /[ +>|~]/.test(r) && /&.*&/.test(a) ? `:is(${r})` : r) : r + " " + a)), n), []) : t, L8 = (e, t) => e in $8 && typeof t == "string" ? t.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (n, r, a, i) => r + (a === "stretch" ? `-moz-available${i};${Hu(e)}:${r}-webkit-fill-available` : `-moz-fit-content${i};${Hu(e)}:${r}fit-content`) + i) : String(t), $8 = { blockSize: 1, height: 1, inlineSize: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, width: 1 }, xr = (e) => e ? e + "-" : "", Y9 = (e, t, n) => e.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (r, a, i, o, s) => o == "$" == !!i ? r : (a || o == "--" ? "calc(" : "") + "var(--" + (o === "$" ? xr(t) + (s.includes("$") ? "" : xr(n)) + s.replace(/\$/g, "-") : s) + ")" + (a || o == "--" ? "*" + (a || "") + (i || "1") + ")" : "")), H8 = /\s*,\s*(?![^()]*\))/, U8 = Object.prototype.toString, Qa = (e, t, n, r, a) => {
  let i, o, s;
  const u = (l, c, f) => {
    let E, T;
    const g = (m) => {
      for (E in m) {
        const y = E.charCodeAt(0) === 64, O = y && Array.isArray(m[E]) ? m[E] : [m[E]];
        for (T of O) {
          const B = /[A-Z]/.test(b = E) ? b : b.replace(/-[^]/g, (C) => C[1].toUpperCase()), S = typeof T == "object" && T && T.toString === U8 && (!r.utils[B] || !c.length);
          if (B in r.utils && !S) {
            const C = r.utils[B];
            if (C !== o) {
              o = C, g(C(T)), o = null;
              continue;
            }
          } else if (B in I0) {
            const C = I0[B];
            if (C !== s) {
              s = C, g(C(T)), s = null;
              continue;
            }
          }
          if (y && (v = E.slice(1) in r.media ? "@media " + r.media[E.slice(1)] : E, E = v.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (C, I, G, V, w, Y) => {
            const X = Gs.test(I), H = 0.0625 * (X ? -1 : 1), [$, L] = X ? [V, I] : [I, V];
            return "(" + (G[0] === "=" ? "" : G[0] === ">" === X ? "max-" : "min-") + $ + ":" + (G[0] !== "=" && G.length === 1 ? L.replace(Gs, (Q, j, ee) => Number(j) + H * (G === ">" ? 1 : -1) + ee) : L) + (w ? ") and (" + (w[0] === ">" ? "min-" : "max-") + $ + ":" + (w.length === 1 ? Y.replace(Gs, (Q, j, ee) => Number(j) + H * (w === ">" ? -1 : 1) + ee) : Y) : "") + ")";
          })), S) {
            const C = y ? f.concat(E) : [...f], I = y ? [...c] : F8(c, E.split(H8));
            i !== void 0 && a(R0(...i)), i = void 0, u(T, I, C);
          } else
            i === void 0 && (i = [[], c, f]), E = y || E.charCodeAt(0) !== 36 ? E : `--${xr(r.prefix)}${E.slice(1).replace(/\$/g, "-")}`, T = S ? T : typeof T == "number" ? T && B in j8 ? String(T) + "px" : String(T) : Y9(L8(B, T == null ? "" : T), r.prefix, r.themeMap[B]), i[0].push(`${y ? `${E} ` : `${Hu(E)}:`}${T}`);
        }
      }
      var v, b;
    };
    g(l), i !== void 0 && a(R0(...i)), i = void 0;
  };
  u(e, t, n);
}, R0 = (e, t, n) => `${n.map((r) => `${r}{`).join("")}${t.length ? `${t.join(",")}{` : ""}${e.join(";")}${t.length ? "}" : ""}${Array(n.length ? n.length + 1 : 0).join("}")}`, j8 = { animationDelay: 1, animationDuration: 1, backgroundSize: 1, blockSize: 1, border: 1, borderBlock: 1, borderBlockEnd: 1, borderBlockEndWidth: 1, borderBlockStart: 1, borderBlockStartWidth: 1, borderBlockWidth: 1, borderBottom: 1, borderBottomLeftRadius: 1, borderBottomRightRadius: 1, borderBottomWidth: 1, borderEndEndRadius: 1, borderEndStartRadius: 1, borderInlineEnd: 1, borderInlineEndWidth: 1, borderInlineStart: 1, borderInlineStartWidth: 1, borderInlineWidth: 1, borderLeft: 1, borderLeftWidth: 1, borderRadius: 1, borderRight: 1, borderRightWidth: 1, borderSpacing: 1, borderStartEndRadius: 1, borderStartStartRadius: 1, borderTop: 1, borderTopLeftRadius: 1, borderTopRightRadius: 1, borderTopWidth: 1, borderWidth: 1, bottom: 1, columnGap: 1, columnRule: 1, columnRuleWidth: 1, columnWidth: 1, containIntrinsicSize: 1, flexBasis: 1, fontSize: 1, gap: 1, gridAutoColumns: 1, gridAutoRows: 1, gridTemplateColumns: 1, gridTemplateRows: 1, height: 1, inlineSize: 1, inset: 1, insetBlock: 1, insetBlockEnd: 1, insetBlockStart: 1, insetInline: 1, insetInlineEnd: 1, insetInlineStart: 1, left: 1, letterSpacing: 1, margin: 1, marginBlock: 1, marginBlockEnd: 1, marginBlockStart: 1, marginBottom: 1, marginInline: 1, marginInlineEnd: 1, marginInlineStart: 1, marginLeft: 1, marginRight: 1, marginTop: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, offsetDistance: 1, offsetRotate: 1, outline: 1, outlineOffset: 1, outlineWidth: 1, overflowClipMargin: 1, padding: 1, paddingBlock: 1, paddingBlockEnd: 1, paddingBlockStart: 1, paddingBottom: 1, paddingInline: 1, paddingInlineEnd: 1, paddingInlineStart: 1, paddingLeft: 1, paddingRight: 1, paddingTop: 1, perspective: 1, right: 1, rowGap: 1, scrollMargin: 1, scrollMarginBlock: 1, scrollMarginBlockEnd: 1, scrollMarginBlockStart: 1, scrollMarginBottom: 1, scrollMarginInline: 1, scrollMarginInlineEnd: 1, scrollMarginInlineStart: 1, scrollMarginLeft: 1, scrollMarginRight: 1, scrollMarginTop: 1, scrollPadding: 1, scrollPaddingBlock: 1, scrollPaddingBlockEnd: 1, scrollPaddingBlockStart: 1, scrollPaddingBottom: 1, scrollPaddingInline: 1, scrollPaddingInlineEnd: 1, scrollPaddingInlineStart: 1, scrollPaddingLeft: 1, scrollPaddingRight: 1, scrollPaddingTop: 1, shapeMargin: 1, textDecoration: 1, textDecorationThickness: 1, textIndent: 1, textUnderlineOffset: 1, top: 1, transitionDelay: 1, transitionDuration: 1, verticalAlign: 1, width: 1, wordSpacing: 1 }, M0 = (e) => String.fromCharCode(e + (e > 25 ? 39 : 97)), va = (e) => ((t) => {
  let n, r = "";
  for (n = Math.abs(t); n > 52; n = n / 52 | 0)
    r = M0(n % 52) + r;
  return M0(n % 52) + r;
})(((t, n) => {
  let r = n.length;
  for (; r; )
    t = 33 * t ^ n.charCodeAt(--r);
  return t;
})(5381, JSON.stringify(e)) >>> 0), zi = ["themed", "global", "styled", "onevar", "resonevar", "allvar", "inline"], z8 = (e) => {
  if (e.href && !e.href.startsWith(location.origin))
    return !1;
  try {
    return !!e.cssRules;
  } catch {
    return !1;
  }
}, G8 = (e) => {
  let t;
  const n = () => {
    const { cssRules: a } = t.sheet;
    return [].map.call(a, (i, o) => {
      const { cssText: s } = i;
      let u = "";
      if (s.startsWith("--sxs"))
        return "";
      if (a[o - 1] && (u = a[o - 1].cssText).startsWith("--sxs")) {
        if (!i.cssRules.length)
          return "";
        for (const l in t.rules)
          if (t.rules[l].group === i)
            return `--sxs{--sxs:${[...t.rules[l].cache].join(" ")}}${s}`;
        return i.cssRules.length ? `${u}${s}` : "";
      }
      return s;
    }).join("");
  }, r = () => {
    if (t) {
      const { rules: s, sheet: u } = t;
      if (!u.deleteRule) {
        for (; Object(Object(u.cssRules)[0]).type === 3; )
          u.cssRules.splice(0, 1);
        u.cssRules = [];
      }
      for (const l in s)
        delete s[l];
    }
    const a = Object(e).styleSheets || [];
    for (const s of a)
      if (z8(s)) {
        for (let u = 0, l = s.cssRules; l[u]; ++u) {
          const c = Object(l[u]);
          if (c.type !== 1)
            continue;
          const f = Object(l[u + 1]);
          if (f.type !== 4)
            continue;
          ++u;
          const { cssText: E } = c;
          if (!E.startsWith("--sxs"))
            continue;
          const T = E.slice(14, -3).trim().split(/\s+/), g = zi[T[0]];
          g && (t || (t = { sheet: s, reset: r, rules: {}, toString: n }), t.rules[g] = { group: f, index: u, cache: new Set(T) });
        }
        if (t)
          break;
      }
    if (!t) {
      const s = (u, l) => ({ type: l, cssRules: [], insertRule(c, f) {
        this.cssRules.splice(f, 0, s(c, { import: 3, undefined: 1 }[(c.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
      }, get cssText() {
        return u === "@media{}" ? `@media{${[].map.call(this.cssRules, (c) => c.cssText).join("")}}` : u;
      } });
      t = { sheet: e ? (e.head || e).appendChild(document.createElement("style")).sheet : s("", "text/css"), rules: {}, reset: r, toString: n };
    }
    const { sheet: i, rules: o } = t;
    for (let s = zi.length - 1; s >= 0; --s) {
      const u = zi[s];
      if (!o[u]) {
        const l = zi[s + 1], c = o[l] ? o[l].index : i.cssRules.length;
        i.insertRule("@media{}", c), i.insertRule(`--sxs{--sxs:${s}}`, c), o[u] = { group: i.cssRules[c + 1], index: c, cache: /* @__PURE__ */ new Set([s]) };
      }
      V8(o[u]);
    }
  };
  return r(), t;
}, V8 = (e) => {
  const t = e.group;
  let n = t.cssRules.length;
  e.apply = (r) => {
    try {
      t.insertRule(r, n), ++n;
    } catch {
    }
  };
}, Ni = Symbol(), Y8 = oi(), x0 = (e, t) => Y8(e, () => (...n) => {
  let r = { type: null, composers: /* @__PURE__ */ new Set() };
  for (const a of n)
    if (a != null)
      if (a[Ta]) {
        r.type == null && (r.type = a[Ta].type);
        for (const i of a[Ta].composers)
          r.composers.add(i);
      } else
        a.constructor !== Object || a.$$typeof ? r.type == null && (r.type = a) : r.composers.add(K8(a, e));
  return r.type == null && (r.type = "span"), r.composers.size || r.composers.add(["PJLV", {}, [], [], {}, []]), W8(e, r, t);
}), K8 = ({ variants: e, compoundVariants: t, defaultVariants: n, ...r }, a) => {
  const i = `${xr(a.prefix)}c-${va(r)}`, o = [], s = [], u = /* @__PURE__ */ Object.create(null), l = [];
  for (const E in n)
    u[E] = String(n[E]);
  if (typeof e == "object" && e)
    for (const E in e) {
      c = u, f = E, P8.call(c, f) || (u[E] = "undefined");
      const T = e[E];
      for (const g in T) {
        const m = { [E]: String(g) };
        String(g) === "undefined" && l.push(E);
        const v = T[g], b = [m, v, !w0(v)];
        o.push(b);
      }
    }
  var c, f;
  if (typeof t == "object" && t)
    for (const E of t) {
      let { css: T, ...g } = E;
      T = typeof T == "object" && T || {};
      for (const v in g)
        g[v] = String(g[v]);
      const m = [g, T, !w0(T)];
      s.push(m);
    }
  return [i, r, o, s, u, l];
}, W8 = (e, t, n) => {
  const [r, a, i, o] = q8(t.composers), s = typeof t.type == "function" || t.type.$$typeof ? ((f) => {
    function E() {
      for (let T = 0; T < E[Ni].length; T++) {
        const [g, m] = E[Ni][T];
        f.rules[g].apply(m);
      }
      return E[Ni] = [], null;
    }
    return E[Ni] = [], E.rules = {}, zi.forEach((T) => E.rules[T] = { apply: (g) => E[Ni].push([T, g]) }), E;
  })(n) : null, u = (s || n).rules, l = `.${r}${a.length > 1 ? `:where(.${a.slice(1).join(".")})` : ""}`, c = (f) => {
    f = typeof f == "object" && f || X8;
    const { css: E, ...T } = f, g = {};
    for (const b in i)
      if (delete T[b], b in f) {
        let y = f[b];
        typeof y == "object" && y ? g[b] = { "@initial": i[b], ...y } : (y = String(y), g[b] = y !== "undefined" || o.has(b) ? y : i[b]);
      } else
        g[b] = i[b];
    const m = /* @__PURE__ */ new Set([...a]);
    for (const [b, y, O, B] of t.composers) {
      n.rules.styled.cache.has(b) || (n.rules.styled.cache.add(b), Qa(y, [`.${b}`], [], e, (I) => {
        u.styled.apply(I);
      }));
      const S = k0(O, g, e.media), C = k0(B, g, e.media, !0);
      for (const I of S)
        if (I !== void 0)
          for (const [G, V, w] of I) {
            const Y = `${b}-${va(V)}-${G}`;
            m.add(Y);
            const X = (w ? n.rules.resonevar : n.rules.onevar).cache, H = w ? u.resonevar : u.onevar;
            X.has(Y) || (X.add(Y), Qa(V, [`.${Y}`], [], e, ($) => {
              H.apply($);
            }));
          }
      for (const I of C)
        if (I !== void 0)
          for (const [G, V] of I) {
            const w = `${b}-${va(V)}-${G}`;
            m.add(w), n.rules.allvar.cache.has(w) || (n.rules.allvar.cache.add(w), Qa(V, [`.${w}`], [], e, (Y) => {
              u.allvar.apply(Y);
            }));
          }
    }
    if (typeof E == "object" && E) {
      const b = `${r}-i${va(E)}-css`;
      m.add(b), n.rules.inline.cache.has(b) || (n.rules.inline.cache.add(b), Qa(E, [`.${b}`], [], e, (y) => {
        u.inline.apply(y);
      }));
    }
    for (const b of String(f.className || "").trim().split(/\s+/))
      b && m.add(b);
    const v = T.className = [...m].join(" ");
    return { type: t.type, className: v, selector: l, props: T, toString: () => v, deferredInjector: s };
  };
  return Cc(c, { className: r, selector: l, [Ta]: t, toString: () => (n.rules.styled.cache.has(r) || c(), r) });
}, q8 = (e) => {
  let t = "";
  const n = [], r = {}, a = [];
  for (const [i, , , , o, s] of e) {
    t === "" && (t = i), n.push(i), a.push(...s);
    for (const u in o) {
      const l = o[u];
      (r[u] === void 0 || l !== "undefined" || s.includes(l)) && (r[u] = l);
    }
  }
  return [t, n, r, new Set(a)];
}, k0 = (e, t, n, r) => {
  const a = [];
  e:
    for (let [i, o, s] of e) {
      if (s)
        continue;
      let u, l = 0, c = !1;
      for (u in i) {
        const f = i[u];
        let E = t[u];
        if (E !== f) {
          if (typeof E != "object" || !E)
            continue e;
          {
            let T, g, m = 0;
            for (const v in E) {
              if (f === String(E[v])) {
                if (v !== "@initial") {
                  const b = v.slice(1);
                  (g = g || []).push(b in n ? n[b] : v.replace(/^@media ?/, "")), c = !0;
                }
                l += m, T = !0;
              }
              ++m;
            }
            if (g && g.length && (o = { ["@media " + g.join(", ")]: o }), !T)
              continue e;
          }
        }
      }
      (a[l] = a[l] || []).push([r ? "cv" : `${u}-${i[u]}`, o, c]);
    }
  return a;
}, X8 = {}, Q8 = oi(), Z8 = (e, t) => Q8(e, () => (...n) => {
  const r = () => {
    for (let a of n) {
      a = typeof a == "object" && a || {};
      let i = va(a);
      if (!t.rules.global.cache.has(i)) {
        if (t.rules.global.cache.add(i), "@import" in a) {
          let o = [].indexOf.call(t.sheet.cssRules, t.rules.themed.group) - 1;
          for (let s of [].concat(a["@import"]))
            s = s.includes('"') || s.includes("'") ? s : `"${s}"`, t.sheet.insertRule(`@import ${s};`, o++);
          delete a["@import"];
        }
        Qa(a, [], [], e, (o) => {
          t.rules.global.apply(o);
        });
      }
    }
    return "";
  };
  return Cc(r, { toString: r });
}), J8 = oi(), ev = (e, t) => J8(e, () => (n) => {
  const r = `${xr(e.prefix)}k-${va(n)}`, a = () => {
    if (!t.rules.global.cache.has(r)) {
      t.rules.global.cache.add(r);
      const i = [];
      Qa(n, [], [], e, (s) => i.push(s));
      const o = `@keyframes ${r}{${i.join("")}}`;
      t.rules.global.apply(o);
    }
    return r;
  };
  return Cc(a, { get name() {
    return a();
  }, toString: a });
}), tv = class {
  constructor(e, t, n, r) {
    this.token = e == null ? "" : String(e), this.value = t == null ? "" : String(t), this.scale = n == null ? "" : String(n), this.prefix = r == null ? "" : String(r);
  }
  get computedValue() {
    return "var(" + this.variable + ")";
  }
  get variable() {
    return "--" + xr(this.prefix) + xr(this.scale) + this.token;
  }
  toString() {
    return this.computedValue;
  }
}, nv = oi(), rv = (e, t) => nv(e, () => (n, r) => {
  r = typeof n == "object" && n || Object(r);
  const a = `.${n = (n = typeof n == "string" ? n : "") || `${xr(e.prefix)}t-${va(r)}`}`, i = {}, o = [];
  for (const u in r) {
    i[u] = {};
    for (const l in r[u]) {
      const c = `--${xr(e.prefix)}${u}-${l}`, f = Y9(String(r[u][l]), e.prefix, u);
      i[u][l] = new tv(l, f, u, e.prefix), o.push(`${c}:${f}`);
    }
  }
  const s = () => {
    if (o.length && !t.rules.themed.cache.has(n)) {
      t.rules.themed.cache.add(n);
      const u = `${r === e.theme ? ":root," : ""}.${n}{${o.join(";")}}`;
      t.rules.themed.apply(u);
    }
    return n;
  };
  return { ...i, get className() {
    return s();
  }, selector: a, toString: s };
}), av = oi(), P0, iv = oi(), K9 = (e) => {
  const t = ((n) => {
    let r = !1;
    const a = av(n, (i) => {
      r = !0;
      const o = "prefix" in (i = typeof i == "object" && i || {}) ? String(i.prefix) : "", s = typeof i.media == "object" && i.media || {}, u = typeof i.root == "object" ? i.root || null : globalThis.document || null, l = typeof i.theme == "object" && i.theme || {}, c = { prefix: o, media: s, theme: l, themeMap: typeof i.themeMap == "object" && i.themeMap || { ...x8 }, utils: typeof i.utils == "object" && i.utils || {} }, f = G8(u), E = { css: x0(c, f), globalCss: Z8(c, f), keyframes: ev(c, f), createTheme: rv(c, f), reset() {
        f.reset(), E.theme.toString();
      }, theme: {}, sheet: f, config: c, prefix: o, getCssText: f.toString, toString: f.toString };
      return String(E.theme = E.createTheme(l)), E;
    });
    return r || a.reset(), a;
  })(e);
  return t.styled = (({ config: n, sheet: r }) => iv(n, () => {
    const a = x0(n, r);
    return (...i) => {
      const o = a(...i), s = o[Ta].type, u = pn.forwardRef((l, c) => {
        const f = l && l.as || s, { props: E, deferredInjector: T } = o(l);
        return delete E.as, E.ref = c, T ? pn.createElement(pn.Fragment, null, pn.createElement(f, E), pn.createElement(T, null)) : pn.createElement(f, E);
      });
      return u.className = o.className, u.displayName = `Styled.${s.displayName || s.name || s}`, u.selector = o.selector, u.toString = () => o.selector, u[Ta] = o[Ta], u;
    };
  }))(t), t;
}, W9 = () => P0 || (P0 = K9()), ov = (...e) => W9().createTheme(...e), ko = (...e) => W9().keyframes(...e);
const sv = ko({
  "50%": { opacity: 1 }
}), q9 = ko({
  from: { opacity: 0 },
  to: { opacity: 1 }
}), uv = ko({
  from: { transform: "rotate(0deg)" },
  to: { transform: "rotate(360deg)" }
}), lv = (e) => ko({
  from: { transform: `translateY(${e}px)` },
  to: { transform: "translateY(0px)" }
}), X9 = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
};
var ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function cv(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function _c(e) {
  var t = e.default;
  if (typeof t == "function") {
    var n = function() {
      return t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var a = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var Q9 = { exports: {} };
/**
 * chroma.js - JavaScript library for color conversions
 *
 * Copyright (c) 2011-2019, Gregor Aisch
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 * derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * -------------------------------------------------------
 *
 * chroma.js includes colors from colorbrewer2.org, which are released under
 * the following license:
 *
 * Copyright (c) 2002 Cynthia Brewer, Mark Harrower,
 * and The Pennsylvania State University.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 * either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 *
 * ------------------------------------------------------
 *
 * Named colors are taken from X11 Color Names.
 * http://www.w3.org/TR/css3-color/#svg-color
 *
 * @preserve
 */
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ft, function() {
    for (var n = function(h, p, A) {
      return p === void 0 && (p = 0), A === void 0 && (A = 1), h < p ? p : h > A ? A : h;
    }, r = n, a = function(h) {
      h._clipped = !1, h._unclipped = h.slice(0);
      for (var p = 0; p <= 3; p++)
        p < 3 ? ((h[p] < 0 || h[p] > 255) && (h._clipped = !0), h[p] = r(h[p], 0, 255)) : p === 3 && (h[p] = r(h[p], 0, 1));
      return h;
    }, i = {}, o = 0, s = ["Boolean", "Number", "String", "Function", "Array", "Date", "RegExp", "Undefined", "Null"]; o < s.length; o += 1) {
      var u = s[o];
      i["[object " + u + "]"] = u.toLowerCase();
    }
    var l = function(h) {
      return i[Object.prototype.toString.call(h)] || "object";
    }, c = l, f = function(h, p) {
      return p === void 0 && (p = null), h.length >= 3 ? Array.prototype.slice.call(h) : c(h[0]) == "object" && p ? p.split("").filter(function(A) {
        return h[0][A] !== void 0;
      }).map(function(A) {
        return h[0][A];
      }) : h[0];
    }, E = l, T = function(h) {
      if (h.length < 2)
        return null;
      var p = h.length - 1;
      return E(h[p]) == "string" ? h[p].toLowerCase() : null;
    }, g = Math.PI, m = {
      clip_rgb: a,
      limit: n,
      type: l,
      unpack: f,
      last: T,
      PI: g,
      TWOPI: g * 2,
      PITHIRD: g / 3,
      DEG2RAD: g / 180,
      RAD2DEG: 180 / g
    }, v = {
      format: {},
      autodetect: []
    }, b = m.last, y = m.clip_rgb, O = m.type, B = v, S = function() {
      for (var p = [], A = arguments.length; A--; )
        p[A] = arguments[A];
      var N = this;
      if (O(p[0]) === "object" && p[0].constructor && p[0].constructor === this.constructor)
        return p[0];
      var F = b(p), U = !1;
      if (!F) {
        U = !0, B.sorted || (B.autodetect = B.autodetect.sort(function(ie, De) {
          return De.p - ie.p;
        }), B.sorted = !0);
        for (var x = 0, K = B.autodetect; x < K.length; x += 1) {
          var W = K[x];
          if (F = W.test.apply(W, p), F)
            break;
        }
      }
      if (B.format[F]) {
        var ne = B.format[F].apply(null, U ? p : p.slice(0, -1));
        N._rgb = y(ne);
      } else
        throw new Error("unknown format: " + p);
      N._rgb.length === 3 && N._rgb.push(1);
    };
    S.prototype.toString = function() {
      return O(this.hex) == "function" ? this.hex() : "[" + this._rgb.join(",") + "]";
    };
    var C = S, I = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(I.Color, [null].concat(h)))();
    };
    I.Color = C, I.version = "2.4.2";
    var G = I, V = m.unpack, w = Math.max, Y = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = V(h, "rgb"), N = A[0], F = A[1], U = A[2];
      N = N / 255, F = F / 255, U = U / 255;
      var x = 1 - w(N, w(F, U)), K = x < 1 ? 1 / (1 - x) : 0, W = (1 - N - x) * K, ne = (1 - F - x) * K, ie = (1 - U - x) * K;
      return [W, ne, ie, x];
    }, X = Y, H = m.unpack, $ = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      h = H(h, "cmyk");
      var A = h[0], N = h[1], F = h[2], U = h[3], x = h.length > 4 ? h[4] : 1;
      return U === 1 ? [0, 0, 0, x] : [
        A >= 1 ? 0 : 255 * (1 - A) * (1 - U),
        N >= 1 ? 0 : 255 * (1 - N) * (1 - U),
        F >= 1 ? 0 : 255 * (1 - F) * (1 - U),
        x
      ];
    }, L = $, Q = G, j = C, ee = v, J = m.unpack, z = m.type, _ = X;
    j.prototype.cmyk = function() {
      return _(this._rgb);
    }, Q.cmyk = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(j, [null].concat(h, ["cmyk"])))();
    }, ee.format.cmyk = L, ee.autodetect.push({
      p: 2,
      test: function() {
        for (var h = [], p = arguments.length; p--; )
          h[p] = arguments[p];
        if (h = J(h, "cmyk"), z(h) === "array" && h.length === 4)
          return "cmyk";
      }
    });
    var D = m.unpack, he = m.last, oe = function(h) {
      return Math.round(h * 100) / 100;
    }, ve = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = D(h, "hsla"), N = he(h) || "lsa";
      return A[0] = oe(A[0] || 0), A[1] = oe(A[1] * 100) + "%", A[2] = oe(A[2] * 100) + "%", N === "hsla" || A.length > 3 && A[3] < 1 ? (A[3] = A.length > 3 ? A[3] : 1, N = "hsla") : A.length = 3, N + "(" + A.join(",") + ")";
    }, le = ve, Ce = m.unpack, _e = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      h = Ce(h, "rgba");
      var A = h[0], N = h[1], F = h[2];
      A /= 255, N /= 255, F /= 255;
      var U = Math.min(A, N, F), x = Math.max(A, N, F), K = (x + U) / 2, W, ne;
      return x === U ? (W = 0, ne = Number.NaN) : W = K < 0.5 ? (x - U) / (x + U) : (x - U) / (2 - x - U), A == x ? ne = (N - F) / (x - U) : N == x ? ne = 2 + (F - A) / (x - U) : F == x && (ne = 4 + (A - N) / (x - U)), ne *= 60, ne < 0 && (ne += 360), h.length > 3 && h[3] !== void 0 ? [ne, W, K, h[3]] : [ne, W, K];
    }, ge = _e, ye = m.unpack, ze = m.last, ce = le, Dt = ge, Se = Math.round, Gt = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = ye(h, "rgba"), N = ze(h) || "rgb";
      return N.substr(0, 3) == "hsl" ? ce(Dt(A), N) : (A[0] = Se(A[0]), A[1] = Se(A[1]), A[2] = Se(A[2]), (N === "rgba" || A.length > 3 && A[3] < 1) && (A[3] = A.length > 3 ? A[3] : 1, N = "rgba"), N + "(" + A.slice(0, N === "rgb" ? 3 : 4).join(",") + ")");
    }, on = Gt, kn = m.unpack, Pn = Math.round, Wn = function() {
      for (var h, p = [], A = arguments.length; A--; )
        p[A] = arguments[A];
      p = kn(p, "hsl");
      var N = p[0], F = p[1], U = p[2], x, K, W;
      if (F === 0)
        x = K = W = U * 255;
      else {
        var ne = [0, 0, 0], ie = [0, 0, 0], De = U < 0.5 ? U * (1 + F) : U + F - U * F, ue = 2 * U - De, Ne = N / 360;
        ne[0] = Ne + 1 / 3, ne[1] = Ne, ne[2] = Ne - 1 / 3;
        for (var Oe = 0; Oe < 3; Oe++)
          ne[Oe] < 0 && (ne[Oe] += 1), ne[Oe] > 1 && (ne[Oe] -= 1), 6 * ne[Oe] < 1 ? ie[Oe] = ue + (De - ue) * 6 * ne[Oe] : 2 * ne[Oe] < 1 ? ie[Oe] = De : 3 * ne[Oe] < 2 ? ie[Oe] = ue + (De - ue) * (2 / 3 - ne[Oe]) * 6 : ie[Oe] = ue;
        h = [Pn(ie[0] * 255), Pn(ie[1] * 255), Pn(ie[2] * 255)], x = h[0], K = h[1], W = h[2];
      }
      return p.length > 3 ? [x, K, W, p[3]] : [x, K, W, 1];
    }, cr = Wn, qn = cr, sn = v, vr = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/, Ar = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/, hn = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/, Tn = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/, Dn = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/, Z = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/, Ee = Math.round, ke = function(h) {
      h = h.toLowerCase().trim();
      var p;
      if (sn.format.named)
        try {
          return sn.format.named(h);
        } catch {
        }
      if (p = h.match(vr)) {
        for (var A = p.slice(1, 4), N = 0; N < 3; N++)
          A[N] = +A[N];
        return A[3] = 1, A;
      }
      if (p = h.match(Ar)) {
        for (var F = p.slice(1, 5), U = 0; U < 4; U++)
          F[U] = +F[U];
        return F;
      }
      if (p = h.match(hn)) {
        for (var x = p.slice(1, 4), K = 0; K < 3; K++)
          x[K] = Ee(x[K] * 2.55);
        return x[3] = 1, x;
      }
      if (p = h.match(Tn)) {
        for (var W = p.slice(1, 5), ne = 0; ne < 3; ne++)
          W[ne] = Ee(W[ne] * 2.55);
        return W[3] = +W[3], W;
      }
      if (p = h.match(Dn)) {
        var ie = p.slice(1, 4);
        ie[1] *= 0.01, ie[2] *= 0.01;
        var De = qn(ie);
        return De[3] = 1, De;
      }
      if (p = h.match(Z)) {
        var ue = p.slice(1, 4);
        ue[1] *= 0.01, ue[2] *= 0.01;
        var Ne = qn(ue);
        return Ne[3] = +p[4], Ne;
      }
    };
    ke.test = function(h) {
      return vr.test(h) || Ar.test(h) || hn.test(h) || Tn.test(h) || Dn.test(h) || Z.test(h);
    };
    var je = ke, qt = G, Bn = C, at = v, $t = m.type, Fn = on, Ln = je;
    Bn.prototype.css = function(h) {
      return Fn(this._rgb, h);
    }, qt.css = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(Bn, [null].concat(h, ["css"])))();
    }, at.format.css = Ln, at.autodetect.push({
      p: 5,
      test: function(h) {
        for (var p = [], A = arguments.length - 1; A-- > 0; )
          p[A] = arguments[A + 1];
        if (!p.length && $t(h) === "string" && Ln.test(h))
          return "css";
      }
    });
    var Ct = C, Xn = G, un = v, Hr = m.unpack;
    un.format.gl = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = Hr(h, "rgba");
      return A[0] *= 255, A[1] *= 255, A[2] *= 255, A;
    }, Xn.gl = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(Ct, [null].concat(h, ["gl"])))();
    }, Ct.prototype.gl = function() {
      var h = this._rgb;
      return [h[0] / 255, h[1] / 255, h[2] / 255, h[3]];
    };
    var Ci = m.unpack, _i = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = Ci(h, "rgb"), N = A[0], F = A[1], U = A[2], x = Math.min(N, F, U), K = Math.max(N, F, U), W = K - x, ne = W * 100 / 255, ie = x / (255 - W) * 100, De;
      return W === 0 ? De = Number.NaN : (N === K && (De = (F - U) / W), F === K && (De = 2 + (U - N) / W), U === K && (De = 4 + (N - F) / W), De *= 60, De < 0 && (De += 360)), [De, ne, ie];
    }, _1 = _i, cs = m.unpack, b1 = Math.floor, fs = function() {
      for (var h, p, A, N, F, U, x = [], K = arguments.length; K--; )
        x[K] = arguments[K];
      x = cs(x, "hcg");
      var W = x[0], ne = x[1], ie = x[2], De, ue, Ne;
      ie = ie * 255;
      var Oe = ne * 255;
      if (ne === 0)
        De = ue = Ne = ie;
      else {
        W === 360 && (W = 0), W > 360 && (W -= 360), W < 0 && (W += 360), W /= 60;
        var Ye = b1(W), Ze = W - Ye, it = ie * (1 - ne), ct = it + Oe * (1 - Ze), en = it + Oe * Ze, Zt = it + Oe;
        switch (Ye) {
          case 0:
            h = [Zt, en, it], De = h[0], ue = h[1], Ne = h[2];
            break;
          case 1:
            p = [ct, Zt, it], De = p[0], ue = p[1], Ne = p[2];
            break;
          case 2:
            A = [it, Zt, en], De = A[0], ue = A[1], Ne = A[2];
            break;
          case 3:
            N = [it, ct, Zt], De = N[0], ue = N[1], Ne = N[2];
            break;
          case 4:
            F = [en, it, Zt], De = F[0], ue = F[1], Ne = F[2];
            break;
          case 5:
            U = [Zt, it, ct], De = U[0], ue = U[1], Ne = U[2];
            break;
        }
      }
      return [De, ue, Ne, x.length > 3 ? x[3] : 1];
    }, y1 = fs, D1 = m.unpack, hs = m.type, ds = G, bi = C, S1 = v, ms = _1;
    bi.prototype.hcg = function() {
      return ms(this._rgb);
    }, ds.hcg = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(bi, [null].concat(h, ["hcg"])))();
    }, S1.format.hcg = y1, S1.autodetect.push({
      p: 1,
      test: function() {
        for (var h = [], p = arguments.length; p--; )
          h[p] = arguments[p];
        if (h = D1(h, "hcg"), hs(h) === "array" && h.length === 3)
          return "hcg";
      }
    });
    var ps = m.unpack, gs = m.last, k = Math.round, se = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = ps(h, "rgba"), N = A[0], F = A[1], U = A[2], x = A[3], K = gs(h) || "auto";
      x === void 0 && (x = 1), K === "auto" && (K = x < 1 ? "rgba" : "rgb"), N = k(N), F = k(F), U = k(U);
      var W = N << 16 | F << 8 | U, ne = "000000" + W.toString(16);
      ne = ne.substr(ne.length - 6);
      var ie = "0" + k(x * 255).toString(16);
      switch (ie = ie.substr(ie.length - 2), K.toLowerCase()) {
        case "rgba":
          return "#" + ne + ie;
        case "argb":
          return "#" + ie + ne;
        default:
          return "#" + ne;
      }
    }, be = se, Fe = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, ut = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/, vt = function(h) {
      if (h.match(Fe)) {
        (h.length === 4 || h.length === 7) && (h = h.substr(1)), h.length === 3 && (h = h.split(""), h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]);
        var p = parseInt(h, 16), A = p >> 16, N = p >> 8 & 255, F = p & 255;
        return [A, N, F, 1];
      }
      if (h.match(ut)) {
        (h.length === 5 || h.length === 9) && (h = h.substr(1)), h.length === 4 && (h = h.split(""), h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2] + h[3] + h[3]);
        var U = parseInt(h, 16), x = U >> 24 & 255, K = U >> 16 & 255, W = U >> 8 & 255, ne = Math.round((U & 255) / 255 * 100) / 100;
        return [x, K, W, ne];
      }
      throw new Error("unknown hex color: " + h);
    }, Qe = vt, We = G, Xt = C, Ht = m.type, Ut = v, vn = be;
    Xt.prototype.hex = function(h) {
      return vn(this._rgb, h);
    }, We.hex = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(Xt, [null].concat(h, ["hex"])))();
    }, Ut.format.hex = Qe, Ut.autodetect.push({
      p: 4,
      test: function(h) {
        for (var p = [], A = arguments.length - 1; A-- > 0; )
          p[A] = arguments[A + 1];
        if (!p.length && Ht(h) === "string" && [3, 4, 5, 6, 7, 8, 9].indexOf(h.length) >= 0)
          return "hex";
      }
    });
    var Ur = m.unpack, yi = m.TWOPI, Qn = Math.min, i4 = Math.sqrt, o4 = Math.acos, s4 = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = Ur(h, "rgb"), N = A[0], F = A[1], U = A[2];
      N /= 255, F /= 255, U /= 255;
      var x, K = Qn(N, F, U), W = (N + F + U) / 3, ne = W > 0 ? 1 - K / W : 0;
      return ne === 0 ? x = NaN : (x = (N - F + (N - U)) / 2, x /= i4((N - F) * (N - F) + (N - U) * (F - U)), x = o4(x), U > F && (x = yi - x), x /= yi), [x * 360, ne, W];
    }, u4 = s4, l4 = m.unpack, Es = m.limit, Ia = m.TWOPI, Ts = m.PITHIRD, Ra = Math.cos, c4 = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      h = l4(h, "hsi");
      var A = h[0], N = h[1], F = h[2], U, x, K;
      return isNaN(A) && (A = 0), isNaN(N) && (N = 0), A > 360 && (A -= 360), A < 0 && (A += 360), A /= 360, A < 1 / 3 ? (K = (1 - N) / 3, U = (1 + N * Ra(Ia * A) / Ra(Ts - Ia * A)) / 3, x = 1 - (K + U)) : A < 2 / 3 ? (A -= 1 / 3, U = (1 - N) / 3, x = (1 + N * Ra(Ia * A) / Ra(Ts - Ia * A)) / 3, K = 1 - (U + x)) : (A -= 2 / 3, x = (1 - N) / 3, K = (1 + N * Ra(Ia * A) / Ra(Ts - Ia * A)) / 3, U = 1 - (x + K)), U = Es(F * U * 3), x = Es(F * x * 3), K = Es(F * K * 3), [U * 255, x * 255, K * 255, h.length > 3 ? h[3] : 1];
    }, f4 = c4, h4 = m.unpack, d4 = m.type, m4 = G, yf = C, Df = v, p4 = u4;
    yf.prototype.hsi = function() {
      return p4(this._rgb);
    }, m4.hsi = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(yf, [null].concat(h, ["hsi"])))();
    }, Df.format.hsi = f4, Df.autodetect.push({
      p: 2,
      test: function() {
        for (var h = [], p = arguments.length; p--; )
          h[p] = arguments[p];
        if (h = h4(h, "hsi"), d4(h) === "array" && h.length === 3)
          return "hsi";
      }
    });
    var g4 = m.unpack, E4 = m.type, T4 = G, Sf = C, Of = v, v4 = ge;
    Sf.prototype.hsl = function() {
      return v4(this._rgb);
    }, T4.hsl = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(Sf, [null].concat(h, ["hsl"])))();
    }, Of.format.hsl = cr, Of.autodetect.push({
      p: 2,
      test: function() {
        for (var h = [], p = arguments.length; p--; )
          h[p] = arguments[p];
        if (h = g4(h, "hsl"), E4(h) === "array" && h.length === 3)
          return "hsl";
      }
    });
    var A4 = m.unpack, C4 = Math.min, _4 = Math.max, b4 = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      h = A4(h, "rgb");
      var A = h[0], N = h[1], F = h[2], U = C4(A, N, F), x = _4(A, N, F), K = x - U, W, ne, ie;
      return ie = x / 255, x === 0 ? (W = Number.NaN, ne = 0) : (ne = K / x, A === x && (W = (N - F) / K), N === x && (W = 2 + (F - A) / K), F === x && (W = 4 + (A - N) / K), W *= 60, W < 0 && (W += 360)), [W, ne, ie];
    }, y4 = b4, D4 = m.unpack, S4 = Math.floor, O4 = function() {
      for (var h, p, A, N, F, U, x = [], K = arguments.length; K--; )
        x[K] = arguments[K];
      x = D4(x, "hsv");
      var W = x[0], ne = x[1], ie = x[2], De, ue, Ne;
      if (ie *= 255, ne === 0)
        De = ue = Ne = ie;
      else {
        W === 360 && (W = 0), W > 360 && (W -= 360), W < 0 && (W += 360), W /= 60;
        var Oe = S4(W), Ye = W - Oe, Ze = ie * (1 - ne), it = ie * (1 - ne * Ye), ct = ie * (1 - ne * (1 - Ye));
        switch (Oe) {
          case 0:
            h = [ie, ct, Ze], De = h[0], ue = h[1], Ne = h[2];
            break;
          case 1:
            p = [it, ie, Ze], De = p[0], ue = p[1], Ne = p[2];
            break;
          case 2:
            A = [Ze, ie, ct], De = A[0], ue = A[1], Ne = A[2];
            break;
          case 3:
            N = [Ze, it, ie], De = N[0], ue = N[1], Ne = N[2];
            break;
          case 4:
            F = [ct, Ze, ie], De = F[0], ue = F[1], Ne = F[2];
            break;
          case 5:
            U = [ie, Ze, it], De = U[0], ue = U[1], Ne = U[2];
            break;
        }
      }
      return [De, ue, Ne, x.length > 3 ? x[3] : 1];
    }, N4 = O4, w4 = m.unpack, I4 = m.type, R4 = G, Nf = C, wf = v, M4 = y4;
    Nf.prototype.hsv = function() {
      return M4(this._rgb);
    }, R4.hsv = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(Nf, [null].concat(h, ["hsv"])))();
    }, wf.format.hsv = N4, wf.autodetect.push({
      p: 2,
      test: function() {
        for (var h = [], p = arguments.length; p--; )
          h[p] = arguments[p];
        if (h = w4(h, "hsv"), I4(h) === "array" && h.length === 3)
          return "hsv";
      }
    });
    var O1 = {
      Kn: 18,
      Xn: 0.95047,
      Yn: 1,
      Zn: 1.08883,
      t0: 0.137931034,
      t1: 0.206896552,
      t2: 0.12841855,
      t3: 8856452e-9
    }, Ma = O1, x4 = m.unpack, If = Math.pow, k4 = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = x4(h, "rgb"), N = A[0], F = A[1], U = A[2], x = P4(N, F, U), K = x[0], W = x[1], ne = x[2], ie = 116 * W - 16;
      return [ie < 0 ? 0 : ie, 500 * (K - W), 200 * (W - ne)];
    }, vs = function(h) {
      return (h /= 255) <= 0.04045 ? h / 12.92 : If((h + 0.055) / 1.055, 2.4);
    }, As = function(h) {
      return h > Ma.t3 ? If(h, 1 / 3) : h / Ma.t2 + Ma.t0;
    }, P4 = function(h, p, A) {
      h = vs(h), p = vs(p), A = vs(A);
      var N = As((0.4124564 * h + 0.3575761 * p + 0.1804375 * A) / Ma.Xn), F = As((0.2126729 * h + 0.7151522 * p + 0.072175 * A) / Ma.Yn), U = As((0.0193339 * h + 0.119192 * p + 0.9503041 * A) / Ma.Zn);
      return [N, F, U];
    }, Rf = k4, xa = O1, B4 = m.unpack, F4 = Math.pow, L4 = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      h = B4(h, "lab");
      var A = h[0], N = h[1], F = h[2], U, x, K, W, ne, ie;
      return x = (A + 16) / 116, U = isNaN(N) ? x : x + N / 500, K = isNaN(F) ? x : x - F / 200, x = xa.Yn * _s(x), U = xa.Xn * _s(U), K = xa.Zn * _s(K), W = Cs(3.2404542 * U - 1.5371385 * x - 0.4985314 * K), ne = Cs(-0.969266 * U + 1.8760108 * x + 0.041556 * K), ie = Cs(0.0556434 * U - 0.2040259 * x + 1.0572252 * K), [W, ne, ie, h.length > 3 ? h[3] : 1];
    }, Cs = function(h) {
      return 255 * (h <= 304e-5 ? 12.92 * h : 1.055 * F4(h, 1 / 2.4) - 0.055);
    }, _s = function(h) {
      return h > xa.t1 ? h * h * h : xa.t2 * (h - xa.t0);
    }, Mf = L4, $4 = m.unpack, H4 = m.type, U4 = G, xf = C, kf = v, j4 = Rf;
    xf.prototype.lab = function() {
      return j4(this._rgb);
    }, U4.lab = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(xf, [null].concat(h, ["lab"])))();
    }, kf.format.lab = Mf, kf.autodetect.push({
      p: 2,
      test: function() {
        for (var h = [], p = arguments.length; p--; )
          h[p] = arguments[p];
        if (h = $4(h, "lab"), H4(h) === "array" && h.length === 3)
          return "lab";
      }
    });
    var z4 = m.unpack, G4 = m.RAD2DEG, V4 = Math.sqrt, Y4 = Math.atan2, K4 = Math.round, W4 = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = z4(h, "lab"), N = A[0], F = A[1], U = A[2], x = V4(F * F + U * U), K = (Y4(U, F) * G4 + 360) % 360;
      return K4(x * 1e4) === 0 && (K = Number.NaN), [N, x, K];
    }, Pf = W4, q4 = m.unpack, X4 = Rf, Q4 = Pf, Z4 = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = q4(h, "rgb"), N = A[0], F = A[1], U = A[2], x = X4(N, F, U), K = x[0], W = x[1], ne = x[2];
      return Q4(K, W, ne);
    }, J4 = Z4, eE = m.unpack, tE = m.DEG2RAD, nE = Math.sin, rE = Math.cos, aE = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = eE(h, "lch"), N = A[0], F = A[1], U = A[2];
      return isNaN(U) && (U = 0), U = U * tE, [N, rE(U) * F, nE(U) * F];
    }, Bf = aE, iE = m.unpack, oE = Bf, sE = Mf, uE = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      h = iE(h, "lch");
      var A = h[0], N = h[1], F = h[2], U = oE(A, N, F), x = U[0], K = U[1], W = U[2], ne = sE(x, K, W), ie = ne[0], De = ne[1], ue = ne[2];
      return [ie, De, ue, h.length > 3 ? h[3] : 1];
    }, Ff = uE, lE = m.unpack, cE = Ff, fE = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = lE(h, "hcl").reverse();
      return cE.apply(void 0, A);
    }, hE = fE, dE = m.unpack, mE = m.type, Lf = G, N1 = C, bs = v, $f = J4;
    N1.prototype.lch = function() {
      return $f(this._rgb);
    }, N1.prototype.hcl = function() {
      return $f(this._rgb).reverse();
    }, Lf.lch = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(N1, [null].concat(h, ["lch"])))();
    }, Lf.hcl = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(N1, [null].concat(h, ["hcl"])))();
    }, bs.format.lch = Ff, bs.format.hcl = hE, ["lch", "hcl"].forEach(function(h) {
      return bs.autodetect.push({
        p: 2,
        test: function() {
          for (var p = [], A = arguments.length; A--; )
            p[A] = arguments[A];
          if (p = dE(p, h), mE(p) === "array" && p.length === 3)
            return h;
        }
      });
    });
    var pE = {
      aliceblue: "#f0f8ff",
      antiquewhite: "#faebd7",
      aqua: "#00ffff",
      aquamarine: "#7fffd4",
      azure: "#f0ffff",
      beige: "#f5f5dc",
      bisque: "#ffe4c4",
      black: "#000000",
      blanchedalmond: "#ffebcd",
      blue: "#0000ff",
      blueviolet: "#8a2be2",
      brown: "#a52a2a",
      burlywood: "#deb887",
      cadetblue: "#5f9ea0",
      chartreuse: "#7fff00",
      chocolate: "#d2691e",
      coral: "#ff7f50",
      cornflower: "#6495ed",
      cornflowerblue: "#6495ed",
      cornsilk: "#fff8dc",
      crimson: "#dc143c",
      cyan: "#00ffff",
      darkblue: "#00008b",
      darkcyan: "#008b8b",
      darkgoldenrod: "#b8860b",
      darkgray: "#a9a9a9",
      darkgreen: "#006400",
      darkgrey: "#a9a9a9",
      darkkhaki: "#bdb76b",
      darkmagenta: "#8b008b",
      darkolivegreen: "#556b2f",
      darkorange: "#ff8c00",
      darkorchid: "#9932cc",
      darkred: "#8b0000",
      darksalmon: "#e9967a",
      darkseagreen: "#8fbc8f",
      darkslateblue: "#483d8b",
      darkslategray: "#2f4f4f",
      darkslategrey: "#2f4f4f",
      darkturquoise: "#00ced1",
      darkviolet: "#9400d3",
      deeppink: "#ff1493",
      deepskyblue: "#00bfff",
      dimgray: "#696969",
      dimgrey: "#696969",
      dodgerblue: "#1e90ff",
      firebrick: "#b22222",
      floralwhite: "#fffaf0",
      forestgreen: "#228b22",
      fuchsia: "#ff00ff",
      gainsboro: "#dcdcdc",
      ghostwhite: "#f8f8ff",
      gold: "#ffd700",
      goldenrod: "#daa520",
      gray: "#808080",
      green: "#008000",
      greenyellow: "#adff2f",
      grey: "#808080",
      honeydew: "#f0fff0",
      hotpink: "#ff69b4",
      indianred: "#cd5c5c",
      indigo: "#4b0082",
      ivory: "#fffff0",
      khaki: "#f0e68c",
      laserlemon: "#ffff54",
      lavender: "#e6e6fa",
      lavenderblush: "#fff0f5",
      lawngreen: "#7cfc00",
      lemonchiffon: "#fffacd",
      lightblue: "#add8e6",
      lightcoral: "#f08080",
      lightcyan: "#e0ffff",
      lightgoldenrod: "#fafad2",
      lightgoldenrodyellow: "#fafad2",
      lightgray: "#d3d3d3",
      lightgreen: "#90ee90",
      lightgrey: "#d3d3d3",
      lightpink: "#ffb6c1",
      lightsalmon: "#ffa07a",
      lightseagreen: "#20b2aa",
      lightskyblue: "#87cefa",
      lightslategray: "#778899",
      lightslategrey: "#778899",
      lightsteelblue: "#b0c4de",
      lightyellow: "#ffffe0",
      lime: "#00ff00",
      limegreen: "#32cd32",
      linen: "#faf0e6",
      magenta: "#ff00ff",
      maroon: "#800000",
      maroon2: "#7f0000",
      maroon3: "#b03060",
      mediumaquamarine: "#66cdaa",
      mediumblue: "#0000cd",
      mediumorchid: "#ba55d3",
      mediumpurple: "#9370db",
      mediumseagreen: "#3cb371",
      mediumslateblue: "#7b68ee",
      mediumspringgreen: "#00fa9a",
      mediumturquoise: "#48d1cc",
      mediumvioletred: "#c71585",
      midnightblue: "#191970",
      mintcream: "#f5fffa",
      mistyrose: "#ffe4e1",
      moccasin: "#ffe4b5",
      navajowhite: "#ffdead",
      navy: "#000080",
      oldlace: "#fdf5e6",
      olive: "#808000",
      olivedrab: "#6b8e23",
      orange: "#ffa500",
      orangered: "#ff4500",
      orchid: "#da70d6",
      palegoldenrod: "#eee8aa",
      palegreen: "#98fb98",
      paleturquoise: "#afeeee",
      palevioletred: "#db7093",
      papayawhip: "#ffefd5",
      peachpuff: "#ffdab9",
      peru: "#cd853f",
      pink: "#ffc0cb",
      plum: "#dda0dd",
      powderblue: "#b0e0e6",
      purple: "#800080",
      purple2: "#7f007f",
      purple3: "#a020f0",
      rebeccapurple: "#663399",
      red: "#ff0000",
      rosybrown: "#bc8f8f",
      royalblue: "#4169e1",
      saddlebrown: "#8b4513",
      salmon: "#fa8072",
      sandybrown: "#f4a460",
      seagreen: "#2e8b57",
      seashell: "#fff5ee",
      sienna: "#a0522d",
      silver: "#c0c0c0",
      skyblue: "#87ceeb",
      slateblue: "#6a5acd",
      slategray: "#708090",
      slategrey: "#708090",
      snow: "#fffafa",
      springgreen: "#00ff7f",
      steelblue: "#4682b4",
      tan: "#d2b48c",
      teal: "#008080",
      thistle: "#d8bfd8",
      tomato: "#ff6347",
      turquoise: "#40e0d0",
      violet: "#ee82ee",
      wheat: "#f5deb3",
      white: "#ffffff",
      whitesmoke: "#f5f5f5",
      yellow: "#ffff00",
      yellowgreen: "#9acd32"
    }, Hf = pE, gE = C, Uf = v, EE = m.type, Di = Hf, TE = Qe, vE = be;
    gE.prototype.name = function() {
      for (var h = vE(this._rgb, "rgb"), p = 0, A = Object.keys(Di); p < A.length; p += 1) {
        var N = A[p];
        if (Di[N] === h)
          return N.toLowerCase();
      }
      return h;
    }, Uf.format.named = function(h) {
      if (h = h.toLowerCase(), Di[h])
        return TE(Di[h]);
      throw new Error("unknown color name: " + h);
    }, Uf.autodetect.push({
      p: 5,
      test: function(h) {
        for (var p = [], A = arguments.length - 1; A-- > 0; )
          p[A] = arguments[A + 1];
        if (!p.length && EE(h) === "string" && Di[h.toLowerCase()])
          return "named";
      }
    });
    var AE = m.unpack, CE = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = AE(h, "rgb"), N = A[0], F = A[1], U = A[2];
      return (N << 16) + (F << 8) + U;
    }, _E = CE, bE = m.type, yE = function(h) {
      if (bE(h) == "number" && h >= 0 && h <= 16777215) {
        var p = h >> 16, A = h >> 8 & 255, N = h & 255;
        return [p, A, N, 1];
      }
      throw new Error("unknown num color: " + h);
    }, DE = yE, SE = G, jf = C, zf = v, OE = m.type, NE = _E;
    jf.prototype.num = function() {
      return NE(this._rgb);
    }, SE.num = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(jf, [null].concat(h, ["num"])))();
    }, zf.format.num = DE, zf.autodetect.push({
      p: 5,
      test: function() {
        for (var h = [], p = arguments.length; p--; )
          h[p] = arguments[p];
        if (h.length === 1 && OE(h[0]) === "number" && h[0] >= 0 && h[0] <= 16777215)
          return "num";
      }
    });
    var wE = G, ys = C, Gf = v, Vf = m.unpack, Yf = m.type, Kf = Math.round;
    ys.prototype.rgb = function(h) {
      return h === void 0 && (h = !0), h === !1 ? this._rgb.slice(0, 3) : this._rgb.slice(0, 3).map(Kf);
    }, ys.prototype.rgba = function(h) {
      return h === void 0 && (h = !0), this._rgb.slice(0, 4).map(function(p, A) {
        return A < 3 ? h === !1 ? p : Kf(p) : p;
      });
    }, wE.rgb = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(ys, [null].concat(h, ["rgb"])))();
    }, Gf.format.rgb = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = Vf(h, "rgba");
      return A[3] === void 0 && (A[3] = 1), A;
    }, Gf.autodetect.push({
      p: 3,
      test: function() {
        for (var h = [], p = arguments.length; p--; )
          h[p] = arguments[p];
        if (h = Vf(h, "rgba"), Yf(h) === "array" && (h.length === 3 || h.length === 4 && Yf(h[3]) == "number" && h[3] >= 0 && h[3] <= 1))
          return "rgb";
      }
    });
    var w1 = Math.log, IE = function(h) {
      var p = h / 100, A, N, F;
      return p < 66 ? (A = 255, N = p < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (N = p - 2) + 104.49216199393888 * w1(N), F = p < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (F = p - 10) + 115.67994401066147 * w1(F)) : (A = 351.97690566805693 + 0.114206453784165 * (A = p - 55) - 40.25366309332127 * w1(A), N = 325.4494125711974 + 0.07943456536662342 * (N = p - 50) - 28.0852963507957 * w1(N), F = 255), [A, N, F, 1];
    }, Wf = IE, RE = Wf, ME = m.unpack, xE = Math.round, kE = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      for (var A = ME(h, "rgb"), N = A[0], F = A[2], U = 1e3, x = 4e4, K = 0.4, W; x - U > K; ) {
        W = (x + U) * 0.5;
        var ne = RE(W);
        ne[2] / ne[0] >= F / N ? x = W : U = W;
      }
      return xE(W);
    }, PE = kE, Ds = G, I1 = C, Ss = v, BE = PE;
    I1.prototype.temp = I1.prototype.kelvin = I1.prototype.temperature = function() {
      return BE(this._rgb);
    }, Ds.temp = Ds.kelvin = Ds.temperature = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(I1, [null].concat(h, ["temp"])))();
    }, Ss.format.temp = Ss.format.kelvin = Ss.format.temperature = Wf;
    var FE = m.unpack, Os = Math.cbrt, LE = Math.pow, $E = Math.sign, HE = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = FE(h, "rgb"), N = A[0], F = A[1], U = A[2], x = [Ns(N / 255), Ns(F / 255), Ns(U / 255)], K = x[0], W = x[1], ne = x[2], ie = Os(0.4122214708 * K + 0.5363325363 * W + 0.0514459929 * ne), De = Os(0.2119034982 * K + 0.6806995451 * W + 0.1073969566 * ne), ue = Os(0.0883024619 * K + 0.2817188376 * W + 0.6299787005 * ne);
      return [
        0.2104542553 * ie + 0.793617785 * De - 0.0040720468 * ue,
        1.9779984951 * ie - 2.428592205 * De + 0.4505937099 * ue,
        0.0259040371 * ie + 0.7827717662 * De - 0.808675766 * ue
      ];
    }, qf = HE;
    function Ns(h) {
      var p = Math.abs(h);
      return p < 0.04045 ? h / 12.92 : ($E(h) || 1) * LE((p + 0.055) / 1.055, 2.4);
    }
    var UE = m.unpack, R1 = Math.pow, jE = Math.sign, zE = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      h = UE(h, "lab");
      var A = h[0], N = h[1], F = h[2], U = R1(A + 0.3963377774 * N + 0.2158037573 * F, 3), x = R1(A - 0.1055613458 * N - 0.0638541728 * F, 3), K = R1(A - 0.0894841775 * N - 1.291485548 * F, 3);
      return [
        255 * ws(4.0767416621 * U - 3.3077115913 * x + 0.2309699292 * K),
        255 * ws(-1.2684380046 * U + 2.6097574011 * x - 0.3413193965 * K),
        255 * ws(-0.0041960863 * U - 0.7034186147 * x + 1.707614701 * K),
        h.length > 3 ? h[3] : 1
      ];
    }, Xf = zE;
    function ws(h) {
      var p = Math.abs(h);
      return p > 31308e-7 ? (jE(h) || 1) * (1.055 * R1(p, 1 / 2.4) - 0.055) : h * 12.92;
    }
    var GE = m.unpack, VE = m.type, YE = G, Qf = C, Zf = v, KE = qf;
    Qf.prototype.oklab = function() {
      return KE(this._rgb);
    }, YE.oklab = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(Qf, [null].concat(h, ["oklab"])))();
    }, Zf.format.oklab = Xf, Zf.autodetect.push({
      p: 3,
      test: function() {
        for (var h = [], p = arguments.length; p--; )
          h[p] = arguments[p];
        if (h = GE(h, "oklab"), VE(h) === "array" && h.length === 3)
          return "oklab";
      }
    });
    var WE = m.unpack, qE = qf, XE = Pf, QE = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      var A = WE(h, "rgb"), N = A[0], F = A[1], U = A[2], x = qE(N, F, U), K = x[0], W = x[1], ne = x[2];
      return XE(K, W, ne);
    }, ZE = QE, JE = m.unpack, eT = Bf, tT = Xf, nT = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      h = JE(h, "lch");
      var A = h[0], N = h[1], F = h[2], U = eT(A, N, F), x = U[0], K = U[1], W = U[2], ne = tT(x, K, W), ie = ne[0], De = ne[1], ue = ne[2];
      return [ie, De, ue, h.length > 3 ? h[3] : 1];
    }, rT = nT, aT = m.unpack, iT = m.type, oT = G, Jf = C, e0 = v, sT = ZE;
    Jf.prototype.oklch = function() {
      return sT(this._rgb);
    }, oT.oklch = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      return new (Function.prototype.bind.apply(Jf, [null].concat(h, ["oklch"])))();
    }, e0.format.oklch = rT, e0.autodetect.push({
      p: 3,
      test: function() {
        for (var h = [], p = arguments.length; p--; )
          h[p] = arguments[p];
        if (h = aT(h, "oklch"), iT(h) === "array" && h.length === 3)
          return "oklch";
      }
    });
    var t0 = C, uT = m.type;
    t0.prototype.alpha = function(h, p) {
      return p === void 0 && (p = !1), h !== void 0 && uT(h) === "number" ? p ? (this._rgb[3] = h, this) : new t0([this._rgb[0], this._rgb[1], this._rgb[2], h], "rgb") : this._rgb[3];
    };
    var lT = C;
    lT.prototype.clipped = function() {
      return this._rgb._clipped || !1;
    };
    var ia = C, cT = O1;
    ia.prototype.darken = function(h) {
      h === void 0 && (h = 1);
      var p = this, A = p.lab();
      return A[0] -= cT.Kn * h, new ia(A, "lab").alpha(p.alpha(), !0);
    }, ia.prototype.brighten = function(h) {
      return h === void 0 && (h = 1), this.darken(-h);
    }, ia.prototype.darker = ia.prototype.darken, ia.prototype.brighter = ia.prototype.brighten;
    var fT = C;
    fT.prototype.get = function(h) {
      var p = h.split("."), A = p[0], N = p[1], F = this[A]();
      if (N) {
        var U = A.indexOf(N) - (A.substr(0, 2) === "ok" ? 2 : 0);
        if (U > -1)
          return F[U];
        throw new Error("unknown channel " + N + " in mode " + A);
      } else
        return F;
    };
    var ka = C, hT = m.type, dT = Math.pow, mT = 1e-7, pT = 20;
    ka.prototype.luminance = function(h) {
      if (h !== void 0 && hT(h) === "number") {
        if (h === 0)
          return new ka([0, 0, 0, this._rgb[3]], "rgb");
        if (h === 1)
          return new ka([255, 255, 255, this._rgb[3]], "rgb");
        var p = this.luminance(), A = "rgb", N = pT, F = function(x, K) {
          var W = x.interpolate(K, 0.5, A), ne = W.luminance();
          return Math.abs(h - ne) < mT || !N-- ? W : ne > h ? F(x, W) : F(W, K);
        }, U = (p > h ? F(new ka([0, 0, 0]), this) : F(this, new ka([255, 255, 255]))).rgb();
        return new ka(U.concat([this._rgb[3]]));
      }
      return gT.apply(void 0, this._rgb.slice(0, 3));
    };
    var gT = function(h, p, A) {
      return h = Is(h), p = Is(p), A = Is(A), 0.2126 * h + 0.7152 * p + 0.0722 * A;
    }, Is = function(h) {
      return h /= 255, h <= 0.03928 ? h / 12.92 : dT((h + 0.055) / 1.055, 2.4);
    }, Sn = {}, n0 = C, r0 = m.type, M1 = Sn, a0 = function(h, p, A) {
      A === void 0 && (A = 0.5);
      for (var N = [], F = arguments.length - 3; F-- > 0; )
        N[F] = arguments[F + 3];
      var U = N[0] || "lrgb";
      if (!M1[U] && !N.length && (U = Object.keys(M1)[0]), !M1[U])
        throw new Error("interpolation mode " + U + " is not defined");
      return r0(h) !== "object" && (h = new n0(h)), r0(p) !== "object" && (p = new n0(p)), M1[U](h, p, A).alpha(h.alpha() + A * (p.alpha() - h.alpha()));
    }, i0 = C, ET = a0;
    i0.prototype.mix = i0.prototype.interpolate = function(h, p) {
      p === void 0 && (p = 0.5);
      for (var A = [], N = arguments.length - 2; N-- > 0; )
        A[N] = arguments[N + 2];
      return ET.apply(void 0, [this, h, p].concat(A));
    };
    var o0 = C;
    o0.prototype.premultiply = function(h) {
      h === void 0 && (h = !1);
      var p = this._rgb, A = p[3];
      return h ? (this._rgb = [p[0] * A, p[1] * A, p[2] * A, A], this) : new o0([p[0] * A, p[1] * A, p[2] * A, A], "rgb");
    };
    var Rs = C, TT = O1;
    Rs.prototype.saturate = function(h) {
      h === void 0 && (h = 1);
      var p = this, A = p.lch();
      return A[1] += TT.Kn * h, A[1] < 0 && (A[1] = 0), new Rs(A, "lch").alpha(p.alpha(), !0);
    }, Rs.prototype.desaturate = function(h) {
      return h === void 0 && (h = 1), this.saturate(-h);
    };
    var s0 = C, u0 = m.type;
    s0.prototype.set = function(h, p, A) {
      A === void 0 && (A = !1);
      var N = h.split("."), F = N[0], U = N[1], x = this[F]();
      if (U) {
        var K = F.indexOf(U) - (F.substr(0, 2) === "ok" ? 2 : 0);
        if (K > -1) {
          if (u0(p) == "string")
            switch (p.charAt(0)) {
              case "+":
                x[K] += +p;
                break;
              case "-":
                x[K] += +p;
                break;
              case "*":
                x[K] *= +p.substr(1);
                break;
              case "/":
                x[K] /= +p.substr(1);
                break;
              default:
                x[K] = +p;
            }
          else if (u0(p) === "number")
            x[K] = p;
          else
            throw new Error("unsupported value for Color.set");
          var W = new s0(x, F);
          return A ? (this._rgb = W._rgb, this) : W;
        }
        throw new Error("unknown channel " + U + " in mode " + F);
      } else
        return x;
    };
    var vT = C, AT = function(h, p, A) {
      var N = h._rgb, F = p._rgb;
      return new vT(
        N[0] + A * (F[0] - N[0]),
        N[1] + A * (F[1] - N[1]),
        N[2] + A * (F[2] - N[2]),
        "rgb"
      );
    };
    Sn.rgb = AT;
    var CT = C, Ms = Math.sqrt, Pa = Math.pow, _T = function(h, p, A) {
      var N = h._rgb, F = N[0], U = N[1], x = N[2], K = p._rgb, W = K[0], ne = K[1], ie = K[2];
      return new CT(
        Ms(Pa(F, 2) * (1 - A) + Pa(W, 2) * A),
        Ms(Pa(U, 2) * (1 - A) + Pa(ne, 2) * A),
        Ms(Pa(x, 2) * (1 - A) + Pa(ie, 2) * A),
        "rgb"
      );
    };
    Sn.lrgb = _T;
    var bT = C, yT = function(h, p, A) {
      var N = h.lab(), F = p.lab();
      return new bT(
        N[0] + A * (F[0] - N[0]),
        N[1] + A * (F[1] - N[1]),
        N[2] + A * (F[2] - N[2]),
        "lab"
      );
    };
    Sn.lab = yT;
    var l0 = C, Ba = function(h, p, A, N) {
      var F, U, x, K;
      N === "hsl" ? (x = h.hsl(), K = p.hsl()) : N === "hsv" ? (x = h.hsv(), K = p.hsv()) : N === "hcg" ? (x = h.hcg(), K = p.hcg()) : N === "hsi" ? (x = h.hsi(), K = p.hsi()) : N === "lch" || N === "hcl" ? (N = "hcl", x = h.hcl(), K = p.hcl()) : N === "oklch" && (x = h.oklch().reverse(), K = p.oklch().reverse());
      var W, ne, ie, De, ue, Ne;
      (N.substr(0, 1) === "h" || N === "oklch") && (F = x, W = F[0], ie = F[1], ue = F[2], U = K, ne = U[0], De = U[1], Ne = U[2]);
      var Oe, Ye, Ze, it;
      return !isNaN(W) && !isNaN(ne) ? (ne > W && ne - W > 180 ? it = ne - (W + 360) : ne < W && W - ne > 180 ? it = ne + 360 - W : it = ne - W, Ye = W + A * it) : isNaN(W) ? isNaN(ne) ? Ye = Number.NaN : (Ye = ne, (ue == 1 || ue == 0) && N != "hsv" && (Oe = De)) : (Ye = W, (Ne == 1 || Ne == 0) && N != "hsv" && (Oe = ie)), Oe === void 0 && (Oe = ie + A * (De - ie)), Ze = ue + A * (Ne - ue), N === "oklch" ? new l0([Ze, Oe, Ye], N) : new l0([Ye, Oe, Ze], N);
    }, DT = Ba, c0 = function(h, p, A) {
      return DT(h, p, A, "lch");
    };
    Sn.lch = c0, Sn.hcl = c0;
    var ST = C, OT = function(h, p, A) {
      var N = h.num(), F = p.num();
      return new ST(N + A * (F - N), "num");
    };
    Sn.num = OT;
    var NT = Ba, wT = function(h, p, A) {
      return NT(h, p, A, "hcg");
    };
    Sn.hcg = wT;
    var IT = Ba, RT = function(h, p, A) {
      return IT(h, p, A, "hsi");
    };
    Sn.hsi = RT;
    var MT = Ba, xT = function(h, p, A) {
      return MT(h, p, A, "hsl");
    };
    Sn.hsl = xT;
    var kT = Ba, PT = function(h, p, A) {
      return kT(h, p, A, "hsv");
    };
    Sn.hsv = PT;
    var BT = C, FT = function(h, p, A) {
      var N = h.oklab(), F = p.oklab();
      return new BT(
        N[0] + A * (F[0] - N[0]),
        N[1] + A * (F[1] - N[1]),
        N[2] + A * (F[2] - N[2]),
        "oklab"
      );
    };
    Sn.oklab = FT;
    var LT = Ba, $T = function(h, p, A) {
      return LT(h, p, A, "oklch");
    };
    Sn.oklch = $T;
    var xs = C, HT = m.clip_rgb, ks = Math.pow, Ps = Math.sqrt, Bs = Math.PI, f0 = Math.cos, h0 = Math.sin, UT = Math.atan2, jT = function(h, p, A) {
      p === void 0 && (p = "lrgb"), A === void 0 && (A = null);
      var N = h.length;
      A || (A = Array.from(new Array(N)).map(function() {
        return 1;
      }));
      var F = N / A.reduce(function(Ye, Ze) {
        return Ye + Ze;
      });
      if (A.forEach(function(Ye, Ze) {
        A[Ze] *= F;
      }), h = h.map(function(Ye) {
        return new xs(Ye);
      }), p === "lrgb")
        return zT(h, A);
      for (var U = h.shift(), x = U.get(p), K = [], W = 0, ne = 0, ie = 0; ie < x.length; ie++)
        if (x[ie] = (x[ie] || 0) * A[0], K.push(isNaN(x[ie]) ? 0 : A[0]), p.charAt(ie) === "h" && !isNaN(x[ie])) {
          var De = x[ie] / 180 * Bs;
          W += f0(De) * A[0], ne += h0(De) * A[0];
        }
      var ue = U.alpha() * A[0];
      h.forEach(function(Ye, Ze) {
        var it = Ye.get(p);
        ue += Ye.alpha() * A[Ze + 1];
        for (var ct = 0; ct < x.length; ct++)
          if (!isNaN(it[ct]))
            if (K[ct] += A[Ze + 1], p.charAt(ct) === "h") {
              var en = it[ct] / 180 * Bs;
              W += f0(en) * A[Ze + 1], ne += h0(en) * A[Ze + 1];
            } else
              x[ct] += it[ct] * A[Ze + 1];
      });
      for (var Ne = 0; Ne < x.length; Ne++)
        if (p.charAt(Ne) === "h") {
          for (var Oe = UT(ne / K[Ne], W / K[Ne]) / Bs * 180; Oe < 0; )
            Oe += 360;
          for (; Oe >= 360; )
            Oe -= 360;
          x[Ne] = Oe;
        } else
          x[Ne] = x[Ne] / K[Ne];
      return ue /= N, new xs(x, p).alpha(ue > 0.99999 ? 1 : ue, !0);
    }, zT = function(h, p) {
      for (var A = h.length, N = [0, 0, 0, 0], F = 0; F < h.length; F++) {
        var U = h[F], x = p[F] / A, K = U._rgb;
        N[0] += ks(K[0], 2) * x, N[1] += ks(K[1], 2) * x, N[2] += ks(K[2], 2) * x, N[3] += K[3] * x;
      }
      return N[0] = Ps(N[0]), N[1] = Ps(N[1]), N[2] = Ps(N[2]), N[3] > 0.9999999 && (N[3] = 1), new xs(HT(N));
    }, Zn = G, Fa = m.type, GT = Math.pow, Fs = function(h) {
      var p = "rgb", A = Zn("#ccc"), N = 0, F = [0, 1], U = [], x = [0, 0], K = !1, W = [], ne = !1, ie = 0, De = 1, ue = !1, Ne = {}, Oe = !0, Ye = 1, Ze = function(fe) {
        if (fe = fe || ["#fff", "#000"], fe && Fa(fe) === "string" && Zn.brewer && Zn.brewer[fe.toLowerCase()] && (fe = Zn.brewer[fe.toLowerCase()]), Fa(fe) === "array") {
          fe.length === 1 && (fe = [fe[0], fe[0]]), fe = fe.slice(0);
          for (var Pe = 0; Pe < fe.length; Pe++)
            fe[Pe] = Zn(fe[Pe]);
          U.length = 0;
          for (var qe = 0; qe < fe.length; qe++)
            U.push(qe / (fe.length - 1));
        }
        return An(), W = fe;
      }, it = function(fe) {
        if (K != null) {
          for (var Pe = K.length - 1, qe = 0; qe < Pe && fe >= K[qe]; )
            qe++;
          return qe - 1;
        }
        return 0;
      }, ct = function(fe) {
        return fe;
      }, en = function(fe) {
        return fe;
      }, Zt = function(fe, Pe) {
        var qe, Ke;
        if (Pe == null && (Pe = !1), isNaN(fe) || fe === null)
          return A;
        if (Pe)
          Ke = fe;
        else if (K && K.length > 2) {
          var tn = it(fe);
          Ke = tn / (K.length - 2);
        } else
          De !== ie ? Ke = (fe - ie) / (De - ie) : Ke = 1;
        Ke = en(Ke), Pe || (Ke = ct(Ke)), Ye !== 1 && (Ke = GT(Ke, Ye)), Ke = x[0] + Ke * (1 - x[0] - x[1]), Ke = Math.min(1, Math.max(0, Ke));
        var Ot = Math.floor(Ke * 1e4);
        if (Oe && Ne[Ot])
          qe = Ne[Ot];
        else {
          if (Fa(W) === "array")
            for (var ot = 0; ot < U.length; ot++) {
              var ht = U[ot];
              if (Ke <= ht) {
                qe = W[ot];
                break;
              }
              if (Ke >= ht && ot === U.length - 1) {
                qe = W[ot];
                break;
              }
              if (Ke > ht && Ke < U[ot + 1]) {
                Ke = (Ke - ht) / (U[ot + 1] - ht), qe = Zn.interpolate(W[ot], W[ot + 1], Ke, p);
                break;
              }
            }
          else
            Fa(W) === "function" && (qe = W(Ke));
          Oe && (Ne[Ot] = qe);
        }
        return qe;
      }, An = function() {
        return Ne = {};
      };
      Ze(h);
      var nt = function(fe) {
        var Pe = Zn(Zt(fe));
        return ne && Pe[ne] ? Pe[ne]() : Pe;
      };
      return nt.classes = function(fe) {
        if (fe != null) {
          if (Fa(fe) === "array")
            K = fe, F = [fe[0], fe[fe.length - 1]];
          else {
            var Pe = Zn.analyze(F);
            fe === 0 ? K = [Pe.min, Pe.max] : K = Zn.limits(Pe, "e", fe);
          }
          return nt;
        }
        return K;
      }, nt.domain = function(fe) {
        if (!arguments.length)
          return F;
        ie = fe[0], De = fe[fe.length - 1], U = [];
        var Pe = W.length;
        if (fe.length === Pe && ie !== De)
          for (var qe = 0, Ke = Array.from(fe); qe < Ke.length; qe += 1) {
            var tn = Ke[qe];
            U.push((tn - ie) / (De - ie));
          }
        else {
          for (var Ot = 0; Ot < Pe; Ot++)
            U.push(Ot / (Pe - 1));
          if (fe.length > 2) {
            var ot = fe.map(function(dt, At) {
              return At / (fe.length - 1);
            }), ht = fe.map(function(dt) {
              return (dt - ie) / (De - ie);
            });
            ht.every(function(dt, At) {
              return ot[At] === dt;
            }) || (en = function(dt) {
              if (dt <= 0 || dt >= 1)
                return dt;
              for (var At = 0; dt >= ht[At + 1]; )
                At++;
              var er = (dt - ht[At]) / (ht[At + 1] - ht[At]), Gr = ot[At] + er * (ot[At + 1] - ot[At]);
              return Gr;
            });
          }
        }
        return F = [ie, De], nt;
      }, nt.mode = function(fe) {
        return arguments.length ? (p = fe, An(), nt) : p;
      }, nt.range = function(fe, Pe) {
        return Ze(fe), nt;
      }, nt.out = function(fe) {
        return ne = fe, nt;
      }, nt.spread = function(fe) {
        return arguments.length ? (N = fe, nt) : N;
      }, nt.correctLightness = function(fe) {
        return fe == null && (fe = !0), ue = fe, An(), ue ? ct = function(Pe) {
          for (var qe = Zt(0, !0).lab()[0], Ke = Zt(1, !0).lab()[0], tn = qe > Ke, Ot = Zt(Pe, !0).lab()[0], ot = qe + (Ke - qe) * Pe, ht = Ot - ot, dt = 0, At = 1, er = 20; Math.abs(ht) > 0.01 && er-- > 0; )
            (function() {
              return tn && (ht *= -1), ht < 0 ? (dt = Pe, Pe += (At - Pe) * 0.5) : (At = Pe, Pe += (dt - Pe) * 0.5), Ot = Zt(Pe, !0).lab()[0], ht = Ot - ot;
            })();
          return Pe;
        } : ct = function(Pe) {
          return Pe;
        }, nt;
      }, nt.padding = function(fe) {
        return fe != null ? (Fa(fe) === "number" && (fe = [fe, fe]), x = fe, nt) : x;
      }, nt.colors = function(fe, Pe) {
        arguments.length < 2 && (Pe = "hex");
        var qe = [];
        if (arguments.length === 0)
          qe = W.slice(0);
        else if (fe === 1)
          qe = [nt(0.5)];
        else if (fe > 1) {
          var Ke = F[0], tn = F[1] - Ke;
          qe = VT(0, fe, !1).map(function(At) {
            return nt(Ke + At / (fe - 1) * tn);
          });
        } else {
          h = [];
          var Ot = [];
          if (K && K.length > 2)
            for (var ot = 1, ht = K.length, dt = 1 <= ht; dt ? ot < ht : ot > ht; dt ? ot++ : ot--)
              Ot.push((K[ot - 1] + K[ot]) * 0.5);
          else
            Ot = F;
          qe = Ot.map(function(At) {
            return nt(At);
          });
        }
        return Zn[Pe] && (qe = qe.map(function(At) {
          return At[Pe]();
        })), qe;
      }, nt.cache = function(fe) {
        return fe != null ? (Oe = fe, nt) : Oe;
      }, nt.gamma = function(fe) {
        return fe != null ? (Ye = fe, nt) : Ye;
      }, nt.nodata = function(fe) {
        return fe != null ? (A = Zn(fe), nt) : A;
      }, nt;
    };
    function VT(h, p, A) {
      for (var N = [], F = h < p, U = A ? F ? p + 1 : p - 1 : p, x = h; F ? x < U : x > U; F ? x++ : x--)
        N.push(x);
      return N;
    }
    var Si = C, YT = Fs, KT = function(h) {
      for (var p = [1, 1], A = 1; A < h; A++) {
        for (var N = [1], F = 1; F <= p.length; F++)
          N[F] = (p[F] || 0) + p[F - 1];
        p = N;
      }
      return p;
    }, WT = function(h) {
      var p, A, N, F, U, x, K;
      if (h = h.map(function(ue) {
        return new Si(ue);
      }), h.length === 2)
        p = h.map(function(ue) {
          return ue.lab();
        }), U = p[0], x = p[1], F = function(ue) {
          var Ne = [0, 1, 2].map(function(Oe) {
            return U[Oe] + ue * (x[Oe] - U[Oe]);
          });
          return new Si(Ne, "lab");
        };
      else if (h.length === 3)
        A = h.map(function(ue) {
          return ue.lab();
        }), U = A[0], x = A[1], K = A[2], F = function(ue) {
          var Ne = [0, 1, 2].map(function(Oe) {
            return (1 - ue) * (1 - ue) * U[Oe] + 2 * (1 - ue) * ue * x[Oe] + ue * ue * K[Oe];
          });
          return new Si(Ne, "lab");
        };
      else if (h.length === 4) {
        var W;
        N = h.map(function(ue) {
          return ue.lab();
        }), U = N[0], x = N[1], K = N[2], W = N[3], F = function(ue) {
          var Ne = [0, 1, 2].map(function(Oe) {
            return (1 - ue) * (1 - ue) * (1 - ue) * U[Oe] + 3 * (1 - ue) * (1 - ue) * ue * x[Oe] + 3 * (1 - ue) * ue * ue * K[Oe] + ue * ue * ue * W[Oe];
          });
          return new Si(Ne, "lab");
        };
      } else if (h.length >= 5) {
        var ne, ie, De;
        ne = h.map(function(ue) {
          return ue.lab();
        }), De = h.length - 1, ie = KT(De), F = function(ue) {
          var Ne = 1 - ue, Oe = [0, 1, 2].map(function(Ye) {
            return ne.reduce(function(Ze, it, ct) {
              return Ze + ie[ct] * Math.pow(Ne, De - ct) * Math.pow(ue, ct) * it[Ye];
            }, 0);
          });
          return new Si(Oe, "lab");
        };
      } else
        throw new RangeError("No point in running bezier with only one color.");
      return F;
    }, qT = function(h) {
      var p = WT(h);
      return p.scale = function() {
        return YT(p);
      }, p;
    }, Ls = G, Jn = function(h, p, A) {
      if (!Jn[A])
        throw new Error("unknown blend mode " + A);
      return Jn[A](h, p);
    }, jr = function(h) {
      return function(p, A) {
        var N = Ls(A).rgb(), F = Ls(p).rgb();
        return Ls.rgb(h(N, F));
      };
    }, zr = function(h) {
      return function(p, A) {
        var N = [];
        return N[0] = h(p[0], A[0]), N[1] = h(p[1], A[1]), N[2] = h(p[2], A[2]), N;
      };
    }, XT = function(h) {
      return h;
    }, QT = function(h, p) {
      return h * p / 255;
    }, ZT = function(h, p) {
      return h > p ? p : h;
    }, JT = function(h, p) {
      return h > p ? h : p;
    }, e8 = function(h, p) {
      return 255 * (1 - (1 - h / 255) * (1 - p / 255));
    }, t8 = function(h, p) {
      return p < 128 ? 2 * h * p / 255 : 255 * (1 - 2 * (1 - h / 255) * (1 - p / 255));
    }, n8 = function(h, p) {
      return 255 * (1 - (1 - p / 255) / (h / 255));
    }, r8 = function(h, p) {
      return h === 255 ? 255 : (h = 255 * (p / 255) / (1 - h / 255), h > 255 ? 255 : h);
    };
    Jn.normal = jr(zr(XT)), Jn.multiply = jr(zr(QT)), Jn.screen = jr(zr(e8)), Jn.overlay = jr(zr(t8)), Jn.darken = jr(zr(ZT)), Jn.lighten = jr(zr(JT)), Jn.dodge = jr(zr(r8)), Jn.burn = jr(zr(n8));
    for (var a8 = Jn, $s = m.type, i8 = m.clip_rgb, o8 = m.TWOPI, s8 = Math.pow, u8 = Math.sin, l8 = Math.cos, d0 = G, c8 = function(h, p, A, N, F) {
      h === void 0 && (h = 300), p === void 0 && (p = -1.5), A === void 0 && (A = 1), N === void 0 && (N = 1), F === void 0 && (F = [0, 1]);
      var U = 0, x;
      $s(F) === "array" ? x = F[1] - F[0] : (x = 0, F = [F, F]);
      var K = function(W) {
        var ne = o8 * ((h + 120) / 360 + p * W), ie = s8(F[0] + x * W, N), De = U !== 0 ? A[0] + W * U : A, ue = De * ie * (1 - ie) / 2, Ne = l8(ne), Oe = u8(ne), Ye = ie + ue * (-0.14861 * Ne + 1.78277 * Oe), Ze = ie + ue * (-0.29227 * Ne - 0.90649 * Oe), it = ie + ue * (1.97294 * Ne);
        return d0(i8([Ye * 255, Ze * 255, it * 255, 1]));
      };
      return K.start = function(W) {
        return W == null ? h : (h = W, K);
      }, K.rotations = function(W) {
        return W == null ? p : (p = W, K);
      }, K.gamma = function(W) {
        return W == null ? N : (N = W, K);
      }, K.hue = function(W) {
        return W == null ? A : (A = W, $s(A) === "array" ? (U = A[1] - A[0], U === 0 && (A = A[1])) : U = 0, K);
      }, K.lightness = function(W) {
        return W == null ? F : ($s(W) === "array" ? (F = W, x = W[1] - W[0]) : (F = [W, W], x = 0), K);
      }, K.scale = function() {
        return d0.scale(K);
      }, K.hue(A), K;
    }, f8 = C, h8 = "0123456789abcdef", d8 = Math.floor, m8 = Math.random, p8 = function() {
      for (var h = "#", p = 0; p < 6; p++)
        h += h8.charAt(d8(m8() * 16));
      return new f8(h, "hex");
    }, Hs = l, m0 = Math.log, g8 = Math.pow, E8 = Math.floor, T8 = Math.abs, p0 = function(h, p) {
      p === void 0 && (p = null);
      var A = {
        min: Number.MAX_VALUE,
        max: Number.MAX_VALUE * -1,
        sum: 0,
        values: [],
        count: 0
      };
      return Hs(h) === "object" && (h = Object.values(h)), h.forEach(function(N) {
        p && Hs(N) === "object" && (N = N[p]), N != null && !isNaN(N) && (A.values.push(N), A.sum += N, N < A.min && (A.min = N), N > A.max && (A.max = N), A.count += 1);
      }), A.domain = [A.min, A.max], A.limits = function(N, F) {
        return g0(A, N, F);
      }, A;
    }, g0 = function(h, p, A) {
      p === void 0 && (p = "equal"), A === void 0 && (A = 7), Hs(h) == "array" && (h = p0(h));
      var N = h.min, F = h.max, U = h.values.sort(function(js, zs) {
        return js - zs;
      });
      if (A === 1)
        return [N, F];
      var x = [];
      if (p.substr(0, 1) === "c" && (x.push(N), x.push(F)), p.substr(0, 1) === "e") {
        x.push(N);
        for (var K = 1; K < A; K++)
          x.push(N + K / A * (F - N));
        x.push(F);
      } else if (p.substr(0, 1) === "l") {
        if (N <= 0)
          throw new Error("Logarithmic scales are only possible for values > 0");
        var W = Math.LOG10E * m0(N), ne = Math.LOG10E * m0(F);
        x.push(N);
        for (var ie = 1; ie < A; ie++)
          x.push(g8(10, W + ie / A * (ne - W)));
        x.push(F);
      } else if (p.substr(0, 1) === "q") {
        x.push(N);
        for (var De = 1; De < A; De++) {
          var ue = (U.length - 1) * De / A, Ne = E8(ue);
          if (Ne === ue)
            x.push(U[Ne]);
          else {
            var Oe = ue - Ne;
            x.push(U[Ne] * (1 - Oe) + U[Ne + 1] * Oe);
          }
        }
        x.push(F);
      } else if (p.substr(0, 1) === "k") {
        var Ye, Ze = U.length, it = new Array(Ze), ct = new Array(A), en = !0, Zt = 0, An = null;
        An = [], An.push(N);
        for (var nt = 1; nt < A; nt++)
          An.push(N + nt / A * (F - N));
        for (An.push(F); en; ) {
          for (var fe = 0; fe < A; fe++)
            ct[fe] = 0;
          for (var Pe = 0; Pe < Ze; Pe++)
            for (var qe = U[Pe], Ke = Number.MAX_VALUE, tn = void 0, Ot = 0; Ot < A; Ot++) {
              var ot = T8(An[Ot] - qe);
              ot < Ke && (Ke = ot, tn = Ot), ct[tn]++, it[Pe] = tn;
            }
          for (var ht = new Array(A), dt = 0; dt < A; dt++)
            ht[dt] = null;
          for (var At = 0; At < Ze; At++)
            Ye = it[At], ht[Ye] === null ? ht[Ye] = U[At] : ht[Ye] += U[At];
          for (var er = 0; er < A; er++)
            ht[er] *= 1 / ct[er];
          en = !1;
          for (var Gr = 0; Gr < A; Gr++)
            if (ht[Gr] !== An[Gr]) {
              en = !0;
              break;
            }
          An = ht, Zt++, Zt > 200 && (en = !1);
        }
        for (var Vr = {}, La = 0; La < A; La++)
          Vr[La] = [];
        for (var $a = 0; $a < Ze; $a++)
          Ye = it[$a], Vr[Ye].push(U[$a]);
        for (var _r = [], oa = 0; oa < A; oa++)
          _r.push(Vr[oa][0]), _r.push(Vr[oa][Vr[oa].length - 1]);
        _r = _r.sort(function(js, zs) {
          return js - zs;
        }), x.push(_r[0]);
        for (var Oi = 1; Oi < _r.length; Oi += 2) {
          var sa = _r[Oi];
          !isNaN(sa) && x.indexOf(sa) === -1 && x.push(sa);
        }
      }
      return x;
    }, E0 = { analyze: p0, limits: g0 }, T0 = C, v8 = function(h, p) {
      h = new T0(h), p = new T0(p);
      var A = h.luminance(), N = p.luminance();
      return A > N ? (A + 0.05) / (N + 0.05) : (N + 0.05) / (A + 0.05);
    }, v0 = C, Cr = Math.sqrt, Yt = Math.pow, A8 = Math.min, C8 = Math.max, A0 = Math.atan2, C0 = Math.abs, x1 = Math.cos, _0 = Math.sin, _8 = Math.exp, b0 = Math.PI, b8 = function(h, p, A, N, F) {
      A === void 0 && (A = 1), N === void 0 && (N = 1), F === void 0 && (F = 1);
      var U = function(sa) {
        return 360 * sa / (2 * b0);
      }, x = function(sa) {
        return 2 * b0 * sa / 360;
      };
      h = new v0(h), p = new v0(p);
      var K = Array.from(h.lab()), W = K[0], ne = K[1], ie = K[2], De = Array.from(p.lab()), ue = De[0], Ne = De[1], Oe = De[2], Ye = (W + ue) / 2, Ze = Cr(Yt(ne, 2) + Yt(ie, 2)), it = Cr(Yt(Ne, 2) + Yt(Oe, 2)), ct = (Ze + it) / 2, en = 0.5 * (1 - Cr(Yt(ct, 7) / (Yt(ct, 7) + Yt(25, 7)))), Zt = ne * (1 + en), An = Ne * (1 + en), nt = Cr(Yt(Zt, 2) + Yt(ie, 2)), fe = Cr(Yt(An, 2) + Yt(Oe, 2)), Pe = (nt + fe) / 2, qe = U(A0(ie, Zt)), Ke = U(A0(Oe, An)), tn = qe >= 0 ? qe : qe + 360, Ot = Ke >= 0 ? Ke : Ke + 360, ot = C0(tn - Ot) > 180 ? (tn + Ot + 360) / 2 : (tn + Ot) / 2, ht = 1 - 0.17 * x1(x(ot - 30)) + 0.24 * x1(x(2 * ot)) + 0.32 * x1(x(3 * ot + 6)) - 0.2 * x1(x(4 * ot - 63)), dt = Ot - tn;
      dt = C0(dt) <= 180 ? dt : Ot <= tn ? dt + 360 : dt - 360, dt = 2 * Cr(nt * fe) * _0(x(dt) / 2);
      var At = ue - W, er = fe - nt, Gr = 1 + 0.015 * Yt(Ye - 50, 2) / Cr(20 + Yt(Ye - 50, 2)), Vr = 1 + 0.045 * Pe, La = 1 + 0.015 * Pe * ht, $a = 30 * _8(-Yt((ot - 275) / 25, 2)), _r = 2 * Cr(Yt(Pe, 7) / (Yt(Pe, 7) + Yt(25, 7))), oa = -_r * _0(2 * x($a)), Oi = Cr(Yt(At / (A * Gr), 2) + Yt(er / (N * Vr), 2) + Yt(dt / (F * La), 2) + oa * (er / (N * Vr)) * (dt / (F * La)));
      return C8(0, A8(100, Oi));
    }, y0 = C, y8 = function(h, p, A) {
      A === void 0 && (A = "lab"), h = new y0(h), p = new y0(p);
      var N = h.get(A), F = p.get(A), U = 0;
      for (var x in N) {
        var K = (N[x] || 0) - (F[x] || 0);
        U += K * K;
      }
      return Math.sqrt(U);
    }, D8 = C, S8 = function() {
      for (var h = [], p = arguments.length; p--; )
        h[p] = arguments[p];
      try {
        return new (Function.prototype.bind.apply(D8, [null].concat(h)))(), !0;
      } catch {
        return !1;
      }
    }, D0 = G, S0 = Fs, O8 = {
      cool: function() {
        return S0([D0.hsl(180, 1, 0.9), D0.hsl(250, 0.7, 0.4)]);
      },
      hot: function() {
        return S0(["#000", "#f00", "#ff0", "#fff"]).mode("rgb");
      }
    }, k1 = {
      OrRd: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"],
      PuBu: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"],
      BuPu: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"],
      Oranges: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"],
      BuGn: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"],
      YlOrBr: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"],
      YlGn: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"],
      Reds: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"],
      RdPu: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"],
      Greens: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"],
      YlGnBu: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"],
      Purples: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"],
      GnBu: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"],
      Greys: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
      YlOrRd: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"],
      PuRd: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"],
      Blues: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"],
      PuBuGn: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"],
      Viridis: ["#440154", "#482777", "#3f4a8a", "#31678e", "#26838f", "#1f9d8a", "#6cce5a", "#b6de2b", "#fee825"],
      Spectral: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"],
      RdYlGn: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"],
      RdBu: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"],
      PiYG: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"],
      PRGn: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"],
      RdYlBu: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"],
      BrBG: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"],
      RdGy: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"],
      PuOr: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"],
      Set2: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"],
      Accent: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"],
      Set1: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf", "#999999"],
      Set3: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"],
      Dark2: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"],
      Paired: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"],
      Pastel2: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"],
      Pastel1: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec", "#f2f2f2"]
    }, Us = 0, O0 = Object.keys(k1); Us < O0.length; Us += 1) {
      var N0 = O0[Us];
      k1[N0.toLowerCase()] = k1[N0];
    }
    var N8 = k1, Qt = G;
    Qt.average = jT, Qt.bezier = qT, Qt.blend = a8, Qt.cubehelix = c8, Qt.mix = Qt.interpolate = a0, Qt.random = p8, Qt.scale = Fs, Qt.analyze = E0.analyze, Qt.contrast = v8, Qt.deltaE = b8, Qt.distance = y8, Qt.limits = E0.limits, Qt.valid = S8, Qt.scales = O8, Qt.colors = Hf, Qt.brewer = N8;
    var w8 = Qt;
    return w8;
  });
})(Q9);
const Uu = Q9.exports, B0 = "#3d82e2", F0 = "#db1b42", Z9 = {
  shadow1: "rgba(0,0,0,0.01)",
  shadow2: "rgba(0,0,0,0.02)",
  shadow3: "rgba(0,0,0,0.03)",
  shadow4: "rgba(0,0,0,0.04)",
  shadow6: "rgba(0,0,0,0.06)",
  shadow8: "rgba(0,0,0,0.08)",
  shadow12: "rgba(0,0,0,0.12)",
  shadow16: "rgba(0,0,0,0.16)"
}, J9 = (e) => ({
  primary: e,
  darkPrimary: Uu(e).darken(0.25).hex(),
  fadedPrimary: Uu(e).alpha(0.45).hex()
}), fv = {
  black: "rgba(0,0,0,0.9)",
  white: "#fff",
  lightGrey: "#f4f4f4",
  medGrey: "#dfdfdf",
  darkGrey: "#737376",
  blue: B0,
  warn: F0,
  darkWarn: Uu(F0).darken(0.25).hex(),
  ...J9(B0),
  ...Z9
}, hv = "'Open Sans', sans-serif", L0 = {
  1: "13px",
  2: "15px",
  3: "18px"
}, $0 = {
  1: 400,
  2: 600
}, H0 = {
  1: "20px",
  2: "22px",
  3: "24px"
}, e5 = 150, t5 = (e, t = e5) => e.map((n) => `${n} ${t}ms ease`).join(", "), { styled: Me, config: lF, keyframes: cF } = K9({
  theme: {
    colors: fv,
    shadows: Z9,
    space: {
      1: "4px",
      2: "6px",
      3: "12px",
      4: "16px",
      5: "20px",
      6: "24px"
    },
    sizes: {
      xxs: "16px",
      xs: "24px",
      sm: "36px",
      md: "42px",
      lg: "56px",
      xl: "60px",
      xxl: "72px"
    },
    fonts: {
      default: hv
    },
    fontSizes: L0,
    fontWeights: $0,
    lineHeights: H0,
    radii: {
      1: "8px",
      2: "10px",
      round: "50%"
    }
  },
  media: {
    mobile: "(max-width: 768px)"
  },
  utils: {
    anim: (e) => ({
      animation: e.map((t) => `${t} ${e5}ms`).join(", ")
    }),
    trans: (e) => ({
      transition: t5(e)
    }),
    typo: ({ size: e = L0[2], weight: t = $0[1], height: n = H0[1] }) => ({
      fontFamily: "$default",
      fontSize: e,
      fontWeight: t,
      lineHeight: n
    })
  }
}), dv = ({ color: e }) => ov({
  colors: e ? J9(e) : {}
}), n5 = (e) => {
  const [t, n] = En("");
  return Rr(() => {
    e != null && e.color && n(dv({ color: e.color }));
  }, [e == null ? void 0 : e.color]), t;
};
var mv = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, a = t.length, i; r < a; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
};
function pv(e, t, n) {
  var r = e.length - t.length, a = Array.from(t);
  if (r === 0)
    return e.apply(void 0, a);
  if (r === 1) {
    var i = function(o) {
      return e.apply(void 0, mv([o], a, !1));
    };
    return (n || e.lazy) && (i.lazy = n || e.lazy, i.lazyArgs = t), i;
  }
  throw new Error("Wrong number of arguments");
}
function bc(e) {
  return !!e && !Array.isArray(e) && typeof e == "object";
}
var U0 = function() {
};
function co() {
  return pv(gv, arguments);
}
function gv(e, t) {
  var n = new Set(t);
  return Object.entries(e).reduce(function(r, a) {
    var i = a[0], o = a[1];
    return n.has(i) || (r[i] = o), r;
  }, {});
}
var r5 = function(t, n) {
  var r = "000000000" + t;
  return r.substr(r.length - n);
}, Ev = r5, Tv = typeof window == "object" ? window : self, vv = Object.keys(Tv).length, Av = navigator.mimeTypes ? navigator.mimeTypes.length : 0, Cv = Ev((Av + navigator.userAgent.length).toString(36) + vv.toString(36), 4), _v = function() {
  return Cv;
}, ju, j0 = typeof window < "u" && (window.crypto || window.msCrypto) || typeof self < "u" && self.crypto;
if (j0) {
  var bv = Math.pow(2, 32) - 1;
  ju = function() {
    return Math.abs(j0.getRandomValues(new Uint32Array(1))[0] / bv);
  };
} else
  ju = Math.random;
var yv = ju, fo = _v, a5 = r5, Dv = yv, wi = 0, yc = 4, ho = 36, i5 = Math.pow(ho, yc);
function zu() {
  return a5((Dv() * i5 << 0).toString(ho), yc);
}
function o5() {
  return wi = wi < i5 ? wi : 0, wi++, wi - 1;
}
function p1() {
  var e = "c", t = new Date().getTime().toString(ho), n = a5(o5().toString(ho), yc), r = fo(), a = zu() + zu();
  return e + t + n + r + a;
}
p1.slug = function() {
  var t = new Date().getTime().toString(36), n = o5().toString(36).slice(-4), r = fo().slice(0, 1) + fo().slice(-1), a = zu().slice(-2);
  return t.slice(-2) + n + r + a;
};
p1.isCuid = function(t) {
  return typeof t != "string" ? !1 : !!t.startsWith("c");
};
p1.isSlug = function(t) {
  if (typeof t != "string")
    return !1;
  var n = t.length;
  return n >= 7 && n <= 10;
};
p1.fingerprint = fo;
var mo = p1;
const fF = (e, t) => typeof e == "string" && Object.values(t).includes(e);
var jn = /* @__PURE__ */ ((e) => (e.FETCH_ASSISTANT = "voiceflow:fetch_assistant", e.FETCHED_ASSISTANT = "voiceflow:fetched_assistant", e.SESSION = "voiceflow:session", e.SAVE_SESSION = "voiceflow:save_session", e.OPEN = "voiceflow:open", e.CLOSE = "voiceflow:close", e.INTERACT = "voiceflow:interact", e))(jn || {});
const s5 = (e) => bc(e) && typeof e.type == "string" && Object.values(jn).includes(e.type), Sv = (e) => bc(e) && e.type === "voiceflow:close", hF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Type: jn,
  isPostMessage: s5,
  isClosePostMessage: Sv
}, Symbol.toStringTag, { value: "Module" })), qi = {
  listeners: []
}, Ov = (e) => {
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}, z0 = (e) => {
  const t = Ov(e.data);
  !s5(t) || qi.listeners.forEach((n) => {
    n.type === t.type && n.action(t);
  });
};
window.addEventListener ? window.addEventListener("message", z0, !1) : window.attachEvent("onmessage", z0);
const s1 = (e, t) => {
  const n = Mr(t);
  n.current = t, Rr(() => {
    const r = { type: e, action: (a) => n.current(a) };
    return qi.listeners.push(r), () => {
      qi.listeners = qi.listeners.filter((a) => a !== r);
    };
  }, []);
}, dF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  context: qi,
  useListenMessage: s1
}, Symbol.toStringTag, { value: "Module" }));
var Po = {};
const Nv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), wv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), Iv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), Rv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), Mv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), xv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), kv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), Pv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), Bv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), Fv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Buttons: wv,
  Capture: Iv,
  CaptureV2: Rv,
  CardV2: Mv,
  Carousel: xv,
  Interaction: kv,
  Prompt: Pv,
  Utils: Bv
}, Symbol.toStringTag, { value: "Module" }));
var Gu;
(function(e) {
  e.INTENT = "INTENT";
})(Gu || (Gu = {}));
var Vu;
(function(e) {
  e.STACKED = "stacked", e.CAROUSEL = "carousel";
})(Vu || (Vu = {}));
const G0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ButtonType() {
    return Gu;
  },
  get ButtonsLayout() {
    return Vu;
  }
}, Symbol.toStringTag, { value: "Module" })), u5 = "VF.";
var u1;
(function(e) {
  e.Workspace = "WS", e.DialogManager = "DM";
})(u1 || (u1 = {}));
const l5 = (e) => (t) => typeof t == "string" && t.startsWith(`${u5}${e}.`), Lv = l5(u1.Workspace), $v = l5(u1.DialogManager), Hv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  API_KEY_PREFIX: u5,
  get APIKeySubType() {
    return u1;
  },
  isWorkspaceAPIKey: Lv,
  isDialogManagerAPIKey: $v
}, Symbol.toStringTag, { value: "Module" }));
var Yu;
(function(e) {
  e.LUIS = "LUIS";
})(Yu || (Yu = {}));
var po;
(function(e) {
  e.CURVED = "CURVED", e.STRAIGHT = "STRAIGHT";
})(po || (po = {}));
var Ku;
(function(e) {
  e.BLOCK = "block", e.ACTIONS = "actions";
})(Ku || (Ku = {}));
var Wu;
(function(e) {
  e.INTENT = "INTENT";
})(Wu || (Wu = {}));
var qu;
(function(e) {
  e.FAIL = "fail", e.NEXT = "next", e.PAUSE = "pause", e.NO_REPLY = "no-reply", e.NO_MATCH = "else", e.PREVIOUS = "previous";
})(qu || (qu = {}));
const Uv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var Xu;
(function(e) {
  e.TOPIC = "TOPIC", e.GROUP = "GROUP", e.COMPONENT = "COMPONENT", e.TEMPLATE = "TEMPLATE";
})(Xu || (Xu = {}));
var Qu;
(function(e) {
  e.NODE = "NODE", e.DIAGRAM = "DIAGRAM";
})(Qu || (Qu = {}));
const jv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get DiagramType() {
    return Xu;
  },
  get MenuItemType() {
    return Qu;
  }
}, Symbol.toStringTag, { value: "Module" })), zv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var Zu;
(function(e) {
  e.PDF = "pdf", e.TEXT = "text", e.URL = "url", e.DOCX = "docx";
})(Zu || (Zu = {}));
var Ju;
(function(e) {
  e.ERROR = "ERROR", e.SUCCESS = "SUCCESS", e.PENDING = "PENDING", e.INITIALIZED = "INITIALIZED";
})(Ju || (Ju = {}));
var el;
(function(e) {
  e.RECURSIVE_TEXT_SPLITTER = "recursive_text_splitter";
})(el || (el = {}));
var tl;
(function(e) {
  e.PUBLIC = "public", e.PRIVATE = "private";
})(tl || (tl = {}));
const Gv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get Privacy() {
    return tl;
  },
  get LinkType() {
    return po;
  },
  get KnowledgeBaseDocumentType() {
    return Zu;
  },
  get KnowledgeBaseDocumentStatus() {
    return Ju;
  },
  get ChunkStrategyType() {
    return el;
  }
}, Symbol.toStringTag, { value: "Module" })), Vv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), Yv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), Kv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var nl;
(function(e) {
  e.DESIGN = "DESIGN", e.REVIEW = "REVIEW", e.COMPLETE = "COMPLETE";
})(nl || (nl = {}));
var rl;
(function(e) {
  e.CONVERSATION = "conversation", e.PROTOTYPE = "prototype", e.NLU_DATASOURCE_IMPORT = "nluDatasourceImport";
})(rl || (rl = {}));
var al;
(function(e) {
  e.FOLDER = "FOLDER", e.DIAGRAM = "DIAGRAM";
})(al || (al = {}));
const Wv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get FolderItemType() {
    return al;
  },
  get DomainStatus() {
    return nl;
  },
  get NLUUnclassifiedDataType() {
    return rl;
  }
}, Symbol.toStringTag, { value: "Module" })), V0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ApiKey: Hv,
  CustomBlock: Uv,
  Diagram: jv,
  Program: zv,
  Project: Gv,
  ProjectSecret: Vv,
  Transcript: Yv,
  VariableState: Kv,
  Version: Wv,
  get ProjectNLP() {
    return Yu;
  },
  get LinkType() {
    return po;
  },
  get BaseNodeType() {
    return Ku;
  },
  get NoteType() {
    return Wu;
  },
  get PortType() {
    return qu;
  }
}, Symbol.toStringTag, { value: "Module" })), qv = "stopTypes", Xv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _V1_STOP_TYPES: qv
}, Symbol.toStringTag, { value: "Module" })), Qv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), Zv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var il;
(function(e) {
  e.FORM_DATA = "formData", e.RAW_INPUT = "rawInput", e.URL_ENCODED = "urlEncoded";
})(il || (il = {}));
var ol;
(function(e) {
  e.GET = "GET", e.PUT = "PUT", e.POST = "POST", e.PATCH = "PATCH", e.DELETE = "DELETE";
})(ol || (ol = {}));
const Jv = (e) => e.toLowerCase();
var sl;
(function(e) {
  e.GET = "Make a GET Request", e.PUT = "Make a PUT Request", e.POST = "Make a POST Request", e.PATCH = "Make a PATCH Request", e.DELETE = "Make a DELETE Request";
})(sl || (sl = {}));
const eA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get APIBodyType() {
    return il;
  },
  get APIMethod() {
    return ol;
  },
  lowercaseAPIMethod: Jv,
  get APIActionType() {
    return sl;
  }
}, Symbol.toStringTag, { value: "Module" }));
var ul;
(function(e) {
  e.URL = "URL", e.PATH = "PATH", e.INTENT = "INTENT";
})(ul || (ul = {}));
const tA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ButtonAction() {
    return ul;
  }
}, Symbol.toStringTag, { value: "Module" })), nA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var ll;
(function(e) {
  e.INTENT = "intent", e.QUERY = "query";
})(ll || (ll = {}));
const rA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get CaptureType() {
    return ll;
  }
}, Symbol.toStringTag, { value: "Module" }));
var cl;
(function(e) {
  e.SIMPLE = "Simple", e.STANDARD = "Standard";
})(cl || (cl = {}));
const aA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get CardType() {
    return cl;
  }
}, Symbol.toStringTag, { value: "Module" })), iA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var fl;
(function(e) {
  e.CAROUSEL = "Carousel", e.LIST = "List";
})(fl || (fl = {}));
const oA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get CarouselLayout() {
    return fl;
  }
}, Symbol.toStringTag, { value: "Module" })), sA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), uA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), lA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var te;
(function(e) {
  e.TEXT = "text", e.SPEAK = "speak", e.START = "start", e.CARD = "card", e.CARD_V2 = "cardV2", e.CAROUSEL = "carousel", e.BUTTONS = "buttons", e.INTERACTION = "interaction", e.AI_RESPONSE = "generative", e.AI_SET = "ai_set", e.SET = "set", e.SET_V2 = "setV2", e.IF = "if", e.IF_V2 = "ifV2", e.RANDOM = "random", e.RANDOM_V2 = "randomV2", e.CAPTURE = "capture", e.CAPTURE_V2 = "captureV2", e.GOTO = "goTo", e.GOTO_NODE = "goToNode", e.GOTO_DOMAIN = "goToDomain", e.API = "api", e.ZAPIER = "zapier", e.INTEGRATIONS = "integrations", e.GOOGLE_SHEETS = "google_sheets", e.INTENT = "intent", e.FLOW = "flow", e.COMPONENT = "component", e.CODE = "code", e.EXIT = "exit", e.PROMPT = "prompt", e.COMMAND = "command", e.TRACE = "trace", e.CHANNEL_ACTION = "channel_action", e.CUSTOM_BLOCK_POINTER = "custom_block_pointer", e.URL = "url", e.STREAM = "stream", e.VISUAL = "visual", e.GENERAL = "general", e.DIRECTIVE = "directive", e.DEPRECATED = "deprecated";
})(te || (te = {}));
const c5 = [te.GOTO], cA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), fA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), hA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), dA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), mA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var hl;
(function(e) {
  e.CREATE_DATA = "Create Data", e.UPDATE_DATA = "Update Data", e.DELETE_DATA = "Delete Data", e.RETRIEVE_DATA = "Retrieve Data";
})(hl || (hl = {}));
const pA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get GoogleSheetsActionType() {
    return hl;
  }
}, Symbol.toStringTag, { value: "Module" })), gA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), EA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), TA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), vA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var dl;
(function(e) {
  e.PATH = "path", e.NONE = "none";
})(dl || (dl = {}));
const AA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get IfNoMatchType() {
    return dl;
  }
}, Symbol.toStringTag, { value: "Module" })), CA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var ml;
(function(e) {
  e.PATH = "PATH", e.GO_TO = "GO_TO";
})(ml || (ml = {}));
const _A = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ChoiceAction() {
    return ml;
  }
}, Symbol.toStringTag, { value: "Module" }));
var pl;
(function(e) {
  e.LOCAL = "LOCAL", e.GLOBAL = "GLOBAL";
})(pl || (pl = {}));
const bA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get IntentAvailability() {
    return pl;
  }
}, Symbol.toStringTag, { value: "Module" })), yA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), DA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var gl;
(function(e) {
  e[e.DEFAULT = 1] = "DEFAULT", e[e.DO_DUPLICATES = 2] = "DO_DUPLICATES";
})(gl || (gl = {}));
const SA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get RandomType() {
    return gl;
  }
}, Symbol.toStringTag, { value: "Module" }));
var El;
(function(e) {
  e[e.DEFAULT = 1] = "DEFAULT", e[e.DO_DUPLICATES = 2] = "DO_DUPLICATES";
})(El || (El = {}));
const OA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get RandomType() {
    return El;
  }
}, Symbol.toStringTag, { value: "Module" })), NA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), wA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var Tl;
(function(e) {
  e.AUDIO = "audio", e.MESSAGE = "message";
})(Tl || (Tl = {}));
const IA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get TraceSpeakType() {
    return Tl;
  }
}, Symbol.toStringTag, { value: "Module" })), RA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var vl;
(function(e) {
  e.LOOP = "LOOP", e.PLAY = "PLAY", e.PAUSE = "PAUSE", e.END = "END";
})(vl || (vl = {}));
const MA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get TraceStreamAction() {
    return vl;
  }
}, Symbol.toStringTag, { value: "Module" })), xA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), kA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var Al;
(function(e) {
  e.PREVIEW = "preview", e.ALL_VARIANTS = "all-variants";
})(Al || (Al = {}));
var Cl;
(function(e) {
  e.JUMP = "jump", e.PUSH = "push";
})(Cl || (Cl = {}));
var l1;
(function(e) {
  e.INTENT = "intent", e.ALEXA = "alexa";
})(l1 || (l1 = {}));
const PA = (e) => e.type === l1.INTENT, BA = Object.values(l1), FA = (e) => !BA.includes(e.type);
var _l;
(function(e) {
  e.EQUALS = "equals", e.GREATER = "greater", e.LESS = "less", e.AND = "and", e.OR = "or", e.VALUE = "value", e.VARIABLE = "variable", e.ADVANCE = "advance", e.PLUS = "plus", e.MINUS = "minus", e.TIMES = "times", e.DIVIDE = "divide", e.NOT = "not";
})(_l || (_l = {}));
var bl;
(function(e) {
  e.EQUALS = "equals", e.GREATER = "greater", e.LESS = "less", e.AND = "and", e.OR = "or", e.VALUE = "value", e.VARIABLE = "variable", e.ADVANCE = "advance", e.NOT_EQUAL = "not_equal", e.GREATER_OR_EQUAL = "greater_or_equal", e.LESS_OR_EQUAL = "less_or_equal", e.CONTAINS = "contains", e.NOT_CONTAIN = "not_contain", e.STARTS_WITH = "starts_with", e.ENDS_WITH = "ends_with", e.HAS_VALUE = "has_value", e.IS_EMPTY = "is_empty";
})(bl || (bl = {}));
var yl;
(function(e) {
  e.VARIABLE = "variable", e.VALUE = "value", e.LOGIC_GROUP = "logic_group", e.EXPRESSION = "expression";
})(yl || (yl = {}));
var Dl;
(function(e) {
  e.ZAPIER = "Zapier", e.CUSTOM_API = "Custom API", e.GOOGLE_SHEETS = "Google Sheets";
})(Dl || (Dl = {}));
var Sl;
(function(e) {
  e.ZAPIER = "Zapier", e.GOOGLE_SHEETS = "Google Sheets";
})(Sl || (Sl = {}));
var Ol;
(function(e) {
  e.NODE = "NODE", e.GLOBAL = "GLOBAL";
})(Ol || (Ol = {}));
var Nl;
(function(e) {
  e.PATH = "path", e.REPROMPT = "reprompt", e.BOTH = "both";
})(Nl || (Nl = {}));
var wl;
(function(e) {
  e.PATH = "path", e.REPROMPT = "reprompt";
})(wl || (wl = {}));
var bn;
(function(e) {
  e.LOG = "log", e.END = "end", e.TEXT = "text", e.PATH = "path", e.FLOW = "flow", e.GOTO = "goto", e.SPEAK = "speak", e.BLOCK = "block", e.DEBUG = "debug", e.CHOICE = "choice", e.STREAM = "stream", e.VISUAL = "visual", e.CARD_V2 = "cardV2", e.CAROUSEL = "carousel", e.NO_REPLY = "no-reply", e.ENTITY_FILLING = "entity-filling", e.CHANNEL_ACTION = "channel-action";
})(bn || (bn = {}));
const LA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get CanvasNodeVisibility() {
    return Al;
  },
  get CommandType() {
    return Cl;
  },
  get EventType() {
    return l1;
  },
  isIntentEvent: PA,
  isGeneralEvent: FA,
  get ExpressionType() {
    return _l;
  },
  get ExpressionTypeV2() {
    return bl;
  },
  get ConditionsLogicInterface() {
    return yl;
  },
  get IntegrationType() {
    return Dl;
  },
  get IntegrationPlatform() {
    return Sl;
  },
  get IntentScope() {
    return Ol;
  },
  get NoMatchType() {
    return Nl;
  },
  get NoReplyType() {
    return wl;
  },
  get TraceType() {
    return bn;
  }
}, Symbol.toStringTag, { value: "Module" }));
var Il;
(function(e) {
  e.MOBILE = "mobile", e.TABLET = "tablet", e.DESKTOP = "desktop", e.SMART_WATCH = "smart_watch", e.TELEVISION = "television", e.IN_CAR_DISPLAY = "in_car_display", e.ECHO_SPOT = "echo_spot", e.ECHO_SHOW_8 = "echo_show_8", e.ECHO_SHOW_10 = "echo_show_10", e.FIRE_HD_8 = "fire_hd_8", e.FIRE_HD_10 = "fire_hd_10", e.FIRE_TV_CUBE = "fire_tv_cube", e.GOOGLE_NEST_HUB = "google_nest_hub";
})(Il || (Il = {}));
var Rl;
(function(e) {
  e.FULL = "full", e.HIDDEN = "hidden", e.CROPPED = "cropped";
})(Rl || (Rl = {}));
var Ml;
(function(e) {
  e.JSON = "JSON", e.SPLASH = "SPLASH";
})(Ml || (Ml = {}));
var xl;
(function(e) {
  e.APL = "apl", e.IMAGE = "image";
})(xl || (xl = {}));
var kl;
(function(e) {
  e.AUTO = "AUTO", e.DEVICE = "DEVICE", e.CUSTOM_SIZE = "CUSTOM_SIZE";
})(kl || (kl = {}));
const $A = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get DeviceType() {
    return Il;
  },
  get CanvasVisibility() {
    return Rl;
  },
  get APLType() {
    return Ml;
  },
  get VisualType() {
    return xl;
  },
  get FrameType() {
    return kl;
  }
}, Symbol.toStringTag, { value: "Module" }));
var Pl;
(function(e) {
  e.START_A_ZAP = "Start a Zap";
})(Pl || (Pl = {}));
const HA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ZapierActionType() {
    return Pl;
  }
}, Symbol.toStringTag, { value: "Module" })), Y0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _v1: Xv,
  AIResponse: Qv,
  AISet: Zv,
  Api: eA,
  Buttons: tA,
  Capture: nA,
  CaptureV2: rA,
  Card: aA,
  CardV2: iA,
  Carousel: oA,
  ChannelAction: sA,
  Code: uA,
  Component: lA,
  CustomBlockPointer: cA,
  Directive: fA,
  Exit: hA,
  Flow: dA,
  General: mA,
  GoogleSheets: pA,
  GoTo: gA,
  GoToDomain: EA,
  GoToNode: TA,
  If: vA,
  IfV2: AA,
  Integration: CA,
  Interaction: _A,
  Intent: bA,
  Prompt: yA,
  Command: DA,
  Random: SA,
  RandomV2: OA,
  Set: NA,
  SetV2: wA,
  Speak: IA,
  Start: RA,
  Stream: MA,
  Text: xA,
  Url: kA,
  Utils: LA,
  Visual: $A,
  Zapier: HA,
  get NodeType() {
    return te;
  },
  RUNTIME_ONLY_NODES: c5
}, Symbol.toStringTag, { value: "Module" })), f5 = (e = {}) => Object.assign({}, e), K0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  defaultPlatformData: f5
}, Symbol.toStringTag, { value: "Module" }));
var go;
(function(e) {
  e.OPEN_URL = "open_url";
})(go || (go = {}));
const h5 = (e) => e.type === go.OPEN_URL, UA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ActionType() {
    return go;
  },
  isOpenURLAction: h5
}, Symbol.toStringTag, { value: "Module" }));
var Er;
(function(e) {
  e.TEXT = "text", e.ACTION = "action", e.INTENT = "intent", e.LAUNCH = "launch", e.NO_REPLY = "no-reply";
})(Er || (Er = {}));
const jA = (e) => e.type === Er.TEXT, zA = (e) => e.type === Er.ACTION, GA = (e) => e.type === Er.LAUNCH, VA = (e) => e.type === Er.NO_REPLY, YA = (e) => e.type === Er.INTENT, KA = Object.values(Er), WA = (e) => !KA.includes(e.type), W0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get RequestType() {
    return Er;
  },
  isTextRequest: jA,
  isActionRequest: zA,
  isLaunchRequest: GA,
  isNoReplyRequest: VA,
  isIntentRequest: YA,
  isGeneralRequest: WA,
  Action: UA
}, Symbol.toStringTag, { value: "Module" })), qA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var jt;
(function(e) {
  e.TEXT = "text", e.SPEAK = "speak", e.AUDIO = "audio", e.VISUALS = "visuals", e.CARD = "card", e.CAROUSEL = "carousel", e.BUTTONS = "buttons", e.CHOICE = "choice", e.CAPTURE = "capture", e.PROMPT = "prompt", e.INTENT = "intent", e.CONDITION = "condition", e.SET = "set", e.RANDOM = "random", e.FLOW = "flow", e.EXIT = "exit", e.API = "api", e.GOOGLE_SHEETS = "google_sheets", e.CUSTOM_CODE = "custom_code", e.CUSTOM_ACTION = "custom_action", e.START = "start";
})(jt || (jt = {}));
var Bl;
(function(e) {
  e.CONVERSATION_START = "conversation_start", e.NLU_INTENT_RESOLVED = "nlu.intent_resolved";
})(Bl || (Bl = {}));
const q0 = {
  [te.TEXT]: jt.TEXT,
  [te.SPEAK]: jt.SPEAK,
  [te.START]: jt.START,
  [te.CARD]: jt.CARD,
  [te.CAROUSEL]: jt.CAROUSEL,
  [te.BUTTONS]: jt.BUTTONS,
  [te.SET]: jt.SET,
  [te.SET_V2]: jt.SET,
  [te.IF]: jt.CONDITION,
  [te.IF_V2]: jt.CONDITION,
  [te.RANDOM]: jt.RANDOM,
  [te.CAPTURE]: jt.CAPTURE,
  [te.CAPTURE_V2]: jt.CAPTURE,
  [te.API]: jt.API,
  [te.GOOGLE_SHEETS]: jt.GOOGLE_SHEETS,
  [te.INTENT]: jt.INTENT,
  [te.CODE]: jt.CUSTOM_CODE,
  [te.EXIT]: jt.EXIT,
  [te.PROMPT]: jt.PROMPT,
  [te.VISUAL]: jt.VISUALS
};
function XA(e) {
  return e in q0 ? q0[e] : void 0;
}
const QA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get StepLogKind() {
    return jt;
  },
  get GlobalLogKind() {
    return Bl;
  },
  nodeTypeToStepLogKind: XA
}, Symbol.toStringTag, { value: "Module" }));
var dr;
(function(e) {
  e.OFF = "off", e.ERROR = "error", e.WARN = "warn", e.INFO = "info", e.VERBOSE = "verbose";
})(dr || (dr = {}));
const ZA = {
  [dr.OFF]: -1,
  [dr.ERROR]: 0,
  [dr.WARN]: 1,
  [dr.INFO]: 2,
  [dr.VERBOSE]: 3
}, JA = (e) => ZA[e], e3 = new Set(Object.values(dr)), t3 = (e) => e3.has(e), n3 = dr.INFO, r3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Kinds: QA,
  get LogLevel() {
    return dr;
  },
  Logs: qA,
  getValueForLogLevel: JA,
  isLogLevel: t3,
  DEFAULT_LOG_LEVEL: n3
}, Symbol.toStringTag, { value: "Module" }));
var ga;
(function(e) {
  e.BACKGROUND_COLOR = "backgroundColor", e.COLOR = "color", e.ITALIC = "italic", e.UNDERLINE = "underline", e.FONT_WEIGHT = "fontWeight", e.FONT_FAMILY = "fontFamily", e.STRIKE_THROUGH = "strikeThrough";
})(ga || (ga = {}));
var Aa;
(function(e) {
  e.LINK = "link", e.VARIABLE = "variable";
})(Aa || (Aa = {}));
var Fl;
(function(e) {
  e.TEXT_ALIGN = "textAlign";
})(Fl || (Fl = {}));
const a3 = (e) => e.type === Aa.VARIABLE, i3 = (e) => e.type === Aa.LINK, X0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get TextProperty() {
    return ga;
  },
  get ElementType() {
    return Aa;
  },
  get ElementProperty() {
    return Fl;
  },
  isVariableElement: a3,
  isLinkElement: i3
}, Symbol.toStringTag, { value: "Module" })), Q0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get TraceType() {
    return bn;
  }
}, Symbol.toStringTag, { value: "Module" }));
var c1;
(function(e) {
  e.DaVinci_003 = "text-davinci-003", e.GPT_3_5_turbo = "gpt-3.5-turbo", e.GPT_4 = "gpt-4", e.CLAUDE_V1 = "claude-v1", e.CLAUDE_INSTANT_V1 = "claude-instant-v1";
})(c1 || (c1 = {}));
const o3 = [c1.GPT_3_5_turbo, c1.GPT_4];
var Ll;
(function(e) {
  e.PROMPT = "prompt", e.MEMORY = "memory", e.MEMORY_PROMPT = "memory_prompt";
})(Ll || (Ll = {}));
var $l;
(function(e) {
  e.KNOWLEDGE_BASE = "knowledge_base", e.DEFAULT = "default";
})($l || ($l = {}));
var Hl;
(function(e) {
  e.SYSTEM = "system", e.ASSISTANT = "assistant", e.USER = "user";
})(Hl || (Hl = {}));
const s3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get GPT_MODEL() {
    return c1;
  },
  ChatModels: o3,
  get PROMPT_MODE() {
    return Ll;
  },
  get DATA_SOURCE() {
    return $l;
  },
  get Role() {
    return Hl;
  }
}, Symbol.toStringTag, { value: "Module" }));
var Z0;
(function(e) {
  e.PRODUCTION = "production", e.DEVELOPMENT = "development", e.LOCAL = "local", e.E2E = "e2e", e.TEST = "test", e.STAGING = "staging";
})(Z0 || (Z0 = {}));
var u3 = { exports: {} };
function l3(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Vs = { exports: {} };
const c3 = {}, f3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: c3
}, Symbol.toStringTag, { value: "Module" })), h3 = /* @__PURE__ */ _c(f3);
var J0;
function d5() {
  return J0 || (J0 = 1, function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(ft, function() {
      var n = n || function(r, a) {
        var i;
        if (typeof window < "u" && window.crypto && (i = window.crypto), typeof self < "u" && self.crypto && (i = self.crypto), typeof globalThis < "u" && globalThis.crypto && (i = globalThis.crypto), !i && typeof window < "u" && window.msCrypto && (i = window.msCrypto), !i && typeof ft < "u" && ft.crypto && (i = ft.crypto), !i && typeof l3 == "function")
          try {
            i = h3;
          } catch {
          }
        var o = function() {
          if (i) {
            if (typeof i.getRandomValues == "function")
              try {
                return i.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof i.randomBytes == "function")
              try {
                return i.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, s = Object.create || function() {
          function y() {
          }
          return function(O) {
            var B;
            return y.prototype = O, B = new y(), y.prototype = null, B;
          };
        }(), u = {}, l = u.lib = {}, c = l.Base = function() {
          return {
            extend: function(y) {
              var O = s(this);
              return y && O.mixIn(y), (!O.hasOwnProperty("init") || this.init === O.init) && (O.init = function() {
                O.$super.init.apply(this, arguments);
              }), O.init.prototype = O, O.$super = this, O;
            },
            create: function() {
              var y = this.extend();
              return y.init.apply(y, arguments), y;
            },
            init: function() {
            },
            mixIn: function(y) {
              for (var O in y)
                y.hasOwnProperty(O) && (this[O] = y[O]);
              y.hasOwnProperty("toString") && (this.toString = y.toString);
            },
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), f = l.WordArray = c.extend({
          init: function(y, O) {
            y = this.words = y || [], O != a ? this.sigBytes = O : this.sigBytes = y.length * 4;
          },
          toString: function(y) {
            return (y || T).stringify(this);
          },
          concat: function(y) {
            var O = this.words, B = y.words, S = this.sigBytes, C = y.sigBytes;
            if (this.clamp(), S % 4)
              for (var I = 0; I < C; I++) {
                var G = B[I >>> 2] >>> 24 - I % 4 * 8 & 255;
                O[S + I >>> 2] |= G << 24 - (S + I) % 4 * 8;
              }
            else
              for (var V = 0; V < C; V += 4)
                O[S + V >>> 2] = B[V >>> 2];
            return this.sigBytes += C, this;
          },
          clamp: function() {
            var y = this.words, O = this.sigBytes;
            y[O >>> 2] &= 4294967295 << 32 - O % 4 * 8, y.length = r.ceil(O / 4);
          },
          clone: function() {
            var y = c.clone.call(this);
            return y.words = this.words.slice(0), y;
          },
          random: function(y) {
            for (var O = [], B = 0; B < y; B += 4)
              O.push(o());
            return new f.init(O, y);
          }
        }), E = u.enc = {}, T = E.Hex = {
          stringify: function(y) {
            for (var O = y.words, B = y.sigBytes, S = [], C = 0; C < B; C++) {
              var I = O[C >>> 2] >>> 24 - C % 4 * 8 & 255;
              S.push((I >>> 4).toString(16)), S.push((I & 15).toString(16));
            }
            return S.join("");
          },
          parse: function(y) {
            for (var O = y.length, B = [], S = 0; S < O; S += 2)
              B[S >>> 3] |= parseInt(y.substr(S, 2), 16) << 24 - S % 8 * 4;
            return new f.init(B, O / 2);
          }
        }, g = E.Latin1 = {
          stringify: function(y) {
            for (var O = y.words, B = y.sigBytes, S = [], C = 0; C < B; C++) {
              var I = O[C >>> 2] >>> 24 - C % 4 * 8 & 255;
              S.push(String.fromCharCode(I));
            }
            return S.join("");
          },
          parse: function(y) {
            for (var O = y.length, B = [], S = 0; S < O; S++)
              B[S >>> 2] |= (y.charCodeAt(S) & 255) << 24 - S % 4 * 8;
            return new f.init(B, O);
          }
        }, m = E.Utf8 = {
          stringify: function(y) {
            try {
              return decodeURIComponent(escape(g.stringify(y)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          parse: function(y) {
            return g.parse(unescape(encodeURIComponent(y)));
          }
        }, v = l.BufferedBlockAlgorithm = c.extend({
          reset: function() {
            this._data = new f.init(), this._nDataBytes = 0;
          },
          _append: function(y) {
            typeof y == "string" && (y = m.parse(y)), this._data.concat(y), this._nDataBytes += y.sigBytes;
          },
          _process: function(y) {
            var O, B = this._data, S = B.words, C = B.sigBytes, I = this.blockSize, G = I * 4, V = C / G;
            y ? V = r.ceil(V) : V = r.max((V | 0) - this._minBufferSize, 0);
            var w = V * I, Y = r.min(w * 4, C);
            if (w) {
              for (var X = 0; X < w; X += I)
                this._doProcessBlock(S, X);
              O = S.splice(0, w), B.sigBytes -= Y;
            }
            return new f.init(O, Y);
          },
          clone: function() {
            var y = c.clone.call(this);
            return y._data = this._data.clone(), y;
          },
          _minBufferSize: 0
        });
        l.Hasher = v.extend({
          cfg: c.extend(),
          init: function(y) {
            this.cfg = this.cfg.extend(y), this.reset();
          },
          reset: function() {
            v.reset.call(this), this._doReset();
          },
          update: function(y) {
            return this._append(y), this._process(), this;
          },
          finalize: function(y) {
            y && this._append(y);
            var O = this._doFinalize();
            return O;
          },
          blockSize: 16,
          _createHelper: function(y) {
            return function(O, B) {
              return new y.init(B).finalize(O);
            };
          },
          _createHmacHelper: function(y) {
            return function(O, B) {
              return new b.HMAC.init(y, B).finalize(O);
            };
          }
        });
        var b = u.algo = {};
        return u;
      }(Math);
      return n;
    });
  }(Vs)), Vs.exports;
}
(function(e, t) {
  (function(n, r) {
    e.exports = r(d5());
  })(ft, function(n) {
    return function() {
      var r = n, a = r.lib, i = a.WordArray, o = r.enc;
      o.Base64 = {
        stringify: function(u) {
          var l = u.words, c = u.sigBytes, f = this._map;
          u.clamp();
          for (var E = [], T = 0; T < c; T += 3)
            for (var g = l[T >>> 2] >>> 24 - T % 4 * 8 & 255, m = l[T + 1 >>> 2] >>> 24 - (T + 1) % 4 * 8 & 255, v = l[T + 2 >>> 2] >>> 24 - (T + 2) % 4 * 8 & 255, b = g << 16 | m << 8 | v, y = 0; y < 4 && T + y * 0.75 < c; y++)
              E.push(f.charAt(b >>> 6 * (3 - y) & 63));
          var O = f.charAt(64);
          if (O)
            for (; E.length % 4; )
              E.push(O);
          return E.join("");
        },
        parse: function(u) {
          var l = u.length, c = this._map, f = this._reverseMap;
          if (!f) {
            f = this._reverseMap = [];
            for (var E = 0; E < c.length; E++)
              f[c.charCodeAt(E)] = E;
          }
          var T = c.charAt(64);
          if (T) {
            var g = u.indexOf(T);
            g !== -1 && (l = g);
          }
          return s(u, l, f);
        },
        _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
      };
      function s(u, l, c) {
        for (var f = [], E = 0, T = 0; T < l; T++)
          if (T % 4) {
            var g = c[u.charCodeAt(T - 1)] << T % 4 * 2, m = c[u.charCodeAt(T)] >>> 6 - T % 4 * 2, v = g | m;
            f[E >>> 2] |= v << 24 - E % 4 * 8, E++;
          }
        return i.create(f, E);
      }
    }(), n.enc.Base64;
  });
})(u3);
var d3 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(d5());
  })(ft, function(n) {
    return n.enc.Utf8;
  });
})(d3);
globalThis && globalThis.__classPrivateFieldSet;
globalThis && globalThis.__classPrivateFieldGet;
var Ys = Math.floor(Math.random() * 16777215), eh = wt.index = parseInt(Math.random() * 16777215, 10), th = (typeof process > "u" || typeof process.pid != "number" ? Math.floor(Math.random() * 1e5) : process.pid) % 65535, to = function(e) {
  return !!(e != null && e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e));
}, m5 = [];
for (var In = 0; In < 256; In++)
  m5[In] = (In <= 15 ? "0" : "") + In.toString(16);
var nh = new RegExp("^[0-9a-fA-F]{24}$"), f1 = [];
In = 0;
for (; In < 10; )
  f1[48 + In] = In++;
for (; In < 16; )
  f1[65 - 10 + In] = f1[97 - 10 + In] = In++;
function wt(e) {
  if (!(this instanceof wt))
    return new wt(e);
  if (e && (e instanceof wt || e._bsontype === "ObjectID"))
    return e;
  if (this._bsontype = "ObjectID", e == null || typeof e == "number") {
    this.id = this.generate(e);
    return;
  }
  var t = wt.isValid(e);
  if (!t && e != null)
    throw new Error(
      "Argument passed in must be a single String of 12 bytes or a string of 24 hex characters"
    );
  if (t && typeof e == "string" && e.length === 24)
    return wt.createFromHexString(e);
  if (e != null && e.length === 12)
    this.id = e;
  else {
    if (e != null && typeof e.toHexString == "function")
      return e;
    throw new Error(
      "Argument passed in must be a single String of 12 bytes or a string of 24 hex characters"
    );
  }
}
wt.default = wt;
wt.createFromTime = function(e) {
  return e = parseInt(e, 10) % 4294967295, new wt(p3(8, e) + "0000000000000000");
};
wt.createFromHexString = function(e) {
  if (typeof e > "u" || e != null && e.length !== 24)
    throw new Error(
      "Argument passed in must be a single String of 12 bytes or a string of 24 hex characters"
    );
  for (var t = "", n = 0; n < 24; )
    t += String.fromCharCode(f1[e.charCodeAt(n++)] << 4 | f1[e.charCodeAt(n++)]);
  return new wt(t);
};
wt.isValid = function(e) {
  return e == null ? !1 : typeof e == "number" ? !0 : typeof e == "string" ? e.length === 12 || e.length === 24 && nh.test(e) : e instanceof wt || to(e) ? !0 : typeof e.toHexString == "function" && (e.id instanceof _Buffer || typeof e.id == "string") ? e.id.length === 12 || e.id.length === 24 && nh.test(e.id) : !1;
};
wt.prototype = {
  constructor: wt,
  toHexString: function() {
    if (!this.id || !this.id.length)
      throw new Error(
        "invalid ObjectId, ObjectId.id must be either a string or a Buffer, but is [" + JSON.stringify(this.id) + "]"
      );
    if (this.id.length === 24)
      return this.id;
    if (to(this.id))
      return this.id.toString("hex");
    for (var e = "", t = 0; t < this.id.length; t++)
      e += m5[this.id.charCodeAt(t)];
    return e;
  },
  equals: function(e) {
    return e instanceof wt ? this.toString() === e.toString() : typeof e == "string" && wt.isValid(e) && e.length === 12 && to(this.id) ? e === this.id.toString("binary") : typeof e == "string" && wt.isValid(e) && e.length === 24 ? e.toLowerCase() === this.toHexString() : typeof e == "string" && wt.isValid(e) && e.length === 12 ? e === this.id : e != null && (e instanceof wt || e.toHexString) ? e.toHexString() === this.toHexString() : !1;
  },
  getTimestamp: function() {
    var e = new Date(), t;
    return to(this.id) ? t = this.id[3] | this.id[2] << 8 | this.id[1] << 16 | this.id[0] << 24 : t = this.id.charCodeAt(3) | this.id.charCodeAt(2) << 8 | this.id.charCodeAt(1) << 16 | this.id.charCodeAt(0) << 24, e.setTime(Math.floor(t) * 1e3), e;
  },
  generate: function(e) {
    typeof e != "number" && (e = ~~(Date.now() / 1e3)), e = parseInt(e, 10) % 4294967295;
    var t = m3();
    return String.fromCharCode(
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      Ys >> 16 & 255,
      Ys >> 8 & 255,
      Ys & 255,
      th >> 8 & 255,
      th & 255,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255
    );
  }
};
function m3() {
  return eh = (eh + 1) % 16777215;
}
function p3(e, t) {
  return t = t.toString(16), t.length === e ? t : "00000000".substring(t.length, e) + t;
}
var g3 = Symbol && Symbol.for && Symbol.for("nodejs.util.inspect.custom") || "inspect";
wt.prototype[g3] = function() {
  return "ObjectID(" + this + ")";
};
wt.prototype.toJSON = wt.prototype.toHexString;
wt.prototype.toString = wt.prototype.toHexString;
const E3 = (e, t) => Object.prototype.hasOwnProperty.call(e, t);
function T3(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var p5 = T3, v3 = typeof ft == "object" && ft && ft.Object === Object && ft, g5 = v3, A3 = g5, C3 = typeof self == "object" && self && self.Object === Object && self, _3 = A3 || C3 || Function("return this")(), Br = _3, b3 = Br, y3 = b3.Symbol, Bo = y3, rh = Bo, E5 = Object.prototype, D3 = E5.hasOwnProperty, S3 = E5.toString, Ii = rh ? rh.toStringTag : void 0;
function O3(e) {
  var t = D3.call(e, Ii), n = e[Ii];
  try {
    e[Ii] = void 0;
    var r = !0;
  } catch {
  }
  var a = S3.call(e);
  return r && (t ? e[Ii] = n : delete e[Ii]), a;
}
var N3 = O3, w3 = Object.prototype, I3 = w3.toString;
function R3(e) {
  return I3.call(e);
}
var M3 = R3, ah = Bo, x3 = N3, k3 = M3, P3 = "[object Null]", B3 = "[object Undefined]", ih = ah ? ah.toStringTag : void 0;
function F3(e) {
  return e == null ? e === void 0 ? B3 : P3 : ih && ih in Object(e) ? x3(e) : k3(e);
}
var Dc = F3;
function L3(e) {
  return e != null && typeof e == "object";
}
var T5 = L3, $3 = Dc, H3 = T5, U3 = "[object Arguments]";
function j3(e) {
  return H3(e) && $3(e) == U3;
}
var z3 = j3, oh = z3, G3 = T5, v5 = Object.prototype, V3 = v5.hasOwnProperty, Y3 = v5.propertyIsEnumerable;
oh(function() {
  return arguments;
}());
var sh = { exports: {} };
function K3() {
  return !1;
}
var W3 = K3;
(function(e, t) {
  var n = Br, r = W3, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? n.Buffer : void 0, u = s ? s.isBuffer : void 0, l = u || r;
  e.exports = l;
})(sh, sh.exports);
var Ul = { exports: {} };
(function(e, t) {
  var n = g5, r = t && !t.nodeType && t, a = r && !0 && e && !e.nodeType && e, i = a && a.exports === r, o = i && n.process, s = function() {
    try {
      var u = a && a.require && a.require("util").types;
      return u || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(Ul, Ul.exports);
var uh = Ul.exports;
uh && uh.isTypedArray;
var q3 = Dc, X3 = p5, Q3 = "[object AsyncFunction]", Z3 = "[object Function]", J3 = "[object GeneratorFunction]", eC = "[object Proxy]";
function tC(e) {
  if (!X3(e))
    return !1;
  var t = q3(e);
  return t == Z3 || t == J3 || t == Q3 || t == eC;
}
var nC = tC;
function rC() {
  this.__data__ = [], this.size = 0;
}
var aC = rC;
function iC(e, t) {
  return e === t || e !== e && t !== t;
}
var oC = iC, sC = oC;
function uC(e, t) {
  for (var n = e.length; n--; )
    if (sC(e[n][0], t))
      return n;
  return -1;
}
var Fo = uC, lC = Fo, cC = Array.prototype, fC = cC.splice;
function hC(e) {
  var t = this.__data__, n = lC(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : fC.call(t, n, 1), --this.size, !0;
}
var dC = hC, mC = Fo;
function pC(e) {
  var t = this.__data__, n = mC(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var gC = pC, EC = Fo;
function TC(e) {
  return EC(this.__data__, e) > -1;
}
var vC = TC, AC = Fo;
function CC(e, t) {
  var n = this.__data__, r = AC(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var _C = CC, bC = aC, yC = dC, DC = gC, SC = vC, OC = _C;
function si(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
si.prototype.clear = bC;
si.prototype.delete = yC;
si.prototype.get = DC;
si.prototype.has = SC;
si.prototype.set = OC;
var NC = si, wC = Br, IC = wC["__core-js_shared__"], RC = IC, Ks = RC, lh = function() {
  var e = /[^.]+$/.exec(Ks && Ks.keys && Ks.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function MC(e) {
  return !!lh && lh in e;
}
var xC = MC, kC = Function.prototype, PC = kC.toString;
function BC(e) {
  if (e != null) {
    try {
      return PC.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var A5 = BC, FC = nC, LC = xC, $C = p5, HC = A5, UC = /[\\^$.*+?()[\]{}|]/g, jC = /^\[object .+?Constructor\]$/, zC = Function.prototype, GC = Object.prototype, VC = zC.toString, YC = GC.hasOwnProperty, KC = RegExp(
  "^" + VC.call(YC).replace(UC, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function WC(e) {
  if (!$C(e) || LC(e))
    return !1;
  var t = FC(e) ? KC : jC;
  return t.test(HC(e));
}
var qC = WC;
function XC(e, t) {
  return e == null ? void 0 : e[t];
}
var QC = XC, ZC = qC, JC = QC;
function e6(e, t) {
  var n = JC(e, t);
  return ZC(n) ? n : void 0;
}
var ui = e6, t6 = ui, n6 = Br, r6 = t6(n6, "Map"), C5 = r6, a6 = ui, i6 = a6(Object, "create"), Lo = i6, ch = Lo;
function o6() {
  this.__data__ = ch ? ch(null) : {}, this.size = 0;
}
var s6 = o6;
function u6(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var l6 = u6, c6 = Lo, f6 = "__lodash_hash_undefined__", h6 = Object.prototype, d6 = h6.hasOwnProperty;
function m6(e) {
  var t = this.__data__;
  if (c6) {
    var n = t[e];
    return n === f6 ? void 0 : n;
  }
  return d6.call(t, e) ? t[e] : void 0;
}
var p6 = m6, g6 = Lo, E6 = Object.prototype, T6 = E6.hasOwnProperty;
function v6(e) {
  var t = this.__data__;
  return g6 ? t[e] !== void 0 : T6.call(t, e);
}
var A6 = v6, C6 = Lo, _6 = "__lodash_hash_undefined__";
function b6(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = C6 && t === void 0 ? _6 : t, this;
}
var y6 = b6, D6 = s6, S6 = l6, O6 = p6, N6 = A6, w6 = y6;
function li(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
li.prototype.clear = D6;
li.prototype.delete = S6;
li.prototype.get = O6;
li.prototype.has = N6;
li.prototype.set = w6;
var I6 = li, fh = I6, R6 = NC, M6 = C5;
function x6() {
  this.size = 0, this.__data__ = {
    hash: new fh(),
    map: new (M6 || R6)(),
    string: new fh()
  };
}
var k6 = x6;
function P6(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var B6 = P6, F6 = B6;
function L6(e, t) {
  var n = e.__data__;
  return F6(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var $o = L6, $6 = $o;
function H6(e) {
  var t = $6(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var U6 = H6, j6 = $o;
function z6(e) {
  return j6(this, e).get(e);
}
var G6 = z6, V6 = $o;
function Y6(e) {
  return V6(this, e).has(e);
}
var K6 = Y6, W6 = $o;
function q6(e, t) {
  var n = W6(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var X6 = q6, Q6 = k6, Z6 = U6, J6 = G6, e7 = K6, t7 = X6;
function ci(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
ci.prototype.clear = Q6;
ci.prototype.delete = Z6;
ci.prototype.get = J6;
ci.prototype.has = e7;
ci.prototype.set = t7;
var n7 = ci, r7 = Br;
r7.Uint8Array;
function a7(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var i7 = a7, hh = Bo, dh = hh ? hh.prototype : void 0;
dh && dh.valueOf;
var o7 = ui, s7 = Br, u7 = o7(s7, "DataView"), l7 = u7, c7 = ui, f7 = Br, h7 = c7(f7, "Promise"), d7 = h7, m7 = ui, p7 = Br, g7 = m7(p7, "Set"), _5 = g7, E7 = ui, T7 = Br, v7 = E7(T7, "WeakMap"), A7 = v7, jl = l7, zl = C5, Gl = d7, Vl = _5, Yl = A7, b5 = Dc, fi = A5, mh = "[object Map]", C7 = "[object Object]", ph = "[object Promise]", gh = "[object Set]", Eh = "[object WeakMap]", Th = "[object DataView]", _7 = fi(jl), b7 = fi(zl), y7 = fi(Gl), D7 = fi(Vl), S7 = fi(Yl), Ua = b5;
(jl && Ua(new jl(new ArrayBuffer(1))) != Th || zl && Ua(new zl()) != mh || Gl && Ua(Gl.resolve()) != ph || Vl && Ua(new Vl()) != gh || Yl && Ua(new Yl()) != Eh) && (Ua = function(e) {
  var t = b5(e), n = t == C7 ? e.constructor : void 0, r = n ? fi(n) : "";
  if (r)
    switch (r) {
      case _7:
        return Th;
      case b7:
        return mh;
      case y7:
        return ph;
      case D7:
        return gh;
      case S7:
        return Eh;
    }
  return t;
});
var y5 = n7, O7 = "Expected a function";
function Sc(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(O7);
  var n = function() {
    var r = arguments, a = t ? t.apply(this, r) : r[0], i = n.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, r);
    return n.cache = i.set(a, o) || i, o;
  };
  return n.cache = new (Sc.Cache || y5)(), n;
}
Sc.Cache = y5;
var N7 = Sc, w7 = N7, I7 = 500;
function R7(e) {
  var t = w7(e, function(r) {
    return n.size === I7 && n.clear(), r;
  }), n = t.cache;
  return t;
}
var M7 = R7, x7 = M7, k7 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, P7 = /\\(\\)?/g;
x7(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(k7, function(n, r, a, i) {
    t.push(a ? i.replace(P7, "$1") : r || n);
  }), t;
});
var vh = Bo, Ah = vh ? vh.prototype : void 0;
Ah && Ah.toString;
Array.from({ length: 26 }).map((e, t) => String.fromCharCode(97 + t));
function B7() {
}
var F7 = B7, Ws = _5, L7 = F7, $7 = i7, H7 = 1 / 0;
Ws && 1 / $7(new Ws([, -0]))[1] == H7;
globalThis && globalThis.__rest;
var Ho = {};
Object.defineProperty(Ho, "__esModule", { value: !0 });
function U7(e, t) {
  return e.type === t.type;
}
Ho.isType = U7;
function D5(e, t) {
  t === void 0 && (t = function(o) {
    return o instanceof Error;
  });
  var n = {}, r = e ? e + "/" : "";
  function a(o, s, u) {
    u === void 0 && (u = t);
    var l = r + o;
    if ({}.NODE_ENV !== "production") {
      if (n[l])
        throw new Error("Duplicate action type: " + l);
      n[l] = !0;
    }
    return Object.assign(function(c, f) {
      var E = {
        type: l,
        payload: c
      };
      return (s || f) && (E.meta = Object.assign({}, s, f)), u && (typeof u == "boolean" || u(c)) && (E.error = !0), E;
    }, {
      type: l,
      toString: function() {
        return l;
      },
      match: function(c) {
        return c.type === l;
      }
    });
  }
  function i(o, s) {
    return {
      type: r + o,
      started: a(o + "_STARTED", s, !1),
      done: a(o + "_DONE", s, !1),
      failed: a(o + "_FAILED", s, !0)
    };
  }
  return Object.assign(a, { async: i });
}
Ho.actionCreatorFactory = D5;
var j7 = Ho.default = D5;
j7();
var S5 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ft, function() {
    var n = 1e3, r = 6e4, a = 36e5, i = "millisecond", o = "second", s = "minute", u = "hour", l = "day", c = "week", f = "month", E = "quarter", T = "year", g = "date", m = "Invalid Date", v = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, b = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, y = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, O = function(H, $, L) {
      var Q = String(H);
      return !Q || Q.length >= $ ? H : "" + Array($ + 1 - Q.length).join(L) + H;
    }, B = { s: O, z: function(H) {
      var $ = -H.utcOffset(), L = Math.abs($), Q = Math.floor(L / 60), j = L % 60;
      return ($ <= 0 ? "+" : "-") + O(Q, 2, "0") + ":" + O(j, 2, "0");
    }, m: function H($, L) {
      if ($.date() < L.date())
        return -H(L, $);
      var Q = 12 * (L.year() - $.year()) + (L.month() - $.month()), j = $.clone().add(Q, f), ee = L - j < 0, J = $.clone().add(Q + (ee ? -1 : 1), f);
      return +(-(Q + (L - j) / (ee ? j - J : J - j)) || 0);
    }, a: function(H) {
      return H < 0 ? Math.ceil(H) || 0 : Math.floor(H);
    }, p: function(H) {
      return { M: f, y: T, w: c, d: l, D: g, h: u, m: s, s: o, ms: i, Q: E }[H] || String(H || "").toLowerCase().replace(/s$/, "");
    }, u: function(H) {
      return H === void 0;
    } }, S = "en", C = {};
    C[S] = y;
    var I = function(H) {
      return H instanceof Y;
    }, G = function(H, $, L) {
      var Q;
      if (!H)
        return S;
      if (typeof H == "string")
        C[H] && (Q = H), $ && (C[H] = $, Q = H);
      else {
        var j = H.name;
        C[j] = H, Q = j;
      }
      return !L && Q && (S = Q), Q || !L && S;
    }, V = function(H, $) {
      if (I(H))
        return H.clone();
      var L = typeof $ == "object" ? $ : {};
      return L.date = H, L.args = arguments, new Y(L);
    }, w = B;
    w.l = G, w.i = I, w.w = function(H, $) {
      return V(H, { locale: $.$L, utc: $.$u, x: $.$x, $offset: $.$offset });
    };
    var Y = function() {
      function H(L) {
        this.$L = G(L.locale, null, !0), this.parse(L);
      }
      var $ = H.prototype;
      return $.parse = function(L) {
        this.$d = function(Q) {
          var j = Q.date, ee = Q.utc;
          if (j === null)
            return new Date(NaN);
          if (w.u(j))
            return new Date();
          if (j instanceof Date)
            return new Date(j);
          if (typeof j == "string" && !/Z$/i.test(j)) {
            var J = j.match(v);
            if (J) {
              var z = J[2] - 1 || 0, _ = (J[7] || "0").substring(0, 3);
              return ee ? new Date(Date.UTC(J[1], z, J[3] || 1, J[4] || 0, J[5] || 0, J[6] || 0, _)) : new Date(J[1], z, J[3] || 1, J[4] || 0, J[5] || 0, J[6] || 0, _);
            }
          }
          return new Date(j);
        }(L), this.$x = L.x || {}, this.init();
      }, $.init = function() {
        var L = this.$d;
        this.$y = L.getFullYear(), this.$M = L.getMonth(), this.$D = L.getDate(), this.$W = L.getDay(), this.$H = L.getHours(), this.$m = L.getMinutes(), this.$s = L.getSeconds(), this.$ms = L.getMilliseconds();
      }, $.$utils = function() {
        return w;
      }, $.isValid = function() {
        return this.$d.toString() !== m;
      }, $.isSame = function(L, Q) {
        var j = V(L);
        return this.startOf(Q) <= j && j <= this.endOf(Q);
      }, $.isAfter = function(L, Q) {
        return V(L) < this.startOf(Q);
      }, $.isBefore = function(L, Q) {
        return this.endOf(Q) < V(L);
      }, $.$g = function(L, Q, j) {
        return w.u(L) ? this[Q] : this.set(j, L);
      }, $.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, $.valueOf = function() {
        return this.$d.getTime();
      }, $.startOf = function(L, Q) {
        var j = this, ee = !!w.u(Q) || Q, J = w.p(L), z = function(_e, ge) {
          var ye = w.w(j.$u ? Date.UTC(j.$y, ge, _e) : new Date(j.$y, ge, _e), j);
          return ee ? ye : ye.endOf(l);
        }, _ = function(_e, ge) {
          return w.w(j.toDate()[_e].apply(j.toDate("s"), (ee ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ge)), j);
        }, D = this.$W, he = this.$M, oe = this.$D, ve = "set" + (this.$u ? "UTC" : "");
        switch (J) {
          case T:
            return ee ? z(1, 0) : z(31, 11);
          case f:
            return ee ? z(1, he) : z(0, he + 1);
          case c:
            var le = this.$locale().weekStart || 0, Ce = (D < le ? D + 7 : D) - le;
            return z(ee ? oe - Ce : oe + (6 - Ce), he);
          case l:
          case g:
            return _(ve + "Hours", 0);
          case u:
            return _(ve + "Minutes", 1);
          case s:
            return _(ve + "Seconds", 2);
          case o:
            return _(ve + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, $.endOf = function(L) {
        return this.startOf(L, !1);
      }, $.$set = function(L, Q) {
        var j, ee = w.p(L), J = "set" + (this.$u ? "UTC" : ""), z = (j = {}, j[l] = J + "Date", j[g] = J + "Date", j[f] = J + "Month", j[T] = J + "FullYear", j[u] = J + "Hours", j[s] = J + "Minutes", j[o] = J + "Seconds", j[i] = J + "Milliseconds", j)[ee], _ = ee === l ? this.$D + (Q - this.$W) : Q;
        if (ee === f || ee === T) {
          var D = this.clone().set(g, 1);
          D.$d[z](_), D.init(), this.$d = D.set(g, Math.min(this.$D, D.daysInMonth())).$d;
        } else
          z && this.$d[z](_);
        return this.init(), this;
      }, $.set = function(L, Q) {
        return this.clone().$set(L, Q);
      }, $.get = function(L) {
        return this[w.p(L)]();
      }, $.add = function(L, Q) {
        var j, ee = this;
        L = Number(L);
        var J = w.p(Q), z = function(he) {
          var oe = V(ee);
          return w.w(oe.date(oe.date() + Math.round(he * L)), ee);
        };
        if (J === f)
          return this.set(f, this.$M + L);
        if (J === T)
          return this.set(T, this.$y + L);
        if (J === l)
          return z(1);
        if (J === c)
          return z(7);
        var _ = (j = {}, j[s] = r, j[u] = a, j[o] = n, j)[J] || 1, D = this.$d.getTime() + L * _;
        return w.w(D, this);
      }, $.subtract = function(L, Q) {
        return this.add(-1 * L, Q);
      }, $.format = function(L) {
        var Q = this, j = this.$locale();
        if (!this.isValid())
          return j.invalidDate || m;
        var ee = L || "YYYY-MM-DDTHH:mm:ssZ", J = w.z(this), z = this.$H, _ = this.$m, D = this.$M, he = j.weekdays, oe = j.months, ve = function(ge, ye, ze, ce) {
          return ge && (ge[ye] || ge(Q, ee)) || ze[ye].substr(0, ce);
        }, le = function(ge) {
          return w.s(z % 12 || 12, ge, "0");
        }, Ce = j.meridiem || function(ge, ye, ze) {
          var ce = ge < 12 ? "AM" : "PM";
          return ze ? ce.toLowerCase() : ce;
        }, _e = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: D + 1, MM: w.s(D + 1, 2, "0"), MMM: ve(j.monthsShort, D, oe, 3), MMMM: ve(oe, D), D: this.$D, DD: w.s(this.$D, 2, "0"), d: String(this.$W), dd: ve(j.weekdaysMin, this.$W, he, 2), ddd: ve(j.weekdaysShort, this.$W, he, 3), dddd: he[this.$W], H: String(z), HH: w.s(z, 2, "0"), h: le(1), hh: le(2), a: Ce(z, _, !0), A: Ce(z, _, !1), m: String(_), mm: w.s(_, 2, "0"), s: String(this.$s), ss: w.s(this.$s, 2, "0"), SSS: w.s(this.$ms, 3, "0"), Z: J };
        return ee.replace(b, function(ge, ye) {
          return ye || _e[ge] || J.replace(":", "");
        });
      }, $.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, $.diff = function(L, Q, j) {
        var ee, J = w.p(Q), z = V(L), _ = (z.utcOffset() - this.utcOffset()) * r, D = this - z, he = w.m(this, z);
        return he = (ee = {}, ee[T] = he / 12, ee[f] = he, ee[E] = he / 3, ee[c] = (D - _) / 6048e5, ee[l] = (D - _) / 864e5, ee[u] = D / a, ee[s] = D / r, ee[o] = D / n, ee)[J] || D, j ? he : w.a(he);
      }, $.daysInMonth = function() {
        return this.endOf(f).$D;
      }, $.$locale = function() {
        return C[this.$L];
      }, $.locale = function(L, Q) {
        if (!L)
          return this.$L;
        var j = this.clone(), ee = G(L, Q, !0);
        return ee && (j.$L = ee), j;
      }, $.clone = function() {
        return w.w(this.$d, this);
      }, $.toDate = function() {
        return new Date(this.valueOf());
      }, $.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, $.toISOString = function() {
        return this.$d.toISOString();
      }, $.toString = function() {
        return this.$d.toUTCString();
      }, H;
    }(), X = Y.prototype;
    return V.prototype = X, [["$ms", i], ["$s", o], ["$m", s], ["$H", u], ["$W", l], ["$M", f], ["$y", T], ["$D", g]].forEach(function(H) {
      X[H[1]] = function($) {
        return this.$g($, H[0], H[1]);
      };
    }), V.extend = function(H, $) {
      return H.$i || (H($, Y, V), H.$i = !0), V;
    }, V.locale = G, V.isDayjs = I, V.unix = function(H) {
      return V(1e3 * H);
    }, V.en = C[S], V.Ls = C, V.p = {}, V;
  });
})(S5);
const na = S5.exports;
var O5 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ft, function() {
    return function(n, r, a) {
      var i = r.prototype, o = i.format;
      a.en.ordinal = function(s) {
        var u = ["th", "st", "nd", "rd"], l = s % 100;
        return "[" + s + (u[(l - 20) % 10] || u[l] || u[0]) + "]";
      }, i.format = function(s) {
        var u = this, l = this.$locale();
        if (!this.isValid())
          return o.bind(this)(s);
        var c = this.$utils(), f = (s || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(E) {
          switch (E) {
            case "Q":
              return Math.ceil((u.$M + 1) / 3);
            case "Do":
              return l.ordinal(u.$D);
            case "gggg":
              return u.weekYear();
            case "GGGG":
              return u.isoWeekYear();
            case "wo":
              return l.ordinal(u.week(), "W");
            case "w":
            case "ww":
              return c.s(u.week(), E === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return c.s(u.isoWeek(), E === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return c.s(String(u.$H === 0 ? 24 : u.$H), E === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(u.$d.getTime() / 1e3);
            case "x":
              return u.$d.getTime();
            case "z":
              return "[" + u.offsetName() + "]";
            case "zzz":
              return "[" + u.offsetName("long") + "]";
            default:
              return E;
          }
        });
        return o.bind(this)(f);
      };
    };
  });
})(O5);
const z7 = O5.exports;
var N5 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ft, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-:/.()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, a = /\d\d/, i = /\d\d?/, o = /\d*[^\s\d-_:/()]+/, s = {}, u = function(m) {
      return (m = +m) + (m > 68 ? 1900 : 2e3);
    }, l = function(m) {
      return function(v) {
        this[m] = +v;
      };
    }, c = [/[+-]\d\d:?(\d\d)?|Z/, function(m) {
      (this.zone || (this.zone = {})).offset = function(v) {
        if (!v || v === "Z")
          return 0;
        var b = v.match(/([+-]|\d\d)/g), y = 60 * b[1] + (+b[2] || 0);
        return y === 0 ? 0 : b[0] === "+" ? -y : y;
      }(m);
    }], f = function(m) {
      var v = s[m];
      return v && (v.indexOf ? v : v.s.concat(v.f));
    }, E = function(m, v) {
      var b, y = s.meridiem;
      if (y) {
        for (var O = 1; O <= 24; O += 1)
          if (m.indexOf(y(O, 0, v)) > -1) {
            b = O > 12;
            break;
          }
      } else
        b = m === (v ? "pm" : "PM");
      return b;
    }, T = { A: [o, function(m) {
      this.afternoon = E(m, !1);
    }], a: [o, function(m) {
      this.afternoon = E(m, !0);
    }], S: [/\d/, function(m) {
      this.milliseconds = 100 * +m;
    }], SS: [a, function(m) {
      this.milliseconds = 10 * +m;
    }], SSS: [/\d{3}/, function(m) {
      this.milliseconds = +m;
    }], s: [i, l("seconds")], ss: [i, l("seconds")], m: [i, l("minutes")], mm: [i, l("minutes")], H: [i, l("hours")], h: [i, l("hours")], HH: [i, l("hours")], hh: [i, l("hours")], D: [i, l("day")], DD: [a, l("day")], Do: [o, function(m) {
      var v = s.ordinal, b = m.match(/\d+/);
      if (this.day = b[0], v)
        for (var y = 1; y <= 31; y += 1)
          v(y).replace(/\[|\]/g, "") === m && (this.day = y);
    }], M: [i, l("month")], MM: [a, l("month")], MMM: [o, function(m) {
      var v = f("months"), b = (f("monthsShort") || v.map(function(y) {
        return y.substr(0, 3);
      })).indexOf(m) + 1;
      if (b < 1)
        throw new Error();
      this.month = b % 12 || b;
    }], MMMM: [o, function(m) {
      var v = f("months").indexOf(m) + 1;
      if (v < 1)
        throw new Error();
      this.month = v % 12 || v;
    }], Y: [/[+-]?\d+/, l("year")], YY: [a, function(m) {
      this.year = u(m);
    }], YYYY: [/\d{4}/, l("year")], Z: c, ZZ: c };
    function g(m) {
      var v, b;
      v = m, b = s && s.formats;
      for (var y = (m = v.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(V, w, Y) {
        var X = Y && Y.toUpperCase();
        return w || b[Y] || n[Y] || b[X].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(H, $, L) {
          return $ || L.slice(1);
        });
      })).match(r), O = y.length, B = 0; B < O; B += 1) {
        var S = y[B], C = T[S], I = C && C[0], G = C && C[1];
        y[B] = G ? { regex: I, parser: G } : S.replace(/^\[|\]$/g, "");
      }
      return function(V) {
        for (var w = {}, Y = 0, X = 0; Y < O; Y += 1) {
          var H = y[Y];
          if (typeof H == "string")
            X += H.length;
          else {
            var $ = H.regex, L = H.parser, Q = V.substr(X), j = $.exec(Q)[0];
            L.call(w, j), V = V.replace(j, "");
          }
        }
        return function(ee) {
          var J = ee.afternoon;
          if (J !== void 0) {
            var z = ee.hours;
            J ? z < 12 && (ee.hours += 12) : z === 12 && (ee.hours = 0), delete ee.afternoon;
          }
        }(w), w;
      };
    }
    return function(m, v, b) {
      b.p.customParseFormat = !0, m && m.parseTwoDigitYear && (u = m.parseTwoDigitYear);
      var y = v.prototype, O = y.parse;
      y.parse = function(B) {
        var S = B.date, C = B.utc, I = B.args;
        this.$u = C;
        var G = I[1];
        if (typeof G == "string") {
          var V = I[2] === !0, w = I[3] === !0, Y = V || w, X = I[2];
          w && (X = I[2]), s = this.$locale(), !V && X && (s = b.Ls[X]), this.$d = function(Q, j, ee) {
            try {
              if (["x", "X"].indexOf(j) > -1)
                return new Date((j === "X" ? 1e3 : 1) * Q);
              var J = g(j)(Q), z = J.year, _ = J.month, D = J.day, he = J.hours, oe = J.minutes, ve = J.seconds, le = J.milliseconds, Ce = J.zone, _e = new Date(), ge = D || (z || _ ? 1 : _e.getDate()), ye = z || _e.getFullYear(), ze = 0;
              z && !_ || (ze = _ > 0 ? _ - 1 : _e.getMonth());
              var ce = he || 0, Dt = oe || 0, Se = ve || 0, Gt = le || 0;
              return Ce ? new Date(Date.UTC(ye, ze, ge, ce, Dt, Se, Gt + 60 * Ce.offset * 1e3)) : ee ? new Date(Date.UTC(ye, ze, ge, ce, Dt, Se, Gt)) : new Date(ye, ze, ge, ce, Dt, Se, Gt);
            } catch {
              return new Date("");
            }
          }(S, G, C), this.init(), X && X !== !0 && (this.$L = this.locale(X).$L), Y && S != this.format(G) && (this.$d = new Date("")), s = {};
        } else if (G instanceof Array)
          for (var H = G.length, $ = 1; $ <= H; $ += 1) {
            I[1] = G[$ - 1];
            var L = b.apply(this, I);
            if (L.isValid()) {
              this.$d = L.$d, this.$L = L.$L, this.init();
              break;
            }
            $ === H && (this.$d = new Date(""));
          }
        else
          O.call(this, B);
      };
    };
  });
})(N5);
const G7 = N5.exports;
var w5 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ft, function() {
    var n, r, a = 1e3, i = 6e4, o = 36e5, s = 864e5, u = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, l = 31536e6, c = 2592e6, f = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, E = { years: l, months: c, days: s, hours: o, minutes: i, seconds: a, milliseconds: 1, weeks: 6048e5 }, T = function(S) {
      return S instanceof B;
    }, g = function(S, C, I) {
      return new B(S, I, C.$l);
    }, m = function(S) {
      return r.p(S) + "s";
    }, v = function(S) {
      return S < 0;
    }, b = function(S) {
      return v(S) ? Math.ceil(S) : Math.floor(S);
    }, y = function(S) {
      return Math.abs(S);
    }, O = function(S, C) {
      return S ? v(S) ? { negative: !0, format: "" + y(S) + C } : { negative: !1, format: "" + S + C } : { negative: !1, format: "" };
    }, B = function() {
      function S(I, G, V) {
        var w = this;
        if (this.$d = {}, this.$l = V, I === void 0 && (this.$ms = 0, this.parseFromMilliseconds()), G)
          return g(I * E[m(G)], this);
        if (typeof I == "number")
          return this.$ms = I, this.parseFromMilliseconds(), this;
        if (typeof I == "object")
          return Object.keys(I).forEach(function(H) {
            w.$d[m(H)] = I[H];
          }), this.calMilliseconds(), this;
        if (typeof I == "string") {
          var Y = I.match(f);
          if (Y) {
            var X = Y.slice(2).map(function(H) {
              return H != null ? Number(H) : 0;
            });
            return this.$d.years = X[0], this.$d.months = X[1], this.$d.weeks = X[2], this.$d.days = X[3], this.$d.hours = X[4], this.$d.minutes = X[5], this.$d.seconds = X[6], this.calMilliseconds(), this;
          }
        }
        return this;
      }
      var C = S.prototype;
      return C.calMilliseconds = function() {
        var I = this;
        this.$ms = Object.keys(this.$d).reduce(function(G, V) {
          return G + (I.$d[V] || 0) * E[V];
        }, 0);
      }, C.parseFromMilliseconds = function() {
        var I = this.$ms;
        this.$d.years = b(I / l), I %= l, this.$d.months = b(I / c), I %= c, this.$d.days = b(I / s), I %= s, this.$d.hours = b(I / o), I %= o, this.$d.minutes = b(I / i), I %= i, this.$d.seconds = b(I / a), I %= a, this.$d.milliseconds = I;
      }, C.toISOString = function() {
        var I = O(this.$d.years, "Y"), G = O(this.$d.months, "M"), V = +this.$d.days || 0;
        this.$d.weeks && (V += 7 * this.$d.weeks);
        var w = O(V, "D"), Y = O(this.$d.hours, "H"), X = O(this.$d.minutes, "M"), H = this.$d.seconds || 0;
        this.$d.milliseconds && (H += this.$d.milliseconds / 1e3);
        var $ = O(H, "S"), L = I.negative || G.negative || w.negative || Y.negative || X.negative || $.negative, Q = Y.format || X.format || $.format ? "T" : "", j = (L ? "-" : "") + "P" + I.format + G.format + w.format + Q + Y.format + X.format + $.format;
        return j === "P" || j === "-P" ? "P0D" : j;
      }, C.toJSON = function() {
        return this.toISOString();
      }, C.format = function(I) {
        var G = I || "YYYY-MM-DDTHH:mm:ss", V = { Y: this.$d.years, YY: r.s(this.$d.years, 2, "0"), YYYY: r.s(this.$d.years, 4, "0"), M: this.$d.months, MM: r.s(this.$d.months, 2, "0"), D: this.$d.days, DD: r.s(this.$d.days, 2, "0"), H: this.$d.hours, HH: r.s(this.$d.hours, 2, "0"), m: this.$d.minutes, mm: r.s(this.$d.minutes, 2, "0"), s: this.$d.seconds, ss: r.s(this.$d.seconds, 2, "0"), SSS: r.s(this.$d.milliseconds, 3, "0") };
        return G.replace(u, function(w, Y) {
          return Y || String(V[w]);
        });
      }, C.as = function(I) {
        return this.$ms / E[m(I)];
      }, C.get = function(I) {
        var G = this.$ms, V = m(I);
        return V === "milliseconds" ? G %= 1e3 : G = V === "weeks" ? b(G / E[V]) : this.$d[V], G === 0 ? 0 : G;
      }, C.add = function(I, G, V) {
        var w;
        return w = G ? I * E[m(G)] : T(I) ? I.$ms : g(I, this).$ms, g(this.$ms + w * (V ? -1 : 1), this);
      }, C.subtract = function(I, G) {
        return this.add(I, G, !0);
      }, C.locale = function(I) {
        var G = this.clone();
        return G.$l = I, G;
      }, C.clone = function() {
        return g(this.$ms, this);
      }, C.humanize = function(I) {
        return n().add(this.$ms, "ms").locale(this.$l).fromNow(!I);
      }, C.milliseconds = function() {
        return this.get("milliseconds");
      }, C.asMilliseconds = function() {
        return this.as("milliseconds");
      }, C.seconds = function() {
        return this.get("seconds");
      }, C.asSeconds = function() {
        return this.as("seconds");
      }, C.minutes = function() {
        return this.get("minutes");
      }, C.asMinutes = function() {
        return this.as("minutes");
      }, C.hours = function() {
        return this.get("hours");
      }, C.asHours = function() {
        return this.as("hours");
      }, C.days = function() {
        return this.get("days");
      }, C.asDays = function() {
        return this.as("days");
      }, C.weeks = function() {
        return this.get("weeks");
      }, C.asWeeks = function() {
        return this.as("weeks");
      }, C.months = function() {
        return this.get("months");
      }, C.asMonths = function() {
        return this.as("months");
      }, C.years = function() {
        return this.get("years");
      }, C.asYears = function() {
        return this.as("years");
      }, S;
    }();
    return function(S, C, I) {
      n = I, r = I().$utils(), I.duration = function(w, Y) {
        var X = I.locale();
        return g(w, { $l: X }, Y);
      }, I.isDuration = T;
      var G = C.prototype.add, V = C.prototype.subtract;
      C.prototype.add = function(w, Y) {
        return T(w) && (w = w.asMilliseconds()), G.bind(this)(w, Y);
      }, C.prototype.subtract = function(w, Y) {
        return T(w) && (w = w.asMilliseconds()), V.bind(this)(w, Y);
      };
    };
  });
})(w5);
const V7 = w5.exports;
var I5 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ft, function() {
    return function(n, r, a) {
      var i = function(o, s) {
        if (!s || !s.length || !s[0] || s.length === 1 && !s[0].length)
          return null;
        var u;
        s.length === 1 && s[0].length > 0 && (s = s[0]), u = s[0];
        for (var l = 1; l < s.length; l += 1)
          s[l].isValid() && !s[l][o](u) || (u = s[l]);
        return u;
      };
      a.max = function() {
        var o = [].slice.call(arguments, 0);
        return i("isAfter", o);
      }, a.min = function() {
        var o = [].slice.call(arguments, 0);
        return i("isBefore", o);
      };
    };
  });
})(I5);
const Y7 = I5.exports;
var R5 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ft, function() {
    return function(n, r, a) {
      n = n || {};
      var i = r.prototype, o = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function s(l, c, f, E) {
        return i.fromToBase(l, c, f, E);
      }
      a.en.relativeTime = o, i.fromToBase = function(l, c, f, E, T) {
        for (var g, m, v, b = f.$locale().relativeTime || o, y = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], O = y.length, B = 0; B < O; B += 1) {
          var S = y[B];
          S.d && (g = E ? a(l).diff(f, S.d, !0) : f.diff(l, S.d, !0));
          var C = (n.rounding || Math.round)(Math.abs(g));
          if (v = g > 0, C <= S.r || !S.r) {
            C <= 1 && B > 0 && (S = y[B - 1]);
            var I = b[S.l];
            T && (C = T("" + C)), m = typeof I == "string" ? I.replace("%d", C) : I(C, c, S.l, v);
            break;
          }
        }
        if (c)
          return m;
        var G = v ? b.future : b.past;
        return typeof G == "function" ? G(m) : G.replace("%s", m);
      }, i.to = function(l, c) {
        return s(l, c, this, !0);
      }, i.from = function(l, c) {
        return s(l, c, this);
      };
      var u = function(l) {
        return l.$u ? a.utc() : a();
      };
      i.toNow = function(l) {
        return this.to(u(this), l);
      }, i.fromNow = function(l) {
        return this.from(u(this), l);
      };
    };
  });
})(R5);
const K7 = R5.exports;
var M5 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ft, function() {
    return function(n, r, a) {
      a.updateLocale = function(i, o) {
        var s = a.Ls[i];
        if (s)
          return (o ? Object.keys(o) : []).forEach(function(u) {
            s[u] = o[u];
          }), s;
      };
    };
  });
})(M5);
const W7 = M5.exports;
var x5 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ft, function() {
    var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, a = /([+-]|\d\d)/g;
    return function(i, o, s) {
      var u = o.prototype;
      s.utc = function(m) {
        var v = { date: m, utc: !0, args: arguments };
        return new o(v);
      }, u.utc = function(m) {
        var v = s(this.toDate(), { locale: this.$L, utc: !0 });
        return m ? v.add(this.utcOffset(), n) : v;
      }, u.local = function() {
        return s(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var l = u.parse;
      u.parse = function(m) {
        m.utc && (this.$u = !0), this.$utils().u(m.$offset) || (this.$offset = m.$offset), l.call(this, m);
      };
      var c = u.init;
      u.init = function() {
        if (this.$u) {
          var m = this.$d;
          this.$y = m.getUTCFullYear(), this.$M = m.getUTCMonth(), this.$D = m.getUTCDate(), this.$W = m.getUTCDay(), this.$H = m.getUTCHours(), this.$m = m.getUTCMinutes(), this.$s = m.getUTCSeconds(), this.$ms = m.getUTCMilliseconds();
        } else
          c.call(this);
      };
      var f = u.utcOffset;
      u.utcOffset = function(m, v) {
        var b = this.$utils().u;
        if (b(m))
          return this.$u ? 0 : b(this.$offset) ? f.call(this) : this.$offset;
        if (typeof m == "string" && (m = function(S) {
          S === void 0 && (S = "");
          var C = S.match(r);
          if (!C)
            return null;
          var I = ("" + C[0]).match(a) || ["-", 0, 0], G = I[0], V = 60 * +I[1] + +I[2];
          return V === 0 ? 0 : G === "+" ? V : -V;
        }(m)) === null)
          return this;
        var y = Math.abs(m) <= 16 ? 60 * m : m, O = this;
        if (v)
          return O.$offset = y, O.$u = m === 0, O;
        if (m !== 0) {
          var B = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (O = this.local().add(y + B, n)).$offset = y, O.$x.$localOffset = B;
        } else
          O = this.utc();
        return O;
      };
      var E = u.format;
      u.format = function(m) {
        var v = m || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return E.call(this, v);
      }, u.valueOf = function() {
        var m = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || new Date().getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * m;
      }, u.isUTC = function() {
        return !!this.$u;
      }, u.toISOString = function() {
        return this.toDate().toISOString();
      }, u.toString = function() {
        return this.toDate().toUTCString();
      };
      var T = u.toDate;
      u.toDate = function(m) {
        return m === "s" && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : T.call(this);
      };
      var g = u.diff;
      u.diff = function(m, v, b) {
        if (m && this.$u === m.$u)
          return g.call(this, m, v, b);
        var y = this.local(), O = s(m).local();
        return g.call(y, O, v, b);
      };
    };
  });
})(x5);
const q7 = x5.exports;
na.extend(q7);
na.extend(V7);
na.extend(K7);
na.extend(G7);
na.extend(Y7);
na.extend(z7);
na.extend(W7);
na.updateLocale("en", {
  relativeTime: {
    future: "in %s",
    past: "%s ago",
    s: "seconds",
    m: "a minute",
    mm: "%d minutes",
    h: "an hour",
    hh: "%d hours",
    d: "a day",
    dd: "%d days",
    M: "a month",
    MM: "%d months",
    y: "a year",
    yy: "%d years"
  }
});
const X7 = [
  {
    group: "US (Common)",
    zones: [
      {
        value: "US/Puerto_Rico",
        name: "Puerto Rico (Atlantic)"
      },
      {
        value: "US/New_York",
        name: "New York (Eastern)"
      },
      {
        value: "US/Chicago",
        name: "Chicago (Central)"
      },
      {
        value: "US/Denver",
        name: "Denver (Mountain)"
      },
      {
        value: "US/Phoenix",
        name: "Phoenix (MST)"
      },
      {
        value: "US/Los_Angeles",
        name: "Los Angeles (Pacific)"
      },
      {
        value: "US/Anchorage",
        name: "Anchorage (Alaska)"
      },
      {
        value: "America Pacific/Honolulu",
        name: "Honolulu (Hawaii)"
      }
    ]
  },
  {
    group: "America",
    zones: [
      {
        value: "America/Adak",
        name: "Adak"
      },
      {
        value: "America/Anchorage",
        name: "Anchorage"
      },
      {
        value: "America/Anguilla",
        name: "Anguilla"
      },
      {
        value: "America/Antigua",
        name: "Antigua"
      },
      {
        value: "America/Araguaina",
        name: "Araguaina"
      },
      {
        value: "America/Argentina/Buenos_Aires",
        name: "Argentina - Buenos Aires"
      },
      {
        value: "America/Argentina/Catamarca",
        name: "Argentina - Catamarca"
      },
      {
        value: "America/Argentina/ComodRivadavia",
        name: "Argentina - ComodRivadavia"
      },
      {
        value: "America/Argentina/Cordoba",
        name: "Argentina - Cordoba"
      },
      {
        value: "America/Argentina/Jujuy",
        name: "Argentina - Jujuy"
      },
      {
        value: "America/Argentina/La_Rioja",
        name: "Argentina - La Rioja"
      },
      {
        value: "America/Argentina/Mendoza",
        name: "Argentina - Mendoza"
      },
      {
        value: "America/Argentina/Rio_Gallegos",
        name: "Argentina - Rio Gallegos"
      },
      {
        value: "America/Argentina/Salta",
        name: "Argentina - Salta"
      },
      {
        value: "America/Argentina/San_Juan",
        name: "Argentina - San Juan"
      },
      {
        value: "America/Argentina/San_Luis",
        name: "Argentina - San Luis"
      },
      {
        value: "America/Argentina/Tucuman",
        name: "Argentina - Tucuman"
      },
      {
        value: "America/Argentina/Ushuaia",
        name: "Argentina - Ushuaia"
      },
      {
        value: "America/Aruba",
        name: "Aruba"
      },
      {
        value: "America/Asuncion",
        name: "Asuncion"
      },
      {
        value: "America/Atikokan",
        name: "Atikokan"
      },
      {
        value: "America/Atka",
        name: "Atka"
      },
      {
        value: "America/Bahia",
        name: "Bahia"
      },
      {
        value: "America/Barbados",
        name: "Barbados"
      },
      {
        value: "America/Belem",
        name: "Belem"
      },
      {
        value: "America/Belize",
        name: "Belize"
      },
      {
        value: "America/Blanc-Sablon",
        name: "Blanc-Sablon"
      },
      {
        value: "America/Boa_Vista",
        name: "Boa Vista"
      },
      {
        value: "America/Bogota",
        name: "Bogota"
      },
      {
        value: "America/Boise",
        name: "Boise"
      },
      {
        value: "America/Buenos_Aires",
        name: "Buenos Aires"
      },
      {
        value: "America/Cambridge_Bay",
        name: "Cambridge Bay"
      },
      {
        value: "America/Campo_Grande",
        name: "Campo Grande"
      },
      {
        value: "America/Cancun",
        name: "Cancun"
      },
      {
        value: "America/Caracas",
        name: "Caracas"
      },
      {
        value: "America/Catamarca",
        name: "Catamarca"
      },
      {
        value: "America/Cayenne",
        name: "Cayenne"
      },
      {
        value: "America/Cayman",
        name: "Cayman"
      },
      {
        value: "America/Chicago",
        name: "Chicago"
      },
      {
        value: "America/Chihuahua",
        name: "Chihuahua"
      },
      {
        value: "America/Coral_Harbour",
        name: "Coral Harbour"
      },
      {
        value: "America/Cordoba",
        name: "Cordoba"
      },
      {
        value: "America/Costa_Rica",
        name: "Costa Rica"
      },
      {
        value: "America/Cuiaba",
        name: "Cuiaba"
      },
      {
        value: "America/Curacao",
        name: "Curacao"
      },
      {
        value: "America/Danmarkshavn",
        name: "Danmarkshavn"
      },
      {
        value: "America/Dawson",
        name: "Dawson"
      },
      {
        value: "America/Dawson_Creek",
        name: "Dawson Creek"
      },
      {
        value: "America/Denver",
        name: "Denver"
      },
      {
        value: "America/Detroit",
        name: "Detroit"
      },
      {
        value: "America/Dominica",
        name: "Dominica"
      },
      {
        value: "America/Edmonton",
        name: "Edmonton"
      },
      {
        value: "America/Eirunepe",
        name: "Eirunepe"
      },
      {
        value: "America/El_Salvador",
        name: "El Salvador"
      },
      {
        value: "America/Ensenada",
        name: "Ensenada"
      },
      {
        value: "America/Fortaleza",
        name: "Fortaleza"
      },
      {
        value: "America/Fort_Wayne",
        name: "Fort Wayne"
      },
      {
        value: "America/Glace_Bay",
        name: "Glace Bay"
      },
      {
        value: "America/Godthab",
        name: "Godthab"
      },
      {
        value: "America/Goose_Bay",
        name: "Goose Bay"
      },
      {
        value: "America/Grand_Turk",
        name: "Grand Turk"
      },
      {
        value: "America/Grenada",
        name: "Grenada"
      },
      {
        value: "America/Guadeloupe",
        name: "Guadeloupe"
      },
      {
        value: "America/Guatemala",
        name: "Guatemala"
      },
      {
        value: "America/Guayaquil",
        name: "Guayaquil"
      },
      {
        value: "America/Guyana",
        name: "Guyana"
      },
      {
        value: "America/Halifax",
        name: "Halifax"
      },
      {
        value: "America/Havana",
        name: "Havana"
      },
      {
        value: "America/Hermosillo",
        name: "Hermosillo"
      },
      {
        value: "America/Indiana/Indianapolis",
        name: "Indiana - Indianapolis"
      },
      {
        value: "America/Indiana/Knox",
        name: "Indiana - Knox"
      },
      {
        value: "America/Indiana/Marengo",
        name: "Indiana - Marengo"
      },
      {
        value: "America/Indiana/Petersburg",
        name: "Indiana - Petersburg"
      },
      {
        value: "America/Indiana/Tell_City",
        name: "Indiana - Tell City"
      },
      {
        value: "America/Indiana/Vevay",
        name: "Indiana - Vevay"
      },
      {
        value: "America/Indiana/Vincennes",
        name: "Indiana - Vincennes"
      },
      {
        value: "America/Indiana/Winamac",
        name: "Indiana - Winamac"
      },
      {
        value: "America/Indianapolis",
        name: "Indianapolis"
      },
      {
        value: "America/Inuvik",
        name: "Inuvik"
      },
      {
        value: "America/Iqaluit",
        name: "Iqaluit"
      },
      {
        value: "America/Jamaica",
        name: "Jamaica"
      },
      {
        value: "America/Jujuy",
        name: "Jujuy"
      },
      {
        value: "America/Juneau",
        name: "Juneau"
      },
      {
        value: "America/Kentucky/Louisville",
        name: "Kentucky - Louisville"
      },
      {
        value: "America/Kentucky/Monticello",
        name: "Kentucky - Monticello"
      },
      {
        value: "America/Knox_IN",
        name: "Knox IN"
      },
      {
        value: "America/La_Paz",
        name: "La Paz"
      },
      {
        value: "America/Lima",
        name: "Lima"
      },
      {
        value: "America/Los_Angeles",
        name: "Los Angeles"
      },
      {
        value: "America/Louisville",
        name: "Louisville"
      },
      {
        value: "America/Maceio",
        name: "Maceio"
      },
      {
        value: "America/Managua",
        name: "Managua"
      },
      {
        value: "America/Manaus",
        name: "Manaus"
      },
      {
        value: "America/Marigot",
        name: "Marigot"
      },
      {
        value: "America/Martinique",
        name: "Martinique"
      },
      {
        value: "America/Matamoros",
        name: "Matamoros"
      },
      {
        value: "America/Mazatlan",
        name: "Mazatlan"
      },
      {
        value: "America/Mendoza",
        name: "Mendoza"
      },
      {
        value: "America/Menominee",
        name: "Menominee"
      },
      {
        value: "America/Merida",
        name: "Merida"
      },
      {
        value: "America/Mexico_City",
        name: "Mexico City"
      },
      {
        value: "America/Miquelon",
        name: "Miquelon"
      },
      {
        value: "America/Moncton",
        name: "Moncton"
      },
      {
        value: "America/Monterrey",
        name: "Monterrey"
      },
      {
        value: "America/Montevideo",
        name: "Montevideo"
      },
      {
        value: "America/Montreal",
        name: "Montreal"
      },
      {
        value: "America/Montserrat",
        name: "Montserrat"
      },
      {
        value: "America/Nassau",
        name: "Nassau"
      },
      {
        value: "America/New_York",
        name: "New York"
      },
      {
        value: "America/Nipigon",
        name: "Nipigon"
      },
      {
        value: "America/Nome",
        name: "Nome"
      },
      {
        value: "America/Noronha",
        name: "Noronha"
      },
      {
        value: "America/North_Dakota/Center",
        name: "North Dakota - Center"
      },
      {
        value: "America/North_Dakota/New_Salem",
        name: "North Dakota - New Salem"
      },
      {
        value: "America/Ojinaga",
        name: "Ojinaga"
      },
      {
        value: "America/Panama",
        name: "Panama"
      },
      {
        value: "America/Pangnirtung",
        name: "Pangnirtung"
      },
      {
        value: "America/Paramaribo",
        name: "Paramaribo"
      },
      {
        value: "America/Phoenix",
        name: "Phoenix"
      },
      {
        value: "America/Port-au-Prince",
        name: "Port-au-Prince"
      },
      {
        value: "America/Porto_Acre",
        name: "Porto Acre"
      },
      {
        value: "America/Port_of_Spain",
        name: "Port of Spain"
      },
      {
        value: "America/Porto_Velho",
        name: "Porto Velho"
      },
      {
        value: "America/Puerto_Rico",
        name: "Puerto Rico"
      },
      {
        value: "America/Rainy_River",
        name: "Rainy River"
      },
      {
        value: "America/Rankin_Inlet",
        name: "Rankin Inlet"
      },
      {
        value: "America/Recife",
        name: "Recife"
      },
      {
        value: "America/Regina",
        name: "Regina"
      },
      {
        value: "America/Resolute",
        name: "Resolute"
      },
      {
        value: "America/Rio_Branco",
        name: "Rio Branco"
      },
      {
        value: "America/Rosario",
        name: "Rosario"
      },
      {
        value: "America/Santa_Isabel",
        name: "Santa Isabel"
      },
      {
        value: "America/Santarem",
        name: "Santarem"
      },
      {
        value: "America/Santiago",
        name: "Santiago"
      },
      {
        value: "America/Santo_Domingo",
        name: "Santo Domingo"
      },
      {
        value: "America/Sao_Paulo",
        name: "Sao Paulo"
      },
      {
        value: "America/Scoresbysund",
        name: "Scoresbysund"
      },
      {
        value: "America/Shiprock",
        name: "Shiprock"
      },
      {
        value: "America/St_Barthelemy",
        name: "St Barthelemy"
      },
      {
        value: "America/St_Johns",
        name: "St Johns"
      },
      {
        value: "America/St_Kitts",
        name: "St Kitts"
      },
      {
        value: "America/St_Lucia",
        name: "St Lucia"
      },
      {
        value: "America/St_Thomas",
        name: "St Thomas"
      },
      {
        value: "America/St_Vincent",
        name: "St Vincent"
      },
      {
        value: "America/Swift_Current",
        name: "Swift Current"
      },
      {
        value: "America/Tegucigalpa",
        name: "Tegucigalpa"
      },
      {
        value: "America/Thule",
        name: "Thule"
      },
      {
        value: "America/Thunder_Bay",
        name: "Thunder Bay"
      },
      {
        value: "America/Tijuana",
        name: "Tijuana"
      },
      {
        value: "America/Toronto",
        name: "Toronto"
      },
      {
        value: "America/Tortola",
        name: "Tortola"
      },
      {
        value: "America/Vancouver",
        name: "Vancouver"
      },
      {
        value: "America/Virgin",
        name: "Virgin"
      },
      {
        value: "America/Whitehorse",
        name: "Whitehorse"
      },
      {
        value: "America/Winnipeg",
        name: "Winnipeg"
      },
      {
        value: "America/Yakutat",
        name: "Yakutat"
      },
      {
        value: "America/Yellowknife",
        name: "Yellowknife"
      }
    ]
  },
  {
    group: "Europe",
    zones: [
      {
        value: "Europe/Amsterdam",
        name: "Amsterdam"
      },
      {
        value: "Europe/Andorra",
        name: "Andorra"
      },
      {
        value: "Europe/Athens",
        name: "Athens"
      },
      {
        value: "Europe/Belfast",
        name: "Belfast"
      },
      {
        value: "Europe/Belgrade",
        name: "Belgrade"
      },
      {
        value: "Europe/Berlin",
        name: "Berlin"
      },
      {
        value: "Europe/Bratislava",
        name: "Bratislava"
      },
      {
        value: "Europe/Brussels",
        name: "Brussels"
      },
      {
        value: "Europe/Bucharest",
        name: "Bucharest"
      },
      {
        value: "Europe/Budapest",
        name: "Budapest"
      },
      {
        value: "Europe/Chisinau",
        name: "Chisinau"
      },
      {
        value: "Europe/Copenhagen",
        name: "Copenhagen"
      },
      {
        value: "Europe/Dublin",
        name: "Dublin"
      },
      {
        value: "Europe/Gibraltar",
        name: "Gibraltar"
      },
      {
        value: "Europe/Guernsey",
        name: "Guernsey"
      },
      {
        value: "Europe/Helsinki",
        name: "Helsinki"
      },
      {
        value: "Europe/Isle_of_Man",
        name: "Isle of Man"
      },
      {
        value: "Europe/Istanbul",
        name: "Istanbul"
      },
      {
        value: "Europe/Jersey",
        name: "Jersey"
      },
      {
        value: "Europe/Kaliningrad",
        name: "Kaliningrad"
      },
      {
        value: "Europe/Kiev",
        name: "Kiev"
      },
      {
        value: "Europe/Lisbon",
        name: "Lisbon"
      },
      {
        value: "Europe/Ljubljana",
        name: "Ljubljana"
      },
      {
        value: "Europe/London",
        name: "London"
      },
      {
        value: "Europe/Luxembourg",
        name: "Luxembourg"
      },
      {
        value: "Europe/Madrid",
        name: "Madrid"
      },
      {
        value: "Europe/Malta",
        name: "Malta"
      },
      {
        value: "Europe/Mariehamn",
        name: "Mariehamn"
      },
      {
        value: "Europe/Minsk",
        name: "Minsk"
      },
      {
        value: "Europe/Monaco",
        name: "Monaco"
      },
      {
        value: "Europe/Moscow",
        name: "Moscow"
      },
      {
        value: "Europe/Nicosia",
        name: "Nicosia"
      },
      {
        value: "Europe/Oslo",
        name: "Oslo"
      },
      {
        value: "Europe/Paris",
        name: "Paris"
      },
      {
        value: "Europe/Podgorica",
        name: "Podgorica"
      },
      {
        value: "Europe/Prague",
        name: "Prague"
      },
      {
        value: "Europe/Riga",
        name: "Riga"
      },
      {
        value: "Europe/Rome",
        name: "Rome"
      },
      {
        value: "Europe/Samara",
        name: "Samara"
      },
      {
        value: "Europe/San_Marino",
        name: "San Marino"
      },
      {
        value: "Europe/Sarajevo",
        name: "Sarajevo"
      },
      {
        value: "Europe/Simferopol",
        name: "Simferopol"
      },
      {
        value: "Europe/Skopje",
        name: "Skopje"
      },
      {
        value: "Europe/Sofia",
        name: "Sofia"
      },
      {
        value: "Europe/Stockholm",
        name: "Stockholm"
      },
      {
        value: "Europe/Tallinn",
        name: "Tallinn"
      },
      {
        value: "Europe/Tirane",
        name: "Tirane"
      },
      {
        value: "Europe/Tiraspol",
        name: "Tiraspol"
      },
      {
        value: "Europe/Uzhgorod",
        name: "Uzhgorod"
      },
      {
        value: "Europe/Vaduz",
        name: "Vaduz"
      },
      {
        value: "Europe/Vatican",
        name: "Vatican"
      },
      {
        value: "Europe/Vienna",
        name: "Vienna"
      },
      {
        value: "Europe/Vilnius",
        name: "Vilnius"
      },
      {
        value: "Europe/Volgograd",
        name: "Volgograd"
      },
      {
        value: "Europe/Warsaw",
        name: "Warsaw"
      },
      {
        value: "Europe/Zagreb",
        name: "Zagreb"
      },
      {
        value: "Europe/Zaporozhye",
        name: "Zaporozhye"
      },
      {
        value: "Europe/Zurich",
        name: "Zurich"
      }
    ]
  },
  {
    group: "Asia",
    zones: [
      {
        value: "Asia/Aden",
        name: "Aden"
      },
      {
        value: "Asia/Almaty",
        name: "Almaty"
      },
      {
        value: "Asia/Amman",
        name: "Amman"
      },
      {
        value: "Asia/Anadyr",
        name: "Anadyr"
      },
      {
        value: "Asia/Aqtau",
        name: "Aqtau"
      },
      {
        value: "Asia/Aqtobe",
        name: "Aqtobe"
      },
      {
        value: "Asia/Ashgabat",
        name: "Ashgabat"
      },
      {
        value: "Asia/Ashkhabad",
        name: "Ashkhabad"
      },
      {
        value: "Asia/Baghdad",
        name: "Baghdad"
      },
      {
        value: "Asia/Bahrain",
        name: "Bahrain"
      },
      {
        value: "Asia/Baku",
        name: "Baku"
      },
      {
        value: "Asia/Bangkok",
        name: "Bangkok"
      },
      {
        value: "Asia/Beirut",
        name: "Beirut"
      },
      {
        value: "Asia/Bishkek",
        name: "Bishkek"
      },
      {
        value: "Asia/Brunei",
        name: "Brunei"
      },
      {
        value: "Asia/Calcutta",
        name: "Calcutta"
      },
      {
        value: "Asia/Choibalsan",
        name: "Choibalsan"
      },
      {
        value: "Asia/Chongqing",
        name: "Chongqing"
      },
      {
        value: "Asia/Chungking",
        name: "Chungking"
      },
      {
        value: "Asia/Colombo",
        name: "Colombo"
      },
      {
        value: "Asia/Dacca",
        name: "Dacca"
      },
      {
        value: "Asia/Damascus",
        name: "Damascus"
      },
      {
        value: "Asia/Dhaka",
        name: "Dhaka"
      },
      {
        value: "Asia/Dili",
        name: "Dili"
      },
      {
        value: "Asia/Dubai",
        name: "Dubai"
      },
      {
        value: "Asia/Dushanbe",
        name: "Dushanbe"
      },
      {
        value: "Asia/Gaza",
        name: "Gaza"
      },
      {
        value: "Asia/Harbin",
        name: "Harbin"
      },
      {
        value: "Asia/Ho_Chi_Minh",
        name: "Ho Chi Minh"
      },
      {
        value: "Asia/Hong_Kong",
        name: "Hong Kong"
      },
      {
        value: "Asia/Hovd",
        name: "Hovd"
      },
      {
        value: "Asia/Irkutsk",
        name: "Irkutsk"
      },
      {
        value: "Asia/Istanbul",
        name: "Istanbul"
      },
      {
        value: "Asia/Jakarta",
        name: "Jakarta"
      },
      {
        value: "Asia/Jayapura",
        name: "Jayapura"
      },
      {
        value: "Asia/Jerusalem",
        name: "Jerusalem"
      },
      {
        value: "Asia/Kabul",
        name: "Kabul"
      },
      {
        value: "Asia/Kamchatka",
        name: "Kamchatka"
      },
      {
        value: "Asia/Karachi",
        name: "Karachi"
      },
      {
        value: "Asia/Kashgar",
        name: "Kashgar"
      },
      {
        value: "Asia/Kathmandu",
        name: "Kathmandu"
      },
      {
        value: "Asia/Katmandu",
        name: "Katmandu"
      },
      {
        value: "Asia/Kolkata",
        name: "Kolkata"
      },
      {
        value: "Asia/Krasnoyarsk",
        name: "Krasnoyarsk"
      },
      {
        value: "Asia/Kuala_Lumpur",
        name: "Kuala Lumpur"
      },
      {
        value: "Asia/Kuching",
        name: "Kuching"
      },
      {
        value: "Asia/Kuwait",
        name: "Kuwait"
      },
      {
        value: "Asia/Macao",
        name: "Macao"
      },
      {
        value: "Asia/Macau",
        name: "Macau"
      },
      {
        value: "Asia/Magadan",
        name: "Magadan"
      },
      {
        value: "Asia/Makassar",
        name: "Makassar"
      },
      {
        value: "Asia/Manila",
        name: "Manila"
      },
      {
        value: "Asia/Muscat",
        name: "Muscat"
      },
      {
        value: "Asia/Nicosia",
        name: "Nicosia"
      },
      {
        value: "Asia/Novokuznetsk",
        name: "Novokuznetsk"
      },
      {
        value: "Asia/Novosibirsk",
        name: "Novosibirsk"
      },
      {
        value: "Asia/Omsk",
        name: "Omsk"
      },
      {
        value: "Asia/Oral",
        name: "Oral"
      },
      {
        value: "Asia/Phnom_Penh",
        name: "Phnom Penh"
      },
      {
        value: "Asia/Pontianak",
        name: "Pontianak"
      },
      {
        value: "Asia/Pyongyang",
        name: "Pyongyang"
      },
      {
        value: "Asia/Qatar",
        name: "Qatar"
      },
      {
        value: "Asia/Qyzylorda",
        name: "Qyzylorda"
      },
      {
        value: "Asia/Rangoon",
        name: "Rangoon"
      },
      {
        value: "Asia/Riyadh",
        name: "Riyadh"
      },
      {
        value: "Asia/Saigon",
        name: "Saigon"
      },
      {
        value: "Asia/Sakhalin",
        name: "Sakhalin"
      },
      {
        value: "Asia/Samarkand",
        name: "Samarkand"
      },
      {
        value: "Asia/Seoul",
        name: "Seoul"
      },
      {
        value: "Asia/Shanghai",
        name: "Shanghai"
      },
      {
        value: "Asia/Singapore",
        name: "Singapore"
      },
      {
        value: "Asia/Taipei",
        name: "Taipei"
      },
      {
        value: "Asia/Tashkent",
        name: "Tashkent"
      },
      {
        value: "Asia/Tbilisi",
        name: "Tbilisi"
      },
      {
        value: "Asia/Tehran",
        name: "Tehran"
      },
      {
        value: "Asia/Tel_Aviv",
        name: "Tel Aviv"
      },
      {
        value: "Asia/Thimbu",
        name: "Thimbu"
      },
      {
        value: "Asia/Thimphu",
        name: "Thimphu"
      },
      {
        value: "Asia/Tokyo",
        name: "Tokyo"
      },
      {
        value: "Asia/Ujung_Pandang",
        name: "Ujung Pandang"
      },
      {
        value: "Asia/Ulaanbaatar",
        name: "Ulaanbaatar"
      },
      {
        value: "Asia/Ulan_Bator",
        name: "Ulan Bator"
      },
      {
        value: "Asia/Urumqi",
        name: "Urumqi"
      },
      {
        value: "Asia/Vientiane",
        name: "Vientiane"
      },
      {
        value: "Asia/Vladivostok",
        name: "Vladivostok"
      },
      {
        value: "Asia/Yakutsk",
        name: "Yakutsk"
      },
      {
        value: "Asia/Yekaterinburg",
        name: "Yekaterinburg"
      },
      {
        value: "Asia/Yerevan",
        name: "Yerevan"
      }
    ]
  },
  {
    group: "Africa",
    zones: [
      {
        value: "Africa/Abidjan",
        name: "Abidjan"
      },
      {
        value: "Africa/Accra",
        name: "Accra"
      },
      {
        value: "Africa/Addis_Ababa",
        name: "Addis Ababa"
      },
      {
        value: "Africa/Algiers",
        name: "Algiers"
      },
      {
        value: "Africa/Asmara",
        name: "Asmara"
      },
      {
        value: "Africa/Asmera",
        name: "Asmera"
      },
      {
        value: "Africa/Bamako",
        name: "Bamako"
      },
      {
        value: "Africa/Bangui",
        name: "Bangui"
      },
      {
        value: "Africa/Banjul",
        name: "Banjul"
      },
      {
        value: "Africa/Bissau",
        name: "Bissau"
      },
      {
        value: "Africa/Blantyre",
        name: "Blantyre"
      },
      {
        value: "Africa/Brazzaville",
        name: "Brazzaville"
      },
      {
        value: "Africa/Bujumbura",
        name: "Bujumbura"
      },
      {
        value: "Africa/Cairo",
        name: "Cairo"
      },
      {
        value: "Africa/Casablanca",
        name: "Casablanca"
      },
      {
        value: "Africa/Ceuta",
        name: "Ceuta"
      },
      {
        value: "Africa/Conakry",
        name: "Conakry"
      },
      {
        value: "Africa/Dakar",
        name: "Dakar"
      },
      {
        value: "Africa/Dar_es_Salaam",
        name: "Dar es Salaam"
      },
      {
        value: "Africa/Djibouti",
        name: "Djibouti"
      },
      {
        value: "Africa/Douala",
        name: "Douala"
      },
      {
        value: "Africa/El_Aaiun",
        name: "El Aaiun"
      },
      {
        value: "Africa/Freetown",
        name: "Freetown"
      },
      {
        value: "Africa/Gaborone",
        name: "Gaborone"
      },
      {
        value: "Africa/Harare",
        name: "Harare"
      },
      {
        value: "Africa/Johannesburg",
        name: "Johannesburg"
      },
      {
        value: "Africa/Kampala",
        name: "Kampala"
      },
      {
        value: "Africa/Khartoum",
        name: "Khartoum"
      },
      {
        value: "Africa/Kigali",
        name: "Kigali"
      },
      {
        value: "Africa/Kinshasa",
        name: "Kinshasa"
      },
      {
        value: "Africa/Lagos",
        name: "Lagos"
      },
      {
        value: "Africa/Libreville",
        name: "Libreville"
      },
      {
        value: "Africa/Lome",
        name: "Lome"
      },
      {
        value: "Africa/Luanda",
        name: "Luanda"
      },
      {
        value: "Africa/Lubumbashi",
        name: "Lubumbashi"
      },
      {
        value: "Africa/Lusaka",
        name: "Lusaka"
      },
      {
        value: "Africa/Malabo",
        name: "Malabo"
      },
      {
        value: "Africa/Maputo",
        name: "Maputo"
      },
      {
        value: "Africa/Maseru",
        name: "Maseru"
      },
      {
        value: "Africa/Mbabane",
        name: "Mbabane"
      },
      {
        value: "Africa/Mogadishu",
        name: "Mogadishu"
      },
      {
        value: "Africa/Monrovia",
        name: "Monrovia"
      },
      {
        value: "Africa/Nairobi",
        name: "Nairobi"
      },
      {
        value: "Africa/Ndjamena",
        name: "Ndjamena"
      },
      {
        value: "Africa/Niamey",
        name: "Niamey"
      },
      {
        value: "Africa/Nouakchott",
        name: "Nouakchott"
      },
      {
        value: "Africa/Ouagadougou",
        name: "Ouagadougou"
      },
      {
        value: "Africa/Porto-Novo",
        name: "Porto-Novo"
      },
      {
        value: "Africa/Sao_Tome",
        name: "Sao Tome"
      },
      {
        value: "Africa/Timbuktu",
        name: "Timbuktu"
      },
      {
        value: "Africa/Tripoli",
        name: "Tripoli"
      },
      {
        value: "Africa/Tunis",
        name: "Tunis"
      },
      {
        value: "Africa/Windhoek",
        name: "Windhoek"
      }
    ]
  },
  {
    group: "Australia",
    zones: [
      {
        value: "Australia/ACT",
        name: "ACT"
      },
      {
        value: "Australia/Adelaide",
        name: "Adelaide"
      },
      {
        value: "Australia/Brisbane",
        name: "Brisbane"
      },
      {
        value: "Australia/Broken_Hill",
        name: "Broken Hill"
      },
      {
        value: "Australia/Canberra",
        name: "Canberra"
      },
      {
        value: "Australia/Currie",
        name: "Currie"
      },
      {
        value: "Australia/Darwin",
        name: "Darwin"
      },
      {
        value: "Australia/Eucla",
        name: "Eucla"
      },
      {
        value: "Australia/Hobart",
        name: "Hobart"
      },
      {
        value: "Australia/LHI",
        name: "LHI"
      },
      {
        value: "Australia/Lindeman",
        name: "Lindeman"
      },
      {
        value: "Australia/Lord_Howe",
        name: "Lord Howe"
      },
      {
        value: "Australia/Melbourne",
        name: "Melbourne"
      },
      {
        value: "Australia/North",
        name: "North"
      },
      {
        value: "Australia/NSW",
        name: "NSW"
      },
      {
        value: "Australia/Perth",
        name: "Perth"
      },
      {
        value: "Australia/Queensland",
        name: "Queensland"
      },
      {
        value: "Australia/South",
        name: "South"
      },
      {
        value: "Australia/Sydney",
        name: "Sydney"
      },
      {
        value: "Australia/Tasmania",
        name: "Tasmania"
      },
      {
        value: "Australia/Victoria",
        name: "Victoria"
      },
      {
        value: "Australia/West",
        name: "West"
      },
      {
        value: "Australia/Yancowinna",
        name: "Yancowinna"
      }
    ]
  },
  {
    group: "Indian",
    zones: [
      {
        value: "Indian/Antananarivo",
        name: "Antananarivo"
      },
      {
        value: "Indian/Chagos",
        name: "Chagos"
      },
      {
        value: "Indian/Christmas",
        name: "Christmas"
      },
      {
        value: "Indian/Cocos",
        name: "Cocos"
      },
      {
        value: "Indian/Comoro",
        name: "Comoro"
      },
      {
        value: "Indian/Kerguelen",
        name: "Kerguelen"
      },
      {
        value: "Indian/Mahe",
        name: "Mahe"
      },
      {
        value: "Indian/Maldives",
        name: "Maldives"
      },
      {
        value: "Indian/Mauritius",
        name: "Mauritius"
      },
      {
        value: "Indian/Mayotte",
        name: "Mayotte"
      },
      {
        value: "Indian/Reunion",
        name: "Reunion"
      }
    ]
  },
  {
    group: "Atlantic",
    zones: [
      {
        value: "Atlantic/Azores",
        name: "Azores"
      },
      {
        value: "Atlantic/Bermuda",
        name: "Bermuda"
      },
      {
        value: "Atlantic/Canary",
        name: "Canary"
      },
      {
        value: "Atlantic/Cape_Verde",
        name: "Cape Verde"
      },
      {
        value: "Atlantic/Faeroe",
        name: "Faeroe"
      },
      {
        value: "Atlantic/Faroe",
        name: "Faroe"
      },
      {
        value: "Atlantic/Jan_Mayen",
        name: "Jan Mayen"
      },
      {
        value: "Atlantic/Madeira",
        name: "Madeira"
      },
      {
        value: "Atlantic/Reykjavik",
        name: "Reykjavik"
      },
      {
        value: "Atlantic/South_Georgia",
        name: "South Georgia"
      },
      {
        value: "Atlantic/Stanley",
        name: "Stanley"
      },
      {
        value: "Atlantic/St_Helena",
        name: "St Helena"
      }
    ]
  },
  {
    group: "Pacific",
    zones: [
      {
        value: "Pacific/Apia",
        name: "Apia"
      },
      {
        value: "Pacific/Auckland",
        name: "Auckland"
      },
      {
        value: "Pacific/Chatham",
        name: "Chatham"
      },
      {
        value: "Pacific/Easter",
        name: "Easter"
      },
      {
        value: "Pacific/Efate",
        name: "Efate"
      },
      {
        value: "Pacific/Enderbury",
        name: "Enderbury"
      },
      {
        value: "Pacific/Fakaofo",
        name: "Fakaofo"
      },
      {
        value: "Pacific/Fiji",
        name: "Fiji"
      },
      {
        value: "Pacific/Funafuti",
        name: "Funafuti"
      },
      {
        value: "Pacific/Galapagos",
        name: "Galapagos"
      },
      {
        value: "Pacific/Gambier",
        name: "Gambier"
      },
      {
        value: "Pacific/Guadalcanal",
        name: "Guadalcanal"
      },
      {
        value: "Pacific/Guam",
        name: "Guam"
      },
      {
        value: "Pacific/Honolulu",
        name: "Honolulu"
      },
      {
        value: "Pacific/Johnston",
        name: "Johnston"
      },
      {
        value: "Pacific/Kiritimati",
        name: "Kiritimati"
      },
      {
        value: "Pacific/Kosrae",
        name: "Kosrae"
      },
      {
        value: "Pacific/Kwajalein",
        name: "Kwajalein"
      },
      {
        value: "Pacific/Majuro",
        name: "Majuro"
      },
      {
        value: "Pacific/Marquesas",
        name: "Marquesas"
      },
      {
        value: "Pacific/Midway",
        name: "Midway"
      },
      {
        value: "Pacific/Nauru",
        name: "Nauru"
      },
      {
        value: "Pacific/Niue",
        name: "Niue"
      },
      {
        value: "Pacific/Norfolk",
        name: "Norfolk"
      },
      {
        value: "Pacific/Noumea",
        name: "Noumea"
      },
      {
        value: "Pacific/Pago_Pago",
        name: "Pago Pago"
      },
      {
        value: "Pacific/Palau",
        name: "Palau"
      },
      {
        value: "Pacific/Pitcairn",
        name: "Pitcairn"
      },
      {
        value: "Pacific/Ponape",
        name: "Ponape"
      },
      {
        value: "Pacific/Port_Moresby",
        name: "Port Moresby"
      },
      {
        value: "Pacific/Rarotonga",
        name: "Rarotonga"
      },
      {
        value: "Pacific/Saipan",
        name: "Saipan"
      },
      {
        value: "Pacific/Samoa",
        name: "Samoa"
      },
      {
        value: "Pacific/Tahiti",
        name: "Tahiti"
      },
      {
        value: "Pacific/Tarawa",
        name: "Tarawa"
      },
      {
        value: "Pacific/Tongatapu",
        name: "Tongatapu"
      },
      {
        value: "Pacific/Truk",
        name: "Truk"
      },
      {
        value: "Pacific/Wake",
        name: "Wake"
      },
      {
        value: "Pacific/Wallis",
        name: "Wallis"
      },
      {
        value: "Pacific/Yap",
        name: "Yap"
      }
    ]
  },
  {
    group: "Antarctica",
    zones: [
      {
        value: "Antarctica/Casey",
        name: "Casey"
      },
      {
        value: "Antarctica/Davis",
        name: "Davis"
      },
      {
        value: "Antarctica/DumontDUrville",
        name: "DumontDUrville"
      },
      {
        value: "Antarctica/Macquarie",
        name: "Macquarie"
      },
      {
        value: "Antarctica/Mawson",
        name: "Mawson"
      },
      {
        value: "Antarctica/McMurdo",
        name: "McMurdo"
      },
      {
        value: "Antarctica/Palmer",
        name: "Palmer"
      },
      {
        value: "Antarctica/Rothera",
        name: "Rothera"
      },
      {
        value: "Antarctica/South_Pole",
        name: "South Pole"
      },
      {
        value: "Antarctica/Syowa",
        name: "Syowa"
      },
      {
        value: "Antarctica/Vostok",
        name: "Vostok"
      }
    ]
  },
  {
    group: "Arctic",
    zones: [
      {
        value: "Arctic/Longyearbyen",
        name: "Longyearbyen"
      }
    ]
  },
  {
    group: "UTC",
    zones: [
      {
        value: "UTC",
        name: "UTC"
      }
    ]
  },
  {
    group: "Manual Offsets",
    zones: [
      {
        value: "UTC-12",
        name: "UTC-12"
      },
      {
        value: "UTC-11",
        name: "UTC-11"
      },
      {
        value: "UTC-10",
        name: "UTC-10"
      },
      {
        value: "UTC-9",
        name: "UTC-9"
      },
      {
        value: "UTC-8",
        name: "UTC-8"
      },
      {
        value: "UTC-7",
        name: "UTC-7"
      },
      {
        value: "UTC-6",
        name: "UTC-6"
      },
      {
        value: "UTC-5",
        name: "UTC-5"
      },
      {
        value: "UTC-4",
        name: "UTC-4"
      },
      {
        value: "UTC-3",
        name: "UTC-3"
      },
      {
        value: "UTC-2",
        name: "UTC-2"
      },
      {
        value: "UTC-1",
        name: "UTC-1"
      },
      {
        value: "UTC+0",
        name: "UTC+0"
      },
      {
        value: "UTC+1",
        name: "UTC+1"
      },
      {
        value: "UTC+2",
        name: "UTC+2"
      },
      {
        value: "UTC+3",
        name: "UTC+3"
      },
      {
        value: "UTC+4",
        name: "UTC+4"
      },
      {
        value: "UTC+5",
        name: "UTC+5"
      },
      {
        value: "UTC+6",
        name: "UTC+6"
      },
      {
        value: "UTC+7",
        name: "UTC+7"
      },
      {
        value: "UTC+8",
        name: "UTC+8"
      },
      {
        value: "UTC+9",
        name: "UTC+9"
      },
      {
        value: "UTC+10",
        name: "UTC+10"
      },
      {
        value: "UTC+11",
        name: "UTC+11"
      },
      {
        value: "UTC+12",
        name: "UTC+12"
      },
      {
        value: "UTC+13",
        name: "UTC+13"
      },
      {
        value: "UTC+14",
        name: "UTC+14"
      }
    ]
  }
], Q7 = () => X7.flatMap((e) => e.zones.map((t) => t.value));
Q7();
const Z7 = () => (e) => (t) => !!t && (Array.isArray(e) ? e.includes(t) : e === t), k5 = () => (e) => (t) => Array.isArray(e) ? e.includes(t.type) : t.type === e, Tt = k5(), J7 = (e) => E3(e, "_v") && e._v === 1, e_ = Tt(te.IF), t_ = Tt(te.URL), n_ = Tt(te.SET), r_ = Tt(te.TEXT), a_ = Tt(te.GOTO), i_ = Tt(te.CARD), o_ = Tt(te.IF_V2), s_ = Tt(te.FLOW), u_ = Tt(te.CODE), l_ = Tt(te.EXIT), c_ = Tt(te.SPEAK), f_ = Tt(te.START), h_ = Tt(te.SET_V2), d_ = Tt(te.VISUAL), m_ = Tt(te.STREAM), p_ = Tt(te.RANDOM), g_ = Tt(te.CARD_V2), E_ = Tt(te.CAPTURE), T_ = Tt(te.GENERAL), v_ = Tt(te.CAROUSEL), A_ = Tt(te.RANDOM_V2), C_ = Tt(te.GOTO_NODE), __ = Tt(te.DIRECTIVE), b_ = Tt(te.CAPTURE_V2), y_ = Tt(te.INTERACTION), D_ = Tt(te.INTEGRATIONS), S_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createNodeTypeguard: Tt,
  isV1: J7,
  isIf: e_,
  isUrl: t_,
  isSet: n_,
  isText: r_,
  isGoTo: a_,
  isCard: i_,
  isIfV2: o_,
  isFlow: s_,
  isCode: u_,
  isExit: l_,
  isSpeak: c_,
  isStart: f_,
  isSetV2: h_,
  isVisual: d_,
  isStream: m_,
  isRandom: p_,
  isCardV2: g_,
  isCapture: E_,
  isGeneral: T_,
  isCarousel: v_,
  isRandomV2: A_,
  isGoToNode: C_,
  isDirective: __,
  isCaptureV2: b_,
  isInteraction: y_,
  isIntegrations: D_
}, Symbol.toStringTag, { value: "Module" })), et = Z7(), O_ = et(te.IF), N_ = et(te.URL), w_ = et(te.SET), I_ = et(te.API), R_ = et(te.GOTO), M_ = et(te.TEXT), x_ = et(te.CARD), k_ = et(te.IF_V2), P_ = et(te.FLOW), B_ = et(te.CODE), F_ = et(te.EXIT), L_ = et(te.SPEAK), $_ = et(te.START), H_ = et(te.SET_V2), U_ = et(te.CAROUSEL), j_ = et(te.PROMPT), z_ = et(te.VISUAL), G_ = et(te.INTENT), V_ = et(te.STREAM), Y_ = et(te.ZAPIER), K_ = et(te.RANDOM), W_ = et(te.RANDOM_V2), q_ = et(te.COMMAND), X_ = et(te.BUTTONS), Q_ = et(te.CAPTURE), Z_ = et(te.GENERAL), J_ = et(te.GOTO_NODE), eb = et(te.DIRECTIVE), tb = et(te.COMPONENT), nb = et(te.CAPTURE_V2), rb = et(te.GOTO_DOMAIN), ab = et(te.DEPRECATED), ib = et(te.INTERACTION), ob = et(te.INTEGRATIONS), sb = et(te.GOOGLE_SHEETS), ub = et(c5), lb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createNodeTypeTypeguard: et,
  isIf: O_,
  isUrl: N_,
  isSet: w_,
  isApi: I_,
  isGoTo: R_,
  isText: M_,
  isCard: x_,
  isIfV2: k_,
  isFlow: P_,
  isCode: B_,
  isExit: F_,
  isSpeak: L_,
  isStart: $_,
  isSetV2: H_,
  isCarousel: U_,
  isPrompt: j_,
  isVisual: z_,
  isIntent: G_,
  isStream: V_,
  isZapier: Y_,
  isRandom: K_,
  isRandomV2: W_,
  isCommand: q_,
  isButtons: X_,
  isCapture: Q_,
  isGeneral: Z_,
  isGoToNode: J_,
  isDirective: eb,
  isComponent: tb,
  isCaptureV2: nb,
  isGoToDomain: rb,
  isDeprecated: ab,
  isInteraction: ib,
  isIntegrations: ob,
  isGoogleSheets: sb,
  isRuntimeOnly: ub
}, Symbol.toStringTag, { value: "Module" })), Ve = k5(), cb = Ve(te.IF), fb = Ve(te.URL), hb = Ve(te.SET), db = Ve(te.API), mb = Ve(te.TEXT), pb = Ve(te.CARD), gb = Ve(te.CARD_V2), Eb = Ve(te.IF_V2), Tb = Ve(te.FLOW), vb = Ve(te.GOTO), Ab = Ve(te.CODE), Cb = Ve(te.EXIT), _b = Ve(te.SPEAK), bb = Ve(te.START), yb = Ve(te.SET_V2), Db = Ve(te.PROMPT), Sb = Ve(te.CAROUSEL), Ob = Ve(te.VISUAL), Nb = Ve(te.INTENT), wb = Ve(te.STREAM), Ib = Ve(te.ZAPIER), Rb = Ve(te.RANDOM), Mb = Ve(te.RANDOM_V2), xb = Ve(te.COMMAND), kb = Ve(te.BUTTONS), Pb = Ve(te.CAPTURE), Bb = Ve(te.GENERAL), Fb = Ve(te.GOTO_NODE), Lb = Ve(te.DIRECTIVE), $b = Ve(te.COMPONENT), Hb = Ve(te.CAPTURE_V2), Ub = Ve(te.GOTO_DOMAIN), jb = Ve(te.DEPRECATED), zb = Ve(te.INTERACTION), Gb = Ve(te.GOOGLE_SHEETS), Vb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createStepTypeguard: Ve,
  isIf: cb,
  isUrl: fb,
  isSet: hb,
  isApi: db,
  isText: mb,
  isCard: pb,
  isCardV2: gb,
  isIfV2: Eb,
  isFlow: Tb,
  isGoTo: vb,
  isCode: Ab,
  isExit: Cb,
  isSpeak: _b,
  isStart: bb,
  isSetV2: yb,
  isPrompt: Db,
  isCarousel: Sb,
  isVisual: Ob,
  isIntent: Nb,
  isStream: wb,
  isZapier: Ib,
  isRandom: Rb,
  isRandomV2: Mb,
  isCommand: xb,
  isButtons: kb,
  isCapture: Pb,
  isGeneral: Bb,
  isGoToNode: Fb,
  isDirective: Lb,
  isComponent: $b,
  isCaptureV2: Hb,
  isGoToDomain: Ub,
  isDeprecated: jb,
  isInteraction: zb,
  isGoogleSheets: Gb
}, Symbol.toStringTag, { value: "Module" })), Ch = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ai: s3,
  node: S_,
  nodeType: lb,
  step: Vb
}, Symbol.toStringTag, { value: "Module" }));
var Eo;
(function(e) {
  e.OFF = "OFF", e.ALL = "ALL", e.DIALOG = "DIALOG";
})(Eo || (Eo = {}));
var To;
(function(e) {
  e.RESUME = "resume", e.RESTART = "restart";
})(To || (To = {}));
var vo;
(function(e) {
  e.STATIC = "static", e.GENERATIVE = "generative";
})(vo || (vo = {}));
const Oc = ({ error: e = null, repeat: t = Eo.ALL, session: n = { type: To.RESTART }, defaultCanvasNodeVisibility: r = null, defaultCarouselLayout: a = null, globalNoMatch: i = { type: vo.STATIC, prompt: void 0 }, globalNoReply: o = { delay: void 0, prompt: void 0 } } = {}) => ({
  error: e,
  repeat: t,
  session: n,
  defaultCanvasNodeVisibility: r,
  defaultCarouselLayout: a,
  globalNoMatch: i,
  globalNoReply: o
});
var Kl;
(function(e) {
  e.PRODUCTION = "production", e.DEVELOPMENT = "development";
})(Kl || (Kl = {}));
const P5 = ({ slots: e = [], intents: t = [], settings: n = {}, publishing: r = {} }) => ({
  slots: e,
  intents: t,
  settings: Oc(n),
  publishing: r
}), qs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  defaultPlatformData: P5,
  get RepeatType() {
    return Eo;
  },
  get SessionType() {
    return To;
  },
  get GlobalNoMatchType() {
    return vo;
  },
  defaultSettings: Oc,
  get VersionTag() {
    return Kl;
  }
}, Symbol.toStringTag, { value: "Module" })), Yb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: G0,
  BaseButton: G0,
  Models: V0,
  BaseModels: V0,
  Node: Y0,
  BaseNode: Y0,
  Project: K0,
  BaseProject: K0,
  Request: W0,
  BaseRequest: W0,
  RuntimeLogs: r3,
  Text: X0,
  BaseText: X0,
  Trace: Q0,
  BaseTrace: Q0,
  Utils: Ch,
  BaseUtils: Ch,
  Version: qs,
  BaseVersion: qs,
  VariableState: qs
}, Symbol.toStringTag, { value: "Module" })), Kb = (e = {}) => Object.assign({}, f5(e)), Wb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  defaultPlatformData: Kb
}, Symbol.toStringTag, { value: "Module" })), qb = Tt(te.CAPTURE), Xb = Tt(te.CAPTURE_V2), Qb = Tt(te.INTERACTION), Zb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isCapture: qb,
  isCaptureV2: Xb,
  isInteraction: Qb
}, Symbol.toStringTag, { value: "Module" })), B5 = (e) => e != null && e.content ? {
  id: e.id,
  content: e.content
} : null, Jb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  defaultPrompt: B5
}, Symbol.toStringTag, { value: "Module" })), ey = Ve(te.PROMPT), ty = Ve(te.BUTTONS), ny = Ve(te.CAPTURE), ry = Ve(te.CAPTURE_V2), ay = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isPrompt: ey,
  isButtons: ty,
  isCapture: ny,
  isCaptureV2: ry
}, Symbol.toStringTag, { value: "Module" })), iy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  node: Zb,
  prompt: Jb,
  step: ay
}, Symbol.toStringTag, { value: "Module" }));
var oy = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const F5 = ({ durationMilliseconds: e = 1e3 } = {}) => ({
  durationMilliseconds: e
}), L5 = (e = {}) => {
  var { error: t, messageDelay: n } = e, r = oy(e, ["error", "messageDelay"]);
  return Object.assign(Object.assign({}, Oc(r)), { error: B5(t), messageDelay: F5(n) });
};
var sy = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
};
const uy = (e) => {
  var { intents: t = [], settings: n = {} } = e, r = sy(e, ["intents", "settings"]);
  return Object.assign(Object.assign({}, P5(r)), { intents: t, settings: L5(n) });
}, ly = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  defaultPlatformData: uy,
  defaultMessageDelay: F5,
  defaultSettings: L5
}, Symbol.toStringTag, { value: "Module" })), cy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ChatModels: Nv,
  ChatNode: Fv,
  ChatProject: Wb,
  ChatUtils: iy,
  ChatVersion: ly
}, Symbol.toStringTag, { value: "Module" })), $5 = /* @__PURE__ */ _c(cy);
var Wl = {}, Uo = {}, H5 = {}, jo = {};
Object.defineProperty(jo, "__esModule", { value: !0 });
jo.AZURE_LOCALE_VOICE_META = void 0;
jo.AZURE_LOCALE_VOICE_META = {
  "ar-EG": { language: "Arabic (Arabic )", locale: "ar-EG", voices: [{ gender: "Female", voiceID: "ar-EG-SalmaNeural" }] },
  "ar-SA": { language: "Arabic (Saudi Arabia)", locale: "ar-SA", voices: [{ gender: "Male", voiceID: "ar-SA-HamedNeural" }] },
  "bg-BG": { language: "Bulgarian (Bulgaria)", locale: "bg-BG", voices: [{ gender: "Male", voiceID: "bg-BG-KalinaNeural" }] },
  "ca-ES": { language: "Catalan (Spain)", locale: "ca-ES", voices: [{ gender: "Female", voiceID: "ca-ES-AlbaNeural" }] },
  "zh-HK": {
    language: "Chinese (Cantonese, Traditional)",
    locale: "zh-HK",
    voices: [
      { gender: "Male", voiceID: "zh-HK-WanLungNeural" },
      { gender: "Female", voiceID: "zh-HK-HiuGaaiNeural" }
    ]
  },
  "zh-CN": {
    language: "Chinese (Mandarin, Simplified)",
    locale: "zh-CN",
    voices: [
      { gender: "Female", voiceID: "zh-CN-XiaochenNeural" },
      { gender: "Male", voiceID: "zh-CN-YunxiNeural" },
      { gender: "Female", voiceID: "zh-CN-XiaohanNeural" }
    ]
  },
  "zh-TW": {
    language: "Chinese (Taiwanese Mandarin)",
    locale: "zh-TW",
    voices: [
      { gender: "Female", voiceID: "zh-TW-HsiaoChenNeural" },
      { gender: "Female", voiceID: "zh-TW-HsiaoYuNeural" },
      { gender: "Male", voiceID: "zh-TW-YunJheNeural" }
    ]
  },
  "hr-HR": { language: "Croatian (Croatia)", locale: "hr-HR", voices: [{ gender: "Male", voiceID: "hr-HR-SreckoNeural" }] },
  "cs-CZ": { language: "Czech (Czech Republic)", locale: "cs-CZ", voices: [{ gender: "Male", voiceID: "cs-CZ-AntoninNeural" }] },
  "da-DK": { language: "Danish (Denmark)", locale: "da-DK", voices: [{ gender: "Female", voiceID: "da-DK-ChristelNeural" }] },
  "nl-NL": { language: "Dutch (Netherlands)", locale: "nl-NL", voices: [{ gender: "Female", voiceID: "nl-NL-ColetteNeural" }] },
  "en-AU": {
    language: "English (Australia)",
    locale: "en-AU",
    voices: [
      { gender: "Female", voiceID: "en-AU-NatashaNeural" },
      { gender: "Male", voiceID: "en-AU-WilliamNeural" }
    ]
  },
  "en-CA": {
    language: "English (Canada)",
    locale: "en-CA",
    voices: [
      { gender: "Female", voiceID: "en-CA-ClaraNeural" },
      { gender: "Male", voiceID: "en-CA-LiamNeural" }
    ]
  },
  "en-IN": {
    language: "English (India)",
    locale: "en-IN",
    voices: [
      { gender: "Female", voiceID: "en-IN-NeerjaNeural" },
      { gender: "Male", voiceID: "en-IN-PrabhatNeural" }
    ]
  },
  "en-IE": { language: "English (Ireland)", locale: "en-IE", voices: [{ gender: "Male", voiceID: "en-IE-ConnorNeural" }] },
  "en-GB": {
    language: "English (United Kingdom)",
    locale: "en-GB",
    voices: [
      { gender: "Male", voiceID: "en-GB-RyanNeural" },
      { gender: "Female", voiceID: "en-GB-LibbyNeural" },
      { gender: "Female", voiceID: "en-GB-SoniaNeural" }
    ]
  },
  "en-US": {
    language: "English (United States)",
    locale: "en-US",
    voices: [
      { gender: "Male", voiceID: "en-US-SaraNeural" },
      { gender: "Male", voiceID: "en-US-ElizabethNeural" },
      { gender: "Female", voiceID: "en-US-BrandonNeural" },
      { gender: "Female", voiceID: "en-US-ChristopherNeural" }
    ]
  },
  "fi-FI": { language: "Finnish (Finland)", locale: "fi-FI", voices: [{ gender: "Female", voiceID: "fi-FI-NooraNeural" }] },
  "fr-CA": {
    language: "French (Canada)",
    locale: "fr-CA",
    voices: [
      { gender: "Female", voiceID: "fr-CA-SylvieNeural" },
      { gender: "Male", voiceID: "fr-CA-AntoineNeural" }
    ]
  },
  "fr-FR": {
    language: "French (France)",
    locale: "fr-FR",
    voices: [
      { gender: "Female", voiceID: "fr-FR-DeniseNeural" },
      { gender: "Male", voiceID: "fr-FR-HenriNeural" }
    ]
  },
  "fr-CH": { language: "French (Switzerland)", locale: "fr-CH", voices: [{ gender: "Male", voiceID: "fr-CH-FabriceNeural" }] },
  "de-AT": { language: "German (Austria)", locale: "de-AT", voices: [{ gender: "Male", voiceID: "de-AT-JonasNeural" }] },
  "de-DE": {
    language: "German (Germany)",
    locale: "de-DE",
    voices: [
      { gender: "Female", voiceID: "de-DE-KatjaNeural" },
      { gender: "Male", voiceID: "de-DE-ConradNeural" }
    ]
  },
  "de-CH": { language: "German (Switzerland)", locale: "de-CH", voices: [{ gender: "Male", voiceID: "de-CH-JanNeural" }] },
  "el-GR": { language: "Greek (Greece)", locale: "el-GR", voices: [{ gender: "Male", voiceID: "el-GR-NestorasNeural" }] },
  "he-IL": { language: "Hebrew (Israel)", locale: "he-IL", voices: [{ gender: "Male", voiceID: "he-IL-AvriNeural" }] },
  "hi-IN": {
    language: "Hindi (India)",
    locale: "hi-IN",
    voices: [
      { gender: "Male", voiceID: "hi-IN-MadhurNeural" },
      { gender: "Female", voiceID: "hi-IN-SwaraNeural" }
    ]
  },
  "hu-HU": { language: "Hungarian (Hungary)", locale: "hu-HU", voices: [{ gender: "Male", voiceID: "hu-HU-TamasNeural" }] },
  "id-ID": { language: "Indonesian (Indonesia)", locale: "id-ID", voices: [{ gender: "Male", voiceID: "id-ID-ArdiNeural" }] },
  "it-IT": {
    language: "Italian (Italy)",
    locale: "it-IT",
    voices: [
      { gender: "Male", voiceID: "it-IT-DiegoNeural" },
      { gender: "Female", voiceID: "it-IT-ElsaNeural" }
    ]
  },
  "ja-JP": {
    language: "Japanese (Japan)",
    locale: "ja-JP",
    voices: [
      { gender: "Female", voiceID: "ja-JP-NanamiNeural" },
      { gender: "Male", voiceID: "ja-JP-KeitaNeural" }
    ]
  },
  "ko-KR": { language: "Korean (Korea)", locale: "ko-KR", voices: [{ gender: "Female", voiceID: "ko-KR-SunHiNeural" }] },
  "ms-MY": { language: "Malay (Malaysia)", locale: "ms-MY", voices: [{ gender: "Male", voiceID: "ms-MY-OsmanNeural" }] },
  "nb-NO": { language: "Norwegian (Bokm\xE5l, Norway)", locale: "nb-NO", voices: [{ gender: "Female", voiceID: "nb-NO-IselinNeural" }] },
  "pl-PL": { language: "Polish (Poland)", locale: "pl-PL", voices: [{ gender: "Female", voiceID: "pl-PL-AgnieszkaNeural" }] },
  "pt-BR": {
    language: "Portuguese (Brazil)",
    locale: "pt-BR",
    voices: [
      { gender: "Male", voiceID: "pt-BR-AntonioNeural" },
      { gender: "Female", voiceID: "pt-BR-FranciscaNeural" }
    ]
  },
  "pt-PT": { language: "Portuguese (Portugal)", locale: "pt-PT", voices: [{ gender: "Female", voiceID: "pt-PT-FernandaNeural" }] },
  "ro-RO": { language: "Romanian (Romania)", locale: "ro-RO", voices: [{ gender: "Male", voiceID: "ro-RO-EmilNeural" }] },
  "ru-RU": {
    language: "Russian (Russia)",
    locale: "ru-RU",
    voices: [
      { gender: "Female", voiceID: "ru-RU-DariyaNeural" },
      { gender: "Female", voiceID: "ru-RU-SvetlanaNeural" },
      { gender: "Male", voiceID: "ru-RU-DmitryNeural" }
    ]
  },
  "sk-SK": { language: "Slovak (Slovakia)", locale: "sk-SK", voices: [{ gender: "Male", voiceID: "sk-SK-ViktoriaNeural" }] },
  "sl-SI": { language: "Slovenian (Slovenia)", locale: "sl-SI", voices: [{ gender: "Male", voiceID: "sl-SI-RokNeural" }] },
  "es-MX": {
    language: "Spanish (Mexico)",
    locale: "es-MX",
    voices: [
      { gender: "Female", voiceID: "es-MX-DaliaNeural" },
      { gender: "Male", voiceID: "es-MX-JorgeNeural" }
    ]
  },
  "es-ES": {
    language: "Spanish (Spain)",
    locale: "es-ES",
    voices: [
      { gender: "Female", voiceID: "es-ES-ElviraNeural" },
      { gender: "Male", voiceID: "es-ES-AlvaroNeural" }
    ]
  },
  "sv-SE": { language: "Swedish (Sweden)", locale: "sv-SE", voices: [{ gender: "Female", voiceID: "sv-SE-HilleviNeural" }] },
  "ta-IN": { language: "Tamil (India)", locale: "ta-IN", voices: [{ gender: "Male", voiceID: "ta-IN-ValluvarNeural" }] },
  "te-IN": { language: "Telugu (India)", locale: "te-IN", voices: [{ gender: "Female", voiceID: "te-IN-ShrutiNeural" }] },
  "th-TH": { language: "Thai (Thailand)", locale: "th-TH", voices: [{ gender: "Male", voiceID: "th-TH-NiwatNeural" }] },
  "tr-TR": { language: "Turkish (Turkey)", locale: "tr-TR", voices: [{ gender: "Female", voiceID: "tr-TR-EmelNeural" }] },
  "vi-VN": { language: "Vietnamese (Vietnam)", locale: "vi-VN", voices: [{ gender: "Male", voiceID: "vi-VN-NamMinhNeural" }] }
};
var zo = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isVoiceflowLanguage = e.Language = e.Locale = e.Voice = void 0, function(a) {
    a.AUDIO = "audio", a.DEFAULT = "default";
  }(e.Voice || (e.Voice = {})), function(a) {
    a.EN_US = "en-US", a.AR_AR = "ar-AR", a.ZH_CN = "zh-CN", a.NL_NL = "nl-NL", a.FR_FR = "fr-FR", a.FR_CA = "fr-CA", a.DE_DE = "de-DE", a.GU_IN = "gu-IN", a.HI_IN = "hi-IN", a.IT_IT = "it-IT", a.JA_JP = "ja-JP", a.KO_KR = "ko-KR", a.MR_IN = "mr-IN", a.PT_BR = "pt-BR", a.ES_ES = "es-ES", a.ES_MX = "es-MX", a.TA_IN = "ta-IN", a.TE_IN = "te-IN", a.TR_TR = "tr-TR";
  }(e.Locale || (e.Locale = {}));
  var t;
  (function(a) {
    a.EN = "en", a.AR = "ar", a.ZH = "zh", a.NL = "nl", a.FR = "fr", a.DE = "de", a.GU = "gu", a.HI = "hi", a.IT = "it", a.JA = "ja", a.KO = "ko", a.MR = "mr", a.PT = "pt", a.ES = "es", a.TA = "ta", a.TE = "te", a.TR = "tr";
  })(t = e.Language || (e.Language = {}));
  const n = new Set(Object.values(t)), r = (a) => n.has(a);
  e.isVoiceflowLanguage = r;
})(zo);
var Go = {};
const fy = /* @__PURE__ */ _c(Yb);
Object.defineProperty(Go, "__esModule", { value: !0 });
Go.DEVICE_SIZE_MAP = void 0;
const On = fy;
Go.DEVICE_SIZE_MAP = {
  [On.BaseNode.Visual.DeviceType.MOBILE]: { width: 375, height: 812 },
  [On.BaseNode.Visual.DeviceType.TABLET]: { width: 1024, height: 1366 },
  [On.BaseNode.Visual.DeviceType.DESKTOP]: { width: 1440, height: 900 },
  [On.BaseNode.Visual.DeviceType.SMART_WATCH]: { width: 184, height: 224 },
  [On.BaseNode.Visual.DeviceType.TELEVISION]: { width: 1920, height: 1200 },
  [On.BaseNode.Visual.DeviceType.IN_CAR_DISPLAY]: { width: 1200, height: 800 },
  [On.BaseNode.Visual.DeviceType.ECHO_SPOT]: { width: 480, height: 480 },
  [On.BaseNode.Visual.DeviceType.ECHO_SHOW_8]: { width: 1280, height: 800 },
  [On.BaseNode.Visual.DeviceType.ECHO_SHOW_10]: { width: 1280, height: 800 },
  [On.BaseNode.Visual.DeviceType.FIRE_HD_8]: { width: 1280, height: 800 },
  [On.BaseNode.Visual.DeviceType.FIRE_HD_10]: { width: 1920, height: 1200 },
  [On.BaseNode.Visual.DeviceType.FIRE_TV_CUBE]: { width: 1920, height: 1080 },
  [On.BaseNode.Visual.DeviceType.GOOGLE_NEST_HUB]: { width: 1280, height: 730 }
};
var U5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DEFAULT_INTENTS_MAP = e.findDefaultIntent = e.IntentName = void 0;
  const t = zo;
  var n;
  (function(a) {
    a.NO = "VF.NO", a.YES = "VF.YES", a.STOP = "VF.STOP", a.NEXT = "VF.NEXT", a.HELP = "VF.HELP", a.PAUSE = "VF.PAUSE", a.CANCEL = "VF.CANCEL", a.RESUME = "VF.RESUME", a.REPEAT = "VF.REPEAT", a.PREVIOUS = "VF.PREVIOUS", a.START_OVER = "VF.START_OVER", a.NONE = "None";
  })(n = e.IntentName || (e.IntentName = {}));
  const r = (a, i) => {
    var o;
    return (o = e.DEFAULT_INTENTS_MAP === null || e.DEFAULT_INTENTS_MAP === void 0 ? void 0 : e.DEFAULT_INTENTS_MAP[a]) === null || o === void 0 ? void 0 : o.find((s) => s.name === i);
  };
  e.findDefaultIntent = r, e.DEFAULT_INTENTS_MAP = {
    [t.Language.EN]: [
      {
        name: n.NO,
        samples: ["no", "nope", "nay", "nah", "no way", "negative"]
      },
      {
        name: n.YES,
        samples: ["yes", "yea", "ok", "okay", "yup", "ya", "sure"]
      },
      {
        name: n.STOP,
        samples: ["stop"]
      },
      {
        name: n.NEXT,
        samples: ["next"]
      },
      {
        name: n.HELP,
        samples: ["help", "help me", "i need help"]
      },
      {
        name: n.PAUSE,
        samples: ["pause"]
      },
      {
        name: n.CANCEL,
        samples: ["cancel"]
      },
      {
        name: n.RESUME,
        samples: ["resume"]
      },
      {
        name: n.REPEAT,
        samples: ["repeat", "again", "say again"]
      },
      {
        name: n.PREVIOUS,
        samples: ["previous"]
      },
      {
        name: n.START_OVER,
        samples: ["start over", "restart"]
      },
      {
        name: n.NONE,
        samples: []
      }
    ],
    [t.Language.FR]: [
      {
        name: n.NO,
        samples: ["non", "nan", "absolument pas", "hors de question", "bien s\xFBr que non"]
      },
      {
        name: n.YES,
        samples: ["oui", "yep", "ok", "bien s\xFBr", "ouais", "ouaip", "exactement", "correct", "okay", "d'accord"]
      },
      {
        name: n.STOP,
        samples: ["s'arr\xEAter", "arr\xEAter", "arr\xEAte", "stop", "fin", "cesser", "mettre fin", "stopper", "mettre un terme", "interrompre"]
      },
      {
        name: n.HELP,
        samples: ["aidez-moi", "l'assistance", "aider"]
      },
      {
        name: n.NEXT,
        samples: ["prochaine", "prochain", "suivant"]
      },
      {
        name: n.PAUSE,
        samples: ["pause"]
      },
      {
        name: n.CANCEL,
        samples: ["annuler", "annule"]
      },
      {
        name: n.RESUME,
        samples: ["reprendre"]
      },
      {
        name: n.REPEAT,
        samples: [
          "repeat",
          "est-ce que tu peux r\xE9p\xE9ter",
          "r\xE9p\xE8te",
          "tu peux r\xE9p\xE9ter",
          "dis-le \xE0 nouveau",
          "tu peux le redire",
          "redire \xE7a",
          "r\xE9p\xE9ter \xE7a"
        ]
      },
      {
        name: n.PREVIOUS,
        samples: ["pr\xE9c\xE9dente", "pr\xE9c\xE9dent"]
      },
      {
        name: n.START_OVER,
        samples: ["recommencer", "red\xE9marrer"]
      },
      {
        name: n.NONE,
        samples: []
      }
    ],
    [t.Language.JA]: [
      {
        name: n.NO,
        samples: ["no", "\u3044\u3044\u3048", "\u305D\u3046\u3060\u306F\u306A\u3044", "\u3044\u3084\u305D\u308C\u3069\u3053\u308D\u304B", "\u30CE\u30F3", "\u5426", "\u5426\u3084"]
      },
      {
        name: n.YES,
        samples: ["yes", "\u306F\u3044", "\u3048\u3048", "\u305D\u3046\u3067\u3059"]
      },
      {
        name: n.STOP,
        samples: [
          "\u6B62\u3081\u308B",
          "\u7ACB\u3061\u6B62\u307E\u308B",
          "\u6B62\u3080",
          "\u6253\u3061\u5207\u308B",
          "\u505C\u3081\u308B",
          "\u7559\u3081\u308B",
          "\u963B\u3080",
          "\u9014\u7D76\u3048\u308B",
          "\u53E5\u5207\u308B",
          "\u505C\u307E\u308B",
          "\u30B9\u30C8\u30C3\u30D7",
          "\u7D42\u6B62",
          "\u505C\u7559",
          "\u6B62\u307E\u308B\u3053\u3068"
        ]
      },
      {
        name: n.NEXT,
        samples: ["\u6B21\u306B", "\u6B21"]
      },
      {
        name: n.HELP,
        samples: ["\u52A9\u3051\u3066", "\u624B\u52A9\u3051", "\u30A2\u30B7\u30B9\u30C8"]
      },
      {
        name: n.PAUSE,
        samples: ["\u4E00\u6642\u505C\u6B62", "\u4F11\u6B62"]
      },
      {
        name: n.CANCEL,
        samples: ["\u53D6\u308A\u6D88\u3059", "\u30AD\u30E3\u30F3\u30BB\u30EB", "\u53D6\u308A\u6D88\u3057", "\u53D6\u6D88"]
      },
      {
        name: n.RESUME,
        samples: ["\u518D\u958B\u3059\u308B"]
      },
      {
        name: n.REPEAT,
        samples: ["repeat", "\u7E70\u308A\u8FD4\u3059", "\u5F15\u304D\u8FD4\u3059", "\u6298\u308C\u8FD4\u308B", "\u8FD4\u3059"]
      },
      {
        name: n.PREVIOUS,
        samples: ["\u524D", "\u4EE5\u524D"]
      },
      {
        name: n.START_OVER,
        samples: ["\u6700\u521D\u304B\u3089\u3084\u308A\u76F4\u3059", "\u518D\u8D77\u52D5"]
      },
      {
        name: n.NONE,
        samples: []
      }
    ],
    [t.Language.IT]: [
      {
        name: n.NO,
        samples: ["no", "il no", "il rifiuto", "la negazione", "nessuno"]
      },
      {
        name: n.YES,
        samples: ["yes", "si", "certo"]
      },
      {
        name: n.STOP,
        samples: [
          "stop",
          "la fermata",
          "il fermo",
          "lo stop",
          "la sosta",
          "la tappa",
          "fermare",
          "interrompere",
          "smettere",
          "fermarsi",
          "arrestare",
          "cessare",
          "sostare",
          "finire",
          "stoppare",
          "fare una fermata"
        ]
      },
      {
        name: n.NEXT,
        samples: ["prossimo", "seguente", "succesivo"]
      },
      {
        name: n.HELP,
        samples: ["aiuto", "la assistenza", "aiutami"]
      },
      {
        name: n.PAUSE,
        samples: ["pausa", "la pausa"]
      },
      {
        name: n.CANCEL,
        samples: ["cancellare", "annullare", "disdire", "sopprimere", "rescindre", "chiudere", "abrogare", "obliterare"]
      },
      {
        name: n.RESUME,
        samples: ["riprendere"]
      },
      {
        name: n.REPEAT,
        samples: ["ripetere", "la ripetizione"]
      },
      {
        name: n.PREVIOUS,
        samples: ["precedente"]
      },
      {
        name: n.START_OVER,
        samples: ["ricominciare", "ricomincia"]
      },
      {
        name: n.NONE,
        samples: []
      }
    ],
    [t.Language.ES]: [
      {
        name: n.NO,
        samples: ["no", "ninguno", "imposible", "prohibido", "la negativa", "el voto negativo", "el voto en contra"]
      },
      {
        name: n.YES,
        samples: ["yes", "si", "s\xED", "decir si"]
      },
      {
        name: n.STOP,
        samples: ["detener", "dejar", "parar", "suspender", "cesar", "pararse", "terminar", "de alto"]
      },
      {
        name: n.NEXT,
        samples: ["siguiente", "pr\xF3ximo"]
      },
      {
        name: n.HELP,
        samples: ["ayuda", "ayuadame"]
      },
      {
        name: n.PAUSE,
        samples: ["pausa", "la pausa"]
      },
      {
        name: n.CANCEL,
        samples: [
          "cancelar",
          "anular",
          "suprimir",
          "abolir",
          "dar anulaci\xF3n",
          "realizar anulaci\xF3n",
          "hacer anulaci\xF3n",
          "hacer dar anulaci\xF3n",
          "noun la cancelaci\xF3n",
          "la anulaci\xF3n"
        ]
      },
      {
        name: n.RESUME,
        samples: ["reanudar"]
      },
      {
        name: n.REPEAT,
        samples: ["repeat", "repetir", "repetirse", "reiterar", "recitar", "volver a dar"]
      },
      {
        name: n.PREVIOUS,
        samples: ["previa", "previo"]
      },
      {
        name: n.START_OVER,
        samples: ["reiniciar"]
      },
      {
        name: n.NONE,
        samples: []
      }
    ],
    [t.Language.DE]: [
      {
        name: n.NO,
        samples: ["no", "nein", "kein", "nicht"]
      },
      {
        name: n.YES,
        samples: ["yes", "ja", "doch", "jawohl"]
      },
      {
        name: n.STOP,
        samples: [
          "der stopp",
          "der anschlag",
          "die haltestelle",
          "der registerzug",
          "stoppen",
          "aufh\xF6ren",
          "beenden",
          "anhalten",
          "halten",
          "verhindern",
          "aufhalten",
          "unterbrechen",
          "abbrechen",
          "unterbinden",
          "einstellen",
          "abbestellen",
          "absetzen"
        ]
      },
      {
        name: n.NEXT,
        samples: ["n\xE4chster", "n\xE4chste", "neben"]
      },
      {
        name: n.HELP,
        samples: ["hilfe", "hilf mir", "helfen"]
      },
      {
        name: n.PAUSE,
        samples: ["pause", "pausieren", "die pause"]
      },
      {
        name: n.CANCEL,
        samples: ["stornieren", "aufheben", "k\xFCndigen", "annullieren", "beenden", "absagen", "abbestellen", "abmelden", "aufl\xF6sen", "zur\xFCcknehmen"]
      },
      {
        name: n.RESUME,
        samples: ["wieder aufnehmen", "fortsetzen", "fortfahren"]
      },
      {
        name: n.REPEAT,
        samples: ["repeat", "wiederholen", "wiedergeben", "repetieren", "weitersagen"]
      },
      {
        name: n.PREVIOUS,
        samples: ["bisherige", "fr\xFCher"]
      },
      {
        name: n.START_OVER,
        samples: ["Von vorn anfangen", "Neustart", "wieder starten"]
      },
      {
        name: n.NONE,
        samples: []
      }
    ],
    [t.Language.PT]: [
      {
        name: n.NO,
        samples: ["no", "n\xE3o", "negativa"]
      },
      {
        name: n.YES,
        samples: ["yes", "sim", "o sim", "dizer sim"]
      },
      {
        name: n.STOP,
        samples: ["parar", "terminar", "impedir", "fazer parar"]
      },
      {
        name: n.NEXT,
        samples: ["pr\xF3xima", "pr\xF3ximo", "seguinte", "seguida"]
      },
      {
        name: n.HELP,
        samples: ["socorro", "me ajude"]
      },
      {
        name: n.PAUSE,
        samples: ["pausa", "pausar"]
      },
      {
        name: n.CANCEL,
        samples: ["cancelar", "anular", "suspender"]
      },
      {
        name: n.RESUME,
        samples: ["retomar"]
      },
      {
        name: n.REPEAT,
        samples: ["repeat", "repetir", "reiterar", "refazer", "amiudar", "recitar de cor"]
      },
      {
        name: n.PREVIOUS,
        samples: ["anterior"]
      },
      {
        name: n.START_OVER,
        samples: ["recome\xE7ar", "reiniciar"]
      },
      {
        name: n.NONE,
        samples: []
      }
    ],
    [t.Language.HI]: [
      {
        name: n.NO,
        samples: ["\u0928\u0939\u0940\u0902", "\u0928\u093E", "\u0928\u0947\u0917\u091F\u093F\u0935\u093C\u094D", "\u0928\u094B", "\u0928\u094B\u092A\u094D"]
      },
      {
        name: n.YES,
        samples: [
          "\u0939\u093E\u0902",
          "\u0939\u093E\u0901",
          "\u091C\u093C\u0930\u0942\u0930",
          "\u0905\u0935\u0936\u094D\u092F",
          "\u0920\u0940\u0915 \u0939\u0948",
          "\u0920\u0940\u0915",
          "\u0905\u091A\u094D\u091B\u093E \u0939\u0948",
          "\u0905\u091A\u094D\u091B\u093E",
          "\u0938\u0939\u0940 \u0939\u0948",
          "\u0938\u0939\u0940",
          "\u0905\u091A\u094D\u091B\u0940 \u092C\u093E\u0924 \u0939\u0948",
          "\u092A\u0915\u094D\u0915\u093E",
          "\u092C\u093F\u0932\u094D\u0915\u0941\u0932",
          "\u0911\u0932 \u0930\u093E\u0907\u091F\u094D",
          "\u0921\u0947\u092B\u093C\u093F\u0928\u093F\u091F\u094D\u0932\u0940",
          "\u092F\u0947\u0938\u094D",
          "\u092F\u0947\u0905",
          "\u092F\u092A\u094D",
          "\u092F\u0947\u092A\u094D",
          "\u0936\u0941\u0905",
          "\u0913\u0915\u0947"
        ]
      },
      {
        name: n.STOP,
        samples: ["\u0930\u0941\u0915\u0947\u0902", "\u0930\u094B\u0915\u0928\u093E", "\u0935\u093F\u0930\u093E\u092E", "\u0930\u0941\u0915\u094B", "\u0930\u0941\u0915", "\u0930\u0941\u0915\u0928\u093E", "\u0930\u0941\u0915 \u091C\u093E\u0928\u093E", "\u092C\u0902\u0926", "\u092C\u0902\u0926 \u0915\u0930\u094B", "\u092C\u0902\u0926 \u0915\u0930 \u0926\u094B", "\u092C\u0902\u0926 \u0915\u0930\u0928\u093E", "\u0938\u094D\u091F\u0949\u092A\u094D"]
      },
      {
        name: n.NEXT,
        samples: ["\u0906\u0917\u0947", "\u0905\u0917\u0932\u093E", "\u0906\u0917\u093E\u092E\u0940", "\u092C\u093E\u0926"]
      },
      {
        name: n.HELP,
        samples: ["\u092E\u0926\u0926", "\u092E\u0947\u0930\u0940 \u092E\u0926\u0926 \u0915\u0930\u094B"]
      },
      {
        name: n.PAUSE,
        samples: ["\u0920\u0939\u0930\u093E\u0935", "\u0935\u093F\u0930\u093E\u092E"]
      },
      {
        name: n.CANCEL,
        samples: [
          "\u0930\u0926\u094D\u0926 \u0915\u0930\u094B",
          "\u0930\u0926\u094D\u0926 \u0915\u0930\u0928\u093E",
          "\u0930\u0926\u094D\u0926 \u0915\u0930 \u0926\u094B",
          "\u0928\u093F\u0930\u0938\u094D\u0924 \u0915\u0930\u094B",
          "\u0928\u093F\u0930\u0938\u094D\u0924 \u0915\u0930\u0928\u093E",
          "\u0928\u093F\u0930\u0938\u094D\u0924 \u0915\u0930 \u0926\u094B",
          "\u0915\u093E\u091F \u0926\u0947",
          "\u0915\u093E\u091F \u0926\u094B",
          "\u0915\u093E\u091F \u0926\u0947\u0928\u093E",
          "\u0935\u093E\u092A\u0938 \u0932\u0947",
          "\u0935\u093E\u092A\u0938 \u0932\u094B",
          "\u0935\u093E\u092A\u0938 \u0932\u0947\u0928\u093E",
          "\u0915\u0948\u0928\u094D\u0938\u0932\u094D",
          "\u0915\u0948\u0928\u094D\u0938\u0932\u094D \u0915\u0930\u094B",
          "\u0915\u0948\u0928\u094D\u0938\u0932\u094D \u0915\u0930\u0928\u093E",
          "\u0915\u0948\u0928\u094D\u0938\u0932\u094D \u0915\u0930 \u0926\u094B"
        ]
      },
      {
        name: n.RESUME,
        samples: ["\u0926\u0941\u092C\u093E\u0930\u093E \u0906\u0930\u092E\u094D\u092D \u0915\u0930\u0928\u093E", "\u092B\u093F\u0930 \u0936\u0941\u0930\u0942 \u0938\u0947 \u0915\u0930\u0928\u093E", "\u092B\u093F\u0930 \u0938\u0947 \u0936\u0941\u0930\u0942 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F"]
      },
      {
        name: n.REPEAT,
        samples: [
          "\u092B\u093F\u0930 \u0938\u0947",
          "\u092B\u093F\u0930 \u092C\u094B\u0932\u093E\u0928\u093E",
          "\u092B\u093F\u0930 \u0938\u0947 \u092C\u094B\u0932\u093E\u0928\u093E",
          "\u092B\u093F\u0930 \u092C\u094B\u0932\u094B",
          "\u092B\u093F\u0930 \u0938\u0947 \u092C\u094B\u0932\u094B",
          "\u092B\u093F\u0930 \u0915\u0939\u094B",
          "\u092B\u093F\u0930 \u0938\u0947 \u0915\u0939\u0928\u093E",
          "\u0926\u0941\u092C\u093E\u0930\u093E \u0938\u0947",
          "\u0926\u0941\u092C\u093E\u0930\u093E \u0915\u0939\u094B",
          "\u0926\u0941\u092C\u093E\u0930\u093E \u0938\u0947 \u0915\u0939\u094B",
          "\u0926\u0941\u092C\u093E\u0930\u093E \u0915\u0939\u0928\u093E",
          "\u0926\u0941\u092C\u093E\u0930\u093E \u0938\u0947 \u0915\u0939\u0928\u093E",
          "\u0926\u0941\u092C\u093E\u0930\u093E \u092C\u094B\u0932\u094B",
          "\u0926\u0941\u092C\u093E\u0930\u093E \u0938\u0947 \u092C\u094B\u0932\u094B",
          "\u0926\u0941\u092C\u093E\u0930\u093E \u092C\u094B\u0932\u093E\u0928\u093E",
          "\u0926\u0941\u092C\u093E\u0930\u093E \u0938\u0947 \u092C\u094B\u0932\u093E\u0928\u093E",
          "\u0926\u0941\u0939\u0930\u093E\u0928\u093E",
          "\u090F\u0915 \u092C\u093E\u0930 \u0914\u0930",
          "\u0930\u093F\u092A\u0940\u091F\u094D",
          "\u0930\u093F\u092A\u0940\u091F\u094D \u0915\u0930\u0928\u093E"
        ]
      },
      {
        name: n.PREVIOUS,
        samples: ["\u092A\u093F\u091B\u0932\u093E", "\u092A\u0942\u0930\u094D\u0935"]
      },
      {
        name: n.START_OVER,
        samples: ["\u092A\u094D\u0930\u093E\u0930\u0902\u092D \u0915\u0930\u0947\u0902", "\u092A\u0941\u0928\u0930\u094D\u092A\u094D\u0930\u093E\u0930\u0902\u092D \u0915\u0930\u0947\u0902"]
      },
      {
        name: n.NONE,
        samples: []
      }
    ]
  };
})(U5);
var Vo = {};
Object.defineProperty(Vo, "__esModule", { value: !0 });
Vo.defaultMessages = void 0;
Vo.defaultMessages = {
  globalNoReply: "Are you still there?",
  globalNoMatch: "Sorry, I didn\u2019t get that. Please try again."
};
var j5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TTSPlatformType = e.ProjectType = e.PlatformType = void 0, function(t) {
    t.ALEXA = "alexa", t.GOOGLE = "google", t.VOICEFLOW = "voiceflow", t.DIALOGFLOW_ES = "df-es", t.DIALOGFLOW_CX = "df-cx", t.LUIS = "luis", t.RASA = "rasa", t.WATSON = "watson", t.LEX = "lex", t.EINSTEIN = "einstein", t.NUANCE_MIX = "nuance-mix", t.WEBCHAT = "webchat", t.MICROSOFT_TEAMS = "microsoft_teams", t.WHATSAPP = "whatsapp", t.SMS = "sms", t.IVR = "ivr", t.CHATBOT = "chatbot", t.DIALOGFLOW_ES_CHAT = "dialogflow_es_chat", t.DIALOGFLOW_ES_VOICE = "dialogflow_es_voice", t.GENERAL = "general", t.MOBILE_APP = "mobile_app";
  }(e.PlatformType || (e.PlatformType = {})), function(t) {
    t.CHAT = "chat", t.VOICE = "voice";
  }(e.ProjectType || (e.ProjectType = {})), function(t) {
    t.ALEXA = "alexa", t.AZURE = "azure", t.GOOGLE = "google";
  }(e.TTSPlatformType || (e.TTSPlatformType = {}));
})(j5);
var z5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SlotTypes = e.SlotType = void 0;
  const t = zo;
  var n;
  (function(c) {
    c.CUSTOM = "VF.CUSTOM", c.AGE = "VF.AGE", c.CURRENCY = "VF.CURRENCY", c.DATETIME = "VF.DATETIME", c.DIMENSION = "VF.DIMENSION", c.EMAIL = "VF.EMAIL", c.GEOGRAPHY = "VF.GEOGRAPHY", c.KEY_PHRASE = "VF.KEY_PHRASE", c.NAME = "VF.NAME", c.NATOAPCO = "VF.NATOAPCO", c.NUMBER = "VF.NUMBER", c.ORDINAL = "VF.ORDINAL", c.PERCENTAGE = "VF.PERCENTAGE", c.PHONENUMBER = "VF.PHONENUMBER", c.TEMPERATURE = "VF.TEMPERATURE", c.URL = "VF.URL";
  })(n = e.SlotType || (e.SlotType = {}));
  const r = {
    name: n.EMAIL,
    label: "Email",
    values: ["user@voiceflow.com", "professor@utoronto.edu", "person_name@gmail.com", "username123.signature@hotmail.com", "researcher@charity.org"],
    regex: "^[\\w-.]+@([\\w-]+\\.)+[\\w-]{2,4}$"
  }, a = {
    name: n.PHONENUMBER,
    label: "Phone Number",
    values: ["1 (800) 642-7676", "123-456-7890", "647 126 3928", "360 392-1293", "906-459-2349", "2018073710", "4791945491"]
  }, i = (c) => ({
    name: n.NUMBER,
    label: c,
    values: ["-43", "0", "35.5", "8", "520", "23599", "325", "15", "84730909029", "6947"]
  }), o = (c) => ({
    name: n.PERCENTAGE,
    label: c,
    values: ["3 1/2", "2%", "5 %"]
  }), s = (c) => ({
    name: n.ORDINAL,
    label: c,
    values: ["first", "second", "third", "next", "last", "previous"]
  }), u = (c) => ({
    name: n.URL,
    label: c,
    values: ["https://www.luis.ai", "www.google.ca", "voiceflow.com", "dev.voiceflow.com", "http://www.something.io"]
  }), l = (c) => ({
    name: n.KEY_PHRASE,
    label: c,
    values: ["educational requirements", "development", "food", "wonderful staff", "extravagant"]
  });
  e.SlotTypes = {
    [t.Language.EN]: [
      {
        name: n.NAME,
        label: "Name",
        values: [
          "john",
          "james",
          "robert",
          "michael",
          "william",
          "david",
          "tyler",
          "roy",
          "andrew",
          "richard",
          "thomas",
          "daniel",
          "anthony",
          "mary",
          "jennifer",
          "emily",
          "susan",
          "valerie",
          "amanda",
          "sam"
        ]
      },
      {
        name: n.GEOGRAPHY,
        label: "Geography",
        values: ["the sphinx", "gizah", "egypt", "africa", "texas"]
      },
      r,
      a,
      i("Number"),
      o("Percentage"),
      s("Ordinal"),
      u("URL"),
      l("Key Phrase"),
      {
        name: n.NATOAPCO,
        label: "NATO/APCO",
        values: [],
        list: [
          { canonicalForm: "Alfa", list: ["Adam", "Alpha"] },
          { canonicalForm: "Bravo", list: ["Boy", "Baker"] },
          { canonicalForm: "Charlie", list: ["Charles"] },
          { canonicalForm: "Delta", list: ["David"] },
          { canonicalForm: "Echo", list: ["Edward", "Easy"] },
          { canonicalForm: "Foxtrot", list: ["Frank"] },
          { canonicalForm: "Golf", list: ["George"] },
          { canonicalForm: "Hotel", list: ["Henry"] },
          { canonicalForm: "India", list: ["Ida"] },
          { canonicalForm: "Juliett", list: ["John"] },
          { canonicalForm: "Kilo", list: ["King"] },
          { canonicalForm: "Lima", list: ["Lincoln"] },
          { canonicalForm: "Mike", list: ["Mary"] },
          { canonicalForm: "November", list: ["Nora"] },
          { canonicalForm: "Oscar", list: ["Ocean"] },
          { canonicalForm: "Papa", list: ["Paul"] },
          { canonicalForm: "Quebec", list: ["Queen"] },
          { canonicalForm: "Romeo", list: ["Robert"] },
          { canonicalForm: "Sierra", list: ["Sam"] },
          { canonicalForm: "Tango", list: ["Tom"] },
          { canonicalForm: "Uniform", list: ["Union"] },
          { canonicalForm: "Victor", list: [] },
          { canonicalForm: "Whiskey", list: ["William"] },
          { canonicalForm: "X-ray", list: ["Xray"] },
          { canonicalForm: "Yankee", list: ["Young", "Yellow"] },
          { canonicalForm: "Zulu", list: ["Zebra"] },
          { canonicalForm: "0", list: ["Zero", "Nadazero"] },
          { canonicalForm: "1", list: ["One", "Wun", "Unaone"] },
          { canonicalForm: "2", list: ["Two", "Too", "Bissotwo"] },
          { canonicalForm: "3", list: ["Three", "Tree", "Terrathree"] },
          { canonicalForm: "4", list: ["Four", "Fower", "Kartefour"] },
          { canonicalForm: "5", list: ["Five", "Fife", "Pantafive"] },
          { canonicalForm: "6", list: ["Six", "Soxisix"] },
          { canonicalForm: "7", list: ["Seven", "Setteseven"] },
          { canonicalForm: "8", list: ["Eight", "Oktoeight"] },
          { canonicalForm: "9", list: ["Nine", "Niner", "Novenine"] },
          { canonicalForm: "00", list: ["Hundred"] },
          { canonicalForm: "000", list: ["Thousand"] },
          { canonicalForm: "-", list: ["Dash", "Hyphen"] },
          { canonicalForm: ".", list: ["Decimal", "Point", "Stop"] }
        ]
      },
      {
        name: n.AGE,
        label: "Age",
        values: ["20 days old", "nineteen years old", "4 weeks old", "8 months old", "45 years-old", "one month old"]
      },
      {
        name: n.CURRENCY,
        label: "Currency",
        values: [
          "5 dollars",
          "1 dollar",
          "one dollar",
          "$8",
          "6 canadian dollars",
          "seven pennies",
          "9 pounds",
          "15 pesos",
          "Four para",
          "87 ruples",
          "thirty rupees",
          "\xA312.34",
          "34.2$"
        ]
      },
      {
        name: n.DATETIME,
        label: "Datetime",
        values: ["May 2nd", "May 25th, 2025", "Tuesday to Thursday", "From 6pm to 7pm", "6:30 pm to 7 pm", "8am", "8:30 pm", "9 am", "10:12 am"]
      },
      {
        name: n.DIMENSION,
        label: "Dimension",
        values: ["10 1/2 miles", "10.5 kilometers", "0.3 mm", "5 feet", "6 yards", "10m", "25 m/s"]
      },
      {
        name: n.TEMPERATURE,
        label: "Temperature",
        values: ["30 degrees", "215 kelvin", "56 f", "33\xB0f", "22 degrees celsius", "102 degs farenheit"]
      }
    ],
    [t.Language.DE]: [
      r,
      a,
      {
        name: n.AGE,
        label: "Alter",
        values: ["7 Jahre alt", "acht Mondate alt", "3 wochen alt", "neun Tage alt", "einen tag alt", "1 Jahr alt"]
      },
      i("Nummer"),
      o("Prozentsatz"),
      s("Ordinalzahl"),
      u("URL"),
      l("Schl\xFCsselsatz"),
      {
        name: n.CURRENCY,
        label: "W\xE4hrung",
        values: ["7 $", "23 Dollar", "drei\xDFig USD", "87 yuan", "11 pfund", "55\xA3", "\xA35.99", "neunzehn Pesos"]
      },
      {
        name: n.DATETIME,
        label: "Datum (und Uhrzeit",
        values: ["2. Mai", "25. Mai 2025", "Dienstag bis Donnerstag", "Von 18 bis 19 Uhr", "8 Uhr morgens", "20:30 Uhr"]
      },
      {
        name: n.DIMENSION,
        label: "Dimension",
        values: ["10 1/2 Meilen", "10,5 Kilometer", "0,3 mm", "5 Fu\xDF", "6 Yards", "6m", "25 m/s"]
      },
      {
        name: n.TEMPERATURE,
        label: "Temperatur",
        values: ["30 Grad", "215 Kelvin", "56 f", "33\xB0f", "22 Grad Celsius", "102 Grad Fahrenheit"]
      }
    ],
    [t.Language.FR]: [
      r,
      a,
      {
        name: n.AGE,
        label: "\xC2ge",
        values: [
          "3 ans",
          "Trois ans",
          "2 mois d'\xE2ge",
          "six mois d'age",
          "8 mois",
          "huit mois",
          "une semaine",
          "1 semaine",
          "3 semaines",
          "sept semaines d'\xE2ge",
          "9 semaines d'age",
          "18 jours",
          "quarante jours",
          "un jour"
        ]
      },
      i("Nombre"),
      o("Pourcentage"),
      s("Nombre ordinal"),
      u("URL"),
      l("Phrase cl\xE9"),
      {
        name: n.CURRENCY,
        label: "Monnaie",
        values: ["un dollar", "3 dollars", "5$", "\xA312.09", "33 pence", "Sept sou", "6 livres", "douze pesos", "trois francs", "7 dollars canadien"]
      },
      {
        name: n.DATETIME,
        label: "Date et l'Heure",
        values: ["2 mai", "2 mai 2025", "du mardi au jeudi", "De 18h \xE0 19h", "8h00", "20h30"]
      },
      {
        name: n.DIMENSION,
        label: "Dimension",
        values: ["10 1/2 miles", "10,5 kilom\xE8tres", "0,3 mm", "5 pieds", "6 yards", "6m", "25 m/s"]
      },
      {
        name: n.TEMPERATURE,
        label: "Temp\xE9rature",
        values: ["30 degr\xE9s", "215 kelvin", "56 f", "33\xB0f", "22 degr\xE9s Celsius", "102 degs farenheit"]
      }
    ],
    [t.Language.PT]: [
      r,
      a,
      {
        name: n.AGE,
        label: "Idade",
        values: [
          "3 anos",
          "3 anos de idade",
          "1 ano",
          "uma ano",
          "6 meses",
          "1 mes",
          "um m\xEAs",
          "7 semanas",
          "uma semana",
          "1 semana",
          "quatro dias",
          "15 dias",
          "1 dia"
        ]
      },
      i("N\xFAmero"),
      o("Porcentagem"),
      s("N\xFAmero ordinal"),
      u("URL"),
      l("Frase chave"),
      {
        name: n.CURRENCY,
        label: "Monnaie",
        values: ["1 d\xF3lar", "quatro pesos", "\u20AC6.01", "5\u20AC", "11.02 francos"]
      },
      {
        name: n.DATETIME,
        label: "Data e Hora",
        values: ["2 de maio", "2 de maio de 2015", "Ter\xE7a a quinta", "Das 18h \xE0s 19h", "8 horas da manh\xE3", "20:30"]
      },
      {
        name: n.DIMENSION,
        label: "Dimens\xE3o",
        values: ["10 1/2 milhas ", "10,5 quil\xF4metros", "0,3 mm", "5 p\xE9s", "6 jardas", "6m", "25 m/s"]
      },
      {
        name: n.TEMPERATURE,
        label: "Temperatura",
        values: ["30 graus", " 215 Kelvin", "56 f", "33 \xB0 f", "22 graus Celsius", "102 degs farenheit"]
      }
    ],
    [t.Language.ES]: [
      r,
      a,
      {
        name: n.AGE,
        label: "Edad",
        values: [
          "3 a\xF1os",
          "1 a\xF1o",
          "un a\xF1o",
          "6 meses",
          "6 meses de edad",
          "1 mes",
          "um m\xEAs",
          "7 semanas",
          "un semana",
          "1 semana",
          "quatro dias",
          "15 d\xEDas",
          "1 dia de edad",
          "un d\xEDa"
        ]
      },
      i("N\xFAmero"),
      o("Porcentaje"),
      s("N\xFAmero ordinal"),
      u("URL"),
      l("Frase clave"),
      {
        name: n.CURRENCY,
        label: "Moneda",
        values: ["5 d\xF3lares", "1 peso", "3.2 libras", "Tres rublos", "1 peso dominicano", "4.5 d\xF3lares canadienses", "3.5\u20AC", "\u20AC9", "tres euros"]
      },
      {
        name: n.DATETIME,
        label: "Fecha y Hora",
        values: ["2 de Mayo", "2 de mayo de 2015", "Martes a jueves", "De 18h a 19h", "8:00AM", "8:30 PM"]
      },
      {
        name: n.DIMENSION,
        label: "Dimensi\xF3n",
        values: ["10 1/2 millas", "10.5 kil\xF3metros", "0,3 mm", "5 pies", "6 yardas", "10 m", "25 m/s"]
      },
      {
        name: n.TEMPERATURE,
        label: "Temperatura",
        values: ["30 grados", "215 kelvin", "56 f", "33\xB0f", "22 grados celsius", "102 grados farenheit"]
      }
    ],
    [t.Language.ZH]: [
      r,
      a,
      {
        name: n.AGE,
        label: "\u5C81",
        values: ["\u4E00\u5C81", "3\u5C81", "5\u5468\u5C81", "7\u4E2A\u6708\u5927", "9\u6708\u5927", "8\u5468\u5927", "21\u5929\u5927", "1\u5929\u5927"]
      },
      i("\u6570\u5B57"),
      o("\u767E\u5206\u6BD4"),
      s("\u5E8F\u6570\u8BCD"),
      u("\u7F51\u5740"),
      {
        name: n.CURRENCY,
        label: "\u8CA8\u5E63",
        values: ["5 \u6B27\u5143", "1\u6BD4\u7D22", "9\u4FBF\u58EB", "\u516B\u4FBF\u58EB", "8 \u7F8E\u5143", "8\u52A0\u5143", "12 \u4EBA\u6C11\u5E01"]
      },
      {
        name: n.DATETIME,
        label: "\u65E5\u671F\u548C\u65F6\u95F4",
        values: ["May 2nd", "2015 \u5E74 5 \u6708 2 \u65E5", "\u5468\u4E8C\u81F3\u5468\u56DB", "\u4ECE\u4E0B\u5348 6 \u70B9\u5230\u665A\u4E0A 7 \u70B9", "\u65E9\u4E0A\u516B\u70B9", "\u665A\u4E0A 8:30"]
      },
      {
        name: n.DIMENSION,
        label: "\u5C3A\u5BF8",
        values: ["10 1/2 \u82F1\u91CC", "10.5 \u516C\u91CC", "0.3 \u6BEB\u7C73", "5 \u82F1\u5C3A", "6 \u7801", "7\u6BEB\u7C73"]
      },
      {
        name: n.TEMPERATURE,
        label: "\u6E29\u5EA6",
        values: ["30 \u5EA6", "215 \u5F00\u5C14\u6587", "56 f", "33\xB0f", "22 \u6444\u6C0F\u5EA6", "\u534E\u6C0F 102 \u5EA6", "34.1\u6444\u6C0F\u5EA6"]
      }
    ],
    [t.Language.JA]: [
      r,
      a,
      {
        name: n.AGE,
        label: "\u6B73",
        values: ["1\u6B73", "\u4E00\u6B73", "2\u6B73", "4\u30F6\u6708", "3\u9031\u9593", "6\u9031", "5\u65E5\u9593", "9\u65E5\u9F62", "10\u65E5\u5927"]
      },
      i("\u6570"),
      o("\u30D1\u30FC\u30BB\u30F3\u30C6\u30FC\u30B8"),
      s("\u5E8F\u6570"),
      u("URL"),
      l("\u30AD\u30FC\u30D5\u30EC\u30FC\u30BA"),
      {
        name: n.CURRENCY,
        label: "\u901A\u8CA8",
        values: ["88\u30C9\u30EB", "123\u4EBA\u6C11\u5143", "7\u30DA\u30F3\u30B9", "87\u30DA\u30BD", "5\u30AB\u30CA\u30C0\u30FB\u30C9\u30EB", "44\u30B7\u30EA\u30F3\u30B0"]
      },
      {
        name: n.DIMENSION,
        label: "\u5BF8\u6CD5",
        values: ["101/2\u30DE\u30A4\u30EB", "10.5\u30AD\u30ED\u30E1\u30FC\u30C8\u30EB", "0.3 mm", "5\u30D5\u30A3\u30FC\u30C8", "6\u30E4\u30FC\u30C9"]
      },
      {
        name: n.TEMPERATURE,
        label: "\u6E29\u5EA6",
        values: ["30\u5EA6", "215\u30B1\u30EB\u30D3\u30F3", "56 f", "33\xB0f", "22\u2103", "102\u5EA6\u83EF\u6C0F"]
      }
    ],
    [t.Language.NL]: [
      r,
      a,
      {
        name: n.AGE,
        label: "Leeftijd",
        values: [
          "twintig jaar oud",
          "19 dagen old",
          "negentien dagen oud",
          "4 week oud",
          "8 maand oud",
          "1 jaar oud",
          "3 jaar",
          "4 levensjaren",
          "30 jarige leeftijd",
          "45-jarige leeftijd",
          "2-jarige",
          "5 jarige",
          "6 maand oud",
          "twee maanden",
          "vier weken oud",
          "5 week",
          "zeven weken",
          "6 dag oud",
          "7 dag",
          "negen dagen"
        ]
      },
      i("Aantal"),
      o("Percentage"),
      s("Rangtelwoord"),
      u("URL"),
      l("Sleutelwoord"),
      {
        name: n.CURRENCY,
        label: "Valuta",
        values: ["8 euro", "negen cent", "4 japanse yen", "vier pesos", "11 centen", "33 pence", "5 dollar", "0.12 bitcoin", "drie\xEBntwintig pond"]
      },
      {
        name: n.DIMENSION,
        label: "Afmeting",
        values: ["10 1/2 mijl", "10,5 kilometer", "0,3 mm", "5 voet", "6 yards", "7m", "25 m/s"]
      },
      {
        name: n.TEMPERATURE,
        label: "Temperatuur",
        values: ["30 graden", "215 kelvin", "56 f", "33\xB0f", "22 graden Celsius", "102 graden farenheit"]
      }
    ],
    [t.Language.IT]: [
      r,
      a,
      {
        name: n.AGE,
        label: "Et\xE0",
        values: [
          "8 anni di et\xE0",
          "sette anni",
          "un anno di et\xE0",
          "11 anni d'et\xE0",
          "1 anno d'et\xE0",
          "di nove anni d'et\xE0",
          "4 anni",
          "1 anno",
          "8 mesi di et\xE0",
          "sette mesi",
          "un mese di et\xE0",
          "11 mesi d'et\xE0",
          "1 mese d'et\xE0",
          "di nove mesi d'et\xE0",
          "1 mese",
          "8 settimane di et\xE0",
          "sette settimane",
          "un settimana di et\xE0",
          "11 settimane d'et\xE0",
          "1 settimana d'et\xE0",
          "di nove settimane d'et\xE0",
          "1 settimana",
          "8 giorni di et\xE0",
          "sette giorni",
          "un giorno di et\xE0",
          "11 giorni d'et\xE0",
          "1 giorno d'et\xE0",
          "di nove giorni d'et\xE0",
          "1 giorno"
        ]
      },
      i("Numero"),
      o("Percentuale"),
      s("Numero ordinale"),
      u("URL"),
      l("Frase chiave"),
      {
        name: n.CURRENCY,
        label: "Valuta",
        values: ["5 dollari", "9.10 dollari canadesi", "6 sterline", "$4.1", "quattro pence", "24 pesos", "84 \xA3", "\xA399.12"]
      },
      {
        name: n.DIMENSION,
        label: "Dimensione",
        values: ["10 1/2 miglia", "10,5 chilometri", "0,3 mm", "5 piedi", "6 iarde", "8m", "25 m/s"]
      },
      {
        name: n.TEMPERATURE,
        label: "Temperatura",
        values: ["30 gradi", "215 kelvin", "56 f", "33\xB0f", "22 gradi Celsius", "102 gradi fanheit"]
      }
    ],
    [t.Language.KO]: [r, a, u("URL"), l("\uD575\uC2EC \uBB38\uAD6C")],
    [t.Locale.ES_MX]: [r, i("N\xFAmero"), u("URL"), l("Frase clave")]
  };
})(z5);
var G5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.BuiltInVariable = void 0, function(t) {
    t.LOCALE = "locale", t.CHANNEL = "channel", t.USER_ID = "user_id", t.SESSIONS = "sessions", t.PLATFORM = "platform", t.TIMESTAMP = "timestamp", t.INTENT_CONFIDENCE = "intent_confidence", t.LAST_UTTERANCE = "last_utterance", t.LAST_RESPONSE = "last_response";
  }(e.BuiltInVariable || (e.BuiltInVariable = {}));
})(G5);
(function(e) {
  var t = ft && ft.__createBinding || (Object.create ? function(r, a, i, o) {
    o === void 0 && (o = i);
    var s = Object.getOwnPropertyDescriptor(a, i);
    (!s || ("get" in s ? !a.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return a[i];
    } }), Object.defineProperty(r, o, s);
  } : function(r, a, i, o) {
    o === void 0 && (o = i), r[o] = a[i];
  }), n = ft && ft.__exportStar || function(r, a) {
    for (var i in r)
      i !== "default" && !Object.prototype.hasOwnProperty.call(a, i) && t(a, r, i);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(jo, e), n(zo, e), n(Go, e), n(U5, e), n(Vo, e), n(j5, e), n(z5, e), n(G5, e);
})(H5);
Object.defineProperty(Uo, "__esModule", { value: !0 });
Uo.defaultBaseSettings = void 0;
const hy = H5, dy = ({ locales: e = [hy.Locale.EN_US] } = {}) => ({
  locales: e
});
Uo.defaultBaseSettings = dy;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.defaultChatSettings = e.defaultSharedChatSettings = void 0;
  const t = $5, n = Uo, r = (i = {}) => Object.assign({}, t.ChatVersion.defaultSettings(i));
  e.defaultSharedChatSettings = r;
  const a = (i = {}) => Object.assign(Object.assign({}, (0, e.defaultSharedChatSettings)(i)), (0, n.defaultBaseSettings)(i));
  e.defaultChatSettings = a;
})(Wl);
var V5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ChatPosition = e.ChatPersistence = void 0, function(t) {
    t.MEMORY = "memory", t.LOCAL_STORAGE = "localStorage", t.SESSION_STORAGE = "sessionStorage";
  }(e.ChatPersistence || (e.ChatPersistence = {})), function(t) {
    t.LEFT = "left", t.RIGHT = "right";
  }(e.ChatPosition || (e.ChatPosition = {}));
})(V5);
(function(e) {
  var t = ft && ft.__createBinding || (Object.create ? function(u, l, c, f) {
    f === void 0 && (f = c);
    var E = Object.getOwnPropertyDescriptor(l, c);
    (!E || ("get" in E ? !l.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
      return l[c];
    } }), Object.defineProperty(u, f, E);
  } : function(u, l, c, f) {
    f === void 0 && (f = c), u[f] = l[c];
  }), n = ft && ft.__exportStar || function(u, l) {
    for (var c in u)
      c !== "default" && !Object.prototype.hasOwnProperty.call(l, c) && t(l, u, c);
  }, r = ft && ft.__rest || function(u, l) {
    var c = {};
    for (var f in u)
      Object.prototype.hasOwnProperty.call(u, f) && l.indexOf(f) < 0 && (c[f] = u[f]);
    if (u != null && typeof Object.getOwnPropertySymbols == "function")
      for (var E = 0, f = Object.getOwnPropertySymbols(u); E < f.length; E++)
        l.indexOf(f[E]) < 0 && Object.prototype.propertyIsEnumerable.call(u, f[E]) && (c[f[E]] = u[f[E]]);
    return c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.defaultChatPlatformData = e.defaultSharedChatPlatformData = void 0;
  const a = $5, i = Wl;
  n(V5, e), n(Wl, e);
  const o = (u) => {
    var { settings: l } = u, c = r(u, ["settings"]);
    return Object.assign(Object.assign({}, a.ChatVersion.defaultPlatformData(c)), { settings: (0, i.defaultSharedChatSettings)(l) });
  };
  e.defaultSharedChatPlatformData = o;
  const s = (u) => {
    var { settings: l } = u, c = r(u, ["settings"]);
    return Object.assign(Object.assign({}, (0, e.defaultSharedChatPlatformData)(c)), { settings: (0, i.defaultChatSettings)(l) });
  };
  e.defaultChatPlatformData = s;
})(Po);
var Ir = /* @__PURE__ */ ((e) => (e.IDLE = "IDLE", e.ACTIVE = "ACTIVE", e.ENDED = "ENDED", e))(Ir || {});
const my = "https://general-runtime.voiceflow.com";
var Pt = /* @__PURE__ */ ((e) => (e.ASSISTANT_INFO = "vfrc-assistant-info", e.AVATAR = "vfrc-avatar", e.BUBBLE = "vfrc-bubble", e.BUTTON = "vfrc-button", e.CARD = "vfrc-card", e.CAROUSEL = "vfrc-carousel", e.CHAT = "vfrc-chat", e.CHAT_INPUT = "vfrc-chat-input", e.FEEDBACK = "vfrc-feedback", e.FOOTER = "vfrc-footer", e.HEADER = "vfrc-header", e.ICON = "vfrc-icon", e.IMAGE = "vfrc-image", e.INPUT = "vfrc-input", e.LAUNCHER = "vfrc-launcher", e.LOADER = "vfrc-loader", e.MESSAGE = "vfrc-message", e.PROMPT = "vfrc-prompt", e.SYSTEM_RESPONSE = "vfrc-system-response", e.TIMESTAMP = "vfrc-timestamp", e.TOOLTIP = "vfrc-tooltip", e.TYPING_INDICATOR = "vfrc-typing-indicator", e.USER_RESPONSE = "vfrc-user-response", e.WIDGET = "vfrc-widget", e))(Pt || {});
function Y5(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = Y5(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function py() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = Y5(e)) && (r && (r += " "), r += t);
  return r;
}
const Lt = (e) => (t, n) => G9((r, a) => Ac(t, {
  ...r,
  ref: a,
  className: py(n ? `${e}--${n}` : e, r.className)
})), gy = Lt(Pt.AVATAR), K5 = Me(gy("div"), {
  flexShrink: 0,
  borderRadius: "$round",
  backgroundColor: "$lightGrey",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  variants: {
    size: {
      small: {
        height: 26,
        width: 26
      },
      large: {
        height: "$xxl",
        width: "$xxl",
        boxSizing: "border-box",
        boxShadow: "0 4px 16px 0 $shadow4, 0 0 0 1px $shadow2"
      }
    }
  },
  defaultVariants: {
    size: "small"
  }
});
var Yo = { exports: {} }, Ri = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _h;
function Ey() {
  if (_h)
    return Ri;
  _h = 1;
  var e = pn, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, u, l) {
    var c, f = {}, E = null, T = null;
    l !== void 0 && (E = "" + l), u.key !== void 0 && (E = "" + u.key), u.ref !== void 0 && (T = u.ref);
    for (c in u)
      r.call(u, c) && !i.hasOwnProperty(c) && (f[c] = u[c]);
    if (s && s.defaultProps)
      for (c in u = s.defaultProps, u)
        f[c] === void 0 && (f[c] = u[c]);
    return { $$typeof: t, type: s, key: E, ref: T, props: f, _owner: a.current };
  }
  return Ri.Fragment = n, Ri.jsx = o, Ri.jsxs = o, Ri;
}
var Mi = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bh;
function Ty() {
  return bh || (bh = 1, {}.NODE_ENV !== "production" && function() {
    var e = pn, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), g = Symbol.iterator, m = "@@iterator";
    function v(k) {
      if (k === null || typeof k != "object")
        return null;
      var se = g && k[g] || k[m];
      return typeof se == "function" ? se : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(k) {
      {
        for (var se = arguments.length, be = new Array(se > 1 ? se - 1 : 0), Fe = 1; Fe < se; Fe++)
          be[Fe - 1] = arguments[Fe];
        O("error", k, be);
      }
    }
    function O(k, se, be) {
      {
        var Fe = b.ReactDebugCurrentFrame, ut = Fe.getStackAddendum();
        ut !== "" && (se += "%s", be = be.concat([ut]));
        var vt = be.map(function(Qe) {
          return String(Qe);
        });
        vt.unshift("Warning: " + se), Function.prototype.apply.call(console[k], console, vt);
      }
    }
    var B = !1, S = !1, C = !1, I = !1, G = !1, V;
    V = Symbol.for("react.module.reference");
    function w(k) {
      return !!(typeof k == "string" || typeof k == "function" || k === r || k === i || G || k === a || k === l || k === c || I || k === T || B || S || C || typeof k == "object" && k !== null && (k.$$typeof === E || k.$$typeof === f || k.$$typeof === o || k.$$typeof === s || k.$$typeof === u || k.$$typeof === V || k.getModuleId !== void 0));
    }
    function Y(k, se, be) {
      var Fe = k.displayName;
      if (Fe)
        return Fe;
      var ut = se.displayName || se.name || "";
      return ut !== "" ? be + "(" + ut + ")" : be;
    }
    function X(k) {
      return k.displayName || "Context";
    }
    function H(k) {
      if (k == null)
        return null;
      if (typeof k.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof k == "function")
        return k.displayName || k.name || null;
      if (typeof k == "string")
        return k;
      switch (k) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case l:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof k == "object")
        switch (k.$$typeof) {
          case s:
            var se = k;
            return X(se) + ".Consumer";
          case o:
            var be = k;
            return X(be._context) + ".Provider";
          case u:
            return Y(k, k.render, "ForwardRef");
          case f:
            var Fe = k.displayName || null;
            return Fe !== null ? Fe : H(k.type) || "Memo";
          case E: {
            var ut = k, vt = ut._payload, Qe = ut._init;
            try {
              return H(Qe(vt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var $ = Object.assign, L = 0, Q, j, ee, J, z, _, D;
    function he() {
    }
    he.__reactDisabledLog = !0;
    function oe() {
      {
        if (L === 0) {
          Q = console.log, j = console.info, ee = console.warn, J = console.error, z = console.group, _ = console.groupCollapsed, D = console.groupEnd;
          var k = {
            configurable: !0,
            enumerable: !0,
            value: he,
            writable: !0
          };
          Object.defineProperties(console, {
            info: k,
            log: k,
            warn: k,
            error: k,
            group: k,
            groupCollapsed: k,
            groupEnd: k
          });
        }
        L++;
      }
    }
    function ve() {
      {
        if (L--, L === 0) {
          var k = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: $({}, k, {
              value: Q
            }),
            info: $({}, k, {
              value: j
            }),
            warn: $({}, k, {
              value: ee
            }),
            error: $({}, k, {
              value: J
            }),
            group: $({}, k, {
              value: z
            }),
            groupCollapsed: $({}, k, {
              value: _
            }),
            groupEnd: $({}, k, {
              value: D
            })
          });
        }
        L < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var le = b.ReactCurrentDispatcher, Ce;
    function _e(k, se, be) {
      {
        if (Ce === void 0)
          try {
            throw Error();
          } catch (ut) {
            var Fe = ut.stack.trim().match(/\n( *(at )?)/);
            Ce = Fe && Fe[1] || "";
          }
        return `
` + Ce + k;
      }
    }
    var ge = !1, ye;
    {
      var ze = typeof WeakMap == "function" ? WeakMap : Map;
      ye = new ze();
    }
    function ce(k, se) {
      if (!k || ge)
        return "";
      {
        var be = ye.get(k);
        if (be !== void 0)
          return be;
      }
      var Fe;
      ge = !0;
      var ut = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var vt;
      vt = le.current, le.current = null, oe();
      try {
        if (se) {
          var Qe = function() {
            throw Error();
          };
          if (Object.defineProperty(Qe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Qe, []);
            } catch (Qn) {
              Fe = Qn;
            }
            Reflect.construct(k, [], Qe);
          } else {
            try {
              Qe.call();
            } catch (Qn) {
              Fe = Qn;
            }
            k.call(Qe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Qn) {
            Fe = Qn;
          }
          k();
        }
      } catch (Qn) {
        if (Qn && Fe && typeof Qn.stack == "string") {
          for (var We = Qn.stack.split(`
`), Xt = Fe.stack.split(`
`), Ht = We.length - 1, Ut = Xt.length - 1; Ht >= 1 && Ut >= 0 && We[Ht] !== Xt[Ut]; )
            Ut--;
          for (; Ht >= 1 && Ut >= 0; Ht--, Ut--)
            if (We[Ht] !== Xt[Ut]) {
              if (Ht !== 1 || Ut !== 1)
                do
                  if (Ht--, Ut--, Ut < 0 || We[Ht] !== Xt[Ut]) {
                    var vn = `
` + We[Ht].replace(" at new ", " at ");
                    return k.displayName && vn.includes("<anonymous>") && (vn = vn.replace("<anonymous>", k.displayName)), typeof k == "function" && ye.set(k, vn), vn;
                  }
                while (Ht >= 1 && Ut >= 0);
              break;
            }
        }
      } finally {
        ge = !1, le.current = vt, ve(), Error.prepareStackTrace = ut;
      }
      var Ur = k ? k.displayName || k.name : "", yi = Ur ? _e(Ur) : "";
      return typeof k == "function" && ye.set(k, yi), yi;
    }
    function Dt(k, se, be) {
      return ce(k, !1);
    }
    function Se(k) {
      var se = k.prototype;
      return !!(se && se.isReactComponent);
    }
    function Gt(k, se, be) {
      if (k == null)
        return "";
      if (typeof k == "function")
        return ce(k, Se(k));
      if (typeof k == "string")
        return _e(k);
      switch (k) {
        case l:
          return _e("Suspense");
        case c:
          return _e("SuspenseList");
      }
      if (typeof k == "object")
        switch (k.$$typeof) {
          case u:
            return Dt(k.render);
          case f:
            return Gt(k.type, se, be);
          case E: {
            var Fe = k, ut = Fe._payload, vt = Fe._init;
            try {
              return Gt(vt(ut), se, be);
            } catch {
            }
          }
        }
      return "";
    }
    var on = Object.prototype.hasOwnProperty, kn = {}, Pn = b.ReactDebugCurrentFrame;
    function Wn(k) {
      if (k) {
        var se = k._owner, be = Gt(k.type, k._source, se ? se.type : null);
        Pn.setExtraStackFrame(be);
      } else
        Pn.setExtraStackFrame(null);
    }
    function cr(k, se, be, Fe, ut) {
      {
        var vt = Function.call.bind(on);
        for (var Qe in k)
          if (vt(k, Qe)) {
            var We = void 0;
            try {
              if (typeof k[Qe] != "function") {
                var Xt = Error((Fe || "React class") + ": " + be + " type `" + Qe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof k[Qe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Xt.name = "Invariant Violation", Xt;
              }
              We = k[Qe](se, Qe, Fe, be, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ht) {
              We = Ht;
            }
            We && !(We instanceof Error) && (Wn(ut), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Fe || "React class", be, Qe, typeof We), Wn(null)), We instanceof Error && !(We.message in kn) && (kn[We.message] = !0, Wn(ut), y("Failed %s type: %s", be, We.message), Wn(null));
          }
      }
    }
    var qn = Array.isArray;
    function sn(k) {
      return qn(k);
    }
    function vr(k) {
      {
        var se = typeof Symbol == "function" && Symbol.toStringTag, be = se && k[Symbol.toStringTag] || k.constructor.name || "Object";
        return be;
      }
    }
    function Ar(k) {
      try {
        return hn(k), !1;
      } catch {
        return !0;
      }
    }
    function hn(k) {
      return "" + k;
    }
    function Tn(k) {
      if (Ar(k))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", vr(k)), hn(k);
    }
    var Dn = b.ReactCurrentOwner, Z = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ee, ke, je;
    je = {};
    function qt(k) {
      if (on.call(k, "ref")) {
        var se = Object.getOwnPropertyDescriptor(k, "ref").get;
        if (se && se.isReactWarning)
          return !1;
      }
      return k.ref !== void 0;
    }
    function Bn(k) {
      if (on.call(k, "key")) {
        var se = Object.getOwnPropertyDescriptor(k, "key").get;
        if (se && se.isReactWarning)
          return !1;
      }
      return k.key !== void 0;
    }
    function at(k, se) {
      if (typeof k.ref == "string" && Dn.current && se && Dn.current.stateNode !== se) {
        var be = H(Dn.current.type);
        je[be] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', H(Dn.current.type), k.ref), je[be] = !0);
      }
    }
    function $t(k, se) {
      {
        var be = function() {
          Ee || (Ee = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", se));
        };
        be.isReactWarning = !0, Object.defineProperty(k, "key", {
          get: be,
          configurable: !0
        });
      }
    }
    function Fn(k, se) {
      {
        var be = function() {
          ke || (ke = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", se));
        };
        be.isReactWarning = !0, Object.defineProperty(k, "ref", {
          get: be,
          configurable: !0
        });
      }
    }
    var Ln = function(k, se, be, Fe, ut, vt, Qe) {
      var We = {
        $$typeof: t,
        type: k,
        key: se,
        ref: be,
        props: Qe,
        _owner: vt
      };
      return We._store = {}, Object.defineProperty(We._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(We, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Fe
      }), Object.defineProperty(We, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ut
      }), Object.freeze && (Object.freeze(We.props), Object.freeze(We)), We;
    };
    function Ct(k, se, be, Fe, ut) {
      {
        var vt, Qe = {}, We = null, Xt = null;
        be !== void 0 && (Tn(be), We = "" + be), Bn(se) && (Tn(se.key), We = "" + se.key), qt(se) && (Xt = se.ref, at(se, ut));
        for (vt in se)
          on.call(se, vt) && !Z.hasOwnProperty(vt) && (Qe[vt] = se[vt]);
        if (k && k.defaultProps) {
          var Ht = k.defaultProps;
          for (vt in Ht)
            Qe[vt] === void 0 && (Qe[vt] = Ht[vt]);
        }
        if (We || Xt) {
          var Ut = typeof k == "function" ? k.displayName || k.name || "Unknown" : k;
          We && $t(Qe, Ut), Xt && Fn(Qe, Ut);
        }
        return Ln(k, We, Xt, ut, Fe, Dn.current, Qe);
      }
    }
    var Xn = b.ReactCurrentOwner, un = b.ReactDebugCurrentFrame;
    function Hr(k) {
      if (k) {
        var se = k._owner, be = Gt(k.type, k._source, se ? se.type : null);
        un.setExtraStackFrame(be);
      } else
        un.setExtraStackFrame(null);
    }
    var Ci;
    Ci = !1;
    function _i(k) {
      return typeof k == "object" && k !== null && k.$$typeof === t;
    }
    function _1() {
      {
        if (Xn.current) {
          var k = H(Xn.current.type);
          if (k)
            return `

Check the render method of \`` + k + "`.";
        }
        return "";
      }
    }
    function cs(k) {
      {
        if (k !== void 0) {
          var se = k.fileName.replace(/^.*[\\\/]/, ""), be = k.lineNumber;
          return `

Check your code at ` + se + ":" + be + ".";
        }
        return "";
      }
    }
    var b1 = {};
    function fs(k) {
      {
        var se = _1();
        if (!se) {
          var be = typeof k == "string" ? k : k.displayName || k.name;
          be && (se = `

Check the top-level render call using <` + be + ">.");
        }
        return se;
      }
    }
    function y1(k, se) {
      {
        if (!k._store || k._store.validated || k.key != null)
          return;
        k._store.validated = !0;
        var be = fs(se);
        if (b1[be])
          return;
        b1[be] = !0;
        var Fe = "";
        k && k._owner && k._owner !== Xn.current && (Fe = " It was passed a child from " + H(k._owner.type) + "."), Hr(k), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', be, Fe), Hr(null);
      }
    }
    function D1(k, se) {
      {
        if (typeof k != "object")
          return;
        if (sn(k))
          for (var be = 0; be < k.length; be++) {
            var Fe = k[be];
            _i(Fe) && y1(Fe, se);
          }
        else if (_i(k))
          k._store && (k._store.validated = !0);
        else if (k) {
          var ut = v(k);
          if (typeof ut == "function" && ut !== k.entries)
            for (var vt = ut.call(k), Qe; !(Qe = vt.next()).done; )
              _i(Qe.value) && y1(Qe.value, se);
        }
      }
    }
    function hs(k) {
      {
        var se = k.type;
        if (se == null || typeof se == "string")
          return;
        var be;
        if (typeof se == "function")
          be = se.propTypes;
        else if (typeof se == "object" && (se.$$typeof === u || se.$$typeof === f))
          be = se.propTypes;
        else
          return;
        if (be) {
          var Fe = H(se);
          cr(be, k.props, "prop", Fe, k);
        } else if (se.PropTypes !== void 0 && !Ci) {
          Ci = !0;
          var ut = H(se);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ut || "Unknown");
        }
        typeof se.getDefaultProps == "function" && !se.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ds(k) {
      {
        for (var se = Object.keys(k.props), be = 0; be < se.length; be++) {
          var Fe = se[be];
          if (Fe !== "children" && Fe !== "key") {
            Hr(k), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Fe), Hr(null);
            break;
          }
        }
        k.ref !== null && (Hr(k), y("Invalid attribute `ref` supplied to `React.Fragment`."), Hr(null));
      }
    }
    function bi(k, se, be, Fe, ut, vt) {
      {
        var Qe = w(k);
        if (!Qe) {
          var We = "";
          (k === void 0 || typeof k == "object" && k !== null && Object.keys(k).length === 0) && (We += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Xt = cs(ut);
          Xt ? We += Xt : We += _1();
          var Ht;
          k === null ? Ht = "null" : sn(k) ? Ht = "array" : k !== void 0 && k.$$typeof === t ? (Ht = "<" + (H(k.type) || "Unknown") + " />", We = " Did you accidentally export a JSX literal instead of a component?") : Ht = typeof k, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ht, We);
        }
        var Ut = Ct(k, se, be, ut, vt);
        if (Ut == null)
          return Ut;
        if (Qe) {
          var vn = se.children;
          if (vn !== void 0)
            if (Fe)
              if (sn(vn)) {
                for (var Ur = 0; Ur < vn.length; Ur++)
                  D1(vn[Ur], k);
                Object.freeze && Object.freeze(vn);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              D1(vn, k);
        }
        return k === r ? ds(Ut) : hs(Ut), Ut;
      }
    }
    function S1(k, se, be) {
      return bi(k, se, be, !0);
    }
    function ms(k, se, be) {
      return bi(k, se, be, !1);
    }
    var ps = ms, gs = S1;
    Mi.Fragment = r, Mi.jsx = ps, Mi.jsxs = gs;
  }()), Mi;
}
(function(e) {
  ({}).NODE_ENV === "production" ? e.exports = Ey() : e.exports = Ty();
})(Yo);
const ri = Yo.exports.Fragment, me = Yo.exports.jsx, Rt = Yo.exports.jsxs, vy = ({
  avatar: e,
  ...t
}) => /* @__PURE__ */ me(K5, {
  ...t,
  css: {
    backgroundImage: `url(${e})`,
    ...t.css
  }
}), ea = Object.assign(vy, {
  Container: K5
}), Nc = Lt(Pt.ASSISTANT_INFO), wc = Me(Nc("h2", "title"), {
  ...X9,
  width: "100%",
  margin: 0,
  typo: { size: 20, weight: "$2", height: "$3" },
  color: "$black"
}), W5 = Me(Nc("p", "description"), {
  display: "-webkit-box",
  margin: 0,
  typo: {},
  color: "$darkGrey",
  "-webkit-line-clamp": 2,
  "-webkit-box-orient": "vertical",
  overflow: "hidden",
  wordBreak: "break-word"
}), q5 = Me(Nc("div"), {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "48px 32px",
  textAlign: "center",
  [`& ${ea.Container}`]: {
    marginBottom: "$4"
  },
  [`& ${wc}`]: {
    marginBottom: 8
  }
}), Ay = ({
  title: e,
  description: t,
  avatar: n
}) => /* @__PURE__ */ Rt(q5, {
  children: [/* @__PURE__ */ me(ea, {
    size: "large",
    avatar: n
  }), /* @__PURE__ */ me(wc, {
    children: e
  }), /* @__PURE__ */ me(W5, {
    children: t
  })]
}), X5 = Object.assign(Ay, {
  Container: q5,
  Title: wc,
  Description: W5
}), Cy = (e) => /* @__PURE__ */ Xe.createElement("svg", {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ...e
}, /* @__PURE__ */ Xe.createElement("path", {
  id: "vf-close",
  d: "M13.748 3.32a.773.773 0 0 0-1.093-1.094l-4.389 4.39a.363.363 0 0 1-.514 0L3.368 2.23a.779.779 0 0 0-1.101 0l-.039.038a.779.779 0 0 0 0 1.101l4.385 4.385a.363.363 0 0 1 0 .514l-4.37 4.37a.773.773 0 1 0 1.092 1.093l4.37-4.37a.363.363 0 0 1 .514 0l4.413 4.412a.779.779 0 0 0 1.101 0l.039-.038a.779.779 0 0 0 0-1.101L9.359 8.222a.363.363 0 0 1 0-.514l4.389-4.389z",
  fill: "currentColor"
})), _y = (e) => /* @__PURE__ */ Xe.createElement("svg", {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ...e
}, /* @__PURE__ */ Xe.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ Xe.createElement("path", {
  fill: "currentColor",
  d: "M14.25 7.281a.75.75 0 0 1 0 1.5H3.38l2.474 2.77a.75.75 0 1 1-1.152.96l-3.5-4a.75.75 0 0 1 0-.96l3.5-4a.75.75 0 0 1 1.152.96L3.38 7.282H14.25z"
}))), by = (e) => /* @__PURE__ */ Xe.createElement("svg", {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ...e
}, /* @__PURE__ */ Xe.createElement("g", {
  id: "vf-minus",
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ Xe.createElement("path", {
  d: "M15 8a.84.84 0 0 1-.84.84H1.84a.84.84 0 0 1 0-1.68h12.32A.84.84 0 0 1 15 8z",
  fill: "currentColor"
}))), yy = (e) => /* @__PURE__ */ Xe.createElement("svg", {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ...e
}, /* @__PURE__ */ Xe.createElement("defs", null, /* @__PURE__ */ Xe.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-1"
}, /* @__PURE__ */ Xe.createElement("stop", {
  stopColor: "currentColor",
  stopOpacity: 0.85,
  offset: "0%"
}), /* @__PURE__ */ Xe.createElement("stop", {
  stopColor: "currentColor",
  offset: "100%"
})), /* @__PURE__ */ Xe.createElement("path", {
  d: "M8.50003057,3.75 C8.50003057,3.335786 8.16424057,3 7.75003057,3 C7.33582057,3 7.00003057,3.335786 7.00003057,3.75 L7.00003057,10.64873 L5.23016057,9.17384 C4.91194957,8.90866 4.43902557,8.95166 4.17385257,9.26987 C3.90867987,9.58807 3.95167287,10.061 4.26988057,10.32617 L7.26988057,12.82617 C7.54801057,13.0579 7.95202057,13.0579 8.23016057,12.82617 L11.2301606,10.32617 C11.5483606,10.061 11.5913606,9.58807 11.3261806,9.26987 C11.0610106,8.95166 10.5880906,8.90866 10.2698806,9.17384 L8.50003057,10.64871 L8.50003057,3.75 Z",
  id: "path-2"
})), /* @__PURE__ */ Xe.createElement("g", {
  id: "vf-arrow-up",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ Xe.createElement("g", {
  id: "Path",
  transform: "translate(7.750018, 7.999984) rotate(180.000000) translate(-7.750018, -7.999984) "
}, /* @__PURE__ */ Xe.createElement("use", {
  fill: "currentColor",
  xlinkHref: "#path-2"
}), /* @__PURE__ */ Xe.createElement("use", {
  fillOpacity: 0.85,
  fill: "url(#linearGradient-1)",
  xlinkHref: "#path-2"
})))), ql = (e) => /* @__PURE__ */ Xe.createElement("svg", {
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e
}, /* @__PURE__ */ Xe.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.29398 20.4966C4.56534 20.4966 4 19.8827 4 19.1539V12.3847C4 11.6559 4.56534 11.042 5.29398 11.042H8.12364L10.8534 4.92738C10.9558 4.69809 11.1677 4.54023 11.4114 4.50434L11.5175 4.49658C12.3273 4.49658 13.0978 4.85402 13.6571 5.48039C14.2015 6.09009 14.5034 6.90649 14.5034 7.7535L14.5027 8.92295L18.1434 8.92346C18.6445 8.92346 19.1173 9.13931 19.4618 9.51188L19.5612 9.62829C19.8955 10.0523 20.0479 10.6054 19.9868 11.1531L19.1398 18.742C19.0297 19.7286 18.2529 20.4966 17.2964 20.4966H8.69422H5.29398ZM11.9545 6.02658L9.41727 11.7111L9.42149 11.7693L9.42091 19.042H17.2964C17.4587 19.042 17.6222 18.8982 17.6784 18.6701L17.6942 18.5807L18.5412 10.9918C18.5604 10.8194 18.5134 10.6486 18.4189 10.5287C18.3398 10.4284 18.2401 10.378 18.1434 10.378H13.7761C13.3745 10.378 13.0488 10.0524 13.0488 9.65073V7.7535C13.0488 7.2587 12.8749 6.78825 12.5721 6.44915C12.4281 6.28794 12.2615 6.16343 12.0824 6.07923L11.9545 6.02658ZM7.96636 12.4966H5.45455V19.042H7.96636V12.4966Z",
  fill: "white"
}), /* @__PURE__ */ Xe.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.29398 20.4966C4.56534 20.4966 4 19.8827 4 19.1539V12.3847C4 11.6559 4.56534 11.042 5.29398 11.042H8.12364L10.8534 4.92738C10.9558 4.69809 11.1677 4.54023 11.4114 4.50434L11.5175 4.49658C12.3273 4.49658 13.0978 4.85402 13.6571 5.48039C14.2015 6.09009 14.5034 6.90649 14.5034 7.7535L14.5027 8.92295L18.1434 8.92346C18.6445 8.92346 19.1173 9.13931 19.4618 9.51188L19.5612 9.62829C19.8955 10.0523 20.0479 10.6054 19.9868 11.1531L19.1398 18.742C19.0297 19.7286 18.2529 20.4966 17.2964 20.4966H8.69422H5.29398ZM11.9545 6.02658L9.41727 11.7111L9.42149 11.7693L9.42091 19.042H17.2964C17.4587 19.042 17.6222 18.8982 17.6784 18.6701L17.6942 18.5807L18.5412 10.9918C18.5604 10.8194 18.5134 10.6486 18.4189 10.5287C18.3398 10.4284 18.2401 10.378 18.1434 10.378H13.7761C13.3745 10.378 13.0488 10.0524 13.0488 9.65073V7.7535C13.0488 7.2587 12.8749 6.78825 12.5721 6.44915C12.4281 6.28794 12.2615 6.16343 12.0824 6.07923L11.9545 6.02658ZM7.96636 12.4966H5.45455V19.042H7.96636V12.4966Z",
  fill: "currentColor"
})), Q5 = (e) => /* @__PURE__ */ Xe.createElement("svg", {
  width: "16px",
  height: "8px",
  viewBox: "0 0 16.0 8.0",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ...e
}, /* @__PURE__ */ Xe.createElement("defs", null, /* @__PURE__ */ Xe.createElement("clipPath", {
  id: "i0"
}, /* @__PURE__ */ Xe.createElement("path", {
  d: "M9.3912777,0.590799928 L11.8266759,3.22760605 C12.8648163,4.35160464 14.3915663,5 16,5 L0,5 C0.0295978076,5 0.0591679461,4.99978044 0.0887078805,4.99934241 C1.66434944,4.97597796 3.15405745,4.33102228 4.17311097,3.22783933 L6.60912844,0.590718281 C7.33672461,-0.196938863 8.66373617,-0.196900538 9.3912777,0.590799928 Z"
})), /* @__PURE__ */ Xe.createElement("clipPath", {
  id: "i1"
}, /* @__PURE__ */ Xe.createElement("path", {
  d: "M17,-1.99999948 L17,7 L-1,7 L-1,-1.99999948 L17,-1.99999948 Z M9.3912777,0.590799928 C8.66373617,-0.196900538 7.33672461,-0.196938863 6.60912844,0.590718281 L4.17311097,3.22783933 C3.15405745,4.33102228 1.66434944,4.97597796 0.0887078805,4.99934241 C0.0591679461,4.99978044 0.0295978076,5 0,5 L16,5 C14.3915663,5 12.8648163,4.35160464 11.8266759,3.22760605 Z"
})), /* @__PURE__ */ Xe.createElement("clipPath", {
  id: "i2"
}, /* @__PURE__ */ Xe.createElement("path", {
  d: "M16,0 L16,2 L0,2 L0,0 L16,0 Z"
}))), /* @__PURE__ */ Xe.createElement("g", {
  transform: "translate(-239.0 1.0)"
}, /* @__PURE__ */ Xe.createElement("g", {
  transform: "translate(239.0 0.0)"
}, /* @__PURE__ */ Xe.createElement("g", {
  clipPath: "url(#i0)"
}, /* @__PURE__ */ Xe.createElement("polygon", {
  points: "0,1.11022302e-16 16,1.11022302e-16 16,5 0,5 0,1.11022302e-16",
  stroke: "none",
  fill: "#FFFFFF"
})), /* @__PURE__ */ Xe.createElement("g", {
  clipPath: "url(#i1)"
}, /* @__PURE__ */ Xe.createElement("path", {
  d: "M16,5 L0,5 C0.0295978076,5 0.0591679461,4.99978044 0.0887078805,4.99934241 C1.66434944,4.97597796 3.15405745,4.33102228 4.17311097,3.22783933 L6.60912844,0.590718281 C7.33672461,-0.196938863 8.66373617,-0.196900538 9.3912777,0.590799928 L11.8266759,3.22760605 C12.8648163,4.35160464 14.3915663,5 16,5 Z",
  stroke: "#DFDFDF",
  strokeWidth: 2,
  fill: "none",
  strokeMiterlimit: 5
})), /* @__PURE__ */ Xe.createElement("g", {
  transform: "translate(0.0 5.0)"
}, /* @__PURE__ */ Xe.createElement("g", {
  clipPath: "url(#i2)"
}, /* @__PURE__ */ Xe.createElement("polygon", {
  points: "0,0 16,0 16,2 0,2 0,0",
  stroke: "none",
  fill: "#FFFFFF"
})))))), Dy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  close: Cy,
  largeArrowLeft: _y,
  minus: by,
  smallArrowUp: yy,
  thumbsUp: ql,
  topCaret: Q5
}, Symbol.toStringTag, { value: "Module" })), Sy = Lt(Pt.ICON), Z5 = Me(Sy("div"), { display: "flex" }), Oy = ({
  svg: e,
  ...t
}) => {
  const n = typeof e == "string" ? Dy[e] : e;
  return /* @__PURE__ */ me(Z5, {
    ...t,
    children: /* @__PURE__ */ me(n, {})
  });
}, zn = Object.assign(Oy, {
  Frame: Z5
}), J5 = (e, t) => pn.forwardRef(({
  variant: n = t,
  ...r
}, a) => {
  const i = e[n];
  return i ? /* @__PURE__ */ me(i, {
    ...r,
    ref: a
  }) : null;
});
var Ca = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e))(Ca || {});
const Ic = Lt(Pt.BUTTON), ep = Me("button", {
  border: 0,
  padding: 0,
  "&:focus": {
    outline: 0
  },
  "&:hover": {
    cursor: "pointer"
  }
}), Rc = Me(Ic(ep), {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "0 14px",
  borderRadius: "$1",
  typo: { weight: "$2" },
  whiteSpace: "nowrap",
  overflowWrap: "anywhere"
}), tp = Me(Ic(Rc, Ca.PRIMARY), {
  height: "$md",
  color: "$white",
  trans: ["background-color"],
  variants: {
    type: {
      info: {
        backgroundColor: "$primary",
        "&:hover": {
          backgroundColor: "$darkPrimary"
        }
      },
      warn: {
        backgroundColor: "$warn",
        "&:hover": {
          backgroundColor: "$darkWarn"
        }
      },
      subtle: {
        color: "$black",
        backgroundColor: "inherit",
        trans: ["color"],
        "&:hover": {
          color: "#000"
        }
      }
    }
  },
  defaultVariants: {
    type: "info"
  }
}), np = Me(Ic(Rc, Ca.SECONDARY), {
  height: "$sm",
  border: "1px solid $fadedPrimary",
  color: "$primary",
  backgroundColor: "$white",
  boxShadow: "0 1px 2px $shadow2",
  trans: ["border-color"],
  "&:hover": {
    borderColor: "$primary"
  }
}), Ny = {
  [Ca.PRIMARY]: tp,
  [Ca.SECONDARY]: np
}, wy = J5(Ny, Ca.PRIMARY), Vn = Object.assign(wy, {
  Variant: Ca,
  Reset: ep,
  Container: Rc,
  Primary: tp,
  Secondary: np
}), Iy = Lt(Pt.BUBBLE), rp = Me(Iy(Vn.Reset), {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "$round",
  backgroundColor: "$primary",
  trans: ["background-color", "box-shadow"],
  "&:hover": {
    backgroundColor: "$darkPrimary"
  },
  variants: {
    size: {
      small: {
        height: "$xs",
        width: "$xs",
        [`& ${zn.Frame}`]: {
          width: "$xxs",
          height: "$xxs"
        }
      },
      large: {
        height: "$xl",
        width: "$xl",
        border: "1px solid $shadow4",
        boxShadow: "0 1px 6px $shadow6, 0 2px 24px $shadow8",
        [`& ${zn.Frame}`]: {
          width: "$sm",
          height: "$sm"
        }
      }
    }
  },
  defaultVariants: {
    size: "large"
  }
}), Ry = ({
  svg: e,
  color: t,
  ...n
}) => /* @__PURE__ */ me(rp, {
  ...n,
  children: /* @__PURE__ */ me(zn, {
    svg: e,
    css: {
      color: t,
      ...n.css
    }
  })
}), Xl = Object.assign(Ry, {
  Container: rp
}), ap = Lt(Pt.IMAGE), ip = Me(ap("img"), {
  width: 248,
  variants: {
    isRounded: {
      true: {
        borderRadius: "$1"
      }
    }
  },
  defaultVariants: {
    isRounded: !0
  }
}), My = ({
  image: e,
  ...t
}) => /* @__PURE__ */ me(ip, {
  ...t,
  src: e || void 0
}), yh = Object.assign(My, {
  Base: ip
}), op = Me(ap("div", "background"), {
  height: 200,
  width: 248,
  backgroundColor: "$lightGrey",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover"
}), xy = ({
  image: e,
  ...t
}) => e ? /* @__PURE__ */ me(op, {
  ...t,
  css: {
    backgroundImage: `url('${e}')`,
    ...t.css
  }
}) : null, ky = Object.assign(xy, {
  Base: op
}), Mc = Object.assign(yh, {
  Default: yh,
  Background: ky
}), xc = V9({
  scrollToBottom: () => {
  }
}), {
  Consumer: mF
} = xc, Py = ({
  target: e,
  children: t
}) => {
  const n = pa(() => {
    requestAnimationFrame(() => {
      const a = e.current;
      if (!a)
        return;
      const {
        scrollTop: i,
        scrollHeight: o,
        clientHeight: s
      } = a, u = o - s;
      u !== i && a.scrollTo({
        top: u
      });
    });
  }, []), r = ii(() => ({
    scrollToBottom: n
  }), [n]);
  return /* @__PURE__ */ me(xc.Provider, {
    value: r,
    children: t
  });
}, Ko = V9({
  send: U0,
  setStatus: U0
}), By = ({
  children: e,
  ...t
}) => {
  const n = ii(() => t, []);
  return /* @__PURE__ */ me(Ko.Provider, {
    value: n,
    children: e
  });
}, sp = 246, g1 = Lt(Pt.CARD), up = Me(g1("section"), {
  display: "inline-flex",
  flexDirection: "column",
  width: sp,
  border: "1px solid #f1f1f1",
  borderRadius: "$2",
  boxSizing: "content-box",
  overflow: "hidden",
  backgroundColor: "$lightGrey",
  [`& ${Mc.Background.Base}`]: {
    height: 150
  },
  [`& ${Vn.Container}`]: {
    width: "100%",
    color: "$primary",
    backgroundColor: "$white",
    boxShadow: "0 5px 8px -8px $shadow12, 0 2px 4px -3px $shadow12, 0 0 0 1px $shadow3, 0 1px 3px 1px $shadow1",
    marginBottom: "$2",
    trans: ["color", "box-shadow"],
    "&:hover": {
      color: "$darkPrimary",
      backgroundColor: "$white",
      boxShadow: "0 5px 8px -8px $shadow12, 0 2px 4px -3px $shadow12, 0 0 0 1px $shadow4, 0 1px 4px 1px $shadow4"
    },
    "&:first-of-type": {
      marginTop: "$3"
    },
    "&:last-of-type": {
      marginBottom: 0
    }
  }
}), Fy = Me(g1("main", "content"), {
  padding: "$3"
}), Ly = Me(g1("h3", "header"), {
  margin: "0 0 $1 0",
  typo: { weight: "$2" },
  color: "$black"
}), $y = Me(g1("p", "description"), {
  margin: 0,
  typo: { size: "$1" },
  color: "$darkGrey",
  whiteSpace: "normal"
}), Hy = Me(g1("a", "link"), {
  margin: 0,
  typo: { size: "$1" },
  whiteSpace: "normal",
  overflow: "hidden",
  textOverflow: "ellipsis",
  color: "rgb(93, 157, 245)",
  textDecoration: "underline",
  pointerEvents: "all"
}), Uy = (e) => {
  let t;
  try {
    t = new URL(e);
  } catch {
    return !1;
  }
  return t.protocol === "http:" || t.protocol === "https:";
}, jy = ({
  title: e,
  description: t,
  image: n,
  actions: r = []
}) => {
  const a = xo(Ko), i = Uy(t);
  return /* @__PURE__ */ Rt(up, {
    children: [!!n && /* @__PURE__ */ me(Mc.Background, {
      image: n
    }), /* @__PURE__ */ Rt(Fy, {
      children: [/* @__PURE__ */ me(Ly, {
        children: e
      }), !i && /* @__PURE__ */ me($y, {
        children: t
      }), i && /* @__PURE__ */ me(Hy, {
        rel: "noopener noreferrer",
        href: t,
        target: "_blank",
        children: t
      }), r.map(({
        name: o,
        request: s
      }, u) => /* @__PURE__ */ me(Vn, {
        onClick: () => a.send(o, s),
        children: o
      }, u))]
    })]
  });
}, kc = Object.assign(jy, {
  Container: up
}), P1 = 42, Wo = 12, lp = Lt(Pt.CAROUSEL), zy = Me(lp("span", "button"), {
  position: "absolute",
  zIndex: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "$round",
  trans: ["background-color", "box-shadow", "opacity"],
  height: P1,
  width: P1,
  cursor: "pointer",
  backgroundColor: "$white",
  color: "$black",
  boxShadow: "0 1px 3px 1px $shadow1, 0 0 0 1px $shadow3, 0 2px 4px -3px $shadow12, 0 5px 8px -8px $shadow12",
  border: "none",
  [`& ${zn.Frame}`]: {
    height: "$xxs",
    width: "$xxs",
    color: "rgba(0,0,0,0.6)",
    trans: ["color"]
  },
  ["&:hover"]: {
    boxShadow: "0 1px 4px 1px $shadow4, 0 0 0 1px $shadow4, 0 2px 4px -3px $shadow12, 0 5px 8px -8px $shadow12"
  },
  ["&:active"]: {
    boxShadow: "0 1px 4px 1px $shadow8, 0 0 0 1px $shadow4, 0 2px 4px -3px $shadow12, 0 5px 8px -8px $shadow12"
  },
  [`
      &:hover ${zn.Frame},
      &:active ${zn.Frame}
    `]: {
    color: "rgba(0,0,0,0.8)"
  },
  variants: {
    visible: {
      true: {
        opacity: 1,
        pointerEvents: "auto"
      },
      false: {
        opacity: 0,
        pointerEvents: "none"
      }
    },
    alignment: {
      left: {
        left: 48 - P1 / 2
      },
      right: {
        right: 70 - P1 / 2,
        [`& ${zn.Frame}`]: {
          transform: "scaleX(-1)"
        }
      }
    }
  }
}), cp = Me(lp("div"), {
  display: "flex",
  whiteSpace: "nowrap",
  [`& ${kc.Container}`]: {
    height: "fit-content",
    flexShrink: 0,
    marginLeft: Wo,
    "&:first-of-type": {
      marginLeft: 0
    }
  }
}), Dh = G9(({
  onClick: e,
  alignment: t,
  visible: n,
  containerEl: r
}, a) => /* @__PURE__ */ me(zy, {
  ref: a,
  alignment: t,
  visible: n,
  css: {
    transform: `translateY(calc(${r.clientHeight / 2}px - 50%))`
  },
  onClick: e,
  children: /* @__PURE__ */ me(zn, {
    svg: "largeArrowLeft"
  })
})), Pc = sp + 2, fp = Pc / 3, Gy = Pc + Wo + fp, Ao = Pc + Wo, Sh = (e, t) => () => {
  const n = e == null ? void 0 : e.current;
  if (!n)
    return;
  const r = t(n);
  n.scrollTo({
    left: r && r * Ao,
    behavior: "smooth"
  });
}, Vy = (e, t, n) => {
  const [r, a] = En(!1), [i, o] = En(!1), s = Mr(null), u = Mr(null), l = n.length > 1;
  return Rr(() => {
    !(t != null && t.current) || !l || o(!0);
  }, []), Rr(() => {
    const c = e == null ? void 0 : e.current;
    if (!c || !l)
      return;
    const f = Ao * n.length - Wo, E = () => {
      const { scrollLeft: T } = c;
      a(T >= fp), o(T <= f - Gy);
    };
    return c.addEventListener("scroll", E), () => {
      c.removeEventListener("scroll", E);
    };
  }, []), {
    previousButtonRef: s,
    nextButtonRef: u,
    showPreviousButton: r,
    showNextButton: i
  };
}, Yy = ({
  cards: e,
  containerRef: t,
  controlsRef: n
}) => {
  const {
    previousButtonRef: r,
    nextButtonRef: a,
    showPreviousButton: i,
    showNextButton: o
  } = Vy(t, n, e), s = t == null ? void 0 : t.current, u = n == null ? void 0 : n.current, l = s && u, c = Sh(t, (E) => Math.ceil(E.scrollLeft / Ao) - 1), f = Sh(t, (E) => Math.floor(E.scrollLeft / Ao) + 1);
  return /* @__PURE__ */ Rt(ri, {
    children: [/* @__PURE__ */ me(cp, {
      children: e.map((E, T) => /* @__PURE__ */ Ac(kc, {
        ...E,
        key: T
      }))
    }), l && M8(/* @__PURE__ */ Rt(ri, {
      children: [/* @__PURE__ */ me(Dh, {
        ref: r,
        alignment: "left",
        visible: i,
        containerEl: s,
        onClick: c
      }), /* @__PURE__ */ me(Dh, {
        ref: a,
        alignment: "right",
        visible: o,
        containerEl: s,
        onClick: f
      })]
    }), u)]
  });
}, Ky = Object.assign(Yy, {
  Container: cp
}), hp = (e, t) => ({
  initialValue: n,
  ...r
}) => {
  var u, l;
  const a = En(n != null ? n : t == null ? void 0 : t.defaultValue), i = (l = (u = t == null ? void 0 : t.enrichProps) == null ? void 0 : u.call(t, r, a)) != null ? l : r, [o, s] = a;
  return /* @__PURE__ */ me(e, {
    ...i,
    value: o,
    onValueChange: s
  });
}, dp = (...e) => (...t) => e.forEach((n) => n == null ? void 0 : n(...t)), xi = () => {
}, Wy = Lt(Pt.INPUT), mp = {
  height: "$md",
  boxSizing: "border-box",
  border: "1px solid rgba(115,115,118,0.3)",
  borderRadius: "$1",
  backgroundColor: "$white",
  boxShadow: "0 1px 12px $shadow2",
  trans: ["border-color"]
}, pp = {
  border: "1px solid rgba(115,115,118,0.5)"
}, gp = Me(Wy("input"), {
  ...mp,
  padding: "0 $4",
  typo: {},
  color: "$black",
  "&:focus": {
    ...pp,
    outline: 0
  },
  "&::placeholder": {
    color: "$darkGrey"
  }
}), Oh = ({
  onValueChange: e,
  onChange: t,
  ...n
}) => {
  const r = dp(t, (a) => e(a.target.value));
  return /* @__PURE__ */ me(gp, {
    ...n,
    onChange: r
  });
}, Xi = Object.assign(Oh, {
  Controlled: hp(Oh, {
    defaultValue: ""
  }),
  Container: gp
}), Ep = Lt(Pt.CHAT_INPUT), Co = Me(Ep("label", "button"), {
  ...mp,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  width: "$md",
  cursor: "text",
  [`& ${Xl.Container}`]: {
    transform: "scale(0)",
    trans: ["background-color", "transform"]
  },
  variants: {
    withContent: {
      true: {
        [`& ${Xl.Container}`]: {
          transform: "scale(1)",
          cursor: "pointer"
        }
      }
    }
  }
}), Tp = Me(Ep("div"), {
  display: "flex",
  boxShadow: "0 1px 12px $shadow2",
  trans: ["border-color", "box-shadow"],
  [`& ${Xi.Container}`]: {
    margin: 0,
    borderRightWidth: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    paddingRight: 7,
    boxShadow: "none"
  },
  [`& ${Co}`]: {
    borderLeftWidth: 0,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  },
  [`& ${zn.Frame}`]: {
    color: "$white"
  },
  [`& ${Xi.Container}:focus`]: {
    borderRightWidth: 0
  },
  [`& ${Xi.Container}:focus + ${Co}`]: {
    ...pp,
    borderLeftWidth: 0
  }
}), Nh = ({
  id: e,
  onSend: t,
  ...n
}) => {
  var i;
  const r = (i = ii(() => `vf-chat-input--${mo()}`, [])) != null ? i : e;
  return /* @__PURE__ */ Rt(Tp, {
    children: [/* @__PURE__ */ me(Xi, {
      id: r,
      onKeyPress: (o) => {
        o.key === "Enter" && (o.preventDefault(), t == null || t());
      },
      ...n
    }), /* @__PURE__ */ me(Co, {
      htmlFor: r,
      withContent: !!n.value,
      children: /* @__PURE__ */ me(Xl, {
        size: "small",
        svg: "smallArrowUp",
        onClick: t
      })
    })]
  });
}, qy = Object.assign(Nh, {
  Controlled: hp(Nh, {
    defaultValue: "",
    enrichProps: (e, [, t]) => ({
      ...e,
      onSend: () => {
        var n;
        t(""), (n = e.onSend) == null || n.call(e);
      }
    })
  }),
  Container: Tp,
  ButtonContainer: Co
}), vp = Lt(Pt.FOOTER), Ap = Me(vp("footer"), {
  padding: "$3 $4 $4 $4",
  borderRadius: "$1",
  [`& ${Xi.Container}`]: {
    flex: 1
  },
  [`& ${Vn.Container}`]: {
    width: "100%"
  },
  variants: {
    withShadow: {
      true: {
        boxShadow: "0 12px 48px $shadow16"
      }
    },
    withWatermark: {
      true: {
        paddingBottom: "0"
      }
    }
  }
}), Cp = Me(vp("aside", "watermark"), {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px 0 $3 0",
  typo: { size: 12, height: "17px" },
  color: "$darkGrey",
  "& a": {
    marginLeft: "0.5ch",
    textDecoration: "none",
    color: "$blue",
    "&:focus": {
      outline: 0
    }
  }
}), Xy = ({
  withWatermark: e,
  hasEnded: t,
  onStart: n,
  onSend: r
}) => {
  const [a, i] = En("");
  return /* @__PURE__ */ Rt(Ap, {
    withShadow: !!t,
    withWatermark: e,
    children: [t ? /* @__PURE__ */ me(Vn, {
      onClick: n,
      children: "Start New Chat"
    }) : /* @__PURE__ */ me(qy, {
      value: a,
      placeholder: "Message\u2026",
      autoFocus: !0,
      onValueChange: i,
      onSend: () => {
        !a || (r == null || r(a), i(""));
      }
    }), e && /* @__PURE__ */ Rt(Cp, {
      children: ["Assistant \u26A1\uFE0F by", /* @__PURE__ */ me("a", {
        target: "_blank",
        href: "https://voiceflow.com",
        rel: "noreferrer",
        children: "Voiceflow"
      })]
    })]
  });
}, _p = Object.assign(Xy, {
  Container: Ap,
  Watermark: Cp
}), Bc = Lt(Pt.HEADER), Fc = Me(Bc("h1", "title"), {
  ...X9,
  typo: { size: 17, weight: "$2", height: "$2" },
  color: "rgba(255,255,255,0.95)"
}), bp = Me(Bc(Vn.Reset, "button"), {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: 32,
  width: 32,
  marginLeft: 8,
  borderRadius: 6,
  background: "none",
  trans: ["background-color"],
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.16)",
    [`& ${zn.Frame}`]: {
      color: "$white"
    }
  },
  [`& ${zn.Frame}`]: {
    height: "$xxs",
    width: "$xxs",
    color: "rgba(255,255,255,0.8)",
    trans: ["color"]
  }
}), yp = Me(Bc("header"), {
  display: "flex",
  flexShrink: 0,
  alignItems: "center",
  height: "$lg",
  padding: "0 $4 0 $5",
  backgroundColor: "$primary",
  boxShadow: "0 1px 2px $shadow16",
  [`& ${ea.Container}`]: {
    height: 32,
    width: 32
  },
  [`& ${Fc}`]: {
    flex: 1,
    margin: "0 0 0 14px"
  }
}), Qy = ({
  title: e,
  image: t,
  actions: n = []
}) => /* @__PURE__ */ Rt(yp, {
  children: [/* @__PURE__ */ me(ea, {
    avatar: t
  }), /* @__PURE__ */ me(Fc, {
    children: e
  }), n.map(({
    svg: r,
    onClick: a
  }, i) => /* @__PURE__ */ me(bp, {
    onClick: a,
    children: /* @__PURE__ */ me(zn, {
      svg: r
    })
  }, i))]
}), Dp = Object.assign(Qy, {
  Container: yp,
  Title: Fc,
  Button: bp
}), wh = 32, Zy = 1e3, Jy = Lt(Pt.LOADER), Sp = Me(Jy("div"), {
  height: wh,
  width: wh,
  borderWidth: "2px",
  borderStyle: "solid",
  borderRadius: "$round",
  borderColor: "#f0f0f0",
  borderTopColor: "#000",
  animation: `${uv} ${Zy}ms linear`,
  animationIterationCount: "infinite"
}), eD = Lt(Pt.PROMPT), Op = Me(eD("div"), {
  padding: "$4 $4 $3 $4",
  borderRadius: "$1",
  backgroundColor: "$white",
  boxShadow: "0 12px 48px 4px $shadow12",
  [`& ${Vn.Container}`]: {
    width: "100%",
    marginTop: "$1",
    "&:first-of-type": {
      marginTop: 0
    }
  }
}), tD = ({
  accept: e,
  cancel: t
}) => /* @__PURE__ */ Rt(Op, {
  children: [/* @__PURE__ */ me(Vn.Primary, {
    tabIndex: -1,
    ...e,
    children: e.label
  }), /* @__PURE__ */ me(Vn, {
    type: "subtle",
    tabIndex: -1,
    ...t,
    children: t.label
  })]
}), no = Object.assign(tD, {
  Container: Op
});
var Np = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ft, function() {
    var n = 1e3, r = 6e4, a = 36e5, i = "millisecond", o = "second", s = "minute", u = "hour", l = "day", c = "week", f = "month", E = "quarter", T = "year", g = "date", m = "Invalid Date", v = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, b = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, y = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, O = function(H, $, L) {
      var Q = String(H);
      return !Q || Q.length >= $ ? H : "" + Array($ + 1 - Q.length).join(L) + H;
    }, B = { s: O, z: function(H) {
      var $ = -H.utcOffset(), L = Math.abs($), Q = Math.floor(L / 60), j = L % 60;
      return ($ <= 0 ? "+" : "-") + O(Q, 2, "0") + ":" + O(j, 2, "0");
    }, m: function H($, L) {
      if ($.date() < L.date())
        return -H(L, $);
      var Q = 12 * (L.year() - $.year()) + (L.month() - $.month()), j = $.clone().add(Q, f), ee = L - j < 0, J = $.clone().add(Q + (ee ? -1 : 1), f);
      return +(-(Q + (L - j) / (ee ? j - J : J - j)) || 0);
    }, a: function(H) {
      return H < 0 ? Math.ceil(H) || 0 : Math.floor(H);
    }, p: function(H) {
      return { M: f, y: T, w: c, d: l, D: g, h: u, m: s, s: o, ms: i, Q: E }[H] || String(H || "").toLowerCase().replace(/s$/, "");
    }, u: function(H) {
      return H === void 0;
    } }, S = "en", C = {};
    C[S] = y;
    var I = function(H) {
      return H instanceof Y;
    }, G = function H($, L, Q) {
      var j;
      if (!$)
        return S;
      if (typeof $ == "string") {
        var ee = $.toLowerCase();
        C[ee] && (j = ee), L && (C[ee] = L, j = ee);
        var J = $.split("-");
        if (!j && J.length > 1)
          return H(J[0]);
      } else {
        var z = $.name;
        C[z] = $, j = z;
      }
      return !Q && j && (S = j), j || !Q && S;
    }, V = function(H, $) {
      if (I(H))
        return H.clone();
      var L = typeof $ == "object" ? $ : {};
      return L.date = H, L.args = arguments, new Y(L);
    }, w = B;
    w.l = G, w.i = I, w.w = function(H, $) {
      return V(H, { locale: $.$L, utc: $.$u, x: $.$x, $offset: $.$offset });
    };
    var Y = function() {
      function H(L) {
        this.$L = G(L.locale, null, !0), this.parse(L);
      }
      var $ = H.prototype;
      return $.parse = function(L) {
        this.$d = function(Q) {
          var j = Q.date, ee = Q.utc;
          if (j === null)
            return new Date(NaN);
          if (w.u(j))
            return new Date();
          if (j instanceof Date)
            return new Date(j);
          if (typeof j == "string" && !/Z$/i.test(j)) {
            var J = j.match(v);
            if (J) {
              var z = J[2] - 1 || 0, _ = (J[7] || "0").substring(0, 3);
              return ee ? new Date(Date.UTC(J[1], z, J[3] || 1, J[4] || 0, J[5] || 0, J[6] || 0, _)) : new Date(J[1], z, J[3] || 1, J[4] || 0, J[5] || 0, J[6] || 0, _);
            }
          }
          return new Date(j);
        }(L), this.$x = L.x || {}, this.init();
      }, $.init = function() {
        var L = this.$d;
        this.$y = L.getFullYear(), this.$M = L.getMonth(), this.$D = L.getDate(), this.$W = L.getDay(), this.$H = L.getHours(), this.$m = L.getMinutes(), this.$s = L.getSeconds(), this.$ms = L.getMilliseconds();
      }, $.$utils = function() {
        return w;
      }, $.isValid = function() {
        return this.$d.toString() !== m;
      }, $.isSame = function(L, Q) {
        var j = V(L);
        return this.startOf(Q) <= j && j <= this.endOf(Q);
      }, $.isAfter = function(L, Q) {
        return V(L) < this.startOf(Q);
      }, $.isBefore = function(L, Q) {
        return this.endOf(Q) < V(L);
      }, $.$g = function(L, Q, j) {
        return w.u(L) ? this[Q] : this.set(j, L);
      }, $.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, $.valueOf = function() {
        return this.$d.getTime();
      }, $.startOf = function(L, Q) {
        var j = this, ee = !!w.u(Q) || Q, J = w.p(L), z = function(_e, ge) {
          var ye = w.w(j.$u ? Date.UTC(j.$y, ge, _e) : new Date(j.$y, ge, _e), j);
          return ee ? ye : ye.endOf(l);
        }, _ = function(_e, ge) {
          return w.w(j.toDate()[_e].apply(j.toDate("s"), (ee ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ge)), j);
        }, D = this.$W, he = this.$M, oe = this.$D, ve = "set" + (this.$u ? "UTC" : "");
        switch (J) {
          case T:
            return ee ? z(1, 0) : z(31, 11);
          case f:
            return ee ? z(1, he) : z(0, he + 1);
          case c:
            var le = this.$locale().weekStart || 0, Ce = (D < le ? D + 7 : D) - le;
            return z(ee ? oe - Ce : oe + (6 - Ce), he);
          case l:
          case g:
            return _(ve + "Hours", 0);
          case u:
            return _(ve + "Minutes", 1);
          case s:
            return _(ve + "Seconds", 2);
          case o:
            return _(ve + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, $.endOf = function(L) {
        return this.startOf(L, !1);
      }, $.$set = function(L, Q) {
        var j, ee = w.p(L), J = "set" + (this.$u ? "UTC" : ""), z = (j = {}, j[l] = J + "Date", j[g] = J + "Date", j[f] = J + "Month", j[T] = J + "FullYear", j[u] = J + "Hours", j[s] = J + "Minutes", j[o] = J + "Seconds", j[i] = J + "Milliseconds", j)[ee], _ = ee === l ? this.$D + (Q - this.$W) : Q;
        if (ee === f || ee === T) {
          var D = this.clone().set(g, 1);
          D.$d[z](_), D.init(), this.$d = D.set(g, Math.min(this.$D, D.daysInMonth())).$d;
        } else
          z && this.$d[z](_);
        return this.init(), this;
      }, $.set = function(L, Q) {
        return this.clone().$set(L, Q);
      }, $.get = function(L) {
        return this[w.p(L)]();
      }, $.add = function(L, Q) {
        var j, ee = this;
        L = Number(L);
        var J = w.p(Q), z = function(he) {
          var oe = V(ee);
          return w.w(oe.date(oe.date() + Math.round(he * L)), ee);
        };
        if (J === f)
          return this.set(f, this.$M + L);
        if (J === T)
          return this.set(T, this.$y + L);
        if (J === l)
          return z(1);
        if (J === c)
          return z(7);
        var _ = (j = {}, j[s] = r, j[u] = a, j[o] = n, j)[J] || 1, D = this.$d.getTime() + L * _;
        return w.w(D, this);
      }, $.subtract = function(L, Q) {
        return this.add(-1 * L, Q);
      }, $.format = function(L) {
        var Q = this, j = this.$locale();
        if (!this.isValid())
          return j.invalidDate || m;
        var ee = L || "YYYY-MM-DDTHH:mm:ssZ", J = w.z(this), z = this.$H, _ = this.$m, D = this.$M, he = j.weekdays, oe = j.months, ve = function(ge, ye, ze, ce) {
          return ge && (ge[ye] || ge(Q, ee)) || ze[ye].slice(0, ce);
        }, le = function(ge) {
          return w.s(z % 12 || 12, ge, "0");
        }, Ce = j.meridiem || function(ge, ye, ze) {
          var ce = ge < 12 ? "AM" : "PM";
          return ze ? ce.toLowerCase() : ce;
        }, _e = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: D + 1, MM: w.s(D + 1, 2, "0"), MMM: ve(j.monthsShort, D, oe, 3), MMMM: ve(oe, D), D: this.$D, DD: w.s(this.$D, 2, "0"), d: String(this.$W), dd: ve(j.weekdaysMin, this.$W, he, 2), ddd: ve(j.weekdaysShort, this.$W, he, 3), dddd: he[this.$W], H: String(z), HH: w.s(z, 2, "0"), h: le(1), hh: le(2), a: Ce(z, _, !0), A: Ce(z, _, !1), m: String(_), mm: w.s(_, 2, "0"), s: String(this.$s), ss: w.s(this.$s, 2, "0"), SSS: w.s(this.$ms, 3, "0"), Z: J };
        return ee.replace(b, function(ge, ye) {
          return ye || _e[ge] || J.replace(":", "");
        });
      }, $.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, $.diff = function(L, Q, j) {
        var ee, J = w.p(Q), z = V(L), _ = (z.utcOffset() - this.utcOffset()) * r, D = this - z, he = w.m(this, z);
        return he = (ee = {}, ee[T] = he / 12, ee[f] = he, ee[E] = he / 3, ee[c] = (D - _) / 6048e5, ee[l] = (D - _) / 864e5, ee[u] = D / a, ee[s] = D / r, ee[o] = D / n, ee)[J] || D, j ? he : w.a(he);
      }, $.daysInMonth = function() {
        return this.endOf(f).$D;
      }, $.$locale = function() {
        return C[this.$L];
      }, $.locale = function(L, Q) {
        if (!L)
          return this.$L;
        var j = this.clone(), ee = G(L, Q, !0);
        return ee && (j.$L = ee), j;
      }, $.clone = function() {
        return w.w(this.$d, this);
      }, $.toDate = function() {
        return new Date(this.valueOf());
      }, $.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, $.toISOString = function() {
        return this.$d.toISOString();
      }, $.toString = function() {
        return this.$d.toUTCString();
      }, H;
    }(), X = Y.prototype;
    return V.prototype = X, [["$ms", i], ["$s", o], ["$m", s], ["$H", u], ["$W", l], ["$M", f], ["$y", T], ["$D", g]].forEach(function(H) {
      X[H[1]] = function($) {
        return this.$g($, H[0], H[1]);
      };
    }), V.extend = function(H, $) {
      return H.$i || (H($, Y, V), H.$i = !0), V;
    }, V.locale = G, V.isDayjs = I, V.unix = function(H) {
      return V(1e3 * H);
    }, V.en = C[S], V.Ls = C, V.p = {}, V;
  });
})(Np);
const Ql = Np.exports;
var wp = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ft, function() {
    return function(n, r, a) {
      n = n || {};
      var i = r.prototype, o = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function s(l, c, f, E) {
        return i.fromToBase(l, c, f, E);
      }
      a.en.relativeTime = o, i.fromToBase = function(l, c, f, E, T) {
        for (var g, m, v, b = f.$locale().relativeTime || o, y = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], O = y.length, B = 0; B < O; B += 1) {
          var S = y[B];
          S.d && (g = E ? a(l).diff(f, S.d, !0) : f.diff(l, S.d, !0));
          var C = (n.rounding || Math.round)(Math.abs(g));
          if (v = g > 0, C <= S.r || !S.r) {
            C <= 1 && B > 0 && (S = y[B - 1]);
            var I = b[S.l];
            T && (C = T("" + C)), m = typeof I == "string" ? I.replace("%d", C) : I(C, c, S.l, v);
            break;
          }
        }
        if (c)
          return m;
        var G = v ? b.future : b.past;
        return typeof G == "function" ? G(m) : G.replace("%s", m);
      }, i.to = function(l, c) {
        return s(l, c, this, !0);
      }, i.from = function(l, c) {
        return s(l, c, this);
      };
      var u = function(l) {
        return l.$u ? a.utc() : a();
      };
      i.toNow = function(l) {
        return this.to(u(this), l);
      }, i.fromNow = function(l) {
        return this.from(u(this), l);
      };
    };
  });
})(wp);
const nD = wp.exports;
Ql.extend(nD);
const rD = (e) => ii(() => {
  if (!e)
    return null;
  const t = Ql(e), n = Ql();
  switch (!0) {
    case n.isSame(t, "day"):
      return "Today";
    case n.subtract(1, "day").isSame(t, "day"):
      return "Yesterday";
    default:
      return t.fromNow();
  }
}, [e]), Ip = (e = []) => {
  const { scrollToBottom: t } = xo(xc);
  I8(() => {
    t();
  }, e);
}, aD = (e, t = []) => {
  const n = Mr(!1);
  Rr(() => {
    if (n.current)
      return e();
    n.current = !0;
  }, t);
}, iD = (e) => {
  var t;
  return !!((t = e == null ? void 0 : e.verify) != null && t.authorization);
}, oD = (e) => {
  var t;
  return typeof ((t = e == null ? void 0 : e.verify) == null ? void 0 : t.projectID) == "string";
}, Xs = Er;
var Rp = { exports: {} };
/*!
 * depd
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var sD = uD;
function uD(e) {
  if (!e)
    throw new TypeError("argument namespace is required");
  function t(n) {
  }
  return t._file = void 0, t._ignored = !0, t._namespace = e, t._traced = !1, t._warned = /* @__PURE__ */ Object.create(null), t.function = lD, t.property = cD, t;
}
function lD(e, t) {
  if (typeof e != "function")
    throw new TypeError("argument fn must be a function");
  return e;
}
function cD(e, t, n) {
  if (!e || typeof e != "object" && typeof e != "function")
    throw new TypeError("argument obj must be object");
  var r = Object.getOwnPropertyDescriptor(e, t);
  if (!r)
    throw new TypeError("must call property on owner object");
  if (!r.configurable)
    throw new TypeError("property must be configurable");
}
var fD = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? hD : dD);
function hD(e, t) {
  return e.__proto__ = t, e;
}
function dD(e, t) {
  for (var n in t)
    Object.prototype.hasOwnProperty.call(e, n) || (e[n] = t[n]);
  return e;
}
const mD = {
  100: "Continue",
  101: "Switching Protocols",
  102: "Processing",
  103: "Early Hints",
  200: "OK",
  201: "Created",
  202: "Accepted",
  203: "Non-Authoritative Information",
  204: "No Content",
  205: "Reset Content",
  206: "Partial Content",
  207: "Multi-Status",
  208: "Already Reported",
  226: "IM Used",
  300: "Multiple Choices",
  301: "Moved Permanently",
  302: "Found",
  303: "See Other",
  304: "Not Modified",
  305: "Use Proxy",
  307: "Temporary Redirect",
  308: "Permanent Redirect",
  400: "Bad Request",
  401: "Unauthorized",
  402: "Payment Required",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  406: "Not Acceptable",
  407: "Proxy Authentication Required",
  408: "Request Timeout",
  409: "Conflict",
  410: "Gone",
  411: "Length Required",
  412: "Precondition Failed",
  413: "Payload Too Large",
  414: "URI Too Long",
  415: "Unsupported Media Type",
  416: "Range Not Satisfiable",
  417: "Expectation Failed",
  418: "I'm a Teapot",
  421: "Misdirected Request",
  422: "Unprocessable Entity",
  423: "Locked",
  424: "Failed Dependency",
  425: "Too Early",
  426: "Upgrade Required",
  428: "Precondition Required",
  429: "Too Many Requests",
  431: "Request Header Fields Too Large",
  451: "Unavailable For Legal Reasons",
  500: "Internal Server Error",
  501: "Not Implemented",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
  505: "HTTP Version Not Supported",
  506: "Variant Also Negotiates",
  507: "Insufficient Storage",
  508: "Loop Detected",
  509: "Bandwidth Limit Exceeded",
  510: "Not Extended",
  511: "Network Authentication Required"
};
/*!
 * statuses
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */
var Lc = mD, pD = sr;
sr.message = Lc;
sr.code = gD(Lc);
sr.codes = ED(Lc);
sr.redirect = {
  300: !0,
  301: !0,
  302: !0,
  303: !0,
  305: !0,
  307: !0,
  308: !0
};
sr.empty = {
  204: !0,
  205: !0,
  304: !0
};
sr.retry = {
  502: !0,
  503: !0,
  504: !0
};
function gD(e) {
  var t = {};
  return Object.keys(e).forEach(function(r) {
    var a = e[r], i = Number(r);
    t[a.toLowerCase()] = i;
  }), t;
}
function ED(e) {
  return Object.keys(e).map(function(n) {
    return Number(n);
  });
}
function TD(e) {
  var t = e.toLowerCase();
  if (!Object.prototype.hasOwnProperty.call(sr.code, t))
    throw new Error('invalid status message: "' + e + '"');
  return sr.code[t];
}
function Ih(e) {
  if (!Object.prototype.hasOwnProperty.call(sr.message, e))
    throw new Error("invalid status code: " + e);
  return sr.message[e];
}
function sr(e) {
  if (typeof e == "number")
    return Ih(e);
  if (typeof e != "string")
    throw new TypeError("code must be a number or string");
  var t = parseInt(e, 10);
  return isNaN(t) ? TD(e) : Ih(t);
}
var Zl = { exports: {} };
typeof Object.create == "function" ? Zl.exports = function(t, n) {
  n && (t.super_ = n, t.prototype = Object.create(n.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : Zl.exports = function(t, n) {
  if (n) {
    t.super_ = n;
    var r = function() {
    };
    r.prototype = n.prototype, t.prototype = new r(), t.prototype.constructor = t;
  }
};
/*!
 * toidentifier
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */
var vD = AD;
function AD(e) {
  return e.split(" ").map(function(t) {
    return t.slice(0, 1).toUpperCase() + t.slice(1);
  }).join("").replace(/[^ _0-9a-z]/gi, "");
}
/*!
 * http-errors
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */
(function(e) {
  sD("http-errors");
  var t = fD, n = pD, r = Zl.exports, a = vD;
  e.exports = o, e.exports.HttpError = s(), e.exports.isHttpError = l(e.exports.HttpError), E(e.exports, n.codes, e.exports.HttpError);
  function i(g) {
    return Number(String(g).charAt(0) + "00");
  }
  function o() {
    for (var g, m, v = 500, b = {}, y = 0; y < arguments.length; y++) {
      var O = arguments[y], B = typeof O;
      if (B === "object" && O instanceof Error)
        g = O, v = g.status || g.statusCode || v;
      else if (B === "number" && y === 0)
        v = O;
      else if (B === "string")
        m = O;
      else if (B === "object")
        b = O;
      else
        throw new TypeError("argument #" + (y + 1) + " unsupported type " + B);
    }
    (typeof v != "number" || !n.message[v] && (v < 400 || v >= 600)) && (v = 500);
    var S = o[v] || o[i(v)];
    g || (g = S ? new S(m) : new Error(m || n.message[v]), Error.captureStackTrace(g, o)), (!S || !(g instanceof S) || g.status !== v) && (g.expose = v < 500, g.status = g.statusCode = v);
    for (var C in b)
      C !== "status" && C !== "statusCode" && (g[C] = b[C]);
    return g;
  }
  function s() {
    function g() {
      throw new TypeError("cannot construct abstract class");
    }
    return r(g, Error), g;
  }
  function u(g, m, v) {
    var b = T(m);
    function y(O) {
      var B = O != null ? O : n.message[v], S = new Error(B);
      return Error.captureStackTrace(S, y), t(S, y.prototype), Object.defineProperty(S, "message", {
        enumerable: !0,
        configurable: !0,
        value: B,
        writable: !0
      }), Object.defineProperty(S, "name", {
        enumerable: !1,
        configurable: !0,
        value: b,
        writable: !0
      }), S;
    }
    return r(y, g), f(y, b), y.prototype.status = v, y.prototype.statusCode = v, y.prototype.expose = !0, y;
  }
  function l(g) {
    return function(v) {
      return !v || typeof v != "object" ? !1 : v instanceof g ? !0 : v instanceof Error && typeof v.expose == "boolean" && typeof v.statusCode == "number" && v.status === v.statusCode;
    };
  }
  function c(g, m, v) {
    var b = T(m);
    function y(O) {
      var B = O != null ? O : n.message[v], S = new Error(B);
      return Error.captureStackTrace(S, y), t(S, y.prototype), Object.defineProperty(S, "message", {
        enumerable: !0,
        configurable: !0,
        value: B,
        writable: !0
      }), Object.defineProperty(S, "name", {
        enumerable: !1,
        configurable: !0,
        value: b,
        writable: !0
      }), S;
    }
    return r(y, g), f(y, b), y.prototype.status = v, y.prototype.statusCode = v, y.prototype.expose = !1, y;
  }
  function f(g, m) {
    var v = Object.getOwnPropertyDescriptor(g, "name");
    v && v.configurable && (v.value = m, Object.defineProperty(g, "name", v));
  }
  function E(g, m, v) {
    m.forEach(function(y) {
      var O, B = a(n.message[y]);
      switch (i(y)) {
        case 400:
          O = u(v, B, y);
          break;
        case 500:
          O = c(v, B, y);
          break;
      }
      O && (g[y] = O, g[B] = O);
    });
  }
  function T(g) {
    return g.substr(-5) !== "Error" ? g + "Error" : g;
  }
})(Rp);
const CD = Rp.exports;
class Mp {
  constructor(t) {
    var n, r;
    if (this.options = t, this.fetch = (r = t.fetchPonyfill) != null ? r : (n = globalThis.fetch) == null ? void 0 : n.bind(globalThis), !this.fetch)
      throw new TypeError("fetch implementation was not provided and a global fetch was not available");
  }
  async send(t, n = {}) {
    var o, s;
    const r = new URL(t, this.options.url);
    n.params && (r.search = n.params.toString());
    const a = await this.fetch(r, {
      method: (o = n.method) != null ? o : "GET",
      body: n.body ? JSON.stringify(n.body) : void 0,
      headers: {
        "content-type": "application/json",
        ...(s = n.headers) != null ? s : {}
      }
    }), i = await a.json().catch(() => null);
    if (!a.ok)
      throw CD(a.status, a.statusText, i);
    return i;
  }
}
class _D extends Mp {
  constructor(t) {
    super(t), this.authorization = t.verify.authorization;
  }
  async interact(t) {
    const { action: n, config: r, sessionID: a, versionID: i } = t;
    return this.send(`state/user/${a}/interact`, {
      method: "POST",
      body: { action: n, config: r },
      headers: {
        authorization: this.authorization,
        sessionID: a,
        ...i ? { versionID: i } : {}
      },
      params: new URLSearchParams({ verbose: "true" })
    });
  }
  async feedback() {
    return Promise.reject(new Error("not implemented"));
  }
  getPublishing() {
    return Promise.reject(new Error("not implemented"));
  }
  createTranscript() {
    return Promise.reject(new Error("not implemented"));
  }
}
class bD extends Mp {
  constructor(t) {
    super(t), this.projectID = t.verify.projectID;
  }
  async interact(t) {
    const { action: n, config: r, sessionID: a, versionID: i } = t;
    return this.send(`public/${this.projectID}/state/user/${a}/interact`, {
      method: "POST",
      body: { action: n, config: r },
      headers: {
        sessionID: a,
        ...i && { versionID: i }
      }
    });
  }
  async feedback(t) {
    const { versionID: n, sessionID: r, ...a } = t;
    await this.send(`feedback/${this.projectID}/user/${r}`, {
      method: "POST",
      body: a,
      headers: {
        sessionID: r,
        ...n && { versionID: n }
      }
    });
  }
  async getPublishing(t) {
    const { versionID: n } = t;
    return this.send(`public/${this.projectID}/publishing`, {
      method: "GET",
      headers: {
        ...n ? { versionID: n } : {}
      }
    });
  }
  async createTranscript(t, n) {
    return this.send(`public/${this.projectID}/transcripts`, {
      method: "POST",
      body: { ...n, sessionID: t }
    });
  }
}
class yD {
  constructor(t = {}) {
    var n;
    this.traces = [], this.registerTraces((n = t.traces) != null ? n : []);
  }
  registerTrace(t) {
    return this.traces.push(t), this;
  }
  registerTraces(t) {
    return t.forEach((n) => this.registerTrace(n)), this;
  }
  async processTrace(t, n) {
    const r = { context: t };
    for (const a of n.trace) {
      const i = this.traces.find((o) => o.canHandle(a));
      i && (r.context = await i.handle(r, a));
    }
    return r.context;
  }
}
class DD {
  constructor(t) {
    if (this.trace = new yD(t), iD(t))
      this.runtime = new _D(t);
    else if (oD(t))
      this.runtime = new bD(t);
    else
      throw new Error("invalid runtime options");
  }
  registerStep(t) {
    return this.trace.registerTrace(t), this;
  }
  async interact(t, n) {
    const r = await this.runtime.interact(n);
    return this.trace.processTrace(t, r);
  }
  async feedback(t) {
    return this.runtime.feedback(t);
  }
  async getPublishing(...t) {
    return this.runtime.getPublishing(...t);
  }
  async createTranscript(...t) {
    return this.runtime.createTranscript(...t);
  }
}
const Sa = (e) => (t) => typeof t == "function" ? {
  canHandle: (n) => n.type === e,
  handle: t
} : t, SD = Sa(bn.CARD_V2), OD = Sa(bn.CHOICE);
Sa(bn.END);
Sa(bn.SPEAK);
Sa(bn.STREAM);
const ND = Sa(bn.TEXT), wD = Sa(bn.VISUAL);
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function Rh(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ln(e) {
  var t, n;
  return Rh(e) === !1 ? !1 : (t = e.constructor, t === void 0 ? !0 : (n = t.prototype, !(Rh(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1)));
}
function rn(e) {
  for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if ({}.NODE_ENV !== "production") {
    var a = FD[e], i = a ? typeof a == "function" ? a.apply(null, n) : a : "unknown error nr: " + e;
    throw Error("[Immer] " + i);
  }
  throw Error("[Immer] minified error nr: " + e + (n.length ? " " + n.map(function(o) {
    return "'" + o + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function _a(e) {
  return !!e && !!e[Mn];
}
function ba(e) {
  return !!e && (function(t) {
    if (!t || typeof t != "object")
      return !1;
    var n = Object.getPrototypeOf(t);
    if (n === null)
      return !0;
    var r = Object.hasOwnProperty.call(n, "constructor") && n.constructor;
    return r === Object || typeof r == "function" && Function.toString.call(r) === LD;
  }(e) || Array.isArray(e) || !!e[$h] || !!e.constructor[$h] || $c(e) || Hc(e));
}
function h1(e, t, n) {
  n === void 0 && (n = !1), hi(e) === 0 ? (n ? Object.keys : Vc)(e).forEach(function(r) {
    n && typeof r == "symbol" || t(r, e[r], e);
  }) : e.forEach(function(r, a) {
    return t(a, r, e);
  });
}
function hi(e) {
  var t = e[Mn];
  return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : $c(e) ? 2 : Hc(e) ? 3 : 0;
}
function Jl(e, t) {
  return hi(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function ID(e, t) {
  return hi(e) === 2 ? e.get(t) : e[t];
}
function xp(e, t, n) {
  var r = hi(e);
  r === 2 ? e.set(t, n) : r === 3 ? (e.delete(t), e.add(n)) : e[t] = n;
}
function RD(e, t) {
  return e === t ? e !== 0 || 1 / e == 1 / t : e != e && t != t;
}
function $c(e) {
  return PD && e instanceof Map;
}
function Hc(e) {
  return BD && e instanceof Set;
}
function ha(e) {
  return e.o || e.t;
}
function Uc(e) {
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  var t = $D(e);
  delete t[Mn];
  for (var n = Vc(t), r = 0; r < n.length; r++) {
    var a = n[r], i = t[a];
    i.writable === !1 && (i.writable = !0, i.configurable = !0), (i.get || i.set) && (t[a] = { configurable: !0, writable: !0, enumerable: i.enumerable, value: e[a] });
  }
  return Object.create(Object.getPrototypeOf(e), t);
}
function jc(e, t) {
  return t === void 0 && (t = !1), zc(e) || _a(e) || !ba(e) || (hi(e) > 1 && (e.set = e.add = e.clear = e.delete = MD), Object.freeze(e), t && h1(e, function(n, r) {
    return jc(r, !0);
  }, !0)), e;
}
function MD() {
  rn(2);
}
function zc(e) {
  return e == null || typeof e != "object" || Object.isFrozen(e);
}
function pr(e) {
  var t = HD[e];
  return t || rn(18, e), t;
}
function Mh() {
  return {}.NODE_ENV === "production" || ai || rn(0), ai;
}
function Qs(e, t) {
  t && (pr("Patches"), e.u = [], e.s = [], e.v = t);
}
function _o(e) {
  ec(e), e.p.forEach(xD), e.p = null;
}
function ec(e) {
  e === ai && (ai = e.l);
}
function xh(e) {
  return ai = { p: [], l: ai, h: e, m: !0, _: 0 };
}
function xD(e) {
  var t = e[Mn];
  t.i === 0 || t.i === 1 ? t.j() : t.O = !0;
}
function Zs(e, t) {
  t._ = t.p.length;
  var n = t.p[0], r = e !== void 0 && e !== n;
  return t.h.g || pr("ES5").S(t, e, r), r ? (n[Mn].P && (_o(t), rn(4)), ba(e) && (e = bo(t, e), t.l || yo(t, e)), t.u && pr("Patches").M(n[Mn].t, e, t.u, t.s)) : e = bo(t, n, []), _o(t), t.u && t.v(t.u, t.s), e !== kp ? e : void 0;
}
function bo(e, t, n) {
  if (zc(t))
    return t;
  var r = t[Mn];
  if (!r)
    return h1(t, function(i, o) {
      return kh(e, r, t, i, o, n);
    }, !0), t;
  if (r.A !== e)
    return t;
  if (!r.P)
    return yo(e, r.t, !0), r.t;
  if (!r.I) {
    r.I = !0, r.A._--;
    var a = r.i === 4 || r.i === 5 ? r.o = Uc(r.k) : r.o;
    h1(r.i === 3 ? new Set(a) : a, function(i, o) {
      return kh(e, r, a, i, o, n);
    }), yo(e, a, !1), n && e.u && pr("Patches").R(r, n, e.u, e.s);
  }
  return r.o;
}
function kh(e, t, n, r, a, i) {
  if ({}.NODE_ENV !== "production" && a === n && rn(5), _a(a)) {
    var o = bo(e, a, i && t && t.i !== 3 && !Jl(t.D, r) ? i.concat(r) : void 0);
    if (xp(n, r, o), !_a(o))
      return;
    e.m = !1;
  }
  if (ba(a) && !zc(a)) {
    if (!e.h.F && e._ < 1)
      return;
    bo(e, a), t && t.A.l || yo(e, a);
  }
}
function yo(e, t, n) {
  n === void 0 && (n = !1), e.h.F && e.m && jc(t, n);
}
function Js(e, t) {
  var n = e[Mn];
  return (n ? ha(n) : e)[t];
}
function Ph(e, t) {
  if (t in e)
    for (var n = Object.getPrototypeOf(e); n; ) {
      var r = Object.getOwnPropertyDescriptor(n, t);
      if (r)
        return r;
      n = Object.getPrototypeOf(n);
    }
}
function tc(e) {
  e.P || (e.P = !0, e.l && tc(e.l));
}
function eu(e) {
  e.o || (e.o = Uc(e.t));
}
function nc(e, t, n) {
  var r = $c(t) ? pr("MapSet").N(t, n) : Hc(t) ? pr("MapSet").T(t, n) : e.g ? function(a, i) {
    var o = Array.isArray(a), s = { i: o ? 1 : 0, A: i ? i.A : Mh(), P: !1, I: !1, D: {}, l: i, t: a, k: null, o: null, j: null, C: !1 }, u = s, l = rc;
    o && (u = [s], l = Gi);
    var c = Proxy.revocable(u, l), f = c.revoke, E = c.proxy;
    return s.k = E, s.j = f, E;
  }(t, n) : pr("ES5").J(t, n);
  return (n ? n.A : Mh()).p.push(r), r;
}
function kD(e) {
  return _a(e) || rn(22, e), function t(n) {
    if (!ba(n))
      return n;
    var r, a = n[Mn], i = hi(n);
    if (a) {
      if (!a.P && (a.i < 4 || !pr("ES5").K(a)))
        return a.t;
      a.I = !0, r = Bh(n, i), a.I = !1;
    } else
      r = Bh(n, i);
    return h1(r, function(o, s) {
      a && ID(a.t, o) === s || xp(r, o, t(s));
    }), i === 3 ? new Set(r) : r;
  }(e);
}
function Bh(e, t) {
  switch (t) {
    case 2:
      return new Map(e);
    case 3:
      return Array.from(e);
  }
  return Uc(e);
}
var Fh, ai, Gc = typeof Symbol < "u" && typeof Symbol("x") == "symbol", PD = typeof Map < "u", BD = typeof Set < "u", Lh = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", kp = Gc ? Symbol.for("immer-nothing") : ((Fh = {})["immer-nothing"] = !0, Fh), $h = Gc ? Symbol.for("immer-draftable") : "__$immer_draftable", Mn = Gc ? Symbol.for("immer-state") : "__$immer_state", FD = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(e) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(e) {
  return "Cannot apply patch, path doesn't resolve: " + e;
}, 16: 'Sets cannot have "replace" patches.', 17: function(e) {
  return "Unsupported patch operation: " + e;
}, 18: function(e) {
  return "The plugin for '" + e + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + e + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(e) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + e + "'";
}, 22: function(e) {
  return "'current' expects a draft, got: " + e;
}, 23: function(e) {
  return "'original' expects a draft, got: " + e;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, LD = "" + Object.prototype.constructor, Vc = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames, $D = Object.getOwnPropertyDescriptors || function(e) {
  var t = {};
  return Vc(e).forEach(function(n) {
    t[n] = Object.getOwnPropertyDescriptor(e, n);
  }), t;
}, HD = {}, rc = { get: function(e, t) {
  if (t === Mn)
    return e;
  var n = ha(e);
  if (!Jl(n, t))
    return function(a, i, o) {
      var s, u = Ph(i, o);
      return u ? "value" in u ? u.value : (s = u.get) === null || s === void 0 ? void 0 : s.call(a.k) : void 0;
    }(e, n, t);
  var r = n[t];
  return e.I || !ba(r) ? r : r === Js(e.t, t) ? (eu(e), e.o[t] = nc(e.A.h, r, e)) : r;
}, has: function(e, t) {
  return t in ha(e);
}, ownKeys: function(e) {
  return Reflect.ownKeys(ha(e));
}, set: function(e, t, n) {
  var r = Ph(ha(e), t);
  if (r != null && r.set)
    return r.set.call(e.k, n), !0;
  if (!e.P) {
    var a = Js(ha(e), t), i = a == null ? void 0 : a[Mn];
    if (i && i.t === n)
      return e.o[t] = n, e.D[t] = !1, !0;
    if (RD(n, a) && (n !== void 0 || Jl(e.t, t)))
      return !0;
    eu(e), tc(e);
  }
  return e.o[t] === n && typeof n != "number" && (n !== void 0 || t in e.o) || (e.o[t] = n, e.D[t] = !0, !0);
}, deleteProperty: function(e, t) {
  return Js(e.t, t) !== void 0 || t in e.t ? (e.D[t] = !1, eu(e), tc(e)) : delete e.D[t], e.o && delete e.o[t], !0;
}, getOwnPropertyDescriptor: function(e, t) {
  var n = ha(e), r = Reflect.getOwnPropertyDescriptor(n, t);
  return r && { writable: !0, configurable: e.i !== 1 || t !== "length", enumerable: r.enumerable, value: n[t] };
}, defineProperty: function() {
  rn(11);
}, getPrototypeOf: function(e) {
  return Object.getPrototypeOf(e.t);
}, setPrototypeOf: function() {
  rn(12);
} }, Gi = {};
h1(rc, function(e, t) {
  Gi[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
}), Gi.deleteProperty = function(e, t) {
  return {}.NODE_ENV !== "production" && isNaN(parseInt(t)) && rn(13), Gi.set.call(this, e, t, void 0);
}, Gi.set = function(e, t, n) {
  return {}.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && rn(14), rc.set.call(this, e[0], t, n, e[0]);
};
var UD = function() {
  function e(n) {
    var r = this;
    this.g = Lh, this.F = !0, this.produce = function(a, i, o) {
      if (typeof a == "function" && typeof i != "function") {
        var s = i;
        i = a;
        var u = r;
        return function(m) {
          var v = this;
          m === void 0 && (m = s);
          for (var b = arguments.length, y = Array(b > 1 ? b - 1 : 0), O = 1; O < b; O++)
            y[O - 1] = arguments[O];
          return u.produce(m, function(B) {
            var S;
            return (S = i).call.apply(S, [v, B].concat(y));
          });
        };
      }
      var l;
      if (typeof i != "function" && rn(6), o !== void 0 && typeof o != "function" && rn(7), ba(a)) {
        var c = xh(r), f = nc(r, a, void 0), E = !0;
        try {
          l = i(f), E = !1;
        } finally {
          E ? _o(c) : ec(c);
        }
        return typeof Promise < "u" && l instanceof Promise ? l.then(function(m) {
          return Qs(c, o), Zs(m, c);
        }, function(m) {
          throw _o(c), m;
        }) : (Qs(c, o), Zs(l, c));
      }
      if (!a || typeof a != "object") {
        if ((l = i(a)) === void 0 && (l = a), l === kp && (l = void 0), r.F && jc(l, !0), o) {
          var T = [], g = [];
          pr("Patches").M(a, l, T, g), o(T, g);
        }
        return l;
      }
      rn(21, a);
    }, this.produceWithPatches = function(a, i) {
      if (typeof a == "function")
        return function(l) {
          for (var c = arguments.length, f = Array(c > 1 ? c - 1 : 0), E = 1; E < c; E++)
            f[E - 1] = arguments[E];
          return r.produceWithPatches(l, function(T) {
            return a.apply(void 0, [T].concat(f));
          });
        };
      var o, s, u = r.produce(a, i, function(l, c) {
        o = l, s = c;
      });
      return typeof Promise < "u" && u instanceof Promise ? u.then(function(l) {
        return [l, o, s];
      }) : [u, o, s];
    }, typeof (n == null ? void 0 : n.useProxies) == "boolean" && this.setUseProxies(n.useProxies), typeof (n == null ? void 0 : n.autoFreeze) == "boolean" && this.setAutoFreeze(n.autoFreeze);
  }
  var t = e.prototype;
  return t.createDraft = function(n) {
    ba(n) || rn(8), _a(n) && (n = kD(n));
    var r = xh(this), a = nc(this, n, void 0);
    return a[Mn].C = !0, ec(r), a;
  }, t.finishDraft = function(n, r) {
    var a = n && n[Mn];
    ({}).NODE_ENV !== "production" && (a && a.C || rn(9), a.I && rn(10));
    var i = a.A;
    return Qs(i, r), Zs(void 0, i);
  }, t.setAutoFreeze = function(n) {
    this.F = n;
  }, t.setUseProxies = function(n) {
    n && !Lh && rn(20), this.g = n;
  }, t.applyPatches = function(n, r) {
    var a;
    for (a = r.length - 1; a >= 0; a--) {
      var i = r[a];
      if (i.path.length === 0 && i.op === "replace") {
        n = i.value;
        break;
      }
    }
    a > -1 && (r = r.slice(a + 1));
    var o = pr("Patches").$;
    return _a(n) ? o(n, r) : this.produce(n, function(s) {
      return o(s, r);
    });
  }, e;
}(), xn = new UD(), qo = xn.produce;
xn.produceWithPatches.bind(xn);
xn.setAutoFreeze.bind(xn);
xn.setUseProxies.bind(xn);
xn.applyPatches.bind(xn);
var Hh = xn.createDraft.bind(xn), Uh = xn.finishDraft.bind(xn);
function Fr(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var jh = /* @__PURE__ */ new WeakMap(), zh = /* @__PURE__ */ new WeakMap(), Gh = /* @__PURE__ */ new WeakMap(), Vh = /* @__PURE__ */ new WeakMap(), Yh = /* @__PURE__ */ new WeakMap(), Kh = /* @__PURE__ */ new WeakMap();
function jD(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function kr(e, t) {
  if (e == null)
    return {};
  var n = jD(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, r) || (n[r] = e[r]));
  }
  return n;
}
var Yc = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = !n, a = n ? WD(t) : t, i = He.None, o = He.None, s = 0, u = null, l = null;
  for (var c of a) {
    var f = c.codePointAt(0);
    if (!f)
      break;
    var E = oS(c, f);
    if ([i, o] = r ? [o, E] : [E, i], Za(i, He.ZWJ) && Za(o, He.ExtPict) && (r ? u = Wh(t.substring(0, s)) : u = Wh(t.substring(0, t.length - s)), !u) || Za(i, He.RI) && Za(o, He.RI) && (l !== null ? l = !l : r ? l = !0 : l = fS(t.substring(0, t.length - s)), !l) || i !== He.None && o !== He.None && uS(i, o))
      break;
    s += c.length;
  }
  return s || 1;
}, zD = /\s/, GD = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, VD = /['\u2018\u2019]/, YD = function(t) {
  for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = 0, a = !1; t.length > 0; ) {
    var i = Yc(t, n), [o, s] = Kc(t, i, n);
    if (KD(o, s, n))
      a = !0, r += i;
    else if (!a)
      r += i;
    else
      break;
    t = s;
  }
  return r;
}, Kc = (e, t, n) => {
  if (n) {
    var r = e.length - t;
    return [e.slice(r, e.length), e.slice(0, r)];
  }
  return [e.slice(0, t), e.slice(t)];
}, KD = function e(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (zD.test(t))
    return !1;
  if (VD.test(t)) {
    var a = Yc(n, r), [i, o] = Kc(n, a, r);
    if (e(i, o, r))
      return !0;
  }
  return !GD.test(t);
}, WD = function* (t) {
  for (var n = t.length - 1, r = 0; r < t.length; r++) {
    var a = t.charAt(n - r);
    if (XD(a.charCodeAt(0))) {
      var i = t.charAt(n - r - 1);
      if (qD(i.charCodeAt(0))) {
        yield i + a, r++;
        continue;
      }
    }
    yield a;
  }
}, qD = (e) => e >= 55296 && e <= 56319, XD = (e) => e >= 56320 && e <= 57343, He;
(function(e) {
  e[e.None = 0] = "None", e[e.Extend = 1] = "Extend", e[e.ZWJ = 2] = "ZWJ", e[e.RI = 4] = "RI", e[e.Prepend = 8] = "Prepend", e[e.SpacingMark = 16] = "SpacingMark", e[e.L = 32] = "L", e[e.V = 64] = "V", e[e.T = 128] = "T", e[e.LV = 256] = "LV", e[e.LVT = 512] = "LVT", e[e.ExtPict = 1024] = "ExtPict", e[e.Any = 2048] = "Any";
})(He || (He = {}));
var QD = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/, ZD = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/, JD = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/, eS = /^[\u1100-\u115F\uA960-\uA97C]$/, tS = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/, nS = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/, rS = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/, aS = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/, iS = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/, oS = (e, t) => {
  var n = He.Any;
  return e.search(QD) !== -1 && (n |= He.Extend), t === 8205 && (n |= He.ZWJ), t >= 127462 && t <= 127487 && (n |= He.RI), e.search(ZD) !== -1 && (n |= He.Prepend), e.search(JD) !== -1 && (n |= He.SpacingMark), e.search(eS) !== -1 && (n |= He.L), e.search(tS) !== -1 && (n |= He.V), e.search(nS) !== -1 && (n |= He.T), e.search(rS) !== -1 && (n |= He.LV), e.search(aS) !== -1 && (n |= He.LVT), e.search(iS) !== -1 && (n |= He.ExtPict), n;
};
function Za(e, t) {
  return (e & t) !== 0;
}
var sS = [
  [He.L, He.L | He.V | He.LV | He.LVT],
  [He.LV | He.V, He.V | He.T],
  [He.LVT | He.T, He.T],
  [He.Any, He.Extend | He.ZWJ],
  [He.Any, He.SpacingMark],
  [He.Prepend, He.Any],
  [He.ZWJ, He.ExtPict],
  [He.RI, He.RI]
];
function uS(e, t) {
  return sS.findIndex((n) => Za(e, n[0]) && Za(t, n[1])) === -1;
}
var lS = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/, Wh = (e) => e.search(lS) !== -1, cS = /(?:\uD83C[\uDDE6-\uDDFF])+$/g, fS = (e) => {
  var t = e.match(cS);
  if (t === null)
    return !1;
  var n = t[0].length / 2;
  return n % 2 === 1;
}, qh = (e) => ln(e) && Re.isNodeList(e.children) && !M.isEditor(e), Ft = {
  isAncestor(e) {
    return ln(e) && Re.isNodeList(e.children);
  },
  isElement: qh,
  isElementList(e) {
    return Array.isArray(e) && e.every((t) => Ft.isElement(t));
  },
  isElementProps(e) {
    return e.children !== void 0;
  },
  isElementType: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "type";
    return qh(t) && t[r] === n;
  },
  matches(e, t) {
    for (var n in t)
      if (n !== "children" && e[n] !== t[n])
        return !1;
    return !0;
  }
}, hS = ["text"], dS = ["text"];
function Xh(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ja(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xh(Object(n), !0).forEach(function(r) {
      Fr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xh(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Qh = /* @__PURE__ */ new WeakMap(), M = {
  above(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      voids: n = !1,
      mode: r = "lowest",
      at: a = e.selection,
      match: i
    } = t;
    if (!!a) {
      var o = M.path(e, a), s = r === "lowest";
      for (var [u, l] of M.levels(e, {
        at: o,
        voids: n,
        match: i,
        reverse: s
      }))
        if (!Ue.isText(u) && !q.equals(o, l))
          return [u, l];
    }
  },
  addMark(e, t, n) {
    e.addMark(t, n);
  },
  after(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = M.point(e, t, {
      edge: "end"
    }), a = M.end(e, []), i = {
      anchor: r,
      focus: a
    }, {
      distance: o = 1
    } = n, s = 0, u;
    for (var l of M.positions(e, ja(ja({}, n), {}, {
      at: i
    }))) {
      if (s > o)
        break;
      s !== 0 && (u = l), s++;
    }
    return u;
  },
  before(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = M.start(e, []), a = M.point(e, t, {
      edge: "start"
    }), i = {
      anchor: r,
      focus: a
    }, {
      distance: o = 1
    } = n, s = 0, u;
    for (var l of M.positions(e, ja(ja({}, n), {}, {
      at: i,
      reverse: !0
    }))) {
      if (s > o)
        break;
      s !== 0 && (u = l), s++;
    }
    return u;
  },
  deleteBackward(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      unit: n = "character"
    } = t;
    e.deleteBackward(n);
  },
  deleteForward(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      unit: n = "character"
    } = t;
    e.deleteForward(n);
  },
  deleteFragment(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      direction: n = "forward"
    } = t;
    e.deleteFragment(n);
  },
  edges(e, t) {
    return [M.start(e, t), M.end(e, t)];
  },
  end(e, t) {
    return M.point(e, t, {
      edge: "end"
    });
  },
  first(e, t) {
    var n = M.path(e, t, {
      edge: "start"
    });
    return M.node(e, n);
  },
  fragment(e, t) {
    var n = M.range(e, t), r = Re.fragment(e, n);
    return r;
  },
  hasBlocks(e, t) {
    return t.children.some((n) => M.isBlock(e, n));
  },
  hasInlines(e, t) {
    return t.children.some((n) => Ue.isText(n) || M.isInline(e, n));
  },
  hasTexts(e, t) {
    return t.children.every((n) => Ue.isText(n));
  },
  insertBreak(e) {
    e.insertBreak();
  },
  insertFragment(e, t) {
    e.insertFragment(t);
  },
  insertNode(e, t) {
    e.insertNode(t);
  },
  insertText(e, t) {
    e.insertText(t);
  },
  isBlock(e, t) {
    return Ft.isElement(t) && !e.isInline(t);
  },
  isEditor(e) {
    if (!ln(e))
      return !1;
    var t = Qh.get(e);
    if (t !== void 0)
      return t;
    var n = typeof e.addMark == "function" && typeof e.apply == "function" && typeof e.deleteBackward == "function" && typeof e.deleteForward == "function" && typeof e.deleteFragment == "function" && typeof e.insertBreak == "function" && typeof e.insertFragment == "function" && typeof e.insertNode == "function" && typeof e.insertText == "function" && typeof e.isInline == "function" && typeof e.isVoid == "function" && typeof e.normalizeNode == "function" && typeof e.onChange == "function" && typeof e.removeMark == "function" && (e.marks === null || ln(e.marks)) && (e.selection === null || Ae.isRange(e.selection)) && Re.isNodeList(e.children) && Vi.isOperationList(e.operations);
    return Qh.set(e, n), n;
  },
  isEnd(e, t, n) {
    var r = M.end(e, n);
    return lt.equals(t, r);
  },
  isEdge(e, t, n) {
    return M.isStart(e, t, n) || M.isEnd(e, t, n);
  },
  isEmpty(e, t) {
    var {
      children: n
    } = t, [r] = n;
    return n.length === 0 || n.length === 1 && Ue.isText(r) && r.text === "" && !e.isVoid(t);
  },
  isInline(e, t) {
    return Ft.isElement(t) && e.isInline(t);
  },
  isNormalizing(e) {
    var t = Gh.get(e);
    return t === void 0 ? !0 : t;
  },
  isStart(e, t, n) {
    if (t.offset !== 0)
      return !1;
    var r = M.start(e, n);
    return lt.equals(t, r);
  },
  isVoid(e, t) {
    return Ft.isElement(t) && e.isVoid(t);
  },
  last(e, t) {
    var n = M.path(e, t, {
      edge: "end"
    });
    return M.node(e, n);
  },
  leaf(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = M.path(e, t, n), a = Re.leaf(e, r);
    return [a, r];
  },
  *levels(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      at: n = e.selection,
      reverse: r = !1,
      voids: a = !1
    } = t, {
      match: i
    } = t;
    if (i == null && (i = () => !0), !!n) {
      var o = [], s = M.path(e, n);
      for (var [u, l] of Re.levels(e, s))
        if (!!i(u, l) && (o.push([u, l]), !a && M.isVoid(e, u)))
          break;
      r && o.reverse(), yield* o;
    }
  },
  marks(e) {
    var {
      marks: t,
      selection: n
    } = e;
    if (!n)
      return null;
    if (t)
      return t;
    if (Ae.isExpanded(n)) {
      var [r] = M.nodes(e, {
        match: Ue.isText
      });
      if (r) {
        var [a] = r, i = kr(a, hS);
        return i;
      } else
        return {};
    }
    var {
      anchor: o
    } = n, {
      path: s
    } = o, [u] = M.leaf(e, s);
    if (o.offset === 0) {
      var l = M.previous(e, {
        at: s,
        match: Ue.isText
      }), c = M.above(e, {
        match: (m) => M.isBlock(e, m)
      });
      if (l && c) {
        var [f, E] = l, [, T] = c;
        q.isAncestor(T, E) && (u = f);
      }
    }
    var g = kr(u, dS);
    return g;
  },
  next(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      mode: n = "lowest",
      voids: r = !1
    } = t, {
      match: a,
      at: i = e.selection
    } = t;
    if (!!i) {
      var o = M.after(e, i, {
        voids: r
      });
      if (!!o) {
        var [, s] = M.last(e, []), u = [o.path, s];
        if (q.isPath(i) && i.length === 0)
          throw new Error("Cannot get the next node from the root node!");
        if (a == null)
          if (q.isPath(i)) {
            var [l] = M.parent(e, i);
            a = (f) => l.children.includes(f);
          } else
            a = () => !0;
        var [c] = M.nodes(e, {
          at: u,
          match: a,
          mode: n,
          voids: r
        });
        return c;
      }
    }
  },
  node(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = M.path(e, t, n), a = Re.get(e, r);
    return [a, r];
  },
  *nodes(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      at: n = e.selection,
      mode: r = "all",
      universal: a = !1,
      reverse: i = !1,
      voids: o = !1
    } = t, {
      match: s
    } = t;
    if (s || (s = () => !0), !!n) {
      var u, l;
      if (mS.isSpan(n))
        u = n[0], l = n[1];
      else {
        var c = M.path(e, n, {
          edge: "start"
        }), f = M.path(e, n, {
          edge: "end"
        });
        u = i ? f : c, l = i ? c : f;
      }
      var E = Re.nodes(e, {
        reverse: i,
        from: u,
        to: l,
        pass: (O) => {
          var [B] = O;
          return o ? !1 : M.isVoid(e, B);
        }
      }), T = [], g;
      for (var [m, v] of E) {
        var b = g && q.compare(v, g[1]) === 0;
        if (!(r === "highest" && b)) {
          if (!s(m, v)) {
            if (a && !b && Ue.isText(m))
              return;
            continue;
          }
          if (r === "lowest" && b) {
            g = [m, v];
            continue;
          }
          var y = r === "lowest" ? g : [m, v];
          y && (a ? T.push(y) : yield y), g = [m, v];
        }
      }
      r === "lowest" && g && (a ? T.push(g) : yield g), a && (yield* T);
    }
  },
  normalize(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      force: n = !1
    } = t, r = (u) => jh.get(u) || [], a = (u) => zh.get(u) || /* @__PURE__ */ new Set(), i = (u) => {
      var l = r(u).pop(), c = l.join(",");
      return a(u).delete(c), l;
    };
    if (!!M.isNormalizing(e)) {
      if (n) {
        var o = Array.from(Re.nodes(e), (u) => {
          var [, l] = u;
          return l;
        }), s = new Set(o.map((u) => u.join(",")));
        jh.set(e, o), zh.set(e, s);
      }
      r(e).length !== 0 && M.withoutNormalizing(e, () => {
        for (var u of r(e))
          if (Re.has(e, u)) {
            var l = M.node(e, u), [c, f] = l;
            Ft.isElement(c) && c.children.length === 0 && e.normalizeNode(l);
          }
        for (var E = r(e).length * 42, T = 0; r(e).length !== 0; ) {
          if (T > E)
            throw new Error(`
            Could not completely normalize the editor after `.concat(E, ` iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state.
          `));
          var g = i(e);
          if (Re.has(e, g)) {
            var m = M.node(e, g);
            e.normalizeNode(m);
          }
          T++;
        }
      });
    }
  },
  parent(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = M.path(e, t, n), a = q.parent(r), i = M.node(e, a);
    return i;
  },
  path(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      depth: r,
      edge: a
    } = n;
    if (q.isPath(t)) {
      if (a === "start") {
        var [, i] = Re.first(e, t);
        t = i;
      } else if (a === "end") {
        var [, o] = Re.last(e, t);
        t = o;
      }
    }
    return Ae.isRange(t) && (a === "start" ? t = Ae.start(t) : a === "end" ? t = Ae.end(t) : t = q.common(t.anchor.path, t.focus.path)), lt.isPoint(t) && (t = t.path), r != null && (t = t.slice(0, r)), t;
  },
  hasPath(e, t) {
    return Re.has(e, t);
  },
  pathRef(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      affinity: r = "forward"
    } = n, a = {
      current: t,
      affinity: r,
      unref() {
        var {
          current: o
        } = a, s = M.pathRefs(e);
        return s.delete(a), a.current = null, o;
      }
    }, i = M.pathRefs(e);
    return i.add(a), a;
  },
  pathRefs(e) {
    var t = Vh.get(e);
    return t || (t = /* @__PURE__ */ new Set(), Vh.set(e, t)), t;
  },
  point(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      edge: r = "start"
    } = n;
    if (q.isPath(t)) {
      var a;
      if (r === "end") {
        var [, i] = Re.last(e, t);
        a = i;
      } else {
        var [, o] = Re.first(e, t);
        a = o;
      }
      var s = Re.get(e, a);
      if (!Ue.isText(s))
        throw new Error("Cannot get the ".concat(r, " point in the node at path [").concat(t, "] because it has no ").concat(r, " text node."));
      return {
        path: a,
        offset: r === "end" ? s.text.length : 0
      };
    }
    if (Ae.isRange(t)) {
      var [u, l] = Ae.edges(t);
      return r === "start" ? u : l;
    }
    return t;
  },
  pointRef(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      affinity: r = "forward"
    } = n, a = {
      current: t,
      affinity: r,
      unref() {
        var {
          current: o
        } = a, s = M.pointRefs(e);
        return s.delete(a), a.current = null, o;
      }
    }, i = M.pointRefs(e);
    return i.add(a), a;
  },
  pointRefs(e) {
    var t = Yh.get(e);
    return t || (t = /* @__PURE__ */ new Set(), Yh.set(e, t)), t;
  },
  *positions(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      at: n = e.selection,
      unit: r = "offset",
      reverse: a = !1,
      voids: i = !1
    } = t;
    if (!n)
      return;
    var o = M.range(e, n), [s, u] = Ae.edges(o), l = a ? u : s, c = !1, f = "", E = 0, T = 0, g = 0;
    for (var [m, v] of M.nodes(e, {
      at: n,
      reverse: a,
      voids: i
    })) {
      if (Ft.isElement(m)) {
        if (!i && e.isVoid(m)) {
          yield M.start(e, v);
          continue;
        }
        if (e.isInline(m))
          continue;
        if (M.hasInlines(e, m)) {
          var b = q.isAncestor(v, u.path) ? u : M.end(e, v), y = q.isAncestor(v, s.path) ? s : M.start(e, v);
          f = M.string(e, {
            anchor: y,
            focus: b
          }, {
            voids: i
          }), c = !0;
        }
      }
      if (Ue.isText(m)) {
        var O = q.equals(v, l.path);
        for (O ? (T = a ? l.offset : m.text.length - l.offset, g = l.offset) : (T = m.text.length, g = a ? T : 0), (O || c || r === "offset") && (yield {
          path: v,
          offset: g
        }, c = !1); ; ) {
          if (E === 0) {
            if (f === "")
              break;
            E = B(f, r, a), f = Kc(f, E, a)[1];
          }
          if (g = a ? g - E : g + E, T = T - E, T < 0) {
            E = -T;
            break;
          }
          E = 0, yield {
            path: v,
            offset: g
          };
        }
      }
    }
    function B(S, C, I) {
      return C === "character" ? Yc(S, I) : C === "word" ? YD(S, I) : C === "line" || C === "block" ? S.length : 1;
    }
  },
  previous(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      mode: n = "lowest",
      voids: r = !1
    } = t, {
      match: a,
      at: i = e.selection
    } = t;
    if (!!i) {
      var o = M.before(e, i, {
        voids: r
      });
      if (!!o) {
        var [, s] = M.first(e, []), u = [o.path, s];
        if (q.isPath(i) && i.length === 0)
          throw new Error("Cannot get the previous node from the root node!");
        if (a == null)
          if (q.isPath(i)) {
            var [l] = M.parent(e, i);
            a = (f) => l.children.includes(f);
          } else
            a = () => !0;
        var [c] = M.nodes(e, {
          reverse: !0,
          at: u,
          match: a,
          mode: n,
          voids: r
        });
        return c;
      }
    }
  },
  range(e, t, n) {
    if (Ae.isRange(t) && !n)
      return t;
    var r = M.start(e, t), a = M.end(e, n || t);
    return {
      anchor: r,
      focus: a
    };
  },
  rangeRef(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      affinity: r = "forward"
    } = n, a = {
      current: t,
      affinity: r,
      unref() {
        var {
          current: o
        } = a, s = M.rangeRefs(e);
        return s.delete(a), a.current = null, o;
      }
    }, i = M.rangeRefs(e);
    return i.add(a), a;
  },
  rangeRefs(e) {
    var t = Kh.get(e);
    return t || (t = /* @__PURE__ */ new Set(), Kh.set(e, t)), t;
  },
  removeMark(e, t) {
    e.removeMark(t);
  },
  setNormalizing(e, t) {
    Gh.set(e, t);
  },
  start(e, t) {
    return M.point(e, t, {
      edge: "start"
    });
  },
  string(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      voids: r = !1
    } = n, a = M.range(e, t), [i, o] = Ae.edges(a), s = "";
    for (var [u, l] of M.nodes(e, {
      at: a,
      match: Ue.isText,
      voids: r
    })) {
      var c = u.text;
      q.equals(l, o.path) && (c = c.slice(0, o.offset)), q.equals(l, i.path) && (c = c.slice(i.offset)), s += c;
    }
    return s;
  },
  unhangRange(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      voids: r = !1
    } = n, [a, i] = Ae.edges(t);
    if (a.offset !== 0 || i.offset !== 0 || Ae.isCollapsed(t))
      return t;
    var o = M.above(e, {
      at: i,
      match: (T) => M.isBlock(e, T)
    }), s = o ? o[1] : [], u = M.start(e, a), l = {
      anchor: u,
      focus: i
    }, c = !0;
    for (var [f, E] of M.nodes(e, {
      at: l,
      match: Ue.isText,
      reverse: !0,
      voids: r
    })) {
      if (c) {
        c = !1;
        continue;
      }
      if (f.text !== "" || q.isBefore(E, s)) {
        i = {
          path: E,
          offset: f.text.length
        };
        break;
      }
    }
    return {
      anchor: a,
      focus: i
    };
  },
  void(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return M.above(e, ja(ja({}, t), {}, {
      match: (n) => M.isVoid(e, n)
    }));
  },
  withoutNormalizing(e, t) {
    var n = M.isNormalizing(e);
    M.setNormalizing(e, !1);
    try {
      t();
    } finally {
      M.setNormalizing(e, n);
    }
    M.normalize(e);
  }
}, mS = {
  isSpan(e) {
    return Array.isArray(e) && e.length === 2 && e.every(q.isPath);
  }
}, pS = ["children"], gS = ["text"], Zh = /* @__PURE__ */ new WeakMap(), Re = {
  ancestor(e, t) {
    var n = Re.get(e, t);
    if (Ue.isText(n))
      throw new Error("Cannot get the ancestor node at path [".concat(t, "] because it refers to a text node instead: ").concat(n));
    return n;
  },
  *ancestors(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    for (var r of q.ancestors(t, n)) {
      var a = Re.ancestor(e, r), i = [a, r];
      yield i;
    }
  },
  child(e, t) {
    if (Ue.isText(e))
      throw new Error("Cannot get the child of a text node: ".concat(JSON.stringify(e)));
    var n = e.children[t];
    if (n == null)
      throw new Error("Cannot get child at index `".concat(t, "` in node: ").concat(JSON.stringify(e)));
    return n;
  },
  *children(e, t) {
    for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      reverse: r = !1
    } = n, a = Re.ancestor(e, t), {
      children: i
    } = a, o = r ? i.length - 1 : 0; r ? o >= 0 : o < i.length; ) {
      var s = Re.child(a, o), u = t.concat(o);
      yield [s, u], o = r ? o - 1 : o + 1;
    }
  },
  common(e, t, n) {
    var r = q.common(t, n), a = Re.get(e, r);
    return [a, r];
  },
  descendant(e, t) {
    var n = Re.get(e, t);
    if (M.isEditor(n))
      throw new Error("Cannot get the descendant node at path [".concat(t, "] because it refers to the root editor node instead: ").concat(n));
    return n;
  },
  *descendants(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    for (var [n, r] of Re.nodes(e, t))
      r.length !== 0 && (yield [n, r]);
  },
  *elements(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    for (var [n, r] of Re.nodes(e, t))
      Ft.isElement(n) && (yield [n, r]);
  },
  extractProps(e) {
    if (Ft.isAncestor(e)) {
      var t = kr(e, pS);
      return t;
    } else {
      var t = kr(e, gS);
      return t;
    }
  },
  first(e, t) {
    for (var n = t.slice(), r = Re.get(e, n); r && !(Ue.isText(r) || r.children.length === 0); )
      r = r.children[0], n.push(0);
    return [r, n];
  },
  fragment(e, t) {
    if (Ue.isText(e))
      throw new Error("Cannot get a fragment starting from a root text node: ".concat(JSON.stringify(e)));
    var n = qo({
      children: e.children
    }, (r) => {
      var [a, i] = Ae.edges(t), o = Re.nodes(r, {
        reverse: !0,
        pass: (E) => {
          var [, T] = E;
          return !Ae.includes(t, T);
        }
      });
      for (var [, s] of o) {
        if (!Ae.includes(t, s)) {
          var u = Re.parent(r, s), l = s[s.length - 1];
          u.children.splice(l, 1);
        }
        if (q.equals(s, i.path)) {
          var c = Re.leaf(r, s);
          c.text = c.text.slice(0, i.offset);
        }
        if (q.equals(s, a.path)) {
          var f = Re.leaf(r, s);
          f.text = f.text.slice(a.offset);
        }
      }
      M.isEditor(r) && (r.selection = null);
    });
    return n.children;
  },
  get(e, t) {
    for (var n = e, r = 0; r < t.length; r++) {
      var a = t[r];
      if (Ue.isText(n) || !n.children[a])
        throw new Error("Cannot find a descendant at path [".concat(t, "] in node: ").concat(JSON.stringify(e)));
      n = n.children[a];
    }
    return n;
  },
  has(e, t) {
    for (var n = e, r = 0; r < t.length; r++) {
      var a = t[r];
      if (Ue.isText(n) || !n.children[a])
        return !1;
      n = n.children[a];
    }
    return !0;
  },
  isNode(e) {
    return Ue.isText(e) || Ft.isElement(e) || M.isEditor(e);
  },
  isNodeList(e) {
    if (!Array.isArray(e))
      return !1;
    var t = Zh.get(e);
    if (t !== void 0)
      return t;
    var n = e.every((r) => Re.isNode(r));
    return Zh.set(e, n), n;
  },
  last(e, t) {
    for (var n = t.slice(), r = Re.get(e, n); r && !(Ue.isText(r) || r.children.length === 0); ) {
      var a = r.children.length - 1;
      r = r.children[a], n.push(a);
    }
    return [r, n];
  },
  leaf(e, t) {
    var n = Re.get(e, t);
    if (!Ue.isText(n))
      throw new Error("Cannot get the leaf node at path [".concat(t, "] because it refers to a non-leaf node: ").concat(n));
    return n;
  },
  *levels(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    for (var r of q.levels(t, n)) {
      var a = Re.get(e, r);
      yield [a, r];
    }
  },
  matches(e, t) {
    return Ft.isElement(e) && Ft.isElementProps(t) && Ft.matches(e, t) || Ue.isText(e) && Ue.isTextProps(t) && Ue.matches(e, t);
  },
  *nodes(e) {
    for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      pass: n,
      reverse: r = !1
    } = t, {
      from: a = [],
      to: i
    } = t, o = /* @__PURE__ */ new Set(), s = [], u = e; !(i && (r ? q.isBefore(s, i) : q.isAfter(s, i))); ) {
      if (o.has(u) || (yield [u, s]), !o.has(u) && !Ue.isText(u) && u.children.length !== 0 && (n == null || n([u, s]) === !1)) {
        o.add(u);
        var l = r ? u.children.length - 1 : 0;
        q.isAncestor(s, a) && (l = a[s.length]), s = s.concat(l), u = Re.get(e, s);
        continue;
      }
      if (s.length === 0)
        break;
      if (!r) {
        var c = q.next(s);
        if (Re.has(e, c)) {
          s = c, u = Re.get(e, s);
          continue;
        }
      }
      if (r && s[s.length - 1] !== 0) {
        var f = q.previous(s);
        s = f, u = Re.get(e, s);
        continue;
      }
      s = q.parent(s), u = Re.get(e, s), o.add(u);
    }
  },
  parent(e, t) {
    var n = q.parent(t), r = Re.get(e, n);
    if (Ue.isText(r))
      throw new Error("Cannot get the parent of path [".concat(t, "] because it does not exist in the root."));
    return r;
  },
  string(e) {
    return Ue.isText(e) ? e.text : e.children.map(Re.string).join("");
  },
  *texts(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    for (var [n, r] of Re.nodes(e, t))
      Ue.isText(n) && (yield [n, r]);
  }
};
function Jh(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Bt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Jh(Object(n), !0).forEach(function(r) {
      Fr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Jh(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Vi = {
  isNodeOperation(e) {
    return Vi.isOperation(e) && e.type.endsWith("_node");
  },
  isOperation(e) {
    if (!ln(e))
      return !1;
    switch (e.type) {
      case "insert_node":
        return q.isPath(e.path) && Re.isNode(e.node);
      case "insert_text":
        return typeof e.offset == "number" && typeof e.text == "string" && q.isPath(e.path);
      case "merge_node":
        return typeof e.position == "number" && q.isPath(e.path) && ln(e.properties);
      case "move_node":
        return q.isPath(e.path) && q.isPath(e.newPath);
      case "remove_node":
        return q.isPath(e.path) && Re.isNode(e.node);
      case "remove_text":
        return typeof e.offset == "number" && typeof e.text == "string" && q.isPath(e.path);
      case "set_node":
        return q.isPath(e.path) && ln(e.properties) && ln(e.newProperties);
      case "set_selection":
        return e.properties === null && Ae.isRange(e.newProperties) || e.newProperties === null && Ae.isRange(e.properties) || ln(e.properties) && ln(e.newProperties);
      case "split_node":
        return q.isPath(e.path) && typeof e.position == "number" && ln(e.properties);
      default:
        return !1;
    }
  },
  isOperationList(e) {
    return Array.isArray(e) && e.every((t) => Vi.isOperation(t));
  },
  isSelectionOperation(e) {
    return Vi.isOperation(e) && e.type.endsWith("_selection");
  },
  isTextOperation(e) {
    return Vi.isOperation(e) && e.type.endsWith("_text");
  },
  inverse(e) {
    switch (e.type) {
      case "insert_node":
        return Bt(Bt({}, e), {}, {
          type: "remove_node"
        });
      case "insert_text":
        return Bt(Bt({}, e), {}, {
          type: "remove_text"
        });
      case "merge_node":
        return Bt(Bt({}, e), {}, {
          type: "split_node",
          path: q.previous(e.path)
        });
      case "move_node": {
        var {
          newPath: t,
          path: n
        } = e;
        if (q.equals(t, n))
          return e;
        if (q.isSibling(n, t))
          return Bt(Bt({}, e), {}, {
            path: t,
            newPath: n
          });
        var r = q.transform(n, e), a = q.transform(q.next(n), e);
        return Bt(Bt({}, e), {}, {
          path: r,
          newPath: a
        });
      }
      case "remove_node":
        return Bt(Bt({}, e), {}, {
          type: "insert_node"
        });
      case "remove_text":
        return Bt(Bt({}, e), {}, {
          type: "insert_text"
        });
      case "set_node": {
        var {
          properties: i,
          newProperties: o
        } = e;
        return Bt(Bt({}, e), {}, {
          properties: o,
          newProperties: i
        });
      }
      case "set_selection": {
        var {
          properties: s,
          newProperties: u
        } = e;
        return s == null ? Bt(Bt({}, e), {}, {
          properties: u,
          newProperties: null
        }) : u == null ? Bt(Bt({}, e), {}, {
          properties: null,
          newProperties: s
        }) : Bt(Bt({}, e), {}, {
          properties: u,
          newProperties: s
        });
      }
      case "split_node":
        return Bt(Bt({}, e), {}, {
          type: "merge_node",
          path: q.next(e.path)
        });
    }
  }
}, q = {
  ancestors(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, r = q.levels(e, t);
    return n ? r = r.slice(1) : r = r.slice(0, -1), r;
  },
  common(e, t) {
    for (var n = [], r = 0; r < e.length && r < t.length; r++) {
      var a = e[r], i = t[r];
      if (a !== i)
        break;
      n.push(a);
    }
    return n;
  },
  compare(e, t) {
    for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) {
      if (e[r] < t[r])
        return -1;
      if (e[r] > t[r])
        return 1;
    }
    return 0;
  },
  endsAfter(e, t) {
    var n = e.length - 1, r = e.slice(0, n), a = t.slice(0, n), i = e[n], o = t[n];
    return q.equals(r, a) && i > o;
  },
  endsAt(e, t) {
    var n = e.length, r = e.slice(0, n), a = t.slice(0, n);
    return q.equals(r, a);
  },
  endsBefore(e, t) {
    var n = e.length - 1, r = e.slice(0, n), a = t.slice(0, n), i = e[n], o = t[n];
    return q.equals(r, a) && i < o;
  },
  equals(e, t) {
    return e.length === t.length && e.every((n, r) => n === t[r]);
  },
  hasPrevious(e) {
    return e[e.length - 1] > 0;
  },
  isAfter(e, t) {
    return q.compare(e, t) === 1;
  },
  isAncestor(e, t) {
    return e.length < t.length && q.compare(e, t) === 0;
  },
  isBefore(e, t) {
    return q.compare(e, t) === -1;
  },
  isChild(e, t) {
    return e.length === t.length + 1 && q.compare(e, t) === 0;
  },
  isCommon(e, t) {
    return e.length <= t.length && q.compare(e, t) === 0;
  },
  isDescendant(e, t) {
    return e.length > t.length && q.compare(e, t) === 0;
  },
  isParent(e, t) {
    return e.length + 1 === t.length && q.compare(e, t) === 0;
  },
  isPath(e) {
    return Array.isArray(e) && (e.length === 0 || typeof e[0] == "number");
  },
  isSibling(e, t) {
    if (e.length !== t.length)
      return !1;
    var n = e.slice(0, -1), r = t.slice(0, -1), a = e[e.length - 1], i = t[t.length - 1];
    return a !== i && q.equals(n, r);
  },
  levels(e) {
    for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, r = [], a = 0; a <= e.length; a++)
      r.push(e.slice(0, a));
    return n && r.reverse(), r;
  },
  next(e) {
    if (e.length === 0)
      throw new Error("Cannot get the next path of a root path [".concat(e, "], because it has no next index."));
    var t = e[e.length - 1];
    return e.slice(0, -1).concat(t + 1);
  },
  operationCanTransformPath(e) {
    switch (e.type) {
      case "insert_node":
      case "remove_node":
      case "merge_node":
      case "split_node":
      case "move_node":
        return !0;
      default:
        return !1;
    }
  },
  parent(e) {
    if (e.length === 0)
      throw new Error("Cannot get the parent path of the root path [".concat(e, "]."));
    return e.slice(0, -1);
  },
  previous(e) {
    if (e.length === 0)
      throw new Error("Cannot get the previous path of a root path [".concat(e, "], because it has no previous index."));
    var t = e[e.length - 1];
    if (t <= 0)
      throw new Error("Cannot get the previous path of a first child path [".concat(e, "] because it would result in a negative index."));
    return e.slice(0, -1).concat(t - 1);
  },
  relative(e, t) {
    if (!q.isAncestor(t, e) && !q.equals(e, t))
      throw new Error("Cannot get the relative path of [".concat(e, "] inside ancestor [").concat(t, "], because it is not above or equal to the path."));
    return e.slice(t.length);
  },
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return qo(e, (r) => {
      var {
        affinity: a = "forward"
      } = n;
      if (!(!e || (e == null ? void 0 : e.length) === 0)) {
        if (r === null)
          return null;
        switch (t.type) {
          case "insert_node": {
            var {
              path: i
            } = t;
            (q.equals(i, r) || q.endsBefore(i, r) || q.isAncestor(i, r)) && (r[i.length - 1] += 1);
            break;
          }
          case "remove_node": {
            var {
              path: o
            } = t;
            if (q.equals(o, r) || q.isAncestor(o, r))
              return null;
            q.endsBefore(o, r) && (r[o.length - 1] -= 1);
            break;
          }
          case "merge_node": {
            var {
              path: s,
              position: u
            } = t;
            q.equals(s, r) || q.endsBefore(s, r) ? r[s.length - 1] -= 1 : q.isAncestor(s, r) && (r[s.length - 1] -= 1, r[s.length] += u);
            break;
          }
          case "split_node": {
            var {
              path: l,
              position: c
            } = t;
            if (q.equals(l, r)) {
              if (a === "forward")
                r[r.length - 1] += 1;
              else if (a !== "backward")
                return null;
            } else
              q.endsBefore(l, r) ? r[l.length - 1] += 1 : q.isAncestor(l, r) && e[l.length] >= c && (r[l.length - 1] += 1, r[l.length] -= c);
            break;
          }
          case "move_node": {
            var {
              path: f,
              newPath: E
            } = t;
            if (q.equals(f, E))
              return;
            if (q.isAncestor(f, r) || q.equals(f, r)) {
              var T = E.slice();
              return q.endsBefore(f, E) && f.length < E.length && (T[f.length - 1] -= 1), T.concat(r.slice(f.length));
            } else
              q.isSibling(f, E) && (q.isAncestor(E, r) || q.equals(E, r)) ? q.endsBefore(f, r) ? r[f.length - 1] -= 1 : r[f.length - 1] += 1 : q.endsBefore(E, r) || q.equals(E, r) || q.isAncestor(E, r) ? (q.endsBefore(f, r) && (r[f.length - 1] -= 1), r[E.length - 1] += 1) : q.endsBefore(f, r) && (q.equals(E, r) && (r[E.length - 1] += 1), r[f.length - 1] -= 1);
            break;
          }
        }
      }
    });
  }
};
function ed(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function td(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ed(Object(n), !0).forEach(function(r) {
      Fr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ed(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var lt = {
  compare(e, t) {
    var n = q.compare(e.path, t.path);
    return n === 0 ? e.offset < t.offset ? -1 : e.offset > t.offset ? 1 : 0 : n;
  },
  isAfter(e, t) {
    return lt.compare(e, t) === 1;
  },
  isBefore(e, t) {
    return lt.compare(e, t) === -1;
  },
  equals(e, t) {
    return e.offset === t.offset && q.equals(e.path, t.path);
  },
  isPoint(e) {
    return ln(e) && typeof e.offset == "number" && q.isPath(e.path);
  },
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return qo(e, (r) => {
      if (r === null)
        return null;
      var {
        affinity: a = "forward"
      } = n, {
        path: i,
        offset: o
      } = r;
      switch (t.type) {
        case "insert_node":
        case "move_node": {
          r.path = q.transform(i, t, n);
          break;
        }
        case "insert_text": {
          q.equals(t.path, i) && t.offset <= o && (r.offset += t.text.length);
          break;
        }
        case "merge_node": {
          q.equals(t.path, i) && (r.offset += t.position), r.path = q.transform(i, t, n);
          break;
        }
        case "remove_text": {
          q.equals(t.path, i) && t.offset <= o && (r.offset -= Math.min(o - t.offset, t.text.length));
          break;
        }
        case "remove_node": {
          if (q.equals(t.path, i) || q.isAncestor(t.path, i))
            return null;
          r.path = q.transform(i, t, n);
          break;
        }
        case "split_node": {
          if (q.equals(t.path, i)) {
            if (t.position === o && a == null)
              return null;
            (t.position < o || t.position === o && a === "forward") && (r.offset -= t.position, r.path = q.transform(i, t, td(td({}, n), {}, {
              affinity: "forward"
            })));
          } else
            r.path = q.transform(i, t, n);
          break;
        }
      }
    });
  }
}, ES = ["anchor", "focus"];
function nd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function TS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nd(Object(n), !0).forEach(function(r) {
      Fr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Ae = {
  edges(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, {
      anchor: r,
      focus: a
    } = e;
    return Ae.isBackward(e) === n ? [r, a] : [a, r];
  },
  end(e) {
    var [, t] = Ae.edges(e);
    return t;
  },
  equals(e, t) {
    return lt.equals(e.anchor, t.anchor) && lt.equals(e.focus, t.focus);
  },
  includes(e, t) {
    if (Ae.isRange(t)) {
      if (Ae.includes(e, t.anchor) || Ae.includes(e, t.focus))
        return !0;
      var [n, r] = Ae.edges(e), [a, i] = Ae.edges(t);
      return lt.isBefore(n, a) && lt.isAfter(r, i);
    }
    var [o, s] = Ae.edges(e), u = !1, l = !1;
    return lt.isPoint(t) ? (u = lt.compare(t, o) >= 0, l = lt.compare(t, s) <= 0) : (u = q.compare(t, o.path) >= 0, l = q.compare(t, s.path) <= 0), u && l;
  },
  intersection(e, t) {
    var n = kr(e, ES), [r, a] = Ae.edges(e), [i, o] = Ae.edges(t), s = lt.isBefore(r, i) ? i : r, u = lt.isBefore(a, o) ? a : o;
    return lt.isBefore(u, s) ? null : TS({
      anchor: s,
      focus: u
    }, n);
  },
  isBackward(e) {
    var {
      anchor: t,
      focus: n
    } = e;
    return lt.isAfter(t, n);
  },
  isCollapsed(e) {
    var {
      anchor: t,
      focus: n
    } = e;
    return lt.equals(t, n);
  },
  isExpanded(e) {
    return !Ae.isCollapsed(e);
  },
  isForward(e) {
    return !Ae.isBackward(e);
  },
  isRange(e) {
    return ln(e) && lt.isPoint(e.anchor) && lt.isPoint(e.focus);
  },
  *points(e) {
    yield [e.anchor, "anchor"], yield [e.focus, "focus"];
  },
  start(e) {
    var [t] = Ae.edges(e);
    return t;
  },
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return qo(e, (r) => {
      if (r === null)
        return null;
      var {
        affinity: a = "inward"
      } = n, i, o;
      if (a === "inward") {
        var s = Ae.isCollapsed(r);
        Ae.isForward(r) ? (i = "forward", o = s ? i : "backward") : (i = "backward", o = s ? i : "forward");
      } else
        a === "outward" ? Ae.isForward(r) ? (i = "backward", o = "forward") : (i = "forward", o = "backward") : (i = a, o = a);
      var u = lt.transform(r.anchor, t, {
        affinity: i
      }), l = lt.transform(r.focus, t, {
        affinity: o
      });
      if (!u || !l)
        return null;
      r.anchor = u, r.focus = l;
    });
  }
}, Pp = (e, t) => {
  for (var n in e) {
    var r = e[n], a = t[n];
    if (ln(r) && ln(a)) {
      if (!Pp(r, a))
        return !1;
    } else if (Array.isArray(r) && Array.isArray(a)) {
      if (r.length !== a.length)
        return !1;
      for (var i = 0; i < r.length; i++)
        if (r[i] !== a[i])
          return !1;
    } else if (r !== a)
      return !1;
  }
  for (var o in t)
    if (e[o] === void 0 && t[o] !== void 0)
      return !1;
  return !0;
}, vS = ["text"], AS = ["anchor", "focus"];
function rd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function br(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rd(Object(n), !0).forEach(function(r) {
      Fr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Ue = {
  equals(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      loose: r = !1
    } = n;
    function a(i) {
      var o = kr(i, vS);
      return o;
    }
    return Pp(r ? a(e) : e, r ? a(t) : t);
  },
  isText(e) {
    return ln(e) && typeof e.text == "string";
  },
  isTextList(e) {
    return Array.isArray(e) && e.every((t) => Ue.isText(t));
  },
  isTextProps(e) {
    return e.text !== void 0;
  },
  matches(e, t) {
    for (var n in t)
      if (n !== "text" && (!e.hasOwnProperty(n) || e[n] !== t[n]))
        return !1;
    return !0;
  },
  decorations(e, t) {
    var n = [br({}, e)];
    for (var r of t) {
      var a = kr(r, AS), [i, o] = Ae.edges(r), s = [], u = 0;
      for (var l of n) {
        var {
          length: c
        } = l.text, f = u;
        if (u += c, i.offset <= f && o.offset >= u) {
          Object.assign(l, a), s.push(l);
          continue;
        }
        if (i.offset !== o.offset && (i.offset === u || o.offset === f) || i.offset > u || o.offset < f || o.offset === f && f !== 0) {
          s.push(l);
          continue;
        }
        var E = l, T = void 0, g = void 0;
        if (o.offset < u) {
          var m = o.offset - f;
          g = br(br({}, E), {}, {
            text: E.text.slice(m)
          }), E = br(br({}, E), {}, {
            text: E.text.slice(0, m)
          });
        }
        if (i.offset > f) {
          var v = i.offset - f;
          T = br(br({}, E), {}, {
            text: E.text.slice(0, v)
          }), E = br(br({}, E), {}, {
            text: E.text.slice(v)
          });
        }
        Object.assign(E, a), T && s.push(T), s.push(E), g && s.push(g);
      }
      n = s;
    }
    return n;
  }
};
function ad(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ki(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ad(Object(n), !0).forEach(function(r) {
      Fr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ad(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var CS = (e, t, n) => {
  switch (n.type) {
    case "insert_node": {
      var {
        path: r,
        node: a
      } = n, i = Re.parent(e, r), o = r[r.length - 1];
      if (o > i.children.length)
        throw new Error('Cannot apply an "insert_node" operation at path ['.concat(r, "] because the destination is past the end of the node."));
      if (i.children.splice(o, 0, a), t)
        for (var [s, u] of Ae.points(t))
          t[u] = lt.transform(s, n);
      break;
    }
    case "insert_text": {
      var {
        path: l,
        offset: c,
        text: f
      } = n;
      if (f.length === 0)
        break;
      var E = Re.leaf(e, l), T = E.text.slice(0, c), g = E.text.slice(c);
      if (E.text = T + f + g, t)
        for (var [m, v] of Ae.points(t))
          t[v] = lt.transform(m, n);
      break;
    }
    case "merge_node": {
      var {
        path: b
      } = n, y = Re.get(e, b), O = q.previous(b), B = Re.get(e, O), S = Re.parent(e, b), C = b[b.length - 1];
      if (Ue.isText(y) && Ue.isText(B))
        B.text += y.text;
      else if (!Ue.isText(y) && !Ue.isText(B))
        B.children.push(...y.children);
      else
        throw new Error('Cannot apply a "merge_node" operation at path ['.concat(b, "] to nodes of different interfaces: ").concat(y, " ").concat(B));
      if (S.children.splice(C, 1), t)
        for (var [I, G] of Ae.points(t))
          t[G] = lt.transform(I, n);
      break;
    }
    case "move_node": {
      var {
        path: V,
        newPath: w
      } = n;
      if (q.isAncestor(V, w))
        throw new Error("Cannot move a path [".concat(V, "] to new path [").concat(w, "] because the destination is inside itself."));
      var Y = Re.get(e, V), X = Re.parent(e, V), H = V[V.length - 1];
      X.children.splice(H, 1);
      var $ = q.transform(V, n), L = Re.get(e, q.parent($)), Q = $[$.length - 1];
      if (L.children.splice(Q, 0, Y), t)
        for (var [j, ee] of Ae.points(t))
          t[ee] = lt.transform(j, n);
      break;
    }
    case "remove_node": {
      var {
        path: J
      } = n, z = J[J.length - 1], _ = Re.parent(e, J);
      if (_.children.splice(z, 1), t)
        for (var [D, he] of Ae.points(t)) {
          var oe = lt.transform(D, n);
          if (t != null && oe != null)
            t[he] = oe;
          else {
            var ve = void 0, le = void 0;
            for (var [Ce, _e] of Re.texts(e))
              if (q.compare(_e, J) === -1)
                ve = [Ce, _e];
              else {
                le = [Ce, _e];
                break;
              }
            var ge = !1;
            ve && le && (q.equals(le[1], J) ? ge = !q.hasPrevious(le[1]) : ge = q.common(ve[1], J).length < q.common(le[1], J).length), ve && !ge ? (D.path = ve[1], D.offset = ve[0].text.length) : le ? (D.path = le[1], D.offset = 0) : t = null;
          }
        }
      break;
    }
    case "remove_text": {
      var {
        path: ye,
        offset: ze,
        text: ce
      } = n;
      if (ce.length === 0)
        break;
      var Dt = Re.leaf(e, ye), Se = Dt.text.slice(0, ze), Gt = Dt.text.slice(ze + ce.length);
      if (Dt.text = Se + Gt, t)
        for (var [on, kn] of Ae.points(t))
          t[kn] = lt.transform(on, n);
      break;
    }
    case "set_node": {
      var {
        path: Pn,
        properties: Wn,
        newProperties: cr
      } = n;
      if (Pn.length === 0)
        throw new Error("Cannot set properties on the root node!");
      var qn = Re.get(e, Pn);
      for (var sn in cr) {
        if (sn === "children" || sn === "text")
          throw new Error('Cannot set the "'.concat(sn, '" property of nodes!'));
        var vr = cr[sn];
        vr == null ? delete qn[sn] : qn[sn] = vr;
      }
      for (var Ar in Wn)
        cr.hasOwnProperty(Ar) || delete qn[Ar];
      break;
    }
    case "set_selection": {
      var {
        newProperties: hn
      } = n;
      if (hn == null)
        t = hn;
      else {
        if (t == null) {
          if (!Ae.isRange(hn))
            throw new Error('Cannot apply an incomplete "set_selection" operation properties '.concat(JSON.stringify(hn), " when there is no current selection."));
          t = ki({}, hn);
        }
        for (var Tn in hn) {
          var Dn = hn[Tn];
          if (Dn == null) {
            if (Tn === "anchor" || Tn === "focus")
              throw new Error('Cannot remove the "'.concat(Tn, '" selection property'));
            delete t[Tn];
          } else
            t[Tn] = Dn;
        }
      }
      break;
    }
    case "split_node": {
      var {
        path: Z,
        position: Ee,
        properties: ke
      } = n;
      if (Z.length === 0)
        throw new Error('Cannot apply a "split_node" operation at path ['.concat(Z, "] because the root node cannot be split."));
      var je = Re.get(e, Z), qt = Re.parent(e, Z), Bn = Z[Z.length - 1], at;
      if (Ue.isText(je)) {
        var $t = je.text.slice(0, Ee), Fn = je.text.slice(Ee);
        je.text = $t, at = ki(ki({}, ke), {}, {
          text: Fn
        });
      } else {
        var Ln = je.children.slice(0, Ee), Ct = je.children.slice(Ee);
        je.children = Ln, at = ki(ki({}, ke), {}, {
          children: Ct
        });
      }
      if (qt.children.splice(Bn + 1, 0, at), t)
        for (var [Xn, un] of Ae.points(t))
          t[un] = lt.transform(Xn, n);
      break;
    }
  }
  return t;
}, _S = {
  transform(e, t) {
    e.children = Hh(e.children);
    var n = e.selection && Hh(e.selection);
    try {
      n = CS(e, n, t);
    } finally {
      e.children = Uh(e.children), n ? e.selection = _a(n) ? Uh(n) : n : e.selection = null;
    }
  }
}, bS = ["text"], yS = ["children"];
function id(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function od(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? id(Object(n), !0).forEach(function(r) {
      Fr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : id(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var DS = {
  insertNodes(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    M.withoutNormalizing(e, () => {
      var {
        hanging: r = !1,
        voids: a = !1,
        mode: i = "lowest"
      } = n, {
        at: o,
        match: s,
        select: u
      } = n;
      if (Re.isNode(t) && (t = [t]), t.length !== 0) {
        var [l] = t;
        if (o || (e.selection ? o = e.selection : e.children.length > 0 ? o = M.end(e, []) : o = [0], u = !0), u == null && (u = !1), Ae.isRange(o))
          if (r || (o = M.unhangRange(e, o)), Ae.isCollapsed(o))
            o = o.anchor;
          else {
            var [, c] = Ae.edges(o), f = M.pointRef(e, c);
            Le.delete(e, {
              at: o
            }), o = f.unref();
          }
        if (lt.isPoint(o)) {
          s == null && (Ue.isText(l) ? s = (C) => Ue.isText(C) : e.isInline(l) ? s = (C) => Ue.isText(C) || M.isInline(e, C) : s = (C) => M.isBlock(e, C));
          var [E] = M.nodes(e, {
            at: o.path,
            match: s,
            mode: i,
            voids: a
          });
          if (E) {
            var [, T] = E, g = M.pathRef(e, T), m = M.isEnd(e, o, T);
            Le.splitNodes(e, {
              at: o,
              match: s,
              mode: i,
              voids: a
            });
            var v = g.unref();
            o = m ? q.next(v) : v;
          } else
            return;
        }
        var b = q.parent(o), y = o[o.length - 1];
        if (!(!a && M.void(e, {
          at: b
        }))) {
          for (var O of t) {
            var B = b.concat(y);
            y++, e.apply({
              type: "insert_node",
              path: B,
              node: O
            }), o = q.next(o);
          }
          if (o = q.previous(o), u) {
            var S = M.end(e, o);
            S && Le.select(e, S);
          }
        }
      }
    });
  },
  liftNodes(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    M.withoutNormalizing(e, () => {
      var {
        at: n = e.selection,
        mode: r = "lowest",
        voids: a = !1
      } = t, {
        match: i
      } = t;
      if (i == null && (i = q.isPath(n) ? za(e, n) : (O) => M.isBlock(e, O)), !!n) {
        var o = M.nodes(e, {
          at: n,
          match: i,
          mode: r,
          voids: a
        }), s = Array.from(o, (O) => {
          var [, B] = O;
          return M.pathRef(e, B);
        });
        for (var u of s) {
          var l = u.unref();
          if (l.length < 2)
            throw new Error("Cannot lift node at a path [".concat(l, "] because it has a depth of less than `2`."));
          var c = M.node(e, q.parent(l)), [f, E] = c, T = l[l.length - 1], {
            length: g
          } = f.children;
          if (g === 1) {
            var m = q.next(E);
            Le.moveNodes(e, {
              at: l,
              to: m,
              voids: a
            }), Le.removeNodes(e, {
              at: E,
              voids: a
            });
          } else if (T === 0)
            Le.moveNodes(e, {
              at: l,
              to: E,
              voids: a
            });
          else if (T === g - 1) {
            var v = q.next(E);
            Le.moveNodes(e, {
              at: l,
              to: v,
              voids: a
            });
          } else {
            var b = q.next(l), y = q.next(E);
            Le.splitNodes(e, {
              at: b,
              voids: a
            }), Le.moveNodes(e, {
              at: l,
              to: y,
              voids: a
            });
          }
        }
      }
    });
  },
  mergeNodes(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    M.withoutNormalizing(e, () => {
      var {
        match: n,
        at: r = e.selection
      } = t, {
        hanging: a = !1,
        voids: i = !1,
        mode: o = "lowest"
      } = t;
      if (!!r) {
        if (n == null)
          if (q.isPath(r)) {
            var [s] = M.parent(e, r);
            n = (V) => s.children.includes(V);
          } else
            n = (V) => M.isBlock(e, V);
        if (!a && Ae.isRange(r) && (r = M.unhangRange(e, r)), Ae.isRange(r))
          if (Ae.isCollapsed(r))
            r = r.anchor;
          else {
            var [, u] = Ae.edges(r), l = M.pointRef(e, u);
            Le.delete(e, {
              at: r
            }), r = l.unref(), t.at == null && Le.select(e, r);
          }
        var [c] = M.nodes(e, {
          at: r,
          match: n,
          voids: i,
          mode: o
        }), f = M.previous(e, {
          at: r,
          match: n,
          voids: i,
          mode: o
        });
        if (!(!c || !f)) {
          var [E, T] = c, [g, m] = f;
          if (!(T.length === 0 || m.length === 0)) {
            var v = q.next(m), b = q.common(T, m), y = q.isSibling(T, m), O = Array.from(M.levels(e, {
              at: T
            }), (V) => {
              var [w] = V;
              return w;
            }).slice(b.length).slice(0, -1), B = M.above(e, {
              at: T,
              mode: "highest",
              match: (V) => O.includes(V) && Bp(e, V)
            }), S = B && M.pathRef(e, B[1]), C, I;
            if (Ue.isText(E) && Ue.isText(g)) {
              var G = kr(E, bS);
              I = g.text.length, C = G;
            } else if (Ft.isElement(E) && Ft.isElement(g)) {
              var G = kr(E, yS);
              I = g.children.length, C = G;
            } else
              throw new Error("Cannot merge the node at path [".concat(T, "] with the previous sibling because it is not the same kind: ").concat(JSON.stringify(E), " ").concat(JSON.stringify(g)));
            y || Le.moveNodes(e, {
              at: T,
              to: v,
              voids: i
            }), S && Le.removeNodes(e, {
              at: S.current,
              voids: i
            }), Ft.isElement(g) && M.isEmpty(e, g) || Ue.isText(g) && g.text === "" && m[m.length - 1] !== 0 ? Le.removeNodes(e, {
              at: m,
              voids: i
            }) : e.apply({
              type: "merge_node",
              path: v,
              position: I,
              properties: C
            }), S && S.unref();
          }
        }
      }
    });
  },
  moveNodes(e, t) {
    M.withoutNormalizing(e, () => {
      var {
        to: n,
        at: r = e.selection,
        mode: a = "lowest",
        voids: i = !1
      } = t, {
        match: o
      } = t;
      if (!!r) {
        o == null && (o = q.isPath(r) ? za(e, r) : (T) => M.isBlock(e, T));
        var s = M.pathRef(e, n), u = M.nodes(e, {
          at: r,
          match: o,
          mode: a,
          voids: i
        }), l = Array.from(u, (T) => {
          var [, g] = T;
          return M.pathRef(e, g);
        });
        for (var c of l) {
          var f = c.unref(), E = s.current;
          f.length !== 0 && e.apply({
            type: "move_node",
            path: f,
            newPath: E
          }), s.current && q.isSibling(E, f) && q.isAfter(E, f) && (s.current = q.next(s.current));
        }
        s.unref();
      }
    });
  },
  removeNodes(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    M.withoutNormalizing(e, () => {
      var {
        hanging: n = !1,
        voids: r = !1,
        mode: a = "lowest"
      } = t, {
        at: i = e.selection,
        match: o
      } = t;
      if (!!i) {
        o == null && (o = q.isPath(i) ? za(e, i) : (E) => M.isBlock(e, E)), !n && Ae.isRange(i) && (i = M.unhangRange(e, i));
        var s = M.nodes(e, {
          at: i,
          match: o,
          mode: a,
          voids: r
        }), u = Array.from(s, (E) => {
          var [, T] = E;
          return M.pathRef(e, T);
        });
        for (var l of u) {
          var c = l.unref();
          if (c) {
            var [f] = M.node(e, c);
            e.apply({
              type: "remove_node",
              path: c,
              node: f
            });
          }
        }
      }
    });
  },
  setNodes(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    M.withoutNormalizing(e, () => {
      var {
        match: r,
        at: a = e.selection
      } = n, {
        hanging: i = !1,
        mode: o = "lowest",
        split: s = !1,
        voids: u = !1
      } = n;
      if (!!a) {
        if (r == null && (r = q.isPath(a) ? za(e, a) : (S) => M.isBlock(e, S)), !i && Ae.isRange(a) && (a = M.unhangRange(e, a)), s && Ae.isRange(a)) {
          if (Ae.isCollapsed(a) && M.leaf(e, a.anchor)[0].text.length > 0)
            return;
          var l = M.rangeRef(e, a, {
            affinity: "inward"
          }), [c, f] = Ae.edges(a), E = o === "lowest" ? "lowest" : "highest", T = M.isEnd(e, f, f.path);
          Le.splitNodes(e, {
            at: f,
            match: r,
            mode: E,
            voids: u,
            always: !T
          });
          var g = M.isStart(e, c, c.path);
          Le.splitNodes(e, {
            at: c,
            match: r,
            mode: E,
            voids: u,
            always: !g
          }), a = l.unref(), n.at == null && Le.select(e, a);
        }
        for (var [m, v] of M.nodes(e, {
          at: a,
          match: r,
          mode: o,
          voids: u
        })) {
          var b = {}, y = {};
          if (v.length !== 0) {
            var O = !1;
            for (var B in t)
              B === "children" || B === "text" || t[B] !== m[B] && (O = !0, m.hasOwnProperty(B) && (b[B] = m[B]), t[B] != null && (y[B] = t[B]));
            O && e.apply({
              type: "set_node",
              path: v,
              properties: b,
              newProperties: y
            });
          }
        }
      }
    });
  },
  splitNodes(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    M.withoutNormalizing(e, () => {
      var {
        mode: n = "lowest",
        voids: r = !1
      } = t, {
        match: a,
        at: i = e.selection,
        height: o = 0,
        always: s = !1
      } = t;
      if (a == null && (a = (j) => M.isBlock(e, j)), Ae.isRange(i) && (i = SS(e, i)), q.isPath(i)) {
        var u = i, l = M.point(e, u), [c] = M.parent(e, u);
        a = (j) => j === c, o = l.path.length - u.length + 1, i = l, s = !0;
      }
      if (!!i) {
        var f = M.pointRef(e, i, {
          affinity: "backward"
        }), [E] = M.nodes(e, {
          at: i,
          match: a,
          mode: n,
          voids: r
        });
        if (!!E) {
          var T = M.void(e, {
            at: i,
            mode: "highest"
          }), g = 0;
          if (!r && T) {
            var [m, v] = T;
            if (Ft.isElement(m) && e.isInline(m)) {
              var b = M.after(e, v);
              if (!b) {
                var y = {
                  text: ""
                }, O = q.next(v);
                Le.insertNodes(e, y, {
                  at: O,
                  voids: r
                }), b = M.point(e, O);
              }
              i = b, s = !0;
            }
            var B = i.path.length - v.length;
            o = B + 1, s = !0;
          }
          var S = M.pointRef(e, i), C = i.path.length - o, [, I] = E, G = i.path.slice(0, C), V = o === 0 ? i.offset : i.path[C] + g;
          for (var [w, Y] of M.levels(e, {
            at: G,
            reverse: !0,
            voids: r
          })) {
            var X = !1;
            if (Y.length < I.length || Y.length === 0 || !r && M.isVoid(e, w))
              break;
            var H = f.current, $ = M.isEnd(e, H, Y);
            if (s || !f || !M.isEdge(e, H, Y)) {
              X = !0;
              var L = Re.extractProps(w);
              e.apply({
                type: "split_node",
                path: Y,
                position: V,
                properties: L
              });
            }
            V = Y[Y.length - 1] + (X || $ ? 1 : 0);
          }
          if (t.at == null) {
            var Q = S.current || M.end(e, []);
            Le.select(e, Q);
          }
          f.unref(), S.unref();
        }
      }
    });
  },
  unsetNodes(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    Array.isArray(t) || (t = [t]);
    var r = {};
    for (var a of t)
      r[a] = null;
    Le.setNodes(e, r, n);
  },
  unwrapNodes(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    M.withoutNormalizing(e, () => {
      var {
        mode: n = "lowest",
        split: r = !1,
        voids: a = !1
      } = t, {
        at: i = e.selection,
        match: o
      } = t;
      if (!!i) {
        o == null && (o = q.isPath(i) ? za(e, i) : (E) => M.isBlock(e, E)), q.isPath(i) && (i = M.range(e, i));
        var s = Ae.isRange(i) ? M.rangeRef(e, i) : null, u = M.nodes(e, {
          at: i,
          match: o,
          mode: n,
          voids: a
        }), l = Array.from(
          u,
          (E) => {
            var [, T] = E;
            return M.pathRef(e, T);
          }
        ).reverse(), c = function(T) {
          var g = T.unref(), [m] = M.node(e, g), v = M.range(e, g);
          r && s && (v = Ae.intersection(s.current, v)), Le.liftNodes(e, {
            at: v,
            match: (b) => Ft.isAncestor(m) && m.children.includes(b),
            voids: a
          });
        };
        for (var f of l)
          c(f);
        s && s.unref();
      }
    });
  },
  wrapNodes(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    M.withoutNormalizing(e, () => {
      var {
        mode: r = "lowest",
        split: a = !1,
        voids: i = !1
      } = n, {
        match: o,
        at: s = e.selection
      } = n;
      if (!!s) {
        if (o == null && (q.isPath(s) ? o = za(e, s) : e.isInline(t) ? o = (v) => M.isInline(e, v) || Ue.isText(v) : o = (v) => M.isBlock(e, v)), a && Ae.isRange(s)) {
          var [u, l] = Ae.edges(s), c = M.rangeRef(e, s, {
            affinity: "inward"
          });
          Le.splitNodes(e, {
            at: l,
            match: o,
            voids: i
          }), Le.splitNodes(e, {
            at: u,
            match: o,
            voids: i
          }), s = c.unref(), n.at == null && Le.select(e, s);
        }
        var f = Array.from(M.nodes(e, {
          at: s,
          match: e.isInline(t) ? (v) => M.isBlock(e, v) : (v) => M.isEditor(v),
          mode: "lowest",
          voids: i
        }));
        for (var [, E] of f) {
          var T = Ae.isRange(s) ? Ae.intersection(s, M.range(e, E)) : s;
          if (!!T) {
            var g = Array.from(M.nodes(e, {
              at: T,
              match: o,
              mode: r,
              voids: i
            }));
            if (g.length > 0) {
              var m = function() {
                var [v] = g, b = g[g.length - 1], [, y] = v, [, O] = b;
                if (y.length === 0 && O.length === 0)
                  return "continue";
                var B = q.equals(y, O) ? q.parent(y) : q.common(y, O), S = M.range(e, y, O), C = M.node(e, B), [I] = C, G = B.length + 1, V = q.next(O.slice(0, G)), w = od(od({}, t), {}, {
                  children: []
                });
                Le.insertNodes(e, w, {
                  at: V,
                  voids: i
                }), Le.moveNodes(e, {
                  at: S,
                  match: (Y) => Ft.isAncestor(I) && I.children.includes(Y),
                  to: V.concat(0),
                  voids: i
                });
              }();
              if (m === "continue")
                continue;
            }
          }
        }
      }
    });
  }
}, Bp = (e, t) => {
  if (Ft.isElement(t)) {
    var n = t;
    return M.isVoid(e, t) ? !0 : n.children.length === 1 ? Bp(e, n.children[0]) : !1;
  } else
    return !M.isEditor(t);
}, SS = (e, t) => {
  if (Ae.isCollapsed(t))
    return t.anchor;
  var [, n] = Ae.edges(t), r = M.pointRef(e, n);
  return Le.delete(e, {
    at: t
  }), r.unref();
}, za = (e, t) => {
  var [n] = M.node(e, t);
  return (r) => r === n;
};
function sd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ud(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sd(Object(n), !0).forEach(function(r) {
      Fr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var OS = {
  collapse(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      edge: n = "anchor"
    } = t, {
      selection: r
    } = e;
    if (r) {
      if (n === "anchor")
        Le.select(e, r.anchor);
      else if (n === "focus")
        Le.select(e, r.focus);
      else if (n === "start") {
        var [a] = Ae.edges(r);
        Le.select(e, a);
      } else if (n === "end") {
        var [, i] = Ae.edges(r);
        Le.select(e, i);
      }
    } else
      return;
  },
  deselect(e) {
    var {
      selection: t
    } = e;
    t && e.apply({
      type: "set_selection",
      properties: t,
      newProperties: null
    });
  },
  move(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      selection: n
    } = e, {
      distance: r = 1,
      unit: a = "character",
      reverse: i = !1
    } = t, {
      edge: o = null
    } = t;
    if (!!n) {
      o === "start" && (o = Ae.isBackward(n) ? "focus" : "anchor"), o === "end" && (o = Ae.isBackward(n) ? "anchor" : "focus");
      var {
        anchor: s,
        focus: u
      } = n, l = {
        distance: r,
        unit: a
      }, c = {};
      if (o == null || o === "anchor") {
        var f = i ? M.before(e, s, l) : M.after(e, s, l);
        f && (c.anchor = f);
      }
      if (o == null || o === "focus") {
        var E = i ? M.before(e, u, l) : M.after(e, u, l);
        E && (c.focus = E);
      }
      Le.setSelection(e, c);
    }
  },
  select(e, t) {
    var {
      selection: n
    } = e;
    if (t = M.range(e, t), n) {
      Le.setSelection(e, t);
      return;
    }
    if (!Ae.isRange(t))
      throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(JSON.stringify(t)));
    e.apply({
      type: "set_selection",
      properties: n,
      newProperties: t
    });
  },
  setPoint(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      selection: r
    } = e, {
      edge: a = "both"
    } = n;
    if (!!r) {
      a === "start" && (a = Ae.isBackward(r) ? "focus" : "anchor"), a === "end" && (a = Ae.isBackward(r) ? "anchor" : "focus");
      var {
        anchor: i,
        focus: o
      } = r, s = a === "anchor" ? i : o;
      Le.setSelection(e, {
        [a === "anchor" ? "anchor" : "focus"]: ud(ud({}, s), t)
      });
    }
  },
  setSelection(e, t) {
    var {
      selection: n
    } = e, r = {}, a = {};
    if (!!n) {
      for (var i in t)
        (i === "anchor" && t.anchor != null && !lt.equals(t.anchor, n.anchor) || i === "focus" && t.focus != null && !lt.equals(t.focus, n.focus) || i !== "anchor" && i !== "focus" && t[i] !== n[i]) && (r[i] = n[i], a[i] = t[i]);
      Object.keys(r).length > 0 && e.apply({
        type: "set_selection",
        properties: r,
        newProperties: a
      });
    }
  }
}, NS = {
  delete(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    M.withoutNormalizing(e, () => {
      var {
        reverse: n = !1,
        unit: r = "character",
        distance: a = 1,
        voids: i = !1
      } = t, {
        at: o = e.selection,
        hanging: s = !1
      } = t;
      if (!!o) {
        if (Ae.isRange(o) && Ae.isCollapsed(o) && (o = o.anchor), lt.isPoint(o)) {
          var u = M.void(e, {
            at: o,
            mode: "highest"
          });
          if (!i && u) {
            var [, l] = u;
            o = l;
          } else {
            var c = {
              unit: r,
              distance: a
            }, f = n ? M.before(e, o, c) || M.start(e, []) : M.after(e, o, c) || M.end(e, []);
            o = {
              anchor: o,
              focus: f
            }, s = !0;
          }
        }
        if (q.isPath(o)) {
          Le.removeNodes(e, {
            at: o,
            voids: i
          });
          return;
        }
        if (!Ae.isCollapsed(o)) {
          if (!s) {
            var [, E] = Ae.edges(o), T = M.end(e, []);
            lt.equals(E, T) || (o = M.unhangRange(e, o, {
              voids: i
            }));
          }
          var [g, m] = Ae.edges(o), v = M.above(e, {
            match: (ge) => M.isBlock(e, ge),
            at: g,
            voids: i
          }), b = M.above(e, {
            match: (ge) => M.isBlock(e, ge),
            at: m,
            voids: i
          }), y = v && b && !q.equals(v[1], b[1]), O = q.equals(g.path, m.path), B = i ? null : M.void(e, {
            at: g,
            mode: "highest"
          }), S = i ? null : M.void(e, {
            at: m,
            mode: "highest"
          });
          if (B) {
            var C = M.before(e, g);
            C && v && q.isAncestor(v[1], C.path) && (g = C);
          }
          if (S) {
            var I = M.after(e, m);
            I && b && q.isAncestor(b[1], I.path) && (m = I);
          }
          var G = [], V;
          for (var w of M.nodes(e, {
            at: o,
            voids: i
          })) {
            var [Y, X] = w;
            V && q.compare(X, V) === 0 || (!i && M.isVoid(e, Y) || !q.isCommon(X, g.path) && !q.isCommon(X, m.path)) && (G.push(w), V = X);
          }
          var H = Array.from(G, (ge) => {
            var [, ye] = ge;
            return M.pathRef(e, ye);
          }), $ = M.pointRef(e, g), L = M.pointRef(e, m);
          if (!O && !B) {
            var Q = $.current, [j] = M.leaf(e, Q), {
              path: ee
            } = Q, {
              offset: J
            } = g, z = j.text.slice(J);
            z.length > 0 && e.apply({
              type: "remove_text",
              path: ee,
              offset: J,
              text: z
            });
          }
          for (var _ of H) {
            var D = _.unref();
            Le.removeNodes(e, {
              at: D,
              voids: i
            });
          }
          if (!S) {
            var he = L.current, [oe] = M.leaf(e, he), {
              path: ve
            } = he, le = O ? g.offset : 0, Ce = oe.text.slice(le, m.offset);
            Ce.length > 0 && e.apply({
              type: "remove_text",
              path: ve,
              offset: le,
              text: Ce
            });
          }
          !O && y && L.current && $.current && Le.mergeNodes(e, {
            at: L.current,
            hanging: !0,
            voids: i
          });
          var _e = n ? $.unref() || L.unref() : L.unref() || $.unref();
          t.at == null && _e && Le.select(e, _e);
        }
      }
    });
  },
  insertFragment(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    M.withoutNormalizing(e, () => {
      var {
        hanging: r = !1,
        voids: a = !1
      } = n, {
        at: i = e.selection
      } = n;
      if (!!t.length) {
        if (i)
          if (Ae.isRange(i))
            if (r || (i = M.unhangRange(e, i)), Ae.isCollapsed(i))
              i = i.anchor;
            else {
              var [, o] = Ae.edges(i);
              if (!a && M.void(e, {
                at: o
              }))
                return;
              var s = M.pointRef(e, o);
              Le.delete(e, {
                at: i
              }), i = s.unref();
            }
          else
            q.isPath(i) && (i = M.start(e, i));
        else
          return;
        if (!(!a && M.void(e, {
          at: i
        }))) {
          var u = M.above(e, {
            at: i,
            match: (oe) => M.isInline(e, oe),
            mode: "highest",
            voids: a
          });
          if (u) {
            var [, l] = u;
            if (M.isEnd(e, i, l)) {
              var c = M.after(e, l);
              i = c;
            } else if (M.isStart(e, i, l)) {
              var f = M.before(e, l);
              i = f;
            }
          }
          var E = M.above(e, {
            match: (oe) => M.isBlock(e, oe),
            at: i,
            voids: a
          }), [, T] = E, g = M.isStart(e, i, T), m = M.isEnd(e, i, T), v = g && m, b = !g || g && m, y = !m, [, O] = Re.first({
            children: t
          }, []), [, B] = Re.last({
            children: t
          }, []), S = [], C = (oe) => {
            var [ve, le] = oe, Ce = le.length === 0;
            return Ce ? !1 : v ? !0 : !(b && q.isAncestor(le, O) && Ft.isElement(ve) && !e.isVoid(ve) && !e.isInline(ve) || y && q.isAncestor(le, B) && Ft.isElement(ve) && !e.isVoid(ve) && !e.isInline(ve));
          };
          for (var I of Re.nodes({
            children: t
          }, {
            pass: C
          }))
            C(I) && S.push(I);
          var G = [], V = [], w = [], Y = !0, X = !1;
          for (var [H] of S)
            Ft.isElement(H) && !e.isInline(H) ? (Y = !1, X = !0, V.push(H)) : Y ? G.push(H) : w.push(H);
          var [$] = M.nodes(e, {
            at: i,
            match: (oe) => Ue.isText(oe) || M.isInline(e, oe),
            mode: "highest",
            voids: a
          }), [, L] = $, Q = M.isStart(e, i, L), j = M.isEnd(e, i, L), ee = M.pathRef(e, m ? q.next(T) : T), J = M.pathRef(e, j ? q.next(L) : L), z = M.pathRef(e, T);
          Le.splitNodes(e, {
            at: i,
            match: (oe) => X ? M.isBlock(e, oe) : Ue.isText(oe) || M.isInline(e, oe),
            mode: X ? "lowest" : "highest",
            voids: a
          });
          var _ = M.pathRef(e, !Q || Q && j ? q.next(L) : L);
          if (Le.insertNodes(e, G, {
            at: _.current,
            match: (oe) => Ue.isText(oe) || M.isInline(e, oe),
            mode: "highest",
            voids: a
          }), v && V.length && Le.delete(e, {
            at: z.unref(),
            voids: a
          }), Le.insertNodes(e, V, {
            at: ee.current,
            match: (oe) => M.isBlock(e, oe),
            mode: "lowest",
            voids: a
          }), Le.insertNodes(e, w, {
            at: J.current,
            match: (oe) => Ue.isText(oe) || M.isInline(e, oe),
            mode: "highest",
            voids: a
          }), !n.at) {
            var D;
            w.length > 0 ? D = q.previous(J.current) : V.length > 0 ? D = q.previous(ee.current) : D = q.previous(_.current);
            var he = M.end(e, D);
            Le.select(e, he);
          }
          _.unref(), ee.unref(), J.unref();
        }
      }
    });
  },
  insertText(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    M.withoutNormalizing(e, () => {
      var {
        voids: r = !1
      } = n, {
        at: a = e.selection
      } = n;
      if (!!a) {
        if (q.isPath(a) && (a = M.range(e, a)), Ae.isRange(a))
          if (Ae.isCollapsed(a))
            a = a.anchor;
          else {
            var i = Ae.end(a);
            if (!r && M.void(e, {
              at: i
            }))
              return;
            var o = Ae.start(a), s = M.pointRef(e, o);
            Le.delete(e, {
              at: a,
              voids: r
            }), a = s.unref(), Le.setSelection(e, {
              anchor: a,
              focus: a
            });
          }
        if (!(!r && M.void(e, {
          at: a
        }))) {
          var {
            path: u,
            offset: l
          } = a;
          t.length > 0 && e.apply({
            type: "insert_text",
            path: u,
            offset: l,
            text: t
          });
        }
      }
    });
  }
};
function ld(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function B1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ld(Object(n), !0).forEach(function(r) {
      Fr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ld(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Le = B1(B1(B1(B1({}, _S), DS), OS), NS);
const Fp = (e) => e.type === Aa.LINK, Lp = (e) => e.type === Aa.VARIABLE, wS = (e, t) => Ft.isElement(e) ? Fp(e) && t.markdownLinks ? `[${Hp(e.children)}](${e.url})` : Lp(e) && t.encodeVariables ? `{${e.name}}` : $p(e.children, t).join("") : Re.string(e), $p = (e, t) => e.map((n) => wS(n, t)), Hp = (e, { encodeVariables: t = !0, markdownLinks: n = !1 } = {}) => $p(e, { encodeVariables: t, markdownLinks: n }).join(`
`).trim(), IS = {
  "Amazon Silk": "amazon_silk",
  "Android Browser": "android",
  Bada: "bada",
  BlackBerry: "blackberry",
  Chrome: "chrome",
  Chromium: "chromium",
  Electron: "electron",
  Epiphany: "epiphany",
  Firefox: "firefox",
  Focus: "focus",
  Generic: "generic",
  "Google Search": "google_search",
  Googlebot: "googlebot",
  "Internet Explorer": "ie",
  "K-Meleon": "k_meleon",
  Maxthon: "maxthon",
  "Microsoft Edge": "edge",
  "MZ Browser": "mz",
  "NAVER Whale Browser": "naver",
  Opera: "opera",
  "Opera Coast": "opera_coast",
  PhantomJS: "phantomjs",
  Puffin: "puffin",
  QupZilla: "qupzilla",
  QQ: "qq",
  QQLite: "qqlite",
  Safari: "safari",
  Sailfish: "sailfish",
  "Samsung Internet for Android": "samsung_internet",
  SeaMonkey: "seamonkey",
  Sleipnir: "sleipnir",
  Swing: "swing",
  Tizen: "tizen",
  "UC Browser": "uc",
  Vivaldi: "vivaldi",
  "WebOS Browser": "webos",
  WeChat: "wechat",
  "Yandex Browser": "yandex",
  Roku: "roku"
}, Up = {
  amazon_silk: "Amazon Silk",
  android: "Android Browser",
  bada: "Bada",
  blackberry: "BlackBerry",
  chrome: "Chrome",
  chromium: "Chromium",
  electron: "Electron",
  epiphany: "Epiphany",
  firefox: "Firefox",
  focus: "Focus",
  generic: "Generic",
  googlebot: "Googlebot",
  google_search: "Google Search",
  ie: "Internet Explorer",
  k_meleon: "K-Meleon",
  maxthon: "Maxthon",
  edge: "Microsoft Edge",
  mz: "MZ Browser",
  naver: "NAVER Whale Browser",
  opera: "Opera",
  opera_coast: "Opera Coast",
  phantomjs: "PhantomJS",
  puffin: "Puffin",
  qupzilla: "QupZilla",
  qq: "QQ Browser",
  qqlite: "QQ Browser Lite",
  safari: "Safari",
  sailfish: "Sailfish",
  samsung_internet: "Samsung Internet for Android",
  seamonkey: "SeaMonkey",
  sleipnir: "Sleipnir",
  swing: "Swing",
  tizen: "Tizen",
  uc: "UC Browser",
  vivaldi: "Vivaldi",
  webos: "WebOS Browser",
  wechat: "WeChat",
  yandex: "Yandex Browser"
}, Vt = {
  tablet: "tablet",
  mobile: "mobile",
  desktop: "desktop",
  tv: "tv"
}, mn = {
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MacOS: "macOS",
  iOS: "iOS",
  Android: "Android",
  WebOS: "WebOS",
  BlackBerry: "BlackBerry",
  Bada: "Bada",
  Tizen: "Tizen",
  Linux: "Linux",
  ChromeOS: "Chrome OS",
  PlayStation4: "PlayStation 4",
  Roku: "Roku"
}, Xr = {
  EdgeHTML: "EdgeHTML",
  Blink: "Blink",
  Trident: "Trident",
  Presto: "Presto",
  Gecko: "Gecko",
  WebKit: "WebKit"
};
class ae {
  static getFirstMatch(t, n) {
    const r = n.match(t);
    return r && r.length > 0 && r[1] || "";
  }
  static getSecondMatch(t, n) {
    const r = n.match(t);
    return r && r.length > 1 && r[2] || "";
  }
  static matchAndReturnConst(t, n, r) {
    if (t.test(n))
      return r;
  }
  static getWindowsVersionName(t) {
    switch (t) {
      case "NT":
        return "NT";
      case "XP":
        return "XP";
      case "NT 5.0":
        return "2000";
      case "NT 5.1":
        return "XP";
      case "NT 5.2":
        return "2003";
      case "NT 6.0":
        return "Vista";
      case "NT 6.1":
        return "7";
      case "NT 6.2":
        return "8";
      case "NT 6.3":
        return "8.1";
      case "NT 10.0":
        return "10";
      default:
        return;
    }
  }
  static getMacOSVersionName(t) {
    const n = t.split(".").splice(0, 2).map((r) => parseInt(r, 10) || 0);
    if (n.push(0), n[0] === 10)
      switch (n[1]) {
        case 5:
          return "Leopard";
        case 6:
          return "Snow Leopard";
        case 7:
          return "Lion";
        case 8:
          return "Mountain Lion";
        case 9:
          return "Mavericks";
        case 10:
          return "Yosemite";
        case 11:
          return "El Capitan";
        case 12:
          return "Sierra";
        case 13:
          return "High Sierra";
        case 14:
          return "Mojave";
        case 15:
          return "Catalina";
        default:
          return;
      }
  }
  static getAndroidVersionName(t) {
    const n = t.split(".").splice(0, 2).map((r) => parseInt(r, 10) || 0);
    if (n.push(0), !(n[0] === 1 && n[1] < 5)) {
      if (n[0] === 1 && n[1] < 6)
        return "Cupcake";
      if (n[0] === 1 && n[1] >= 6)
        return "Donut";
      if (n[0] === 2 && n[1] < 2)
        return "Eclair";
      if (n[0] === 2 && n[1] === 2)
        return "Froyo";
      if (n[0] === 2 && n[1] > 2)
        return "Gingerbread";
      if (n[0] === 3)
        return "Honeycomb";
      if (n[0] === 4 && n[1] < 1)
        return "Ice Cream Sandwich";
      if (n[0] === 4 && n[1] < 4)
        return "Jelly Bean";
      if (n[0] === 4 && n[1] >= 4)
        return "KitKat";
      if (n[0] === 5)
        return "Lollipop";
      if (n[0] === 6)
        return "Marshmallow";
      if (n[0] === 7)
        return "Nougat";
      if (n[0] === 8)
        return "Oreo";
      if (n[0] === 9)
        return "Pie";
    }
  }
  static getVersionPrecision(t) {
    return t.split(".").length;
  }
  static compareVersions(t, n, r = !1) {
    const a = ae.getVersionPrecision(t), i = ae.getVersionPrecision(n);
    let o = Math.max(a, i), s = 0;
    const u = ae.map([t, n], (l) => {
      const c = o - ae.getVersionPrecision(l), f = l + new Array(c + 1).join(".0");
      return ae.map(f.split("."), (E) => new Array(20 - E.length).join("0") + E).reverse();
    });
    for (r && (s = o - Math.min(a, i)), o -= 1; o >= s; ) {
      if (u[0][o] > u[1][o])
        return 1;
      if (u[0][o] === u[1][o]) {
        if (o === s)
          return 0;
        o -= 1;
      } else if (u[0][o] < u[1][o])
        return -1;
    }
  }
  static map(t, n) {
    const r = [];
    let a;
    if (Array.prototype.map)
      return Array.prototype.map.call(t, n);
    for (a = 0; a < t.length; a += 1)
      r.push(n(t[a]));
    return r;
  }
  static find(t, n) {
    let r, a;
    if (Array.prototype.find)
      return Array.prototype.find.call(t, n);
    for (r = 0, a = t.length; r < a; r += 1) {
      const i = t[r];
      if (n(i, r))
        return i;
    }
  }
  static assign(t, ...n) {
    const r = t;
    let a, i;
    if (Object.assign)
      return Object.assign(t, ...n);
    for (a = 0, i = n.length; a < i; a += 1) {
      const o = n[a];
      typeof o == "object" && o !== null && Object.keys(o).forEach((u) => {
        r[u] = o[u];
      });
    }
    return t;
  }
  static getBrowserAlias(t) {
    return IS[t];
  }
  static getBrowserTypeByAlias(t) {
    return Up[t] || "";
  }
}
const St = /version\/(\d+(\.?_?\d+)+)/i, RS = [
  {
    test: [/googlebot/i],
    describe(e) {
      const t = {
        name: "Googlebot"
      }, n = ae.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/opera/i],
    describe(e) {
      const t = {
        name: "Opera"
      }, n = ae.getFirstMatch(St, e) || ae.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/opr\/|opios/i],
    describe(e) {
      const t = {
        name: "Opera"
      }, n = ae.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/SamsungBrowser/i],
    describe(e) {
      const t = {
        name: "Samsung Internet for Android"
      }, n = ae.getFirstMatch(St, e) || ae.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/Whale/i],
    describe(e) {
      const t = {
        name: "NAVER Whale Browser"
      }, n = ae.getFirstMatch(St, e) || ae.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/MZBrowser/i],
    describe(e) {
      const t = {
        name: "MZ Browser"
      }, n = ae.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/focus/i],
    describe(e) {
      const t = {
        name: "Focus"
      }, n = ae.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/swing/i],
    describe(e) {
      const t = {
        name: "Swing"
      }, n = ae.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/coast/i],
    describe(e) {
      const t = {
        name: "Opera Coast"
      }, n = ae.getFirstMatch(St, e) || ae.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(e) {
      const t = {
        name: "Opera Touch"
      }, n = ae.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/yabrowser/i],
    describe(e) {
      const t = {
        name: "Yandex Browser"
      }, n = ae.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/ucbrowser/i],
    describe(e) {
      const t = {
        name: "UC Browser"
      }, n = ae.getFirstMatch(St, e) || ae.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/Maxthon|mxios/i],
    describe(e) {
      const t = {
        name: "Maxthon"
      }, n = ae.getFirstMatch(St, e) || ae.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/epiphany/i],
    describe(e) {
      const t = {
        name: "Epiphany"
      }, n = ae.getFirstMatch(St, e) || ae.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/puffin/i],
    describe(e) {
      const t = {
        name: "Puffin"
      }, n = ae.getFirstMatch(St, e) || ae.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/sleipnir/i],
    describe(e) {
      const t = {
        name: "Sleipnir"
      }, n = ae.getFirstMatch(St, e) || ae.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/k-meleon/i],
    describe(e) {
      const t = {
        name: "K-Meleon"
      }, n = ae.getFirstMatch(St, e) || ae.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/micromessenger/i],
    describe(e) {
      const t = {
        name: "WeChat"
      }, n = ae.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/qqbrowser/i],
    describe(e) {
      const t = {
        name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
      }, n = ae.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/msie|trident/i],
    describe(e) {
      const t = {
        name: "Internet Explorer"
      }, n = ae.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/\sedg\//i],
    describe(e) {
      const t = {
        name: "Microsoft Edge"
      }, n = ae.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(e) {
      const t = {
        name: "Microsoft Edge"
      }, n = ae.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/vivaldi/i],
    describe(e) {
      const t = {
        name: "Vivaldi"
      }, n = ae.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/seamonkey/i],
    describe(e) {
      const t = {
        name: "SeaMonkey"
      }, n = ae.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/sailfish/i],
    describe(e) {
      const t = {
        name: "Sailfish"
      }, n = ae.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/silk/i],
    describe(e) {
      const t = {
        name: "Amazon Silk"
      }, n = ae.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/phantom/i],
    describe(e) {
      const t = {
        name: "PhantomJS"
      }, n = ae.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/slimerjs/i],
    describe(e) {
      const t = {
        name: "SlimerJS"
      }, n = ae.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(e) {
      const t = {
        name: "BlackBerry"
      }, n = ae.getFirstMatch(St, e) || ae.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(e) {
      const t = {
        name: "WebOS Browser"
      }, n = ae.getFirstMatch(St, e) || ae.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/bada/i],
    describe(e) {
      const t = {
        name: "Bada"
      }, n = ae.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/tizen/i],
    describe(e) {
      const t = {
        name: "Tizen"
      }, n = ae.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/qupzilla/i],
    describe(e) {
      const t = {
        name: "QupZilla"
      }, n = ae.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(e) {
      const t = {
        name: "Firefox"
      }, n = ae.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/electron/i],
    describe(e) {
      const t = {
        name: "Electron"
      }, n = ae.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/MiuiBrowser/i],
    describe(e) {
      const t = {
        name: "Miui"
      }, n = ae.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/chromium/i],
    describe(e) {
      const t = {
        name: "Chromium"
      }, n = ae.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(e) {
      const t = {
        name: "Chrome"
      }, n = ae.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/GSA/i],
    describe(e) {
      const t = {
        name: "Google Search"
      }, n = ae.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test(e) {
      const t = !e.test(/like android/i), n = e.test(/android/i);
      return t && n;
    },
    describe(e) {
      const t = {
        name: "Android Browser"
      }, n = ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/playstation 4/i],
    describe(e) {
      const t = {
        name: "PlayStation 4"
      }, n = ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/safari|applewebkit/i],
    describe(e) {
      const t = {
        name: "Safari"
      }, n = ae.getFirstMatch(St, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/.*/i],
    describe(e) {
      const t = /^(.*)\/(.*) /, n = /^(.*)\/(.*)[ \t]\((.*)/, a = e.search("\\(") !== -1 ? n : t;
      return {
        name: ae.getFirstMatch(a, e),
        version: ae.getSecondMatch(a, e)
      };
    }
  }
], MS = [
  {
    test: [/Roku\/DVP/],
    describe(e) {
      const t = ae.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
      return {
        name: mn.Roku,
        version: t
      };
    }
  },
  {
    test: [/windows phone/i],
    describe(e) {
      const t = ae.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
      return {
        name: mn.WindowsPhone,
        version: t
      };
    }
  },
  {
    test: [/windows /i],
    describe(e) {
      const t = ae.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), n = ae.getWindowsVersionName(t);
      return {
        name: mn.Windows,
        version: t,
        versionName: n
      };
    }
  },
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe(e) {
      const t = {
        name: mn.iOS
      }, n = ae.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/macintosh/i],
    describe(e) {
      const t = ae.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), n = ae.getMacOSVersionName(t), r = {
        name: mn.MacOS,
        version: t
      };
      return n && (r.versionName = n), r;
    }
  },
  {
    test: [/(ipod|iphone|ipad)/i],
    describe(e) {
      const t = ae.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
      return {
        name: mn.iOS,
        version: t
      };
    }
  },
  {
    test(e) {
      const t = !e.test(/like android/i), n = e.test(/android/i);
      return t && n;
    },
    describe(e) {
      const t = ae.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), n = ae.getAndroidVersionName(t), r = {
        name: mn.Android,
        version: t
      };
      return n && (r.versionName = n), r;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(e) {
      const t = ae.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), n = {
        name: mn.WebOS
      };
      return t && t.length && (n.version = t), n;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(e) {
      const t = ae.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || ae.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || ae.getFirstMatch(/\bbb(\d+)/i, e);
      return {
        name: mn.BlackBerry,
        version: t
      };
    }
  },
  {
    test: [/bada/i],
    describe(e) {
      const t = ae.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
      return {
        name: mn.Bada,
        version: t
      };
    }
  },
  {
    test: [/tizen/i],
    describe(e) {
      const t = ae.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
      return {
        name: mn.Tizen,
        version: t
      };
    }
  },
  {
    test: [/linux/i],
    describe() {
      return {
        name: mn.Linux
      };
    }
  },
  {
    test: [/CrOS/],
    describe() {
      return {
        name: mn.ChromeOS
      };
    }
  },
  {
    test: [/PlayStation 4/],
    describe(e) {
      const t = ae.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
      return {
        name: mn.PlayStation4,
        version: t
      };
    }
  }
], xS = [
  {
    test: [/googlebot/i],
    describe() {
      return {
        type: "bot",
        vendor: "Google"
      };
    }
  },
  {
    test: [/huawei/i],
    describe(e) {
      const t = ae.getFirstMatch(/(can-l01)/i, e) && "Nova", n = {
        type: Vt.mobile,
        vendor: "Huawei"
      };
      return t && (n.model = t), n;
    }
  },
  {
    test: [/nexus\s*(?:7|8|9|10).*/i],
    describe() {
      return {
        type: Vt.tablet,
        vendor: "Nexus"
      };
    }
  },
  {
    test: [/ipad/i],
    describe() {
      return {
        type: Vt.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe() {
      return {
        type: Vt.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  {
    test: [/kftt build/i],
    describe() {
      return {
        type: Vt.tablet,
        vendor: "Amazon",
        model: "Kindle Fire HD 7"
      };
    }
  },
  {
    test: [/silk/i],
    describe() {
      return {
        type: Vt.tablet,
        vendor: "Amazon"
      };
    }
  },
  {
    test: [/tablet(?! pc)/i],
    describe() {
      return {
        type: Vt.tablet
      };
    }
  },
  {
    test(e) {
      const t = e.test(/ipod|iphone/i), n = e.test(/like (ipod|iphone)/i);
      return t && !n;
    },
    describe(e) {
      const t = ae.getFirstMatch(/(ipod|iphone)/i, e);
      return {
        type: Vt.mobile,
        vendor: "Apple",
        model: t
      };
    }
  },
  {
    test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
    describe() {
      return {
        type: Vt.mobile,
        vendor: "Nexus"
      };
    }
  },
  {
    test: [/[^-]mobi/i],
    describe() {
      return {
        type: Vt.mobile
      };
    }
  },
  {
    test(e) {
      return e.getBrowserName(!0) === "blackberry";
    },
    describe() {
      return {
        type: Vt.mobile,
        vendor: "BlackBerry"
      };
    }
  },
  {
    test(e) {
      return e.getBrowserName(!0) === "bada";
    },
    describe() {
      return {
        type: Vt.mobile
      };
    }
  },
  {
    test(e) {
      return e.getBrowserName() === "windows phone";
    },
    describe() {
      return {
        type: Vt.mobile,
        vendor: "Microsoft"
      };
    }
  },
  {
    test(e) {
      const t = Number(String(e.getOSVersion()).split(".")[0]);
      return e.getOSName(!0) === "android" && t >= 3;
    },
    describe() {
      return {
        type: Vt.tablet
      };
    }
  },
  {
    test(e) {
      return e.getOSName(!0) === "android";
    },
    describe() {
      return {
        type: Vt.mobile
      };
    }
  },
  {
    test(e) {
      return e.getOSName(!0) === "macos";
    },
    describe() {
      return {
        type: Vt.desktop,
        vendor: "Apple"
      };
    }
  },
  {
    test(e) {
      return e.getOSName(!0) === "windows";
    },
    describe() {
      return {
        type: Vt.desktop
      };
    }
  },
  {
    test(e) {
      return e.getOSName(!0) === "linux";
    },
    describe() {
      return {
        type: Vt.desktop
      };
    }
  },
  {
    test(e) {
      return e.getOSName(!0) === "playstation 4";
    },
    describe() {
      return {
        type: Vt.tv
      };
    }
  },
  {
    test(e) {
      return e.getOSName(!0) === "roku";
    },
    describe() {
      return {
        type: Vt.tv
      };
    }
  }
], kS = [
  {
    test(e) {
      return e.getBrowserName(!0) === "microsoft edge";
    },
    describe(e) {
      if (/\sedg\//i.test(e))
        return {
          name: Xr.Blink
        };
      const n = ae.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
      return {
        name: Xr.EdgeHTML,
        version: n
      };
    }
  },
  {
    test: [/trident/i],
    describe(e) {
      const t = {
        name: Xr.Trident
      }, n = ae.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test(e) {
      return e.test(/presto/i);
    },
    describe(e) {
      const t = {
        name: Xr.Presto
      }, n = ae.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test(e) {
      const t = e.test(/gecko/i), n = e.test(/like gecko/i);
      return t && !n;
    },
    describe(e) {
      const t = {
        name: Xr.Gecko
      }, n = ae.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/(apple)?webkit\/537\.36/i],
    describe() {
      return {
        name: Xr.Blink
      };
    }
  },
  {
    test: [/(apple)?webkit/i],
    describe(e) {
      const t = {
        name: Xr.WebKit
      }, n = ae.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  }
];
class cd {
  constructor(t, n = !1) {
    if (t == null || t === "")
      throw new Error("UserAgent parameter can't be empty");
    this._ua = t, this.parsedResult = {}, n !== !0 && this.parse();
  }
  getUA() {
    return this._ua;
  }
  test(t) {
    return t.test(this._ua);
  }
  parseBrowser() {
    this.parsedResult.browser = {};
    const t = ae.find(RS, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
  }
  getBrowser() {
    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
  }
  getBrowserName(t) {
    return t ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
  }
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  getOS() {
    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
  }
  parseOS() {
    this.parsedResult.os = {};
    const t = ae.find(MS, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
  }
  getOSName(t) {
    const { name: n } = this.getOS();
    return t ? String(n).toLowerCase() || "" : n || "";
  }
  getOSVersion() {
    return this.getOS().version;
  }
  getPlatform() {
    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
  }
  getPlatformType(t = !1) {
    const { type: n } = this.getPlatform();
    return t ? String(n).toLowerCase() || "" : n || "";
  }
  parsePlatform() {
    this.parsedResult.platform = {};
    const t = ae.find(xS, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
  }
  getEngine() {
    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
  }
  getEngineName(t) {
    return t ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
  }
  parseEngine() {
    this.parsedResult.engine = {};
    const t = ae.find(kS, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
  }
  parse() {
    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
  }
  getResult() {
    return ae.assign({}, this.parsedResult);
  }
  satisfies(t) {
    const n = {};
    let r = 0;
    const a = {};
    let i = 0;
    if (Object.keys(t).forEach((s) => {
      const u = t[s];
      typeof u == "string" ? (a[s] = u, i += 1) : typeof u == "object" && (n[s] = u, r += 1);
    }), r > 0) {
      const s = Object.keys(n), u = ae.find(s, (c) => this.isOS(c));
      if (u) {
        const c = this.satisfies(n[u]);
        if (c !== void 0)
          return c;
      }
      const l = ae.find(
        s,
        (c) => this.isPlatform(c)
      );
      if (l) {
        const c = this.satisfies(n[l]);
        if (c !== void 0)
          return c;
      }
    }
    if (i > 0) {
      const s = Object.keys(a), u = ae.find(s, (l) => this.isBrowser(l, !0));
      if (u !== void 0)
        return this.compareVersion(a[u]);
    }
  }
  isBrowser(t, n = !1) {
    const r = this.getBrowserName().toLowerCase();
    let a = t.toLowerCase();
    const i = ae.getBrowserTypeByAlias(a);
    return n && i && (a = i.toLowerCase()), a === r;
  }
  compareVersion(t) {
    let n = [0], r = t, a = !1;
    const i = this.getBrowserVersion();
    if (typeof i == "string")
      return t[0] === ">" || t[0] === "<" ? (r = t.substr(1), t[1] === "=" ? (a = !0, r = t.substr(2)) : n = [], t[0] === ">" ? n.push(1) : n.push(-1)) : t[0] === "=" ? r = t.substr(1) : t[0] === "~" && (a = !0, r = t.substr(1)), n.indexOf(
        ae.compareVersions(i, r, a)
      ) > -1;
  }
  isOS(t) {
    return this.getOSName(!0) === String(t).toLowerCase();
  }
  isPlatform(t) {
    return this.getPlatformType(!0) === String(t).toLowerCase();
  }
  isEngine(t) {
    return this.getEngineName(!0) === String(t).toLowerCase();
  }
  is(t, n = !1) {
    return this.isBrowser(t, n) || this.isOS(t) || this.isPlatform(t);
  }
  some(t = []) {
    return t.some((n) => this.is(n));
  }
}
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */
class PS {
  static getParser(t, n = !1) {
    if (typeof t != "string")
      throw new Error("UserAgent should be a string");
    return new cd(t, n);
  }
  static parse(t) {
    return new cd(t).getResult();
  }
  static get BROWSER_MAP() {
    return Up;
  }
  static get ENGINE_MAP() {
    return Xr;
  }
  static get OS_MAP() {
    return mn;
  }
  static get PLATFORMS_MAP() {
    return Vt;
  }
}
var wn = /* @__PURE__ */ ((e) => (e.TEXT = "text", e.IMAGE = "image", e.CARD = "card", e.CAROUSEL = "carousel", e.END = "END", e))(wn || {});
const BS = [
  ND(({ context: e }, { payload: t }) => {
    const { slate: n, message: r } = t;
    return e.messages.push({
      type: wn.TEXT,
      text: (n == null ? void 0 : n.content) || r,
      delay: t.delay,
      ...t.ai ? { ai: t.ai } : {}
    }), e;
  }),
  wD(({ context: e }, { payload: { image: t } }) => (e.messages.push({ type: wn.IMAGE, url: t }), e)),
  OD(({ context: e }, { payload: { buttons: t } }) => (e.actions = t.map(({ name: n, request: r }) => ({
    name: n,
    request: r
  })), e)),
  SD(({ context: e }, { payload: { title: t, imageUrl: n, description: r, buttons: a } }) => (e.messages.push({
    type: "card",
    title: t,
    description: r.text,
    image: n,
    actions: a.map(({ name: i, request: o }) => ({ name: i, request: o }))
  }), e)),
  {
    canHandle: ({ type: e }) => e === bn.CAROUSEL,
    handle: ({ context: e }, { payload: { cards: t } }) => (e.messages.push({
      type: wn.CAROUSEL,
      cards: t.map(({ title: n, description: r, imageUrl: a, buttons: i }) => ({
        title: n,
        description: r.text,
        image: a,
        actions: i.map(({ name: o, request: s }) => ({ name: o, request: s }))
      }))
    }), e)
  },
  {
    canHandle: ({ type: e }) => e === bn.END,
    handle: ({ context: e }) => (e.messages.push({ type: wn.END }), e)
  }
];
var ti = /* @__PURE__ */ ((e) => (e.USER = "user", e.SYSTEM = "system", e))(ti || {});
const FS = /^about:[\w#%+.:=@~-]{2,256}\b([\w#%&+./:=?@~-]*)$/, LS = /^bitcoin:[\dA-Za-z]{26,35}([\w#%&+./:=?@~-]*)$/, $S = /^callto:[+\d-\s()]+$/, HS = /^tel:[+\d-\s()]+$/, US = /^sms:[+\d-\s()]+$/, jS = /^mailto:([^\s?]+)\b([\w#%&+./:=?@~-]*)$/, zS = /^im:([^\s?]+)\b([\w#%&+./:=?@~-]*)$/, GS = /^facetime(-(audio|group))?:([^\s?]+|([+\d-()]+))$/, VS = /^skype:(\S+)\b$/, YS = /^webcal:(\S+)\b$/, KS = [
  FS,
  LS,
  $S,
  HS,
  US,
  jS,
  zS,
  GS,
  VS,
  YS
], WS = (e) => !!KS.some((t) => e.match(t)), qS = (e) => e.startsWith("//") || e.includes("://") || WS(e) ? e : `//${e}`, XS = (e, t = "noopener=true,noreferrer=true") => {
  var n;
  return (n = window.open(qS(e), "_blank", t)) == null ? void 0 : n.focus();
}, QS = (e) => !!e.payload && typeof e.payload == "object" && Array.isArray(e.payload.actions), ZS = (e) => {
  var t;
  QS(e) && ((t = e.payload.actions) == null || t.forEach((n) => {
    h5(n) && n.payload.url && XS(n.payload.url);
  }));
}, JS = (e) => typeof e == "function", eO = (e) => {
  const [t, n] = En(e), r = Mr(t), a = pa((i) => {
    r.current = JS(i) ? i(r.current) : i, n(r.current);
  }, []);
  return [t, a, r];
}, tO = () => ({
  messages: []
});
var Yi = /* @__PURE__ */ ((e) => (e.POSITIVE = "Thumbs up", e.NEGATIVE = "Thumbs down", e))(Yi || {});
const nO = {
  turns: [],
  userID: mo(),
  startTime: Date.now(),
  status: Ir.IDLE
}, rO = ({ url: e = my, versionID: t, verify: n, user: r, ...a }, i = []) => {
  const [o, s] = En(!1), [u, l, c] = eO({ ...nO, ...a.session }), [f, E] = En(Date.now()), [T, g] = En(null);
  Rr(() => {
    let Y;
    const X = () => {
      y(Ir.ACTIVE) && T && f && Date.now() - f > T && O({ type: Xs.NO_REPLY, payload: null }), Y = setTimeout(X, 1e3);
    };
    return X(), () => {
      clearTimeout(Y);
    };
  }, [T, f]);
  const m = ii(
    () => {
      var Y;
      return new DD({
        verify: n,
        url: e,
        traces: [
          ...(Y = a.traces) != null ? Y : [],
          ...BS,
          {
            canHandle: ({ type: X }) => X === bn.NO_REPLY,
            handle: ({ context: X }, H) => (g(H.payload.timeout * 1e3), E(Date.now()), X)
          }
        ]
      });
    },
    i
  ), v = (Y) => {
    l((X) => ({ ...X, turns: Y(X.turns) }));
  }, b = (Y) => {
    l((X) => X.status === Y ? X : { ...X, status: Y });
  }, y = (Y) => c.current.status === Y, O = async (Y) => {
    var $;
    s(!0);
    const X = await m.interact(tO(), { sessionID: c.current.userID, action: Y, ...t && { versionID: t } });
    s(!1), v((L) => [
      ...L,
      {
        id: mo(),
        type: ti.SYSTEM,
        timestamp: Date.now(),
        ...X
      }
    ]), ($ = a.saveSession) == null || $.call(a, c.current);
    let H = Date.now();
    X.messages.forEach((L) => {
      var Q;
      H += (Q = L.delay) != null ? Q : 1e3;
    }), E(H);
  }, B = async (Y, X) => {
    if (c.current.status !== Ir.ENDED) {
      if (c.current.turns.length === 1) {
        const {
          browser: { name: H },
          os: { name: $ },
          platform: { type: L }
        } = PS.parse(window.navigator.userAgent);
        m.createTranscript(u.userID, { ...$ && { os: $ }, ...H && { browser: H }, ...L && { device: L }, ...r && { user: r } });
      }
      ZS(X), v((H) => [
        ...H,
        {
          id: mo(),
          type: ti.USER,
          message: Y,
          timestamp: Date.now()
        }
      ]), await O(X);
    }
  }, S = () => v(() => []);
  return {
    send: B,
    reply: async (Y) => B(Y, { type: Xs.TEXT, payload: Y }),
    register: (Y) => m.registerStep(Y),
    reset: S,
    launch: async () => {
      c.current.turns.length && S(), b(Ir.ACTIVE), await O({ type: Xs.LAUNCH, payload: null });
    },
    interact: O,
    feedback: async (Y, X, H) => {
      const $ = [];
      X.forEach((L) => {
        if (!L.ai || L.type !== wn.TEXT)
          return;
        const Q = typeof L.text == "string" ? L.text : Hp(L.text);
        $.push(Q);
      }), await m.feedback({
        sessionID: c.current.userID,
        text: $,
        name: Y,
        last_user_input: H,
        ...t && { versionID: t }
      });
    },
    indicator: o,
    session: u,
    setStatus: b,
    isStatus: y,
    addTurn: (Y) => v((X) => [...X, Y])
  };
}, ac = Symbol("@ts-pattern/matcher"), fd = "@ts-pattern/anonymous-select-key", hd = (e) => Boolean(e && typeof e == "object"), tu = (e) => e && !!e[ac], Ki = (e, t, n) => {
  if (hd(e)) {
    if (tu(e)) {
      const r = e[ac](), { matched: a, selections: i } = r.match(t);
      return a && i && Object.keys(i).forEach((o) => n(o, i[o])), a;
    }
    if (!hd(t))
      return !1;
    if (Array.isArray(e))
      return !!Array.isArray(t) && e.length === t.length && e.every((r, a) => Ki(r, t[a], n));
    if (e instanceof Map)
      return t instanceof Map && Array.from(e.keys()).every((r) => Ki(e.get(r), t.get(r), n));
    if (e instanceof Set) {
      if (!(t instanceof Set))
        return !1;
      if (e.size === 0)
        return t.size === 0;
      if (e.size === 1) {
        const [r] = Array.from(e.values());
        return tu(r) ? Array.from(t.values()).every((a) => Ki(r, a, n)) : t.has(r);
      }
      return Array.from(e.values()).every((r) => t.has(r));
    }
    return Object.keys(e).every((r) => {
      const a = e[r];
      return (r in t || tu(i = a) && i[ac]().matcherType === "optional") && Ki(a, t[r], n);
      var i;
    });
  }
  return Object.is(t, e);
}, Wc = (e) => new Qi(e, []);
class Qi {
  constructor(t, n) {
    this.value = void 0, this.cases = void 0, this.value = t, this.cases = n;
  }
  with(...t) {
    const n = t[t.length - 1], r = [t[0]], a = [];
    return t.length === 3 && typeof t[1] == "function" ? (r.push(t[0]), a.push(t[1])) : t.length > 2 && r.push(...t.slice(1, t.length - 1)), new Qi(this.value, this.cases.concat([{ match: (i) => {
      let o = {};
      const s = Boolean(r.some((u) => Ki(u, i, (l, c) => {
        o[l] = c;
      })) && a.every((u) => u(i)));
      return { matched: s, value: s && Object.keys(o).length ? fd in o ? o[fd] : o : i };
    }, handler: n }]));
  }
  when(t, n) {
    return new Qi(this.value, this.cases.concat([{ match: (r) => ({ matched: Boolean(t(r)), value: r }), handler: n }]));
  }
  otherwise(t) {
    return new Qi(this.value, this.cases.concat([{ match: (n) => ({ matched: !0, value: n }), handler: t }])).run();
  }
  exhaustive() {
    return this.run();
  }
  run() {
    let t, n = this.value;
    for (let r = 0; r < this.cases.length; r++) {
      const a = this.cases[r], i = a.match(this.value);
      if (i.matched) {
        n = i.value, t = a.handler;
        break;
      }
    }
    if (!t) {
      let r;
      try {
        r = JSON.stringify(this.value);
      } catch {
        r = this.value;
      }
      throw new Error(`Pattern matching error: no pattern matches value ${r}`);
    }
    return t(n, this.value);
  }
}
const ic = 1e3, aO = (e = ic) => ({
  type: "indicator",
  messageDelay: e
}), iO = ({ messages: e, isLast: t }) => {
  const n = Mr(t && !!e.length), [r, a] = En(!n.current), [i, o] = En(n.current), [s, u] = En(n.current ? [] : e), l = pa(() => {
    a(!0), o(!1);
  }, []);
  return Rr(() => {
    if (!n)
      return;
    const c = e.flatMap((g) => [aO(g.delay), { type: "message", message: g }]);
    let f;
    const E = (g, m) => {
      if (m === 0) {
        g();
        return;
      }
      f = setTimeout(() => {
        g();
      }, m);
    }, T = () => {
      if (!n.current)
        return;
      const g = c.shift();
      if (!g) {
        l();
        return;
      }
      Wc(g).with({ type: "message" }, ({ message: m }) => {
        o(!1), u((v) => [...v, m]), E(T, ic);
      }).with({ type: "indicator" }, ({ messageDelay: m = ic }) => {
        o(!0), E(T, m);
      }).exhaustive();
    };
    return T(), () => {
      clearTimeout(f);
    };
  }, []), aD(() => {
    t || (n.current = !1, l(), u(e));
  }, [t]), {
    complete: r,
    showIndicator: i,
    visibleMessages: s
  };
}, jp = 1e3, zp = Lt(Pt.TYPING_INDICATOR), Gp = Me(zp("span"), {
  display: "inline-flex"
}), Vp = Me(zp("span", "dot"), {
  height: 8,
  width: 8,
  margin: "0 2px",
  borderRadius: "$round",
  backgroundColor: "#adadb3",
  opacity: 0.2,
  animation: `${sv} ${jp}ms`,
  animationIterationCount: "infinite"
}), oO = Math.floor(jp / 3), sO = () => /* @__PURE__ */ me(Gp, {
  children: Array.from({
    length: 3
  }).map((e, t) => /* @__PURE__ */ me(Vp, {
    css: {
      animationDelay: `${oO * (t + 1)}ms`
    }
  }, t))
}), uO = Object.assign(sO, {
  Container: Gp,
  Dot: Vp
}), qc = Lt(Pt.MESSAGE), Xc = Me(qc("div"), {
  display: "inline-block",
  boxSizing: "border-box",
  padding: "10px 14px",
  borderRadius: "$1",
  typo: {},
  overflowWrap: "anywhere"
}), Yp = Me(qc(Xc, "chat"), {
  variants: {
    from: {
      system: {
        color: "$black",
        backgroundColor: "$lightGrey"
      },
      user: {
        color: "$white",
        backgroundColor: "$primary"
      }
    }
  },
  defaultVariants: {
    from: "system"
  }
});
var d1 = /* @__PURE__ */ ((e) => (e.CHAT = "chat", e.DEBUG = "debug", e))(d1 || {});
const dd = 6, md = 32, Kp = Me(qc(Xc, "debug"), {
  position: "relative",
  marginTop: dd,
  border: "1px solid $medGrey",
  padding: "10px 14px",
  backgroundColor: "$white",
  boxShadow: "0 1px 2px $shadow2",
  svg: {
    position: "absolute",
    top: -dd
  },
  variants: {
    orientation: {
      left: {
        svg: {
          left: md
        }
      },
      right: {
        svg: {
          right: md
        }
      }
    }
  },
  defaultVariants: {
    orientation: "left"
  }
}), lO = ({
  children: e,
  ...t
}) => /* @__PURE__ */ Rt(Kp, {
  ...t,
  children: [/* @__PURE__ */ me(Q5, {}), e]
}), Wp = Object.assign(lO, {
  Container: Kp
}), cO = {
  [d1.CHAT]: Yp,
  [d1.DEBUG]: Wp
}, fO = J5(cO, d1.CHAT), di = Object.assign(fO, {
  Variant: d1,
  Container: Xc,
  Chat: Yp,
  Debug: Wp
}), hO = (e) => {
  const t = new Date(e), n = t.getHours(), r = t.getMinutes();
  return `${n % 12 || 12}:${r >= 10 ? "" : "0"}${r} ${n >= 12 ? "pm" : "am"}`;
}, dO = Lt(Pt.TIMESTAMP), qp = Me(dO("div"), {
  typo: { size: 12, height: "17px" },
  color: "$darkGrey",
  whiteSpace: "nowrap",
  flexShrink: 0
}), mO = ({
  value: e
}) => /* @__PURE__ */ me(qp, {
  children: hO(e)
}), ya = Object.assign(mO, {
  Container: qp
}), mi = Lt(Pt.SYSTEM_RESPONSE), Xp = Me(mi("div", "actions"), {
  display: "flex",
  flexWrap: "wrap",
  marginBottom: 8,
  padding: "0 $5 0 54px",
  [`& ${Vn.Container}`]: {
    height: "unset",
    paddingTop: 7,
    paddingBottom: 7,
    marginTop: 8,
    marginRight: 8,
    whiteSpace: "normal",
    textAlign: "start"
  }
}), Qp = Me(mi("span", "controls"), {
  position: "relative"
}), Qc = Me(mi("div"), {
  display: "flex",
  [`& ${ea.Container}`]: {
    visibility: "hidden",
    alignSelf: "flex-end",
    margin: "0 8px 4px 0"
  },
  [`& ${ya.Container}`]: {
    alignSelf: "center",
    whiteSpace: "nowrap",
    marginLeft: 8,
    opacity: "0%",
    trans: ["opacity"]
  },
  [`&:hover ${ya.Container}`]: {
    opacity: "100%"
  },
  variants: {
    withImage: {
      true: {
        [`& ${ea.Container}`]: {
          visibility: "visible"
        }
      }
    },
    scrollable: {
      true: {
        overflowX: "scroll",
        flexShrink: 0,
        scrollbarWidth: "none",
        "-ms-overflow-style": "none",
        ["&::-webkit-scrollbar"]: {
          display: "none"
        }
      }
    },
    center: {
      true: {
        alignItems: "center"
      }
    }
  }
}), pO = Me(mi(Qc, "message")), gO = Me(mi(Qc, "indicator")), Zp = Me(mi("div", "list"), {
  display: "flex",
  flexDirection: "column",
  flexShrink: 0,
  [`& ${di.Container}`]: {
    marginBottom: "$1",
    maxWidth: 248,
    "&:last-of-type": {
      marginBottom: 0
    }
  }
}), Jp = ({
  avatar: e
}) => /* @__PURE__ */ Rt(gO, {
  withImage: !0,
  center: !0,
  children: [/* @__PURE__ */ me(ea, {
    avatar: e
  }), /* @__PURE__ */ me(uO, {})]
}), EO = (e) => {
  const t = e[ga.ITALIC], n = e[ga.UNDERLINE], r = e[ga.STRIKE_THROUGH], a = e[ga.FONT_WEIGHT];
  let { text: i } = e;
  if (!i.trim())
    return i;
  const o = i.match(/^\s+/) || "", s = i.match(/\s+$/) || "";
  return i = i.trim(), t && (i = `*${i}*`), n && (i = `<u>${i}</u>`), r && (i = `~~${i}~~`), a && (i = `**${i}**`), `${o}${i}${s}`;
}, TO = (e) => `[${e.children.map(Zc())}](${e.url})`, vO = (e) => `{${e.name}}`, AO = (e) => Fp(e) ? TO(e) : Lp(e) ? vO(e) : e.children.map(Zc()).join(""), Zc = () => (e) => Ue.isText(e) ? EO(e) : Ft.isElement(e) ? AO(e) : "", CO = (e) => e.map(Zc()).join(`
`).replace(/\n{3,}/g, (t) => `
${"<br/>".repeat(t.length - 2)}

`), pd = ["http", "https", "mailto", "tel"];
function _O(e) {
  const t = (e || "").trim(), n = t.charAt(0);
  if (n === "#" || n === "/")
    return t;
  const r = t.indexOf(":");
  if (r === -1)
    return t;
  let a = -1;
  for (; ++a < pd.length; ) {
    const i = pd[a];
    if (r === i.length && t.slice(0, i.length).toLowerCase() === i)
      return t;
  }
  return a = t.indexOf("?"), a !== -1 && r > a || (a = t.indexOf("#"), a !== -1 && r > a) ? t : "javascript:void(0)";
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var eg = function(t) {
  return t != null && t.constructor != null && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
};
function bO(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? gd(e.position) : "start" in e || "end" in e ? gd(e) : "line" in e || "column" in e ? oc(e) : "";
}
function oc(e) {
  return Ed(e && e.line) + ":" + Ed(e && e.column);
}
function gd(e) {
  return oc(e && e.start) + "-" + oc(e && e.end);
}
function Ed(e) {
  return e && typeof e == "number" ? e : 1;
}
class Yn extends Error {
  constructor(t, n, r) {
    const a = [null, null];
    let i = {
      start: { line: null, column: null },
      end: { line: null, column: null }
    };
    if (super(), typeof n == "string" && (r = n, n = void 0), typeof r == "string") {
      const o = r.indexOf(":");
      o === -1 ? a[1] = r : (a[0] = r.slice(0, o), a[1] = r.slice(o + 1));
    }
    n && ("type" in n || "position" in n ? n.position && (i = n.position) : "start" in n || "end" in n ? i = n : ("line" in n || "column" in n) && (i.start = n)), this.name = bO(n) || "1:1", this.message = typeof t == "object" ? t.message : t, this.stack = typeof t == "object" ? t.stack : "", this.reason = this.message, this.fatal, this.line = i.start.line, this.column = i.start.column, this.source = a[0], this.ruleId = a[1], this.position = i, this.actual, this.expected, this.file, this.url, this.note;
  }
}
Yn.prototype.file = "";
Yn.prototype.name = "";
Yn.prototype.reason = "";
Yn.prototype.message = "";
Yn.prototype.stack = "";
Yn.prototype.fatal = null;
Yn.prototype.column = null;
Yn.prototype.line = null;
Yn.prototype.source = null;
Yn.prototype.ruleId = null;
Yn.prototype.position = null;
const hr = { basename: yO, dirname: DO, extname: SO, join: OO, sep: "/" };
function yO(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  E1(e);
  let n = 0, r = -1, a = e.length, i;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; a--; )
      if (e.charCodeAt(a) === 47) {
        if (i) {
          n = a + 1;
          break;
        }
      } else
        r < 0 && (i = !0, r = a + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let o = -1, s = t.length - 1;
  for (; a--; )
    if (e.charCodeAt(a) === 47) {
      if (i) {
        n = a + 1;
        break;
      }
    } else
      o < 0 && (i = !0, o = a + 1), s > -1 && (e.charCodeAt(a) === t.charCodeAt(s--) ? s < 0 && (r = a) : (s = -1, r = o));
  return n === r ? r = o : r < 0 && (r = e.length), e.slice(n, r);
}
function DO(e) {
  if (E1(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.charCodeAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else
      r || (r = !0);
  return t < 0 ? e.charCodeAt(0) === 47 ? "/" : "." : t === 1 && e.charCodeAt(0) === 47 ? "//" : e.slice(0, t);
}
function SO(e) {
  E1(e);
  let t = e.length, n = -1, r = 0, a = -1, i = 0, o;
  for (; t--; ) {
    const s = e.charCodeAt(t);
    if (s === 47) {
      if (o) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (o = !0, n = t + 1), s === 46 ? a < 0 ? a = t : i !== 1 && (i = 1) : a > -1 && (i = -1);
  }
  return a < 0 || n < 0 || i === 0 || i === 1 && a === n - 1 && a === r + 1 ? "" : e.slice(a, n);
}
function OO(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    E1(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : NO(n);
}
function NO(e) {
  E1(e);
  const t = e.charCodeAt(0) === 47;
  let n = wO(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.charCodeAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function wO(e, t) {
  let n = "", r = 0, a = -1, i = 0, o = -1, s, u;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      s = e.charCodeAt(o);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(a === o - 1 || i === 1))
        if (a !== o - 1 && i === 2) {
          if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (u = n.lastIndexOf("/"), u !== n.length - 1) {
                u < 0 ? (n = "", r = 0) : (n = n.slice(0, u), r = n.length - 1 - n.lastIndexOf("/")), a = o, i = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, a = o, i = 0;
              continue;
            }
          }
          t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else
          n.length > 0 ? n += "/" + e.slice(a + 1, o) : n = e.slice(a + 1, o), r = o - a - 1;
      a = o, i = 0;
    } else
      s === 46 && i > -1 ? i++ : i = -1;
  }
  return n;
}
function E1(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const IO = { cwd: RO };
function RO() {
  return "/";
}
function sc(e) {
  return e !== null && typeof e == "object" && e.href && e.origin;
}
function MO(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!sc(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return xO(e);
}
function xO(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.charCodeAt(n) === 37 && t.charCodeAt(n + 1) === 50) {
      const r = t.charCodeAt(n + 2);
      if (r === 70 || r === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(t);
}
const nu = ["history", "path", "basename", "stem", "extname", "dirname"];
class tg {
  constructor(t) {
    let n;
    t ? typeof t == "string" || eg(t) ? n = { value: t } : sc(t) ? n = { path: t } : n = t : n = {}, this.data = {}, this.messages = [], this.history = [], this.cwd = IO.cwd(), this.value, this.stored, this.result, this.map;
    let r = -1;
    for (; ++r < nu.length; ) {
      const i = nu[r];
      i in n && n[i] !== void 0 && (this[i] = i === "history" ? [...n[i]] : n[i]);
    }
    let a;
    for (a in n)
      nu.includes(a) || (this[a] = n[a]);
  }
  get path() {
    return this.history[this.history.length - 1];
  }
  set path(t) {
    sc(t) && (t = MO(t)), au(t, "path"), this.path !== t && this.history.push(t);
  }
  get dirname() {
    return typeof this.path == "string" ? hr.dirname(this.path) : void 0;
  }
  set dirname(t) {
    Td(this.basename, "dirname"), this.path = hr.join(t || "", this.basename);
  }
  get basename() {
    return typeof this.path == "string" ? hr.basename(this.path) : void 0;
  }
  set basename(t) {
    au(t, "basename"), ru(t, "basename"), this.path = hr.join(this.dirname || "", t);
  }
  get extname() {
    return typeof this.path == "string" ? hr.extname(this.path) : void 0;
  }
  set extname(t) {
    if (ru(t, "extname"), Td(this.dirname, "extname"), t) {
      if (t.charCodeAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = hr.join(this.dirname, this.stem + (t || ""));
  }
  get stem() {
    return typeof this.path == "string" ? hr.basename(this.path, this.extname) : void 0;
  }
  set stem(t) {
    au(t, "stem"), ru(t, "stem"), this.path = hr.join(this.dirname || "", t + (this.extname || ""));
  }
  toString(t) {
    return (this.value || "").toString(t);
  }
  message(t, n, r) {
    const a = new Yn(t, n, r);
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  info(t, n, r) {
    const a = this.message(t, n, r);
    return a.fatal = null, a;
  }
  fail(t, n, r) {
    const a = this.message(t, n, r);
    throw a.fatal = !0, a;
  }
}
function ru(e, t) {
  if (e && e.includes(hr.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + hr.sep + "`"
    );
}
function au(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Td(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function vd(e) {
  if (e)
    throw e;
}
var ro = Object.prototype.hasOwnProperty, ng = Object.prototype.toString, Ad = Object.defineProperty, Cd = Object.getOwnPropertyDescriptor, _d = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : ng.call(t) === "[object Array]";
}, bd = function(t) {
  if (!t || ng.call(t) !== "[object Object]")
    return !1;
  var n = ro.call(t, "constructor"), r = t.constructor && t.constructor.prototype && ro.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var a;
  for (a in t)
    ;
  return typeof a > "u" || ro.call(t, a);
}, yd = function(t, n) {
  Ad && n.name === "__proto__" ? Ad(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, Dd = function(t, n) {
  if (n === "__proto__")
    if (ro.call(t, n)) {
      if (Cd)
        return Cd(t, n).value;
    } else
      return;
  return t[n];
}, Sd = function e() {
  var t, n, r, a, i, o, s = arguments[0], u = 1, l = arguments.length, c = !1;
  for (typeof s == "boolean" && (c = s, s = arguments[1] || {}, u = 2), (s == null || typeof s != "object" && typeof s != "function") && (s = {}); u < l; ++u)
    if (t = arguments[u], t != null)
      for (n in t)
        r = Dd(s, n), a = Dd(t, n), s !== a && (c && a && (bd(a) || (i = _d(a))) ? (i ? (i = !1, o = r && _d(r) ? r : []) : o = r && bd(r) ? r : {}, yd(s, { name: n, newValue: e(c, o, a) })) : typeof a < "u" && yd(s, { name: n, newValue: a }));
  return s;
};
function uc(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function kO() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...a) {
    let i = -1;
    const o = a.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    s(null, ...a);
    function s(u, ...l) {
      const c = e[++i];
      let f = -1;
      if (u) {
        o(u);
        return;
      }
      for (; ++f < a.length; )
        (l[f] === null || l[f] === void 0) && (l[f] = a[f]);
      a = l, c ? PO(c, s)(...l) : o(null, ...l);
    }
  }
  function r(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), t;
  }
}
function PO(e, t) {
  let n;
  return r;
  function r(...o) {
    const s = e.length > o.length;
    let u;
    s && o.push(a);
    try {
      u = e.apply(this, o);
    } catch (l) {
      const c = l;
      if (s && n)
        throw c;
      return a(c);
    }
    s || (u instanceof Promise ? u.then(i, a) : u instanceof Error ? a(u) : i(u));
  }
  function a(o, ...s) {
    n || (n = !0, t(o, ...s));
  }
  function i(o) {
    a(null, o);
  }
}
const BO = ag().freeze(), rg = {}.hasOwnProperty;
function ag() {
  const e = kO(), t = [];
  let n = {}, r, a = -1;
  return i.data = o, i.Parser = void 0, i.Compiler = void 0, i.freeze = s, i.attachers = t, i.use = u, i.parse = l, i.stringify = c, i.run = f, i.runSync = E, i.process = T, i.processSync = g, i;
  function i() {
    const m = ag();
    let v = -1;
    for (; ++v < t.length; )
      m.use(...t[v]);
    return m.data(Sd(!0, {}, n)), m;
  }
  function o(m, v) {
    return typeof m == "string" ? arguments.length === 2 ? (su("data", r), n[m] = v, i) : rg.call(n, m) && n[m] || null : m ? (su("data", r), n = m, i) : n;
  }
  function s() {
    if (r)
      return i;
    for (; ++a < t.length; ) {
      const [m, ...v] = t[a];
      if (v[0] === !1)
        continue;
      v[0] === !0 && (v[0] = void 0);
      const b = m.call(i, ...v);
      typeof b == "function" && e.use(b);
    }
    return r = !0, a = Number.POSITIVE_INFINITY, i;
  }
  function u(m, ...v) {
    let b;
    if (su("use", r), m != null)
      if (typeof m == "function")
        S(m, ...v);
      else if (typeof m == "object")
        Array.isArray(m) ? B(m) : O(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    return b && (n.settings = Object.assign(n.settings || {}, b)), i;
    function y(C) {
      if (typeof C == "function")
        S(C);
      else if (typeof C == "object")
        if (Array.isArray(C)) {
          const [I, ...G] = C;
          S(I, ...G);
        } else
          O(C);
      else
        throw new TypeError("Expected usable value, not `" + C + "`");
    }
    function O(C) {
      B(C.plugins), C.settings && (b = Object.assign(b || {}, C.settings));
    }
    function B(C) {
      let I = -1;
      if (C != null)
        if (Array.isArray(C))
          for (; ++I < C.length; ) {
            const G = C[I];
            y(G);
          }
        else
          throw new TypeError("Expected a list of plugins, not `" + C + "`");
    }
    function S(C, I) {
      let G = -1, V;
      for (; ++G < t.length; )
        if (t[G][0] === C) {
          V = t[G];
          break;
        }
      V ? (uc(V[1]) && uc(I) && (I = Sd(!0, V[1], I)), V[1] = I) : t.push([...arguments]);
    }
  }
  function l(m) {
    i.freeze();
    const v = Pi(m), b = i.Parser;
    return iu("parse", b), Od(b, "parse") ? new b(String(v), v).parse() : b(String(v), v);
  }
  function c(m, v) {
    i.freeze();
    const b = Pi(v), y = i.Compiler;
    return ou("stringify", y), Nd(m), Od(y, "compile") ? new y(m, b).compile() : y(m, b);
  }
  function f(m, v, b) {
    if (Nd(m), i.freeze(), !b && typeof v == "function" && (b = v, v = void 0), !b)
      return new Promise(y);
    y(null, b);
    function y(O, B) {
      e.run(m, Pi(v), S);
      function S(C, I, G) {
        I = I || m, C ? B(C) : O ? O(I) : b(null, I, G);
      }
    }
  }
  function E(m, v) {
    let b, y;
    return i.run(m, v, O), wd("runSync", "run", y), b;
    function O(B, S) {
      vd(B), b = S, y = !0;
    }
  }
  function T(m, v) {
    if (i.freeze(), iu("process", i.Parser), ou("process", i.Compiler), !v)
      return new Promise(b);
    b(null, v);
    function b(y, O) {
      const B = Pi(m);
      i.run(i.parse(B), B, (C, I, G) => {
        if (C || !I || !G)
          S(C);
        else {
          const V = i.stringify(I, G);
          V == null || ($O(V) ? G.value = V : G.result = V), S(C, G);
        }
      });
      function S(C, I) {
        C || !I ? O(C) : y ? y(I) : v(null, I);
      }
    }
  }
  function g(m) {
    let v;
    i.freeze(), iu("processSync", i.Parser), ou("processSync", i.Compiler);
    const b = Pi(m);
    return i.process(b, y), wd("processSync", "process", v), b;
    function y(O) {
      v = !0, vd(O);
    }
  }
}
function Od(e, t) {
  return typeof e == "function" && e.prototype && (FO(e.prototype) || t in e.prototype);
}
function FO(e) {
  let t;
  for (t in e)
    if (rg.call(e, t))
      return !0;
  return !1;
}
function iu(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Parser`");
}
function ou(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Compiler`");
}
function su(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Nd(e) {
  if (!uc(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function wd(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Pi(e) {
  return LO(e) ? e : new tg(e);
}
function LO(e) {
  return Boolean(
    e && typeof e == "object" && "message" in e && "messages" in e
  );
}
function $O(e) {
  return typeof e == "string" || eg(e);
}
function HO(e, t) {
  var { includeImageAlt: n = !0 } = t || {};
  return ig(e, n);
}
function ig(e, t) {
  return e && typeof e == "object" && (e.value || (t ? e.alt : "") || "children" in e && Id(e.children, t) || Array.isArray(e) && Id(e, t)) || "";
}
function Id(e, t) {
  for (var n = [], r = -1; ++r < e.length; )
    n[r] = ig(e[r], t);
  return n.join("");
}
function Rn(e, t, n, r) {
  const a = e.length;
  let i = 0, o;
  if (t < 0 ? t = -t > a ? 0 : a + t : t = t > a ? a : t, n = n > 0 ? n : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(t, n), [].splice.apply(e, o);
  else
    for (n && [].splice.apply(e, [t, n]); i < r.length; )
      o = r.slice(i, i + 1e4), o.unshift(t, 0), [].splice.apply(e, o), i += 1e4, t += 1e4;
}
function Un(e, t) {
  return e.length > 0 ? (Rn(e, e.length, 0, t), e) : t;
}
const Rd = {}.hasOwnProperty;
function og(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    UO(t, e[n]);
  return t;
}
function UO(e, t) {
  let n;
  for (n in t) {
    const a = (Rd.call(e, n) ? e[n] : void 0) || (e[n] = {}), i = t[n];
    let o;
    for (o in i) {
      Rd.call(a, o) || (a[o] = []);
      const s = i[o];
      jO(
        a[o],
        Array.isArray(s) ? s : s ? [s] : []
      );
    }
  }
}
function jO(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Rn(e, 0, 0, r);
}
const zO = /[!-/:-@[-`{-~\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, gn = ra(/[A-Za-z]/), lc = ra(/\d/), GO = ra(/[\dA-Fa-f]/), fn = ra(/[\dA-Za-z]/), VO = ra(/[!-/:-@[-`{-~]/), Md = ra(/[#-'*+\--9=?A-Z^-~]/);
function Do(e) {
  return e !== null && (e < 32 || e === 127);
}
function kt(e) {
  return e !== null && (e < 0 || e === 32);
}
function Be(e) {
  return e !== null && e < -2;
}
function It(e) {
  return e === -2 || e === -1 || e === 32;
}
const Da = ra(/\s/), Xo = ra(zO);
function ra(e) {
  return t;
  function t(n) {
    return n !== null && e.test(String.fromCharCode(n));
  }
}
function rt(e, t, n, r) {
  const a = r ? r - 1 : Number.POSITIVE_INFINITY;
  let i = 0;
  return o;
  function o(u) {
    return It(u) ? (e.enter(n), s(u)) : t(u);
  }
  function s(u) {
    return It(u) && i++ < a ? (e.consume(u), s) : (e.exit(n), t(u));
  }
}
const YO = {
  tokenize: KO
};
function KO(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    a
  );
  let n;
  return t;
  function r(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), rt(e, t, "linePrefix");
  }
  function a(s) {
    return e.enter("paragraph"), i(s);
  }
  function i(s) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = u), n = u, o(s);
  }
  function o(s) {
    if (s === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(s);
      return;
    }
    return Be(s) ? (e.consume(s), e.exit("chunkText"), i) : (e.consume(s), o);
  }
}
const WO = {
  tokenize: qO
}, xd = {
  tokenize: XO
};
function qO(e) {
  const t = this, n = [];
  let r = 0, a, i, o;
  return s;
  function s(O) {
    if (r < n.length) {
      const B = n[r];
      return t.containerState = B[1], e.attempt(
        B[0].continuation,
        u,
        l
      )(O);
    }
    return l(O);
  }
  function u(O) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, a && y();
      const B = t.events.length;
      let S = B, C;
      for (; S--; )
        if (t.events[S][0] === "exit" && t.events[S][1].type === "chunkFlow") {
          C = t.events[S][1].end;
          break;
        }
      b(r);
      let I = B;
      for (; I < t.events.length; )
        t.events[I][1].end = Object.assign({}, C), I++;
      return Rn(
        t.events,
        S + 1,
        0,
        t.events.slice(B)
      ), t.events.length = I, l(O);
    }
    return s(O);
  }
  function l(O) {
    if (r === n.length) {
      if (!a)
        return E(O);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return g(O);
      t.interrupt = Boolean(
        a.currentConstruct && !a._gfmTableDynamicInterruptHack
      );
    }
    return t.containerState = {}, e.check(
      xd,
      c,
      f
    )(O);
  }
  function c(O) {
    return a && y(), b(r), E(O);
  }
  function f(O) {
    return t.parser.lazy[t.now().line] = r !== n.length, o = t.now().offset, g(O);
  }
  function E(O) {
    return t.containerState = {}, e.attempt(
      xd,
      T,
      g
    )(O);
  }
  function T(O) {
    return r++, n.push([t.currentConstruct, t.containerState]), E(O);
  }
  function g(O) {
    if (O === null) {
      a && y(), b(0), e.consume(O);
      return;
    }
    return a = a || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: i,
      _tokenizer: a
    }), m(O);
  }
  function m(O) {
    if (O === null) {
      v(e.exit("chunkFlow"), !0), b(0), e.consume(O);
      return;
    }
    return Be(O) ? (e.consume(O), v(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, s) : (e.consume(O), m);
  }
  function v(O, B) {
    const S = t.sliceStream(O);
    if (B && S.push(null), O.previous = i, i && (i.next = O), i = O, a.defineSkip(O.start), a.write(S), t.parser.lazy[O.start.line]) {
      let C = a.events.length;
      for (; C--; )
        if (a.events[C][1].start.offset < o && (!a.events[C][1].end || a.events[C][1].end.offset > o))
          return;
      const I = t.events.length;
      let G = I, V, w;
      for (; G--; )
        if (t.events[G][0] === "exit" && t.events[G][1].type === "chunkFlow") {
          if (V) {
            w = t.events[G][1].end;
            break;
          }
          V = !0;
        }
      for (b(r), C = I; C < t.events.length; )
        t.events[C][1].end = Object.assign({}, w), C++;
      Rn(
        t.events,
        G + 1,
        0,
        t.events.slice(I)
      ), t.events.length = C;
    }
  }
  function b(O) {
    let B = n.length;
    for (; B-- > O; ) {
      const S = n[B];
      t.containerState = S[1], S[0].exit.call(t, e);
    }
    n.length = O;
  }
  function y() {
    a.write([null]), i = void 0, a = void 0, t.containerState._closeFlow = void 0;
  }
}
function XO(e, t, n) {
  return rt(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function So(e) {
  if (e === null || kt(e) || Da(e))
    return 1;
  if (Xo(e))
    return 2;
}
function Qo(e, t, n) {
  const r = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const i = e[a].resolveAll;
    i && !r.includes(i) && (t = i(t, n), r.push(i));
  }
  return t;
}
const cc = {
  name: "attention",
  tokenize: ZO,
  resolveAll: QO
};
function QO(e, t) {
  let n = -1, r, a, i, o, s, u, l, c;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          u = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const f = Object.assign({}, e[r][1].end), E = Object.assign({}, e[n][1].start);
          kd(f, -u), kd(E, u), o = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: Object.assign({}, e[r][1].end)
          }, s = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[n][1].start),
            end: E
          }, i = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[n][1].start)
          }, a = {
            type: u > 1 ? "strong" : "emphasis",
            start: Object.assign({}, o.start),
            end: Object.assign({}, s.end)
          }, e[r][1].end = Object.assign({}, o.start), e[n][1].start = Object.assign({}, s.end), l = [], e[r][1].end.offset - e[r][1].start.offset && (l = Un(l, [
            ["enter", e[r][1], t],
            ["exit", e[r][1], t]
          ])), l = Un(l, [
            ["enter", a, t],
            ["enter", o, t],
            ["exit", o, t],
            ["enter", i, t]
          ]), l = Un(
            l,
            Qo(
              t.parser.constructs.insideSpan.null,
              e.slice(r + 1, n),
              t
            )
          ), l = Un(l, [
            ["exit", i, t],
            ["enter", s, t],
            ["exit", s, t],
            ["exit", a, t]
          ]), e[n][1].end.offset - e[n][1].start.offset ? (c = 2, l = Un(l, [
            ["enter", e[n][1], t],
            ["exit", e[n][1], t]
          ])) : c = 0, Rn(e, r - 1, n - r + 3, l), n = r + l.length - c - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function ZO(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, a = So(r);
  let i;
  return o;
  function o(u) {
    return e.enter("attentionSequence"), i = u, s(u);
  }
  function s(u) {
    if (u === i)
      return e.consume(u), s;
    const l = e.exit("attentionSequence"), c = So(u), f = !c || c === 2 && a || n.includes(u), E = !a || a === 2 && c || n.includes(r);
    return l._open = Boolean(i === 42 ? f : f && (a || !E)), l._close = Boolean(i === 42 ? E : E && (c || !f)), t(u);
  }
}
function kd(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const JO = {
  name: "autolink",
  tokenize: eN
};
function eN(e, t, n) {
  let r = 1;
  return a;
  function a(g) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), i;
  }
  function i(g) {
    return gn(g) ? (e.consume(g), o) : Md(g) ? l(g) : n(g);
  }
  function o(g) {
    return g === 43 || g === 45 || g === 46 || fn(g) ? s(g) : l(g);
  }
  function s(g) {
    return g === 58 ? (e.consume(g), u) : (g === 43 || g === 45 || g === 46 || fn(g)) && r++ < 32 ? (e.consume(g), s) : l(g);
  }
  function u(g) {
    return g === 62 ? (e.exit("autolinkProtocol"), T(g)) : g === null || g === 32 || g === 60 || Do(g) ? n(g) : (e.consume(g), u);
  }
  function l(g) {
    return g === 64 ? (e.consume(g), r = 0, c) : Md(g) ? (e.consume(g), l) : n(g);
  }
  function c(g) {
    return fn(g) ? f(g) : n(g);
  }
  function f(g) {
    return g === 46 ? (e.consume(g), r = 0, c) : g === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", T(g)) : E(g);
  }
  function E(g) {
    return (g === 45 || fn(g)) && r++ < 63 ? (e.consume(g), g === 45 ? E : f) : n(g);
  }
  function T(g) {
    return e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.exit("autolink"), t;
  }
}
const T1 = {
  tokenize: tN,
  partial: !0
};
function tN(e, t, n) {
  return rt(e, r, "linePrefix");
  function r(a) {
    return a === null || Be(a) ? t(a) : n(a);
  }
}
const sg = {
  name: "blockQuote",
  tokenize: nN,
  continuation: {
    tokenize: rN
  },
  exit: aN
};
function nN(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    if (o === 62) {
      const s = r.containerState;
      return s.open || (e.enter("blockQuote", {
        _container: !0
      }), s.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), i;
    }
    return n(o);
  }
  function i(o) {
    return It(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(o));
  }
}
function rN(e, t, n) {
  return rt(
    e,
    e.attempt(sg, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function aN(e) {
  e.exit("blockQuote");
}
const ug = {
  name: "characterEscape",
  tokenize: iN
};
function iN(e, t, n) {
  return r;
  function r(i) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(i), e.exit("escapeMarker"), a;
  }
  function a(i) {
    return VO(i) ? (e.enter("characterEscapeValue"), e.consume(i), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(i);
  }
}
const Pd = document.createElement("i");
function Jc(e) {
  const t = "&" + e + ";";
  Pd.innerHTML = t;
  const n = Pd.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
const lg = {
  name: "characterReference",
  tokenize: oN
};
function oN(e, t, n) {
  const r = this;
  let a = 0, i, o;
  return s;
  function s(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), u;
  }
  function u(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), l) : (e.enter("characterReferenceValue"), i = 31, o = fn, c(f));
  }
  function l(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), i = 6, o = GO, c) : (e.enter("characterReferenceValue"), i = 7, o = lc, c(f));
  }
  function c(f) {
    let E;
    return f === 59 && a ? (E = e.exit("characterReferenceValue"), o === fn && !Jc(r.sliceSerialize(E)) ? n(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), t)) : o(f) && a++ < i ? (e.consume(f), c) : n(f);
  }
}
const Bd = {
  name: "codeFenced",
  tokenize: sN,
  concrete: !0
};
function sN(e, t, n) {
  const r = this, a = {
    tokenize: S,
    partial: !0
  }, i = {
    tokenize: B,
    partial: !0
  }, o = this.events[this.events.length - 1], s = o && o[1].type === "linePrefix" ? o[2].sliceSerialize(o[1], !0).length : 0;
  let u = 0, l;
  return c;
  function c(C) {
    return e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), l = C, f(C);
  }
  function f(C) {
    return C === l ? (e.consume(C), u++, f) : (e.exit("codeFencedFenceSequence"), u < 3 ? n(C) : rt(e, E, "whitespace")(C));
  }
  function E(C) {
    return C === null || Be(C) ? v(C) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), T(C));
  }
  function T(C) {
    return C === null || kt(C) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), rt(e, g, "whitespace")(C)) : C === 96 && C === l ? n(C) : (e.consume(C), T);
  }
  function g(C) {
    return C === null || Be(C) ? v(C) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), m(C));
  }
  function m(C) {
    return C === null || Be(C) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), v(C)) : C === 96 && C === l ? n(C) : (e.consume(C), m);
  }
  function v(C) {
    return e.exit("codeFencedFence"), r.interrupt ? t(C) : b(C);
  }
  function b(C) {
    return C === null ? O(C) : Be(C) ? e.attempt(
      i,
      e.attempt(
        a,
        O,
        s ? rt(
          e,
          b,
          "linePrefix",
          s + 1
        ) : b
      ),
      O
    )(C) : (e.enter("codeFlowValue"), y(C));
  }
  function y(C) {
    return C === null || Be(C) ? (e.exit("codeFlowValue"), b(C)) : (e.consume(C), y);
  }
  function O(C) {
    return e.exit("codeFenced"), t(C);
  }
  function B(C, I, G) {
    const V = this;
    return w;
    function w(X) {
      return C.enter("lineEnding"), C.consume(X), C.exit("lineEnding"), Y;
    }
    function Y(X) {
      return V.parser.lazy[V.now().line] ? G(X) : I(X);
    }
  }
  function S(C, I, G) {
    let V = 0;
    return rt(
      C,
      w,
      "linePrefix",
      this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    );
    function w(H) {
      return C.enter("codeFencedFence"), C.enter("codeFencedFenceSequence"), Y(H);
    }
    function Y(H) {
      return H === l ? (C.consume(H), V++, Y) : V < u ? G(H) : (C.exit("codeFencedFenceSequence"), rt(C, X, "whitespace")(H));
    }
    function X(H) {
      return H === null || Be(H) ? (C.exit("codeFencedFence"), I(H)) : G(H);
    }
  }
}
const uu = {
  name: "codeIndented",
  tokenize: lN
}, uN = {
  tokenize: cN,
  partial: !0
};
function lN(e, t, n) {
  const r = this;
  return a;
  function a(l) {
    return e.enter("codeIndented"), rt(e, i, "linePrefix", 4 + 1)(l);
  }
  function i(l) {
    const c = r.events[r.events.length - 1];
    return c && c[1].type === "linePrefix" && c[2].sliceSerialize(c[1], !0).length >= 4 ? o(l) : n(l);
  }
  function o(l) {
    return l === null ? u(l) : Be(l) ? e.attempt(uN, o, u)(l) : (e.enter("codeFlowValue"), s(l));
  }
  function s(l) {
    return l === null || Be(l) ? (e.exit("codeFlowValue"), o(l)) : (e.consume(l), s);
  }
  function u(l) {
    return e.exit("codeIndented"), t(l);
  }
}
function cN(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : Be(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a) : rt(e, i, "linePrefix", 4 + 1)(o);
  }
  function i(o) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(o) : Be(o) ? a(o) : n(o);
  }
}
const fN = {
  name: "codeText",
  tokenize: mN,
  resolve: hN,
  previous: dN
};
function hN(e) {
  let t = e.length - 4, n = 3, r, a;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    a === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (a = r) : (r === t || e[r][1].type === "lineEnding") && (e[a][1].type = "codeTextData", r !== a + 2 && (e[a][1].end = e[r - 1][1].end, e.splice(a + 2, r - a - 2), t -= r - a - 2, r = a + 2), a = void 0);
  return e;
}
function dN(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function mN(e, t, n) {
  let r = 0, a, i;
  return o;
  function o(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), s(f);
  }
  function s(f) {
    return f === 96 ? (e.consume(f), r++, s) : (e.exit("codeTextSequence"), u(f));
  }
  function u(f) {
    return f === null ? n(f) : f === 96 ? (i = e.enter("codeTextSequence"), a = 0, c(f)) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), u) : Be(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), u) : (e.enter("codeTextData"), l(f));
  }
  function l(f) {
    return f === null || f === 32 || f === 96 || Be(f) ? (e.exit("codeTextData"), u(f)) : (e.consume(f), l);
  }
  function c(f) {
    return f === 96 ? (e.consume(f), a++, c) : a === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(f)) : (i.type = "codeTextData", l(f));
  }
}
function cg(e) {
  const t = {};
  let n = -1, r, a, i, o, s, u, l;
  for (; ++n < e.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = e[n], n && r[1].type === "chunkFlow" && e[n - 1][1].type === "listItemPrefix" && (u = r[1]._tokenizer.events, i = 0, i < u.length && u[i][1].type === "lineEndingBlank" && (i += 2), i < u.length && u[i][1].type === "content"))
      for (; ++i < u.length && u[i][1].type !== "content"; )
        u[i][1].type === "chunkText" && (u[i][1]._isInFirstContentOfListItem = !0, i++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, pN(e, n)), n = t[n], l = !0);
    else if (r[1]._container) {
      for (i = n, a = void 0; i-- && (o = e[i], o[1].type === "lineEnding" || o[1].type === "lineEndingBlank"); )
        o[0] === "enter" && (a && (e[a][1].type = "lineEndingBlank"), o[1].type = "lineEnding", a = i);
      a && (r[1].end = Object.assign({}, e[a][1].start), s = e.slice(a, n), s.unshift(r), Rn(e, a, n - a + 1, s));
    }
  }
  return !l;
}
function pN(e, t) {
  const n = e[t][1], r = e[t][2];
  let a = t - 1;
  const i = [], o = n._tokenizer || r.parser[n.contentType](n.start), s = o.events, u = [], l = {};
  let c, f, E = -1, T = n, g = 0, m = 0;
  const v = [m];
  for (; T; ) {
    for (; e[++a][1] !== T; )
      ;
    i.push(a), T._tokenizer || (c = r.sliceStream(T), T.next || c.push(null), f && o.defineSkip(T.start), T._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(c), T._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), f = T, T = T.next;
  }
  for (T = n; ++E < s.length; )
    s[E][0] === "exit" && s[E - 1][0] === "enter" && s[E][1].type === s[E - 1][1].type && s[E][1].start.line !== s[E][1].end.line && (m = E + 1, v.push(m), T._tokenizer = void 0, T.previous = void 0, T = T.next);
  for (o.events = [], T ? (T._tokenizer = void 0, T.previous = void 0) : v.pop(), E = v.length; E--; ) {
    const b = s.slice(v[E], v[E + 1]), y = i.pop();
    u.unshift([y, y + b.length - 1]), Rn(e, y, 2, b);
  }
  for (E = -1; ++E < u.length; )
    l[g + u[E][0]] = g + u[E][1], g += u[E][1] - u[E][0] - 1;
  return l;
}
const gN = {
  tokenize: vN,
  resolve: TN
}, EN = {
  tokenize: AN,
  partial: !0
};
function TN(e) {
  return cg(e), e;
}
function vN(e, t) {
  let n;
  return r;
  function r(s) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), a(s);
  }
  function a(s) {
    return s === null ? i(s) : Be(s) ? e.check(
      EN,
      o,
      i
    )(s) : (e.consume(s), a);
  }
  function i(s) {
    return e.exit("chunkContent"), e.exit("content"), t(s);
  }
  function o(s) {
    return e.consume(s), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, a;
  }
}
function AN(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), rt(e, i, "linePrefix");
  }
  function i(o) {
    if (o === null || Be(o))
      return n(o);
    const s = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(o) : e.interrupt(r.parser.constructs.flow, n, t)(o);
  }
}
function fg(e, t, n, r, a, i, o, s, u) {
  const l = u || Number.POSITIVE_INFINITY;
  let c = 0;
  return f;
  function f(b) {
    return b === 60 ? (e.enter(r), e.enter(a), e.enter(i), e.consume(b), e.exit(i), E) : b === null || b === 41 || Do(b) ? n(b) : (e.enter(r), e.enter(o), e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), m(b));
  }
  function E(b) {
    return b === 62 ? (e.enter(i), e.consume(b), e.exit(i), e.exit(a), e.exit(r), t) : (e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), T(b));
  }
  function T(b) {
    return b === 62 ? (e.exit("chunkString"), e.exit(s), E(b)) : b === null || b === 60 || Be(b) ? n(b) : (e.consume(b), b === 92 ? g : T);
  }
  function g(b) {
    return b === 60 || b === 62 || b === 92 ? (e.consume(b), T) : T(b);
  }
  function m(b) {
    return b === 40 ? ++c > l ? n(b) : (e.consume(b), m) : b === 41 ? c-- ? (e.consume(b), m) : (e.exit("chunkString"), e.exit(s), e.exit(o), e.exit(r), t(b)) : b === null || kt(b) ? c ? n(b) : (e.exit("chunkString"), e.exit(s), e.exit(o), e.exit(r), t(b)) : Do(b) ? n(b) : (e.consume(b), b === 92 ? v : m);
  }
  function v(b) {
    return b === 40 || b === 41 || b === 92 ? (e.consume(b), m) : m(b);
  }
}
function hg(e, t, n, r, a, i) {
  const o = this;
  let s = 0, u;
  return l;
  function l(T) {
    return e.enter(r), e.enter(a), e.consume(T), e.exit(a), e.enter(i), c;
  }
  function c(T) {
    return T === null || T === 91 || T === 93 && !u || T === 94 && !s && "_hiddenFootnoteSupport" in o.parser.constructs || s > 999 ? n(T) : T === 93 ? (e.exit(i), e.enter(a), e.consume(T), e.exit(a), e.exit(r), t) : Be(T) ? (e.enter("lineEnding"), e.consume(T), e.exit("lineEnding"), c) : (e.enter("chunkString", {
      contentType: "string"
    }), f(T));
  }
  function f(T) {
    return T === null || T === 91 || T === 93 || Be(T) || s++ > 999 ? (e.exit("chunkString"), c(T)) : (e.consume(T), u = u || !It(T), T === 92 ? E : f);
  }
  function E(T) {
    return T === 91 || T === 92 || T === 93 ? (e.consume(T), s++, f) : f(T);
  }
}
function dg(e, t, n, r, a, i) {
  let o;
  return s;
  function s(E) {
    return e.enter(r), e.enter(a), e.consume(E), e.exit(a), o = E === 40 ? 41 : E, u;
  }
  function u(E) {
    return E === o ? (e.enter(a), e.consume(E), e.exit(a), e.exit(r), t) : (e.enter(i), l(E));
  }
  function l(E) {
    return E === o ? (e.exit(i), u(o)) : E === null ? n(E) : Be(E) ? (e.enter("lineEnding"), e.consume(E), e.exit("lineEnding"), rt(e, l, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), c(E));
  }
  function c(E) {
    return E === o || E === null || Be(E) ? (e.exit("chunkString"), l(E)) : (e.consume(E), E === 92 ? f : c);
  }
  function f(E) {
    return E === o || E === 92 ? (e.consume(E), c) : c(E);
  }
}
function Zi(e, t) {
  let n;
  return r;
  function r(a) {
    return Be(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), n = !0, r) : It(a) ? rt(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(a) : t(a);
  }
}
function or(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const CN = {
  name: "definition",
  tokenize: bN
}, _N = {
  tokenize: yN,
  partial: !0
};
function bN(e, t, n) {
  const r = this;
  let a;
  return i;
  function i(u) {
    return e.enter("definition"), hg.call(
      r,
      e,
      o,
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(u);
  }
  function o(u) {
    return a = or(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), u === 58 ? (e.enter("definitionMarker"), e.consume(u), e.exit("definitionMarker"), Zi(
      e,
      fg(
        e,
        e.attempt(
          _N,
          rt(e, s, "whitespace"),
          rt(e, s, "whitespace")
        ),
        n,
        "definitionDestination",
        "definitionDestinationLiteral",
        "definitionDestinationLiteralMarker",
        "definitionDestinationRaw",
        "definitionDestinationString"
      )
    )) : n(u);
  }
  function s(u) {
    return u === null || Be(u) ? (e.exit("definition"), r.parser.defined.includes(a) || r.parser.defined.push(a), t(u)) : n(u);
  }
}
function yN(e, t, n) {
  return r;
  function r(o) {
    return kt(o) ? Zi(e, a)(o) : n(o);
  }
  function a(o) {
    return o === 34 || o === 39 || o === 40 ? dg(
      e,
      rt(e, i, "whitespace"),
      n,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(o) : n(o);
  }
  function i(o) {
    return o === null || Be(o) ? t(o) : n(o);
  }
}
const DN = {
  name: "hardBreakEscape",
  tokenize: SN
};
function SN(e, t, n) {
  return r;
  function r(i) {
    return e.enter("hardBreakEscape"), e.enter("escapeMarker"), e.consume(i), a;
  }
  function a(i) {
    return Be(i) ? (e.exit("escapeMarker"), e.exit("hardBreakEscape"), t(i)) : n(i);
  }
}
const ON = {
  name: "headingAtx",
  tokenize: wN,
  resolve: NN
};
function NN(e, t) {
  let n = e.length - 2, r = 3, a, i;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (a = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, i = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Rn(e, r, n - r + 1, [
    ["enter", a, t],
    ["enter", i, t],
    ["exit", i, t],
    ["exit", a, t]
  ])), e;
}
function wN(e, t, n) {
  const r = this;
  let a = 0;
  return i;
  function i(c) {
    return e.enter("atxHeading"), e.enter("atxHeadingSequence"), o(c);
  }
  function o(c) {
    return c === 35 && a++ < 6 ? (e.consume(c), o) : c === null || kt(c) ? (e.exit("atxHeadingSequence"), r.interrupt ? t(c) : s(c)) : n(c);
  }
  function s(c) {
    return c === 35 ? (e.enter("atxHeadingSequence"), u(c)) : c === null || Be(c) ? (e.exit("atxHeading"), t(c)) : It(c) ? rt(e, s, "whitespace")(c) : (e.enter("atxHeadingText"), l(c));
  }
  function u(c) {
    return c === 35 ? (e.consume(c), u) : (e.exit("atxHeadingSequence"), s(c));
  }
  function l(c) {
    return c === null || c === 35 || kt(c) ? (e.exit("atxHeadingText"), s(c)) : (e.consume(c), l);
  }
}
const IN = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Fd = ["pre", "script", "style", "textarea"], RN = {
  name: "htmlFlow",
  tokenize: kN,
  resolveTo: xN,
  concrete: !0
}, MN = {
  tokenize: PN,
  partial: !0
};
function xN(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function kN(e, t, n) {
  const r = this;
  let a, i, o, s, u;
  return l;
  function l(D) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(D), c;
  }
  function c(D) {
    return D === 33 ? (e.consume(D), f) : D === 47 ? (e.consume(D), g) : D === 63 ? (e.consume(D), a = 3, r.interrupt ? t : J) : gn(D) ? (e.consume(D), o = String.fromCharCode(D), i = !0, m) : n(D);
  }
  function f(D) {
    return D === 45 ? (e.consume(D), a = 2, E) : D === 91 ? (e.consume(D), a = 5, o = "CDATA[", s = 0, T) : gn(D) ? (e.consume(D), a = 4, r.interrupt ? t : J) : n(D);
  }
  function E(D) {
    return D === 45 ? (e.consume(D), r.interrupt ? t : J) : n(D);
  }
  function T(D) {
    return D === o.charCodeAt(s++) ? (e.consume(D), s === o.length ? r.interrupt ? t : Y : T) : n(D);
  }
  function g(D) {
    return gn(D) ? (e.consume(D), o = String.fromCharCode(D), m) : n(D);
  }
  function m(D) {
    return D === null || D === 47 || D === 62 || kt(D) ? D !== 47 && i && Fd.includes(o.toLowerCase()) ? (a = 1, r.interrupt ? t(D) : Y(D)) : IN.includes(o.toLowerCase()) ? (a = 6, D === 47 ? (e.consume(D), v) : r.interrupt ? t(D) : Y(D)) : (a = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(D) : i ? y(D) : b(D)) : D === 45 || fn(D) ? (e.consume(D), o += String.fromCharCode(D), m) : n(D);
  }
  function v(D) {
    return D === 62 ? (e.consume(D), r.interrupt ? t : Y) : n(D);
  }
  function b(D) {
    return It(D) ? (e.consume(D), b) : V(D);
  }
  function y(D) {
    return D === 47 ? (e.consume(D), V) : D === 58 || D === 95 || gn(D) ? (e.consume(D), O) : It(D) ? (e.consume(D), y) : V(D);
  }
  function O(D) {
    return D === 45 || D === 46 || D === 58 || D === 95 || fn(D) ? (e.consume(D), O) : B(D);
  }
  function B(D) {
    return D === 61 ? (e.consume(D), S) : It(D) ? (e.consume(D), B) : y(D);
  }
  function S(D) {
    return D === null || D === 60 || D === 61 || D === 62 || D === 96 ? n(D) : D === 34 || D === 39 ? (e.consume(D), u = D, C) : It(D) ? (e.consume(D), S) : (u = null, I(D));
  }
  function C(D) {
    return D === null || Be(D) ? n(D) : D === u ? (e.consume(D), G) : (e.consume(D), C);
  }
  function I(D) {
    return D === null || D === 34 || D === 39 || D === 60 || D === 61 || D === 62 || D === 96 || kt(D) ? B(D) : (e.consume(D), I);
  }
  function G(D) {
    return D === 47 || D === 62 || It(D) ? y(D) : n(D);
  }
  function V(D) {
    return D === 62 ? (e.consume(D), w) : n(D);
  }
  function w(D) {
    return It(D) ? (e.consume(D), w) : D === null || Be(D) ? Y(D) : n(D);
  }
  function Y(D) {
    return D === 45 && a === 2 ? (e.consume(D), L) : D === 60 && a === 1 ? (e.consume(D), Q) : D === 62 && a === 4 ? (e.consume(D), z) : D === 63 && a === 3 ? (e.consume(D), J) : D === 93 && a === 5 ? (e.consume(D), ee) : Be(D) && (a === 6 || a === 7) ? e.check(
      MN,
      z,
      X
    )(D) : D === null || Be(D) ? X(D) : (e.consume(D), Y);
  }
  function X(D) {
    return e.exit("htmlFlowData"), H(D);
  }
  function H(D) {
    return D === null ? _(D) : Be(D) ? e.attempt(
      {
        tokenize: $,
        partial: !0
      },
      H,
      _
    )(D) : (e.enter("htmlFlowData"), Y(D));
  }
  function $(D, he, oe) {
    return ve;
    function ve(Ce) {
      return D.enter("lineEnding"), D.consume(Ce), D.exit("lineEnding"), le;
    }
    function le(Ce) {
      return r.parser.lazy[r.now().line] ? oe(Ce) : he(Ce);
    }
  }
  function L(D) {
    return D === 45 ? (e.consume(D), J) : Y(D);
  }
  function Q(D) {
    return D === 47 ? (e.consume(D), o = "", j) : Y(D);
  }
  function j(D) {
    return D === 62 && Fd.includes(o.toLowerCase()) ? (e.consume(D), z) : gn(D) && o.length < 8 ? (e.consume(D), o += String.fromCharCode(D), j) : Y(D);
  }
  function ee(D) {
    return D === 93 ? (e.consume(D), J) : Y(D);
  }
  function J(D) {
    return D === 62 ? (e.consume(D), z) : D === 45 && a === 2 ? (e.consume(D), J) : Y(D);
  }
  function z(D) {
    return D === null || Be(D) ? (e.exit("htmlFlowData"), _(D)) : (e.consume(D), z);
  }
  function _(D) {
    return e.exit("htmlFlow"), t(D);
  }
}
function PN(e, t, n) {
  return r;
  function r(a) {
    return e.exit("htmlFlowData"), e.enter("lineEndingBlank"), e.consume(a), e.exit("lineEndingBlank"), e.attempt(T1, t, n);
  }
}
const BN = {
  name: "htmlText",
  tokenize: FN
};
function FN(e, t, n) {
  const r = this;
  let a, i, o, s;
  return u;
  function u(_) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(_), l;
  }
  function l(_) {
    return _ === 33 ? (e.consume(_), c) : _ === 47 ? (e.consume(_), I) : _ === 63 ? (e.consume(_), S) : gn(_) ? (e.consume(_), w) : n(_);
  }
  function c(_) {
    return _ === 45 ? (e.consume(_), f) : _ === 91 ? (e.consume(_), i = "CDATA[", o = 0, v) : gn(_) ? (e.consume(_), B) : n(_);
  }
  function f(_) {
    return _ === 45 ? (e.consume(_), E) : n(_);
  }
  function E(_) {
    return _ === null || _ === 62 ? n(_) : _ === 45 ? (e.consume(_), T) : g(_);
  }
  function T(_) {
    return _ === null || _ === 62 ? n(_) : g(_);
  }
  function g(_) {
    return _ === null ? n(_) : _ === 45 ? (e.consume(_), m) : Be(_) ? (s = g, ee(_)) : (e.consume(_), g);
  }
  function m(_) {
    return _ === 45 ? (e.consume(_), z) : g(_);
  }
  function v(_) {
    return _ === i.charCodeAt(o++) ? (e.consume(_), o === i.length ? b : v) : n(_);
  }
  function b(_) {
    return _ === null ? n(_) : _ === 93 ? (e.consume(_), y) : Be(_) ? (s = b, ee(_)) : (e.consume(_), b);
  }
  function y(_) {
    return _ === 93 ? (e.consume(_), O) : b(_);
  }
  function O(_) {
    return _ === 62 ? z(_) : _ === 93 ? (e.consume(_), O) : b(_);
  }
  function B(_) {
    return _ === null || _ === 62 ? z(_) : Be(_) ? (s = B, ee(_)) : (e.consume(_), B);
  }
  function S(_) {
    return _ === null ? n(_) : _ === 63 ? (e.consume(_), C) : Be(_) ? (s = S, ee(_)) : (e.consume(_), S);
  }
  function C(_) {
    return _ === 62 ? z(_) : S(_);
  }
  function I(_) {
    return gn(_) ? (e.consume(_), G) : n(_);
  }
  function G(_) {
    return _ === 45 || fn(_) ? (e.consume(_), G) : V(_);
  }
  function V(_) {
    return Be(_) ? (s = V, ee(_)) : It(_) ? (e.consume(_), V) : z(_);
  }
  function w(_) {
    return _ === 45 || fn(_) ? (e.consume(_), w) : _ === 47 || _ === 62 || kt(_) ? Y(_) : n(_);
  }
  function Y(_) {
    return _ === 47 ? (e.consume(_), z) : _ === 58 || _ === 95 || gn(_) ? (e.consume(_), X) : Be(_) ? (s = Y, ee(_)) : It(_) ? (e.consume(_), Y) : z(_);
  }
  function X(_) {
    return _ === 45 || _ === 46 || _ === 58 || _ === 95 || fn(_) ? (e.consume(_), X) : H(_);
  }
  function H(_) {
    return _ === 61 ? (e.consume(_), $) : Be(_) ? (s = H, ee(_)) : It(_) ? (e.consume(_), H) : Y(_);
  }
  function $(_) {
    return _ === null || _ === 60 || _ === 61 || _ === 62 || _ === 96 ? n(_) : _ === 34 || _ === 39 ? (e.consume(_), a = _, L) : Be(_) ? (s = $, ee(_)) : It(_) ? (e.consume(_), $) : (e.consume(_), a = void 0, j);
  }
  function L(_) {
    return _ === a ? (e.consume(_), Q) : _ === null ? n(_) : Be(_) ? (s = L, ee(_)) : (e.consume(_), L);
  }
  function Q(_) {
    return _ === 62 || _ === 47 || kt(_) ? Y(_) : n(_);
  }
  function j(_) {
    return _ === null || _ === 34 || _ === 39 || _ === 60 || _ === 61 || _ === 96 ? n(_) : _ === 62 || kt(_) ? Y(_) : (e.consume(_), j);
  }
  function ee(_) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(_), e.exit("lineEnding"), rt(
      e,
      J,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    );
  }
  function J(_) {
    return e.enter("htmlTextData"), s(_);
  }
  function z(_) {
    return _ === 62 ? (e.consume(_), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(_);
  }
}
const ef = {
  name: "labelEnd",
  tokenize: zN,
  resolveTo: jN,
  resolveAll: UN
}, LN = {
  tokenize: GN
}, $N = {
  tokenize: VN
}, HN = {
  tokenize: YN
};
function UN(e) {
  let t = -1, n;
  for (; ++t < e.length; )
    n = e[t][1], (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  return e;
}
function jN(e, t) {
  let n = e.length, r = 0, a, i, o, s;
  for (; n--; )
    if (a = e[n][1], i) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[n][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (o) {
      if (e[n][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (i = n, a.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else
      a.type === "labelEnd" && (o = n);
  const u = {
    type: e[i][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, l = {
    type: "label",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[o][1].end)
  }, c = {
    type: "labelText",
    start: Object.assign({}, e[i + r + 2][1].end),
    end: Object.assign({}, e[o - 2][1].start)
  };
  return s = [
    ["enter", u, t],
    ["enter", l, t]
  ], s = Un(s, e.slice(i + 1, i + r + 3)), s = Un(s, [["enter", c, t]]), s = Un(
    s,
    Qo(
      t.parser.constructs.insideSpan.null,
      e.slice(i + r + 4, o - 3),
      t
    )
  ), s = Un(s, [
    ["exit", c, t],
    e[o - 2],
    e[o - 1],
    ["exit", l, t]
  ]), s = Un(s, e.slice(o + 1)), s = Un(s, [["exit", u, t]]), Rn(e, i, e.length, s), e;
}
function zN(e, t, n) {
  const r = this;
  let a = r.events.length, i, o;
  for (; a--; )
    if ((r.events[a][1].type === "labelImage" || r.events[a][1].type === "labelLink") && !r.events[a][1]._balanced) {
      i = r.events[a][1];
      break;
    }
  return s;
  function s(c) {
    return i ? i._inactive ? l(c) : (o = r.parser.defined.includes(
      or(
        r.sliceSerialize({
          start: i.end,
          end: r.now()
        })
      )
    ), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(c), e.exit("labelMarker"), e.exit("labelEnd"), u) : n(c);
  }
  function u(c) {
    return c === 40 ? e.attempt(
      LN,
      t,
      o ? t : l
    )(c) : c === 91 ? e.attempt(
      $N,
      t,
      o ? e.attempt(HN, t, l) : l
    )(c) : o ? t(c) : l(c);
  }
  function l(c) {
    return i._balanced = !0, n(c);
  }
}
function GN(e, t, n) {
  return r;
  function r(u) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(u), e.exit("resourceMarker"), Zi(e, a);
  }
  function a(u) {
    return u === 41 ? s(u) : fg(
      e,
      i,
      n,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(u);
  }
  function i(u) {
    return kt(u) ? Zi(e, o)(u) : s(u);
  }
  function o(u) {
    return u === 34 || u === 39 || u === 40 ? dg(
      e,
      Zi(e, s),
      n,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(u) : s(u);
  }
  function s(u) {
    return u === 41 ? (e.enter("resourceMarker"), e.consume(u), e.exit("resourceMarker"), e.exit("resource"), t) : n(u);
  }
}
function VN(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    return hg.call(
      r,
      e,
      i,
      n,
      "reference",
      "referenceMarker",
      "referenceString"
    )(o);
  }
  function i(o) {
    return r.parser.defined.includes(
      or(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) ? t(o) : n(o);
  }
}
function YN(e, t, n) {
  return r;
  function r(i) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), a;
  }
  function a(i) {
    return i === 93 ? (e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), e.exit("reference"), t) : n(i);
  }
}
const KN = {
  name: "labelStartImage",
  tokenize: WN,
  resolveAll: ef.resolveAll
};
function WN(e, t, n) {
  const r = this;
  return a;
  function a(s) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(s), e.exit("labelImageMarker"), i;
  }
  function i(s) {
    return s === 91 ? (e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelImage"), o) : n(s);
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const qN = {
  name: "labelStartLink",
  tokenize: XN,
  resolveAll: ef.resolveAll
};
function XN(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), i;
  }
  function i(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
  }
}
const lu = {
  name: "lineEnding",
  tokenize: QN
};
function QN(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), rt(e, t, "linePrefix");
  }
}
const ao = {
  name: "thematicBreak",
  tokenize: ZN
};
function ZN(e, t, n) {
  let r = 0, a;
  return i;
  function i(u) {
    return e.enter("thematicBreak"), a = u, o(u);
  }
  function o(u) {
    return u === a ? (e.enter("thematicBreakSequence"), s(u)) : It(u) ? rt(e, o, "whitespace")(u) : r < 3 || u !== null && !Be(u) ? n(u) : (e.exit("thematicBreak"), t(u));
  }
  function s(u) {
    return u === a ? (e.consume(u), r++, s) : (e.exit("thematicBreakSequence"), o(u));
  }
}
const Cn = {
  name: "list",
  tokenize: tw,
  continuation: {
    tokenize: nw
  },
  exit: aw
}, JN = {
  tokenize: iw,
  partial: !0
}, ew = {
  tokenize: rw,
  partial: !0
};
function tw(e, t, n) {
  const r = this, a = r.events[r.events.length - 1];
  let i = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, o = 0;
  return s;
  function s(T) {
    const g = r.containerState.type || (T === 42 || T === 43 || T === 45 ? "listUnordered" : "listOrdered");
    if (g === "listUnordered" ? !r.containerState.marker || T === r.containerState.marker : lc(T)) {
      if (r.containerState.type || (r.containerState.type = g, e.enter(g, {
        _container: !0
      })), g === "listUnordered")
        return e.enter("listItemPrefix"), T === 42 || T === 45 ? e.check(ao, n, l)(T) : l(T);
      if (!r.interrupt || T === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(T);
    }
    return n(T);
  }
  function u(T) {
    return lc(T) && ++o < 10 ? (e.consume(T), u) : (!r.interrupt || o < 2) && (r.containerState.marker ? T === r.containerState.marker : T === 41 || T === 46) ? (e.exit("listItemValue"), l(T)) : n(T);
  }
  function l(T) {
    return e.enter("listItemMarker"), e.consume(T), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || T, e.check(
      T1,
      r.interrupt ? n : c,
      e.attempt(
        JN,
        E,
        f
      )
    );
  }
  function c(T) {
    return r.containerState.initialBlankLine = !0, i++, E(T);
  }
  function f(T) {
    return It(T) ? (e.enter("listItemPrefixWhitespace"), e.consume(T), e.exit("listItemPrefixWhitespace"), E) : n(T);
  }
  function E(T) {
    return r.containerState.size = i + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(T);
  }
}
function nw(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(T1, a, i);
  function a(s) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, rt(
      e,
      t,
      "listItemIndent",
      r.containerState.size + 1
    )(s);
  }
  function i(s) {
    return r.containerState.furtherBlankLines || !It(s) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(s)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(ew, t, o)(s));
  }
  function o(s) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, rt(
      e,
      e.attempt(Cn, t, n),
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(s);
  }
}
function rw(e, t, n) {
  const r = this;
  return rt(
    e,
    a,
    "listItemIndent",
    r.containerState.size + 1
  );
  function a(i) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? t(i) : n(i);
  }
}
function aw(e) {
  e.exit(this.containerState.type);
}
function iw(e, t, n) {
  const r = this;
  return rt(
    e,
    a,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1
  );
  function a(i) {
    const o = r.events[r.events.length - 1];
    return !It(i) && o && o[1].type === "listItemPrefixWhitespace" ? t(i) : n(i);
  }
}
const Ld = {
  name: "setextUnderline",
  tokenize: sw,
  resolveTo: ow
};
function ow(e, t) {
  let n = e.length, r, a, i;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (a = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !i && e[n][1].type === "definition" && (i = n);
  const o = {
    type: "setextHeading",
    start: Object.assign({}, e[a][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[a][1].type = "setextHeadingText", i ? (e.splice(a, 0, ["enter", o, t]), e.splice(i + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[i][1].end)) : e[r][1] = o, e.push(["exit", o, t]), e;
}
function sw(e, t, n) {
  const r = this;
  let a = r.events.length, i, o;
  for (; a--; )
    if (r.events[a][1].type !== "lineEnding" && r.events[a][1].type !== "linePrefix" && r.events[a][1].type !== "content") {
      o = r.events[a][1].type === "paragraph";
      break;
    }
  return s;
  function s(c) {
    return !r.parser.lazy[r.now().line] && (r.interrupt || o) ? (e.enter("setextHeadingLine"), e.enter("setextHeadingLineSequence"), i = c, u(c)) : n(c);
  }
  function u(c) {
    return c === i ? (e.consume(c), u) : (e.exit("setextHeadingLineSequence"), rt(e, l, "lineSuffix")(c));
  }
  function l(c) {
    return c === null || Be(c) ? (e.exit("setextHeadingLine"), t(c)) : n(c);
  }
}
const uw = {
  tokenize: lw
};
function lw(e) {
  const t = this, n = e.attempt(
    T1,
    r,
    e.attempt(
      this.parser.constructs.flowInitial,
      a,
      rt(
        e,
        e.attempt(
          this.parser.constructs.flow,
          a,
          e.attempt(gN, a)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(i), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function a(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const cw = {
  resolveAll: pg()
}, fw = mg("string"), hw = mg("text");
function mg(e) {
  return {
    tokenize: t,
    resolveAll: pg(
      e === "text" ? dw : void 0
    )
  };
  function t(n) {
    const r = this, a = this.parser.constructs[e], i = n.attempt(a, o, s);
    return o;
    function o(c) {
      return l(c) ? i(c) : s(c);
    }
    function s(c) {
      if (c === null) {
        n.consume(c);
        return;
      }
      return n.enter("data"), n.consume(c), u;
    }
    function u(c) {
      return l(c) ? (n.exit("data"), i(c)) : (n.consume(c), u);
    }
    function l(c) {
      if (c === null)
        return !0;
      const f = a[c];
      let E = -1;
      if (f)
        for (; ++E < f.length; ) {
          const T = f[E];
          if (!T.previous || T.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function pg(e) {
  return t;
  function t(n, r) {
    let a = -1, i;
    for (; ++a <= n.length; )
      i === void 0 ? n[a] && n[a][1].type === "data" && (i = a, a++) : (!n[a] || n[a][1].type !== "data") && (a !== i + 2 && (n[i][1].end = n[a - 1][1].end, n.splice(i + 2, a - i - 2), a = i + 2), i = void 0);
    return e ? e(n, r) : n;
  }
}
function dw(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], a = t.sliceStream(r);
      let i = a.length, o = -1, s = 0, u;
      for (; i--; ) {
        const l = a[i];
        if (typeof l == "string") {
          for (o = l.length; l.charCodeAt(o - 1) === 32; )
            s++, o--;
          if (o)
            break;
          o = -1;
        } else if (l === -2)
          u = !0, s++;
        else if (l !== -1) {
          i++;
          break;
        }
      }
      if (s) {
        const l = {
          type: n === e.length || u || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - s,
            offset: r.end.offset - s,
            _index: r.start._index + i,
            _bufferIndex: i ? o : r.start._bufferIndex + o
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, l.start), r.start.offset === r.end.offset ? Object.assign(r, l) : (e.splice(
          n,
          0,
          ["enter", l, t],
          ["exit", l, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
function mw(e, t, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const a = {}, i = [];
  let o = [], s = [];
  const u = {
    consume: y,
    enter: O,
    exit: B,
    attempt: I(S),
    check: I(C),
    interrupt: I(C, {
      interrupt: !0
    })
  }, l = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: T,
    sliceSerialize: E,
    now: g,
    defineSkip: m,
    write: f
  };
  let c = t.tokenize.call(l, u);
  return t.resolveAll && i.push(t), l;
  function f(Y) {
    return o = Un(o, Y), v(), o[o.length - 1] !== null ? [] : (G(t, 0), l.events = Qo(i, l.events, l), l.events);
  }
  function E(Y, X) {
    return gw(T(Y), X);
  }
  function T(Y) {
    return pw(o, Y);
  }
  function g() {
    return Object.assign({}, r);
  }
  function m(Y) {
    a[Y.line] = Y.column, w();
  }
  function v() {
    let Y;
    for (; r._index < o.length; ) {
      const X = o[r._index];
      if (typeof X == "string")
        for (Y = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === Y && r._bufferIndex < X.length; )
          b(X.charCodeAt(r._bufferIndex));
      else
        b(X);
    }
  }
  function b(Y) {
    c = c(Y);
  }
  function y(Y) {
    Be(Y) ? (r.line++, r.column = 1, r.offset += Y === -3 ? 2 : 1, w()) : Y !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === o[r._index].length && (r._bufferIndex = -1, r._index++)), l.previous = Y;
  }
  function O(Y, X) {
    const H = X || {};
    return H.type = Y, H.start = g(), l.events.push(["enter", H, l]), s.push(H), H;
  }
  function B(Y) {
    const X = s.pop();
    return X.end = g(), l.events.push(["exit", X, l]), X;
  }
  function S(Y, X) {
    G(Y, X.from);
  }
  function C(Y, X) {
    X.restore();
  }
  function I(Y, X) {
    return H;
    function H($, L, Q) {
      let j, ee, J, z;
      return Array.isArray($) ? D($) : "tokenize" in $ ? D([$]) : _($);
      function _(le) {
        return Ce;
        function Ce(_e) {
          const ge = _e !== null && le[_e], ye = _e !== null && le.null, ze = [
            ...Array.isArray(ge) ? ge : ge ? [ge] : [],
            ...Array.isArray(ye) ? ye : ye ? [ye] : []
          ];
          return D(ze)(_e);
        }
      }
      function D(le) {
        return j = le, ee = 0, le.length === 0 ? Q : he(le[ee]);
      }
      function he(le) {
        return Ce;
        function Ce(_e) {
          return z = V(), J = le, le.partial || (l.currentConstruct = le), le.name && l.parser.constructs.disable.null.includes(le.name) ? ve() : le.tokenize.call(
            X ? Object.assign(Object.create(l), X) : l,
            u,
            oe,
            ve
          )(_e);
        }
      }
      function oe(le) {
        return Y(J, z), L;
      }
      function ve(le) {
        return z.restore(), ++ee < j.length ? he(j[ee]) : Q;
      }
    }
  }
  function G(Y, X) {
    Y.resolveAll && !i.includes(Y) && i.push(Y), Y.resolve && Rn(
      l.events,
      X,
      l.events.length - X,
      Y.resolve(l.events.slice(X), l)
    ), Y.resolveTo && (l.events = Y.resolveTo(l.events, l));
  }
  function V() {
    const Y = g(), X = l.previous, H = l.currentConstruct, $ = l.events.length, L = Array.from(s);
    return {
      restore: Q,
      from: $
    };
    function Q() {
      r = Y, l.previous = X, l.currentConstruct = H, l.events.length = $, s = L, w();
    }
  }
  function w() {
    r.line in a && r.column < 2 && (r.column = a[r.line], r.offset += a[r.line] - 1);
  }
}
function pw(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, a = t.end._index, i = t.end._bufferIndex;
  let o;
  return n === a ? o = [e[n].slice(r, i)] : (o = e.slice(n, a), r > -1 && (o[0] = o[0].slice(r)), i > 0 && o.push(e[a].slice(0, i))), o;
}
function gw(e, t) {
  let n = -1;
  const r = [];
  let a;
  for (; ++n < e.length; ) {
    const i = e[n];
    let o;
    if (typeof i == "string")
      o = i;
    else
      switch (i) {
        case -5: {
          o = "\r";
          break;
        }
        case -4: {
          o = `
`;
          break;
        }
        case -3: {
          o = `\r
`;
          break;
        }
        case -2: {
          o = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && a)
            continue;
          o = " ";
          break;
        }
        default:
          o = String.fromCharCode(i);
      }
    a = i === -2, r.push(o);
  }
  return r.join("");
}
const Ew = {
  [42]: Cn,
  [43]: Cn,
  [45]: Cn,
  [48]: Cn,
  [49]: Cn,
  [50]: Cn,
  [51]: Cn,
  [52]: Cn,
  [53]: Cn,
  [54]: Cn,
  [55]: Cn,
  [56]: Cn,
  [57]: Cn,
  [62]: sg
}, Tw = {
  [91]: CN
}, vw = {
  [-2]: uu,
  [-1]: uu,
  [32]: uu
}, Aw = {
  [35]: ON,
  [42]: ao,
  [45]: [Ld, ao],
  [60]: RN,
  [61]: Ld,
  [95]: ao,
  [96]: Bd,
  [126]: Bd
}, Cw = {
  [38]: lg,
  [92]: ug
}, _w = {
  [-5]: lu,
  [-4]: lu,
  [-3]: lu,
  [33]: KN,
  [38]: lg,
  [42]: cc,
  [60]: [JO, BN],
  [91]: qN,
  [92]: [DN, ug],
  [93]: ef,
  [95]: cc,
  [96]: fN
}, bw = {
  null: [cc, cw]
}, yw = {
  null: [42, 95]
}, Dw = {
  null: []
}, Sw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  document: Ew,
  contentInitial: Tw,
  flowInitial: vw,
  flow: Aw,
  string: Cw,
  text: _w,
  insideSpan: bw,
  attentionMarkers: yw,
  disable: Dw
}, Symbol.toStringTag, { value: "Module" }));
function Ow(e = {}) {
  const t = og(
    [Sw].concat(e.extensions || [])
  ), n = {
    defined: [],
    lazy: {},
    constructs: t,
    content: r(YO),
    document: r(WO),
    flow: r(uw),
    string: r(fw),
    text: r(hw)
  };
  return n;
  function r(a) {
    return i;
    function i(o) {
      return mw(n, a, o);
    }
  }
}
const $d = /[\0\t\n\r]/g;
function Nw() {
  let e = 1, t = "", n = !0, r;
  return a;
  function a(i, o, s) {
    const u = [];
    let l, c, f, E, T;
    for (i = t + i.toString(o), f = 0, t = "", n && (i.charCodeAt(0) === 65279 && f++, n = void 0); f < i.length; ) {
      if ($d.lastIndex = f, l = $d.exec(i), E = l && l.index !== void 0 ? l.index : i.length, T = i.charCodeAt(E), !l) {
        t = i.slice(f);
        break;
      }
      if (T === 10 && f === E && r)
        u.push(-3), r = void 0;
      else
        switch (r && (u.push(-5), r = void 0), f < E && (u.push(i.slice(f, E)), e += E - f), T) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (c = Math.ceil(e / 4) * 4, u.push(-2); e++ < c; )
              u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      f = E + 1;
    }
    return s && (r && u.push(-5), t && u.push(t), u.push(null)), u;
  }
}
function ww(e) {
  for (; !cg(e); )
    ;
  return e;
}
function gg(e, t) {
  const n = Number.parseInt(e, t);
  return n < 9 || n === 11 || n > 13 && n < 32 || n > 126 && n < 160 || n > 55295 && n < 57344 || n > 64975 && n < 65008 || (n & 65535) === 65535 || (n & 65535) === 65534 || n > 1114111 ? "\uFFFD" : String.fromCharCode(n);
}
const Iw = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function Eg(e) {
  return e.replace(Iw, Rw);
}
function Rw(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const a = n.charCodeAt(1), i = a === 120 || a === 88;
    return gg(n.slice(i ? 2 : 1), i ? 16 : 10);
  }
  return Jc(n) || e;
}
function io(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Hd(e.position) : "start" in e || "end" in e ? Hd(e) : "line" in e || "column" in e ? fc(e) : "";
}
function fc(e) {
  return Ud(e && e.line) + ":" + Ud(e && e.column);
}
function Hd(e) {
  return fc(e && e.start) + "-" + fc(e && e.end);
}
function Ud(e) {
  return e && typeof e == "number" ? e : 1;
}
const hc = {}.hasOwnProperty, Mw = function(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), xw(n)(
    ww(
      Ow(n).document().write(Nw()(e, t, !0))
    )
  );
};
function xw(e = {}) {
  const t = Tg(
    {
      transforms: [],
      canContainEols: [
        "emphasis",
        "fragment",
        "heading",
        "paragraph",
        "strong"
      ],
      enter: {
        autolink: u(qn),
        autolinkProtocol: X,
        autolinkEmail: X,
        atxHeading: u(kn),
        blockQuote: u(ce),
        characterEscape: X,
        characterReference: X,
        codeFenced: u(Dt),
        codeFencedFenceInfo: l,
        codeFencedFenceMeta: l,
        codeIndented: u(Dt, l),
        codeText: u(Se, l),
        codeTextData: X,
        data: X,
        codeFlowValue: X,
        definition: u(Gt),
        definitionDestinationString: l,
        definitionLabelString: l,
        definitionTitleString: l,
        emphasis: u(on),
        hardBreakEscape: u(Pn),
        hardBreakTrailing: u(Pn),
        htmlFlow: u(Wn, l),
        htmlFlowData: X,
        htmlText: u(Wn, l),
        htmlTextData: X,
        image: u(cr),
        label: l,
        link: u(qn),
        listItem: u(vr),
        listItemValue: m,
        listOrdered: u(sn, g),
        listUnordered: u(sn),
        paragraph: u(Ar),
        reference: le,
        referenceString: l,
        resourceDestinationString: l,
        resourceTitleString: l,
        setextHeading: u(kn),
        strong: u(hn),
        thematicBreak: u(Dn)
      },
      exit: {
        atxHeading: f(),
        atxHeadingSequence: G,
        autolink: f(),
        autolinkEmail: ze,
        autolinkProtocol: ye,
        blockQuote: f(),
        characterEscapeValue: H,
        characterReferenceMarkerHexadecimal: _e,
        characterReferenceMarkerNumeric: _e,
        characterReferenceValue: ge,
        codeFenced: f(O),
        codeFencedFence: y,
        codeFencedFenceInfo: v,
        codeFencedFenceMeta: b,
        codeFlowValue: H,
        codeIndented: f(B),
        codeText: f(ee),
        codeTextData: H,
        data: H,
        definition: f(),
        definitionDestinationString: I,
        definitionLabelString: S,
        definitionTitleString: C,
        emphasis: f(),
        hardBreakEscape: f(L),
        hardBreakTrailing: f(L),
        htmlFlow: f(Q),
        htmlFlowData: H,
        htmlText: f(j),
        htmlTextData: H,
        image: f(z),
        label: D,
        labelText: _,
        lineEnding: $,
        link: f(J),
        listItem: f(),
        listOrdered: f(),
        listUnordered: f(),
        paragraph: f(),
        referenceString: Ce,
        resourceDestinationString: he,
        resourceTitleString: oe,
        resource: ve,
        setextHeading: f(Y),
        setextHeadingLineSequence: w,
        setextHeadingText: V,
        strong: f(),
        thematicBreak: f()
      }
    },
    e.mdastExtensions || []
  ), n = {};
  return r;
  function r(Z) {
    let Ee = {
      type: "root",
      children: []
    };
    const ke = [Ee], je = [], qt = [], Bn = {
      stack: ke,
      tokenStack: je,
      config: t,
      enter: c,
      exit: E,
      buffer: l,
      resume: T,
      setData: i,
      getData: o
    };
    let at = -1;
    for (; ++at < Z.length; )
      if (Z[at][1].type === "listOrdered" || Z[at][1].type === "listUnordered")
        if (Z[at][0] === "enter")
          qt.push(at);
        else {
          const $t = qt.pop();
          at = a(Z, $t, at);
        }
    for (at = -1; ++at < Z.length; ) {
      const $t = t[Z[at][0]];
      hc.call($t, Z[at][1].type) && $t[Z[at][1].type].call(
        Object.assign(
          {
            sliceSerialize: Z[at][2].sliceSerialize
          },
          Bn
        ),
        Z[at][1]
      );
    }
    if (je.length > 0) {
      const $t = je[je.length - 1];
      ($t[1] || jd).call(Bn, void 0, $t[0]);
    }
    for (Ee.position = {
      start: s(
        Z.length > 0 ? Z[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: s(
        Z.length > 0 ? Z[Z.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, at = -1; ++at < t.transforms.length; )
      Ee = t.transforms[at](Ee) || Ee;
    return Ee;
  }
  function a(Z, Ee, ke) {
    let je = Ee - 1, qt = -1, Bn = !1, at, $t, Fn, Ln;
    for (; ++je <= ke; ) {
      const Ct = Z[je];
      if (Ct[1].type === "listUnordered" || Ct[1].type === "listOrdered" || Ct[1].type === "blockQuote" ? (Ct[0] === "enter" ? qt++ : qt--, Ln = void 0) : Ct[1].type === "lineEndingBlank" ? Ct[0] === "enter" && (at && !Ln && !qt && !Fn && (Fn = je), Ln = void 0) : Ct[1].type === "linePrefix" || Ct[1].type === "listItemValue" || Ct[1].type === "listItemMarker" || Ct[1].type === "listItemPrefix" || Ct[1].type === "listItemPrefixWhitespace" || (Ln = void 0), !qt && Ct[0] === "enter" && Ct[1].type === "listItemPrefix" || qt === -1 && Ct[0] === "exit" && (Ct[1].type === "listUnordered" || Ct[1].type === "listOrdered")) {
        if (at) {
          let Xn = je;
          for ($t = void 0; Xn--; ) {
            const un = Z[Xn];
            if (un[1].type === "lineEnding" || un[1].type === "lineEndingBlank") {
              if (un[0] === "exit")
                continue;
              $t && (Z[$t][1].type = "lineEndingBlank", Bn = !0), un[1].type = "lineEnding", $t = Xn;
            } else if (!(un[1].type === "linePrefix" || un[1].type === "blockQuotePrefix" || un[1].type === "blockQuotePrefixWhitespace" || un[1].type === "blockQuoteMarker" || un[1].type === "listItemIndent"))
              break;
          }
          Fn && (!$t || Fn < $t) && (at._spread = !0), at.end = Object.assign(
            {},
            $t ? Z[$t][1].start : Ct[1].end
          ), Z.splice($t || je, 0, ["exit", at, Ct[2]]), je++, ke++;
        }
        Ct[1].type === "listItemPrefix" && (at = {
          type: "listItem",
          _spread: !1,
          start: Object.assign({}, Ct[1].start)
        }, Z.splice(je, 0, ["enter", at, Ct[2]]), je++, ke++, Fn = void 0, Ln = !0);
      }
    }
    return Z[Ee][1]._spread = Bn, ke;
  }
  function i(Z, Ee) {
    n[Z] = Ee;
  }
  function o(Z) {
    return n[Z];
  }
  function s(Z) {
    return {
      line: Z.line,
      column: Z.column,
      offset: Z.offset
    };
  }
  function u(Z, Ee) {
    return ke;
    function ke(je) {
      c.call(this, Z(je), je), Ee && Ee.call(this, je);
    }
  }
  function l() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function c(Z, Ee, ke) {
    return this.stack[this.stack.length - 1].children.push(Z), this.stack.push(Z), this.tokenStack.push([Ee, ke]), Z.position = {
      start: s(Ee.start)
    }, Z;
  }
  function f(Z) {
    return Ee;
    function Ee(ke) {
      Z && Z.call(this, ke), E.call(this, ke);
    }
  }
  function E(Z, Ee) {
    const ke = this.stack.pop(), je = this.tokenStack.pop();
    if (je)
      je[0].type !== Z.type && (Ee ? Ee.call(this, Z, je[0]) : (je[1] || jd).call(this, Z, je[0]));
    else
      throw new Error(
        "Cannot close `" + Z.type + "` (" + io({
          start: Z.start,
          end: Z.end
        }) + "): it\u2019s not open"
      );
    return ke.position.end = s(Z.end), ke;
  }
  function T() {
    return HO(this.stack.pop());
  }
  function g() {
    i("expectingFirstListItemValue", !0);
  }
  function m(Z) {
    if (o("expectingFirstListItemValue")) {
      const Ee = this.stack[this.stack.length - 2];
      Ee.start = Number.parseInt(this.sliceSerialize(Z), 10), i("expectingFirstListItemValue");
    }
  }
  function v() {
    const Z = this.resume(), Ee = this.stack[this.stack.length - 1];
    Ee.lang = Z;
  }
  function b() {
    const Z = this.resume(), Ee = this.stack[this.stack.length - 1];
    Ee.meta = Z;
  }
  function y() {
    o("flowCodeInside") || (this.buffer(), i("flowCodeInside", !0));
  }
  function O() {
    const Z = this.resume(), Ee = this.stack[this.stack.length - 1];
    Ee.value = Z.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), i("flowCodeInside");
  }
  function B() {
    const Z = this.resume(), Ee = this.stack[this.stack.length - 1];
    Ee.value = Z.replace(/(\r?\n|\r)$/g, "");
  }
  function S(Z) {
    const Ee = this.resume(), ke = this.stack[this.stack.length - 1];
    ke.label = Ee, ke.identifier = or(
      this.sliceSerialize(Z)
    ).toLowerCase();
  }
  function C() {
    const Z = this.resume(), Ee = this.stack[this.stack.length - 1];
    Ee.title = Z;
  }
  function I() {
    const Z = this.resume(), Ee = this.stack[this.stack.length - 1];
    Ee.url = Z;
  }
  function G(Z) {
    const Ee = this.stack[this.stack.length - 1];
    if (!Ee.depth) {
      const ke = this.sliceSerialize(Z).length;
      Ee.depth = ke;
    }
  }
  function V() {
    i("setextHeadingSlurpLineEnding", !0);
  }
  function w(Z) {
    const Ee = this.stack[this.stack.length - 1];
    Ee.depth = this.sliceSerialize(Z).charCodeAt(0) === 61 ? 1 : 2;
  }
  function Y() {
    i("setextHeadingSlurpLineEnding");
  }
  function X(Z) {
    const Ee = this.stack[this.stack.length - 1];
    let ke = Ee.children[Ee.children.length - 1];
    (!ke || ke.type !== "text") && (ke = Tn(), ke.position = {
      start: s(Z.start)
    }, Ee.children.push(ke)), this.stack.push(ke);
  }
  function H(Z) {
    const Ee = this.stack.pop();
    Ee.value += this.sliceSerialize(Z), Ee.position.end = s(Z.end);
  }
  function $(Z) {
    const Ee = this.stack[this.stack.length - 1];
    if (o("atHardBreak")) {
      const ke = Ee.children[Ee.children.length - 1];
      ke.position.end = s(Z.end), i("atHardBreak");
      return;
    }
    !o("setextHeadingSlurpLineEnding") && t.canContainEols.includes(Ee.type) && (X.call(this, Z), H.call(this, Z));
  }
  function L() {
    i("atHardBreak", !0);
  }
  function Q() {
    const Z = this.resume(), Ee = this.stack[this.stack.length - 1];
    Ee.value = Z;
  }
  function j() {
    const Z = this.resume(), Ee = this.stack[this.stack.length - 1];
    Ee.value = Z;
  }
  function ee() {
    const Z = this.resume(), Ee = this.stack[this.stack.length - 1];
    Ee.value = Z;
  }
  function J() {
    const Z = this.stack[this.stack.length - 1];
    o("inReference") ? (Z.type += "Reference", Z.referenceType = o("referenceType") || "shortcut", delete Z.url, delete Z.title) : (delete Z.identifier, delete Z.label), i("referenceType");
  }
  function z() {
    const Z = this.stack[this.stack.length - 1];
    o("inReference") ? (Z.type += "Reference", Z.referenceType = o("referenceType") || "shortcut", delete Z.url, delete Z.title) : (delete Z.identifier, delete Z.label), i("referenceType");
  }
  function _(Z) {
    const Ee = this.stack[this.stack.length - 2], ke = this.sliceSerialize(Z);
    Ee.label = Eg(ke), Ee.identifier = or(ke).toLowerCase();
  }
  function D() {
    const Z = this.stack[this.stack.length - 1], Ee = this.resume(), ke = this.stack[this.stack.length - 1];
    i("inReference", !0), ke.type === "link" ? ke.children = Z.children : ke.alt = Ee;
  }
  function he() {
    const Z = this.resume(), Ee = this.stack[this.stack.length - 1];
    Ee.url = Z;
  }
  function oe() {
    const Z = this.resume(), Ee = this.stack[this.stack.length - 1];
    Ee.title = Z;
  }
  function ve() {
    i("inReference");
  }
  function le() {
    i("referenceType", "collapsed");
  }
  function Ce(Z) {
    const Ee = this.resume(), ke = this.stack[this.stack.length - 1];
    ke.label = Ee, ke.identifier = or(
      this.sliceSerialize(Z)
    ).toLowerCase(), i("referenceType", "full");
  }
  function _e(Z) {
    i("characterReferenceType", Z.type);
  }
  function ge(Z) {
    const Ee = this.sliceSerialize(Z), ke = o("characterReferenceType");
    let je;
    ke ? (je = gg(
      Ee,
      ke === "characterReferenceMarkerNumeric" ? 10 : 16
    ), i("characterReferenceType")) : je = Jc(Ee);
    const qt = this.stack.pop();
    qt.value += je, qt.position.end = s(Z.end);
  }
  function ye(Z) {
    H.call(this, Z);
    const Ee = this.stack[this.stack.length - 1];
    Ee.url = this.sliceSerialize(Z);
  }
  function ze(Z) {
    H.call(this, Z);
    const Ee = this.stack[this.stack.length - 1];
    Ee.url = "mailto:" + this.sliceSerialize(Z);
  }
  function ce() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Dt() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Se() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Gt() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function on() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function kn() {
    return {
      type: "heading",
      depth: void 0,
      children: []
    };
  }
  function Pn() {
    return {
      type: "break"
    };
  }
  function Wn() {
    return {
      type: "html",
      value: ""
    };
  }
  function cr() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function qn() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function sn(Z) {
    return {
      type: "list",
      ordered: Z.type === "listOrdered",
      start: null,
      spread: Z._spread,
      children: []
    };
  }
  function vr(Z) {
    return {
      type: "listItem",
      spread: Z._spread,
      checked: null,
      children: []
    };
  }
  function Ar() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function hn() {
    return {
      type: "strong",
      children: []
    };
  }
  function Tn() {
    return {
      type: "text",
      value: ""
    };
  }
  function Dn() {
    return {
      type: "thematicBreak"
    };
  }
}
function Tg(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? Tg(e, r) : kw(e, r);
  }
  return e;
}
function kw(e, t) {
  let n;
  for (n in t)
    if (hc.call(t, n)) {
      const r = n === "canContainEols" || n === "transforms", i = (hc.call(e, n) ? e[n] : void 0) || (e[n] = r ? [] : {}), o = t[n];
      o && (r ? e[n] = [...i, ...o] : Object.assign(i, o));
    }
}
function jd(e, t) {
  throw e ? new Error(
    "Cannot close `" + e.type + "` (" + io({
      start: e.start,
      end: e.end
    }) + "): a different token (`" + t.type + "`, " + io({
      start: t.start,
      end: t.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + t.type + "`, " + io({
      start: t.start,
      end: t.end
    }) + ") is still open"
  );
}
function Pw(e) {
  Object.assign(this, { Parser: (n) => {
    const r = this.data("settings");
    return Mw(
      n,
      Object.assign({}, r, e, {
        extensions: this.data("micromarkExtensions") || [],
        mdastExtensions: this.data("fromMarkdownExtensions") || []
      })
    );
  } });
}
function Bw(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Fw(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function Lw(e, t) {
  const n = t.value ? t.value + `
` : "", r = t.lang ? t.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null, a = {};
  r && (a.className = ["language-" + r]);
  let i = {
    type: "element",
    tagName: "code",
    properties: a,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function $w(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Hw(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function pi(e) {
  const t = [];
  let n = -1, r = 0, a = 0;
  for (; ++n < e.length; ) {
    const i = e.charCodeAt(n);
    let o = "";
    if (i === 37 && fn(e.charCodeAt(n + 1)) && fn(e.charCodeAt(n + 2)))
      a = 2;
    else if (i < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(i)) || (o = String.fromCharCode(i));
    else if (i > 55295 && i < 57344) {
      const s = e.charCodeAt(n + 1);
      i < 56320 && s > 56319 && s < 57344 ? (o = String.fromCharCode(i, s), a = 1) : o = "\uFFFD";
    } else
      o = String.fromCharCode(i);
    o && (t.push(e.slice(r, n), encodeURIComponent(o)), r = n + a + 1, o = ""), a && (n += a, a = 0);
  }
  return t.join("") + e.slice(r);
}
function vg(e, t) {
  const n = String(t.identifier).toUpperCase(), r = pi(n.toLowerCase()), a = e.footnoteOrder.indexOf(n);
  let i;
  a === -1 ? (e.footnoteOrder.push(n), e.footnoteCounts[n] = 1, i = e.footnoteOrder.length) : (e.footnoteCounts[n]++, i = a + 1);
  const o = e.footnoteCounts[n], s = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + e.clobberPrefix + "fn-" + r,
      id: e.clobberPrefix + "fnref-" + r + (o > 1 ? "-" + o : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(i) }]
  };
  e.patch(t, s);
  const u = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [s]
  };
  return e.patch(t, u), e.applyData(t, u);
}
function Uw(e, t) {
  const n = e.footnoteById;
  let r = 1;
  for (; r in n; )
    r++;
  const a = String(r);
  return n[a] = {
    type: "footnoteDefinition",
    identifier: a,
    children: [{ type: "paragraph", children: t.children }],
    position: t.position
  }, vg(e, {
    type: "footnoteReference",
    identifier: a,
    position: t.position
  });
}
function jw(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function zw(e, t) {
  if (e.dangerous) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
  return null;
}
function Ag(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return { type: "text", value: "![" + t.alt + r };
  const a = e.all(t), i = a[0];
  i && i.type === "text" ? i.value = "[" + i.value : a.unshift({ type: "text", value: "[" });
  const o = a[a.length - 1];
  return o && o.type === "text" ? o.value += r : a.push({ type: "text", value: r }), a;
}
function Gw(e, t) {
  const n = e.definition(t.identifier);
  if (!n)
    return Ag(e, t);
  const r = { src: pi(n.url || ""), alt: t.alt };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const a = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(t, a), e.applyData(t, a);
}
function Vw(e, t) {
  const n = { src: pi(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function Yw(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function Kw(e, t) {
  const n = e.definition(t.identifier);
  if (!n)
    return Ag(e, t);
  const r = { href: pi(n.url || "") };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const a = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(t)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function Ww(e, t) {
  const n = { href: pi(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function qw(e, t, n) {
  const r = e.all(t), a = n ? Xw(n) : Cg(t), i = {}, o = [];
  if (typeof t.checked == "boolean") {
    const c = r[0];
    let f;
    c && c.type === "element" && c.tagName === "p" ? f = c : (f = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), i.className = ["task-list-item"];
  }
  let s = -1;
  for (; ++s < r.length; ) {
    const c = r[s];
    (a || s !== 0 || c.type !== "element" || c.tagName !== "p") && o.push({ type: "text", value: `
` }), c.type === "element" && c.tagName === "p" && !a ? o.push(...c.children) : o.push(c);
  }
  const u = r[r.length - 1];
  u && (a || u.type !== "element" || u.tagName !== "p") && o.push({ type: "text", value: `
` });
  const l = { type: "element", tagName: "li", properties: i, children: o };
  return e.patch(t, l), e.applyData(t, l);
}
function Xw(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = Cg(n[r]);
  }
  return t;
}
function Cg(e) {
  const t = e.spread;
  return t == null ? e.children.length > 1 : t;
}
function Qw(e, t) {
  const n = {}, r = e.all(t);
  let a = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++a < r.length; ) {
    const o = r[a];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const i = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function Zw(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Jw(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function eI(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const tf = _g("start"), nf = _g("end");
function tI(e) {
  return { start: tf(e), end: nf(e) };
}
function _g(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    return {
      line: r.line || null,
      column: r.column || null,
      offset: r.offset > -1 ? r.offset : null
    };
  }
}
function nI(e, t) {
  const n = e.all(t), r = n.shift(), a = [];
  if (r) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], o), a.push(o);
  }
  if (n.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, s = tf(t.children[1]), u = nf(t.children[t.children.length - 1]);
    s.line && u.line && (o.position = { start: s, end: u }), a.push(o);
  }
  const i = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function rI(e, t, n) {
  const r = n ? n.children : void 0, i = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", o = n && n.type === "table" ? n.align : void 0, s = o ? o.length : t.children.length;
  let u = -1;
  const l = [];
  for (; ++u < s; ) {
    const f = t.children[u], E = {}, T = o ? o[u] : void 0;
    T && (E.align = T);
    let g = { type: "element", tagName: i, properties: E, children: [] };
    f && (g.children = e.all(f), e.patch(f, g), g = e.applyData(t, g)), l.push(g);
  }
  const c = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(l, !0)
  };
  return e.patch(t, c), e.applyData(t, c);
}
function aI(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const zd = 9, Gd = 32;
function iI(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), a = 0;
  const i = [];
  for (; r; )
    i.push(
      Vd(t.slice(a, r.index), a > 0, !0),
      r[0]
    ), a = r.index + r[0].length, r = n.exec(t);
  return i.push(Vd(t.slice(a), a > 0, !1)), i.join("");
}
function Vd(e, t, n) {
  let r = 0, a = e.length;
  if (t) {
    let i = e.codePointAt(r);
    for (; i === zd || i === Gd; )
      r++, i = e.codePointAt(r);
  }
  if (n) {
    let i = e.codePointAt(a - 1);
    for (; i === zd || i === Gd; )
      a--, i = e.codePointAt(a - 1);
  }
  return a > r ? e.slice(r, a) : "";
}
function oI(e, t) {
  const n = { type: "text", value: iI(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function sI(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const uI = {
  blockquote: Bw,
  break: Fw,
  code: Lw,
  delete: $w,
  emphasis: Hw,
  footnoteReference: vg,
  footnote: Uw,
  heading: jw,
  html: zw,
  imageReference: Gw,
  image: Vw,
  inlineCode: Yw,
  linkReference: Kw,
  link: Ww,
  listItem: qw,
  list: Qw,
  paragraph: Zw,
  root: Jw,
  strong: eI,
  table: nI,
  tableCell: aI,
  tableRow: rI,
  text: oI,
  thematicBreak: sI,
  toml: F1,
  yaml: F1,
  definition: F1,
  footnoteDefinition: F1
};
function F1() {
  return null;
}
const bg = function(e) {
  if (e == null)
    return hI;
  if (typeof e == "string")
    return fI(e);
  if (typeof e == "object")
    return Array.isArray(e) ? lI(e) : cI(e);
  if (typeof e == "function")
    return Zo(e);
  throw new Error("Expected function, string, or object as test");
};
function lI(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = bg(e[n]);
  return Zo(r);
  function r(...a) {
    let i = -1;
    for (; ++i < t.length; )
      if (t[i].call(this, ...a))
        return !0;
    return !1;
  }
}
function cI(e) {
  return Zo(t);
  function t(n) {
    let r;
    for (r in e)
      if (n[r] !== e[r])
        return !1;
    return !0;
  }
}
function fI(e) {
  return Zo(t);
  function t(n) {
    return n && n.type === e;
  }
}
function Zo(e) {
  return t;
  function t(...n) {
    return Boolean(e.call(this, ...n));
  }
}
function hI() {
  return !0;
}
const dI = !0, mI = "skip", Yd = !1, Jo = function(e, t, n, r) {
  typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null);
  const a = bg(t), i = r ? -1 : 1;
  o(e, null, [])();
  function o(s, u, l) {
    const c = typeof s == "object" && s !== null ? s : {};
    let f;
    return typeof c.type == "string" && (f = typeof c.tagName == "string" ? c.tagName : typeof c.name == "string" ? c.name : void 0, Object.defineProperty(E, "name", {
      value: "node (" + (c.type + (f ? "<" + f + ">" : "")) + ")"
    })), E;
    function E() {
      let T = [], g, m, v;
      if ((!t || a(s, u, l[l.length - 1] || null)) && (T = pI(n(s, l)), T[0] === Yd))
        return T;
      if (s.children && T[0] !== mI)
        for (m = (r ? s.children.length : -1) + i, v = l.concat(s); m > -1 && m < s.children.length; ) {
          if (g = o(s.children[m], m, v)(), g[0] === Yd)
            return g;
          m = typeof g[1] == "number" ? g[1] : m + i;
        }
      return T;
    }
  }
};
function pI(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [dI, e] : [e];
}
const yg = function(e, t, n, r) {
  typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), Jo(e, t, a, r);
  function a(i, o) {
    const s = o[o.length - 1];
    return n(
      i,
      s ? s.children.indexOf(i) : null,
      s
    );
  }
};
function gI(e) {
  return !e || !e.position || !e.position.start || !e.position.start.line || !e.position.start.column || !e.position.end || !e.position.end.line || !e.position.end.column;
}
const Kd = {}.hasOwnProperty;
function EI(e) {
  const t = /* @__PURE__ */ Object.create(null);
  if (!e || !e.type)
    throw new Error("mdast-util-definitions expected node");
  return yg(e, "definition", (r) => {
    const a = Wd(r.identifier);
    a && !Kd.call(t, a) && (t[a] = r);
  }), n;
  function n(r) {
    const a = Wd(r);
    return a && Kd.call(t, a) ? t[a] : null;
  }
}
function Wd(e) {
  return String(e || "").toUpperCase();
}
const Oo = {}.hasOwnProperty;
function TI(e, t) {
  const n = t || {}, r = n.allowDangerousHtml || !1, a = {};
  return o.dangerous = r, o.clobberPrefix = n.clobberPrefix === void 0 || n.clobberPrefix === null ? "user-content-" : n.clobberPrefix, o.footnoteLabel = n.footnoteLabel || "Footnotes", o.footnoteLabelTagName = n.footnoteLabelTagName || "h2", o.footnoteLabelProperties = n.footnoteLabelProperties || {
    className: ["sr-only"]
  }, o.footnoteBackLabel = n.footnoteBackLabel || "Back to content", o.unknownHandler = n.unknownHandler, o.passThrough = n.passThrough, o.handlers = { ...uI, ...n.handlers }, o.definition = EI(e), o.footnoteById = a, o.footnoteOrder = [], o.footnoteCounts = {}, o.patch = vI, o.applyData = AI, o.one = s, o.all = u, o.wrap = _I, o.augment = i, yg(e, "footnoteDefinition", (l) => {
    const c = String(l.identifier).toUpperCase();
    Oo.call(a, c) || (a[c] = l);
  }), o;
  function i(l, c) {
    if (l && "data" in l && l.data) {
      const f = l.data;
      f.hName && (c.type !== "element" && (c = {
        type: "element",
        tagName: "",
        properties: {},
        children: []
      }), c.tagName = f.hName), c.type === "element" && f.hProperties && (c.properties = { ...c.properties, ...f.hProperties }), "children" in c && c.children && f.hChildren && (c.children = f.hChildren);
    }
    if (l) {
      const f = "type" in l ? l : { position: l };
      gI(f) || (c.position = { start: tf(f), end: nf(f) });
    }
    return c;
  }
  function o(l, c, f, E) {
    return Array.isArray(f) && (E = f, f = {}), i(l, {
      type: "element",
      tagName: c,
      properties: f || {},
      children: E || []
    });
  }
  function s(l, c) {
    return Dg(o, l, c);
  }
  function u(l) {
    return rf(o, l);
  }
}
function vI(e, t) {
  e.position && (t.position = tI(e));
}
function AI(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, a = e.data.hChildren, i = e.data.hProperties;
    typeof r == "string" && (n.type === "element" ? n.tagName = r : n = {
      type: "element",
      tagName: r,
      properties: {},
      children: []
    }), n.type === "element" && i && (n.properties = { ...n.properties, ...i }), "children" in n && n.children && a !== null && a !== void 0 && (n.children = a);
  }
  return n;
}
function Dg(e, t, n) {
  const r = t && t.type;
  if (!r)
    throw new Error("Expected node, got `" + t + "`");
  return Oo.call(e.handlers, r) ? e.handlers[r](e, t, n) : e.passThrough && e.passThrough.includes(r) ? "children" in t ? { ...t, children: rf(e, t) } : t : e.unknownHandler ? e.unknownHandler(e, t, n) : CI(e, t);
}
function rf(e, t) {
  const n = [];
  if ("children" in t) {
    const r = t.children;
    let a = -1;
    for (; ++a < r.length; ) {
      const i = Dg(e, r[a], t);
      if (i) {
        if (a && r[a - 1].type === "break" && (!Array.isArray(i) && i.type === "text" && (i.value = i.value.replace(/^\s+/, "")), !Array.isArray(i) && i.type === "element")) {
          const o = i.children[0];
          o && o.type === "text" && (o.value = o.value.replace(/^\s+/, ""));
        }
        Array.isArray(i) ? n.push(...i) : n.push(i);
      }
    }
  }
  return n;
}
function CI(e, t) {
  const n = t.data || {}, r = "value" in t && !(Oo.call(n, "hProperties") || Oo.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: rf(e, t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function _I(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function bI(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.footnoteOrder.length; ) {
    const r = e.footnoteById[e.footnoteOrder[n]];
    if (!r)
      continue;
    const a = e.all(r), i = String(r.identifier).toUpperCase(), o = pi(i.toLowerCase());
    let s = 0;
    const u = [];
    for (; ++s <= e.footnoteCounts[i]; ) {
      const f = {
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + e.clobberPrefix + "fnref-" + o + (s > 1 ? "-" + s : ""),
          dataFootnoteBackref: !0,
          className: ["data-footnote-backref"],
          ariaLabel: e.footnoteBackLabel
        },
        children: [{ type: "text", value: "\u21A9" }]
      };
      s > 1 && f.children.push({
        type: "element",
        tagName: "sup",
        children: [{ type: "text", value: String(s) }]
      }), u.length > 0 && u.push({ type: "text", value: " " }), u.push(f);
    }
    const l = a[a.length - 1];
    if (l && l.type === "element" && l.tagName === "p") {
      const f = l.children[l.children.length - 1];
      f && f.type === "text" ? f.value += " " : l.children.push({ type: "text", value: " " }), l.children.push(...u);
    } else
      a.push(...u);
    const c = {
      type: "element",
      tagName: "li",
      properties: { id: e.clobberPrefix + "fn-" + o },
      children: e.wrap(a, !0)
    };
    e.patch(r, c), t.push(c);
  }
  if (t.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: e.footnoteLabelTagName,
          properties: {
            ...JSON.parse(JSON.stringify(e.footnoteLabelProperties)),
            id: "footnote-label"
          },
          children: [{ type: "text", value: e.footnoteLabel }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(t, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
function Sg(e, t) {
  const n = TI(e, t), r = n.one(e, null), a = bI(n);
  return a && r.children.push({ type: "text", value: `
` }, a), Array.isArray(r) ? { type: "root", children: r } : r;
}
const yI = function(e, t) {
  return e && "run" in e ? SI(e, t) : OI(e || t);
}, DI = yI;
function SI(e, t) {
  return (n, r, a) => {
    e.run(Sg(n, t), r, (i) => {
      a(i);
    });
  };
}
function OI(e) {
  return (t) => Sg(t, e);
}
var $e = { exports: {} }, cu = { exports: {} }, mt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qd;
function NI() {
  if (qd)
    return mt;
  qd = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function O(S) {
    if (typeof S == "object" && S !== null) {
      var C = S.$$typeof;
      switch (C) {
        case t:
          switch (S = S.type, S) {
            case u:
            case l:
            case r:
            case i:
            case a:
            case f:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case s:
                case c:
                case g:
                case T:
                case o:
                  return S;
                default:
                  return C;
              }
          }
        case n:
          return C;
      }
    }
  }
  function B(S) {
    return O(S) === l;
  }
  return mt.AsyncMode = u, mt.ConcurrentMode = l, mt.ContextConsumer = s, mt.ContextProvider = o, mt.Element = t, mt.ForwardRef = c, mt.Fragment = r, mt.Lazy = g, mt.Memo = T, mt.Portal = n, mt.Profiler = i, mt.StrictMode = a, mt.Suspense = f, mt.isAsyncMode = function(S) {
    return B(S) || O(S) === u;
  }, mt.isConcurrentMode = B, mt.isContextConsumer = function(S) {
    return O(S) === s;
  }, mt.isContextProvider = function(S) {
    return O(S) === o;
  }, mt.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === t;
  }, mt.isForwardRef = function(S) {
    return O(S) === c;
  }, mt.isFragment = function(S) {
    return O(S) === r;
  }, mt.isLazy = function(S) {
    return O(S) === g;
  }, mt.isMemo = function(S) {
    return O(S) === T;
  }, mt.isPortal = function(S) {
    return O(S) === n;
  }, mt.isProfiler = function(S) {
    return O(S) === i;
  }, mt.isStrictMode = function(S) {
    return O(S) === a;
  }, mt.isSuspense = function(S) {
    return O(S) === f;
  }, mt.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === r || S === l || S === i || S === a || S === f || S === E || typeof S == "object" && S !== null && (S.$$typeof === g || S.$$typeof === T || S.$$typeof === o || S.$$typeof === s || S.$$typeof === c || S.$$typeof === v || S.$$typeof === b || S.$$typeof === y || S.$$typeof === m);
  }, mt.typeOf = O, mt;
}
var pt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xd;
function wI() {
  return Xd || (Xd = 1, {}.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function O(ce) {
      return typeof ce == "string" || typeof ce == "function" || ce === r || ce === l || ce === i || ce === a || ce === f || ce === E || typeof ce == "object" && ce !== null && (ce.$$typeof === g || ce.$$typeof === T || ce.$$typeof === o || ce.$$typeof === s || ce.$$typeof === c || ce.$$typeof === v || ce.$$typeof === b || ce.$$typeof === y || ce.$$typeof === m);
    }
    function B(ce) {
      if (typeof ce == "object" && ce !== null) {
        var Dt = ce.$$typeof;
        switch (Dt) {
          case t:
            var Se = ce.type;
            switch (Se) {
              case u:
              case l:
              case r:
              case i:
              case a:
              case f:
                return Se;
              default:
                var Gt = Se && Se.$$typeof;
                switch (Gt) {
                  case s:
                  case c:
                  case g:
                  case T:
                  case o:
                    return Gt;
                  default:
                    return Dt;
                }
            }
          case n:
            return Dt;
        }
      }
    }
    var S = u, C = l, I = s, G = o, V = t, w = c, Y = r, X = g, H = T, $ = n, L = i, Q = a, j = f, ee = !1;
    function J(ce) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), z(ce) || B(ce) === u;
    }
    function z(ce) {
      return B(ce) === l;
    }
    function _(ce) {
      return B(ce) === s;
    }
    function D(ce) {
      return B(ce) === o;
    }
    function he(ce) {
      return typeof ce == "object" && ce !== null && ce.$$typeof === t;
    }
    function oe(ce) {
      return B(ce) === c;
    }
    function ve(ce) {
      return B(ce) === r;
    }
    function le(ce) {
      return B(ce) === g;
    }
    function Ce(ce) {
      return B(ce) === T;
    }
    function _e(ce) {
      return B(ce) === n;
    }
    function ge(ce) {
      return B(ce) === i;
    }
    function ye(ce) {
      return B(ce) === a;
    }
    function ze(ce) {
      return B(ce) === f;
    }
    pt.AsyncMode = S, pt.ConcurrentMode = C, pt.ContextConsumer = I, pt.ContextProvider = G, pt.Element = V, pt.ForwardRef = w, pt.Fragment = Y, pt.Lazy = X, pt.Memo = H, pt.Portal = $, pt.Profiler = L, pt.StrictMode = Q, pt.Suspense = j, pt.isAsyncMode = J, pt.isConcurrentMode = z, pt.isContextConsumer = _, pt.isContextProvider = D, pt.isElement = he, pt.isForwardRef = oe, pt.isFragment = ve, pt.isLazy = le, pt.isMemo = Ce, pt.isPortal = _e, pt.isProfiler = ge, pt.isStrictMode = ye, pt.isSuspense = ze, pt.isValidElementType = O, pt.typeOf = B;
  }()), pt;
}
var Qd;
function Og() {
  return Qd || (Qd = 1, function(e) {
    ({}).NODE_ENV === "production" ? e.exports = NI() : e.exports = wI();
  }(cu)), cu.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var fu, Zd;
function II() {
  if (Zd)
    return fu;
  Zd = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var u = Object.getOwnPropertyNames(o).map(function(c) {
        return o[c];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        l[c] = c;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return fu = a() ? Object.assign : function(i, o) {
    for (var s, u = r(i), l, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var f in s)
        t.call(s, f) && (u[f] = s[f]);
      if (e) {
        l = e(s);
        for (var E = 0; E < l.length; E++)
          n.call(s, l[E]) && (u[l[E]] = s[l[E]]);
      }
    }
    return u;
  }, fu;
}
var hu, Jd;
function af() {
  if (Jd)
    return hu;
  Jd = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return hu = e, hu;
}
var du, em;
function Ng() {
  return em || (em = 1, du = Function.call.bind(Object.prototype.hasOwnProperty)), du;
}
var mu, tm;
function RI() {
  if (tm)
    return mu;
  tm = 1;
  var e = function() {
  };
  if ({}.NODE_ENV !== "production") {
    var t = af(), n = {}, r = Ng();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, s, u, l) {
    if ({}.NODE_ENV !== "production") {
      for (var c in i)
        if (r(i, c)) {
          var f;
          try {
            if (typeof i[c] != "function") {
              var E = Error(
                (u || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw E.name = "Invariant Violation", E;
            }
            f = i[c](o, c, u, s, null, t);
          } catch (g) {
            f = g;
          }
          if (f && !(f instanceof Error) && e(
            (u || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var T = l ? l() : "";
            e(
              "Failed " + s + " type: " + f.message + (T != null ? T : "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    ({}).NODE_ENV !== "production" && (n = {});
  }, mu = a, mu;
}
var pu, nm;
function MI() {
  if (nm)
    return pu;
  nm = 1;
  var e = Og(), t = II(), n = af(), r = Ng(), a = RI(), i = function() {
  };
  ({}).NODE_ENV !== "production" && (i = function(s) {
    var u = "Warning: " + s;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return pu = function(s, u) {
    var l = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function f(z) {
      var _ = z && (l && z[l] || z[c]);
      if (typeof _ == "function")
        return _;
    }
    var E = "<<anonymous>>", T = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: y(),
      arrayOf: O,
      element: B(),
      elementType: S(),
      instanceOf: C,
      node: w(),
      objectOf: G,
      oneOf: I,
      oneOfType: V,
      shape: X,
      exact: H
    };
    function g(z, _) {
      return z === _ ? z !== 0 || 1 / z === 1 / _ : z !== z && _ !== _;
    }
    function m(z, _) {
      this.message = z, this.data = _ && typeof _ == "object" ? _ : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function v(z) {
      if ({}.NODE_ENV !== "production")
        var _ = {}, D = 0;
      function he(ve, le, Ce, _e, ge, ye, ze) {
        if (_e = _e || E, ye = ye || Ce, ze !== n) {
          if (u) {
            var ce = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ce.name = "Invariant Violation", ce;
          } else if ({}.NODE_ENV !== "production" && typeof console < "u") {
            var Dt = _e + ":" + Ce;
            !_[Dt] && D < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + ye + "` prop on `" + _e + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), _[Dt] = !0, D++);
          }
        }
        return le[Ce] == null ? ve ? le[Ce] === null ? new m("The " + ge + " `" + ye + "` is marked as required " + ("in `" + _e + "`, but its value is `null`.")) : new m("The " + ge + " `" + ye + "` is marked as required in " + ("`" + _e + "`, but its value is `undefined`.")) : null : z(le, Ce, _e, ge, ye);
      }
      var oe = he.bind(null, !1);
      return oe.isRequired = he.bind(null, !0), oe;
    }
    function b(z) {
      function _(D, he, oe, ve, le, Ce) {
        var _e = D[he], ge = Q(_e);
        if (ge !== z) {
          var ye = j(_e);
          return new m(
            "Invalid " + ve + " `" + le + "` of type " + ("`" + ye + "` supplied to `" + oe + "`, expected ") + ("`" + z + "`."),
            { expectedType: z }
          );
        }
        return null;
      }
      return v(_);
    }
    function y() {
      return v(o);
    }
    function O(z) {
      function _(D, he, oe, ve, le) {
        if (typeof z != "function")
          return new m("Property `" + le + "` of component `" + oe + "` has invalid PropType notation inside arrayOf.");
        var Ce = D[he];
        if (!Array.isArray(Ce)) {
          var _e = Q(Ce);
          return new m("Invalid " + ve + " `" + le + "` of type " + ("`" + _e + "` supplied to `" + oe + "`, expected an array."));
        }
        for (var ge = 0; ge < Ce.length; ge++) {
          var ye = z(Ce, ge, oe, ve, le + "[" + ge + "]", n);
          if (ye instanceof Error)
            return ye;
        }
        return null;
      }
      return v(_);
    }
    function B() {
      function z(_, D, he, oe, ve) {
        var le = _[D];
        if (!s(le)) {
          var Ce = Q(le);
          return new m("Invalid " + oe + " `" + ve + "` of type " + ("`" + Ce + "` supplied to `" + he + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(z);
    }
    function S() {
      function z(_, D, he, oe, ve) {
        var le = _[D];
        if (!e.isValidElementType(le)) {
          var Ce = Q(le);
          return new m("Invalid " + oe + " `" + ve + "` of type " + ("`" + Ce + "` supplied to `" + he + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(z);
    }
    function C(z) {
      function _(D, he, oe, ve, le) {
        if (!(D[he] instanceof z)) {
          var Ce = z.name || E, _e = J(D[he]);
          return new m("Invalid " + ve + " `" + le + "` of type " + ("`" + _e + "` supplied to `" + oe + "`, expected ") + ("instance of `" + Ce + "`."));
        }
        return null;
      }
      return v(_);
    }
    function I(z) {
      if (!Array.isArray(z))
        return {}.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function _(D, he, oe, ve, le) {
        for (var Ce = D[he], _e = 0; _e < z.length; _e++)
          if (g(Ce, z[_e]))
            return null;
        var ge = JSON.stringify(z, function(ze, ce) {
          var Dt = j(ce);
          return Dt === "symbol" ? String(ce) : ce;
        });
        return new m("Invalid " + ve + " `" + le + "` of value `" + String(Ce) + "` " + ("supplied to `" + oe + "`, expected one of " + ge + "."));
      }
      return v(_);
    }
    function G(z) {
      function _(D, he, oe, ve, le) {
        if (typeof z != "function")
          return new m("Property `" + le + "` of component `" + oe + "` has invalid PropType notation inside objectOf.");
        var Ce = D[he], _e = Q(Ce);
        if (_e !== "object")
          return new m("Invalid " + ve + " `" + le + "` of type " + ("`" + _e + "` supplied to `" + oe + "`, expected an object."));
        for (var ge in Ce)
          if (r(Ce, ge)) {
            var ye = z(Ce, ge, oe, ve, le + "." + ge, n);
            if (ye instanceof Error)
              return ye;
          }
        return null;
      }
      return v(_);
    }
    function V(z) {
      if (!Array.isArray(z))
        return {}.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var _ = 0; _ < z.length; _++) {
        var D = z[_];
        if (typeof D != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ee(D) + " at index " + _ + "."
          ), o;
      }
      function he(oe, ve, le, Ce, _e) {
        for (var ge = [], ye = 0; ye < z.length; ye++) {
          var ze = z[ye], ce = ze(oe, ve, le, Ce, _e, n);
          if (ce == null)
            return null;
          ce.data && r(ce.data, "expectedType") && ge.push(ce.data.expectedType);
        }
        var Dt = ge.length > 0 ? ", expected one of type [" + ge.join(", ") + "]" : "";
        return new m("Invalid " + Ce + " `" + _e + "` supplied to " + ("`" + le + "`" + Dt + "."));
      }
      return v(he);
    }
    function w() {
      function z(_, D, he, oe, ve) {
        return $(_[D]) ? null : new m("Invalid " + oe + " `" + ve + "` supplied to " + ("`" + he + "`, expected a ReactNode."));
      }
      return v(z);
    }
    function Y(z, _, D, he, oe) {
      return new m(
        (z || "React class") + ": " + _ + " type `" + D + "." + he + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + oe + "`."
      );
    }
    function X(z) {
      function _(D, he, oe, ve, le) {
        var Ce = D[he], _e = Q(Ce);
        if (_e !== "object")
          return new m("Invalid " + ve + " `" + le + "` of type `" + _e + "` " + ("supplied to `" + oe + "`, expected `object`."));
        for (var ge in z) {
          var ye = z[ge];
          if (typeof ye != "function")
            return Y(oe, ve, le, ge, j(ye));
          var ze = ye(Ce, ge, oe, ve, le + "." + ge, n);
          if (ze)
            return ze;
        }
        return null;
      }
      return v(_);
    }
    function H(z) {
      function _(D, he, oe, ve, le) {
        var Ce = D[he], _e = Q(Ce);
        if (_e !== "object")
          return new m("Invalid " + ve + " `" + le + "` of type `" + _e + "` " + ("supplied to `" + oe + "`, expected `object`."));
        var ge = t({}, D[he], z);
        for (var ye in ge) {
          var ze = z[ye];
          if (r(z, ye) && typeof ze != "function")
            return Y(oe, ve, le, ye, j(ze));
          if (!ze)
            return new m(
              "Invalid " + ve + " `" + le + "` key `" + ye + "` supplied to `" + oe + "`.\nBad object: " + JSON.stringify(D[he], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(z), null, "  ")
            );
          var ce = ze(Ce, ye, oe, ve, le + "." + ye, n);
          if (ce)
            return ce;
        }
        return null;
      }
      return v(_);
    }
    function $(z) {
      switch (typeof z) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !z;
        case "object":
          if (Array.isArray(z))
            return z.every($);
          if (z === null || s(z))
            return !0;
          var _ = f(z);
          if (_) {
            var D = _.call(z), he;
            if (_ !== z.entries) {
              for (; !(he = D.next()).done; )
                if (!$(he.value))
                  return !1;
            } else
              for (; !(he = D.next()).done; ) {
                var oe = he.value;
                if (oe && !$(oe[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function L(z, _) {
      return z === "symbol" ? !0 : _ ? _["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && _ instanceof Symbol : !1;
    }
    function Q(z) {
      var _ = typeof z;
      return Array.isArray(z) ? "array" : z instanceof RegExp ? "object" : L(_, z) ? "symbol" : _;
    }
    function j(z) {
      if (typeof z > "u" || z === null)
        return "" + z;
      var _ = Q(z);
      if (_ === "object") {
        if (z instanceof Date)
          return "date";
        if (z instanceof RegExp)
          return "regexp";
      }
      return _;
    }
    function ee(z) {
      var _ = j(z);
      switch (_) {
        case "array":
        case "object":
          return "an " + _;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + _;
        default:
          return _;
      }
    }
    function J(z) {
      return !z.constructor || !z.constructor.name ? E : z.constructor.name;
    }
    return T.checkPropTypes = a, T.resetWarningCache = a.resetWarningCache, T.PropTypes = T, T;
  }, pu;
}
var gu, rm;
function xI() {
  if (rm)
    return gu;
  rm = 1;
  var e = af();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, gu = function() {
    function r(o, s, u, l, c, f) {
      if (f !== e) {
        var E = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw E.name = "Invariant Violation", E;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, gu;
}
if ({}.NODE_ENV !== "production") {
  var kI = Og(), PI = !0;
  $e.exports = MI()(kI.isElement, PI);
} else
  $e.exports = xI()();
class v1 {
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
v1.prototype.property = {};
v1.prototype.normal = {};
v1.prototype.space = null;
function wg(e, t) {
  const n = {}, r = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(n, e[a].property), Object.assign(r, e[a].normal);
  return new v1(n, r, t);
}
function m1(e) {
  return e.toLowerCase();
}
class Kn {
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
Kn.prototype.space = null;
Kn.prototype.boolean = !1;
Kn.prototype.booleanish = !1;
Kn.prototype.overloadedBoolean = !1;
Kn.prototype.number = !1;
Kn.prototype.commaSeparated = !1;
Kn.prototype.spaceSeparated = !1;
Kn.prototype.commaOrSpaceSeparated = !1;
Kn.prototype.mustUseProperty = !1;
Kn.prototype.defined = !1;
let BI = 0;
const Ge = Oa(), Kt = Oa(), Ig = Oa(), de = Oa(), xt = Oa(), ni = Oa(), Nn = Oa();
function Oa() {
  return 2 ** ++BI;
}
const dc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Ge,
  booleanish: Kt,
  overloadedBoolean: Ig,
  number: de,
  spaceSeparated: xt,
  commaSeparated: ni,
  commaOrSpaceSeparated: Nn
}, Symbol.toStringTag, { value: "Module" })), Eu = Object.keys(dc);
class of extends Kn {
  constructor(t, n, r, a) {
    let i = -1;
    if (super(t, n), am(this, "space", a), typeof r == "number")
      for (; ++i < Eu.length; ) {
        const o = Eu[i];
        am(this, Eu[i], (r & dc[o]) === dc[o]);
      }
  }
}
of.prototype.defined = !0;
function am(e, t, n) {
  n && (e[t] = n);
}
const FI = {}.hasOwnProperty;
function gi(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (FI.call(e.properties, r)) {
      const a = e.properties[r], i = new of(
        r,
        e.transform(e.attributes || {}, r),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (i.mustUseProperty = !0), t[r] = i, n[m1(r)] = r, n[m1(i.attribute)] = r;
    }
  return new v1(t, n, e.space);
}
const Rg = gi({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), Mg = gi({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function xg(e, t) {
  return t in e ? e[t] : t;
}
function kg(e, t) {
  return xg(e, t.toLowerCase());
}
const Pg = gi({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: kg,
  properties: { xmlns: null, xmlnsXLink: null }
}), Bg = gi({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Kt,
    ariaAutoComplete: null,
    ariaBusy: Kt,
    ariaChecked: Kt,
    ariaColCount: de,
    ariaColIndex: de,
    ariaColSpan: de,
    ariaControls: xt,
    ariaCurrent: null,
    ariaDescribedBy: xt,
    ariaDetails: null,
    ariaDisabled: Kt,
    ariaDropEffect: xt,
    ariaErrorMessage: null,
    ariaExpanded: Kt,
    ariaFlowTo: xt,
    ariaGrabbed: Kt,
    ariaHasPopup: null,
    ariaHidden: Kt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: xt,
    ariaLevel: de,
    ariaLive: null,
    ariaModal: Kt,
    ariaMultiLine: Kt,
    ariaMultiSelectable: Kt,
    ariaOrientation: null,
    ariaOwns: xt,
    ariaPlaceholder: null,
    ariaPosInSet: de,
    ariaPressed: Kt,
    ariaReadOnly: Kt,
    ariaRelevant: null,
    ariaRequired: Kt,
    ariaRoleDescription: xt,
    ariaRowCount: de,
    ariaRowIndex: de,
    ariaRowSpan: de,
    ariaSelected: Kt,
    ariaSetSize: de,
    ariaSort: null,
    ariaValueMax: de,
    ariaValueMin: de,
    ariaValueNow: de,
    ariaValueText: null,
    role: null
  }
}), LI = gi({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: kg,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    abbr: null,
    accept: ni,
    acceptCharset: xt,
    accessKey: xt,
    action: null,
    allow: null,
    allowFullScreen: Ge,
    allowPaymentRequest: Ge,
    allowUserMedia: Ge,
    alt: null,
    as: null,
    async: Ge,
    autoCapitalize: null,
    autoComplete: xt,
    autoFocus: Ge,
    autoPlay: Ge,
    capture: Ge,
    charSet: null,
    checked: Ge,
    cite: null,
    className: xt,
    cols: de,
    colSpan: null,
    content: null,
    contentEditable: Kt,
    controls: Ge,
    controlsList: xt,
    coords: de | ni,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Ge,
    defer: Ge,
    dir: null,
    dirName: null,
    disabled: Ge,
    download: Ig,
    draggable: Kt,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Ge,
    formTarget: null,
    headers: xt,
    height: de,
    hidden: Ge,
    high: de,
    href: null,
    hrefLang: null,
    htmlFor: xt,
    httpEquiv: xt,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Ge,
    itemId: null,
    itemProp: xt,
    itemRef: xt,
    itemScope: Ge,
    itemType: xt,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Ge,
    low: de,
    manifest: null,
    max: null,
    maxLength: de,
    media: null,
    method: null,
    min: null,
    minLength: de,
    multiple: Ge,
    muted: Ge,
    name: null,
    nonce: null,
    noModule: Ge,
    noValidate: Ge,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Ge,
    optimum: de,
    pattern: null,
    ping: xt,
    placeholder: null,
    playsInline: Ge,
    poster: null,
    preload: null,
    readOnly: Ge,
    referrerPolicy: null,
    rel: xt,
    required: Ge,
    reversed: Ge,
    rows: de,
    rowSpan: de,
    sandbox: xt,
    scope: null,
    scoped: Ge,
    seamless: Ge,
    selected: Ge,
    shape: null,
    size: de,
    sizes: null,
    slot: null,
    span: de,
    spellCheck: Kt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: de,
    step: null,
    style: null,
    tabIndex: de,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Ge,
    useMap: null,
    value: Kt,
    width: de,
    wrap: null,
    align: null,
    aLink: null,
    archive: xt,
    axis: null,
    background: null,
    bgColor: null,
    border: de,
    borderColor: null,
    bottomMargin: de,
    cellPadding: null,
    cellSpacing: null,
    char: null,
    charOff: null,
    classId: null,
    clear: null,
    code: null,
    codeBase: null,
    codeType: null,
    color: null,
    compact: Ge,
    declare: Ge,
    event: null,
    face: null,
    frame: null,
    frameBorder: null,
    hSpace: de,
    leftMargin: de,
    link: null,
    longDesc: null,
    lowSrc: null,
    marginHeight: de,
    marginWidth: de,
    noResize: Ge,
    noHref: Ge,
    noShade: Ge,
    noWrap: Ge,
    object: null,
    profile: null,
    prompt: null,
    rev: null,
    rightMargin: de,
    rules: null,
    scheme: null,
    scrolling: Kt,
    standby: null,
    summary: null,
    text: null,
    topMargin: de,
    valueType: null,
    version: null,
    vAlign: null,
    vLink: null,
    vSpace: de,
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Ge,
    disableRemotePlayback: Ge,
    prefix: null,
    property: null,
    results: de,
    security: null,
    unselectable: null
  }
}), $I = gi({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: xg,
  properties: {
    about: Nn,
    accentHeight: de,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: de,
    amplitude: de,
    arabicForm: null,
    ascent: de,
    attributeName: null,
    attributeType: null,
    azimuth: de,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: de,
    by: null,
    calcMode: null,
    capHeight: de,
    className: xt,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: de,
    diffuseConstant: de,
    direction: null,
    display: null,
    dur: null,
    divisor: de,
    dominantBaseline: null,
    download: Ge,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: de,
    enableBackground: null,
    end: null,
    event: null,
    exponent: de,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: de,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ni,
    g2: ni,
    glyphName: ni,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: de,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: de,
    horizOriginX: de,
    horizOriginY: de,
    id: null,
    ideographic: de,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: de,
    k: de,
    k1: de,
    k2: de,
    k3: de,
    k4: de,
    kernelMatrix: Nn,
    kernelUnitLength: null,
    keyPoints: null,
    keySplines: null,
    keyTimes: null,
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: de,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: de,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: de,
    overlineThickness: de,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: de,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: xt,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: de,
    pointsAtY: de,
    pointsAtZ: de,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Nn,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Nn,
    rev: Nn,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Nn,
    requiredFeatures: Nn,
    requiredFonts: Nn,
    requiredFormats: Nn,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: de,
    specularExponent: de,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: de,
    strikethroughThickness: de,
    string: null,
    stroke: null,
    strokeDashArray: Nn,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: de,
    strokeOpacity: de,
    strokeWidth: null,
    style: null,
    surfaceScale: de,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Nn,
    tabIndex: de,
    tableValues: null,
    target: null,
    targetX: de,
    targetY: de,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Nn,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: de,
    underlineThickness: de,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: de,
    values: null,
    vAlphabetic: de,
    vMathematical: de,
    vectorEffect: null,
    vHanging: de,
    vIdeographic: de,
    version: null,
    vertAdvY: de,
    vertOriginX: de,
    vertOriginY: de,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: de,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), HI = /^data[-\w.:]+$/i, im = /-[a-z]/g, UI = /[A-Z]/g;
function es(e, t) {
  const n = m1(t);
  let r = t, a = Kn;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && HI.test(t)) {
    if (t.charAt(4) === "-") {
      const i = t.slice(5).replace(im, zI);
      r = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = t.slice(4);
      if (!im.test(i)) {
        let o = i.replace(UI, jI);
        o.charAt(0) !== "-" && (o = "-" + o), t = "data" + o;
      }
    }
    a = of;
  }
  return new a(r, t);
}
function jI(e) {
  return "-" + e.toLowerCase();
}
function zI(e) {
  return e.charAt(1).toUpperCase();
}
const om = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, A1 = wg([Mg, Rg, Pg, Bg, LI], "html"), Ei = wg([Mg, Rg, Pg, Bg, $I], "svg"), GI = function(e, t, n, r) {
  typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), Jo(e, t, a, r);
  function a(i, o) {
    const s = o[o.length - 1];
    return n(
      i,
      s ? s.children.indexOf(i) : null,
      s
    );
  }
};
function VI(e) {
  if (e.allowedElements && e.disallowedElements)
    throw new TypeError(
      "Only one of `allowedElements` and `disallowedElements` should be defined"
    );
  if (e.allowedElements || e.disallowedElements || e.allowElement)
    return (t) => {
      GI(t, "element", (n, r, a) => {
        const i = a;
        let o;
        if (e.allowedElements ? o = !e.allowedElements.includes(n.tagName) : e.disallowedElements && (o = e.disallowedElements.includes(n.tagName)), !o && e.allowElement && typeof r == "number" && (o = !e.allowElement(n, r, i)), o && typeof r == "number")
          return e.unwrapDisallowed && n.children ? i.children.splice(r, 1, ...n.children) : i.children.splice(r, 1), r;
      });
    };
}
var Fg = { exports: {} }, gt = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sm;
function YI() {
  if (sm)
    return gt;
  sm = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function m(v) {
    if (typeof v == "object" && v !== null) {
      var b = v.$$typeof;
      switch (b) {
        case e:
          switch (v = v.type, v) {
            case n:
            case a:
            case r:
            case l:
            case c:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case s:
                case o:
                case u:
                case E:
                case f:
                case i:
                  return v;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return gt.ContextConsumer = o, gt.ContextProvider = i, gt.Element = e, gt.ForwardRef = u, gt.Fragment = n, gt.Lazy = E, gt.Memo = f, gt.Portal = t, gt.Profiler = a, gt.StrictMode = r, gt.Suspense = l, gt.SuspenseList = c, gt.isAsyncMode = function() {
    return !1;
  }, gt.isConcurrentMode = function() {
    return !1;
  }, gt.isContextConsumer = function(v) {
    return m(v) === o;
  }, gt.isContextProvider = function(v) {
    return m(v) === i;
  }, gt.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, gt.isForwardRef = function(v) {
    return m(v) === u;
  }, gt.isFragment = function(v) {
    return m(v) === n;
  }, gt.isLazy = function(v) {
    return m(v) === E;
  }, gt.isMemo = function(v) {
    return m(v) === f;
  }, gt.isPortal = function(v) {
    return m(v) === t;
  }, gt.isProfiler = function(v) {
    return m(v) === a;
  }, gt.isStrictMode = function(v) {
    return m(v) === r;
  }, gt.isSuspense = function(v) {
    return m(v) === l;
  }, gt.isSuspenseList = function(v) {
    return m(v) === c;
  }, gt.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === n || v === a || v === r || v === l || v === c || v === T || typeof v == "object" && v !== null && (v.$$typeof === E || v.$$typeof === f || v.$$typeof === i || v.$$typeof === o || v.$$typeof === u || v.$$typeof === g || v.getModuleId !== void 0);
  }, gt.typeOf = m, gt;
}
var Et = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var um;
function KI() {
  return um || (um = 1, {}.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), g = !1, m = !1, v = !1, b = !1, y = !1, O;
    O = Symbol.for("react.module.reference");
    function B(Se) {
      return !!(typeof Se == "string" || typeof Se == "function" || Se === n || Se === a || y || Se === r || Se === l || Se === c || b || Se === T || g || m || v || typeof Se == "object" && Se !== null && (Se.$$typeof === E || Se.$$typeof === f || Se.$$typeof === i || Se.$$typeof === o || Se.$$typeof === u || Se.$$typeof === O || Se.getModuleId !== void 0));
    }
    function S(Se) {
      if (typeof Se == "object" && Se !== null) {
        var Gt = Se.$$typeof;
        switch (Gt) {
          case e:
            var on = Se.type;
            switch (on) {
              case n:
              case a:
              case r:
              case l:
              case c:
                return on;
              default:
                var kn = on && on.$$typeof;
                switch (kn) {
                  case s:
                  case o:
                  case u:
                  case E:
                  case f:
                  case i:
                    return kn;
                  default:
                    return Gt;
                }
            }
          case t:
            return Gt;
        }
      }
    }
    var C = o, I = i, G = e, V = u, w = n, Y = E, X = f, H = t, $ = a, L = r, Q = l, j = c, ee = !1, J = !1;
    function z(Se) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function _(Se) {
      return J || (J = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function D(Se) {
      return S(Se) === o;
    }
    function he(Se) {
      return S(Se) === i;
    }
    function oe(Se) {
      return typeof Se == "object" && Se !== null && Se.$$typeof === e;
    }
    function ve(Se) {
      return S(Se) === u;
    }
    function le(Se) {
      return S(Se) === n;
    }
    function Ce(Se) {
      return S(Se) === E;
    }
    function _e(Se) {
      return S(Se) === f;
    }
    function ge(Se) {
      return S(Se) === t;
    }
    function ye(Se) {
      return S(Se) === a;
    }
    function ze(Se) {
      return S(Se) === r;
    }
    function ce(Se) {
      return S(Se) === l;
    }
    function Dt(Se) {
      return S(Se) === c;
    }
    Et.ContextConsumer = C, Et.ContextProvider = I, Et.Element = G, Et.ForwardRef = V, Et.Fragment = w, Et.Lazy = Y, Et.Memo = X, Et.Portal = H, Et.Profiler = $, Et.StrictMode = L, Et.Suspense = Q, Et.SuspenseList = j, Et.isAsyncMode = z, Et.isConcurrentMode = _, Et.isContextConsumer = D, Et.isContextProvider = he, Et.isElement = oe, Et.isForwardRef = ve, Et.isFragment = le, Et.isLazy = Ce, Et.isMemo = _e, Et.isPortal = ge, Et.isProfiler = ye, Et.isStrictMode = ze, Et.isSuspense = ce, Et.isSuspenseList = Dt, Et.isValidElementType = B, Et.typeOf = S;
  }()), Et;
}
(function(e) {
  ({}).NODE_ENV === "production" ? e.exports = YI() : e.exports = KI();
})(Fg);
const WI = /* @__PURE__ */ cv(Fg.exports);
function qI(e) {
  const t = e && typeof e == "object" && e.type === "text" ? e.value || "" : e;
  return typeof t == "string" && t.replace(/[ \t\n\f\r]/g, "") === "";
}
function lm(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function Lg(e) {
  return e.join(" ").trim();
}
function cm(e) {
  const t = [], n = String(e || "");
  let r = n.indexOf(","), a = 0, i = !1;
  for (; !i; ) {
    r === -1 && (r = n.length, i = !0);
    const o = n.slice(a, r).trim();
    (o || !i) && t.push(o), a = r + 1, r = n.indexOf(",", a);
  }
  return t;
}
function $g(e, t) {
  const n = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
var sf = { exports: {} }, fm = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, XI = /\n/g, QI = /^\s*/, ZI = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, JI = /^:\s*/, eR = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, tR = /^[;\s]*/, nR = /^\s+|\s+$/g, rR = `
`, hm = "/", dm = "*", ma = "", aR = "comment", iR = "declaration", oR = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  t = t || {};
  var n = 1, r = 1;
  function a(g) {
    var m = g.match(XI);
    m && (n += m.length);
    var v = g.lastIndexOf(rR);
    r = ~v ? g.length - v : r + g.length;
  }
  function i() {
    var g = { line: n, column: r };
    return function(m) {
      return m.position = new o(g), l(), m;
    };
  }
  function o(g) {
    this.start = g, this.end = { line: n, column: r }, this.source = t.source;
  }
  o.prototype.content = e;
  function s(g) {
    var m = new Error(
      t.source + ":" + n + ":" + r + ": " + g
    );
    if (m.reason = g, m.filename = t.source, m.line = n, m.column = r, m.source = e, !t.silent)
      throw m;
  }
  function u(g) {
    var m = g.exec(e);
    if (!!m) {
      var v = m[0];
      return a(v), e = e.slice(v.length), m;
    }
  }
  function l() {
    u(QI);
  }
  function c(g) {
    var m;
    for (g = g || []; m = f(); )
      m !== !1 && g.push(m);
    return g;
  }
  function f() {
    var g = i();
    if (!(hm != e.charAt(0) || dm != e.charAt(1))) {
      for (var m = 2; ma != e.charAt(m) && (dm != e.charAt(m) || hm != e.charAt(m + 1)); )
        ++m;
      if (m += 2, ma === e.charAt(m - 1))
        return s("End of comment missing");
      var v = e.slice(2, m - 2);
      return r += 2, a(v), e = e.slice(m), r += 2, g({
        type: aR,
        comment: v
      });
    }
  }
  function E() {
    var g = i(), m = u(ZI);
    if (!!m) {
      if (f(), !u(JI))
        return s("property missing ':'");
      var v = u(eR), b = g({
        type: iR,
        property: mm(m[0].replace(fm, ma)),
        value: v ? mm(v[0].replace(fm, ma)) : ma
      });
      return u(tR), b;
    }
  }
  function T() {
    var g = [];
    c(g);
    for (var m; m = E(); )
      m !== !1 && (g.push(m), c(g));
    return g;
  }
  return l(), T();
};
function mm(e) {
  return e ? e.replace(nR, ma) : ma;
}
var sR = oR;
function Hg(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  for (var r, a = sR(e), i = typeof t == "function", o, s, u = 0, l = a.length; u < l; u++)
    r = a[u], o = r.property, s = r.value, i ? t(o, s, r) : s && (n || (n = {}), n[o] = s);
  return n;
}
sf.exports = Hg;
sf.exports.default = Hg;
const uR = sf.exports, mc = {}.hasOwnProperty, lR = /* @__PURE__ */ new Set(["table", "thead", "tbody", "tfoot", "tr"]);
function Ug(e, t) {
  const n = [];
  let r = -1, a;
  for (; ++r < t.children.length; )
    a = t.children[r], a.type === "element" ? n.push(cR(e, a, r, t)) : a.type === "text" ? (t.type !== "element" || !lR.has(t.tagName) || !qI(a)) && n.push(a.value) : a.type === "raw" && !e.options.skipHtml && n.push(a.value);
  return n;
}
function cR(e, t, n, r) {
  const a = e.options, i = a.transformLinkUri === void 0 ? _O : a.transformLinkUri, o = e.schema, s = t.tagName, u = {};
  let l = o, c;
  if (o.space === "html" && s === "svg" && (l = Ei, e.schema = l), t.properties)
    for (c in t.properties)
      mc.call(t.properties, c) && hR(u, c, t.properties[c], e);
  (s === "ol" || s === "ul") && e.listDepth++;
  const f = Ug(e, t);
  (s === "ol" || s === "ul") && e.listDepth--, e.schema = o;
  const E = t.position || {
    start: {
      line: null,
      column: null,
      offset: null
    },
    end: {
      line: null,
      column: null,
      offset: null
    }
  }, T = a.components && mc.call(a.components, s) ? a.components[s] : s, g = typeof T == "string" || T === pn.Fragment;
  if (!WI.isValidElementType(T))
    throw new TypeError(`Component for name \`${s}\` not defined or is not renderable`);
  if (u.key = n, s === "a" && a.linkTarget && (u.target = typeof a.linkTarget == "function" ? a.linkTarget(String(u.href || ""), t.children, typeof u.title == "string" ? u.title : null) : a.linkTarget), s === "a" && i && (u.href = i(String(u.href || ""), t.children, typeof u.title == "string" ? u.title : null)), !g && s === "code" && r.type === "element" && r.tagName !== "pre" && (u.inline = !0), !g && (s === "h1" || s === "h2" || s === "h3" || s === "h4" || s === "h5" || s === "h6") && (u.level = Number.parseInt(s.charAt(1), 10)), s === "img" && a.transformImageUri && (u.src = a.transformImageUri(String(u.src || ""), String(u.alt || ""), typeof u.title == "string" ? u.title : null)), !g && s === "li" && r.type === "element") {
    const m = fR(t);
    u.checked = m && m.properties ? Boolean(m.properties.checked) : null, u.index = Tu(r, t), u.ordered = r.tagName === "ol";
  }
  return !g && (s === "ol" || s === "ul") && (u.ordered = s === "ol", u.depth = e.listDepth), (s === "td" || s === "th") && (u.align && (u.style || (u.style = {}), u.style.textAlign = u.align, delete u.align), g || (u.isHeader = s === "th")), !g && s === "tr" && r.type === "element" && (u.isHeader = Boolean(r.tagName === "thead")), a.sourcePos && (u["data-sourcepos"] = pR(E)), !g && a.rawSourcePos && (u.sourcePosition = t.position), !g && a.includeElementIndex && (u.index = Tu(r, t), u.siblingCount = Tu(r)), g || (u.node = t), f.length > 0 ? pn.createElement(T, u, f) : pn.createElement(T, u);
}
function fR(e) {
  let t = -1;
  for (; ++t < e.children.length; ) {
    const n = e.children[t];
    if (n.type === "element" && n.tagName === "input")
      return n;
  }
  return null;
}
function Tu(e, t) {
  let n = -1, r = 0;
  for (; ++n < e.children.length && e.children[n] !== t; )
    e.children[n].type === "element" && r++;
  return r;
}
function hR(e, t, n, r) {
  const a = es(r.schema, t);
  let i = n;
  i == null || i !== i || (Array.isArray(i) && (i = a.commaSeparated ? $g(i) : Lg(i)), a.property === "style" && typeof i == "string" && (i = dR(i)), a.space && a.property ? e[mc.call(om, a.property) ? om[a.property] : a.property] = i : a.attribute && (e[a.attribute] = i));
}
function dR(e) {
  const t = {};
  try {
    uR(e, n);
  } catch {
  }
  return t;
  function n(r, a) {
    const i = r.slice(0, 4) === "-ms-" ? `ms-${r.slice(4)}` : r;
    t[i.replace(/-([a-z])/g, mR)] = a;
  }
}
function mR(e, t) {
  return t.toUpperCase();
}
function pR(e) {
  return [e.start.line, ":", e.start.column, "-", e.end.line, ":", e.end.column].map(String).join("");
}
const pm = {}.hasOwnProperty, gR = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", L1 = {
  plugins: {
    to: "remarkPlugins",
    id: "change-plugins-to-remarkplugins"
  },
  renderers: {
    to: "components",
    id: "change-renderers-to-components"
  },
  astPlugins: {
    id: "remove-buggy-html-in-markdown-parser"
  },
  allowDangerousHtml: {
    id: "remove-buggy-html-in-markdown-parser"
  },
  escapeHtml: {
    id: "remove-buggy-html-in-markdown-parser"
  },
  source: {
    to: "children",
    id: "change-source-to-children"
  },
  allowNode: {
    to: "allowElement",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  allowedTypes: {
    to: "allowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  disallowedTypes: {
    to: "disallowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  includeNodeIndex: {
    to: "includeElementIndex",
    id: "change-includenodeindex-to-includeelementindex"
  }
};
function jg(e) {
  for (const i in L1)
    if (pm.call(L1, i) && pm.call(e, i)) {
      const o = L1[i];
      console.warn(`[react-markdown] Warning: please ${o.to ? `use \`${o.to}\` instead of` : "remove"} \`${i}\` (see <${gR}#${o.id}> for more info)`), delete L1[i];
    }
  const t = BO().use(Pw).use(e.remarkPlugins || []).use(DI, {
    ...e.remarkRehypeOptions,
    allowDangerousHtml: !0
  }).use(e.rehypePlugins || []).use(VI, e), n = new tg();
  typeof e.children == "string" ? n.value = e.children : e.children !== void 0 && e.children !== null && console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${e.children}\`)`);
  const r = t.runSync(t.parse(n), n);
  if (r.type !== "root")
    throw new TypeError("Expected a `root` node");
  let a = /* @__PURE__ */ me(ri, {
    children: Ug({
      options: e,
      schema: A1,
      listDepth: 0
    }, r)
  });
  return e.className && (a = /* @__PURE__ */ me("div", {
    className: e.className,
    children: a
  })), a;
}
jg.propTypes = {
  children: $e.exports.string,
  className: $e.exports.string,
  allowElement: $e.exports.func,
  allowedElements: $e.exports.arrayOf($e.exports.string),
  disallowedElements: $e.exports.arrayOf($e.exports.string),
  unwrapDisallowed: $e.exports.bool,
  remarkPlugins: $e.exports.arrayOf($e.exports.oneOfType([$e.exports.object, $e.exports.func, $e.exports.arrayOf($e.exports.oneOfType([$e.exports.bool, $e.exports.string, $e.exports.object, $e.exports.func, $e.exports.arrayOf(
    $e.exports.any
  )]))])),
  rehypePlugins: $e.exports.arrayOf($e.exports.oneOfType([$e.exports.object, $e.exports.func, $e.exports.arrayOf($e.exports.oneOfType([$e.exports.bool, $e.exports.string, $e.exports.object, $e.exports.func, $e.exports.arrayOf(
    $e.exports.any
  )]))])),
  sourcePos: $e.exports.bool,
  rawSourcePos: $e.exports.bool,
  skipHtml: $e.exports.bool,
  includeElementIndex: $e.exports.bool,
  transformLinkUri: $e.exports.oneOfType([$e.exports.func, $e.exports.bool]),
  linkTarget: $e.exports.oneOfType([$e.exports.func, $e.exports.string]),
  transformImageUri: $e.exports.func,
  components: $e.exports.object
};
var ur = {};
const ER = [
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
];
ur.REPLACEMENT_CHARACTER = "\uFFFD";
ur.CODE_POINTS = {
  EOF: -1,
  NULL: 0,
  TABULATION: 9,
  CARRIAGE_RETURN: 13,
  LINE_FEED: 10,
  FORM_FEED: 12,
  SPACE: 32,
  EXCLAMATION_MARK: 33,
  QUOTATION_MARK: 34,
  NUMBER_SIGN: 35,
  AMPERSAND: 38,
  APOSTROPHE: 39,
  HYPHEN_MINUS: 45,
  SOLIDUS: 47,
  DIGIT_0: 48,
  DIGIT_9: 57,
  SEMICOLON: 59,
  LESS_THAN_SIGN: 60,
  EQUALS_SIGN: 61,
  GREATER_THAN_SIGN: 62,
  QUESTION_MARK: 63,
  LATIN_CAPITAL_A: 65,
  LATIN_CAPITAL_F: 70,
  LATIN_CAPITAL_X: 88,
  LATIN_CAPITAL_Z: 90,
  RIGHT_SQUARE_BRACKET: 93,
  GRAVE_ACCENT: 96,
  LATIN_SMALL_A: 97,
  LATIN_SMALL_F: 102,
  LATIN_SMALL_X: 120,
  LATIN_SMALL_Z: 122,
  REPLACEMENT_CHARACTER: 65533
};
ur.CODE_POINT_SEQUENCES = {
  DASH_DASH_STRING: [45, 45],
  DOCTYPE_STRING: [68, 79, 67, 84, 89, 80, 69],
  CDATA_START_STRING: [91, 67, 68, 65, 84, 65, 91],
  SCRIPT_STRING: [115, 99, 114, 105, 112, 116],
  PUBLIC_STRING: [80, 85, 66, 76, 73, 67],
  SYSTEM_STRING: [83, 89, 83, 84, 69, 77]
};
ur.isSurrogate = function(e) {
  return e >= 55296 && e <= 57343;
};
ur.isSurrogatePair = function(e) {
  return e >= 56320 && e <= 57343;
};
ur.getSurrogatePairCodePoint = function(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
};
ur.isControlCodePoint = function(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
};
ur.isUndefinedCodePoint = function(e) {
  return e >= 64976 && e <= 65007 || ER.indexOf(e) > -1;
};
var uf = {
  controlCharacterInInputStream: "control-character-in-input-stream",
  noncharacterInInputStream: "noncharacter-in-input-stream",
  surrogateInInputStream: "surrogate-in-input-stream",
  nonVoidHtmlElementStartTagWithTrailingSolidus: "non-void-html-element-start-tag-with-trailing-solidus",
  endTagWithAttributes: "end-tag-with-attributes",
  endTagWithTrailingSolidus: "end-tag-with-trailing-solidus",
  unexpectedSolidusInTag: "unexpected-solidus-in-tag",
  unexpectedNullCharacter: "unexpected-null-character",
  unexpectedQuestionMarkInsteadOfTagName: "unexpected-question-mark-instead-of-tag-name",
  invalidFirstCharacterOfTagName: "invalid-first-character-of-tag-name",
  unexpectedEqualsSignBeforeAttributeName: "unexpected-equals-sign-before-attribute-name",
  missingEndTagName: "missing-end-tag-name",
  unexpectedCharacterInAttributeName: "unexpected-character-in-attribute-name",
  unknownNamedCharacterReference: "unknown-named-character-reference",
  missingSemicolonAfterCharacterReference: "missing-semicolon-after-character-reference",
  unexpectedCharacterAfterDoctypeSystemIdentifier: "unexpected-character-after-doctype-system-identifier",
  unexpectedCharacterInUnquotedAttributeValue: "unexpected-character-in-unquoted-attribute-value",
  eofBeforeTagName: "eof-before-tag-name",
  eofInTag: "eof-in-tag",
  missingAttributeValue: "missing-attribute-value",
  missingWhitespaceBetweenAttributes: "missing-whitespace-between-attributes",
  missingWhitespaceAfterDoctypePublicKeyword: "missing-whitespace-after-doctype-public-keyword",
  missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: "missing-whitespace-between-doctype-public-and-system-identifiers",
  missingWhitespaceAfterDoctypeSystemKeyword: "missing-whitespace-after-doctype-system-keyword",
  missingQuoteBeforeDoctypePublicIdentifier: "missing-quote-before-doctype-public-identifier",
  missingQuoteBeforeDoctypeSystemIdentifier: "missing-quote-before-doctype-system-identifier",
  missingDoctypePublicIdentifier: "missing-doctype-public-identifier",
  missingDoctypeSystemIdentifier: "missing-doctype-system-identifier",
  abruptDoctypePublicIdentifier: "abrupt-doctype-public-identifier",
  abruptDoctypeSystemIdentifier: "abrupt-doctype-system-identifier",
  cdataInHtmlContent: "cdata-in-html-content",
  incorrectlyOpenedComment: "incorrectly-opened-comment",
  eofInScriptHtmlCommentLikeText: "eof-in-script-html-comment-like-text",
  eofInDoctype: "eof-in-doctype",
  nestedComment: "nested-comment",
  abruptClosingOfEmptyComment: "abrupt-closing-of-empty-comment",
  eofInComment: "eof-in-comment",
  incorrectlyClosedComment: "incorrectly-closed-comment",
  eofInCdata: "eof-in-cdata",
  absenceOfDigitsInNumericCharacterReference: "absence-of-digits-in-numeric-character-reference",
  nullCharacterReference: "null-character-reference",
  surrogateCharacterReference: "surrogate-character-reference",
  characterReferenceOutsideUnicodeRange: "character-reference-outside-unicode-range",
  controlCharacterReference: "control-character-reference",
  noncharacterCharacterReference: "noncharacter-character-reference",
  missingWhitespaceBeforeDoctypeName: "missing-whitespace-before-doctype-name",
  missingDoctypeName: "missing-doctype-name",
  invalidCharacterSequenceAfterDoctypeName: "invalid-character-sequence-after-doctype-name",
  duplicateAttribute: "duplicate-attribute",
  nonConformingDoctype: "non-conforming-doctype",
  missingDoctype: "missing-doctype",
  misplacedDoctype: "misplaced-doctype",
  endTagWithoutMatchingOpenElement: "end-tag-without-matching-open-element",
  closingOfElementWithOpenChildElements: "closing-of-element-with-open-child-elements",
  disallowedContentInNoscriptInHead: "disallowed-content-in-noscript-in-head",
  openElementsLeftAfterEof: "open-elements-left-after-eof",
  abandonedHeadElementChild: "abandoned-head-element-child",
  misplacedStartTagForHeadElement: "misplaced-start-tag-for-head-element",
  nestedNoscriptInHead: "nested-noscript-in-head",
  eofInElementThatCanContainOnlyText: "eof-in-element-that-can-contain-only-text"
};
const Ka = ur, vu = uf, ua = Ka.CODE_POINTS, TR = 1 << 16;
class vR {
  constructor() {
    this.html = null, this.pos = -1, this.lastGapPos = -1, this.lastCharPos = -1, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = TR;
  }
  _err() {
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.lastCharPos) {
      const n = this.html.charCodeAt(this.pos + 1);
      if (Ka.isSurrogatePair(n))
        return this.pos++, this._addGap(), Ka.getSurrogatePairCodePoint(t, n);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, ua.EOF;
    return this._err(vu.surrogateInInputStream), t;
  }
  dropParsedChunk() {
    this.pos > this.bufferWaterline && (this.lastCharPos -= this.pos, this.html = this.html.substring(this.pos), this.pos = 0, this.lastGapPos = -1, this.gapStack = []);
  }
  write(t, n) {
    this.html ? this.html += t : this.html = t, this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1, this.lastChunkWritten = n;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1, this.html.length), this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1;
  }
  advance() {
    if (this.pos++, this.pos > this.lastCharPos)
      return this.endOfChunkHit = !this.lastChunkWritten, ua.EOF;
    let t = this.html.charCodeAt(this.pos);
    return this.skipNextNewLine && t === ua.LINE_FEED ? (this.skipNextNewLine = !1, this._addGap(), this.advance()) : t === ua.CARRIAGE_RETURN ? (this.skipNextNewLine = !0, ua.LINE_FEED) : (this.skipNextNewLine = !1, Ka.isSurrogate(t) && (t = this._processSurrogate(t)), t > 31 && t < 127 || t === ua.LINE_FEED || t === ua.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    Ka.isControlCodePoint(t) ? this._err(vu.controlCharacterInInputStream) : Ka.isUndefinedCodePoint(t) && this._err(vu.noncharacterInInputStream);
  }
  retreat() {
    this.pos === this.lastGapPos && (this.lastGapPos = this.gapStack.pop(), this.pos--), this.pos--;
  }
}
var AR = vR, CR = new Uint16Array([4, 52, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 106, 303, 412, 810, 1432, 1701, 1796, 1987, 2114, 2360, 2420, 2484, 3170, 3251, 4140, 4393, 4575, 4610, 5106, 5512, 5728, 6117, 6274, 6315, 6345, 6427, 6516, 7002, 7910, 8733, 9323, 9870, 10170, 10631, 10893, 11318, 11386, 11467, 12773, 13092, 14474, 14922, 15448, 15542, 16419, 17666, 18166, 18611, 19004, 19095, 19298, 19397, 4, 16, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 140, 150, 158, 169, 176, 194, 199, 210, 216, 222, 226, 242, 256, 266, 283, 294, 108, 105, 103, 5, 198, 1, 59, 148, 1, 198, 80, 5, 38, 1, 59, 156, 1, 38, 99, 117, 116, 101, 5, 193, 1, 59, 167, 1, 193, 114, 101, 118, 101, 59, 1, 258, 4, 2, 105, 121, 182, 191, 114, 99, 5, 194, 1, 59, 189, 1, 194, 59, 1, 1040, 114, 59, 3, 55349, 56580, 114, 97, 118, 101, 5, 192, 1, 59, 208, 1, 192, 112, 104, 97, 59, 1, 913, 97, 99, 114, 59, 1, 256, 100, 59, 1, 10835, 4, 2, 103, 112, 232, 237, 111, 110, 59, 1, 260, 102, 59, 3, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 1, 8289, 105, 110, 103, 5, 197, 1, 59, 264, 1, 197, 4, 2, 99, 115, 272, 277, 114, 59, 3, 55349, 56476, 105, 103, 110, 59, 1, 8788, 105, 108, 100, 101, 5, 195, 1, 59, 292, 1, 195, 109, 108, 5, 196, 1, 59, 301, 1, 196, 4, 8, 97, 99, 101, 102, 111, 114, 115, 117, 321, 350, 354, 383, 388, 394, 400, 405, 4, 2, 99, 114, 327, 336, 107, 115, 108, 97, 115, 104, 59, 1, 8726, 4, 2, 118, 119, 342, 345, 59, 1, 10983, 101, 100, 59, 1, 8966, 121, 59, 1, 1041, 4, 3, 99, 114, 116, 362, 369, 379, 97, 117, 115, 101, 59, 1, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 1, 8492, 97, 59, 1, 914, 114, 59, 3, 55349, 56581, 112, 102, 59, 3, 55349, 56633, 101, 118, 101, 59, 1, 728, 99, 114, 59, 1, 8492, 109, 112, 101, 113, 59, 1, 8782, 4, 14, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 442, 447, 456, 504, 542, 547, 569, 573, 577, 616, 678, 784, 790, 796, 99, 121, 59, 1, 1063, 80, 89, 5, 169, 1, 59, 454, 1, 169, 4, 3, 99, 112, 121, 464, 470, 497, 117, 116, 101, 59, 1, 262, 4, 2, 59, 105, 476, 478, 1, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8517, 108, 101, 121, 115, 59, 1, 8493, 4, 4, 97, 101, 105, 111, 514, 520, 530, 535, 114, 111, 110, 59, 1, 268, 100, 105, 108, 5, 199, 1, 59, 528, 1, 199, 114, 99, 59, 1, 264, 110, 105, 110, 116, 59, 1, 8752, 111, 116, 59, 1, 266, 4, 2, 100, 110, 553, 560, 105, 108, 108, 97, 59, 1, 184, 116, 101, 114, 68, 111, 116, 59, 1, 183, 114, 59, 1, 8493, 105, 59, 1, 935, 114, 99, 108, 101, 4, 4, 68, 77, 80, 84, 591, 596, 603, 609, 111, 116, 59, 1, 8857, 105, 110, 117, 115, 59, 1, 8854, 108, 117, 115, 59, 1, 8853, 105, 109, 101, 115, 59, 1, 8855, 111, 4, 2, 99, 115, 623, 646, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8754, 101, 67, 117, 114, 108, 121, 4, 2, 68, 81, 658, 671, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8221, 117, 111, 116, 101, 59, 1, 8217, 4, 4, 108, 110, 112, 117, 688, 701, 736, 753, 111, 110, 4, 2, 59, 101, 696, 698, 1, 8759, 59, 1, 10868, 4, 3, 103, 105, 116, 709, 717, 722, 114, 117, 101, 110, 116, 59, 1, 8801, 110, 116, 59, 1, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8750, 4, 2, 102, 114, 742, 745, 59, 1, 8450, 111, 100, 117, 99, 116, 59, 1, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8755, 111, 115, 115, 59, 1, 10799, 99, 114, 59, 3, 55349, 56478, 112, 4, 2, 59, 67, 803, 805, 1, 8915, 97, 112, 59, 1, 8781, 4, 11, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 834, 850, 855, 860, 865, 888, 903, 916, 921, 1011, 1415, 4, 2, 59, 111, 840, 842, 1, 8517, 116, 114, 97, 104, 100, 59, 1, 10513, 99, 121, 59, 1, 1026, 99, 121, 59, 1, 1029, 99, 121, 59, 1, 1039, 4, 3, 103, 114, 115, 873, 879, 883, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8609, 104, 118, 59, 1, 10980, 4, 2, 97, 121, 894, 900, 114, 111, 110, 59, 1, 270, 59, 1, 1044, 108, 4, 2, 59, 116, 910, 912, 1, 8711, 97, 59, 1, 916, 114, 59, 3, 55349, 56583, 4, 2, 97, 102, 927, 998, 4, 2, 99, 109, 933, 992, 114, 105, 116, 105, 99, 97, 108, 4, 4, 65, 68, 71, 84, 950, 957, 978, 985, 99, 117, 116, 101, 59, 1, 180, 111, 4, 2, 116, 117, 964, 967, 59, 1, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 1, 733, 114, 97, 118, 101, 59, 1, 96, 105, 108, 100, 101, 59, 1, 732, 111, 110, 100, 59, 1, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8518, 4, 4, 112, 116, 117, 119, 1021, 1026, 1048, 1249, 102, 59, 3, 55349, 56635, 4, 3, 59, 68, 69, 1034, 1036, 1041, 1, 168, 111, 116, 59, 1, 8412, 113, 117, 97, 108, 59, 1, 8784, 98, 108, 101, 4, 6, 67, 68, 76, 82, 85, 86, 1065, 1082, 1101, 1189, 1211, 1236, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8751, 111, 4, 2, 116, 119, 1089, 1092, 59, 1, 168, 110, 65, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 101, 111, 1107, 1141, 102, 116, 4, 3, 65, 82, 84, 1117, 1124, 1136, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8660, 101, 101, 59, 1, 10980, 110, 103, 4, 2, 76, 82, 1149, 1177, 101, 102, 116, 4, 2, 65, 82, 1158, 1165, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10233, 105, 103, 104, 116, 4, 2, 65, 84, 1199, 1206, 114, 114, 111, 119, 59, 1, 8658, 101, 101, 59, 1, 8872, 112, 4, 2, 65, 68, 1218, 1225, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8741, 110, 4, 6, 65, 66, 76, 82, 84, 97, 1264, 1292, 1299, 1352, 1391, 1408, 114, 114, 111, 119, 4, 3, 59, 66, 85, 1276, 1278, 1283, 1, 8595, 97, 114, 59, 1, 10515, 112, 65, 114, 114, 111, 119, 59, 1, 8693, 114, 101, 118, 101, 59, 1, 785, 101, 102, 116, 4, 3, 82, 84, 86, 1310, 1323, 1334, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 1, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10590, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1345, 1347, 1, 8637, 97, 114, 59, 1, 10582, 105, 103, 104, 116, 4, 2, 84, 86, 1362, 1373, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10591, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1384, 1386, 1, 8641, 97, 114, 59, 1, 10583, 101, 101, 4, 2, 59, 65, 1399, 1401, 1, 8868, 114, 114, 111, 119, 59, 1, 8615, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 99, 116, 1421, 1426, 114, 59, 3, 55349, 56479, 114, 111, 107, 59, 1, 272, 4, 16, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1466, 1470, 1478, 1489, 1515, 1520, 1525, 1536, 1544, 1593, 1609, 1617, 1650, 1664, 1668, 1677, 71, 59, 1, 330, 72, 5, 208, 1, 59, 1476, 1, 208, 99, 117, 116, 101, 5, 201, 1, 59, 1487, 1, 201, 4, 3, 97, 105, 121, 1497, 1503, 1512, 114, 111, 110, 59, 1, 282, 114, 99, 5, 202, 1, 59, 1510, 1, 202, 59, 1, 1069, 111, 116, 59, 1, 278, 114, 59, 3, 55349, 56584, 114, 97, 118, 101, 5, 200, 1, 59, 1534, 1, 200, 101, 109, 101, 110, 116, 59, 1, 8712, 4, 2, 97, 112, 1550, 1555, 99, 114, 59, 1, 274, 116, 121, 4, 2, 83, 86, 1563, 1576, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9643, 4, 2, 103, 112, 1599, 1604, 111, 110, 59, 1, 280, 102, 59, 3, 55349, 56636, 115, 105, 108, 111, 110, 59, 1, 917, 117, 4, 2, 97, 105, 1624, 1640, 108, 4, 2, 59, 84, 1631, 1633, 1, 10869, 105, 108, 100, 101, 59, 1, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8652, 4, 2, 99, 105, 1656, 1660, 114, 59, 1, 8496, 109, 59, 1, 10867, 97, 59, 1, 919, 109, 108, 5, 203, 1, 59, 1675, 1, 203, 4, 2, 105, 112, 1683, 1689, 115, 116, 115, 59, 1, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 1, 8519, 4, 5, 99, 102, 105, 111, 115, 1713, 1717, 1722, 1762, 1791, 121, 59, 1, 1060, 114, 59, 3, 55349, 56585, 108, 108, 101, 100, 4, 2, 83, 86, 1732, 1745, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9642, 4, 3, 112, 114, 117, 1770, 1775, 1781, 102, 59, 3, 55349, 56637, 65, 108, 108, 59, 1, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 1, 8497, 99, 114, 59, 1, 8497, 4, 12, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1822, 1827, 1834, 1848, 1855, 1877, 1882, 1887, 1890, 1896, 1978, 1984, 99, 121, 59, 1, 1027, 5, 62, 1, 59, 1832, 1, 62, 109, 109, 97, 4, 2, 59, 100, 1843, 1845, 1, 915, 59, 1, 988, 114, 101, 118, 101, 59, 1, 286, 4, 3, 101, 105, 121, 1863, 1869, 1874, 100, 105, 108, 59, 1, 290, 114, 99, 59, 1, 284, 59, 1, 1043, 111, 116, 59, 1, 288, 114, 59, 3, 55349, 56586, 59, 1, 8921, 112, 102, 59, 3, 55349, 56638, 101, 97, 116, 101, 114, 4, 6, 69, 70, 71, 76, 83, 84, 1915, 1933, 1944, 1953, 1959, 1971, 113, 117, 97, 108, 4, 2, 59, 76, 1925, 1927, 1, 8805, 101, 115, 115, 59, 1, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8807, 114, 101, 97, 116, 101, 114, 59, 1, 10914, 101, 115, 115, 59, 1, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10878, 105, 108, 100, 101, 59, 1, 8819, 99, 114, 59, 3, 55349, 56482, 59, 1, 8811, 4, 8, 65, 97, 99, 102, 105, 111, 115, 117, 2005, 2012, 2026, 2032, 2036, 2049, 2073, 2089, 82, 68, 99, 121, 59, 1, 1066, 4, 2, 99, 116, 2018, 2023, 101, 107, 59, 1, 711, 59, 1, 94, 105, 114, 99, 59, 1, 292, 114, 59, 1, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 1, 8459, 4, 2, 112, 114, 2055, 2059, 102, 59, 1, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 1, 9472, 4, 2, 99, 116, 2079, 2083, 114, 59, 1, 8459, 114, 111, 107, 59, 1, 294, 109, 112, 4, 2, 68, 69, 2097, 2107, 111, 119, 110, 72, 117, 109, 112, 59, 1, 8782, 113, 117, 97, 108, 59, 1, 8783, 4, 14, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 2144, 2149, 2155, 2160, 2171, 2189, 2194, 2198, 2209, 2245, 2307, 2329, 2334, 2341, 99, 121, 59, 1, 1045, 108, 105, 103, 59, 1, 306, 99, 121, 59, 1, 1025, 99, 117, 116, 101, 5, 205, 1, 59, 2169, 1, 205, 4, 2, 105, 121, 2177, 2186, 114, 99, 5, 206, 1, 59, 2184, 1, 206, 59, 1, 1048, 111, 116, 59, 1, 304, 114, 59, 1, 8465, 114, 97, 118, 101, 5, 204, 1, 59, 2207, 1, 204, 4, 3, 59, 97, 112, 2217, 2219, 2238, 1, 8465, 4, 2, 99, 103, 2225, 2229, 114, 59, 1, 298, 105, 110, 97, 114, 121, 73, 59, 1, 8520, 108, 105, 101, 115, 59, 1, 8658, 4, 2, 116, 118, 2251, 2281, 4, 2, 59, 101, 2257, 2259, 1, 8748, 4, 2, 103, 114, 2265, 2271, 114, 97, 108, 59, 1, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8898, 105, 115, 105, 98, 108, 101, 4, 2, 67, 84, 2293, 2300, 111, 109, 109, 97, 59, 1, 8291, 105, 109, 101, 115, 59, 1, 8290, 4, 3, 103, 112, 116, 2315, 2320, 2325, 111, 110, 59, 1, 302, 102, 59, 3, 55349, 56640, 97, 59, 1, 921, 99, 114, 59, 1, 8464, 105, 108, 100, 101, 59, 1, 296, 4, 2, 107, 109, 2347, 2352, 99, 121, 59, 1, 1030, 108, 5, 207, 1, 59, 2358, 1, 207, 4, 5, 99, 102, 111, 115, 117, 2372, 2386, 2391, 2397, 2414, 4, 2, 105, 121, 2378, 2383, 114, 99, 59, 1, 308, 59, 1, 1049, 114, 59, 3, 55349, 56589, 112, 102, 59, 3, 55349, 56641, 4, 2, 99, 101, 2403, 2408, 114, 59, 3, 55349, 56485, 114, 99, 121, 59, 1, 1032, 107, 99, 121, 59, 1, 1028, 4, 7, 72, 74, 97, 99, 102, 111, 115, 2436, 2441, 2446, 2452, 2467, 2472, 2478, 99, 121, 59, 1, 1061, 99, 121, 59, 1, 1036, 112, 112, 97, 59, 1, 922, 4, 2, 101, 121, 2458, 2464, 100, 105, 108, 59, 1, 310, 59, 1, 1050, 114, 59, 3, 55349, 56590, 112, 102, 59, 3, 55349, 56642, 99, 114, 59, 3, 55349, 56486, 4, 11, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2508, 2513, 2520, 2562, 2585, 2981, 2986, 3004, 3011, 3146, 3167, 99, 121, 59, 1, 1033, 5, 60, 1, 59, 2518, 1, 60, 4, 5, 99, 109, 110, 112, 114, 2532, 2538, 2544, 2548, 2558, 117, 116, 101, 59, 1, 313, 98, 100, 97, 59, 1, 923, 103, 59, 1, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 1, 8466, 114, 59, 1, 8606, 4, 3, 97, 101, 121, 2570, 2576, 2582, 114, 111, 110, 59, 1, 317, 100, 105, 108, 59, 1, 315, 59, 1, 1051, 4, 2, 102, 115, 2591, 2907, 116, 4, 10, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2614, 2663, 2672, 2728, 2735, 2760, 2820, 2870, 2888, 2895, 4, 2, 110, 114, 2620, 2633, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10216, 114, 111, 119, 4, 3, 59, 66, 82, 2644, 2646, 2651, 1, 8592, 97, 114, 59, 1, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8646, 101, 105, 108, 105, 110, 103, 59, 1, 8968, 111, 4, 2, 117, 119, 2679, 2692, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10214, 110, 4, 2, 84, 86, 2699, 2710, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10593, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2721, 2723, 1, 8643, 97, 114, 59, 1, 10585, 108, 111, 111, 114, 59, 1, 8970, 105, 103, 104, 116, 4, 2, 65, 86, 2745, 2752, 114, 114, 111, 119, 59, 1, 8596, 101, 99, 116, 111, 114, 59, 1, 10574, 4, 2, 101, 114, 2766, 2792, 101, 4, 3, 59, 65, 86, 2775, 2777, 2784, 1, 8867, 114, 114, 111, 119, 59, 1, 8612, 101, 99, 116, 111, 114, 59, 1, 10586, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 2806, 2808, 2813, 1, 8882, 97, 114, 59, 1, 10703, 113, 117, 97, 108, 59, 1, 8884, 112, 4, 3, 68, 84, 86, 2829, 2841, 2852, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10592, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2863, 2865, 1, 8639, 97, 114, 59, 1, 10584, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2881, 2883, 1, 8636, 97, 114, 59, 1, 10578, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8660, 115, 4, 6, 69, 70, 71, 76, 83, 84, 2922, 2936, 2947, 2956, 2962, 2974, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8806, 114, 101, 97, 116, 101, 114, 59, 1, 8822, 101, 115, 115, 59, 1, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10877, 105, 108, 100, 101, 59, 1, 8818, 114, 59, 3, 55349, 56591, 4, 2, 59, 101, 2992, 2994, 1, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8666, 105, 100, 111, 116, 59, 1, 319, 4, 3, 110, 112, 119, 3019, 3110, 3115, 103, 4, 4, 76, 82, 108, 114, 3030, 3058, 3070, 3098, 101, 102, 116, 4, 2, 65, 82, 3039, 3046, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10230, 101, 102, 116, 4, 2, 97, 114, 3079, 3086, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10233, 102, 59, 3, 55349, 56643, 101, 114, 4, 2, 76, 82, 3123, 3134, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8600, 4, 3, 99, 104, 116, 3154, 3158, 3161, 114, 59, 1, 8466, 59, 1, 8624, 114, 111, 107, 59, 1, 321, 59, 1, 8810, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 3188, 3192, 3196, 3222, 3227, 3237, 3243, 3248, 112, 59, 1, 10501, 121, 59, 1, 1052, 4, 2, 100, 108, 3202, 3213, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8287, 108, 105, 110, 116, 114, 102, 59, 1, 8499, 114, 59, 3, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 1, 8723, 112, 102, 59, 3, 55349, 56644, 99, 114, 59, 1, 8499, 59, 1, 924, 4, 9, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3271, 3276, 3283, 3306, 3422, 3427, 4120, 4126, 4137, 99, 121, 59, 1, 1034, 99, 117, 116, 101, 59, 1, 323, 4, 3, 97, 101, 121, 3291, 3297, 3303, 114, 111, 110, 59, 1, 327, 100, 105, 108, 59, 1, 325, 59, 1, 1053, 4, 3, 103, 115, 119, 3314, 3380, 3415, 97, 116, 105, 118, 101, 4, 3, 77, 84, 86, 3327, 3340, 3365, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8203, 104, 105, 4, 2, 99, 110, 3348, 3357, 107, 83, 112, 97, 99, 101, 59, 1, 8203, 83, 112, 97, 99, 101, 59, 1, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8203, 116, 101, 100, 4, 2, 71, 76, 3389, 3405, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 1, 8810, 76, 105, 110, 101, 59, 1, 10, 114, 59, 3, 55349, 56593, 4, 4, 66, 110, 112, 116, 3437, 3444, 3460, 3464, 114, 101, 97, 107, 59, 1, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 1, 160, 102, 59, 1, 8469, 4, 13, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3492, 3494, 3517, 3536, 3578, 3657, 3685, 3784, 3823, 3860, 3915, 4066, 4107, 1, 10988, 4, 2, 111, 117, 3500, 3510, 110, 103, 114, 117, 101, 110, 116, 59, 1, 8802, 112, 67, 97, 112, 59, 1, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8742, 4, 3, 108, 113, 120, 3544, 3552, 3571, 101, 109, 101, 110, 116, 59, 1, 8713, 117, 97, 108, 4, 2, 59, 84, 3561, 3563, 1, 8800, 105, 108, 100, 101, 59, 3, 8770, 824, 105, 115, 116, 115, 59, 1, 8708, 114, 101, 97, 116, 101, 114, 4, 7, 59, 69, 70, 71, 76, 83, 84, 3600, 3602, 3609, 3621, 3631, 3637, 3650, 1, 8815, 113, 117, 97, 108, 59, 1, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 3, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 3, 8811, 824, 101, 115, 115, 59, 1, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10878, 824, 105, 108, 100, 101, 59, 1, 8821, 117, 109, 112, 4, 2, 68, 69, 3666, 3677, 111, 119, 110, 72, 117, 109, 112, 59, 3, 8782, 824, 113, 117, 97, 108, 59, 3, 8783, 824, 101, 4, 2, 102, 115, 3692, 3724, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3709, 3711, 3717, 1, 8938, 97, 114, 59, 3, 10703, 824, 113, 117, 97, 108, 59, 1, 8940, 115, 4, 6, 59, 69, 71, 76, 83, 84, 3739, 3741, 3748, 3757, 3764, 3777, 1, 8814, 113, 117, 97, 108, 59, 1, 8816, 114, 101, 97, 116, 101, 114, 59, 1, 8824, 101, 115, 115, 59, 3, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10877, 824, 105, 108, 100, 101, 59, 1, 8820, 101, 115, 116, 101, 100, 4, 2, 71, 76, 3795, 3812, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 3, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 3, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 4, 3, 59, 69, 83, 3838, 3840, 3848, 1, 8832, 113, 117, 97, 108, 59, 3, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8928, 4, 2, 101, 105, 3866, 3881, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 1, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3900, 3902, 3908, 1, 8939, 97, 114, 59, 3, 10704, 824, 113, 117, 97, 108, 59, 1, 8941, 4, 2, 113, 117, 3921, 3973, 117, 97, 114, 101, 83, 117, 4, 2, 98, 112, 3933, 3952, 115, 101, 116, 4, 2, 59, 69, 3942, 3945, 3, 8847, 824, 113, 117, 97, 108, 59, 1, 8930, 101, 114, 115, 101, 116, 4, 2, 59, 69, 3963, 3966, 3, 8848, 824, 113, 117, 97, 108, 59, 1, 8931, 4, 3, 98, 99, 112, 3981, 4e3, 4045, 115, 101, 116, 4, 2, 59, 69, 3990, 3993, 3, 8834, 8402, 113, 117, 97, 108, 59, 1, 8840, 99, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 4015, 4017, 4025, 4037, 1, 8833, 113, 117, 97, 108, 59, 3, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8929, 105, 108, 100, 101, 59, 3, 8831, 824, 101, 114, 115, 101, 116, 4, 2, 59, 69, 4056, 4059, 3, 8835, 8402, 113, 117, 97, 108, 59, 1, 8841, 105, 108, 100, 101, 4, 4, 59, 69, 70, 84, 4080, 4082, 4089, 4100, 1, 8769, 113, 117, 97, 108, 59, 1, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8775, 105, 108, 100, 101, 59, 1, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8740, 99, 114, 59, 3, 55349, 56489, 105, 108, 100, 101, 5, 209, 1, 59, 4135, 1, 209, 59, 1, 925, 4, 14, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 4170, 4176, 4187, 4205, 4212, 4217, 4228, 4253, 4259, 4292, 4295, 4316, 4337, 4346, 108, 105, 103, 59, 1, 338, 99, 117, 116, 101, 5, 211, 1, 59, 4185, 1, 211, 4, 2, 105, 121, 4193, 4202, 114, 99, 5, 212, 1, 59, 4200, 1, 212, 59, 1, 1054, 98, 108, 97, 99, 59, 1, 336, 114, 59, 3, 55349, 56594, 114, 97, 118, 101, 5, 210, 1, 59, 4226, 1, 210, 4, 3, 97, 101, 105, 4236, 4241, 4246, 99, 114, 59, 1, 332, 103, 97, 59, 1, 937, 99, 114, 111, 110, 59, 1, 927, 112, 102, 59, 3, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 4, 2, 68, 81, 4272, 4285, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8220, 117, 111, 116, 101, 59, 1, 8216, 59, 1, 10836, 4, 2, 99, 108, 4301, 4306, 114, 59, 3, 55349, 56490, 97, 115, 104, 5, 216, 1, 59, 4314, 1, 216, 105, 4, 2, 108, 109, 4323, 4332, 100, 101, 5, 213, 1, 59, 4330, 1, 213, 101, 115, 59, 1, 10807, 109, 108, 5, 214, 1, 59, 4344, 1, 214, 101, 114, 4, 2, 66, 80, 4354, 4380, 4, 2, 97, 114, 4360, 4364, 114, 59, 1, 8254, 97, 99, 4, 2, 101, 107, 4372, 4375, 59, 1, 9182, 101, 116, 59, 1, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9180, 4, 9, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4413, 4422, 4426, 4431, 4435, 4438, 4448, 4471, 4561, 114, 116, 105, 97, 108, 68, 59, 1, 8706, 121, 59, 1, 1055, 114, 59, 3, 55349, 56595, 105, 59, 1, 934, 59, 1, 928, 117, 115, 77, 105, 110, 117, 115, 59, 1, 177, 4, 2, 105, 112, 4454, 4467, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 1, 8460, 102, 59, 1, 8473, 4, 4, 59, 101, 105, 111, 4481, 4483, 4526, 4531, 1, 10939, 99, 101, 100, 101, 115, 4, 4, 59, 69, 83, 84, 4498, 4500, 4507, 4519, 1, 8826, 113, 117, 97, 108, 59, 1, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8828, 105, 108, 100, 101, 59, 1, 8830, 109, 101, 59, 1, 8243, 4, 2, 100, 112, 4537, 4543, 117, 99, 116, 59, 1, 8719, 111, 114, 116, 105, 111, 110, 4, 2, 59, 97, 4555, 4557, 1, 8759, 108, 59, 1, 8733, 4, 2, 99, 105, 4567, 4572, 114, 59, 3, 55349, 56491, 59, 1, 936, 4, 4, 85, 102, 111, 115, 4585, 4594, 4599, 4604, 79, 84, 5, 34, 1, 59, 4592, 1, 34, 114, 59, 3, 55349, 56596, 112, 102, 59, 1, 8474, 99, 114, 59, 3, 55349, 56492, 4, 12, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4636, 4642, 4650, 4681, 4704, 4763, 4767, 4771, 5047, 5069, 5081, 5094, 97, 114, 114, 59, 1, 10512, 71, 5, 174, 1, 59, 4648, 1, 174, 4, 3, 99, 110, 114, 4658, 4664, 4668, 117, 116, 101, 59, 1, 340, 103, 59, 1, 10219, 114, 4, 2, 59, 116, 4675, 4677, 1, 8608, 108, 59, 1, 10518, 4, 3, 97, 101, 121, 4689, 4695, 4701, 114, 111, 110, 59, 1, 344, 100, 105, 108, 59, 1, 342, 59, 1, 1056, 4, 2, 59, 118, 4710, 4712, 1, 8476, 101, 114, 115, 101, 4, 2, 69, 85, 4722, 4748, 4, 2, 108, 113, 4728, 4736, 101, 109, 101, 110, 116, 59, 1, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10607, 114, 59, 1, 8476, 111, 59, 1, 929, 103, 104, 116, 4, 8, 65, 67, 68, 70, 84, 85, 86, 97, 4792, 4840, 4849, 4905, 4912, 4972, 5022, 5040, 4, 2, 110, 114, 4798, 4811, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10217, 114, 111, 119, 4, 3, 59, 66, 76, 4822, 4824, 4829, 1, 8594, 97, 114, 59, 1, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8644, 101, 105, 108, 105, 110, 103, 59, 1, 8969, 111, 4, 2, 117, 119, 4856, 4869, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10215, 110, 4, 2, 84, 86, 4876, 4887, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10589, 101, 99, 116, 111, 114, 4, 2, 59, 66, 4898, 4900, 1, 8642, 97, 114, 59, 1, 10581, 108, 111, 111, 114, 59, 1, 8971, 4, 2, 101, 114, 4918, 4944, 101, 4, 3, 59, 65, 86, 4927, 4929, 4936, 1, 8866, 114, 114, 111, 119, 59, 1, 8614, 101, 99, 116, 111, 114, 59, 1, 10587, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 4958, 4960, 4965, 1, 8883, 97, 114, 59, 1, 10704, 113, 117, 97, 108, 59, 1, 8885, 112, 4, 3, 68, 84, 86, 4981, 4993, 5004, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10588, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5015, 5017, 1, 8638, 97, 114, 59, 1, 10580, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5033, 5035, 1, 8640, 97, 114, 59, 1, 10579, 114, 114, 111, 119, 59, 1, 8658, 4, 2, 112, 117, 5053, 5057, 102, 59, 1, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 1, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8667, 4, 2, 99, 104, 5087, 5091, 114, 59, 1, 8475, 59, 1, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 1, 10740, 4, 13, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 5134, 5150, 5157, 5164, 5198, 5203, 5259, 5265, 5277, 5283, 5374, 5380, 5385, 4, 2, 67, 99, 5140, 5146, 72, 99, 121, 59, 1, 1065, 121, 59, 1, 1064, 70, 84, 99, 121, 59, 1, 1068, 99, 117, 116, 101, 59, 1, 346, 4, 5, 59, 97, 101, 105, 121, 5176, 5178, 5184, 5190, 5195, 1, 10940, 114, 111, 110, 59, 1, 352, 100, 105, 108, 59, 1, 350, 114, 99, 59, 1, 348, 59, 1, 1057, 114, 59, 3, 55349, 56598, 111, 114, 116, 4, 4, 68, 76, 82, 85, 5216, 5227, 5238, 5250, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8594, 112, 65, 114, 114, 111, 119, 59, 1, 8593, 103, 109, 97, 59, 1, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 1, 8728, 112, 102, 59, 3, 55349, 56650, 4, 2, 114, 117, 5289, 5293, 116, 59, 1, 8730, 97, 114, 101, 4, 4, 59, 73, 83, 85, 5306, 5308, 5322, 5367, 1, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8851, 117, 4, 2, 98, 112, 5329, 5347, 115, 101, 116, 4, 2, 59, 69, 5338, 5340, 1, 8847, 113, 117, 97, 108, 59, 1, 8849, 101, 114, 115, 101, 116, 4, 2, 59, 69, 5358, 5360, 1, 8848, 113, 117, 97, 108, 59, 1, 8850, 110, 105, 111, 110, 59, 1, 8852, 99, 114, 59, 3, 55349, 56494, 97, 114, 59, 1, 8902, 4, 4, 98, 99, 109, 112, 5395, 5420, 5475, 5478, 4, 2, 59, 115, 5401, 5403, 1, 8912, 101, 116, 4, 2, 59, 69, 5411, 5413, 1, 8912, 113, 117, 97, 108, 59, 1, 8838, 4, 2, 99, 104, 5426, 5468, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 5440, 5442, 5449, 5461, 1, 8827, 113, 117, 97, 108, 59, 1, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8829, 105, 108, 100, 101, 59, 1, 8831, 84, 104, 97, 116, 59, 1, 8715, 59, 1, 8721, 4, 3, 59, 101, 115, 5486, 5488, 5507, 1, 8913, 114, 115, 101, 116, 4, 2, 59, 69, 5498, 5500, 1, 8835, 113, 117, 97, 108, 59, 1, 8839, 101, 116, 59, 1, 8913, 4, 11, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5536, 5546, 5552, 5567, 5579, 5602, 5607, 5655, 5695, 5701, 5711, 79, 82, 78, 5, 222, 1, 59, 5544, 1, 222, 65, 68, 69, 59, 1, 8482, 4, 2, 72, 99, 5558, 5563, 99, 121, 59, 1, 1035, 121, 59, 1, 1062, 4, 2, 98, 117, 5573, 5576, 59, 1, 9, 59, 1, 932, 4, 3, 97, 101, 121, 5587, 5593, 5599, 114, 111, 110, 59, 1, 356, 100, 105, 108, 59, 1, 354, 59, 1, 1058, 114, 59, 3, 55349, 56599, 4, 2, 101, 105, 5613, 5631, 4, 2, 114, 116, 5619, 5627, 101, 102, 111, 114, 101, 59, 1, 8756, 97, 59, 1, 920, 4, 2, 99, 110, 5637, 5647, 107, 83, 112, 97, 99, 101, 59, 3, 8287, 8202, 83, 112, 97, 99, 101, 59, 1, 8201, 108, 100, 101, 4, 4, 59, 69, 70, 84, 5668, 5670, 5677, 5688, 1, 8764, 113, 117, 97, 108, 59, 1, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8773, 105, 108, 100, 101, 59, 1, 8776, 112, 102, 59, 3, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 1, 8411, 4, 2, 99, 116, 5717, 5722, 114, 59, 3, 55349, 56495, 114, 111, 107, 59, 1, 358, 4, 14, 97, 98, 99, 100, 102, 103, 109, 110, 111, 112, 114, 115, 116, 117, 5758, 5789, 5805, 5823, 5830, 5835, 5846, 5852, 5921, 5937, 6089, 6095, 6101, 6108, 4, 2, 99, 114, 5764, 5774, 117, 116, 101, 5, 218, 1, 59, 5772, 1, 218, 114, 4, 2, 59, 111, 5781, 5783, 1, 8607, 99, 105, 114, 59, 1, 10569, 114, 4, 2, 99, 101, 5796, 5800, 121, 59, 1, 1038, 118, 101, 59, 1, 364, 4, 2, 105, 121, 5811, 5820, 114, 99, 5, 219, 1, 59, 5818, 1, 219, 59, 1, 1059, 98, 108, 97, 99, 59, 1, 368, 114, 59, 3, 55349, 56600, 114, 97, 118, 101, 5, 217, 1, 59, 5844, 1, 217, 97, 99, 114, 59, 1, 362, 4, 2, 100, 105, 5858, 5905, 101, 114, 4, 2, 66, 80, 5866, 5892, 4, 2, 97, 114, 5872, 5876, 114, 59, 1, 95, 97, 99, 4, 2, 101, 107, 5884, 5887, 59, 1, 9183, 101, 116, 59, 1, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9181, 111, 110, 4, 2, 59, 80, 5913, 5915, 1, 8899, 108, 117, 115, 59, 1, 8846, 4, 2, 103, 112, 5927, 5932, 111, 110, 59, 1, 370, 102, 59, 3, 55349, 56652, 4, 8, 65, 68, 69, 84, 97, 100, 112, 115, 5955, 5985, 5996, 6009, 6026, 6033, 6044, 6075, 114, 114, 111, 119, 4, 3, 59, 66, 68, 5967, 5969, 5974, 1, 8593, 97, 114, 59, 1, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10606, 101, 101, 4, 2, 59, 65, 6017, 6019, 1, 8869, 114, 114, 111, 119, 59, 1, 8613, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 4, 2, 76, 82, 6052, 6063, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8599, 105, 4, 2, 59, 108, 6082, 6084, 1, 978, 111, 110, 59, 1, 933, 105, 110, 103, 59, 1, 366, 99, 114, 59, 3, 55349, 56496, 105, 108, 100, 101, 59, 1, 360, 109, 108, 5, 220, 1, 59, 6115, 1, 220, 4, 9, 68, 98, 99, 100, 101, 102, 111, 115, 118, 6137, 6143, 6148, 6152, 6166, 6250, 6255, 6261, 6267, 97, 115, 104, 59, 1, 8875, 97, 114, 59, 1, 10987, 121, 59, 1, 1042, 97, 115, 104, 4, 2, 59, 108, 6161, 6163, 1, 8873, 59, 1, 10982, 4, 2, 101, 114, 6172, 6175, 59, 1, 8897, 4, 3, 98, 116, 121, 6183, 6188, 6238, 97, 114, 59, 1, 8214, 4, 2, 59, 105, 6194, 6196, 1, 8214, 99, 97, 108, 4, 4, 66, 76, 83, 84, 6209, 6214, 6220, 6231, 97, 114, 59, 1, 8739, 105, 110, 101, 59, 1, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 1, 10072, 105, 108, 100, 101, 59, 1, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8202, 114, 59, 3, 55349, 56601, 112, 102, 59, 3, 55349, 56653, 99, 114, 59, 3, 55349, 56497, 100, 97, 115, 104, 59, 1, 8874, 4, 5, 99, 101, 102, 111, 115, 6286, 6292, 6298, 6303, 6309, 105, 114, 99, 59, 1, 372, 100, 103, 101, 59, 1, 8896, 114, 59, 3, 55349, 56602, 112, 102, 59, 3, 55349, 56654, 99, 114, 59, 3, 55349, 56498, 4, 4, 102, 105, 111, 115, 6325, 6330, 6333, 6339, 114, 59, 3, 55349, 56603, 59, 1, 926, 112, 102, 59, 3, 55349, 56655, 99, 114, 59, 3, 55349, 56499, 4, 9, 65, 73, 85, 97, 99, 102, 111, 115, 117, 6365, 6370, 6375, 6380, 6391, 6405, 6410, 6416, 6422, 99, 121, 59, 1, 1071, 99, 121, 59, 1, 1031, 99, 121, 59, 1, 1070, 99, 117, 116, 101, 5, 221, 1, 59, 6389, 1, 221, 4, 2, 105, 121, 6397, 6402, 114, 99, 59, 1, 374, 59, 1, 1067, 114, 59, 3, 55349, 56604, 112, 102, 59, 3, 55349, 56656, 99, 114, 59, 3, 55349, 56500, 109, 108, 59, 1, 376, 4, 8, 72, 97, 99, 100, 101, 102, 111, 115, 6445, 6450, 6457, 6472, 6477, 6501, 6505, 6510, 99, 121, 59, 1, 1046, 99, 117, 116, 101, 59, 1, 377, 4, 2, 97, 121, 6463, 6469, 114, 111, 110, 59, 1, 381, 59, 1, 1047, 111, 116, 59, 1, 379, 4, 2, 114, 116, 6483, 6497, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 1, 8203, 97, 59, 1, 918, 114, 59, 1, 8488, 112, 102, 59, 1, 8484, 99, 114, 59, 3, 55349, 56501, 4, 16, 97, 98, 99, 101, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 119, 6550, 6561, 6568, 6612, 6622, 6634, 6645, 6672, 6699, 6854, 6870, 6923, 6933, 6963, 6974, 6983, 99, 117, 116, 101, 5, 225, 1, 59, 6559, 1, 225, 114, 101, 118, 101, 59, 1, 259, 4, 6, 59, 69, 100, 105, 117, 121, 6582, 6584, 6588, 6591, 6600, 6609, 1, 8766, 59, 3, 8766, 819, 59, 1, 8767, 114, 99, 5, 226, 1, 59, 6598, 1, 226, 116, 101, 5, 180, 1, 59, 6607, 1, 180, 59, 1, 1072, 108, 105, 103, 5, 230, 1, 59, 6620, 1, 230, 4, 2, 59, 114, 6628, 6630, 1, 8289, 59, 3, 55349, 56606, 114, 97, 118, 101, 5, 224, 1, 59, 6643, 1, 224, 4, 2, 101, 112, 6651, 6667, 4, 2, 102, 112, 6657, 6663, 115, 121, 109, 59, 1, 8501, 104, 59, 1, 8501, 104, 97, 59, 1, 945, 4, 2, 97, 112, 6678, 6692, 4, 2, 99, 108, 6684, 6688, 114, 59, 1, 257, 103, 59, 1, 10815, 5, 38, 1, 59, 6697, 1, 38, 4, 2, 100, 103, 6705, 6737, 4, 5, 59, 97, 100, 115, 118, 6717, 6719, 6724, 6727, 6734, 1, 8743, 110, 100, 59, 1, 10837, 59, 1, 10844, 108, 111, 112, 101, 59, 1, 10840, 59, 1, 10842, 4, 7, 59, 101, 108, 109, 114, 115, 122, 6753, 6755, 6758, 6762, 6814, 6835, 6848, 1, 8736, 59, 1, 10660, 101, 59, 1, 8736, 115, 100, 4, 2, 59, 97, 6770, 6772, 1, 8737, 4, 8, 97, 98, 99, 100, 101, 102, 103, 104, 6790, 6793, 6796, 6799, 6802, 6805, 6808, 6811, 59, 1, 10664, 59, 1, 10665, 59, 1, 10666, 59, 1, 10667, 59, 1, 10668, 59, 1, 10669, 59, 1, 10670, 59, 1, 10671, 116, 4, 2, 59, 118, 6821, 6823, 1, 8735, 98, 4, 2, 59, 100, 6830, 6832, 1, 8894, 59, 1, 10653, 4, 2, 112, 116, 6841, 6845, 104, 59, 1, 8738, 59, 1, 197, 97, 114, 114, 59, 1, 9084, 4, 2, 103, 112, 6860, 6865, 111, 110, 59, 1, 261, 102, 59, 3, 55349, 56658, 4, 7, 59, 69, 97, 101, 105, 111, 112, 6886, 6888, 6891, 6897, 6900, 6904, 6908, 1, 8776, 59, 1, 10864, 99, 105, 114, 59, 1, 10863, 59, 1, 8778, 100, 59, 1, 8779, 115, 59, 1, 39, 114, 111, 120, 4, 2, 59, 101, 6917, 6919, 1, 8776, 113, 59, 1, 8778, 105, 110, 103, 5, 229, 1, 59, 6931, 1, 229, 4, 3, 99, 116, 121, 6941, 6946, 6949, 114, 59, 3, 55349, 56502, 59, 1, 42, 109, 112, 4, 2, 59, 101, 6957, 6959, 1, 8776, 113, 59, 1, 8781, 105, 108, 100, 101, 5, 227, 1, 59, 6972, 1, 227, 109, 108, 5, 228, 1, 59, 6981, 1, 228, 4, 2, 99, 105, 6989, 6997, 111, 110, 105, 110, 116, 59, 1, 8755, 110, 116, 59, 1, 10769, 4, 16, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 7036, 7041, 7119, 7135, 7149, 7155, 7219, 7224, 7347, 7354, 7463, 7489, 7786, 7793, 7814, 7866, 111, 116, 59, 1, 10989, 4, 2, 99, 114, 7047, 7094, 107, 4, 4, 99, 101, 112, 115, 7058, 7064, 7073, 7080, 111, 110, 103, 59, 1, 8780, 112, 115, 105, 108, 111, 110, 59, 1, 1014, 114, 105, 109, 101, 59, 1, 8245, 105, 109, 4, 2, 59, 101, 7088, 7090, 1, 8765, 113, 59, 1, 8909, 4, 2, 118, 119, 7100, 7105, 101, 101, 59, 1, 8893, 101, 100, 4, 2, 59, 103, 7113, 7115, 1, 8965, 101, 59, 1, 8965, 114, 107, 4, 2, 59, 116, 7127, 7129, 1, 9141, 98, 114, 107, 59, 1, 9142, 4, 2, 111, 121, 7141, 7146, 110, 103, 59, 1, 8780, 59, 1, 1073, 113, 117, 111, 59, 1, 8222, 4, 5, 99, 109, 112, 114, 116, 7167, 7181, 7188, 7193, 7199, 97, 117, 115, 4, 2, 59, 101, 7176, 7178, 1, 8757, 59, 1, 8757, 112, 116, 121, 118, 59, 1, 10672, 115, 105, 59, 1, 1014, 110, 111, 117, 59, 1, 8492, 4, 3, 97, 104, 119, 7207, 7210, 7213, 59, 1, 946, 59, 1, 8502, 101, 101, 110, 59, 1, 8812, 114, 59, 3, 55349, 56607, 103, 4, 7, 99, 111, 115, 116, 117, 118, 119, 7241, 7262, 7288, 7305, 7328, 7335, 7340, 4, 3, 97, 105, 117, 7249, 7253, 7258, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 4, 3, 100, 112, 116, 7270, 7275, 7281, 111, 116, 59, 1, 10752, 108, 117, 115, 59, 1, 10753, 105, 109, 101, 115, 59, 1, 10754, 4, 2, 113, 116, 7294, 7300, 99, 117, 112, 59, 1, 10758, 97, 114, 59, 1, 9733, 114, 105, 97, 110, 103, 108, 101, 4, 2, 100, 117, 7318, 7324, 111, 119, 110, 59, 1, 9661, 112, 59, 1, 9651, 112, 108, 117, 115, 59, 1, 10756, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 97, 114, 111, 119, 59, 1, 10509, 4, 3, 97, 107, 111, 7362, 7436, 7458, 4, 2, 99, 110, 7368, 7432, 107, 4, 3, 108, 115, 116, 7377, 7386, 7394, 111, 122, 101, 110, 103, 101, 59, 1, 10731, 113, 117, 97, 114, 101, 59, 1, 9642, 114, 105, 97, 110, 103, 108, 101, 4, 4, 59, 100, 108, 114, 7411, 7413, 7419, 7425, 1, 9652, 111, 119, 110, 59, 1, 9662, 101, 102, 116, 59, 1, 9666, 105, 103, 104, 116, 59, 1, 9656, 107, 59, 1, 9251, 4, 2, 49, 51, 7442, 7454, 4, 2, 50, 52, 7448, 7451, 59, 1, 9618, 59, 1, 9617, 52, 59, 1, 9619, 99, 107, 59, 1, 9608, 4, 2, 101, 111, 7469, 7485, 4, 2, 59, 113, 7475, 7478, 3, 61, 8421, 117, 105, 118, 59, 3, 8801, 8421, 116, 59, 1, 8976, 4, 4, 112, 116, 119, 120, 7499, 7504, 7517, 7523, 102, 59, 3, 55349, 56659, 4, 2, 59, 116, 7510, 7512, 1, 8869, 111, 109, 59, 1, 8869, 116, 105, 101, 59, 1, 8904, 4, 12, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7549, 7571, 7597, 7619, 7655, 7660, 7682, 7708, 7715, 7721, 7728, 7750, 4, 4, 76, 82, 108, 114, 7559, 7562, 7565, 7568, 59, 1, 9559, 59, 1, 9556, 59, 1, 9558, 59, 1, 9555, 4, 5, 59, 68, 85, 100, 117, 7583, 7585, 7588, 7591, 7594, 1, 9552, 59, 1, 9574, 59, 1, 9577, 59, 1, 9572, 59, 1, 9575, 4, 4, 76, 82, 108, 114, 7607, 7610, 7613, 7616, 59, 1, 9565, 59, 1, 9562, 59, 1, 9564, 59, 1, 9561, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7635, 7637, 7640, 7643, 7646, 7649, 7652, 1, 9553, 59, 1, 9580, 59, 1, 9571, 59, 1, 9568, 59, 1, 9579, 59, 1, 9570, 59, 1, 9567, 111, 120, 59, 1, 10697, 4, 4, 76, 82, 108, 114, 7670, 7673, 7676, 7679, 59, 1, 9557, 59, 1, 9554, 59, 1, 9488, 59, 1, 9484, 4, 5, 59, 68, 85, 100, 117, 7694, 7696, 7699, 7702, 7705, 1, 9472, 59, 1, 9573, 59, 1, 9576, 59, 1, 9516, 59, 1, 9524, 105, 110, 117, 115, 59, 1, 8863, 108, 117, 115, 59, 1, 8862, 105, 109, 101, 115, 59, 1, 8864, 4, 4, 76, 82, 108, 114, 7738, 7741, 7744, 7747, 59, 1, 9563, 59, 1, 9560, 59, 1, 9496, 59, 1, 9492, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7766, 7768, 7771, 7774, 7777, 7780, 7783, 1, 9474, 59, 1, 9578, 59, 1, 9569, 59, 1, 9566, 59, 1, 9532, 59, 1, 9508, 59, 1, 9500, 114, 105, 109, 101, 59, 1, 8245, 4, 2, 101, 118, 7799, 7804, 118, 101, 59, 1, 728, 98, 97, 114, 5, 166, 1, 59, 7812, 1, 166, 4, 4, 99, 101, 105, 111, 7824, 7829, 7834, 7846, 114, 59, 3, 55349, 56503, 109, 105, 59, 1, 8271, 109, 4, 2, 59, 101, 7841, 7843, 1, 8765, 59, 1, 8909, 108, 4, 3, 59, 98, 104, 7855, 7857, 7860, 1, 92, 59, 1, 10693, 115, 117, 98, 59, 1, 10184, 4, 2, 108, 109, 7872, 7885, 108, 4, 2, 59, 101, 7879, 7881, 1, 8226, 116, 59, 1, 8226, 112, 4, 3, 59, 69, 101, 7894, 7896, 7899, 1, 8782, 59, 1, 10926, 4, 2, 59, 113, 7905, 7907, 1, 8783, 59, 1, 8783, 4, 15, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 116, 117, 119, 121, 7942, 8021, 8075, 8080, 8121, 8126, 8157, 8279, 8295, 8430, 8446, 8485, 8491, 8707, 8726, 4, 3, 99, 112, 114, 7950, 7956, 8007, 117, 116, 101, 59, 1, 263, 4, 6, 59, 97, 98, 99, 100, 115, 7970, 7972, 7977, 7984, 7998, 8003, 1, 8745, 110, 100, 59, 1, 10820, 114, 99, 117, 112, 59, 1, 10825, 4, 2, 97, 117, 7990, 7994, 112, 59, 1, 10827, 112, 59, 1, 10823, 111, 116, 59, 1, 10816, 59, 3, 8745, 65024, 4, 2, 101, 111, 8013, 8017, 116, 59, 1, 8257, 110, 59, 1, 711, 4, 4, 97, 101, 105, 117, 8031, 8046, 8056, 8061, 4, 2, 112, 114, 8037, 8041, 115, 59, 1, 10829, 111, 110, 59, 1, 269, 100, 105, 108, 5, 231, 1, 59, 8054, 1, 231, 114, 99, 59, 1, 265, 112, 115, 4, 2, 59, 115, 8069, 8071, 1, 10828, 109, 59, 1, 10832, 111, 116, 59, 1, 267, 4, 3, 100, 109, 110, 8088, 8097, 8104, 105, 108, 5, 184, 1, 59, 8095, 1, 184, 112, 116, 121, 118, 59, 1, 10674, 116, 5, 162, 2, 59, 101, 8112, 8114, 1, 162, 114, 100, 111, 116, 59, 1, 183, 114, 59, 3, 55349, 56608, 4, 3, 99, 101, 105, 8134, 8138, 8154, 121, 59, 1, 1095, 99, 107, 4, 2, 59, 109, 8146, 8148, 1, 10003, 97, 114, 107, 59, 1, 10003, 59, 1, 967, 114, 4, 7, 59, 69, 99, 101, 102, 109, 115, 8174, 8176, 8179, 8258, 8261, 8268, 8273, 1, 9675, 59, 1, 10691, 4, 3, 59, 101, 108, 8187, 8189, 8193, 1, 710, 113, 59, 1, 8791, 101, 4, 2, 97, 100, 8200, 8223, 114, 114, 111, 119, 4, 2, 108, 114, 8210, 8216, 101, 102, 116, 59, 1, 8634, 105, 103, 104, 116, 59, 1, 8635, 4, 5, 82, 83, 97, 99, 100, 8235, 8238, 8241, 8246, 8252, 59, 1, 174, 59, 1, 9416, 115, 116, 59, 1, 8859, 105, 114, 99, 59, 1, 8858, 97, 115, 104, 59, 1, 8861, 59, 1, 8791, 110, 105, 110, 116, 59, 1, 10768, 105, 100, 59, 1, 10991, 99, 105, 114, 59, 1, 10690, 117, 98, 115, 4, 2, 59, 117, 8288, 8290, 1, 9827, 105, 116, 59, 1, 9827, 4, 4, 108, 109, 110, 112, 8305, 8326, 8376, 8400, 111, 110, 4, 2, 59, 101, 8313, 8315, 1, 58, 4, 2, 59, 113, 8321, 8323, 1, 8788, 59, 1, 8788, 4, 2, 109, 112, 8332, 8344, 97, 4, 2, 59, 116, 8339, 8341, 1, 44, 59, 1, 64, 4, 3, 59, 102, 108, 8352, 8354, 8358, 1, 8705, 110, 59, 1, 8728, 101, 4, 2, 109, 120, 8365, 8371, 101, 110, 116, 59, 1, 8705, 101, 115, 59, 1, 8450, 4, 2, 103, 105, 8382, 8395, 4, 2, 59, 100, 8388, 8390, 1, 8773, 111, 116, 59, 1, 10861, 110, 116, 59, 1, 8750, 4, 3, 102, 114, 121, 8408, 8412, 8417, 59, 3, 55349, 56660, 111, 100, 59, 1, 8720, 5, 169, 2, 59, 115, 8424, 8426, 1, 169, 114, 59, 1, 8471, 4, 2, 97, 111, 8436, 8441, 114, 114, 59, 1, 8629, 115, 115, 59, 1, 10007, 4, 2, 99, 117, 8452, 8457, 114, 59, 3, 55349, 56504, 4, 2, 98, 112, 8463, 8474, 4, 2, 59, 101, 8469, 8471, 1, 10959, 59, 1, 10961, 4, 2, 59, 101, 8480, 8482, 1, 10960, 59, 1, 10962, 100, 111, 116, 59, 1, 8943, 4, 7, 100, 101, 108, 112, 114, 118, 119, 8507, 8522, 8536, 8550, 8600, 8697, 8702, 97, 114, 114, 4, 2, 108, 114, 8516, 8519, 59, 1, 10552, 59, 1, 10549, 4, 2, 112, 115, 8528, 8532, 114, 59, 1, 8926, 99, 59, 1, 8927, 97, 114, 114, 4, 2, 59, 112, 8545, 8547, 1, 8630, 59, 1, 10557, 4, 6, 59, 98, 99, 100, 111, 115, 8564, 8566, 8573, 8587, 8592, 8596, 1, 8746, 114, 99, 97, 112, 59, 1, 10824, 4, 2, 97, 117, 8579, 8583, 112, 59, 1, 10822, 112, 59, 1, 10826, 111, 116, 59, 1, 8845, 114, 59, 1, 10821, 59, 3, 8746, 65024, 4, 4, 97, 108, 114, 118, 8610, 8623, 8663, 8672, 114, 114, 4, 2, 59, 109, 8618, 8620, 1, 8631, 59, 1, 10556, 121, 4, 3, 101, 118, 119, 8632, 8651, 8656, 113, 4, 2, 112, 115, 8639, 8645, 114, 101, 99, 59, 1, 8926, 117, 99, 99, 59, 1, 8927, 101, 101, 59, 1, 8910, 101, 100, 103, 101, 59, 1, 8911, 101, 110, 5, 164, 1, 59, 8670, 1, 164, 101, 97, 114, 114, 111, 119, 4, 2, 108, 114, 8684, 8690, 101, 102, 116, 59, 1, 8630, 105, 103, 104, 116, 59, 1, 8631, 101, 101, 59, 1, 8910, 101, 100, 59, 1, 8911, 4, 2, 99, 105, 8713, 8721, 111, 110, 105, 110, 116, 59, 1, 8754, 110, 116, 59, 1, 8753, 108, 99, 116, 121, 59, 1, 9005, 4, 19, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8773, 8778, 8783, 8821, 8839, 8854, 8887, 8914, 8930, 8944, 9036, 9041, 9058, 9197, 9227, 9258, 9281, 9297, 9305, 114, 114, 59, 1, 8659, 97, 114, 59, 1, 10597, 4, 4, 103, 108, 114, 115, 8793, 8799, 8805, 8809, 103, 101, 114, 59, 1, 8224, 101, 116, 104, 59, 1, 8504, 114, 59, 1, 8595, 104, 4, 2, 59, 118, 8816, 8818, 1, 8208, 59, 1, 8867, 4, 2, 107, 108, 8827, 8834, 97, 114, 111, 119, 59, 1, 10511, 97, 99, 59, 1, 733, 4, 2, 97, 121, 8845, 8851, 114, 111, 110, 59, 1, 271, 59, 1, 1076, 4, 3, 59, 97, 111, 8862, 8864, 8880, 1, 8518, 4, 2, 103, 114, 8870, 8876, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8650, 116, 115, 101, 113, 59, 1, 10871, 4, 3, 103, 108, 109, 8895, 8902, 8907, 5, 176, 1, 59, 8900, 1, 176, 116, 97, 59, 1, 948, 112, 116, 121, 118, 59, 1, 10673, 4, 2, 105, 114, 8920, 8926, 115, 104, 116, 59, 1, 10623, 59, 3, 55349, 56609, 97, 114, 4, 2, 108, 114, 8938, 8941, 59, 1, 8643, 59, 1, 8642, 4, 5, 97, 101, 103, 115, 118, 8956, 8986, 8989, 8996, 9001, 109, 4, 3, 59, 111, 115, 8965, 8967, 8983, 1, 8900, 110, 100, 4, 2, 59, 115, 8975, 8977, 1, 8900, 117, 105, 116, 59, 1, 9830, 59, 1, 9830, 59, 1, 168, 97, 109, 109, 97, 59, 1, 989, 105, 110, 59, 1, 8946, 4, 3, 59, 105, 111, 9009, 9011, 9031, 1, 247, 100, 101, 5, 247, 2, 59, 111, 9020, 9022, 1, 247, 110, 116, 105, 109, 101, 115, 59, 1, 8903, 110, 120, 59, 1, 8903, 99, 121, 59, 1, 1106, 99, 4, 2, 111, 114, 9048, 9053, 114, 110, 59, 1, 8990, 111, 112, 59, 1, 8973, 4, 5, 108, 112, 116, 117, 119, 9070, 9076, 9081, 9130, 9144, 108, 97, 114, 59, 1, 36, 102, 59, 3, 55349, 56661, 4, 5, 59, 101, 109, 112, 115, 9093, 9095, 9109, 9116, 9122, 1, 729, 113, 4, 2, 59, 100, 9102, 9104, 1, 8784, 111, 116, 59, 1, 8785, 105, 110, 117, 115, 59, 1, 8760, 108, 117, 115, 59, 1, 8724, 113, 117, 97, 114, 101, 59, 1, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 1, 8966, 110, 4, 3, 97, 100, 104, 9153, 9160, 9172, 114, 114, 111, 119, 59, 1, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 1, 8650, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 9184, 9190, 101, 102, 116, 59, 1, 8643, 105, 103, 104, 116, 59, 1, 8642, 4, 2, 98, 99, 9203, 9211, 107, 97, 114, 111, 119, 59, 1, 10512, 4, 2, 111, 114, 9217, 9222, 114, 110, 59, 1, 8991, 111, 112, 59, 1, 8972, 4, 3, 99, 111, 116, 9235, 9248, 9252, 4, 2, 114, 121, 9241, 9245, 59, 3, 55349, 56505, 59, 1, 1109, 108, 59, 1, 10742, 114, 111, 107, 59, 1, 273, 4, 2, 100, 114, 9264, 9269, 111, 116, 59, 1, 8945, 105, 4, 2, 59, 102, 9276, 9278, 1, 9663, 59, 1, 9662, 4, 2, 97, 104, 9287, 9292, 114, 114, 59, 1, 8693, 97, 114, 59, 1, 10607, 97, 110, 103, 108, 101, 59, 1, 10662, 4, 2, 99, 105, 9311, 9315, 121, 59, 1, 1119, 103, 114, 97, 114, 114, 59, 1, 10239, 4, 18, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 9361, 9376, 9398, 9439, 9444, 9447, 9462, 9495, 9531, 9585, 9598, 9614, 9659, 9755, 9771, 9792, 9808, 9826, 4, 2, 68, 111, 9367, 9372, 111, 116, 59, 1, 10871, 116, 59, 1, 8785, 4, 2, 99, 115, 9382, 9392, 117, 116, 101, 5, 233, 1, 59, 9390, 1, 233, 116, 101, 114, 59, 1, 10862, 4, 4, 97, 105, 111, 121, 9408, 9414, 9430, 9436, 114, 111, 110, 59, 1, 283, 114, 4, 2, 59, 99, 9421, 9423, 1, 8790, 5, 234, 1, 59, 9428, 1, 234, 108, 111, 110, 59, 1, 8789, 59, 1, 1101, 111, 116, 59, 1, 279, 59, 1, 8519, 4, 2, 68, 114, 9453, 9458, 111, 116, 59, 1, 8786, 59, 3, 55349, 56610, 4, 3, 59, 114, 115, 9470, 9472, 9482, 1, 10906, 97, 118, 101, 5, 232, 1, 59, 9480, 1, 232, 4, 2, 59, 100, 9488, 9490, 1, 10902, 111, 116, 59, 1, 10904, 4, 4, 59, 105, 108, 115, 9505, 9507, 9515, 9518, 1, 10905, 110, 116, 101, 114, 115, 59, 1, 9191, 59, 1, 8467, 4, 2, 59, 100, 9524, 9526, 1, 10901, 111, 116, 59, 1, 10903, 4, 3, 97, 112, 115, 9539, 9544, 9564, 99, 114, 59, 1, 275, 116, 121, 4, 3, 59, 115, 118, 9554, 9556, 9561, 1, 8709, 101, 116, 59, 1, 8709, 59, 1, 8709, 112, 4, 2, 49, 59, 9571, 9583, 4, 2, 51, 52, 9577, 9580, 59, 1, 8196, 59, 1, 8197, 1, 8195, 4, 2, 103, 115, 9591, 9594, 59, 1, 331, 112, 59, 1, 8194, 4, 2, 103, 112, 9604, 9609, 111, 110, 59, 1, 281, 102, 59, 3, 55349, 56662, 4, 3, 97, 108, 115, 9622, 9635, 9640, 114, 4, 2, 59, 115, 9629, 9631, 1, 8917, 108, 59, 1, 10723, 117, 115, 59, 1, 10865, 105, 4, 3, 59, 108, 118, 9649, 9651, 9656, 1, 949, 111, 110, 59, 1, 949, 59, 1, 1013, 4, 4, 99, 115, 117, 118, 9669, 9686, 9716, 9747, 4, 2, 105, 111, 9675, 9680, 114, 99, 59, 1, 8790, 108, 111, 110, 59, 1, 8789, 4, 2, 105, 108, 9692, 9696, 109, 59, 1, 8770, 97, 110, 116, 4, 2, 103, 108, 9705, 9710, 116, 114, 59, 1, 10902, 101, 115, 115, 59, 1, 10901, 4, 3, 97, 101, 105, 9724, 9729, 9734, 108, 115, 59, 1, 61, 115, 116, 59, 1, 8799, 118, 4, 2, 59, 68, 9741, 9743, 1, 8801, 68, 59, 1, 10872, 112, 97, 114, 115, 108, 59, 1, 10725, 4, 2, 68, 97, 9761, 9766, 111, 116, 59, 1, 8787, 114, 114, 59, 1, 10609, 4, 3, 99, 100, 105, 9779, 9783, 9788, 114, 59, 1, 8495, 111, 116, 59, 1, 8784, 109, 59, 1, 8770, 4, 2, 97, 104, 9798, 9801, 59, 1, 951, 5, 240, 1, 59, 9806, 1, 240, 4, 2, 109, 114, 9814, 9822, 108, 5, 235, 1, 59, 9820, 1, 235, 111, 59, 1, 8364, 4, 3, 99, 105, 112, 9834, 9838, 9843, 108, 59, 1, 33, 115, 116, 59, 1, 8707, 4, 2, 101, 111, 9849, 9859, 99, 116, 97, 116, 105, 111, 110, 59, 1, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 1, 8519, 4, 12, 97, 99, 101, 102, 105, 106, 108, 110, 111, 112, 114, 115, 9896, 9910, 9914, 9921, 9954, 9960, 9967, 9989, 9994, 10027, 10036, 10164, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8786, 121, 59, 1, 1092, 109, 97, 108, 101, 59, 1, 9792, 4, 3, 105, 108, 114, 9929, 9935, 9950, 108, 105, 103, 59, 1, 64259, 4, 2, 105, 108, 9941, 9945, 103, 59, 1, 64256, 105, 103, 59, 1, 64260, 59, 3, 55349, 56611, 108, 105, 103, 59, 1, 64257, 108, 105, 103, 59, 3, 102, 106, 4, 3, 97, 108, 116, 9975, 9979, 9984, 116, 59, 1, 9837, 105, 103, 59, 1, 64258, 110, 115, 59, 1, 9649, 111, 102, 59, 1, 402, 4, 2, 112, 114, 1e4, 10005, 102, 59, 3, 55349, 56663, 4, 2, 97, 107, 10011, 10016, 108, 108, 59, 1, 8704, 4, 2, 59, 118, 10022, 10024, 1, 8916, 59, 1, 10969, 97, 114, 116, 105, 110, 116, 59, 1, 10765, 4, 2, 97, 111, 10042, 10159, 4, 2, 99, 115, 10048, 10155, 4, 6, 49, 50, 51, 52, 53, 55, 10062, 10102, 10114, 10135, 10139, 10151, 4, 6, 50, 51, 52, 53, 54, 56, 10076, 10083, 10086, 10093, 10096, 10099, 5, 189, 1, 59, 10081, 1, 189, 59, 1, 8531, 5, 188, 1, 59, 10091, 1, 188, 59, 1, 8533, 59, 1, 8537, 59, 1, 8539, 4, 2, 51, 53, 10108, 10111, 59, 1, 8532, 59, 1, 8534, 4, 3, 52, 53, 56, 10122, 10129, 10132, 5, 190, 1, 59, 10127, 1, 190, 59, 1, 8535, 59, 1, 8540, 53, 59, 1, 8536, 4, 2, 54, 56, 10145, 10148, 59, 1, 8538, 59, 1, 8541, 56, 59, 1, 8542, 108, 59, 1, 8260, 119, 110, 59, 1, 8994, 99, 114, 59, 3, 55349, 56507, 4, 17, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 10206, 10217, 10247, 10254, 10268, 10273, 10358, 10363, 10374, 10380, 10385, 10406, 10458, 10464, 10470, 10497, 10610, 4, 2, 59, 108, 10212, 10214, 1, 8807, 59, 1, 10892, 4, 3, 99, 109, 112, 10225, 10231, 10244, 117, 116, 101, 59, 1, 501, 109, 97, 4, 2, 59, 100, 10239, 10241, 1, 947, 59, 1, 989, 59, 1, 10886, 114, 101, 118, 101, 59, 1, 287, 4, 2, 105, 121, 10260, 10265, 114, 99, 59, 1, 285, 59, 1, 1075, 111, 116, 59, 1, 289, 4, 4, 59, 108, 113, 115, 10283, 10285, 10288, 10308, 1, 8805, 59, 1, 8923, 4, 3, 59, 113, 115, 10296, 10298, 10301, 1, 8805, 59, 1, 8807, 108, 97, 110, 116, 59, 1, 10878, 4, 4, 59, 99, 100, 108, 10318, 10320, 10324, 10345, 1, 10878, 99, 59, 1, 10921, 111, 116, 4, 2, 59, 111, 10332, 10334, 1, 10880, 4, 2, 59, 108, 10340, 10342, 1, 10882, 59, 1, 10884, 4, 2, 59, 101, 10351, 10354, 3, 8923, 65024, 115, 59, 1, 10900, 114, 59, 3, 55349, 56612, 4, 2, 59, 103, 10369, 10371, 1, 8811, 59, 1, 8921, 109, 101, 108, 59, 1, 8503, 99, 121, 59, 1, 1107, 4, 4, 59, 69, 97, 106, 10395, 10397, 10400, 10403, 1, 8823, 59, 1, 10898, 59, 1, 10917, 59, 1, 10916, 4, 4, 69, 97, 101, 115, 10416, 10419, 10434, 10453, 59, 1, 8809, 112, 4, 2, 59, 112, 10426, 10428, 1, 10890, 114, 111, 120, 59, 1, 10890, 4, 2, 59, 113, 10440, 10442, 1, 10888, 4, 2, 59, 113, 10448, 10450, 1, 10888, 59, 1, 8809, 105, 109, 59, 1, 8935, 112, 102, 59, 3, 55349, 56664, 97, 118, 101, 59, 1, 96, 4, 2, 99, 105, 10476, 10480, 114, 59, 1, 8458, 109, 4, 3, 59, 101, 108, 10489, 10491, 10494, 1, 8819, 59, 1, 10894, 59, 1, 10896, 5, 62, 6, 59, 99, 100, 108, 113, 114, 10512, 10514, 10527, 10532, 10538, 10545, 1, 62, 4, 2, 99, 105, 10520, 10523, 59, 1, 10919, 114, 59, 1, 10874, 111, 116, 59, 1, 8919, 80, 97, 114, 59, 1, 10645, 117, 101, 115, 116, 59, 1, 10876, 4, 5, 97, 100, 101, 108, 115, 10557, 10574, 10579, 10599, 10605, 4, 2, 112, 114, 10563, 10570, 112, 114, 111, 120, 59, 1, 10886, 114, 59, 1, 10616, 111, 116, 59, 1, 8919, 113, 4, 2, 108, 113, 10586, 10592, 101, 115, 115, 59, 1, 8923, 108, 101, 115, 115, 59, 1, 10892, 101, 115, 115, 59, 1, 8823, 105, 109, 59, 1, 8819, 4, 2, 101, 110, 10616, 10626, 114, 116, 110, 101, 113, 113, 59, 3, 8809, 65024, 69, 59, 3, 8809, 65024, 4, 10, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 10653, 10658, 10713, 10718, 10724, 10760, 10765, 10786, 10850, 10875, 114, 114, 59, 1, 8660, 4, 4, 105, 108, 109, 114, 10668, 10674, 10678, 10684, 114, 115, 112, 59, 1, 8202, 102, 59, 1, 189, 105, 108, 116, 59, 1, 8459, 4, 2, 100, 114, 10690, 10695, 99, 121, 59, 1, 1098, 4, 3, 59, 99, 119, 10703, 10705, 10710, 1, 8596, 105, 114, 59, 1, 10568, 59, 1, 8621, 97, 114, 59, 1, 8463, 105, 114, 99, 59, 1, 293, 4, 3, 97, 108, 114, 10732, 10748, 10754, 114, 116, 115, 4, 2, 59, 117, 10741, 10743, 1, 9829, 105, 116, 59, 1, 9829, 108, 105, 112, 59, 1, 8230, 99, 111, 110, 59, 1, 8889, 114, 59, 3, 55349, 56613, 115, 4, 2, 101, 119, 10772, 10779, 97, 114, 111, 119, 59, 1, 10533, 97, 114, 111, 119, 59, 1, 10534, 4, 5, 97, 109, 111, 112, 114, 10798, 10803, 10809, 10839, 10844, 114, 114, 59, 1, 8703, 116, 104, 116, 59, 1, 8763, 107, 4, 2, 108, 114, 10816, 10827, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8618, 102, 59, 3, 55349, 56665, 98, 97, 114, 59, 1, 8213, 4, 3, 99, 108, 116, 10858, 10863, 10869, 114, 59, 3, 55349, 56509, 97, 115, 104, 59, 1, 8463, 114, 111, 107, 59, 1, 295, 4, 2, 98, 112, 10881, 10887, 117, 108, 108, 59, 1, 8259, 104, 101, 110, 59, 1, 8208, 4, 15, 97, 99, 101, 102, 103, 105, 106, 109, 110, 111, 112, 113, 115, 116, 117, 10925, 10936, 10958, 10977, 10990, 11001, 11039, 11045, 11101, 11192, 11220, 11226, 11237, 11285, 11299, 99, 117, 116, 101, 5, 237, 1, 59, 10934, 1, 237, 4, 3, 59, 105, 121, 10944, 10946, 10955, 1, 8291, 114, 99, 5, 238, 1, 59, 10953, 1, 238, 59, 1, 1080, 4, 2, 99, 120, 10964, 10968, 121, 59, 1, 1077, 99, 108, 5, 161, 1, 59, 10975, 1, 161, 4, 2, 102, 114, 10983, 10986, 59, 1, 8660, 59, 3, 55349, 56614, 114, 97, 118, 101, 5, 236, 1, 59, 10999, 1, 236, 4, 4, 59, 105, 110, 111, 11011, 11013, 11028, 11034, 1, 8520, 4, 2, 105, 110, 11019, 11024, 110, 116, 59, 1, 10764, 116, 59, 1, 8749, 102, 105, 110, 59, 1, 10716, 116, 97, 59, 1, 8489, 108, 105, 103, 59, 1, 307, 4, 3, 97, 111, 112, 11053, 11092, 11096, 4, 3, 99, 103, 116, 11061, 11065, 11088, 114, 59, 1, 299, 4, 3, 101, 108, 112, 11073, 11076, 11082, 59, 1, 8465, 105, 110, 101, 59, 1, 8464, 97, 114, 116, 59, 1, 8465, 104, 59, 1, 305, 102, 59, 1, 8887, 101, 100, 59, 1, 437, 4, 5, 59, 99, 102, 111, 116, 11113, 11115, 11121, 11136, 11142, 1, 8712, 97, 114, 101, 59, 1, 8453, 105, 110, 4, 2, 59, 116, 11129, 11131, 1, 8734, 105, 101, 59, 1, 10717, 100, 111, 116, 59, 1, 305, 4, 5, 59, 99, 101, 108, 112, 11154, 11156, 11161, 11179, 11186, 1, 8747, 97, 108, 59, 1, 8890, 4, 2, 103, 114, 11167, 11173, 101, 114, 115, 59, 1, 8484, 99, 97, 108, 59, 1, 8890, 97, 114, 104, 107, 59, 1, 10775, 114, 111, 100, 59, 1, 10812, 4, 4, 99, 103, 112, 116, 11202, 11206, 11211, 11216, 121, 59, 1, 1105, 111, 110, 59, 1, 303, 102, 59, 3, 55349, 56666, 97, 59, 1, 953, 114, 111, 100, 59, 1, 10812, 117, 101, 115, 116, 5, 191, 1, 59, 11235, 1, 191, 4, 2, 99, 105, 11243, 11248, 114, 59, 3, 55349, 56510, 110, 4, 5, 59, 69, 100, 115, 118, 11261, 11263, 11266, 11271, 11282, 1, 8712, 59, 1, 8953, 111, 116, 59, 1, 8949, 4, 2, 59, 118, 11277, 11279, 1, 8948, 59, 1, 8947, 59, 1, 8712, 4, 2, 59, 105, 11291, 11293, 1, 8290, 108, 100, 101, 59, 1, 297, 4, 2, 107, 109, 11305, 11310, 99, 121, 59, 1, 1110, 108, 5, 239, 1, 59, 11316, 1, 239, 4, 6, 99, 102, 109, 111, 115, 117, 11332, 11346, 11351, 11357, 11363, 11380, 4, 2, 105, 121, 11338, 11343, 114, 99, 59, 1, 309, 59, 1, 1081, 114, 59, 3, 55349, 56615, 97, 116, 104, 59, 1, 567, 112, 102, 59, 3, 55349, 56667, 4, 2, 99, 101, 11369, 11374, 114, 59, 3, 55349, 56511, 114, 99, 121, 59, 1, 1112, 107, 99, 121, 59, 1, 1108, 4, 8, 97, 99, 102, 103, 104, 106, 111, 115, 11404, 11418, 11433, 11438, 11445, 11450, 11455, 11461, 112, 112, 97, 4, 2, 59, 118, 11413, 11415, 1, 954, 59, 1, 1008, 4, 2, 101, 121, 11424, 11430, 100, 105, 108, 59, 1, 311, 59, 1, 1082, 114, 59, 3, 55349, 56616, 114, 101, 101, 110, 59, 1, 312, 99, 121, 59, 1, 1093, 99, 121, 59, 1, 1116, 112, 102, 59, 3, 55349, 56668, 99, 114, 59, 3, 55349, 56512, 4, 23, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 11515, 11538, 11544, 11555, 11560, 11721, 11780, 11818, 11868, 12136, 12160, 12171, 12203, 12208, 12246, 12275, 12327, 12509, 12523, 12569, 12641, 12732, 12752, 4, 3, 97, 114, 116, 11523, 11528, 11532, 114, 114, 59, 1, 8666, 114, 59, 1, 8656, 97, 105, 108, 59, 1, 10523, 97, 114, 114, 59, 1, 10510, 4, 2, 59, 103, 11550, 11552, 1, 8806, 59, 1, 10891, 97, 114, 59, 1, 10594, 4, 9, 99, 101, 103, 109, 110, 112, 113, 114, 116, 11580, 11586, 11594, 11600, 11606, 11624, 11627, 11636, 11694, 117, 116, 101, 59, 1, 314, 109, 112, 116, 121, 118, 59, 1, 10676, 114, 97, 110, 59, 1, 8466, 98, 100, 97, 59, 1, 955, 103, 4, 3, 59, 100, 108, 11615, 11617, 11620, 1, 10216, 59, 1, 10641, 101, 59, 1, 10216, 59, 1, 10885, 117, 111, 5, 171, 1, 59, 11634, 1, 171, 114, 4, 8, 59, 98, 102, 104, 108, 112, 115, 116, 11655, 11657, 11669, 11673, 11677, 11681, 11685, 11690, 1, 8592, 4, 2, 59, 102, 11663, 11665, 1, 8676, 115, 59, 1, 10527, 115, 59, 1, 10525, 107, 59, 1, 8617, 112, 59, 1, 8619, 108, 59, 1, 10553, 105, 109, 59, 1, 10611, 108, 59, 1, 8610, 4, 3, 59, 97, 101, 11702, 11704, 11709, 1, 10923, 105, 108, 59, 1, 10521, 4, 2, 59, 115, 11715, 11717, 1, 10925, 59, 3, 10925, 65024, 4, 3, 97, 98, 114, 11729, 11734, 11739, 114, 114, 59, 1, 10508, 114, 107, 59, 1, 10098, 4, 2, 97, 107, 11745, 11758, 99, 4, 2, 101, 107, 11752, 11755, 59, 1, 123, 59, 1, 91, 4, 2, 101, 115, 11764, 11767, 59, 1, 10635, 108, 4, 2, 100, 117, 11774, 11777, 59, 1, 10639, 59, 1, 10637, 4, 4, 97, 101, 117, 121, 11790, 11796, 11811, 11815, 114, 111, 110, 59, 1, 318, 4, 2, 100, 105, 11802, 11807, 105, 108, 59, 1, 316, 108, 59, 1, 8968, 98, 59, 1, 123, 59, 1, 1083, 4, 4, 99, 113, 114, 115, 11828, 11832, 11845, 11864, 97, 59, 1, 10550, 117, 111, 4, 2, 59, 114, 11840, 11842, 1, 8220, 59, 1, 8222, 4, 2, 100, 117, 11851, 11857, 104, 97, 114, 59, 1, 10599, 115, 104, 97, 114, 59, 1, 10571, 104, 59, 1, 8626, 4, 5, 59, 102, 103, 113, 115, 11880, 11882, 12008, 12011, 12031, 1, 8804, 116, 4, 5, 97, 104, 108, 114, 116, 11895, 11913, 11935, 11947, 11996, 114, 114, 111, 119, 4, 2, 59, 116, 11905, 11907, 1, 8592, 97, 105, 108, 59, 1, 8610, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 11925, 11931, 111, 119, 110, 59, 1, 8637, 112, 59, 1, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8647, 105, 103, 104, 116, 4, 3, 97, 104, 115, 11959, 11974, 11984, 114, 114, 111, 119, 4, 2, 59, 115, 11969, 11971, 1, 8596, 59, 1, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8907, 59, 1, 8922, 4, 3, 59, 113, 115, 12019, 12021, 12024, 1, 8804, 59, 1, 8806, 108, 97, 110, 116, 59, 1, 10877, 4, 5, 59, 99, 100, 103, 115, 12043, 12045, 12049, 12070, 12083, 1, 10877, 99, 59, 1, 10920, 111, 116, 4, 2, 59, 111, 12057, 12059, 1, 10879, 4, 2, 59, 114, 12065, 12067, 1, 10881, 59, 1, 10883, 4, 2, 59, 101, 12076, 12079, 3, 8922, 65024, 115, 59, 1, 10899, 4, 5, 97, 100, 101, 103, 115, 12095, 12103, 12108, 12126, 12131, 112, 112, 114, 111, 120, 59, 1, 10885, 111, 116, 59, 1, 8918, 113, 4, 2, 103, 113, 12115, 12120, 116, 114, 59, 1, 8922, 103, 116, 114, 59, 1, 10891, 116, 114, 59, 1, 8822, 105, 109, 59, 1, 8818, 4, 3, 105, 108, 114, 12144, 12150, 12156, 115, 104, 116, 59, 1, 10620, 111, 111, 114, 59, 1, 8970, 59, 3, 55349, 56617, 4, 2, 59, 69, 12166, 12168, 1, 8822, 59, 1, 10897, 4, 2, 97, 98, 12177, 12198, 114, 4, 2, 100, 117, 12184, 12187, 59, 1, 8637, 4, 2, 59, 108, 12193, 12195, 1, 8636, 59, 1, 10602, 108, 107, 59, 1, 9604, 99, 121, 59, 1, 1113, 4, 5, 59, 97, 99, 104, 116, 12220, 12222, 12227, 12235, 12241, 1, 8810, 114, 114, 59, 1, 8647, 111, 114, 110, 101, 114, 59, 1, 8990, 97, 114, 100, 59, 1, 10603, 114, 105, 59, 1, 9722, 4, 2, 105, 111, 12252, 12258, 100, 111, 116, 59, 1, 320, 117, 115, 116, 4, 2, 59, 97, 12267, 12269, 1, 9136, 99, 104, 101, 59, 1, 9136, 4, 4, 69, 97, 101, 115, 12285, 12288, 12303, 12322, 59, 1, 8808, 112, 4, 2, 59, 112, 12295, 12297, 1, 10889, 114, 111, 120, 59, 1, 10889, 4, 2, 59, 113, 12309, 12311, 1, 10887, 4, 2, 59, 113, 12317, 12319, 1, 10887, 59, 1, 8808, 105, 109, 59, 1, 8934, 4, 8, 97, 98, 110, 111, 112, 116, 119, 122, 12345, 12359, 12364, 12421, 12446, 12467, 12474, 12490, 4, 2, 110, 114, 12351, 12355, 103, 59, 1, 10220, 114, 59, 1, 8701, 114, 107, 59, 1, 10214, 103, 4, 3, 108, 109, 114, 12373, 12401, 12409, 101, 102, 116, 4, 2, 97, 114, 12382, 12389, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10231, 97, 112, 115, 116, 111, 59, 1, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10230, 112, 97, 114, 114, 111, 119, 4, 2, 108, 114, 12433, 12439, 101, 102, 116, 59, 1, 8619, 105, 103, 104, 116, 59, 1, 8620, 4, 3, 97, 102, 108, 12454, 12458, 12462, 114, 59, 1, 10629, 59, 3, 55349, 56669, 117, 115, 59, 1, 10797, 105, 109, 101, 115, 59, 1, 10804, 4, 2, 97, 98, 12480, 12485, 115, 116, 59, 1, 8727, 97, 114, 59, 1, 95, 4, 3, 59, 101, 102, 12498, 12500, 12506, 1, 9674, 110, 103, 101, 59, 1, 9674, 59, 1, 10731, 97, 114, 4, 2, 59, 108, 12517, 12519, 1, 40, 116, 59, 1, 10643, 4, 5, 97, 99, 104, 109, 116, 12535, 12540, 12548, 12561, 12564, 114, 114, 59, 1, 8646, 111, 114, 110, 101, 114, 59, 1, 8991, 97, 114, 4, 2, 59, 100, 12556, 12558, 1, 8651, 59, 1, 10605, 59, 1, 8206, 114, 105, 59, 1, 8895, 4, 6, 97, 99, 104, 105, 113, 116, 12583, 12589, 12594, 12597, 12614, 12635, 113, 117, 111, 59, 1, 8249, 114, 59, 3, 55349, 56513, 59, 1, 8624, 109, 4, 3, 59, 101, 103, 12606, 12608, 12611, 1, 8818, 59, 1, 10893, 59, 1, 10895, 4, 2, 98, 117, 12620, 12623, 59, 1, 91, 111, 4, 2, 59, 114, 12630, 12632, 1, 8216, 59, 1, 8218, 114, 111, 107, 59, 1, 322, 5, 60, 8, 59, 99, 100, 104, 105, 108, 113, 114, 12660, 12662, 12675, 12680, 12686, 12692, 12698, 12705, 1, 60, 4, 2, 99, 105, 12668, 12671, 59, 1, 10918, 114, 59, 1, 10873, 111, 116, 59, 1, 8918, 114, 101, 101, 59, 1, 8907, 109, 101, 115, 59, 1, 8905, 97, 114, 114, 59, 1, 10614, 117, 101, 115, 116, 59, 1, 10875, 4, 2, 80, 105, 12711, 12716, 97, 114, 59, 1, 10646, 4, 3, 59, 101, 102, 12724, 12726, 12729, 1, 9667, 59, 1, 8884, 59, 1, 9666, 114, 4, 2, 100, 117, 12739, 12746, 115, 104, 97, 114, 59, 1, 10570, 104, 97, 114, 59, 1, 10598, 4, 2, 101, 110, 12758, 12768, 114, 116, 110, 101, 113, 113, 59, 3, 8808, 65024, 69, 59, 3, 8808, 65024, 4, 14, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 12803, 12809, 12893, 12908, 12914, 12928, 12933, 12937, 13011, 13025, 13032, 13049, 13052, 13069, 68, 111, 116, 59, 1, 8762, 4, 4, 99, 108, 112, 114, 12819, 12827, 12849, 12887, 114, 5, 175, 1, 59, 12825, 1, 175, 4, 2, 101, 116, 12833, 12836, 59, 1, 9794, 4, 2, 59, 101, 12842, 12844, 1, 10016, 115, 101, 59, 1, 10016, 4, 2, 59, 115, 12855, 12857, 1, 8614, 116, 111, 4, 4, 59, 100, 108, 117, 12869, 12871, 12877, 12883, 1, 8614, 111, 119, 110, 59, 1, 8615, 101, 102, 116, 59, 1, 8612, 112, 59, 1, 8613, 107, 101, 114, 59, 1, 9646, 4, 2, 111, 121, 12899, 12905, 109, 109, 97, 59, 1, 10793, 59, 1, 1084, 97, 115, 104, 59, 1, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 1, 8737, 114, 59, 3, 55349, 56618, 111, 59, 1, 8487, 4, 3, 99, 100, 110, 12945, 12954, 12985, 114, 111, 5, 181, 1, 59, 12952, 1, 181, 4, 4, 59, 97, 99, 100, 12964, 12966, 12971, 12976, 1, 8739, 115, 116, 59, 1, 42, 105, 114, 59, 1, 10992, 111, 116, 5, 183, 1, 59, 12983, 1, 183, 117, 115, 4, 3, 59, 98, 100, 12995, 12997, 13e3, 1, 8722, 59, 1, 8863, 4, 2, 59, 117, 13006, 13008, 1, 8760, 59, 1, 10794, 4, 2, 99, 100, 13017, 13021, 112, 59, 1, 10971, 114, 59, 1, 8230, 112, 108, 117, 115, 59, 1, 8723, 4, 2, 100, 112, 13038, 13044, 101, 108, 115, 59, 1, 8871, 102, 59, 3, 55349, 56670, 59, 1, 8723, 4, 2, 99, 116, 13058, 13063, 114, 59, 3, 55349, 56514, 112, 111, 115, 59, 1, 8766, 4, 3, 59, 108, 109, 13077, 13079, 13087, 1, 956, 116, 105, 109, 97, 112, 59, 1, 8888, 97, 112, 59, 1, 8888, 4, 24, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 13142, 13165, 13217, 13229, 13247, 13330, 13359, 13414, 13420, 13508, 13513, 13579, 13602, 13626, 13631, 13762, 13767, 13855, 13936, 13995, 14214, 14285, 14312, 14432, 4, 2, 103, 116, 13148, 13152, 59, 3, 8921, 824, 4, 2, 59, 118, 13158, 13161, 3, 8811, 8402, 59, 3, 8811, 824, 4, 3, 101, 108, 116, 13173, 13200, 13204, 102, 116, 4, 2, 97, 114, 13181, 13188, 114, 114, 111, 119, 59, 1, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8654, 59, 3, 8920, 824, 4, 2, 59, 118, 13210, 13213, 3, 8810, 8402, 59, 3, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8655, 4, 2, 68, 100, 13235, 13241, 97, 115, 104, 59, 1, 8879, 97, 115, 104, 59, 1, 8878, 4, 5, 98, 99, 110, 112, 116, 13259, 13264, 13270, 13275, 13308, 108, 97, 59, 1, 8711, 117, 116, 101, 59, 1, 324, 103, 59, 3, 8736, 8402, 4, 5, 59, 69, 105, 111, 112, 13287, 13289, 13293, 13298, 13302, 1, 8777, 59, 3, 10864, 824, 100, 59, 3, 8779, 824, 115, 59, 1, 329, 114, 111, 120, 59, 1, 8777, 117, 114, 4, 2, 59, 97, 13316, 13318, 1, 9838, 108, 4, 2, 59, 115, 13325, 13327, 1, 9838, 59, 1, 8469, 4, 2, 115, 117, 13336, 13344, 112, 5, 160, 1, 59, 13342, 1, 160, 109, 112, 4, 2, 59, 101, 13352, 13355, 3, 8782, 824, 59, 3, 8783, 824, 4, 5, 97, 101, 111, 117, 121, 13371, 13385, 13391, 13407, 13411, 4, 2, 112, 114, 13377, 13380, 59, 1, 10819, 111, 110, 59, 1, 328, 100, 105, 108, 59, 1, 326, 110, 103, 4, 2, 59, 100, 13399, 13401, 1, 8775, 111, 116, 59, 3, 10861, 824, 112, 59, 1, 10818, 59, 1, 1085, 97, 115, 104, 59, 1, 8211, 4, 7, 59, 65, 97, 100, 113, 115, 120, 13436, 13438, 13443, 13466, 13472, 13478, 13494, 1, 8800, 114, 114, 59, 1, 8663, 114, 4, 2, 104, 114, 13450, 13454, 107, 59, 1, 10532, 4, 2, 59, 111, 13460, 13462, 1, 8599, 119, 59, 1, 8599, 111, 116, 59, 3, 8784, 824, 117, 105, 118, 59, 1, 8802, 4, 2, 101, 105, 13484, 13489, 97, 114, 59, 1, 10536, 109, 59, 3, 8770, 824, 105, 115, 116, 4, 2, 59, 115, 13503, 13505, 1, 8708, 59, 1, 8708, 114, 59, 3, 55349, 56619, 4, 4, 69, 101, 115, 116, 13523, 13527, 13563, 13568, 59, 3, 8807, 824, 4, 3, 59, 113, 115, 13535, 13537, 13559, 1, 8817, 4, 3, 59, 113, 115, 13545, 13547, 13551, 1, 8817, 59, 3, 8807, 824, 108, 97, 110, 116, 59, 3, 10878, 824, 59, 3, 10878, 824, 105, 109, 59, 1, 8821, 4, 2, 59, 114, 13574, 13576, 1, 8815, 59, 1, 8815, 4, 3, 65, 97, 112, 13587, 13592, 13597, 114, 114, 59, 1, 8654, 114, 114, 59, 1, 8622, 97, 114, 59, 1, 10994, 4, 3, 59, 115, 118, 13610, 13612, 13623, 1, 8715, 4, 2, 59, 100, 13618, 13620, 1, 8956, 59, 1, 8954, 59, 1, 8715, 99, 121, 59, 1, 1114, 4, 7, 65, 69, 97, 100, 101, 115, 116, 13647, 13652, 13656, 13661, 13665, 13737, 13742, 114, 114, 59, 1, 8653, 59, 3, 8806, 824, 114, 114, 59, 1, 8602, 114, 59, 1, 8229, 4, 4, 59, 102, 113, 115, 13675, 13677, 13703, 13725, 1, 8816, 116, 4, 2, 97, 114, 13684, 13691, 114, 114, 111, 119, 59, 1, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8622, 4, 3, 59, 113, 115, 13711, 13713, 13717, 1, 8816, 59, 3, 8806, 824, 108, 97, 110, 116, 59, 3, 10877, 824, 4, 2, 59, 115, 13731, 13734, 3, 10877, 824, 59, 1, 8814, 105, 109, 59, 1, 8820, 4, 2, 59, 114, 13748, 13750, 1, 8814, 105, 4, 2, 59, 101, 13757, 13759, 1, 8938, 59, 1, 8940, 105, 100, 59, 1, 8740, 4, 2, 112, 116, 13773, 13778, 102, 59, 3, 55349, 56671, 5, 172, 3, 59, 105, 110, 13787, 13789, 13829, 1, 172, 110, 4, 4, 59, 69, 100, 118, 13800, 13802, 13806, 13812, 1, 8713, 59, 3, 8953, 824, 111, 116, 59, 3, 8949, 824, 4, 3, 97, 98, 99, 13820, 13823, 13826, 59, 1, 8713, 59, 1, 8951, 59, 1, 8950, 105, 4, 2, 59, 118, 13836, 13838, 1, 8716, 4, 3, 97, 98, 99, 13846, 13849, 13852, 59, 1, 8716, 59, 1, 8958, 59, 1, 8957, 4, 3, 97, 111, 114, 13863, 13892, 13899, 114, 4, 4, 59, 97, 115, 116, 13874, 13876, 13883, 13888, 1, 8742, 108, 108, 101, 108, 59, 1, 8742, 108, 59, 3, 11005, 8421, 59, 3, 8706, 824, 108, 105, 110, 116, 59, 1, 10772, 4, 3, 59, 99, 101, 13907, 13909, 13914, 1, 8832, 117, 101, 59, 1, 8928, 4, 2, 59, 99, 13920, 13923, 3, 10927, 824, 4, 2, 59, 101, 13929, 13931, 1, 8832, 113, 59, 3, 10927, 824, 4, 4, 65, 97, 105, 116, 13946, 13951, 13971, 13982, 114, 114, 59, 1, 8655, 114, 114, 4, 3, 59, 99, 119, 13961, 13963, 13967, 1, 8603, 59, 3, 10547, 824, 59, 3, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8603, 114, 105, 4, 2, 59, 101, 13990, 13992, 1, 8939, 59, 1, 8941, 4, 7, 99, 104, 105, 109, 112, 113, 117, 14011, 14036, 14060, 14080, 14085, 14090, 14106, 4, 4, 59, 99, 101, 114, 14021, 14023, 14028, 14032, 1, 8833, 117, 101, 59, 1, 8929, 59, 3, 10928, 824, 59, 3, 55349, 56515, 111, 114, 116, 4, 2, 109, 112, 14045, 14050, 105, 100, 59, 1, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8742, 109, 4, 2, 59, 101, 14067, 14069, 1, 8769, 4, 2, 59, 113, 14075, 14077, 1, 8772, 59, 1, 8772, 105, 100, 59, 1, 8740, 97, 114, 59, 1, 8742, 115, 117, 4, 2, 98, 112, 14098, 14102, 101, 59, 1, 8930, 101, 59, 1, 8931, 4, 3, 98, 99, 112, 14114, 14157, 14171, 4, 4, 59, 69, 101, 115, 14124, 14126, 14130, 14133, 1, 8836, 59, 3, 10949, 824, 59, 1, 8840, 101, 116, 4, 2, 59, 101, 14141, 14144, 3, 8834, 8402, 113, 4, 2, 59, 113, 14151, 14153, 1, 8840, 59, 3, 10949, 824, 99, 4, 2, 59, 101, 14164, 14166, 1, 8833, 113, 59, 3, 10928, 824, 4, 4, 59, 69, 101, 115, 14181, 14183, 14187, 14190, 1, 8837, 59, 3, 10950, 824, 59, 1, 8841, 101, 116, 4, 2, 59, 101, 14198, 14201, 3, 8835, 8402, 113, 4, 2, 59, 113, 14208, 14210, 1, 8841, 59, 3, 10950, 824, 4, 4, 103, 105, 108, 114, 14224, 14228, 14238, 14242, 108, 59, 1, 8825, 108, 100, 101, 5, 241, 1, 59, 14236, 1, 241, 103, 59, 1, 8824, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 14254, 14269, 101, 102, 116, 4, 2, 59, 101, 14263, 14265, 1, 8938, 113, 59, 1, 8940, 105, 103, 104, 116, 4, 2, 59, 101, 14279, 14281, 1, 8939, 113, 59, 1, 8941, 4, 2, 59, 109, 14291, 14293, 1, 957, 4, 3, 59, 101, 115, 14301, 14303, 14308, 1, 35, 114, 111, 59, 1, 8470, 112, 59, 1, 8199, 4, 9, 68, 72, 97, 100, 103, 105, 108, 114, 115, 14332, 14338, 14344, 14349, 14355, 14369, 14376, 14408, 14426, 97, 115, 104, 59, 1, 8877, 97, 114, 114, 59, 1, 10500, 112, 59, 3, 8781, 8402, 97, 115, 104, 59, 1, 8876, 4, 2, 101, 116, 14361, 14365, 59, 3, 8805, 8402, 59, 3, 62, 8402, 110, 102, 105, 110, 59, 1, 10718, 4, 3, 65, 101, 116, 14384, 14389, 14393, 114, 114, 59, 1, 10498, 59, 3, 8804, 8402, 4, 2, 59, 114, 14399, 14402, 3, 60, 8402, 105, 101, 59, 3, 8884, 8402, 4, 2, 65, 116, 14414, 14419, 114, 114, 59, 1, 10499, 114, 105, 101, 59, 3, 8885, 8402, 105, 109, 59, 3, 8764, 8402, 4, 3, 65, 97, 110, 14440, 14445, 14468, 114, 114, 59, 1, 8662, 114, 4, 2, 104, 114, 14452, 14456, 107, 59, 1, 10531, 4, 2, 59, 111, 14462, 14464, 1, 8598, 119, 59, 1, 8598, 101, 97, 114, 59, 1, 10535, 4, 18, 83, 97, 99, 100, 101, 102, 103, 104, 105, 108, 109, 111, 112, 114, 115, 116, 117, 118, 14512, 14515, 14535, 14560, 14597, 14603, 14618, 14643, 14657, 14662, 14701, 14741, 14747, 14769, 14851, 14877, 14907, 14916, 59, 1, 9416, 4, 2, 99, 115, 14521, 14531, 117, 116, 101, 5, 243, 1, 59, 14529, 1, 243, 116, 59, 1, 8859, 4, 2, 105, 121, 14541, 14557, 114, 4, 2, 59, 99, 14548, 14550, 1, 8858, 5, 244, 1, 59, 14555, 1, 244, 59, 1, 1086, 4, 5, 97, 98, 105, 111, 115, 14572, 14577, 14583, 14587, 14591, 115, 104, 59, 1, 8861, 108, 97, 99, 59, 1, 337, 118, 59, 1, 10808, 116, 59, 1, 8857, 111, 108, 100, 59, 1, 10684, 108, 105, 103, 59, 1, 339, 4, 2, 99, 114, 14609, 14614, 105, 114, 59, 1, 10687, 59, 3, 55349, 56620, 4, 3, 111, 114, 116, 14626, 14630, 14640, 110, 59, 1, 731, 97, 118, 101, 5, 242, 1, 59, 14638, 1, 242, 59, 1, 10689, 4, 2, 98, 109, 14649, 14654, 97, 114, 59, 1, 10677, 59, 1, 937, 110, 116, 59, 1, 8750, 4, 4, 97, 99, 105, 116, 14672, 14677, 14693, 14698, 114, 114, 59, 1, 8634, 4, 2, 105, 114, 14683, 14687, 114, 59, 1, 10686, 111, 115, 115, 59, 1, 10683, 110, 101, 59, 1, 8254, 59, 1, 10688, 4, 3, 97, 101, 105, 14709, 14714, 14719, 99, 114, 59, 1, 333, 103, 97, 59, 1, 969, 4, 3, 99, 100, 110, 14727, 14733, 14736, 114, 111, 110, 59, 1, 959, 59, 1, 10678, 117, 115, 59, 1, 8854, 112, 102, 59, 3, 55349, 56672, 4, 3, 97, 101, 108, 14755, 14759, 14764, 114, 59, 1, 10679, 114, 112, 59, 1, 10681, 117, 115, 59, 1, 8853, 4, 7, 59, 97, 100, 105, 111, 115, 118, 14785, 14787, 14792, 14831, 14837, 14841, 14848, 1, 8744, 114, 114, 59, 1, 8635, 4, 4, 59, 101, 102, 109, 14802, 14804, 14817, 14824, 1, 10845, 114, 4, 2, 59, 111, 14811, 14813, 1, 8500, 102, 59, 1, 8500, 5, 170, 1, 59, 14822, 1, 170, 5, 186, 1, 59, 14829, 1, 186, 103, 111, 102, 59, 1, 8886, 114, 59, 1, 10838, 108, 111, 112, 101, 59, 1, 10839, 59, 1, 10843, 4, 3, 99, 108, 111, 14859, 14863, 14873, 114, 59, 1, 8500, 97, 115, 104, 5, 248, 1, 59, 14871, 1, 248, 108, 59, 1, 8856, 105, 4, 2, 108, 109, 14884, 14893, 100, 101, 5, 245, 1, 59, 14891, 1, 245, 101, 115, 4, 2, 59, 97, 14901, 14903, 1, 8855, 115, 59, 1, 10806, 109, 108, 5, 246, 1, 59, 14914, 1, 246, 98, 97, 114, 59, 1, 9021, 4, 12, 97, 99, 101, 102, 104, 105, 108, 109, 111, 114, 115, 117, 14948, 14992, 14996, 15033, 15038, 15068, 15090, 15189, 15192, 15222, 15427, 15441, 114, 4, 4, 59, 97, 115, 116, 14959, 14961, 14976, 14989, 1, 8741, 5, 182, 2, 59, 108, 14968, 14970, 1, 182, 108, 101, 108, 59, 1, 8741, 4, 2, 105, 108, 14982, 14986, 109, 59, 1, 10995, 59, 1, 11005, 59, 1, 8706, 121, 59, 1, 1087, 114, 4, 5, 99, 105, 109, 112, 116, 15009, 15014, 15019, 15024, 15027, 110, 116, 59, 1, 37, 111, 100, 59, 1, 46, 105, 108, 59, 1, 8240, 59, 1, 8869, 101, 110, 107, 59, 1, 8241, 114, 59, 3, 55349, 56621, 4, 3, 105, 109, 111, 15046, 15057, 15063, 4, 2, 59, 118, 15052, 15054, 1, 966, 59, 1, 981, 109, 97, 116, 59, 1, 8499, 110, 101, 59, 1, 9742, 4, 3, 59, 116, 118, 15076, 15078, 15087, 1, 960, 99, 104, 102, 111, 114, 107, 59, 1, 8916, 59, 1, 982, 4, 2, 97, 117, 15096, 15119, 110, 4, 2, 99, 107, 15103, 15115, 107, 4, 2, 59, 104, 15110, 15112, 1, 8463, 59, 1, 8462, 118, 59, 1, 8463, 115, 4, 9, 59, 97, 98, 99, 100, 101, 109, 115, 116, 15140, 15142, 15148, 15151, 15156, 15168, 15171, 15179, 15184, 1, 43, 99, 105, 114, 59, 1, 10787, 59, 1, 8862, 105, 114, 59, 1, 10786, 4, 2, 111, 117, 15162, 15165, 59, 1, 8724, 59, 1, 10789, 59, 1, 10866, 110, 5, 177, 1, 59, 15177, 1, 177, 105, 109, 59, 1, 10790, 119, 111, 59, 1, 10791, 59, 1, 177, 4, 3, 105, 112, 117, 15200, 15208, 15213, 110, 116, 105, 110, 116, 59, 1, 10773, 102, 59, 3, 55349, 56673, 110, 100, 5, 163, 1, 59, 15220, 1, 163, 4, 10, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 15244, 15246, 15249, 15253, 15258, 15334, 15347, 15367, 15416, 15421, 1, 8826, 59, 1, 10931, 112, 59, 1, 10935, 117, 101, 59, 1, 8828, 4, 2, 59, 99, 15264, 15266, 1, 10927, 4, 6, 59, 97, 99, 101, 110, 115, 15280, 15282, 15290, 15299, 15303, 15329, 1, 8826, 112, 112, 114, 111, 120, 59, 1, 10935, 117, 114, 108, 121, 101, 113, 59, 1, 8828, 113, 59, 1, 10927, 4, 3, 97, 101, 115, 15311, 15319, 15324, 112, 112, 114, 111, 120, 59, 1, 10937, 113, 113, 59, 1, 10933, 105, 109, 59, 1, 8936, 105, 109, 59, 1, 8830, 109, 101, 4, 2, 59, 115, 15342, 15344, 1, 8242, 59, 1, 8473, 4, 3, 69, 97, 115, 15355, 15358, 15362, 59, 1, 10933, 112, 59, 1, 10937, 105, 109, 59, 1, 8936, 4, 3, 100, 102, 112, 15375, 15378, 15404, 59, 1, 8719, 4, 3, 97, 108, 115, 15386, 15392, 15398, 108, 97, 114, 59, 1, 9006, 105, 110, 101, 59, 1, 8978, 117, 114, 102, 59, 1, 8979, 4, 2, 59, 116, 15410, 15412, 1, 8733, 111, 59, 1, 8733, 105, 109, 59, 1, 8830, 114, 101, 108, 59, 1, 8880, 4, 2, 99, 105, 15433, 15438, 114, 59, 3, 55349, 56517, 59, 1, 968, 110, 99, 115, 112, 59, 1, 8200, 4, 6, 102, 105, 111, 112, 115, 117, 15462, 15467, 15472, 15478, 15485, 15491, 114, 59, 3, 55349, 56622, 110, 116, 59, 1, 10764, 112, 102, 59, 3, 55349, 56674, 114, 105, 109, 101, 59, 1, 8279, 99, 114, 59, 3, 55349, 56518, 4, 3, 97, 101, 111, 15499, 15520, 15534, 116, 4, 2, 101, 105, 15506, 15515, 114, 110, 105, 111, 110, 115, 59, 1, 8461, 110, 116, 59, 1, 10774, 115, 116, 4, 2, 59, 101, 15528, 15530, 1, 63, 113, 59, 1, 8799, 116, 5, 34, 1, 59, 15540, 1, 34, 4, 21, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 15586, 15609, 15615, 15620, 15796, 15855, 15893, 15931, 15977, 16001, 16039, 16183, 16204, 16222, 16228, 16285, 16312, 16318, 16363, 16408, 16416, 4, 3, 97, 114, 116, 15594, 15599, 15603, 114, 114, 59, 1, 8667, 114, 59, 1, 8658, 97, 105, 108, 59, 1, 10524, 97, 114, 114, 59, 1, 10511, 97, 114, 59, 1, 10596, 4, 7, 99, 100, 101, 110, 113, 114, 116, 15636, 15651, 15656, 15664, 15687, 15696, 15770, 4, 2, 101, 117, 15642, 15646, 59, 3, 8765, 817, 116, 101, 59, 1, 341, 105, 99, 59, 1, 8730, 109, 112, 116, 121, 118, 59, 1, 10675, 103, 4, 4, 59, 100, 101, 108, 15675, 15677, 15680, 15683, 1, 10217, 59, 1, 10642, 59, 1, 10661, 101, 59, 1, 10217, 117, 111, 5, 187, 1, 59, 15694, 1, 187, 114, 4, 11, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 15721, 15723, 15727, 15739, 15742, 15746, 15750, 15754, 15758, 15763, 15767, 1, 8594, 112, 59, 1, 10613, 4, 2, 59, 102, 15733, 15735, 1, 8677, 115, 59, 1, 10528, 59, 1, 10547, 115, 59, 1, 10526, 107, 59, 1, 8618, 112, 59, 1, 8620, 108, 59, 1, 10565, 105, 109, 59, 1, 10612, 108, 59, 1, 8611, 59, 1, 8605, 4, 2, 97, 105, 15776, 15781, 105, 108, 59, 1, 10522, 111, 4, 2, 59, 110, 15788, 15790, 1, 8758, 97, 108, 115, 59, 1, 8474, 4, 3, 97, 98, 114, 15804, 15809, 15814, 114, 114, 59, 1, 10509, 114, 107, 59, 1, 10099, 4, 2, 97, 107, 15820, 15833, 99, 4, 2, 101, 107, 15827, 15830, 59, 1, 125, 59, 1, 93, 4, 2, 101, 115, 15839, 15842, 59, 1, 10636, 108, 4, 2, 100, 117, 15849, 15852, 59, 1, 10638, 59, 1, 10640, 4, 4, 97, 101, 117, 121, 15865, 15871, 15886, 15890, 114, 111, 110, 59, 1, 345, 4, 2, 100, 105, 15877, 15882, 105, 108, 59, 1, 343, 108, 59, 1, 8969, 98, 59, 1, 125, 59, 1, 1088, 4, 4, 99, 108, 113, 115, 15903, 15907, 15914, 15927, 97, 59, 1, 10551, 100, 104, 97, 114, 59, 1, 10601, 117, 111, 4, 2, 59, 114, 15922, 15924, 1, 8221, 59, 1, 8221, 104, 59, 1, 8627, 4, 3, 97, 99, 103, 15939, 15966, 15970, 108, 4, 4, 59, 105, 112, 115, 15950, 15952, 15957, 15963, 1, 8476, 110, 101, 59, 1, 8475, 97, 114, 116, 59, 1, 8476, 59, 1, 8477, 116, 59, 1, 9645, 5, 174, 1, 59, 15975, 1, 174, 4, 3, 105, 108, 114, 15985, 15991, 15997, 115, 104, 116, 59, 1, 10621, 111, 111, 114, 59, 1, 8971, 59, 3, 55349, 56623, 4, 2, 97, 111, 16007, 16028, 114, 4, 2, 100, 117, 16014, 16017, 59, 1, 8641, 4, 2, 59, 108, 16023, 16025, 1, 8640, 59, 1, 10604, 4, 2, 59, 118, 16034, 16036, 1, 961, 59, 1, 1009, 4, 3, 103, 110, 115, 16047, 16167, 16171, 104, 116, 4, 6, 97, 104, 108, 114, 115, 116, 16063, 16081, 16103, 16130, 16143, 16155, 114, 114, 111, 119, 4, 2, 59, 116, 16073, 16075, 1, 8594, 97, 105, 108, 59, 1, 8611, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 16093, 16099, 111, 119, 110, 59, 1, 8641, 112, 59, 1, 8640, 101, 102, 116, 4, 2, 97, 104, 16112, 16120, 114, 114, 111, 119, 115, 59, 1, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8908, 103, 59, 1, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8787, 4, 3, 97, 104, 109, 16191, 16196, 16201, 114, 114, 59, 1, 8644, 97, 114, 59, 1, 8652, 59, 1, 8207, 111, 117, 115, 116, 4, 2, 59, 97, 16214, 16216, 1, 9137, 99, 104, 101, 59, 1, 9137, 109, 105, 100, 59, 1, 10990, 4, 4, 97, 98, 112, 116, 16238, 16252, 16257, 16278, 4, 2, 110, 114, 16244, 16248, 103, 59, 1, 10221, 114, 59, 1, 8702, 114, 107, 59, 1, 10215, 4, 3, 97, 102, 108, 16265, 16269, 16273, 114, 59, 1, 10630, 59, 3, 55349, 56675, 117, 115, 59, 1, 10798, 105, 109, 101, 115, 59, 1, 10805, 4, 2, 97, 112, 16291, 16304, 114, 4, 2, 59, 103, 16298, 16300, 1, 41, 116, 59, 1, 10644, 111, 108, 105, 110, 116, 59, 1, 10770, 97, 114, 114, 59, 1, 8649, 4, 4, 97, 99, 104, 113, 16328, 16334, 16339, 16342, 113, 117, 111, 59, 1, 8250, 114, 59, 3, 55349, 56519, 59, 1, 8625, 4, 2, 98, 117, 16348, 16351, 59, 1, 93, 111, 4, 2, 59, 114, 16358, 16360, 1, 8217, 59, 1, 8217, 4, 3, 104, 105, 114, 16371, 16377, 16383, 114, 101, 101, 59, 1, 8908, 109, 101, 115, 59, 1, 8906, 105, 4, 4, 59, 101, 102, 108, 16394, 16396, 16399, 16402, 1, 9657, 59, 1, 8885, 59, 1, 9656, 116, 114, 105, 59, 1, 10702, 108, 117, 104, 97, 114, 59, 1, 10600, 59, 1, 8478, 4, 19, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 111, 112, 113, 114, 115, 116, 117, 119, 122, 16459, 16466, 16472, 16572, 16590, 16672, 16687, 16746, 16844, 16850, 16924, 16963, 16988, 17115, 17121, 17154, 17206, 17614, 17656, 99, 117, 116, 101, 59, 1, 347, 113, 117, 111, 59, 1, 8218, 4, 10, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 16494, 16496, 16499, 16513, 16518, 16531, 16536, 16556, 16564, 16569, 1, 8827, 59, 1, 10932, 4, 2, 112, 114, 16505, 16508, 59, 1, 10936, 111, 110, 59, 1, 353, 117, 101, 59, 1, 8829, 4, 2, 59, 100, 16524, 16526, 1, 10928, 105, 108, 59, 1, 351, 114, 99, 59, 1, 349, 4, 3, 69, 97, 115, 16544, 16547, 16551, 59, 1, 10934, 112, 59, 1, 10938, 105, 109, 59, 1, 8937, 111, 108, 105, 110, 116, 59, 1, 10771, 105, 109, 59, 1, 8831, 59, 1, 1089, 111, 116, 4, 3, 59, 98, 101, 16582, 16584, 16587, 1, 8901, 59, 1, 8865, 59, 1, 10854, 4, 7, 65, 97, 99, 109, 115, 116, 120, 16606, 16611, 16634, 16642, 16646, 16652, 16668, 114, 114, 59, 1, 8664, 114, 4, 2, 104, 114, 16618, 16622, 107, 59, 1, 10533, 4, 2, 59, 111, 16628, 16630, 1, 8600, 119, 59, 1, 8600, 116, 5, 167, 1, 59, 16640, 1, 167, 105, 59, 1, 59, 119, 97, 114, 59, 1, 10537, 109, 4, 2, 105, 110, 16659, 16665, 110, 117, 115, 59, 1, 8726, 59, 1, 8726, 116, 59, 1, 10038, 114, 4, 2, 59, 111, 16679, 16682, 3, 55349, 56624, 119, 110, 59, 1, 8994, 4, 4, 97, 99, 111, 121, 16697, 16702, 16716, 16739, 114, 112, 59, 1, 9839, 4, 2, 104, 121, 16708, 16713, 99, 121, 59, 1, 1097, 59, 1, 1096, 114, 116, 4, 2, 109, 112, 16724, 16729, 105, 100, 59, 1, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8741, 5, 173, 1, 59, 16744, 1, 173, 4, 2, 103, 109, 16752, 16770, 109, 97, 4, 3, 59, 102, 118, 16762, 16764, 16767, 1, 963, 59, 1, 962, 59, 1, 962, 4, 8, 59, 100, 101, 103, 108, 110, 112, 114, 16788, 16790, 16795, 16806, 16817, 16828, 16832, 16838, 1, 8764, 111, 116, 59, 1, 10858, 4, 2, 59, 113, 16801, 16803, 1, 8771, 59, 1, 8771, 4, 2, 59, 69, 16812, 16814, 1, 10910, 59, 1, 10912, 4, 2, 59, 69, 16823, 16825, 1, 10909, 59, 1, 10911, 101, 59, 1, 8774, 108, 117, 115, 59, 1, 10788, 97, 114, 114, 59, 1, 10610, 97, 114, 114, 59, 1, 8592, 4, 4, 97, 101, 105, 116, 16860, 16883, 16891, 16904, 4, 2, 108, 115, 16866, 16878, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 1, 8726, 104, 112, 59, 1, 10803, 112, 97, 114, 115, 108, 59, 1, 10724, 4, 2, 100, 108, 16897, 16900, 59, 1, 8739, 101, 59, 1, 8995, 4, 2, 59, 101, 16910, 16912, 1, 10922, 4, 2, 59, 115, 16918, 16920, 1, 10924, 59, 3, 10924, 65024, 4, 3, 102, 108, 112, 16932, 16938, 16958, 116, 99, 121, 59, 1, 1100, 4, 2, 59, 98, 16944, 16946, 1, 47, 4, 2, 59, 97, 16952, 16954, 1, 10692, 114, 59, 1, 9023, 102, 59, 3, 55349, 56676, 97, 4, 2, 100, 114, 16970, 16985, 101, 115, 4, 2, 59, 117, 16978, 16980, 1, 9824, 105, 116, 59, 1, 9824, 59, 1, 8741, 4, 3, 99, 115, 117, 16996, 17028, 17089, 4, 2, 97, 117, 17002, 17015, 112, 4, 2, 59, 115, 17009, 17011, 1, 8851, 59, 3, 8851, 65024, 112, 4, 2, 59, 115, 17022, 17024, 1, 8852, 59, 3, 8852, 65024, 117, 4, 2, 98, 112, 17035, 17062, 4, 3, 59, 101, 115, 17043, 17045, 17048, 1, 8847, 59, 1, 8849, 101, 116, 4, 2, 59, 101, 17056, 17058, 1, 8847, 113, 59, 1, 8849, 4, 3, 59, 101, 115, 17070, 17072, 17075, 1, 8848, 59, 1, 8850, 101, 116, 4, 2, 59, 101, 17083, 17085, 1, 8848, 113, 59, 1, 8850, 4, 3, 59, 97, 102, 17097, 17099, 17112, 1, 9633, 114, 4, 2, 101, 102, 17106, 17109, 59, 1, 9633, 59, 1, 9642, 59, 1, 9642, 97, 114, 114, 59, 1, 8594, 4, 4, 99, 101, 109, 116, 17131, 17136, 17142, 17148, 114, 59, 3, 55349, 56520, 116, 109, 110, 59, 1, 8726, 105, 108, 101, 59, 1, 8995, 97, 114, 102, 59, 1, 8902, 4, 2, 97, 114, 17160, 17172, 114, 4, 2, 59, 102, 17167, 17169, 1, 9734, 59, 1, 9733, 4, 2, 97, 110, 17178, 17202, 105, 103, 104, 116, 4, 2, 101, 112, 17188, 17197, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 104, 105, 59, 1, 981, 115, 59, 1, 175, 4, 5, 98, 99, 109, 110, 112, 17218, 17351, 17420, 17423, 17427, 4, 9, 59, 69, 100, 101, 109, 110, 112, 114, 115, 17238, 17240, 17243, 17248, 17261, 17267, 17279, 17285, 17291, 1, 8834, 59, 1, 10949, 111, 116, 59, 1, 10941, 4, 2, 59, 100, 17254, 17256, 1, 8838, 111, 116, 59, 1, 10947, 117, 108, 116, 59, 1, 10945, 4, 2, 69, 101, 17273, 17276, 59, 1, 10955, 59, 1, 8842, 108, 117, 115, 59, 1, 10943, 97, 114, 114, 59, 1, 10617, 4, 3, 101, 105, 117, 17299, 17335, 17339, 116, 4, 3, 59, 101, 110, 17308, 17310, 17322, 1, 8834, 113, 4, 2, 59, 113, 17317, 17319, 1, 8838, 59, 1, 10949, 101, 113, 4, 2, 59, 113, 17330, 17332, 1, 8842, 59, 1, 10955, 109, 59, 1, 10951, 4, 2, 98, 112, 17345, 17348, 59, 1, 10965, 59, 1, 10963, 99, 4, 6, 59, 97, 99, 101, 110, 115, 17366, 17368, 17376, 17385, 17389, 17415, 1, 8827, 112, 112, 114, 111, 120, 59, 1, 10936, 117, 114, 108, 121, 101, 113, 59, 1, 8829, 113, 59, 1, 10928, 4, 3, 97, 101, 115, 17397, 17405, 17410, 112, 112, 114, 111, 120, 59, 1, 10938, 113, 113, 59, 1, 10934, 105, 109, 59, 1, 8937, 105, 109, 59, 1, 8831, 59, 1, 8721, 103, 59, 1, 9834, 4, 13, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 17455, 17462, 17469, 17476, 17478, 17481, 17496, 17509, 17524, 17530, 17536, 17548, 17554, 5, 185, 1, 59, 17460, 1, 185, 5, 178, 1, 59, 17467, 1, 178, 5, 179, 1, 59, 17474, 1, 179, 1, 8835, 59, 1, 10950, 4, 2, 111, 115, 17487, 17491, 116, 59, 1, 10942, 117, 98, 59, 1, 10968, 4, 2, 59, 100, 17502, 17504, 1, 8839, 111, 116, 59, 1, 10948, 115, 4, 2, 111, 117, 17516, 17520, 108, 59, 1, 10185, 98, 59, 1, 10967, 97, 114, 114, 59, 1, 10619, 117, 108, 116, 59, 1, 10946, 4, 2, 69, 101, 17542, 17545, 59, 1, 10956, 59, 1, 8843, 108, 117, 115, 59, 1, 10944, 4, 3, 101, 105, 117, 17562, 17598, 17602, 116, 4, 3, 59, 101, 110, 17571, 17573, 17585, 1, 8835, 113, 4, 2, 59, 113, 17580, 17582, 1, 8839, 59, 1, 10950, 101, 113, 4, 2, 59, 113, 17593, 17595, 1, 8843, 59, 1, 10956, 109, 59, 1, 10952, 4, 2, 98, 112, 17608, 17611, 59, 1, 10964, 59, 1, 10966, 4, 3, 65, 97, 110, 17622, 17627, 17650, 114, 114, 59, 1, 8665, 114, 4, 2, 104, 114, 17634, 17638, 107, 59, 1, 10534, 4, 2, 59, 111, 17644, 17646, 1, 8601, 119, 59, 1, 8601, 119, 97, 114, 59, 1, 10538, 108, 105, 103, 5, 223, 1, 59, 17664, 1, 223, 4, 13, 97, 98, 99, 100, 101, 102, 104, 105, 111, 112, 114, 115, 119, 17694, 17709, 17714, 17737, 17742, 17749, 17754, 17860, 17905, 17957, 17964, 18090, 18122, 4, 2, 114, 117, 17700, 17706, 103, 101, 116, 59, 1, 8982, 59, 1, 964, 114, 107, 59, 1, 9140, 4, 3, 97, 101, 121, 17722, 17728, 17734, 114, 111, 110, 59, 1, 357, 100, 105, 108, 59, 1, 355, 59, 1, 1090, 111, 116, 59, 1, 8411, 108, 114, 101, 99, 59, 1, 8981, 114, 59, 3, 55349, 56625, 4, 4, 101, 105, 107, 111, 17764, 17805, 17836, 17851, 4, 2, 114, 116, 17770, 17786, 101, 4, 2, 52, 102, 17777, 17780, 59, 1, 8756, 111, 114, 101, 59, 1, 8756, 97, 4, 3, 59, 115, 118, 17795, 17797, 17802, 1, 952, 121, 109, 59, 1, 977, 59, 1, 977, 4, 2, 99, 110, 17811, 17831, 107, 4, 2, 97, 115, 17818, 17826, 112, 112, 114, 111, 120, 59, 1, 8776, 105, 109, 59, 1, 8764, 115, 112, 59, 1, 8201, 4, 2, 97, 115, 17842, 17846, 112, 59, 1, 8776, 105, 109, 59, 1, 8764, 114, 110, 5, 254, 1, 59, 17858, 1, 254, 4, 3, 108, 109, 110, 17868, 17873, 17901, 100, 101, 59, 1, 732, 101, 115, 5, 215, 3, 59, 98, 100, 17884, 17886, 17898, 1, 215, 4, 2, 59, 97, 17892, 17894, 1, 8864, 114, 59, 1, 10801, 59, 1, 10800, 116, 59, 1, 8749, 4, 3, 101, 112, 115, 17913, 17917, 17953, 97, 59, 1, 10536, 4, 4, 59, 98, 99, 102, 17927, 17929, 17934, 17939, 1, 8868, 111, 116, 59, 1, 9014, 105, 114, 59, 1, 10993, 4, 2, 59, 111, 17945, 17948, 3, 55349, 56677, 114, 107, 59, 1, 10970, 97, 59, 1, 10537, 114, 105, 109, 101, 59, 1, 8244, 4, 3, 97, 105, 112, 17972, 17977, 18082, 100, 101, 59, 1, 8482, 4, 7, 97, 100, 101, 109, 112, 115, 116, 17993, 18051, 18056, 18059, 18066, 18072, 18076, 110, 103, 108, 101, 4, 5, 59, 100, 108, 113, 114, 18009, 18011, 18017, 18032, 18035, 1, 9653, 111, 119, 110, 59, 1, 9663, 101, 102, 116, 4, 2, 59, 101, 18026, 18028, 1, 9667, 113, 59, 1, 8884, 59, 1, 8796, 105, 103, 104, 116, 4, 2, 59, 101, 18045, 18047, 1, 9657, 113, 59, 1, 8885, 111, 116, 59, 1, 9708, 59, 1, 8796, 105, 110, 117, 115, 59, 1, 10810, 108, 117, 115, 59, 1, 10809, 98, 59, 1, 10701, 105, 109, 101, 59, 1, 10811, 101, 122, 105, 117, 109, 59, 1, 9186, 4, 3, 99, 104, 116, 18098, 18111, 18116, 4, 2, 114, 121, 18104, 18108, 59, 3, 55349, 56521, 59, 1, 1094, 99, 121, 59, 1, 1115, 114, 111, 107, 59, 1, 359, 4, 2, 105, 111, 18128, 18133, 120, 116, 59, 1, 8812, 104, 101, 97, 100, 4, 2, 108, 114, 18143, 18154, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8608, 4, 18, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 18204, 18209, 18214, 18234, 18250, 18268, 18292, 18308, 18319, 18343, 18379, 18397, 18413, 18504, 18547, 18553, 18584, 18603, 114, 114, 59, 1, 8657, 97, 114, 59, 1, 10595, 4, 2, 99, 114, 18220, 18230, 117, 116, 101, 5, 250, 1, 59, 18228, 1, 250, 114, 59, 1, 8593, 114, 4, 2, 99, 101, 18241, 18245, 121, 59, 1, 1118, 118, 101, 59, 1, 365, 4, 2, 105, 121, 18256, 18265, 114, 99, 5, 251, 1, 59, 18263, 1, 251, 59, 1, 1091, 4, 3, 97, 98, 104, 18276, 18281, 18287, 114, 114, 59, 1, 8645, 108, 97, 99, 59, 1, 369, 97, 114, 59, 1, 10606, 4, 2, 105, 114, 18298, 18304, 115, 104, 116, 59, 1, 10622, 59, 3, 55349, 56626, 114, 97, 118, 101, 5, 249, 1, 59, 18317, 1, 249, 4, 2, 97, 98, 18325, 18338, 114, 4, 2, 108, 114, 18332, 18335, 59, 1, 8639, 59, 1, 8638, 108, 107, 59, 1, 9600, 4, 2, 99, 116, 18349, 18374, 4, 2, 111, 114, 18355, 18369, 114, 110, 4, 2, 59, 101, 18363, 18365, 1, 8988, 114, 59, 1, 8988, 111, 112, 59, 1, 8975, 114, 105, 59, 1, 9720, 4, 2, 97, 108, 18385, 18390, 99, 114, 59, 1, 363, 5, 168, 1, 59, 18395, 1, 168, 4, 2, 103, 112, 18403, 18408, 111, 110, 59, 1, 371, 102, 59, 3, 55349, 56678, 4, 6, 97, 100, 104, 108, 115, 117, 18427, 18434, 18445, 18470, 18475, 18494, 114, 114, 111, 119, 59, 1, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8597, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 18457, 18463, 101, 102, 116, 59, 1, 8639, 105, 103, 104, 116, 59, 1, 8638, 117, 115, 59, 1, 8846, 105, 4, 3, 59, 104, 108, 18484, 18486, 18489, 1, 965, 59, 1, 978, 111, 110, 59, 1, 965, 112, 97, 114, 114, 111, 119, 115, 59, 1, 8648, 4, 3, 99, 105, 116, 18512, 18537, 18542, 4, 2, 111, 114, 18518, 18532, 114, 110, 4, 2, 59, 101, 18526, 18528, 1, 8989, 114, 59, 1, 8989, 111, 112, 59, 1, 8974, 110, 103, 59, 1, 367, 114, 105, 59, 1, 9721, 99, 114, 59, 3, 55349, 56522, 4, 3, 100, 105, 114, 18561, 18566, 18572, 111, 116, 59, 1, 8944, 108, 100, 101, 59, 1, 361, 105, 4, 2, 59, 102, 18579, 18581, 1, 9653, 59, 1, 9652, 4, 2, 97, 109, 18590, 18595, 114, 114, 59, 1, 8648, 108, 5, 252, 1, 59, 18601, 1, 252, 97, 110, 103, 108, 101, 59, 1, 10663, 4, 15, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 18643, 18648, 18661, 18667, 18847, 18851, 18857, 18904, 18909, 18915, 18931, 18937, 18943, 18949, 18996, 114, 114, 59, 1, 8661, 97, 114, 4, 2, 59, 118, 18656, 18658, 1, 10984, 59, 1, 10985, 97, 115, 104, 59, 1, 8872, 4, 2, 110, 114, 18673, 18679, 103, 114, 116, 59, 1, 10652, 4, 7, 101, 107, 110, 112, 114, 115, 116, 18695, 18704, 18711, 18720, 18742, 18754, 18810, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 97, 112, 112, 97, 59, 1, 1008, 111, 116, 104, 105, 110, 103, 59, 1, 8709, 4, 3, 104, 105, 114, 18728, 18732, 18735, 105, 59, 1, 981, 59, 1, 982, 111, 112, 116, 111, 59, 1, 8733, 4, 2, 59, 104, 18748, 18750, 1, 8597, 111, 59, 1, 1009, 4, 2, 105, 117, 18760, 18766, 103, 109, 97, 59, 1, 962, 4, 2, 98, 112, 18772, 18791, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18784, 18787, 3, 8842, 65024, 59, 3, 10955, 65024, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18803, 18806, 3, 8843, 65024, 59, 3, 10956, 65024, 4, 2, 104, 114, 18816, 18822, 101, 116, 97, 59, 1, 977, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 18834, 18840, 101, 102, 116, 59, 1, 8882, 105, 103, 104, 116, 59, 1, 8883, 121, 59, 1, 1074, 97, 115, 104, 59, 1, 8866, 4, 3, 101, 108, 114, 18865, 18884, 18890, 4, 3, 59, 98, 101, 18873, 18875, 18880, 1, 8744, 97, 114, 59, 1, 8891, 113, 59, 1, 8794, 108, 105, 112, 59, 1, 8942, 4, 2, 98, 116, 18896, 18901, 97, 114, 59, 1, 124, 59, 1, 124, 114, 59, 3, 55349, 56627, 116, 114, 105, 59, 1, 8882, 115, 117, 4, 2, 98, 112, 18923, 18927, 59, 3, 8834, 8402, 59, 3, 8835, 8402, 112, 102, 59, 3, 55349, 56679, 114, 111, 112, 59, 1, 8733, 116, 114, 105, 59, 1, 8883, 4, 2, 99, 117, 18955, 18960, 114, 59, 3, 55349, 56523, 4, 2, 98, 112, 18966, 18981, 110, 4, 2, 69, 101, 18973, 18977, 59, 3, 10955, 65024, 59, 3, 8842, 65024, 110, 4, 2, 69, 101, 18988, 18992, 59, 3, 10956, 65024, 59, 3, 8843, 65024, 105, 103, 122, 97, 103, 59, 1, 10650, 4, 7, 99, 101, 102, 111, 112, 114, 115, 19020, 19026, 19061, 19066, 19072, 19075, 19089, 105, 114, 99, 59, 1, 373, 4, 2, 100, 105, 19032, 19055, 4, 2, 98, 103, 19038, 19043, 97, 114, 59, 1, 10847, 101, 4, 2, 59, 113, 19050, 19052, 1, 8743, 59, 1, 8793, 101, 114, 112, 59, 1, 8472, 114, 59, 3, 55349, 56628, 112, 102, 59, 3, 55349, 56680, 59, 1, 8472, 4, 2, 59, 101, 19081, 19083, 1, 8768, 97, 116, 104, 59, 1, 8768, 99, 114, 59, 3, 55349, 56524, 4, 14, 99, 100, 102, 104, 105, 108, 109, 110, 111, 114, 115, 117, 118, 119, 19125, 19146, 19152, 19157, 19173, 19176, 19192, 19197, 19202, 19236, 19252, 19269, 19286, 19291, 4, 3, 97, 105, 117, 19133, 19137, 19142, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 116, 114, 105, 59, 1, 9661, 114, 59, 3, 55349, 56629, 4, 2, 65, 97, 19163, 19168, 114, 114, 59, 1, 10234, 114, 114, 59, 1, 10231, 59, 1, 958, 4, 2, 65, 97, 19182, 19187, 114, 114, 59, 1, 10232, 114, 114, 59, 1, 10229, 97, 112, 59, 1, 10236, 105, 115, 59, 1, 8955, 4, 3, 100, 112, 116, 19210, 19215, 19230, 111, 116, 59, 1, 10752, 4, 2, 102, 108, 19221, 19225, 59, 3, 55349, 56681, 117, 115, 59, 1, 10753, 105, 109, 101, 59, 1, 10754, 4, 2, 65, 97, 19242, 19247, 114, 114, 59, 1, 10233, 114, 114, 59, 1, 10230, 4, 2, 99, 113, 19258, 19263, 114, 59, 3, 55349, 56525, 99, 117, 112, 59, 1, 10758, 4, 2, 112, 116, 19275, 19281, 108, 117, 115, 59, 1, 10756, 114, 105, 59, 1, 9651, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 19316, 19335, 19349, 19357, 19362, 19367, 19373, 19379, 99, 4, 2, 117, 121, 19323, 19332, 116, 101, 5, 253, 1, 59, 19330, 1, 253, 59, 1, 1103, 4, 2, 105, 121, 19341, 19346, 114, 99, 59, 1, 375, 59, 1, 1099, 110, 5, 165, 1, 59, 19355, 1, 165, 114, 59, 3, 55349, 56630, 99, 121, 59, 1, 1111, 112, 102, 59, 3, 55349, 56682, 99, 114, 59, 3, 55349, 56526, 4, 2, 99, 109, 19385, 19389, 121, 59, 1, 1102, 108, 5, 255, 1, 59, 19395, 1, 255, 4, 10, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 19419, 19426, 19441, 19446, 19462, 19467, 19472, 19480, 19486, 19492, 99, 117, 116, 101, 59, 1, 378, 4, 2, 97, 121, 19432, 19438, 114, 111, 110, 59, 1, 382, 59, 1, 1079, 111, 116, 59, 1, 380, 4, 2, 101, 116, 19452, 19458, 116, 114, 102, 59, 1, 8488, 97, 59, 1, 950, 114, 59, 3, 55349, 56631, 99, 121, 59, 1, 1078, 103, 114, 97, 114, 114, 59, 1, 8669, 112, 102, 59, 3, 55349, 56683, 99, 114, 59, 3, 55349, 56527, 4, 2, 106, 110, 19498, 19501, 59, 1, 8205, 106, 59, 1, 8204]);
const _R = AR, bt = ur, Ea = CR, re = uf, R = bt.CODE_POINTS, la = bt.CODE_POINT_SEQUENCES, bR = {
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
}, zg = 1 << 0, Gg = 1 << 1, Vg = 1 << 2, yR = zg | Gg | Vg, Je = "DATA_STATE", Wa = "RCDATA_STATE", Wi = "RAWTEXT_STATE", wr = "SCRIPT_DATA_STATE", Yg = "PLAINTEXT_STATE", gm = "TAG_OPEN_STATE", Em = "END_TAG_OPEN_STATE", Au = "TAG_NAME_STATE", Tm = "RCDATA_LESS_THAN_SIGN_STATE", vm = "RCDATA_END_TAG_OPEN_STATE", Am = "RCDATA_END_TAG_NAME_STATE", Cm = "RAWTEXT_LESS_THAN_SIGN_STATE", _m = "RAWTEXT_END_TAG_OPEN_STATE", bm = "RAWTEXT_END_TAG_NAME_STATE", ym = "SCRIPT_DATA_LESS_THAN_SIGN_STATE", Dm = "SCRIPT_DATA_END_TAG_OPEN_STATE", Sm = "SCRIPT_DATA_END_TAG_NAME_STATE", Om = "SCRIPT_DATA_ESCAPE_START_STATE", Nm = "SCRIPT_DATA_ESCAPE_START_DASH_STATE", tr = "SCRIPT_DATA_ESCAPED_STATE", wm = "SCRIPT_DATA_ESCAPED_DASH_STATE", Cu = "SCRIPT_DATA_ESCAPED_DASH_DASH_STATE", $1 = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE", Im = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE", Rm = "SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE", Mm = "SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE", yr = "SCRIPT_DATA_DOUBLE_ESCAPED_STATE", xm = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE", km = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE", H1 = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE", Pm = "SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE", fr = "BEFORE_ATTRIBUTE_NAME_STATE", U1 = "ATTRIBUTE_NAME_STATE", _u = "AFTER_ATTRIBUTE_NAME_STATE", bu = "BEFORE_ATTRIBUTE_VALUE_STATE", j1 = "ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE", z1 = "ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE", G1 = "ATTRIBUTE_VALUE_UNQUOTED_STATE", yu = "AFTER_ATTRIBUTE_VALUE_QUOTED_STATE", Yr = "SELF_CLOSING_START_TAG_STATE", Bi = "BOGUS_COMMENT_STATE", Bm = "MARKUP_DECLARATION_OPEN_STATE", Fm = "COMMENT_START_STATE", Lm = "COMMENT_START_DASH_STATE", Kr = "COMMENT_STATE", $m = "COMMENT_LESS_THAN_SIGN_STATE", Hm = "COMMENT_LESS_THAN_SIGN_BANG_STATE", Um = "COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE", jm = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE", V1 = "COMMENT_END_DASH_STATE", Y1 = "COMMENT_END_STATE", zm = "COMMENT_END_BANG_STATE", Gm = "DOCTYPE_STATE", K1 = "BEFORE_DOCTYPE_NAME_STATE", W1 = "DOCTYPE_NAME_STATE", Vm = "AFTER_DOCTYPE_NAME_STATE", Ym = "AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE", Km = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE", Du = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE", Su = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE", Ou = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE", Wm = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE", qm = "AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE", Xm = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE", Fi = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE", Li = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE", Nu = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE", Dr = "BOGUS_DOCTYPE_STATE", q1 = "CDATA_SECTION_STATE", Qm = "CDATA_SECTION_BRACKET_STATE", Zm = "CDATA_SECTION_END_STATE", Ga = "CHARACTER_REFERENCE_STATE", Jm = "NAMED_CHARACTER_REFERENCE_STATE", e9 = "AMBIGUOS_AMPERSAND_STATE", t9 = "NUMERIC_CHARACTER_REFERENCE_STATE", n9 = "HEXADEMICAL_CHARACTER_REFERENCE_START_STATE", r9 = "DECIMAL_CHARACTER_REFERENCE_START_STATE", a9 = "HEXADEMICAL_CHARACTER_REFERENCE_STATE", i9 = "DECIMAL_CHARACTER_REFERENCE_STATE", $i = "NUMERIC_CHARACTER_REFERENCE_END_STATE";
function Mt(e) {
  return e === R.SPACE || e === R.LINE_FEED || e === R.TABULATION || e === R.FORM_FEED;
}
function Ji(e) {
  return e >= R.DIGIT_0 && e <= R.DIGIT_9;
}
function nr(e) {
  return e >= R.LATIN_CAPITAL_A && e <= R.LATIN_CAPITAL_Z;
}
function da(e) {
  return e >= R.LATIN_SMALL_A && e <= R.LATIN_SMALL_Z;
}
function Qr(e) {
  return da(e) || nr(e);
}
function wu(e) {
  return Qr(e) || Ji(e);
}
function Kg(e) {
  return e >= R.LATIN_CAPITAL_A && e <= R.LATIN_CAPITAL_F;
}
function Wg(e) {
  return e >= R.LATIN_SMALL_A && e <= R.LATIN_SMALL_F;
}
function DR(e) {
  return Ji(e) || Kg(e) || Wg(e);
}
function oo(e) {
  return e + 32;
}
function zt(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(e >>> 10 & 1023 | 55296) + String.fromCharCode(56320 | e & 1023));
}
function Wr(e) {
  return String.fromCharCode(oo(e));
}
function o9(e, t) {
  const n = Ea[++e];
  let r = ++e, a = r + n - 1;
  for (; r <= a; ) {
    const i = r + a >>> 1, o = Ea[i];
    if (o < t)
      r = i + 1;
    else if (o > t)
      a = i - 1;
    else
      return Ea[i + n];
  }
  return -1;
}
class Nt {
  constructor() {
    this.preprocessor = new _R(), this.tokenQueue = [], this.allowCDATA = !1, this.state = Je, this.returnState = "", this.charRefCode = -1, this.tempBuff = [], this.lastStartTagName = "", this.consumedAfterSnapshot = -1, this.active = !1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = null;
  }
  _err() {
  }
  _errOnNextCodePoint(t) {
    this._consume(), this._err(t), this._unconsume();
  }
  getNextToken() {
    for (; !this.tokenQueue.length && this.active; ) {
      this.consumedAfterSnapshot = 0;
      const t = this._consume();
      this._ensureHibernation() || this[this.state](t);
    }
    return this.tokenQueue.shift();
  }
  write(t, n) {
    this.active = !0, this.preprocessor.write(t, n);
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t);
  }
  _ensureHibernation() {
    if (this.preprocessor.endOfChunkHit) {
      for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)
        this.preprocessor.retreat();
      return this.active = !1, this.tokenQueue.push({ type: Nt.HIBERNATION_TOKEN }), !0;
    }
    return !1;
  }
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _unconsume() {
    this.consumedAfterSnapshot--, this.preprocessor.retreat();
  }
  _reconsumeInState(t) {
    this.state = t, this._unconsume();
  }
  _consumeSequenceIfMatch(t, n, r) {
    let a = 0, i = !0;
    const o = t.length;
    let s = 0, u = n, l;
    for (; s < o; s++) {
      if (s > 0 && (u = this._consume(), a++), u === R.EOF) {
        i = !1;
        break;
      }
      if (l = t[s], u !== l && (r || u !== oo(l))) {
        i = !1;
        break;
      }
    }
    if (!i)
      for (; a--; )
        this._unconsume();
    return i;
  }
  _isTempBufferEqualToScriptString() {
    if (this.tempBuff.length !== la.SCRIPT_STRING.length)
      return !1;
    for (let t = 0; t < this.tempBuff.length; t++)
      if (this.tempBuff[t] !== la.SCRIPT_STRING[t])
        return !1;
    return !0;
  }
  _createStartTagToken() {
    this.currentToken = {
      type: Nt.START_TAG_TOKEN,
      tagName: "",
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: []
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: Nt.END_TAG_TOKEN,
      tagName: "",
      selfClosing: !1,
      attrs: []
    };
  }
  _createCommentToken() {
    this.currentToken = {
      type: Nt.COMMENT_TOKEN,
      data: ""
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: Nt.DOCTYPE_TOKEN,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null
    };
  }
  _createCharacterToken(t, n) {
    this.currentCharacterToken = {
      type: t,
      chars: n
    };
  }
  _createEOFToken() {
    this.currentToken = { type: Nt.EOF_TOKEN };
  }
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    };
  }
  _leaveAttrName(t) {
    Nt.getTokenAttr(this.currentToken, this.currentAttr.name) === null ? this.currentToken.attrs.push(this.currentAttr) : this._err(re.duplicateAttribute), this.state = t;
  }
  _leaveAttrValue(t) {
    this.state = t;
  }
  _emitCurrentToken() {
    this._emitCurrentCharacterToken();
    const t = this.currentToken;
    this.currentToken = null, t.type === Nt.START_TAG_TOKEN ? this.lastStartTagName = t.tagName : t.type === Nt.END_TAG_TOKEN && (t.attrs.length > 0 && this._err(re.endTagWithAttributes), t.selfClosing && this._err(re.endTagWithTrailingSolidus)), this.tokenQueue.push(t);
  }
  _emitCurrentCharacterToken() {
    this.currentCharacterToken && (this.tokenQueue.push(this.currentCharacterToken), this.currentCharacterToken = null);
  }
  _emitEOFToken() {
    this._createEOFToken(), this._emitCurrentToken();
  }
  _appendCharToCurrentCharacterToken(t, n) {
    this.currentCharacterToken && this.currentCharacterToken.type !== t && this._emitCurrentCharacterToken(), this.currentCharacterToken ? this.currentCharacterToken.chars += n : this._createCharacterToken(t, n);
  }
  _emitCodePoint(t) {
    let n = Nt.CHARACTER_TOKEN;
    Mt(t) ? n = Nt.WHITESPACE_CHARACTER_TOKEN : t === R.NULL && (n = Nt.NULL_CHARACTER_TOKEN), this._appendCharToCurrentCharacterToken(n, zt(t));
  }
  _emitSeveralCodePoints(t) {
    for (let n = 0; n < t.length; n++)
      this._emitCodePoint(t[n]);
  }
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(Nt.CHARACTER_TOKEN, t);
  }
  _matchNamedCharacterReference(t) {
    let n = null, r = 1, a = o9(0, t);
    for (this.tempBuff.push(t); a > -1; ) {
      const i = Ea[a], o = i < yR;
      o && i & zg && (n = i & Gg ? [Ea[++a], Ea[++a]] : [Ea[++a]], r = 0);
      const u = this._consume();
      if (this.tempBuff.push(u), r++, u === R.EOF)
        break;
      o ? a = i & Vg ? o9(a, u) : -1 : a = u === i ? ++a : -1;
    }
    for (; r--; )
      this.tempBuff.pop(), this._unconsume();
    return n;
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === j1 || this.returnState === z1 || this.returnState === G1;
  }
  _isCharacterReferenceAttributeQuirk(t) {
    if (!t && this._isCharacterReferenceInAttribute()) {
      const n = this._consume();
      return this._unconsume(), n === R.EQUALS_SIGN || wu(n);
    }
    return !1;
  }
  _flushCodePointsConsumedAsCharacterReference() {
    if (this._isCharacterReferenceInAttribute())
      for (let t = 0; t < this.tempBuff.length; t++)
        this.currentAttr.value += zt(this.tempBuff[t]);
    else
      this._emitSeveralCodePoints(this.tempBuff);
    this.tempBuff = [];
  }
  [Je](t) {
    this.preprocessor.dropParsedChunk(), t === R.LESS_THAN_SIGN ? this.state = gm : t === R.AMPERSAND ? (this.returnState = Je, this.state = Ga) : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this._emitCodePoint(t)) : t === R.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  [Wa](t) {
    this.preprocessor.dropParsedChunk(), t === R.AMPERSAND ? (this.returnState = Wa, this.state = Ga) : t === R.LESS_THAN_SIGN ? this.state = Tm : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this._emitChars(bt.REPLACEMENT_CHARACTER)) : t === R.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  [Wi](t) {
    this.preprocessor.dropParsedChunk(), t === R.LESS_THAN_SIGN ? this.state = Cm : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this._emitChars(bt.REPLACEMENT_CHARACTER)) : t === R.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  [wr](t) {
    this.preprocessor.dropParsedChunk(), t === R.LESS_THAN_SIGN ? this.state = ym : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this._emitChars(bt.REPLACEMENT_CHARACTER)) : t === R.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  [Yg](t) {
    this.preprocessor.dropParsedChunk(), t === R.NULL ? (this._err(re.unexpectedNullCharacter), this._emitChars(bt.REPLACEMENT_CHARACTER)) : t === R.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  [gm](t) {
    t === R.EXCLAMATION_MARK ? this.state = Bm : t === R.SOLIDUS ? this.state = Em : Qr(t) ? (this._createStartTagToken(), this._reconsumeInState(Au)) : t === R.QUESTION_MARK ? (this._err(re.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(), this._reconsumeInState(Bi)) : t === R.EOF ? (this._err(re.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken()) : (this._err(re.invalidFirstCharacterOfTagName), this._emitChars("<"), this._reconsumeInState(Je));
  }
  [Em](t) {
    Qr(t) ? (this._createEndTagToken(), this._reconsumeInState(Au)) : t === R.GREATER_THAN_SIGN ? (this._err(re.missingEndTagName), this.state = Je) : t === R.EOF ? (this._err(re.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken()) : (this._err(re.invalidFirstCharacterOfTagName), this._createCommentToken(), this._reconsumeInState(Bi));
  }
  [Au](t) {
    Mt(t) ? this.state = fr : t === R.SOLIDUS ? this.state = Yr : t === R.GREATER_THAN_SIGN ? (this.state = Je, this._emitCurrentToken()) : nr(t) ? this.currentToken.tagName += Wr(t) : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.currentToken.tagName += bt.REPLACEMENT_CHARACTER) : t === R.EOF ? (this._err(re.eofInTag), this._emitEOFToken()) : this.currentToken.tagName += zt(t);
  }
  [Tm](t) {
    t === R.SOLIDUS ? (this.tempBuff = [], this.state = vm) : (this._emitChars("<"), this._reconsumeInState(Wa));
  }
  [vm](t) {
    Qr(t) ? (this._createEndTagToken(), this._reconsumeInState(Am)) : (this._emitChars("</"), this._reconsumeInState(Wa));
  }
  [Am](t) {
    if (nr(t))
      this.currentToken.tagName += Wr(t), this.tempBuff.push(t);
    else if (da(t))
      this.currentToken.tagName += zt(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Mt(t)) {
          this.state = fr;
          return;
        }
        if (t === R.SOLIDUS) {
          this.state = Yr;
          return;
        }
        if (t === R.GREATER_THAN_SIGN) {
          this.state = Je, this._emitCurrentToken();
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Wa);
    }
  }
  [Cm](t) {
    t === R.SOLIDUS ? (this.tempBuff = [], this.state = _m) : (this._emitChars("<"), this._reconsumeInState(Wi));
  }
  [_m](t) {
    Qr(t) ? (this._createEndTagToken(), this._reconsumeInState(bm)) : (this._emitChars("</"), this._reconsumeInState(Wi));
  }
  [bm](t) {
    if (nr(t))
      this.currentToken.tagName += Wr(t), this.tempBuff.push(t);
    else if (da(t))
      this.currentToken.tagName += zt(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Mt(t)) {
          this.state = fr;
          return;
        }
        if (t === R.SOLIDUS) {
          this.state = Yr;
          return;
        }
        if (t === R.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = Je;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Wi);
    }
  }
  [ym](t) {
    t === R.SOLIDUS ? (this.tempBuff = [], this.state = Dm) : t === R.EXCLAMATION_MARK ? (this.state = Om, this._emitChars("<!")) : (this._emitChars("<"), this._reconsumeInState(wr));
  }
  [Dm](t) {
    Qr(t) ? (this._createEndTagToken(), this._reconsumeInState(Sm)) : (this._emitChars("</"), this._reconsumeInState(wr));
  }
  [Sm](t) {
    if (nr(t))
      this.currentToken.tagName += Wr(t), this.tempBuff.push(t);
    else if (da(t))
      this.currentToken.tagName += zt(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Mt(t)) {
          this.state = fr;
          return;
        } else if (t === R.SOLIDUS) {
          this.state = Yr;
          return;
        } else if (t === R.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = Je;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(wr);
    }
  }
  [Om](t) {
    t === R.HYPHEN_MINUS ? (this.state = Nm, this._emitChars("-")) : this._reconsumeInState(wr);
  }
  [Nm](t) {
    t === R.HYPHEN_MINUS ? (this.state = Cu, this._emitChars("-")) : this._reconsumeInState(wr);
  }
  [tr](t) {
    t === R.HYPHEN_MINUS ? (this.state = wm, this._emitChars("-")) : t === R.LESS_THAN_SIGN ? this.state = $1 : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this._emitChars(bt.REPLACEMENT_CHARACTER)) : t === R.EOF ? (this._err(re.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  [wm](t) {
    t === R.HYPHEN_MINUS ? (this.state = Cu, this._emitChars("-")) : t === R.LESS_THAN_SIGN ? this.state = $1 : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.state = tr, this._emitChars(bt.REPLACEMENT_CHARACTER)) : t === R.EOF ? (this._err(re.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = tr, this._emitCodePoint(t));
  }
  [Cu](t) {
    t === R.HYPHEN_MINUS ? this._emitChars("-") : t === R.LESS_THAN_SIGN ? this.state = $1 : t === R.GREATER_THAN_SIGN ? (this.state = wr, this._emitChars(">")) : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.state = tr, this._emitChars(bt.REPLACEMENT_CHARACTER)) : t === R.EOF ? (this._err(re.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = tr, this._emitCodePoint(t));
  }
  [$1](t) {
    t === R.SOLIDUS ? (this.tempBuff = [], this.state = Im) : Qr(t) ? (this.tempBuff = [], this._emitChars("<"), this._reconsumeInState(Mm)) : (this._emitChars("<"), this._reconsumeInState(tr));
  }
  [Im](t) {
    Qr(t) ? (this._createEndTagToken(), this._reconsumeInState(Rm)) : (this._emitChars("</"), this._reconsumeInState(tr));
  }
  [Rm](t) {
    if (nr(t))
      this.currentToken.tagName += Wr(t), this.tempBuff.push(t);
    else if (da(t))
      this.currentToken.tagName += zt(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Mt(t)) {
          this.state = fr;
          return;
        }
        if (t === R.SOLIDUS) {
          this.state = Yr;
          return;
        }
        if (t === R.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = Je;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(tr);
    }
  }
  [Mm](t) {
    Mt(t) || t === R.SOLIDUS || t === R.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? yr : tr, this._emitCodePoint(t)) : nr(t) ? (this.tempBuff.push(oo(t)), this._emitCodePoint(t)) : da(t) ? (this.tempBuff.push(t), this._emitCodePoint(t)) : this._reconsumeInState(tr);
  }
  [yr](t) {
    t === R.HYPHEN_MINUS ? (this.state = xm, this._emitChars("-")) : t === R.LESS_THAN_SIGN ? (this.state = H1, this._emitChars("<")) : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this._emitChars(bt.REPLACEMENT_CHARACTER)) : t === R.EOF ? (this._err(re.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  [xm](t) {
    t === R.HYPHEN_MINUS ? (this.state = km, this._emitChars("-")) : t === R.LESS_THAN_SIGN ? (this.state = H1, this._emitChars("<")) : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.state = yr, this._emitChars(bt.REPLACEMENT_CHARACTER)) : t === R.EOF ? (this._err(re.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = yr, this._emitCodePoint(t));
  }
  [km](t) {
    t === R.HYPHEN_MINUS ? this._emitChars("-") : t === R.LESS_THAN_SIGN ? (this.state = H1, this._emitChars("<")) : t === R.GREATER_THAN_SIGN ? (this.state = wr, this._emitChars(">")) : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.state = yr, this._emitChars(bt.REPLACEMENT_CHARACTER)) : t === R.EOF ? (this._err(re.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = yr, this._emitCodePoint(t));
  }
  [H1](t) {
    t === R.SOLIDUS ? (this.tempBuff = [], this.state = Pm, this._emitChars("/")) : this._reconsumeInState(yr);
  }
  [Pm](t) {
    Mt(t) || t === R.SOLIDUS || t === R.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? tr : yr, this._emitCodePoint(t)) : nr(t) ? (this.tempBuff.push(oo(t)), this._emitCodePoint(t)) : da(t) ? (this.tempBuff.push(t), this._emitCodePoint(t)) : this._reconsumeInState(yr);
  }
  [fr](t) {
    Mt(t) || (t === R.SOLIDUS || t === R.GREATER_THAN_SIGN || t === R.EOF ? this._reconsumeInState(_u) : t === R.EQUALS_SIGN ? (this._err(re.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = U1) : (this._createAttr(""), this._reconsumeInState(U1)));
  }
  [U1](t) {
    Mt(t) || t === R.SOLIDUS || t === R.GREATER_THAN_SIGN || t === R.EOF ? (this._leaveAttrName(_u), this._unconsume()) : t === R.EQUALS_SIGN ? this._leaveAttrName(bu) : nr(t) ? this.currentAttr.name += Wr(t) : t === R.QUOTATION_MARK || t === R.APOSTROPHE || t === R.LESS_THAN_SIGN ? (this._err(re.unexpectedCharacterInAttributeName), this.currentAttr.name += zt(t)) : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.currentAttr.name += bt.REPLACEMENT_CHARACTER) : this.currentAttr.name += zt(t);
  }
  [_u](t) {
    Mt(t) || (t === R.SOLIDUS ? this.state = Yr : t === R.EQUALS_SIGN ? this.state = bu : t === R.GREATER_THAN_SIGN ? (this.state = Je, this._emitCurrentToken()) : t === R.EOF ? (this._err(re.eofInTag), this._emitEOFToken()) : (this._createAttr(""), this._reconsumeInState(U1)));
  }
  [bu](t) {
    Mt(t) || (t === R.QUOTATION_MARK ? this.state = j1 : t === R.APOSTROPHE ? this.state = z1 : t === R.GREATER_THAN_SIGN ? (this._err(re.missingAttributeValue), this.state = Je, this._emitCurrentToken()) : this._reconsumeInState(G1));
  }
  [j1](t) {
    t === R.QUOTATION_MARK ? this.state = yu : t === R.AMPERSAND ? (this.returnState = j1, this.state = Ga) : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.currentAttr.value += bt.REPLACEMENT_CHARACTER) : t === R.EOF ? (this._err(re.eofInTag), this._emitEOFToken()) : this.currentAttr.value += zt(t);
  }
  [z1](t) {
    t === R.APOSTROPHE ? this.state = yu : t === R.AMPERSAND ? (this.returnState = z1, this.state = Ga) : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.currentAttr.value += bt.REPLACEMENT_CHARACTER) : t === R.EOF ? (this._err(re.eofInTag), this._emitEOFToken()) : this.currentAttr.value += zt(t);
  }
  [G1](t) {
    Mt(t) ? this._leaveAttrValue(fr) : t === R.AMPERSAND ? (this.returnState = G1, this.state = Ga) : t === R.GREATER_THAN_SIGN ? (this._leaveAttrValue(Je), this._emitCurrentToken()) : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.currentAttr.value += bt.REPLACEMENT_CHARACTER) : t === R.QUOTATION_MARK || t === R.APOSTROPHE || t === R.LESS_THAN_SIGN || t === R.EQUALS_SIGN || t === R.GRAVE_ACCENT ? (this._err(re.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += zt(t)) : t === R.EOF ? (this._err(re.eofInTag), this._emitEOFToken()) : this.currentAttr.value += zt(t);
  }
  [yu](t) {
    Mt(t) ? this._leaveAttrValue(fr) : t === R.SOLIDUS ? this._leaveAttrValue(Yr) : t === R.GREATER_THAN_SIGN ? (this._leaveAttrValue(Je), this._emitCurrentToken()) : t === R.EOF ? (this._err(re.eofInTag), this._emitEOFToken()) : (this._err(re.missingWhitespaceBetweenAttributes), this._reconsumeInState(fr));
  }
  [Yr](t) {
    t === R.GREATER_THAN_SIGN ? (this.currentToken.selfClosing = !0, this.state = Je, this._emitCurrentToken()) : t === R.EOF ? (this._err(re.eofInTag), this._emitEOFToken()) : (this._err(re.unexpectedSolidusInTag), this._reconsumeInState(fr));
  }
  [Bi](t) {
    t === R.GREATER_THAN_SIGN ? (this.state = Je, this._emitCurrentToken()) : t === R.EOF ? (this._emitCurrentToken(), this._emitEOFToken()) : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.currentToken.data += bt.REPLACEMENT_CHARACTER) : this.currentToken.data += zt(t);
  }
  [Bm](t) {
    this._consumeSequenceIfMatch(la.DASH_DASH_STRING, t, !0) ? (this._createCommentToken(), this.state = Fm) : this._consumeSequenceIfMatch(la.DOCTYPE_STRING, t, !1) ? this.state = Gm : this._consumeSequenceIfMatch(la.CDATA_START_STRING, t, !0) ? this.allowCDATA ? this.state = q1 : (this._err(re.cdataInHtmlContent), this._createCommentToken(), this.currentToken.data = "[CDATA[", this.state = Bi) : this._ensureHibernation() || (this._err(re.incorrectlyOpenedComment), this._createCommentToken(), this._reconsumeInState(Bi));
  }
  [Fm](t) {
    t === R.HYPHEN_MINUS ? this.state = Lm : t === R.GREATER_THAN_SIGN ? (this._err(re.abruptClosingOfEmptyComment), this.state = Je, this._emitCurrentToken()) : this._reconsumeInState(Kr);
  }
  [Lm](t) {
    t === R.HYPHEN_MINUS ? this.state = Y1 : t === R.GREATER_THAN_SIGN ? (this._err(re.abruptClosingOfEmptyComment), this.state = Je, this._emitCurrentToken()) : t === R.EOF ? (this._err(re.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(Kr));
  }
  [Kr](t) {
    t === R.HYPHEN_MINUS ? this.state = V1 : t === R.LESS_THAN_SIGN ? (this.currentToken.data += "<", this.state = $m) : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.currentToken.data += bt.REPLACEMENT_CHARACTER) : t === R.EOF ? (this._err(re.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.data += zt(t);
  }
  [$m](t) {
    t === R.EXCLAMATION_MARK ? (this.currentToken.data += "!", this.state = Hm) : t === R.LESS_THAN_SIGN ? this.currentToken.data += "!" : this._reconsumeInState(Kr);
  }
  [Hm](t) {
    t === R.HYPHEN_MINUS ? this.state = Um : this._reconsumeInState(Kr);
  }
  [Um](t) {
    t === R.HYPHEN_MINUS ? this.state = jm : this._reconsumeInState(V1);
  }
  [jm](t) {
    t !== R.GREATER_THAN_SIGN && t !== R.EOF && this._err(re.nestedComment), this._reconsumeInState(Y1);
  }
  [V1](t) {
    t === R.HYPHEN_MINUS ? this.state = Y1 : t === R.EOF ? (this._err(re.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(Kr));
  }
  [Y1](t) {
    t === R.GREATER_THAN_SIGN ? (this.state = Je, this._emitCurrentToken()) : t === R.EXCLAMATION_MARK ? this.state = zm : t === R.HYPHEN_MINUS ? this.currentToken.data += "-" : t === R.EOF ? (this._err(re.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--", this._reconsumeInState(Kr));
  }
  [zm](t) {
    t === R.HYPHEN_MINUS ? (this.currentToken.data += "--!", this.state = V1) : t === R.GREATER_THAN_SIGN ? (this._err(re.incorrectlyClosedComment), this.state = Je, this._emitCurrentToken()) : t === R.EOF ? (this._err(re.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--!", this._reconsumeInState(Kr));
  }
  [Gm](t) {
    Mt(t) ? this.state = K1 : t === R.GREATER_THAN_SIGN ? this._reconsumeInState(K1) : t === R.EOF ? (this._err(re.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(re.missingWhitespaceBeforeDoctypeName), this._reconsumeInState(K1));
  }
  [K1](t) {
    Mt(t) || (nr(t) ? (this._createDoctypeToken(Wr(t)), this.state = W1) : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this._createDoctypeToken(bt.REPLACEMENT_CHARACTER), this.state = W1) : t === R.GREATER_THAN_SIGN ? (this._err(re.missingDoctypeName), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = Je) : t === R.EOF ? (this._err(re.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._createDoctypeToken(zt(t)), this.state = W1));
  }
  [W1](t) {
    Mt(t) ? this.state = Vm : t === R.GREATER_THAN_SIGN ? (this.state = Je, this._emitCurrentToken()) : nr(t) ? this.currentToken.name += Wr(t) : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.currentToken.name += bt.REPLACEMENT_CHARACTER) : t === R.EOF ? (this._err(re.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.name += zt(t);
  }
  [Vm](t) {
    Mt(t) || (t === R.GREATER_THAN_SIGN ? (this.state = Je, this._emitCurrentToken()) : t === R.EOF ? (this._err(re.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this._consumeSequenceIfMatch(la.PUBLIC_STRING, t, !1) ? this.state = Ym : this._consumeSequenceIfMatch(la.SYSTEM_STRING, t, !1) ? this.state = qm : this._ensureHibernation() || (this._err(re.invalidCharacterSequenceAfterDoctypeName), this.currentToken.forceQuirks = !0, this._reconsumeInState(Dr)));
  }
  [Ym](t) {
    Mt(t) ? this.state = Km : t === R.QUOTATION_MARK ? (this._err(re.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = Du) : t === R.APOSTROPHE ? (this._err(re.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = Su) : t === R.GREATER_THAN_SIGN ? (this._err(re.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = Je, this._emitCurrentToken()) : t === R.EOF ? (this._err(re.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(re.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Dr));
  }
  [Km](t) {
    Mt(t) || (t === R.QUOTATION_MARK ? (this.currentToken.publicId = "", this.state = Du) : t === R.APOSTROPHE ? (this.currentToken.publicId = "", this.state = Su) : t === R.GREATER_THAN_SIGN ? (this._err(re.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = Je, this._emitCurrentToken()) : t === R.EOF ? (this._err(re.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(re.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Dr)));
  }
  [Du](t) {
    t === R.QUOTATION_MARK ? this.state = Ou : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.currentToken.publicId += bt.REPLACEMENT_CHARACTER) : t === R.GREATER_THAN_SIGN ? (this._err(re.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = Je) : t === R.EOF ? (this._err(re.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += zt(t);
  }
  [Su](t) {
    t === R.APOSTROPHE ? this.state = Ou : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.currentToken.publicId += bt.REPLACEMENT_CHARACTER) : t === R.GREATER_THAN_SIGN ? (this._err(re.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = Je) : t === R.EOF ? (this._err(re.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += zt(t);
  }
  [Ou](t) {
    Mt(t) ? this.state = Wm : t === R.GREATER_THAN_SIGN ? (this.state = Je, this._emitCurrentToken()) : t === R.QUOTATION_MARK ? (this._err(re.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = Fi) : t === R.APOSTROPHE ? (this._err(re.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = Li) : t === R.EOF ? (this._err(re.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(re.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Dr));
  }
  [Wm](t) {
    Mt(t) || (t === R.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = Je) : t === R.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = Fi) : t === R.APOSTROPHE ? (this.currentToken.systemId = "", this.state = Li) : t === R.EOF ? (this._err(re.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(re.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Dr)));
  }
  [qm](t) {
    Mt(t) ? this.state = Xm : t === R.QUOTATION_MARK ? (this._err(re.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = Fi) : t === R.APOSTROPHE ? (this._err(re.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = Li) : t === R.GREATER_THAN_SIGN ? (this._err(re.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = Je, this._emitCurrentToken()) : t === R.EOF ? (this._err(re.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(re.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Dr));
  }
  [Xm](t) {
    Mt(t) || (t === R.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = Fi) : t === R.APOSTROPHE ? (this.currentToken.systemId = "", this.state = Li) : t === R.GREATER_THAN_SIGN ? (this._err(re.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = Je, this._emitCurrentToken()) : t === R.EOF ? (this._err(re.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(re.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(Dr)));
  }
  [Fi](t) {
    t === R.QUOTATION_MARK ? this.state = Nu : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.currentToken.systemId += bt.REPLACEMENT_CHARACTER) : t === R.GREATER_THAN_SIGN ? (this._err(re.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = Je) : t === R.EOF ? (this._err(re.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += zt(t);
  }
  [Li](t) {
    t === R.APOSTROPHE ? this.state = Nu : t === R.NULL ? (this._err(re.unexpectedNullCharacter), this.currentToken.systemId += bt.REPLACEMENT_CHARACTER) : t === R.GREATER_THAN_SIGN ? (this._err(re.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = Je) : t === R.EOF ? (this._err(re.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += zt(t);
  }
  [Nu](t) {
    Mt(t) || (t === R.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = Je) : t === R.EOF ? (this._err(re.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(re.unexpectedCharacterAfterDoctypeSystemIdentifier), this._reconsumeInState(Dr)));
  }
  [Dr](t) {
    t === R.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = Je) : t === R.NULL ? this._err(re.unexpectedNullCharacter) : t === R.EOF && (this._emitCurrentToken(), this._emitEOFToken());
  }
  [q1](t) {
    t === R.RIGHT_SQUARE_BRACKET ? this.state = Qm : t === R.EOF ? (this._err(re.eofInCdata), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  [Qm](t) {
    t === R.RIGHT_SQUARE_BRACKET ? this.state = Zm : (this._emitChars("]"), this._reconsumeInState(q1));
  }
  [Zm](t) {
    t === R.GREATER_THAN_SIGN ? this.state = Je : t === R.RIGHT_SQUARE_BRACKET ? this._emitChars("]") : (this._emitChars("]]"), this._reconsumeInState(q1));
  }
  [Ga](t) {
    this.tempBuff = [R.AMPERSAND], t === R.NUMBER_SIGN ? (this.tempBuff.push(t), this.state = t9) : wu(t) ? this._reconsumeInState(Jm) : (this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  [Jm](t) {
    const n = this._matchNamedCharacterReference(t);
    if (this._ensureHibernation())
      this.tempBuff = [R.AMPERSAND];
    else if (n) {
      const r = this.tempBuff[this.tempBuff.length - 1] === R.SEMICOLON;
      this._isCharacterReferenceAttributeQuirk(r) || (r || this._errOnNextCodePoint(re.missingSemicolonAfterCharacterReference), this.tempBuff = n), this._flushCodePointsConsumedAsCharacterReference(), this.state = this.returnState;
    } else
      this._flushCodePointsConsumedAsCharacterReference(), this.state = e9;
  }
  [e9](t) {
    wu(t) ? this._isCharacterReferenceInAttribute() ? this.currentAttr.value += zt(t) : this._emitCodePoint(t) : (t === R.SEMICOLON && this._err(re.unknownNamedCharacterReference), this._reconsumeInState(this.returnState));
  }
  [t9](t) {
    this.charRefCode = 0, t === R.LATIN_SMALL_X || t === R.LATIN_CAPITAL_X ? (this.tempBuff.push(t), this.state = n9) : this._reconsumeInState(r9);
  }
  [n9](t) {
    DR(t) ? this._reconsumeInState(a9) : (this._err(re.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  [r9](t) {
    Ji(t) ? this._reconsumeInState(i9) : (this._err(re.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  [a9](t) {
    Kg(t) ? this.charRefCode = this.charRefCode * 16 + t - 55 : Wg(t) ? this.charRefCode = this.charRefCode * 16 + t - 87 : Ji(t) ? this.charRefCode = this.charRefCode * 16 + t - 48 : t === R.SEMICOLON ? this.state = $i : (this._err(re.missingSemicolonAfterCharacterReference), this._reconsumeInState($i));
  }
  [i9](t) {
    Ji(t) ? this.charRefCode = this.charRefCode * 10 + t - 48 : t === R.SEMICOLON ? this.state = $i : (this._err(re.missingSemicolonAfterCharacterReference), this._reconsumeInState($i));
  }
  [$i]() {
    if (this.charRefCode === R.NULL)
      this._err(re.nullCharacterReference), this.charRefCode = R.REPLACEMENT_CHARACTER;
    else if (this.charRefCode > 1114111)
      this._err(re.characterReferenceOutsideUnicodeRange), this.charRefCode = R.REPLACEMENT_CHARACTER;
    else if (bt.isSurrogate(this.charRefCode))
      this._err(re.surrogateCharacterReference), this.charRefCode = R.REPLACEMENT_CHARACTER;
    else if (bt.isUndefinedCodePoint(this.charRefCode))
      this._err(re.noncharacterCharacterReference);
    else if (bt.isControlCodePoint(this.charRefCode) || this.charRefCode === R.CARRIAGE_RETURN) {
      this._err(re.controlCharacterReference);
      const t = bR[this.charRefCode];
      t && (this.charRefCode = t);
    }
    this.tempBuff = [this.charRefCode], this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState);
  }
}
Nt.CHARACTER_TOKEN = "CHARACTER_TOKEN";
Nt.NULL_CHARACTER_TOKEN = "NULL_CHARACTER_TOKEN";
Nt.WHITESPACE_CHARACTER_TOKEN = "WHITESPACE_CHARACTER_TOKEN";
Nt.START_TAG_TOKEN = "START_TAG_TOKEN";
Nt.END_TAG_TOKEN = "END_TAG_TOKEN";
Nt.COMMENT_TOKEN = "COMMENT_TOKEN";
Nt.DOCTYPE_TOKEN = "DOCTYPE_TOKEN";
Nt.EOF_TOKEN = "EOF_TOKEN";
Nt.HIBERNATION_TOKEN = "HIBERNATION_TOKEN";
Nt.MODE = {
  DATA: Je,
  RCDATA: Wa,
  RAWTEXT: Wi,
  SCRIPT_DATA: wr,
  PLAINTEXT: Yg
};
Nt.getTokenAttr = function(e, t) {
  for (let n = e.attrs.length - 1; n >= 0; n--)
    if (e.attrs[n].name === t)
      return e.attrs[n].value;
  return null;
};
var ts = Nt, lr = {};
const Iu = lr.NAMESPACES = {
  HTML: "http://www.w3.org/1999/xhtml",
  MATHML: "http://www.w3.org/1998/Math/MathML",
  SVG: "http://www.w3.org/2000/svg",
  XLINK: "http://www.w3.org/1999/xlink",
  XML: "http://www.w3.org/XML/1998/namespace",
  XMLNS: "http://www.w3.org/2000/xmlns/"
};
lr.ATTRS = {
  TYPE: "type",
  ACTION: "action",
  ENCODING: "encoding",
  PROMPT: "prompt",
  NAME: "name",
  COLOR: "color",
  FACE: "face",
  SIZE: "size"
};
lr.DOCUMENT_MODE = {
  NO_QUIRKS: "no-quirks",
  QUIRKS: "quirks",
  LIMITED_QUIRKS: "limited-quirks"
};
const pe = lr.TAG_NAMES = {
  A: "a",
  ADDRESS: "address",
  ANNOTATION_XML: "annotation-xml",
  APPLET: "applet",
  AREA: "area",
  ARTICLE: "article",
  ASIDE: "aside",
  B: "b",
  BASE: "base",
  BASEFONT: "basefont",
  BGSOUND: "bgsound",
  BIG: "big",
  BLOCKQUOTE: "blockquote",
  BODY: "body",
  BR: "br",
  BUTTON: "button",
  CAPTION: "caption",
  CENTER: "center",
  CODE: "code",
  COL: "col",
  COLGROUP: "colgroup",
  DD: "dd",
  DESC: "desc",
  DETAILS: "details",
  DIALOG: "dialog",
  DIR: "dir",
  DIV: "div",
  DL: "dl",
  DT: "dt",
  EM: "em",
  EMBED: "embed",
  FIELDSET: "fieldset",
  FIGCAPTION: "figcaption",
  FIGURE: "figure",
  FONT: "font",
  FOOTER: "footer",
  FOREIGN_OBJECT: "foreignObject",
  FORM: "form",
  FRAME: "frame",
  FRAMESET: "frameset",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6",
  HEAD: "head",
  HEADER: "header",
  HGROUP: "hgroup",
  HR: "hr",
  HTML: "html",
  I: "i",
  IMG: "img",
  IMAGE: "image",
  INPUT: "input",
  IFRAME: "iframe",
  KEYGEN: "keygen",
  LABEL: "label",
  LI: "li",
  LINK: "link",
  LISTING: "listing",
  MAIN: "main",
  MALIGNMARK: "malignmark",
  MARQUEE: "marquee",
  MATH: "math",
  MENU: "menu",
  META: "meta",
  MGLYPH: "mglyph",
  MI: "mi",
  MO: "mo",
  MN: "mn",
  MS: "ms",
  MTEXT: "mtext",
  NAV: "nav",
  NOBR: "nobr",
  NOFRAMES: "noframes",
  NOEMBED: "noembed",
  NOSCRIPT: "noscript",
  OBJECT: "object",
  OL: "ol",
  OPTGROUP: "optgroup",
  OPTION: "option",
  P: "p",
  PARAM: "param",
  PLAINTEXT: "plaintext",
  PRE: "pre",
  RB: "rb",
  RP: "rp",
  RT: "rt",
  RTC: "rtc",
  RUBY: "ruby",
  S: "s",
  SCRIPT: "script",
  SECTION: "section",
  SELECT: "select",
  SOURCE: "source",
  SMALL: "small",
  SPAN: "span",
  STRIKE: "strike",
  STRONG: "strong",
  STYLE: "style",
  SUB: "sub",
  SUMMARY: "summary",
  SUP: "sup",
  TABLE: "table",
  TBODY: "tbody",
  TEMPLATE: "template",
  TEXTAREA: "textarea",
  TFOOT: "tfoot",
  TD: "td",
  TH: "th",
  THEAD: "thead",
  TITLE: "title",
  TR: "tr",
  TRACK: "track",
  TT: "tt",
  U: "u",
  UL: "ul",
  SVG: "svg",
  VAR: "var",
  WBR: "wbr",
  XMP: "xmp"
};
lr.SPECIAL_ELEMENTS = {
  [Iu.HTML]: {
    [pe.ADDRESS]: !0,
    [pe.APPLET]: !0,
    [pe.AREA]: !0,
    [pe.ARTICLE]: !0,
    [pe.ASIDE]: !0,
    [pe.BASE]: !0,
    [pe.BASEFONT]: !0,
    [pe.BGSOUND]: !0,
    [pe.BLOCKQUOTE]: !0,
    [pe.BODY]: !0,
    [pe.BR]: !0,
    [pe.BUTTON]: !0,
    [pe.CAPTION]: !0,
    [pe.CENTER]: !0,
    [pe.COL]: !0,
    [pe.COLGROUP]: !0,
    [pe.DD]: !0,
    [pe.DETAILS]: !0,
    [pe.DIR]: !0,
    [pe.DIV]: !0,
    [pe.DL]: !0,
    [pe.DT]: !0,
    [pe.EMBED]: !0,
    [pe.FIELDSET]: !0,
    [pe.FIGCAPTION]: !0,
    [pe.FIGURE]: !0,
    [pe.FOOTER]: !0,
    [pe.FORM]: !0,
    [pe.FRAME]: !0,
    [pe.FRAMESET]: !0,
    [pe.H1]: !0,
    [pe.H2]: !0,
    [pe.H3]: !0,
    [pe.H4]: !0,
    [pe.H5]: !0,
    [pe.H6]: !0,
    [pe.HEAD]: !0,
    [pe.HEADER]: !0,
    [pe.HGROUP]: !0,
    [pe.HR]: !0,
    [pe.HTML]: !0,
    [pe.IFRAME]: !0,
    [pe.IMG]: !0,
    [pe.INPUT]: !0,
    [pe.LI]: !0,
    [pe.LINK]: !0,
    [pe.LISTING]: !0,
    [pe.MAIN]: !0,
    [pe.MARQUEE]: !0,
    [pe.MENU]: !0,
    [pe.META]: !0,
    [pe.NAV]: !0,
    [pe.NOEMBED]: !0,
    [pe.NOFRAMES]: !0,
    [pe.NOSCRIPT]: !0,
    [pe.OBJECT]: !0,
    [pe.OL]: !0,
    [pe.P]: !0,
    [pe.PARAM]: !0,
    [pe.PLAINTEXT]: !0,
    [pe.PRE]: !0,
    [pe.SCRIPT]: !0,
    [pe.SECTION]: !0,
    [pe.SELECT]: !0,
    [pe.SOURCE]: !0,
    [pe.STYLE]: !0,
    [pe.SUMMARY]: !0,
    [pe.TABLE]: !0,
    [pe.TBODY]: !0,
    [pe.TD]: !0,
    [pe.TEMPLATE]: !0,
    [pe.TEXTAREA]: !0,
    [pe.TFOOT]: !0,
    [pe.TH]: !0,
    [pe.THEAD]: !0,
    [pe.TITLE]: !0,
    [pe.TR]: !0,
    [pe.TRACK]: !0,
    [pe.UL]: !0,
    [pe.WBR]: !0,
    [pe.XMP]: !0
  },
  [Iu.MATHML]: {
    [pe.MI]: !0,
    [pe.MO]: !0,
    [pe.MN]: !0,
    [pe.MS]: !0,
    [pe.MTEXT]: !0,
    [pe.ANNOTATION_XML]: !0
  },
  [Iu.SVG]: {
    [pe.TITLE]: !0,
    [pe.FOREIGN_OBJECT]: !0,
    [pe.DESC]: !0
  }
};
const qg = lr, Te = qg.TAG_NAMES, yt = qg.NAMESPACES;
function s9(e) {
  switch (e.length) {
    case 1:
      return e === Te.P;
    case 2:
      return e === Te.RB || e === Te.RP || e === Te.RT || e === Te.DD || e === Te.DT || e === Te.LI;
    case 3:
      return e === Te.RTC;
    case 6:
      return e === Te.OPTION;
    case 8:
      return e === Te.OPTGROUP;
  }
  return !1;
}
function SR(e) {
  switch (e.length) {
    case 1:
      return e === Te.P;
    case 2:
      return e === Te.RB || e === Te.RP || e === Te.RT || e === Te.DD || e === Te.DT || e === Te.LI || e === Te.TD || e === Te.TH || e === Te.TR;
    case 3:
      return e === Te.RTC;
    case 5:
      return e === Te.TBODY || e === Te.TFOOT || e === Te.THEAD;
    case 6:
      return e === Te.OPTION;
    case 7:
      return e === Te.CAPTION;
    case 8:
      return e === Te.OPTGROUP || e === Te.COLGROUP;
  }
  return !1;
}
function X1(e, t) {
  switch (e.length) {
    case 2:
      if (e === Te.TD || e === Te.TH)
        return t === yt.HTML;
      if (e === Te.MI || e === Te.MO || e === Te.MN || e === Te.MS)
        return t === yt.MATHML;
      break;
    case 4:
      if (e === Te.HTML)
        return t === yt.HTML;
      if (e === Te.DESC)
        return t === yt.SVG;
      break;
    case 5:
      if (e === Te.TABLE)
        return t === yt.HTML;
      if (e === Te.MTEXT)
        return t === yt.MATHML;
      if (e === Te.TITLE)
        return t === yt.SVG;
      break;
    case 6:
      return (e === Te.APPLET || e === Te.OBJECT) && t === yt.HTML;
    case 7:
      return (e === Te.CAPTION || e === Te.MARQUEE) && t === yt.HTML;
    case 8:
      return e === Te.TEMPLATE && t === yt.HTML;
    case 13:
      return e === Te.FOREIGN_OBJECT && t === yt.SVG;
    case 14:
      return e === Te.ANNOTATION_XML && t === yt.MATHML;
  }
  return !1;
}
class OR {
  constructor(t, n) {
    this.stackTop = -1, this.items = [], this.current = t, this.currentTagName = null, this.currentTmplContent = null, this.tmplCount = 0, this.treeAdapter = n;
  }
  _indexOf(t) {
    let n = -1;
    for (let r = this.stackTop; r >= 0; r--)
      if (this.items[r] === t) {
        n = r;
        break;
      }
    return n;
  }
  _isInTemplate() {
    return this.currentTagName === Te.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === yt.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagName = this.current && this.treeAdapter.getTagName(this.current), this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
  }
  push(t) {
    this.items[++this.stackTop] = t, this._updateCurrentElement(), this._isInTemplate() && this.tmplCount++;
  }
  pop() {
    this.stackTop--, this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this._updateCurrentElement();
  }
  replace(t, n) {
    const r = this._indexOf(t);
    this.items[r] = n, r === this.stackTop && this._updateCurrentElement();
  }
  insertAfter(t, n) {
    const r = this._indexOf(t) + 1;
    this.items.splice(r, 0, n), r === ++this.stackTop && this._updateCurrentElement();
  }
  popUntilTagNamePopped(t) {
    for (; this.stackTop > -1; ) {
      const n = this.currentTagName, r = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), n === t && r === yt.HTML)
        break;
    }
  }
  popUntilElementPopped(t) {
    for (; this.stackTop > -1; ) {
      const n = this.current;
      if (this.pop(), n === t)
        break;
    }
  }
  popUntilNumberedHeaderPopped() {
    for (; this.stackTop > -1; ) {
      const t = this.currentTagName, n = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), t === Te.H1 || t === Te.H2 || t === Te.H3 || t === Te.H4 || t === Te.H5 || t === Te.H6 && n === yt.HTML)
        break;
    }
  }
  popUntilTableCellPopped() {
    for (; this.stackTop > -1; ) {
      const t = this.currentTagName, n = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), t === Te.TD || t === Te.TH && n === yt.HTML)
        break;
    }
  }
  popAllUpToHtmlElement() {
    this.stackTop = 0, this._updateCurrentElement();
  }
  clearBackToTableContext() {
    for (; this.currentTagName !== Te.TABLE && this.currentTagName !== Te.TEMPLATE && this.currentTagName !== Te.HTML || this.treeAdapter.getNamespaceURI(this.current) !== yt.HTML; )
      this.pop();
  }
  clearBackToTableBodyContext() {
    for (; this.currentTagName !== Te.TBODY && this.currentTagName !== Te.TFOOT && this.currentTagName !== Te.THEAD && this.currentTagName !== Te.TEMPLATE && this.currentTagName !== Te.HTML || this.treeAdapter.getNamespaceURI(this.current) !== yt.HTML; )
      this.pop();
  }
  clearBackToTableRowContext() {
    for (; this.currentTagName !== Te.TR && this.currentTagName !== Te.TEMPLATE && this.currentTagName !== Te.HTML || this.treeAdapter.getNamespaceURI(this.current) !== yt.HTML; )
      this.pop();
  }
  remove(t) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.items[n] === t) {
        this.items.splice(n, 1), this.stackTop--, this._updateCurrentElement();
        break;
      }
  }
  tryPeekProperlyNestedBodyElement() {
    const t = this.items[1];
    return t && this.treeAdapter.getTagName(t) === Te.BODY ? t : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    let n = this._indexOf(t);
    return --n >= 0 ? this.items[n] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.currentTagName === Te.HTML;
  }
  hasInScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]), a = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === t && a === yt.HTML)
        return !0;
      if (X1(r, a))
        return !1;
    }
    return !0;
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]), r = this.treeAdapter.getNamespaceURI(this.items[t]);
      if ((n === Te.H1 || n === Te.H2 || n === Te.H3 || n === Te.H4 || n === Te.H5 || n === Te.H6) && r === yt.HTML)
        return !0;
      if (X1(n, r))
        return !1;
    }
    return !0;
  }
  hasInListItemScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]), a = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === t && a === yt.HTML)
        return !0;
      if ((r === Te.UL || r === Te.OL) && a === yt.HTML || X1(r, a))
        return !1;
    }
    return !0;
  }
  hasInButtonScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]), a = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === t && a === yt.HTML)
        return !0;
      if (r === Te.BUTTON && a === yt.HTML || X1(r, a))
        return !1;
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]);
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === yt.HTML) {
        if (r === t)
          return !0;
        if (r === Te.TABLE || r === Te.TEMPLATE || r === Te.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]);
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === yt.HTML) {
        if (n === Te.TBODY || n === Te.THEAD || n === Te.TFOOT)
          return !0;
        if (n === Te.TABLE || n === Te.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasInSelectScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]);
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === yt.HTML) {
        if (r === t)
          return !0;
        if (r !== Te.OPTION && r !== Te.OPTGROUP)
          return !1;
      }
    }
    return !0;
  }
  generateImpliedEndTags() {
    for (; s9(this.currentTagName); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; SR(this.currentTagName); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; s9(this.currentTagName) && this.currentTagName !== t; )
      this.pop();
  }
}
var NR = OR;
const Q1 = 3;
class ir {
  constructor(t) {
    this.length = 0, this.entries = [], this.treeAdapter = t, this.bookmark = null;
  }
  _getNoahArkConditionCandidates(t) {
    const n = [];
    if (this.length >= Q1) {
      const r = this.treeAdapter.getAttrList(t).length, a = this.treeAdapter.getTagName(t), i = this.treeAdapter.getNamespaceURI(t);
      for (let o = this.length - 1; o >= 0; o--) {
        const s = this.entries[o];
        if (s.type === ir.MARKER_ENTRY)
          break;
        const u = s.element, l = this.treeAdapter.getAttrList(u);
        this.treeAdapter.getTagName(u) === a && this.treeAdapter.getNamespaceURI(u) === i && l.length === r && n.push({ idx: o, attrs: l });
      }
    }
    return n.length < Q1 ? [] : n;
  }
  _ensureNoahArkCondition(t) {
    const n = this._getNoahArkConditionCandidates(t);
    let r = n.length;
    if (r) {
      const a = this.treeAdapter.getAttrList(t), i = a.length, o = /* @__PURE__ */ Object.create(null);
      for (let s = 0; s < i; s++) {
        const u = a[s];
        o[u.name] = u.value;
      }
      for (let s = 0; s < i; s++)
        for (let u = 0; u < r; u++) {
          const l = n[u].attrs[s];
          if (o[l.name] !== l.value && (n.splice(u, 1), r--), n.length < Q1)
            return;
        }
      for (let s = r - 1; s >= Q1 - 1; s--)
        this.entries.splice(n[s].idx, 1), this.length--;
    }
  }
  insertMarker() {
    this.entries.push({ type: ir.MARKER_ENTRY }), this.length++;
  }
  pushElement(t, n) {
    this._ensureNoahArkCondition(t), this.entries.push({
      type: ir.ELEMENT_ENTRY,
      element: t,
      token: n
    }), this.length++;
  }
  insertElementAfterBookmark(t, n) {
    let r = this.length - 1;
    for (; r >= 0 && this.entries[r] !== this.bookmark; r--)
      ;
    this.entries.splice(r + 1, 0, {
      type: ir.ELEMENT_ENTRY,
      element: t,
      token: n
    }), this.length++;
  }
  removeEntry(t) {
    for (let n = this.length - 1; n >= 0; n--)
      if (this.entries[n] === t) {
        this.entries.splice(n, 1), this.length--;
        break;
      }
  }
  clearToLastMarker() {
    for (; this.length; ) {
      const t = this.entries.pop();
      if (this.length--, t.type === ir.MARKER_ENTRY)
        break;
    }
  }
  getElementEntryInScopeWithTagName(t) {
    for (let n = this.length - 1; n >= 0; n--) {
      const r = this.entries[n];
      if (r.type === ir.MARKER_ENTRY)
        return null;
      if (this.treeAdapter.getTagName(r.element) === t)
        return r;
    }
    return null;
  }
  getElementEntry(t) {
    for (let n = this.length - 1; n >= 0; n--) {
      const r = this.entries[n];
      if (r.type === ir.ELEMENT_ENTRY && r.element === t)
        return r;
    }
    return null;
  }
}
ir.MARKER_ENTRY = "MARKER_ENTRY";
ir.ELEMENT_ENTRY = "ELEMENT_ENTRY";
var wR = ir;
class Xg {
  constructor(t) {
    const n = {}, r = this._getOverriddenMethods(this, n);
    for (const a of Object.keys(r))
      typeof r[a] == "function" && (n[a] = t[a], t[a] = r[a]);
  }
  _getOverriddenMethods() {
    throw new Error("Not implemented");
  }
}
Xg.install = function(e, t, n) {
  e.__mixins || (e.__mixins = []);
  for (let a = 0; a < e.__mixins.length; a++)
    if (e.__mixins[a].constructor === t)
      return e.__mixins[a];
  const r = new t(e, n);
  return e.__mixins.push(r), r;
};
var Lr = Xg;
const IR = Lr;
class RR extends IR {
  constructor(t) {
    super(t), this.preprocessor = t, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.offset = 0, this.col = 0, this.line = 1;
  }
  _getOverriddenMethods(t, n) {
    return {
      advance() {
        const r = this.pos + 1, a = this.html[r];
        return t.isEol && (t.isEol = !1, t.line++, t.lineStartPos = r), (a === `
` || a === "\r" && this.html[r + 1] !== `
`) && (t.isEol = !0), t.col = r - t.lineStartPos + 1, t.offset = t.droppedBufferSize + r, n.advance.call(this);
      },
      retreat() {
        n.retreat.call(this), t.isEol = !1, t.col = this.pos - t.lineStartPos + 1;
      },
      dropParsedChunk() {
        const r = this.pos;
        n.dropParsedChunk.call(this);
        const a = r - this.pos;
        t.lineStartPos -= a, t.droppedBufferSize += a, t.offset = t.droppedBufferSize + this.pos;
      }
    };
  }
}
var Qg = RR;
const u9 = Lr, Ru = ts, MR = Qg;
class xR extends u9 {
  constructor(t) {
    super(t), this.tokenizer = t, this.posTracker = u9.install(t.preprocessor, MR), this.currentAttrLocation = null, this.ctLoc = null;
  }
  _getCurrentLocation() {
    return {
      startLine: this.posTracker.line,
      startCol: this.posTracker.col,
      startOffset: this.posTracker.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
  }
  _attachCurrentAttrLocationInfo() {
    this.currentAttrLocation.endLine = this.posTracker.line, this.currentAttrLocation.endCol = this.posTracker.col, this.currentAttrLocation.endOffset = this.posTracker.offset;
    const t = this.tokenizer.currentToken, n = this.tokenizer.currentAttr;
    t.location.attrs || (t.location.attrs = /* @__PURE__ */ Object.create(null)), t.location.attrs[n.name] = this.currentAttrLocation;
  }
  _getOverriddenMethods(t, n) {
    const r = {
      _createStartTagToken() {
        n._createStartTagToken.call(this), this.currentToken.location = t.ctLoc;
      },
      _createEndTagToken() {
        n._createEndTagToken.call(this), this.currentToken.location = t.ctLoc;
      },
      _createCommentToken() {
        n._createCommentToken.call(this), this.currentToken.location = t.ctLoc;
      },
      _createDoctypeToken(a) {
        n._createDoctypeToken.call(this, a), this.currentToken.location = t.ctLoc;
      },
      _createCharacterToken(a, i) {
        n._createCharacterToken.call(this, a, i), this.currentCharacterToken.location = t.ctLoc;
      },
      _createEOFToken() {
        n._createEOFToken.call(this), this.currentToken.location = t._getCurrentLocation();
      },
      _createAttr(a) {
        n._createAttr.call(this, a), t.currentAttrLocation = t._getCurrentLocation();
      },
      _leaveAttrName(a) {
        n._leaveAttrName.call(this, a), t._attachCurrentAttrLocationInfo();
      },
      _leaveAttrValue(a) {
        n._leaveAttrValue.call(this, a), t._attachCurrentAttrLocationInfo();
      },
      _emitCurrentToken() {
        const a = this.currentToken.location;
        this.currentCharacterToken && (this.currentCharacterToken.location.endLine = a.startLine, this.currentCharacterToken.location.endCol = a.startCol, this.currentCharacterToken.location.endOffset = a.startOffset), this.currentToken.type === Ru.EOF_TOKEN ? (a.endLine = a.startLine, a.endCol = a.startCol, a.endOffset = a.startOffset) : (a.endLine = t.posTracker.line, a.endCol = t.posTracker.col + 1, a.endOffset = t.posTracker.offset + 1), n._emitCurrentToken.call(this);
      },
      _emitCurrentCharacterToken() {
        const a = this.currentCharacterToken && this.currentCharacterToken.location;
        a && a.endOffset === -1 && (a.endLine = t.posTracker.line, a.endCol = t.posTracker.col, a.endOffset = t.posTracker.offset), n._emitCurrentCharacterToken.call(this);
      }
    };
    return Object.keys(Ru.MODE).forEach((a) => {
      const i = Ru.MODE[a];
      r[i] = function(o) {
        t.ctLoc = t._getCurrentLocation(), n[i].call(this, o);
      };
    }), r;
  }
}
var Zg = xR;
const kR = Lr;
class PR extends kR {
  constructor(t, n) {
    super(t), this.onItemPop = n.onItemPop;
  }
  _getOverriddenMethods(t, n) {
    return {
      pop() {
        t.onItemPop(this.current), n.pop.call(this);
      },
      popAllUpToHtmlElement() {
        for (let r = this.stackTop; r > 0; r--)
          t.onItemPop(this.items[r]);
        n.popAllUpToHtmlElement.call(this);
      },
      remove(r) {
        t.onItemPop(this.current), n.remove.call(this, r);
      }
    };
  }
}
var BR = PR;
const Mu = Lr, l9 = ts, FR = Zg, LR = BR, $R = lr, xu = $R.TAG_NAMES;
class HR extends Mu {
  constructor(t) {
    super(t), this.parser = t, this.treeAdapter = this.parser.treeAdapter, this.posTracker = null, this.lastStartTagToken = null, this.lastFosterParentingLocation = null, this.currentToken = null;
  }
  _setStartLocation(t) {
    let n = null;
    this.lastStartTagToken && (n = Object.assign({}, this.lastStartTagToken.location), n.startTag = this.lastStartTagToken.location), this.treeAdapter.setNodeSourceCodeLocation(t, n);
  }
  _setEndLocation(t, n) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && n.location) {
      const a = n.location, i = this.treeAdapter.getTagName(t), o = n.type === l9.END_TAG_TOKEN && i === n.tagName, s = {};
      o ? (s.endTag = Object.assign({}, a), s.endLine = a.endLine, s.endCol = a.endCol, s.endOffset = a.endOffset) : (s.endLine = a.startLine, s.endCol = a.startCol, s.endOffset = a.startOffset), this.treeAdapter.updateNodeSourceCodeLocation(t, s);
    }
  }
  _getOverriddenMethods(t, n) {
    return {
      _bootstrap(r, a) {
        n._bootstrap.call(this, r, a), t.lastStartTagToken = null, t.lastFosterParentingLocation = null, t.currentToken = null;
        const i = Mu.install(this.tokenizer, FR);
        t.posTracker = i.posTracker, Mu.install(this.openElements, LR, {
          onItemPop: function(o) {
            t._setEndLocation(o, t.currentToken);
          }
        });
      },
      _runParsingLoop(r) {
        n._runParsingLoop.call(this, r);
        for (let a = this.openElements.stackTop; a >= 0; a--)
          t._setEndLocation(this.openElements.items[a], t.currentToken);
      },
      _processTokenInForeignContent(r) {
        t.currentToken = r, n._processTokenInForeignContent.call(this, r);
      },
      _processToken(r) {
        if (t.currentToken = r, n._processToken.call(this, r), r.type === l9.END_TAG_TOKEN && (r.tagName === xu.HTML || r.tagName === xu.BODY && this.openElements.hasInScope(xu.BODY)))
          for (let i = this.openElements.stackTop; i >= 0; i--) {
            const o = this.openElements.items[i];
            if (this.treeAdapter.getTagName(o) === r.tagName) {
              t._setEndLocation(o, r);
              break;
            }
          }
      },
      _setDocumentType(r) {
        n._setDocumentType.call(this, r);
        const a = this.treeAdapter.getChildNodes(this.document), i = a.length;
        for (let o = 0; o < i; o++) {
          const s = a[o];
          if (this.treeAdapter.isDocumentTypeNode(s)) {
            this.treeAdapter.setNodeSourceCodeLocation(s, r.location);
            break;
          }
        }
      },
      _attachElementToTree(r) {
        t._setStartLocation(r), t.lastStartTagToken = null, n._attachElementToTree.call(this, r);
      },
      _appendElement(r, a) {
        t.lastStartTagToken = r, n._appendElement.call(this, r, a);
      },
      _insertElement(r, a) {
        t.lastStartTagToken = r, n._insertElement.call(this, r, a);
      },
      _insertTemplate(r) {
        t.lastStartTagToken = r, n._insertTemplate.call(this, r);
        const a = this.treeAdapter.getTemplateContent(this.openElements.current);
        this.treeAdapter.setNodeSourceCodeLocation(a, null);
      },
      _insertFakeRootElement() {
        n._insertFakeRootElement.call(this), this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
      },
      _appendCommentNode(r, a) {
        n._appendCommentNode.call(this, r, a);
        const i = this.treeAdapter.getChildNodes(a), o = i[i.length - 1];
        this.treeAdapter.setNodeSourceCodeLocation(o, r.location);
      },
      _findFosterParentingLocation() {
        return t.lastFosterParentingLocation = n._findFosterParentingLocation.call(this), t.lastFosterParentingLocation;
      },
      _insertCharacters(r) {
        n._insertCharacters.call(this, r);
        const a = this._shouldFosterParentOnInsertion(), i = a && t.lastFosterParentingLocation.parent || this.openElements.currentTmplContent || this.openElements.current, o = this.treeAdapter.getChildNodes(i), s = a && t.lastFosterParentingLocation.beforeElement ? o.indexOf(t.lastFosterParentingLocation.beforeElement) - 1 : o.length - 1, u = o[s];
        if (this.treeAdapter.getNodeSourceCodeLocation(u)) {
          const { endLine: c, endCol: f, endOffset: E } = r.location;
          this.treeAdapter.updateNodeSourceCodeLocation(u, { endLine: c, endCol: f, endOffset: E });
        } else
          this.treeAdapter.setNodeSourceCodeLocation(u, r.location);
      }
    };
  }
}
var UR = HR;
const jR = Lr;
class zR extends jR {
  constructor(t, n) {
    super(t), this.posTracker = null, this.onParseError = n.onParseError;
  }
  _setErrorLocation(t) {
    t.startLine = t.endLine = this.posTracker.line, t.startCol = t.endCol = this.posTracker.col, t.startOffset = t.endOffset = this.posTracker.offset;
  }
  _reportError(t) {
    const n = {
      code: t,
      startLine: -1,
      startCol: -1,
      startOffset: -1,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    this._setErrorLocation(n), this.onParseError(n);
  }
  _getOverriddenMethods(t) {
    return {
      _err(n) {
        t._reportError(n);
      }
    };
  }
}
var lf = zR;
const GR = lf, VR = Qg, YR = Lr;
class KR extends GR {
  constructor(t, n) {
    super(t, n), this.posTracker = YR.install(t, VR), this.lastErrOffset = -1;
  }
  _reportError(t) {
    this.lastErrOffset !== this.posTracker.offset && (this.lastErrOffset = this.posTracker.offset, super._reportError(t));
  }
}
var WR = KR;
const qR = lf, XR = WR, QR = Lr;
class ZR extends qR {
  constructor(t, n) {
    super(t, n);
    const r = QR.install(t.preprocessor, XR, n);
    this.posTracker = r.posTracker;
  }
}
var JR = ZR;
const eM = lf, tM = JR, nM = Zg, c9 = Lr;
class rM extends eM {
  constructor(t, n) {
    super(t, n), this.opts = n, this.ctLoc = null, this.locBeforeToken = !1;
  }
  _setErrorLocation(t) {
    this.ctLoc && (t.startLine = this.ctLoc.startLine, t.startCol = this.ctLoc.startCol, t.startOffset = this.ctLoc.startOffset, t.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine, t.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol, t.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset);
  }
  _getOverriddenMethods(t, n) {
    return {
      _bootstrap(r, a) {
        n._bootstrap.call(this, r, a), c9.install(this.tokenizer, tM, t.opts), c9.install(this.tokenizer, nM);
      },
      _processInputToken(r) {
        t.ctLoc = r.location, n._processInputToken.call(this, r);
      },
      _err(r, a) {
        t.locBeforeToken = a && a.beforeToken, t._reportError(r);
      }
    };
  }
}
var aM = rM, st = {};
const { DOCUMENT_MODE: iM } = lr;
st.createDocument = function() {
  return {
    nodeName: "#document",
    mode: iM.NO_QUIRKS,
    childNodes: []
  };
};
st.createDocumentFragment = function() {
  return {
    nodeName: "#document-fragment",
    childNodes: []
  };
};
st.createElement = function(e, t, n) {
  return {
    nodeName: e,
    tagName: e,
    attrs: n,
    namespaceURI: t,
    childNodes: [],
    parentNode: null
  };
};
st.createCommentNode = function(e) {
  return {
    nodeName: "#comment",
    data: e,
    parentNode: null
  };
};
const Jg = function(e) {
  return {
    nodeName: "#text",
    value: e,
    parentNode: null
  };
}, e2 = st.appendChild = function(e, t) {
  e.childNodes.push(t), t.parentNode = e;
}, oM = st.insertBefore = function(e, t, n) {
  const r = e.childNodes.indexOf(n);
  e.childNodes.splice(r, 0, t), t.parentNode = e;
};
st.setTemplateContent = function(e, t) {
  e.content = t;
};
st.getTemplateContent = function(e) {
  return e.content;
};
st.setDocumentType = function(e, t, n, r) {
  let a = null;
  for (let i = 0; i < e.childNodes.length; i++)
    if (e.childNodes[i].nodeName === "#documentType") {
      a = e.childNodes[i];
      break;
    }
  a ? (a.name = t, a.publicId = n, a.systemId = r) : e2(e, {
    nodeName: "#documentType",
    name: t,
    publicId: n,
    systemId: r
  });
};
st.setDocumentMode = function(e, t) {
  e.mode = t;
};
st.getDocumentMode = function(e) {
  return e.mode;
};
st.detachNode = function(e) {
  if (e.parentNode) {
    const t = e.parentNode.childNodes.indexOf(e);
    e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
  }
};
st.insertText = function(e, t) {
  if (e.childNodes.length) {
    const n = e.childNodes[e.childNodes.length - 1];
    if (n.nodeName === "#text") {
      n.value += t;
      return;
    }
  }
  e2(e, Jg(t));
};
st.insertTextBefore = function(e, t, n) {
  const r = e.childNodes[e.childNodes.indexOf(n) - 1];
  r && r.nodeName === "#text" ? r.value += t : oM(e, Jg(t), n);
};
st.adoptAttributes = function(e, t) {
  const n = [];
  for (let r = 0; r < e.attrs.length; r++)
    n.push(e.attrs[r].name);
  for (let r = 0; r < t.length; r++)
    n.indexOf(t[r].name) === -1 && e.attrs.push(t[r]);
};
st.getFirstChild = function(e) {
  return e.childNodes[0];
};
st.getChildNodes = function(e) {
  return e.childNodes;
};
st.getParentNode = function(e) {
  return e.parentNode;
};
st.getAttrList = function(e) {
  return e.attrs;
};
st.getTagName = function(e) {
  return e.tagName;
};
st.getNamespaceURI = function(e) {
  return e.namespaceURI;
};
st.getTextNodeContent = function(e) {
  return e.value;
};
st.getCommentNodeContent = function(e) {
  return e.data;
};
st.getDocumentTypeNodeName = function(e) {
  return e.name;
};
st.getDocumentTypeNodePublicId = function(e) {
  return e.publicId;
};
st.getDocumentTypeNodeSystemId = function(e) {
  return e.systemId;
};
st.isTextNode = function(e) {
  return e.nodeName === "#text";
};
st.isCommentNode = function(e) {
  return e.nodeName === "#comment";
};
st.isDocumentTypeNode = function(e) {
  return e.nodeName === "#documentType";
};
st.isElementNode = function(e) {
  return !!e.tagName;
};
st.setNodeSourceCodeLocation = function(e, t) {
  e.sourceCodeLocation = t;
};
st.getNodeSourceCodeLocation = function(e) {
  return e.sourceCodeLocation;
};
st.updateNodeSourceCodeLocation = function(e, t) {
  e.sourceCodeLocation = Object.assign(e.sourceCodeLocation, t);
};
var sM = function(t, n) {
  return n = n || /* @__PURE__ */ Object.create(null), [t, n].reduce((r, a) => (Object.keys(a).forEach((i) => {
    r[i] = a[i];
  }), r), /* @__PURE__ */ Object.create(null));
}, ns = {};
const { DOCUMENT_MODE: Va } = lr, t2 = "html", uM = "about:legacy-compat", lM = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", n2 = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], cM = n2.concat([
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
]), fM = ["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"], r2 = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], hM = r2.concat([
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
]);
function f9(e) {
  const t = e.indexOf('"') !== -1 ? "'" : '"';
  return t + e + t;
}
function h9(e, t) {
  for (let n = 0; n < t.length; n++)
    if (e.indexOf(t[n]) === 0)
      return !0;
  return !1;
}
ns.isConforming = function(e) {
  return e.name === t2 && e.publicId === null && (e.systemId === null || e.systemId === uM);
};
ns.getDocumentMode = function(e) {
  if (e.name !== t2)
    return Va.QUIRKS;
  const t = e.systemId;
  if (t && t.toLowerCase() === lM)
    return Va.QUIRKS;
  let n = e.publicId;
  if (n !== null) {
    if (n = n.toLowerCase(), fM.indexOf(n) > -1)
      return Va.QUIRKS;
    let r = t === null ? cM : n2;
    if (h9(n, r))
      return Va.QUIRKS;
    if (r = t === null ? r2 : hM, h9(n, r))
      return Va.LIMITED_QUIRKS;
  }
  return Va.NO_QUIRKS;
};
ns.serializeContent = function(e, t, n) {
  let r = "!DOCTYPE ";
  return e && (r += e), t ? r += " PUBLIC " + f9(t) : n && (r += " SYSTEM"), n !== null && (r += " " + f9(n)), r;
};
var aa = {};
const ku = ts, cf = lr, xe = cf.TAG_NAMES, nn = cf.NAMESPACES, so = cf.ATTRS, d9 = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, dM = "definitionurl", mM = "definitionURL", pM = {
  attributename: "attributeName",
  attributetype: "attributeType",
  basefrequency: "baseFrequency",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  clippathunits: "clipPathUnits",
  diffuseconstant: "diffuseConstant",
  edgemode: "edgeMode",
  filterunits: "filterUnits",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  limitingconeangle: "limitingConeAngle",
  markerheight: "markerHeight",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textlength: "textLength",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  xchannelselector: "xChannelSelector",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan"
}, gM = {
  "xlink:actuate": { prefix: "xlink", name: "actuate", namespace: nn.XLINK },
  "xlink:arcrole": { prefix: "xlink", name: "arcrole", namespace: nn.XLINK },
  "xlink:href": { prefix: "xlink", name: "href", namespace: nn.XLINK },
  "xlink:role": { prefix: "xlink", name: "role", namespace: nn.XLINK },
  "xlink:show": { prefix: "xlink", name: "show", namespace: nn.XLINK },
  "xlink:title": { prefix: "xlink", name: "title", namespace: nn.XLINK },
  "xlink:type": { prefix: "xlink", name: "type", namespace: nn.XLINK },
  "xml:base": { prefix: "xml", name: "base", namespace: nn.XML },
  "xml:lang": { prefix: "xml", name: "lang", namespace: nn.XML },
  "xml:space": { prefix: "xml", name: "space", namespace: nn.XML },
  xmlns: { prefix: "", name: "xmlns", namespace: nn.XMLNS },
  "xmlns:xlink": { prefix: "xmlns", name: "xlink", namespace: nn.XMLNS }
}, EM = aa.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
  altglyph: "altGlyph",
  altglyphdef: "altGlyphDef",
  altglyphitem: "altGlyphItem",
  animatecolor: "animateColor",
  animatemotion: "animateMotion",
  animatetransform: "animateTransform",
  clippath: "clipPath",
  feblend: "feBlend",
  fecolormatrix: "feColorMatrix",
  fecomponenttransfer: "feComponentTransfer",
  fecomposite: "feComposite",
  feconvolvematrix: "feConvolveMatrix",
  fediffuselighting: "feDiffuseLighting",
  fedisplacementmap: "feDisplacementMap",
  fedistantlight: "feDistantLight",
  feflood: "feFlood",
  fefunca: "feFuncA",
  fefuncb: "feFuncB",
  fefuncg: "feFuncG",
  fefuncr: "feFuncR",
  fegaussianblur: "feGaussianBlur",
  feimage: "feImage",
  femerge: "feMerge",
  femergenode: "feMergeNode",
  femorphology: "feMorphology",
  feoffset: "feOffset",
  fepointlight: "fePointLight",
  fespecularlighting: "feSpecularLighting",
  fespotlight: "feSpotLight",
  fetile: "feTile",
  feturbulence: "feTurbulence",
  foreignobject: "foreignObject",
  glyphref: "glyphRef",
  lineargradient: "linearGradient",
  radialgradient: "radialGradient",
  textpath: "textPath"
}, TM = {
  [xe.B]: !0,
  [xe.BIG]: !0,
  [xe.BLOCKQUOTE]: !0,
  [xe.BODY]: !0,
  [xe.BR]: !0,
  [xe.CENTER]: !0,
  [xe.CODE]: !0,
  [xe.DD]: !0,
  [xe.DIV]: !0,
  [xe.DL]: !0,
  [xe.DT]: !0,
  [xe.EM]: !0,
  [xe.EMBED]: !0,
  [xe.H1]: !0,
  [xe.H2]: !0,
  [xe.H3]: !0,
  [xe.H4]: !0,
  [xe.H5]: !0,
  [xe.H6]: !0,
  [xe.HEAD]: !0,
  [xe.HR]: !0,
  [xe.I]: !0,
  [xe.IMG]: !0,
  [xe.LI]: !0,
  [xe.LISTING]: !0,
  [xe.MENU]: !0,
  [xe.META]: !0,
  [xe.NOBR]: !0,
  [xe.OL]: !0,
  [xe.P]: !0,
  [xe.PRE]: !0,
  [xe.RUBY]: !0,
  [xe.S]: !0,
  [xe.SMALL]: !0,
  [xe.SPAN]: !0,
  [xe.STRONG]: !0,
  [xe.STRIKE]: !0,
  [xe.SUB]: !0,
  [xe.SUP]: !0,
  [xe.TABLE]: !0,
  [xe.TT]: !0,
  [xe.U]: !0,
  [xe.UL]: !0,
  [xe.VAR]: !0
};
aa.causesExit = function(e) {
  const t = e.tagName;
  return t === xe.FONT && (ku.getTokenAttr(e, so.COLOR) !== null || ku.getTokenAttr(e, so.SIZE) !== null || ku.getTokenAttr(e, so.FACE) !== null) ? !0 : TM[t];
};
aa.adjustTokenMathMLAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === dM) {
      e.attrs[t].name = mM;
      break;
    }
};
aa.adjustTokenSVGAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = pM[e.attrs[t].name];
    n && (e.attrs[t].name = n);
  }
};
aa.adjustTokenXMLAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = gM[e.attrs[t].name];
    n && (e.attrs[t].prefix = n.prefix, e.attrs[t].name = n.name, e.attrs[t].namespace = n.namespace);
  }
};
aa.adjustTokenSVGTagName = function(e) {
  const t = EM[e.tagName];
  t && (e.tagName = t);
};
function vM(e, t) {
  return t === nn.MATHML && (e === xe.MI || e === xe.MO || e === xe.MN || e === xe.MS || e === xe.MTEXT);
}
function AM(e, t, n) {
  if (t === nn.MATHML && e === xe.ANNOTATION_XML) {
    for (let r = 0; r < n.length; r++)
      if (n[r].name === so.ENCODING) {
        const a = n[r].value.toLowerCase();
        return a === d9.TEXT_HTML || a === d9.APPLICATION_XML;
      }
  }
  return t === nn.SVG && (e === xe.FOREIGN_OBJECT || e === xe.DESC || e === xe.TITLE);
}
aa.isIntegrationPoint = function(e, t, n, r) {
  return !!((!r || r === nn.HTML) && AM(e, t, n) || (!r || r === nn.MATHML) && vM(e, t));
};
const P = ts, CM = NR, m9 = wR, _M = UR, bM = aM, p9 = Lr, yM = st, DM = sM, g9 = ns, mr = aa, an = uf, SM = ur, Na = lr, d = Na.TAG_NAMES, Ie = Na.NAMESPACES, a2 = Na.ATTRS, OM = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  onParseError: null,
  treeAdapter: yM
}, i2 = "hidden", NM = 8, wM = 3, o2 = "INITIAL_MODE", ff = "BEFORE_HTML_MODE", rs = "BEFORE_HEAD_MODE", Ti = "IN_HEAD_MODE", s2 = "IN_HEAD_NO_SCRIPT_MODE", as = "AFTER_HEAD_MODE", gr = "IN_BODY_MODE", No = "TEXT_MODE", cn = "IN_TABLE_MODE", u2 = "IN_TABLE_TEXT_MODE", is = "IN_CAPTION_MODE", C1 = "IN_COLUMN_GROUP_MODE", Gn = "IN_TABLE_BODY_MODE", Pr = "IN_ROW_MODE", os = "IN_CELL_MODE", hf = "IN_SELECT_MODE", df = "IN_SELECT_IN_TABLE_MODE", wo = "IN_TEMPLATE_MODE", mf = "AFTER_BODY_MODE", ss = "IN_FRAMESET_MODE", l2 = "AFTER_FRAMESET_MODE", c2 = "AFTER_AFTER_BODY_MODE", f2 = "AFTER_AFTER_FRAMESET_MODE", IM = {
  [d.TR]: Pr,
  [d.TBODY]: Gn,
  [d.THEAD]: Gn,
  [d.TFOOT]: Gn,
  [d.CAPTION]: is,
  [d.COLGROUP]: C1,
  [d.TABLE]: cn,
  [d.BODY]: gr,
  [d.FRAMESET]: ss
}, RM = {
  [d.CAPTION]: cn,
  [d.COLGROUP]: cn,
  [d.TBODY]: cn,
  [d.TFOOT]: cn,
  [d.THEAD]: cn,
  [d.COL]: C1,
  [d.TR]: Gn,
  [d.TD]: Pr,
  [d.TH]: Pr
}, E9 = {
  [o2]: {
    [P.CHARACTER_TOKEN]: Ui,
    [P.NULL_CHARACTER_TOKEN]: Ui,
    [P.WHITESPACE_CHARACTER_TOKEN]: tt,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: UM,
    [P.START_TAG_TOKEN]: Ui,
    [P.END_TAG_TOKEN]: Ui,
    [P.EOF_TOKEN]: Ui
  },
  [ff]: {
    [P.CHARACTER_TOKEN]: e1,
    [P.NULL_CHARACTER_TOKEN]: e1,
    [P.WHITESPACE_CHARACTER_TOKEN]: tt,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: jM,
    [P.END_TAG_TOKEN]: zM,
    [P.EOF_TOKEN]: e1
  },
  [rs]: {
    [P.CHARACTER_TOKEN]: t1,
    [P.NULL_CHARACTER_TOKEN]: t1,
    [P.WHITESPACE_CHARACTER_TOKEN]: tt,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: Z1,
    [P.START_TAG_TOKEN]: GM,
    [P.END_TAG_TOKEN]: VM,
    [P.EOF_TOKEN]: t1
  },
  [Ti]: {
    [P.CHARACTER_TOKEN]: n1,
    [P.NULL_CHARACTER_TOKEN]: n1,
    [P.WHITESPACE_CHARACTER_TOKEN]: _n,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: Z1,
    [P.START_TAG_TOKEN]: Jt,
    [P.END_TAG_TOKEN]: wa,
    [P.EOF_TOKEN]: n1
  },
  [s2]: {
    [P.CHARACTER_TOKEN]: r1,
    [P.NULL_CHARACTER_TOKEN]: r1,
    [P.WHITESPACE_CHARACTER_TOKEN]: _n,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: Z1,
    [P.START_TAG_TOKEN]: YM,
    [P.END_TAG_TOKEN]: KM,
    [P.EOF_TOKEN]: r1
  },
  [as]: {
    [P.CHARACTER_TOKEN]: a1,
    [P.NULL_CHARACTER_TOKEN]: a1,
    [P.WHITESPACE_CHARACTER_TOKEN]: _n,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: Z1,
    [P.START_TAG_TOKEN]: WM,
    [P.END_TAG_TOKEN]: qM,
    [P.EOF_TOKEN]: a1
  },
  [gr]: {
    [P.CHARACTER_TOKEN]: J1,
    [P.NULL_CHARACTER_TOKEN]: tt,
    [P.WHITESPACE_CHARACTER_TOKEN]: ca,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: yn,
    [P.END_TAG_TOKEN]: pf,
    [P.EOF_TOKEN]: Or
  },
  [No]: {
    [P.CHARACTER_TOKEN]: _n,
    [P.NULL_CHARACTER_TOKEN]: _n,
    [P.WHITESPACE_CHARACTER_TOKEN]: _n,
    [P.COMMENT_TOKEN]: tt,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: tt,
    [P.END_TAG_TOKEN]: Sx,
    [P.EOF_TOKEN]: Ox
  },
  [cn]: {
    [P.CHARACTER_TOKEN]: Nr,
    [P.NULL_CHARACTER_TOKEN]: Nr,
    [P.WHITESPACE_CHARACTER_TOKEN]: Nr,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: gf,
    [P.END_TAG_TOKEN]: Ef,
    [P.EOF_TOKEN]: Or
  },
  [u2]: {
    [P.CHARACTER_TOKEN]: Fx,
    [P.NULL_CHARACTER_TOKEN]: tt,
    [P.WHITESPACE_CHARACTER_TOKEN]: Bx,
    [P.COMMENT_TOKEN]: ji,
    [P.DOCTYPE_TOKEN]: ji,
    [P.START_TAG_TOKEN]: ji,
    [P.END_TAG_TOKEN]: ji,
    [P.EOF_TOKEN]: ji
  },
  [is]: {
    [P.CHARACTER_TOKEN]: J1,
    [P.NULL_CHARACTER_TOKEN]: tt,
    [P.WHITESPACE_CHARACTER_TOKEN]: ca,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: Lx,
    [P.END_TAG_TOKEN]: $x,
    [P.EOF_TOKEN]: Or
  },
  [C1]: {
    [P.CHARACTER_TOKEN]: Io,
    [P.NULL_CHARACTER_TOKEN]: Io,
    [P.WHITESPACE_CHARACTER_TOKEN]: _n,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: Hx,
    [P.END_TAG_TOKEN]: Ux,
    [P.EOF_TOKEN]: Or
  },
  [Gn]: {
    [P.CHARACTER_TOKEN]: Nr,
    [P.NULL_CHARACTER_TOKEN]: Nr,
    [P.WHITESPACE_CHARACTER_TOKEN]: Nr,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: jx,
    [P.END_TAG_TOKEN]: zx,
    [P.EOF_TOKEN]: Or
  },
  [Pr]: {
    [P.CHARACTER_TOKEN]: Nr,
    [P.NULL_CHARACTER_TOKEN]: Nr,
    [P.WHITESPACE_CHARACTER_TOKEN]: Nr,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: Gx,
    [P.END_TAG_TOKEN]: Vx,
    [P.EOF_TOKEN]: Or
  },
  [os]: {
    [P.CHARACTER_TOKEN]: J1,
    [P.NULL_CHARACTER_TOKEN]: tt,
    [P.WHITESPACE_CHARACTER_TOKEN]: ca,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: Yx,
    [P.END_TAG_TOKEN]: Kx,
    [P.EOF_TOKEN]: Or
  },
  [hf]: {
    [P.CHARACTER_TOKEN]: _n,
    [P.NULL_CHARACTER_TOKEN]: tt,
    [P.WHITESPACE_CHARACTER_TOKEN]: _n,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: h2,
    [P.END_TAG_TOKEN]: d2,
    [P.EOF_TOKEN]: Or
  },
  [df]: {
    [P.CHARACTER_TOKEN]: _n,
    [P.NULL_CHARACTER_TOKEN]: tt,
    [P.WHITESPACE_CHARACTER_TOKEN]: _n,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: Wx,
    [P.END_TAG_TOKEN]: qx,
    [P.EOF_TOKEN]: Or
  },
  [wo]: {
    [P.CHARACTER_TOKEN]: J1,
    [P.NULL_CHARACTER_TOKEN]: tt,
    [P.WHITESPACE_CHARACTER_TOKEN]: ca,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: Xx,
    [P.END_TAG_TOKEN]: Qx,
    [P.EOF_TOKEN]: m2
  },
  [mf]: {
    [P.CHARACTER_TOKEN]: Ro,
    [P.NULL_CHARACTER_TOKEN]: Ro,
    [P.WHITESPACE_CHARACTER_TOKEN]: ca,
    [P.COMMENT_TOKEN]: HM,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: Zx,
    [P.END_TAG_TOKEN]: Jx,
    [P.EOF_TOKEN]: Hi
  },
  [ss]: {
    [P.CHARACTER_TOKEN]: tt,
    [P.NULL_CHARACTER_TOKEN]: tt,
    [P.WHITESPACE_CHARACTER_TOKEN]: _n,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: ek,
    [P.END_TAG_TOKEN]: tk,
    [P.EOF_TOKEN]: Hi
  },
  [l2]: {
    [P.CHARACTER_TOKEN]: tt,
    [P.NULL_CHARACTER_TOKEN]: tt,
    [P.WHITESPACE_CHARACTER_TOKEN]: _n,
    [P.COMMENT_TOKEN]: Wt,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: nk,
    [P.END_TAG_TOKEN]: rk,
    [P.EOF_TOKEN]: Hi
  },
  [c2]: {
    [P.CHARACTER_TOKEN]: uo,
    [P.NULL_CHARACTER_TOKEN]: uo,
    [P.WHITESPACE_CHARACTER_TOKEN]: ca,
    [P.COMMENT_TOKEN]: T9,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: ak,
    [P.END_TAG_TOKEN]: uo,
    [P.EOF_TOKEN]: Hi
  },
  [f2]: {
    [P.CHARACTER_TOKEN]: tt,
    [P.NULL_CHARACTER_TOKEN]: tt,
    [P.WHITESPACE_CHARACTER_TOKEN]: ca,
    [P.COMMENT_TOKEN]: T9,
    [P.DOCTYPE_TOKEN]: tt,
    [P.START_TAG_TOKEN]: ik,
    [P.END_TAG_TOKEN]: tt,
    [P.EOF_TOKEN]: Hi
  }
};
class MM {
  constructor(t) {
    this.options = DM(OM, t), this.treeAdapter = this.options.treeAdapter, this.pendingScript = null, this.options.sourceCodeLocationInfo && p9.install(this, _M), this.options.onParseError && p9.install(this, bM, { onParseError: this.options.onParseError });
  }
  parse(t) {
    const n = this.treeAdapter.createDocument();
    return this._bootstrap(n, null), this.tokenizer.write(t, !0), this._runParsingLoop(null), n;
  }
  parseFragment(t, n) {
    n || (n = this.treeAdapter.createElement(d.TEMPLATE, Ie.HTML, []));
    const r = this.treeAdapter.createElement("documentmock", Ie.HTML, []);
    this._bootstrap(r, n), this.treeAdapter.getTagName(n) === d.TEMPLATE && this._pushTmplInsertionMode(wo), this._initTokenizerForFragmentParsing(), this._insertFakeRootElement(), this._resetInsertionMode(), this._findFormInFragmentContext(), this.tokenizer.write(t, !0), this._runParsingLoop(null);
    const a = this.treeAdapter.getFirstChild(r), i = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(a, i), i;
  }
  _bootstrap(t, n) {
    this.tokenizer = new P(this.options), this.stopped = !1, this.insertionMode = o2, this.originalInsertionMode = "", this.document = t, this.fragmentContext = n, this.headElement = null, this.formElement = null, this.openElements = new CM(this.document, this.treeAdapter), this.activeFormattingElements = new m9(this.treeAdapter), this.tmplInsertionModeStack = [], this.tmplInsertionModeStackTop = -1, this.currentTmplInsertionMode = null, this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1;
  }
  _err() {
  }
  _runParsingLoop(t) {
    for (; !this.stopped; ) {
      this._setupTokenizerCDATAMode();
      const n = this.tokenizer.getNextToken();
      if (n.type === P.HIBERNATION_TOKEN)
        break;
      if (this.skipNextNewLine && (this.skipNextNewLine = !1, n.type === P.WHITESPACE_CHARACTER_TOKEN && n.chars[0] === `
`)) {
        if (n.chars.length === 1)
          continue;
        n.chars = n.chars.substr(1);
      }
      if (this._processInputToken(n), t && this.pendingScript)
        break;
    }
  }
  runParsingLoopForCurrentChunk(t, n) {
    if (this._runParsingLoop(n), n && this.pendingScript) {
      const r = this.pendingScript;
      this.pendingScript = null, n(r);
      return;
    }
    t && t();
  }
  _setupTokenizerCDATAMode() {
    const t = this._getAdjustedCurrentElement();
    this.tokenizer.allowCDATA = t && t !== this.document && this.treeAdapter.getNamespaceURI(t) !== Ie.HTML && !this._isIntegrationPoint(t);
  }
  _switchToTextParsing(t, n) {
    this._insertElement(t, Ie.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = No;
  }
  switchToPlaintextParsing() {
    this.insertionMode = No, this.originalInsertionMode = gr, this.tokenizer.state = P.MODE.PLAINTEXT;
  }
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    do {
      if (this.treeAdapter.getTagName(t) === d.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    } while (t);
  }
  _initTokenizerForFragmentParsing() {
    if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === Ie.HTML) {
      const t = this.treeAdapter.getTagName(this.fragmentContext);
      t === d.TITLE || t === d.TEXTAREA ? this.tokenizer.state = P.MODE.RCDATA : t === d.STYLE || t === d.XMP || t === d.IFRAME || t === d.NOEMBED || t === d.NOFRAMES || t === d.NOSCRIPT ? this.tokenizer.state = P.MODE.RAWTEXT : t === d.SCRIPT ? this.tokenizer.state = P.MODE.SCRIPT_DATA : t === d.PLAINTEXT && (this.tokenizer.state = P.MODE.PLAINTEXT);
    }
  }
  _setDocumentType(t) {
    const n = t.name || "", r = t.publicId || "", a = t.systemId || "";
    this.treeAdapter.setDocumentType(this.document, n, r, a);
  }
  _attachElementToTree(t) {
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const n = this.openElements.currentTmplContent || this.openElements.current;
      this.treeAdapter.appendChild(n, t);
    }
  }
  _appendElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r);
  }
  _insertElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r), this.openElements.push(r);
  }
  _insertFakeElement(t) {
    const n = this.treeAdapter.createElement(t, Ie.HTML, []);
    this._attachElementToTree(n), this.openElements.push(n);
  }
  _insertTemplate(t) {
    const n = this.treeAdapter.createElement(t.tagName, Ie.HTML, t.attrs), r = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, r), this._attachElementToTree(n), this.openElements.push(n);
  }
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(d.HTML, Ie.HTML, []);
    this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t);
  }
  _appendCommentNode(t, n) {
    const r = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(n, r);
  }
  _insertCharacters(t) {
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentText(t.chars);
    else {
      const n = this.openElements.currentTmplContent || this.openElements.current;
      this.treeAdapter.insertText(n, t.chars);
    }
  }
  _adoptNodes(t, n) {
    for (let r = this.treeAdapter.getFirstChild(t); r; r = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(r), this.treeAdapter.appendChild(n, r);
  }
  _shouldProcessTokenInForeignContent(t) {
    const n = this._getAdjustedCurrentElement();
    if (!n || n === this.document)
      return !1;
    const r = this.treeAdapter.getNamespaceURI(n);
    if (r === Ie.HTML || this.treeAdapter.getTagName(n) === d.ANNOTATION_XML && r === Ie.MATHML && t.type === P.START_TAG_TOKEN && t.tagName === d.SVG)
      return !1;
    const a = t.type === P.CHARACTER_TOKEN || t.type === P.NULL_CHARACTER_TOKEN || t.type === P.WHITESPACE_CHARACTER_TOKEN;
    return (t.type === P.START_TAG_TOKEN && t.tagName !== d.MGLYPH && t.tagName !== d.MALIGNMARK || a) && this._isIntegrationPoint(n, Ie.MATHML) || (t.type === P.START_TAG_TOKEN || a) && this._isIntegrationPoint(n, Ie.HTML) ? !1 : t.type !== P.EOF_TOKEN;
  }
  _processToken(t) {
    E9[this.insertionMode][t.type](this, t);
  }
  _processTokenInBodyMode(t) {
    E9[gr][t.type](this, t);
  }
  _processTokenInForeignContent(t) {
    t.type === P.CHARACTER_TOKEN ? sk(this, t) : t.type === P.NULL_CHARACTER_TOKEN ? ok(this, t) : t.type === P.WHITESPACE_CHARACTER_TOKEN ? _n(this, t) : t.type === P.COMMENT_TOKEN ? Wt(this, t) : t.type === P.START_TAG_TOKEN ? uk(this, t) : t.type === P.END_TAG_TOKEN && lk(this, t);
  }
  _processInputToken(t) {
    this._shouldProcessTokenInForeignContent(t) ? this._processTokenInForeignContent(t) : this._processToken(t), t.type === P.START_TAG_TOKEN && t.selfClosing && !t.ackSelfClosing && this._err(an.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  _isIntegrationPoint(t, n) {
    const r = this.treeAdapter.getTagName(t), a = this.treeAdapter.getNamespaceURI(t), i = this.treeAdapter.getAttrList(t);
    return mr.isIntegrationPoint(r, a, i, n);
  }
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.length;
    if (t) {
      let n = t, r = null;
      do
        if (n--, r = this.activeFormattingElements.entries[n], r.type === m9.MARKER_ENTRY || this.openElements.contains(r.element)) {
          n++;
          break;
        }
      while (n > 0);
      for (let a = n; a < t; a++)
        r = this.activeFormattingElements.entries[a], this._insertElement(r.token, this.treeAdapter.getNamespaceURI(r.element)), r.element = this.openElements.current;
    }
  }
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = Pr;
  }
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(d.P), this.openElements.popUntilTagNamePopped(d.P);
  }
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop, n = !1; t >= 0; t--) {
      let r = this.openElements.items[t];
      t === 0 && (n = !0, this.fragmentContext && (r = this.fragmentContext));
      const a = this.treeAdapter.getTagName(r), i = IM[a];
      if (i) {
        this.insertionMode = i;
        break;
      } else if (!n && (a === d.TD || a === d.TH)) {
        this.insertionMode = os;
        break;
      } else if (!n && a === d.HEAD) {
        this.insertionMode = Ti;
        break;
      } else if (a === d.SELECT) {
        this._resetInsertionModeForSelect(t);
        break;
      } else if (a === d.TEMPLATE) {
        this.insertionMode = this.currentTmplInsertionMode;
        break;
      } else if (a === d.HTML) {
        this.insertionMode = this.headElement ? as : rs;
        break;
      } else if (n) {
        this.insertionMode = gr;
        break;
      }
    }
  }
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let n = t - 1; n > 0; n--) {
        const r = this.openElements.items[n], a = this.treeAdapter.getTagName(r);
        if (a === d.TEMPLATE)
          break;
        if (a === d.TABLE) {
          this.insertionMode = df;
          return;
        }
      }
    this.insertionMode = hf;
  }
  _pushTmplInsertionMode(t) {
    this.tmplInsertionModeStack.push(t), this.tmplInsertionModeStackTop++, this.currentTmplInsertionMode = t;
  }
  _popTmplInsertionMode() {
    this.tmplInsertionModeStack.pop(), this.tmplInsertionModeStackTop--, this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
  }
  _isElementCausesFosterParenting(t) {
    const n = this.treeAdapter.getTagName(t);
    return n === d.TABLE || n === d.TBODY || n === d.TFOOT || n === d.THEAD || n === d.TR;
  }
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
  }
  _findFosterParentingLocation() {
    const t = {
      parent: null,
      beforeElement: null
    };
    for (let n = this.openElements.stackTop; n >= 0; n--) {
      const r = this.openElements.items[n], a = this.treeAdapter.getTagName(r), i = this.treeAdapter.getNamespaceURI(r);
      if (a === d.TEMPLATE && i === Ie.HTML) {
        t.parent = this.treeAdapter.getTemplateContent(r);
        break;
      } else if (a === d.TABLE) {
        t.parent = this.treeAdapter.getParentNode(r), t.parent ? t.beforeElement = r : t.parent = this.openElements.items[n - 1];
        break;
      }
    }
    return t.parent || (t.parent = this.openElements.items[0]), t;
  }
  _fosterParentElement(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, t, n.beforeElement) : this.treeAdapter.appendChild(n.parent, t);
  }
  _fosterParentText(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertTextBefore(n.parent, t, n.beforeElement) : this.treeAdapter.insertText(n.parent, t);
  }
  _isSpecialElement(t) {
    const n = this.treeAdapter.getTagName(t), r = this.treeAdapter.getNamespaceURI(t);
    return Na.SPECIAL_ELEMENTS[r][n];
  }
}
var xM = MM;
function kM(e, t) {
  let n = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return n ? e.openElements.contains(n.element) ? e.openElements.hasInScope(t.tagName) || (n = null) : (e.activeFormattingElements.removeEntry(n), n = null) : rr(e, t), n;
}
function PM(e, t) {
  let n = null;
  for (let r = e.openElements.stackTop; r >= 0; r--) {
    const a = e.openElements.items[r];
    if (a === t.element)
      break;
    e._isSpecialElement(a) && (n = a);
  }
  return n || (e.openElements.popUntilElementPopped(t.element), e.activeFormattingElements.removeEntry(t)), n;
}
function BM(e, t, n) {
  let r = t, a = e.openElements.getCommonAncestor(t);
  for (let i = 0, o = a; o !== n; i++, o = a) {
    a = e.openElements.getCommonAncestor(o);
    const s = e.activeFormattingElements.getElementEntry(o), u = s && i >= wM;
    !s || u ? (u && e.activeFormattingElements.removeEntry(s), e.openElements.remove(o)) : (o = FM(e, s), r === t && (e.activeFormattingElements.bookmark = s), e.treeAdapter.detachNode(r), e.treeAdapter.appendChild(o, r), r = o);
  }
  return r;
}
function FM(e, t) {
  const n = e.treeAdapter.getNamespaceURI(t.element), r = e.treeAdapter.createElement(t.token.tagName, n, t.token.attrs);
  return e.openElements.replace(t.element, r), t.element = r, r;
}
function LM(e, t, n) {
  if (e._isElementCausesFosterParenting(t))
    e._fosterParentElement(n);
  else {
    const r = e.treeAdapter.getTagName(t), a = e.treeAdapter.getNamespaceURI(t);
    r === d.TEMPLATE && a === Ie.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, n);
  }
}
function $M(e, t, n) {
  const r = e.treeAdapter.getNamespaceURI(n.element), a = n.token, i = e.treeAdapter.createElement(a.tagName, r, a.attrs);
  e._adoptNodes(t, i), e.treeAdapter.appendChild(t, i), e.activeFormattingElements.insertElementAfterBookmark(i, n.token), e.activeFormattingElements.removeEntry(n), e.openElements.remove(n.element), e.openElements.insertAfter(t, i);
}
function Jr(e, t) {
  let n;
  for (let r = 0; r < NM && (n = kM(e, t), !!n); r++) {
    const a = PM(e, n);
    if (!a)
      break;
    e.activeFormattingElements.bookmark = n;
    const i = BM(e, a, n.element), o = e.openElements.getCommonAncestor(n.element);
    e.treeAdapter.detachNode(i), LM(e, o, i), $M(e, a, n);
  }
}
function tt() {
}
function Z1(e) {
  e._err(an.misplacedDoctype);
}
function Wt(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContent || e.openElements.current);
}
function HM(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function T9(e, t) {
  e._appendCommentNode(t, e.document);
}
function _n(e, t) {
  e._insertCharacters(t);
}
function Hi(e) {
  e.stopped = !0;
}
function UM(e, t) {
  e._setDocumentType(t);
  const n = t.forceQuirks ? Na.DOCUMENT_MODE.QUIRKS : g9.getDocumentMode(t);
  g9.isConforming(t) || e._err(an.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, n), e.insertionMode = ff;
}
function Ui(e, t) {
  e._err(an.missingDoctype, { beforeToken: !0 }), e.treeAdapter.setDocumentMode(e.document, Na.DOCUMENT_MODE.QUIRKS), e.insertionMode = ff, e._processToken(t);
}
function jM(e, t) {
  t.tagName === d.HTML ? (e._insertElement(t, Ie.HTML), e.insertionMode = rs) : e1(e, t);
}
function zM(e, t) {
  const n = t.tagName;
  (n === d.HTML || n === d.HEAD || n === d.BODY || n === d.BR) && e1(e, t);
}
function e1(e, t) {
  e._insertFakeRootElement(), e.insertionMode = rs, e._processToken(t);
}
function GM(e, t) {
  const n = t.tagName;
  n === d.HTML ? yn(e, t) : n === d.HEAD ? (e._insertElement(t, Ie.HTML), e.headElement = e.openElements.current, e.insertionMode = Ti) : t1(e, t);
}
function VM(e, t) {
  const n = t.tagName;
  n === d.HEAD || n === d.BODY || n === d.HTML || n === d.BR ? t1(e, t) : e._err(an.endTagWithoutMatchingOpenElement);
}
function t1(e, t) {
  e._insertFakeElement(d.HEAD), e.headElement = e.openElements.current, e.insertionMode = Ti, e._processToken(t);
}
function Jt(e, t) {
  const n = t.tagName;
  n === d.HTML ? yn(e, t) : n === d.BASE || n === d.BASEFONT || n === d.BGSOUND || n === d.LINK || n === d.META ? (e._appendElement(t, Ie.HTML), t.ackSelfClosing = !0) : n === d.TITLE ? e._switchToTextParsing(t, P.MODE.RCDATA) : n === d.NOSCRIPT ? e.options.scriptingEnabled ? e._switchToTextParsing(t, P.MODE.RAWTEXT) : (e._insertElement(t, Ie.HTML), e.insertionMode = s2) : n === d.NOFRAMES || n === d.STYLE ? e._switchToTextParsing(t, P.MODE.RAWTEXT) : n === d.SCRIPT ? e._switchToTextParsing(t, P.MODE.SCRIPT_DATA) : n === d.TEMPLATE ? (e._insertTemplate(t, Ie.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = wo, e._pushTmplInsertionMode(wo)) : n === d.HEAD ? e._err(an.misplacedStartTagForHeadElement) : n1(e, t);
}
function wa(e, t) {
  const n = t.tagName;
  n === d.HEAD ? (e.openElements.pop(), e.insertionMode = as) : n === d.BODY || n === d.BR || n === d.HTML ? n1(e, t) : n === d.TEMPLATE && e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagName !== d.TEMPLATE && e._err(an.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(d.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e._popTmplInsertionMode(), e._resetInsertionMode()) : e._err(an.endTagWithoutMatchingOpenElement);
}
function n1(e, t) {
  e.openElements.pop(), e.insertionMode = as, e._processToken(t);
}
function YM(e, t) {
  const n = t.tagName;
  n === d.HTML ? yn(e, t) : n === d.BASEFONT || n === d.BGSOUND || n === d.HEAD || n === d.LINK || n === d.META || n === d.NOFRAMES || n === d.STYLE ? Jt(e, t) : n === d.NOSCRIPT ? e._err(an.nestedNoscriptInHead) : r1(e, t);
}
function KM(e, t) {
  const n = t.tagName;
  n === d.NOSCRIPT ? (e.openElements.pop(), e.insertionMode = Ti) : n === d.BR ? r1(e, t) : e._err(an.endTagWithoutMatchingOpenElement);
}
function r1(e, t) {
  const n = t.type === P.EOF_TOKEN ? an.openElementsLeftAfterEof : an.disallowedContentInNoscriptInHead;
  e._err(n), e.openElements.pop(), e.insertionMode = Ti, e._processToken(t);
}
function WM(e, t) {
  const n = t.tagName;
  n === d.HTML ? yn(e, t) : n === d.BODY ? (e._insertElement(t, Ie.HTML), e.framesetOk = !1, e.insertionMode = gr) : n === d.FRAMESET ? (e._insertElement(t, Ie.HTML), e.insertionMode = ss) : n === d.BASE || n === d.BASEFONT || n === d.BGSOUND || n === d.LINK || n === d.META || n === d.NOFRAMES || n === d.SCRIPT || n === d.STYLE || n === d.TEMPLATE || n === d.TITLE ? (e._err(an.abandonedHeadElementChild), e.openElements.push(e.headElement), Jt(e, t), e.openElements.remove(e.headElement)) : n === d.HEAD ? e._err(an.misplacedStartTagForHeadElement) : a1(e, t);
}
function qM(e, t) {
  const n = t.tagName;
  n === d.BODY || n === d.HTML || n === d.BR ? a1(e, t) : n === d.TEMPLATE ? wa(e, t) : e._err(an.endTagWithoutMatchingOpenElement);
}
function a1(e, t) {
  e._insertFakeElement(d.BODY), e.insertionMode = gr, e._processToken(t);
}
function ca(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function J1(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function XM(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function QM(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  n && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(n, t.attrs));
}
function ZM(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && n && (e.treeAdapter.detachNode(n), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, Ie.HTML), e.insertionMode = ss);
}
function Sr(e, t) {
  e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._insertElement(t, Ie.HTML);
}
function JM(e, t) {
  e.openElements.hasInButtonScope(d.P) && e._closePElement();
  const n = e.openElements.currentTagName;
  (n === d.H1 || n === d.H2 || n === d.H3 || n === d.H4 || n === d.H5 || n === d.H6) && e.openElements.pop(), e._insertElement(t, Ie.HTML);
}
function v9(e, t) {
  e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._insertElement(t, Ie.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function ex(e, t) {
  const n = e.openElements.tmplCount > 0;
  (!e.formElement || n) && (e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._insertElement(t, Ie.HTML), n || (e.formElement = e.openElements.current));
}
function tx(e, t) {
  e.framesetOk = !1;
  const n = t.tagName;
  for (let r = e.openElements.stackTop; r >= 0; r--) {
    const a = e.openElements.items[r], i = e.treeAdapter.getTagName(a);
    let o = null;
    if (n === d.LI && i === d.LI ? o = d.LI : (n === d.DD || n === d.DT) && (i === d.DD || i === d.DT) && (o = i), o) {
      e.openElements.generateImpliedEndTagsWithExclusion(o), e.openElements.popUntilTagNamePopped(o);
      break;
    }
    if (i !== d.ADDRESS && i !== d.DIV && i !== d.P && e._isSpecialElement(a))
      break;
  }
  e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._insertElement(t, Ie.HTML);
}
function nx(e, t) {
  e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._insertElement(t, Ie.HTML), e.tokenizer.state = P.MODE.PLAINTEXT;
}
function rx(e, t) {
  e.openElements.hasInScope(d.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(d.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, Ie.HTML), e.framesetOk = !1;
}
function ax(e, t) {
  const n = e.activeFormattingElements.getElementEntryInScopeWithTagName(d.A);
  n && (Jr(e, t), e.openElements.remove(n.element), e.activeFormattingElements.removeEntry(n)), e._reconstructActiveFormattingElements(), e._insertElement(t, Ie.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Ya(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, Ie.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function ix(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(d.NOBR) && (Jr(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, Ie.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function A9(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, Ie.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function ox(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== Na.DOCUMENT_MODE.QUIRKS && e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._insertElement(t, Ie.HTML), e.framesetOk = !1, e.insertionMode = cn;
}
function qa(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, Ie.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function sx(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, Ie.HTML);
  const n = P.getTokenAttr(t, a2.TYPE);
  (!n || n.toLowerCase() !== i2) && (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function C9(e, t) {
  e._appendElement(t, Ie.HTML), t.ackSelfClosing = !0;
}
function ux(e, t) {
  e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._appendElement(t, Ie.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function lx(e, t) {
  t.tagName = d.IMG, qa(e, t);
}
function cx(e, t) {
  e._insertElement(t, Ie.HTML), e.skipNextNewLine = !0, e.tokenizer.state = P.MODE.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = No;
}
function fx(e, t) {
  e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, P.MODE.RAWTEXT);
}
function hx(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, P.MODE.RAWTEXT);
}
function _9(e, t) {
  e._switchToTextParsing(t, P.MODE.RAWTEXT);
}
function dx(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, Ie.HTML), e.framesetOk = !1, e.insertionMode === cn || e.insertionMode === is || e.insertionMode === Gn || e.insertionMode === Pr || e.insertionMode === os ? e.insertionMode = df : e.insertionMode = hf;
}
function b9(e, t) {
  e.openElements.currentTagName === d.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, Ie.HTML);
}
function y9(e, t) {
  e.openElements.hasInScope(d.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, Ie.HTML);
}
function mx(e, t) {
  e.openElements.hasInScope(d.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(d.RTC), e._insertElement(t, Ie.HTML);
}
function px(e, t) {
  e.openElements.hasInButtonScope(d.P) && e._closePElement(), e._insertElement(t, Ie.HTML);
}
function gx(e, t) {
  e._reconstructActiveFormattingElements(), mr.adjustTokenMathMLAttrs(t), mr.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, Ie.MATHML) : e._insertElement(t, Ie.MATHML), t.ackSelfClosing = !0;
}
function Ex(e, t) {
  e._reconstructActiveFormattingElements(), mr.adjustTokenSVGAttrs(t), mr.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, Ie.SVG) : e._insertElement(t, Ie.SVG), t.ackSelfClosing = !0;
}
function $n(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, Ie.HTML);
}
function yn(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 1:
      n === d.I || n === d.S || n === d.B || n === d.U ? Ya(e, t) : n === d.P ? Sr(e, t) : n === d.A ? ax(e, t) : $n(e, t);
      break;
    case 2:
      n === d.DL || n === d.OL || n === d.UL ? Sr(e, t) : n === d.H1 || n === d.H2 || n === d.H3 || n === d.H4 || n === d.H5 || n === d.H6 ? JM(e, t) : n === d.LI || n === d.DD || n === d.DT ? tx(e, t) : n === d.EM || n === d.TT ? Ya(e, t) : n === d.BR ? qa(e, t) : n === d.HR ? ux(e, t) : n === d.RB ? y9(e, t) : n === d.RT || n === d.RP ? mx(e, t) : n !== d.TH && n !== d.TD && n !== d.TR && $n(e, t);
      break;
    case 3:
      n === d.DIV || n === d.DIR || n === d.NAV ? Sr(e, t) : n === d.PRE ? v9(e, t) : n === d.BIG ? Ya(e, t) : n === d.IMG || n === d.WBR ? qa(e, t) : n === d.XMP ? fx(e, t) : n === d.SVG ? Ex(e, t) : n === d.RTC ? y9(e, t) : n !== d.COL && $n(e, t);
      break;
    case 4:
      n === d.HTML ? XM(e, t) : n === d.BASE || n === d.LINK || n === d.META ? Jt(e, t) : n === d.BODY ? QM(e, t) : n === d.MAIN || n === d.MENU ? Sr(e, t) : n === d.FORM ? ex(e, t) : n === d.CODE || n === d.FONT ? Ya(e, t) : n === d.NOBR ? ix(e, t) : n === d.AREA ? qa(e, t) : n === d.MATH ? gx(e, t) : n === d.MENU ? px(e, t) : n !== d.HEAD && $n(e, t);
      break;
    case 5:
      n === d.STYLE || n === d.TITLE ? Jt(e, t) : n === d.ASIDE ? Sr(e, t) : n === d.SMALL ? Ya(e, t) : n === d.TABLE ? ox(e, t) : n === d.EMBED ? qa(e, t) : n === d.INPUT ? sx(e, t) : n === d.PARAM || n === d.TRACK ? C9(e, t) : n === d.IMAGE ? lx(e, t) : n !== d.FRAME && n !== d.TBODY && n !== d.TFOOT && n !== d.THEAD && $n(e, t);
      break;
    case 6:
      n === d.SCRIPT ? Jt(e, t) : n === d.CENTER || n === d.FIGURE || n === d.FOOTER || n === d.HEADER || n === d.HGROUP || n === d.DIALOG ? Sr(e, t) : n === d.BUTTON ? rx(e, t) : n === d.STRIKE || n === d.STRONG ? Ya(e, t) : n === d.APPLET || n === d.OBJECT ? A9(e, t) : n === d.KEYGEN ? qa(e, t) : n === d.SOURCE ? C9(e, t) : n === d.IFRAME ? hx(e, t) : n === d.SELECT ? dx(e, t) : n === d.OPTION ? b9(e, t) : $n(e, t);
      break;
    case 7:
      n === d.BGSOUND ? Jt(e, t) : n === d.DETAILS || n === d.ADDRESS || n === d.ARTICLE || n === d.SECTION || n === d.SUMMARY ? Sr(e, t) : n === d.LISTING ? v9(e, t) : n === d.MARQUEE ? A9(e, t) : n === d.NOEMBED ? _9(e, t) : n !== d.CAPTION && $n(e, t);
      break;
    case 8:
      n === d.BASEFONT ? Jt(e, t) : n === d.FRAMESET ? ZM(e, t) : n === d.FIELDSET ? Sr(e, t) : n === d.TEXTAREA ? cx(e, t) : n === d.TEMPLATE ? Jt(e, t) : n === d.NOSCRIPT ? e.options.scriptingEnabled ? _9(e, t) : $n(e, t) : n === d.OPTGROUP ? b9(e, t) : n !== d.COLGROUP && $n(e, t);
      break;
    case 9:
      n === d.PLAINTEXT ? nx(e, t) : $n(e, t);
      break;
    case 10:
      n === d.BLOCKQUOTE || n === d.FIGCAPTION ? Sr(e, t) : $n(e, t);
      break;
    default:
      $n(e, t);
  }
}
function Tx(e) {
  e.openElements.hasInScope(d.BODY) && (e.insertionMode = mf);
}
function vx(e, t) {
  e.openElements.hasInScope(d.BODY) && (e.insertionMode = mf, e._processToken(t));
}
function qr(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n));
}
function Ax(e) {
  const t = e.openElements.tmplCount > 0, n = e.formElement;
  t || (e.formElement = null), (n || t) && e.openElements.hasInScope(d.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(d.FORM) : e.openElements.remove(n));
}
function Cx(e) {
  e.openElements.hasInButtonScope(d.P) || e._insertFakeElement(d.P), e._closePElement();
}
function _x(e) {
  e.openElements.hasInListItemScope(d.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(d.LI), e.openElements.popUntilTagNamePopped(d.LI));
}
function bx(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilTagNamePopped(n));
}
function yx(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function D9(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker());
}
function Dx(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(d.BR), e.openElements.pop(), e.framesetOk = !1;
}
function rr(e, t) {
  const n = t.tagName;
  for (let r = e.openElements.stackTop; r > 0; r--) {
    const a = e.openElements.items[r];
    if (e.treeAdapter.getTagName(a) === n) {
      e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilElementPopped(a);
      break;
    }
    if (e._isSpecialElement(a))
      break;
  }
}
function pf(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 1:
      n === d.A || n === d.B || n === d.I || n === d.S || n === d.U ? Jr(e, t) : n === d.P ? Cx(e) : rr(e, t);
      break;
    case 2:
      n === d.DL || n === d.UL || n === d.OL ? qr(e, t) : n === d.LI ? _x(e) : n === d.DD || n === d.DT ? bx(e, t) : n === d.H1 || n === d.H2 || n === d.H3 || n === d.H4 || n === d.H5 || n === d.H6 ? yx(e) : n === d.BR ? Dx(e) : n === d.EM || n === d.TT ? Jr(e, t) : rr(e, t);
      break;
    case 3:
      n === d.BIG ? Jr(e, t) : n === d.DIR || n === d.DIV || n === d.NAV || n === d.PRE ? qr(e, t) : rr(e, t);
      break;
    case 4:
      n === d.BODY ? Tx(e) : n === d.HTML ? vx(e, t) : n === d.FORM ? Ax(e) : n === d.CODE || n === d.FONT || n === d.NOBR ? Jr(e, t) : n === d.MAIN || n === d.MENU ? qr(e, t) : rr(e, t);
      break;
    case 5:
      n === d.ASIDE ? qr(e, t) : n === d.SMALL ? Jr(e, t) : rr(e, t);
      break;
    case 6:
      n === d.CENTER || n === d.FIGURE || n === d.FOOTER || n === d.HEADER || n === d.HGROUP || n === d.DIALOG ? qr(e, t) : n === d.APPLET || n === d.OBJECT ? D9(e, t) : n === d.STRIKE || n === d.STRONG ? Jr(e, t) : rr(e, t);
      break;
    case 7:
      n === d.ADDRESS || n === d.ARTICLE || n === d.DETAILS || n === d.SECTION || n === d.SUMMARY || n === d.LISTING ? qr(e, t) : n === d.MARQUEE ? D9(e, t) : rr(e, t);
      break;
    case 8:
      n === d.FIELDSET ? qr(e, t) : n === d.TEMPLATE ? wa(e, t) : rr(e, t);
      break;
    case 10:
      n === d.BLOCKQUOTE || n === d.FIGCAPTION ? qr(e, t) : rr(e, t);
      break;
    default:
      rr(e, t);
  }
}
function Or(e, t) {
  e.tmplInsertionModeStackTop > -1 ? m2(e, t) : e.stopped = !0;
}
function Sx(e, t) {
  t.tagName === d.SCRIPT && (e.pendingScript = e.openElements.current), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function Ox(e, t) {
  e._err(an.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
function Nr(e, t) {
  const n = e.openElements.currentTagName;
  n === d.TABLE || n === d.TBODY || n === d.TFOOT || n === d.THEAD || n === d.TR ? (e.pendingCharacterTokens = [], e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = u2, e._processToken(t)) : Hn(e, t);
}
function Nx(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, Ie.HTML), e.insertionMode = is;
}
function wx(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, Ie.HTML), e.insertionMode = C1;
}
function Ix(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(d.COLGROUP), e.insertionMode = C1, e._processToken(t);
}
function Rx(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, Ie.HTML), e.insertionMode = Gn;
}
function Mx(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(d.TBODY), e.insertionMode = Gn, e._processToken(t);
}
function xx(e, t) {
  e.openElements.hasInTableScope(d.TABLE) && (e.openElements.popUntilTagNamePopped(d.TABLE), e._resetInsertionMode(), e._processToken(t));
}
function kx(e, t) {
  const n = P.getTokenAttr(t, a2.TYPE);
  n && n.toLowerCase() === i2 ? e._appendElement(t, Ie.HTML) : Hn(e, t), t.ackSelfClosing = !0;
}
function Px(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, Ie.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function gf(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 2:
      n === d.TD || n === d.TH || n === d.TR ? Mx(e, t) : Hn(e, t);
      break;
    case 3:
      n === d.COL ? Ix(e, t) : Hn(e, t);
      break;
    case 4:
      n === d.FORM ? Px(e, t) : Hn(e, t);
      break;
    case 5:
      n === d.TABLE ? xx(e, t) : n === d.STYLE ? Jt(e, t) : n === d.TBODY || n === d.TFOOT || n === d.THEAD ? Rx(e, t) : n === d.INPUT ? kx(e, t) : Hn(e, t);
      break;
    case 6:
      n === d.SCRIPT ? Jt(e, t) : Hn(e, t);
      break;
    case 7:
      n === d.CAPTION ? Nx(e, t) : Hn(e, t);
      break;
    case 8:
      n === d.COLGROUP ? wx(e, t) : n === d.TEMPLATE ? Jt(e, t) : Hn(e, t);
      break;
    default:
      Hn(e, t);
  }
}
function Ef(e, t) {
  const n = t.tagName;
  n === d.TABLE ? e.openElements.hasInTableScope(d.TABLE) && (e.openElements.popUntilTagNamePopped(d.TABLE), e._resetInsertionMode()) : n === d.TEMPLATE ? wa(e, t) : n !== d.BODY && n !== d.CAPTION && n !== d.COL && n !== d.COLGROUP && n !== d.HTML && n !== d.TBODY && n !== d.TD && n !== d.TFOOT && n !== d.TH && n !== d.THEAD && n !== d.TR && Hn(e, t);
}
function Hn(e, t) {
  const n = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, e._processTokenInBodyMode(t), e.fosterParentingEnabled = n;
}
function Bx(e, t) {
  e.pendingCharacterTokens.push(t);
}
function Fx(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function ji(e, t) {
  let n = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; n < e.pendingCharacterTokens.length; n++)
      Hn(e, e.pendingCharacterTokens[n]);
  else
    for (; n < e.pendingCharacterTokens.length; n++)
      e._insertCharacters(e.pendingCharacterTokens[n]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
function Lx(e, t) {
  const n = t.tagName;
  n === d.CAPTION || n === d.COL || n === d.COLGROUP || n === d.TBODY || n === d.TD || n === d.TFOOT || n === d.TH || n === d.THEAD || n === d.TR ? e.openElements.hasInTableScope(d.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(d.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = cn, e._processToken(t)) : yn(e, t);
}
function $x(e, t) {
  const n = t.tagName;
  n === d.CAPTION || n === d.TABLE ? e.openElements.hasInTableScope(d.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(d.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = cn, n === d.TABLE && e._processToken(t)) : n !== d.BODY && n !== d.COL && n !== d.COLGROUP && n !== d.HTML && n !== d.TBODY && n !== d.TD && n !== d.TFOOT && n !== d.TH && n !== d.THEAD && n !== d.TR && pf(e, t);
}
function Hx(e, t) {
  const n = t.tagName;
  n === d.HTML ? yn(e, t) : n === d.COL ? (e._appendElement(t, Ie.HTML), t.ackSelfClosing = !0) : n === d.TEMPLATE ? Jt(e, t) : Io(e, t);
}
function Ux(e, t) {
  const n = t.tagName;
  n === d.COLGROUP ? e.openElements.currentTagName === d.COLGROUP && (e.openElements.pop(), e.insertionMode = cn) : n === d.TEMPLATE ? wa(e, t) : n !== d.COL && Io(e, t);
}
function Io(e, t) {
  e.openElements.currentTagName === d.COLGROUP && (e.openElements.pop(), e.insertionMode = cn, e._processToken(t));
}
function jx(e, t) {
  const n = t.tagName;
  n === d.TR ? (e.openElements.clearBackToTableBodyContext(), e._insertElement(t, Ie.HTML), e.insertionMode = Pr) : n === d.TH || n === d.TD ? (e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(d.TR), e.insertionMode = Pr, e._processToken(t)) : n === d.CAPTION || n === d.COL || n === d.COLGROUP || n === d.TBODY || n === d.TFOOT || n === d.THEAD ? e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = cn, e._processToken(t)) : gf(e, t);
}
function zx(e, t) {
  const n = t.tagName;
  n === d.TBODY || n === d.TFOOT || n === d.THEAD ? e.openElements.hasInTableScope(n) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = cn) : n === d.TABLE ? e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = cn, e._processToken(t)) : (n !== d.BODY && n !== d.CAPTION && n !== d.COL && n !== d.COLGROUP || n !== d.HTML && n !== d.TD && n !== d.TH && n !== d.TR) && Ef(e, t);
}
function Gx(e, t) {
  const n = t.tagName;
  n === d.TH || n === d.TD ? (e.openElements.clearBackToTableRowContext(), e._insertElement(t, Ie.HTML), e.insertionMode = os, e.activeFormattingElements.insertMarker()) : n === d.CAPTION || n === d.COL || n === d.COLGROUP || n === d.TBODY || n === d.TFOOT || n === d.THEAD || n === d.TR ? e.openElements.hasInTableScope(d.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = Gn, e._processToken(t)) : gf(e, t);
}
function Vx(e, t) {
  const n = t.tagName;
  n === d.TR ? e.openElements.hasInTableScope(d.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = Gn) : n === d.TABLE ? e.openElements.hasInTableScope(d.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = Gn, e._processToken(t)) : n === d.TBODY || n === d.TFOOT || n === d.THEAD ? (e.openElements.hasInTableScope(n) || e.openElements.hasInTableScope(d.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = Gn, e._processToken(t)) : (n !== d.BODY && n !== d.CAPTION && n !== d.COL && n !== d.COLGROUP || n !== d.HTML && n !== d.TD && n !== d.TH) && Ef(e, t);
}
function Yx(e, t) {
  const n = t.tagName;
  n === d.CAPTION || n === d.COL || n === d.COLGROUP || n === d.TBODY || n === d.TD || n === d.TFOOT || n === d.TH || n === d.THEAD || n === d.TR ? (e.openElements.hasInTableScope(d.TD) || e.openElements.hasInTableScope(d.TH)) && (e._closeTableCell(), e._processToken(t)) : yn(e, t);
}
function Kx(e, t) {
  const n = t.tagName;
  n === d.TD || n === d.TH ? e.openElements.hasInTableScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = Pr) : n === d.TABLE || n === d.TBODY || n === d.TFOOT || n === d.THEAD || n === d.TR ? e.openElements.hasInTableScope(n) && (e._closeTableCell(), e._processToken(t)) : n !== d.BODY && n !== d.CAPTION && n !== d.COL && n !== d.COLGROUP && n !== d.HTML && pf(e, t);
}
function h2(e, t) {
  const n = t.tagName;
  n === d.HTML ? yn(e, t) : n === d.OPTION ? (e.openElements.currentTagName === d.OPTION && e.openElements.pop(), e._insertElement(t, Ie.HTML)) : n === d.OPTGROUP ? (e.openElements.currentTagName === d.OPTION && e.openElements.pop(), e.openElements.currentTagName === d.OPTGROUP && e.openElements.pop(), e._insertElement(t, Ie.HTML)) : n === d.INPUT || n === d.KEYGEN || n === d.TEXTAREA || n === d.SELECT ? e.openElements.hasInSelectScope(d.SELECT) && (e.openElements.popUntilTagNamePopped(d.SELECT), e._resetInsertionMode(), n !== d.SELECT && e._processToken(t)) : (n === d.SCRIPT || n === d.TEMPLATE) && Jt(e, t);
}
function d2(e, t) {
  const n = t.tagName;
  if (n === d.OPTGROUP) {
    const r = e.openElements.items[e.openElements.stackTop - 1], a = r && e.treeAdapter.getTagName(r);
    e.openElements.currentTagName === d.OPTION && a === d.OPTGROUP && e.openElements.pop(), e.openElements.currentTagName === d.OPTGROUP && e.openElements.pop();
  } else
    n === d.OPTION ? e.openElements.currentTagName === d.OPTION && e.openElements.pop() : n === d.SELECT && e.openElements.hasInSelectScope(d.SELECT) ? (e.openElements.popUntilTagNamePopped(d.SELECT), e._resetInsertionMode()) : n === d.TEMPLATE && wa(e, t);
}
function Wx(e, t) {
  const n = t.tagName;
  n === d.CAPTION || n === d.TABLE || n === d.TBODY || n === d.TFOOT || n === d.THEAD || n === d.TR || n === d.TD || n === d.TH ? (e.openElements.popUntilTagNamePopped(d.SELECT), e._resetInsertionMode(), e._processToken(t)) : h2(e, t);
}
function qx(e, t) {
  const n = t.tagName;
  n === d.CAPTION || n === d.TABLE || n === d.TBODY || n === d.TFOOT || n === d.THEAD || n === d.TR || n === d.TD || n === d.TH ? e.openElements.hasInTableScope(n) && (e.openElements.popUntilTagNamePopped(d.SELECT), e._resetInsertionMode(), e._processToken(t)) : d2(e, t);
}
function Xx(e, t) {
  const n = t.tagName;
  if (n === d.BASE || n === d.BASEFONT || n === d.BGSOUND || n === d.LINK || n === d.META || n === d.NOFRAMES || n === d.SCRIPT || n === d.STYLE || n === d.TEMPLATE || n === d.TITLE)
    Jt(e, t);
  else {
    const r = RM[n] || gr;
    e._popTmplInsertionMode(), e._pushTmplInsertionMode(r), e.insertionMode = r, e._processToken(t);
  }
}
function Qx(e, t) {
  t.tagName === d.TEMPLATE && wa(e, t);
}
function m2(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(d.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e._popTmplInsertionMode(), e._resetInsertionMode(), e._processToken(t)) : e.stopped = !0;
}
function Zx(e, t) {
  t.tagName === d.HTML ? yn(e, t) : Ro(e, t);
}
function Jx(e, t) {
  t.tagName === d.HTML ? e.fragmentContext || (e.insertionMode = c2) : Ro(e, t);
}
function Ro(e, t) {
  e.insertionMode = gr, e._processToken(t);
}
function ek(e, t) {
  const n = t.tagName;
  n === d.HTML ? yn(e, t) : n === d.FRAMESET ? e._insertElement(t, Ie.HTML) : n === d.FRAME ? (e._appendElement(t, Ie.HTML), t.ackSelfClosing = !0) : n === d.NOFRAMES && Jt(e, t);
}
function tk(e, t) {
  t.tagName === d.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagName !== d.FRAMESET && (e.insertionMode = l2));
}
function nk(e, t) {
  const n = t.tagName;
  n === d.HTML ? yn(e, t) : n === d.NOFRAMES && Jt(e, t);
}
function rk(e, t) {
  t.tagName === d.HTML && (e.insertionMode = f2);
}
function ak(e, t) {
  t.tagName === d.HTML ? yn(e, t) : uo(e, t);
}
function uo(e, t) {
  e.insertionMode = gr, e._processToken(t);
}
function ik(e, t) {
  const n = t.tagName;
  n === d.HTML ? yn(e, t) : n === d.NOFRAMES && Jt(e, t);
}
function ok(e, t) {
  t.chars = SM.REPLACEMENT_CHARACTER, e._insertCharacters(t);
}
function sk(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function uk(e, t) {
  if (mr.causesExit(t) && !e.fragmentContext) {
    for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== Ie.HTML && !e._isIntegrationPoint(e.openElements.current); )
      e.openElements.pop();
    e._processToken(t);
  } else {
    const n = e._getAdjustedCurrentElement(), r = e.treeAdapter.getNamespaceURI(n);
    r === Ie.MATHML ? mr.adjustTokenMathMLAttrs(t) : r === Ie.SVG && (mr.adjustTokenSVGTagName(t), mr.adjustTokenSVGAttrs(t)), mr.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, r) : e._insertElement(t, r), t.ackSelfClosing = !0;
  }
}
function lk(e, t) {
  for (let n = e.openElements.stackTop; n > 0; n--) {
    const r = e.openElements.items[n];
    if (e.treeAdapter.getNamespaceURI(r) === Ie.HTML) {
      e._processToken(t);
      break;
    }
    if (e.treeAdapter.getTagName(r).toLowerCase() === t.tagName) {
      e.openElements.popUntilElementPopped(r);
      break;
    }
  }
}
const p2 = g2("start"), ck = g2("end");
function g2(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    return {
      line: r.line || null,
      column: r.column || null,
      offset: r.offset > -1 ? r.offset : null
    };
  }
}
const fk = function(e, t, n, r) {
  typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), Jo(e, t, a, r);
  function a(i, o) {
    const s = o[o.length - 1];
    return n(
      i,
      s ? s.children.indexOf(i) : null,
      s
    );
  }
}, S9 = /[#.]/g;
function hk(e, t) {
  const n = e || "", r = {};
  let a = 0, i, o;
  for (; a < n.length; ) {
    S9.lastIndex = a;
    const s = S9.exec(n), u = n.slice(a, s ? s.index : n.length);
    u && (i ? i === "#" ? r.id = u : Array.isArray(r.className) ? r.className.push(u) : r.className = [u] : o = u, a += u.length), s && (i = s[0], a++);
  }
  return {
    type: "element",
    tagName: o || t || "div",
    properties: r,
    children: []
  };
}
const dk = /* @__PURE__ */ new Set(["menu", "submit", "reset", "button"]), pc = {}.hasOwnProperty;
function E2(e, t, n) {
  const r = n && Ek(n);
  return function(i, o, ...s) {
    let u = -1, l;
    if (i == null)
      l = { type: "root", children: [] }, s.unshift(o);
    else if (l = hk(i, t), l.tagName = l.tagName.toLowerCase(), r && pc.call(r, l.tagName) && (l.tagName = r[l.tagName]), mk(o, l.tagName)) {
      let c;
      for (c in o)
        pc.call(o, c) && pk(e, l.properties, c, o[c]);
    } else
      s.unshift(o);
    for (; ++u < s.length; )
      gc(l.children, s[u]);
    return l.type === "element" && l.tagName === "template" && (l.content = { type: "root", children: l.children }, l.children = []), l;
  };
}
function mk(e, t) {
  return e == null || typeof e != "object" || Array.isArray(e) ? !1 : t === "input" || !e.type || typeof e.type != "string" ? !0 : "children" in e && Array.isArray(e.children) ? !1 : t === "button" ? dk.has(e.type.toLowerCase()) : !("value" in e);
}
function pk(e, t, n, r) {
  const a = es(e, n);
  let i = -1, o;
  if (r != null) {
    if (typeof r == "number") {
      if (Number.isNaN(r))
        return;
      o = r;
    } else
      typeof r == "boolean" ? o = r : typeof r == "string" ? a.spaceSeparated ? o = lm(r) : a.commaSeparated ? o = cm(r) : a.commaOrSpaceSeparated ? o = lm(cm(r).join(" ")) : o = O9(a, a.property, r) : Array.isArray(r) ? o = r.concat() : o = a.property === "style" ? gk(r) : String(r);
    if (Array.isArray(o)) {
      const s = [];
      for (; ++i < o.length; )
        s[i] = O9(a, a.property, o[i]);
      o = s;
    }
    a.property === "className" && Array.isArray(t.className) && (o = t.className.concat(o)), t[a.property] = o;
  }
}
function gc(e, t) {
  let n = -1;
  if (t != null)
    if (typeof t == "string" || typeof t == "number")
      e.push({ type: "text", value: String(t) });
    else if (Array.isArray(t))
      for (; ++n < t.length; )
        gc(e, t[n]);
    else if (typeof t == "object" && "type" in t)
      t.type === "root" ? gc(e, t.children) : e.push(t);
    else
      throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function O9(e, t, n) {
  if (typeof n == "string") {
    if (e.number && n && !Number.isNaN(Number(n)))
      return Number(n);
    if ((e.boolean || e.overloadedBoolean) && (n === "" || m1(n) === m1(t)))
      return !0;
  }
  return n;
}
function gk(e) {
  const t = [];
  let n;
  for (n in e)
    pc.call(e, n) && t.push([n, e[n]].join(": "));
  return t.join("; ");
}
function Ek(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    t[e[n].toLowerCase()] = e[n];
  return t;
}
const Tk = E2(A1, "div"), vk = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], Ak = E2(Ei, "g", vk);
function Ck(e) {
  for (var t = String(e), n = [], r = /\r?\n|\r/g; r.test(t); )
    n.push(r.lastIndex);
  return n.push(t.length + 1), { toPoint: a, toOffset: i };
  function a(o) {
    var s = -1;
    if (o > -1 && o < n[n.length - 1]) {
      for (; ++s < n.length; )
        if (n[s] > o)
          return {
            line: s + 1,
            column: o - (n[s - 1] || 0) + 1,
            offset: o
          };
    }
    return { line: void 0, column: void 0, offset: void 0 };
  }
  function i(o) {
    var s = o && o.line, u = o && o.column, l;
    return typeof s == "number" && typeof u == "number" && !Number.isNaN(s) && !Number.isNaN(u) && s - 1 in n && (l = (n[s - 2] || 0) + u - 1 || 0), l > -1 && l < n[n.length - 1] ? l : -1;
  }
}
const _k = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, T2 = {}.hasOwnProperty, bk = Object.prototype;
function yk(e, t) {
  const n = t || {};
  let r, a;
  return Ok(n) ? (a = n, r = {}) : (a = n.file || void 0, r = n), Tf(
    {
      schema: r.space === "svg" ? Ei : A1,
      file: a,
      verbose: r.verbose,
      location: !1
    },
    e
  );
}
function Tf(e, t) {
  let n;
  switch (t.nodeName) {
    case "#comment": {
      const r = t;
      return n = { type: "comment", value: r.data }, lo(e, r, n), n;
    }
    case "#document":
    case "#document-fragment": {
      const r = t, a = "mode" in r ? r.mode === "quirks" || r.mode === "limited-quirks" : !1;
      if (n = {
        type: "root",
        children: v2(e, t.childNodes),
        data: { quirksMode: a }
      }, e.file && e.location) {
        const i = String(e.file), o = Ck(i), s = o.toPoint(0), u = o.toPoint(i.length);
        n.position = { start: s, end: u };
      }
      return n;
    }
    case "#documentType": {
      const r = t;
      return n = { type: "doctype" }, lo(e, r, n), n;
    }
    case "#text": {
      const r = t;
      return n = { type: "text", value: r.value }, lo(e, r, n), n;
    }
    default:
      return n = Dk(e, t), n;
  }
}
function v2(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    r[n] = Tf(e, t[n]);
  return r;
}
function Dk(e, t) {
  const n = e.schema;
  e.schema = t.namespaceURI === _k.svg ? Ei : A1;
  let r = -1;
  const a = {};
  for (; ++r < t.attrs.length; ) {
    const s = t.attrs[r], u = (s.prefix ? s.prefix + ":" : "") + s.name;
    T2.call(bk, u) || (a[u] = s.value);
  }
  const o = (e.schema.space === "svg" ? Ak : Tk)(t.tagName, a, v2(e, t.childNodes));
  if (lo(e, t, o), o.tagName === "template") {
    const s = t, u = s.sourceCodeLocation, l = u && u.startTag && Ja(u.startTag), c = u && u.endTag && Ja(u.endTag), f = Tf(e, s.content);
    l && c && e.file && (f.position = { start: l.end, end: c.start }), o.content = f;
  }
  return e.schema = n, o;
}
function lo(e, t, n) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const r = Sk(e, n, t.sourceCodeLocation);
    r && (e.location = !0, n.position = r);
  }
}
function Sk(e, t, n) {
  const r = Ja(n);
  if (t.type === "element") {
    const a = t.children[t.children.length - 1];
    if (r && !n.endTag && a && a.position && a.position.end && (r.end = Object.assign({}, a.position.end)), e.verbose) {
      const i = {};
      let o;
      if (n.attrs)
        for (o in n.attrs)
          T2.call(n.attrs, o) && (i[es(e.schema, o).property] = Ja(
            n.attrs[o]
          ));
      t.data = {
        position: {
          opening: Ja(n.startTag),
          closing: n.endTag ? Ja(n.endTag) : null,
          properties: i
        }
      };
    }
  }
  return r;
}
function Ja(e) {
  const t = N9({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), n = N9({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return t || n ? { start: t, end: n } : void 0;
}
function N9(e) {
  return e.line && e.column ? e : void 0;
}
function Ok(e) {
  return "messages" in e;
}
const A2 = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
var w9 = {}.hasOwnProperty;
function Nk(e, t) {
  var n = t || {};
  function r(a) {
    var i = r.invalid, o = r.handlers;
    if (a && w9.call(a, e) && (i = w9.call(o, a[e]) ? o[a[e]] : r.unknown), i)
      return i.apply(this, arguments);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const wk = {}.hasOwnProperty, C2 = Nk("type", { handlers: { root: Rk, element: Bk, text: kk, comment: Pk, doctype: xk } });
function Ik(e, t) {
  const n = t && typeof t == "object" ? t.space : t;
  return C2(e, n === "svg" ? Ei : A1);
}
function Rk(e, t) {
  const n = {
    nodeName: "#document",
    mode: (e.data || {}).quirksMode ? "quirks" : "no-quirks",
    childNodes: []
  };
  return n.childNodes = vf(e.children, n, t), vi(e, n), n;
}
function Mk(e, t) {
  const n = { nodeName: "#document-fragment", childNodes: [] };
  return n.childNodes = vf(e.children, n, t), vi(e, n), n;
}
function xk(e) {
  const t = {
    nodeName: "#documentType",
    name: "html",
    publicId: "",
    systemId: "",
    parentNode: void 0
  };
  return vi(e, t), t;
}
function kk(e) {
  const t = {
    nodeName: "#text",
    value: e.value,
    parentNode: void 0
  };
  return vi(e, t), t;
}
function Pk(e) {
  const t = {
    nodeName: "#comment",
    data: e.value,
    parentNode: void 0
  };
  return vi(e, t), t;
}
function Bk(e, t) {
  const n = t;
  let r = n;
  e.type === "element" && e.tagName.toLowerCase() === "svg" && n.space === "html" && (r = Ei);
  const a = [];
  let i;
  if (e.properties) {
    for (i in e.properties)
      if (i !== "children" && wk.call(e.properties, i)) {
        const s = Fk(
          r,
          i,
          e.properties[i]
        );
        s && a.push(s);
      }
  }
  const o = {
    nodeName: e.tagName,
    tagName: e.tagName,
    attrs: a,
    namespaceURI: A2[r.space],
    childNodes: [],
    parentNode: void 0
  };
  return o.childNodes = vf(e.children, o, r), vi(e, o), e.tagName === "template" && e.content && (o.content = Mk(e.content, r)), o;
}
function Fk(e, t, n) {
  const r = es(e, t);
  if (n == null || n === !1 || typeof n == "number" && Number.isNaN(n) || !n && r.boolean)
    return;
  Array.isArray(n) && (n = r.commaSeparated ? $g(n) : Lg(n));
  const a = {
    name: r.attribute,
    value: n === !0 ? "" : String(n)
  };
  if (r.space && r.space !== "html" && r.space !== "svg") {
    const i = a.name.indexOf(":");
    i < 0 ? a.prefix = "" : (a.name = a.name.slice(i + 1), a.prefix = r.attribute.slice(0, i)), a.namespace = A2[r.space];
  }
  return a;
}
function vf(e, t, n) {
  let r = -1;
  const a = [];
  if (e)
    for (; ++r < e.length; ) {
      const i = C2(e[r], n);
      i.parentNode = t, a.push(i);
    }
  return a;
}
function vi(e, t) {
  const n = e.position;
  n && n.start && n.end && (t.sourceCodeLocation = {
    startLine: n.start.line,
    startCol: n.start.column,
    startOffset: n.start.offset,
    endLine: n.end.line,
    endCol: n.end.column,
    endOffset: n.end.offset
  });
}
const Lk = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "menuitem",
  "meta",
  "nextid",
  "param",
  "source",
  "track",
  "wbr"
], I9 = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
var R9 = {}.hasOwnProperty;
function $k(e, t) {
  var n = t || {};
  function r(a) {
    var i = r.invalid, o = r.handlers;
    if (a && R9.call(a, e) && (i = R9.call(o, a[e]) ? o[a[e]] : r.unknown), i)
      return i.apply(this, arguments);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const Hk = "IN_TEMPLATE_MODE", Uk = "DATA_STATE", jk = "CHARACTER_TOKEN", zk = "START_TAG_TOKEN", Gk = "END_TAG_TOKEN", Vk = "COMMENT_TOKEN", Yk = "DOCTYPE_TOKEN", Kk = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 }, _2 = function(e, t, n) {
  let r = -1;
  const a = new xM(Kk), i = $k("type", {
    handlers: { root: m, element: v, text: b, comment: O, doctype: y, raw: B },
    unknown: Qk
  });
  let o, s, u, l, c;
  if (Jk(t) && (n = t, t = void 0), n && n.passThrough)
    for (; ++r < n.passThrough.length; )
      i.handlers[n.passThrough[r]] = S;
  const f = yk(
    Zk(e) ? T() : E(),
    t
  );
  if (o && fk(f, "comment", (I, G, V) => {
    const w = I;
    if (w.value.stitch && V !== null && G !== null)
      return V.children[G] = w.value.stitch, G;
  }), e.type !== "root" && f.type === "root" && f.children.length === 1)
    return f.children[0];
  return f;
  function E() {
    const I = {
      nodeName: "template",
      tagName: "template",
      attrs: [],
      namespaceURI: I9.html,
      childNodes: []
    }, G = {
      nodeName: "documentmock",
      tagName: "documentmock",
      attrs: [],
      namespaceURI: I9.html,
      childNodes: []
    }, V = { nodeName: "#document-fragment", childNodes: [] };
    if (a._bootstrap(G, I), a._pushTmplInsertionMode(Hk), a._initTokenizerForFragmentParsing(), a._insertFakeRootElement(), a._resetInsertionMode(), a._findFormInFragmentContext(), s = a.tokenizer, !s)
      throw new Error("Expected `tokenizer`");
    return u = s.preprocessor, c = s.__mixins[0], l = c.posTracker, i(e), C(), a._adoptNodes(G.childNodes[0], V), V;
  }
  function T() {
    const I = a.treeAdapter.createDocument();
    if (a._bootstrap(I, void 0), s = a.tokenizer, !s)
      throw new Error("Expected `tokenizer`");
    return u = s.preprocessor, c = s.__mixins[0], l = c.posTracker, i(e), C(), I;
  }
  function g(I) {
    let G = -1;
    if (I)
      for (; ++G < I.length; )
        i(I[G]);
  }
  function m(I) {
    g(I.children);
  }
  function v(I) {
    C(), a._processInputToken(Wk(I)), g(I.children), Lk.includes(I.tagName) || (C(), a._processInputToken(Xk(I)));
  }
  function b(I) {
    C(), a._processInputToken({
      type: jk,
      chars: I.value,
      location: ei(I)
    });
  }
  function y(I) {
    C(), a._processInputToken({
      type: Yk,
      name: "html",
      forceQuirks: !1,
      publicId: "",
      systemId: "",
      location: ei(I)
    });
  }
  function O(I) {
    C(), a._processInputToken({
      type: Vk,
      data: I.value,
      location: ei(I)
    });
  }
  function B(I) {
    const G = p2(I), V = G.line || 1, w = G.column || 1, Y = G.offset || 0;
    if (!u)
      throw new Error("Expected `preprocessor`");
    if (!s)
      throw new Error("Expected `tokenizer`");
    if (!l)
      throw new Error("Expected `posTracker`");
    if (!c)
      throw new Error("Expected `locationTracker`");
    u.html = void 0, u.pos = -1, u.lastGapPos = -1, u.lastCharPos = -1, u.gapStack = [], u.skipNextNewLine = !1, u.lastChunkWritten = !1, u.endOfChunkHit = !1, l.isEol = !1, l.lineStartPos = -w + 1, l.droppedBufferSize = Y, l.offset = 0, l.col = 1, l.line = V, c.currentAttrLocation = void 0, c.ctLoc = ei(I), s.write(I.value), a._runParsingLoop(null), (s.state === "NAMED_CHARACTER_REFERENCE_STATE" || s.state === "NUMERIC_CHARACTER_REFERENCE_END_STATE") && (u.lastChunkWritten = !0, s[s.state](s._consume()));
  }
  function S(I) {
    o = !0;
    let G;
    "children" in I ? G = {
      ...I,
      children: _2(
        { type: "root", children: I.children },
        t,
        n
      ).children
    } : G = { ...I }, O({ type: "comment", value: { stitch: G } });
  }
  function C() {
    if (!s)
      throw new Error("Expected `tokenizer`");
    if (!l)
      throw new Error("Expected `posTracker`");
    const I = s.currentCharacterToken;
    I && (I.location.endLine = l.line, I.location.endCol = l.col + 1, I.location.endOffset = l.offset + 1, a._processInputToken(I)), s.tokenQueue = [], s.state = Uk, s.returnState = "", s.charRefCode = -1, s.tempBuff = [], s.lastStartTagName = "", s.consumedAfterSnapshot = -1, s.active = !1, s.currentCharacterToken = void 0, s.currentToken = void 0, s.currentAttr = void 0;
  }
};
function Wk(e) {
  const t = Object.assign(ei(e));
  return t.startTag = Object.assign({}, t), {
    type: zk,
    tagName: e.tagName,
    selfClosing: !1,
    attrs: qk(e),
    location: t
  };
}
function qk(e) {
  return Ik({
    tagName: e.tagName,
    type: "element",
    properties: e.properties,
    children: []
  }).attrs;
}
function Xk(e) {
  const t = Object.assign(ei(e));
  return t.startTag = Object.assign({}, t), {
    type: Gk,
    tagName: e.tagName,
    attrs: [],
    location: t
  };
}
function Qk(e) {
  throw new Error("Cannot compile `" + e.type + "` node");
}
function Zk(e) {
  const t = e.type === "root" ? e.children[0] : e;
  return Boolean(
    t && (t.type === "doctype" || t.type === "element" && t.tagName === "html")
  );
}
function ei(e) {
  const t = p2(e), n = ck(e);
  return {
    startLine: t.line,
    startCol: t.column,
    startOffset: t.offset,
    endLine: n.line,
    endCol: n.column,
    endOffset: n.offset
  };
}
function Jk(e) {
  return Boolean(e && !("message" in e && "messages" in e));
}
function eP(e = {}) {
  return (t, n) => _2(t, n, e);
}
const tP = {
  tokenize: sP,
  partial: !0
}, b2 = {
  tokenize: uP,
  partial: !0
}, y2 = {
  tokenize: lP,
  partial: !0
}, D2 = {
  tokenize: cP,
  partial: !0
}, nP = {
  tokenize: fP,
  partial: !0
}, S2 = {
  tokenize: iP,
  previous: N2
}, O2 = {
  tokenize: oP,
  previous: w2
}, $r = {
  tokenize: aP,
  previous: I2
}, Tr = {}, rP = {
  text: Tr
};
let fa = 48;
for (; fa < 123; )
  Tr[fa] = $r, fa++, fa === 58 ? fa = 65 : fa === 91 && (fa = 97);
Tr[43] = $r;
Tr[45] = $r;
Tr[46] = $r;
Tr[95] = $r;
Tr[72] = [$r, O2];
Tr[104] = [$r, O2];
Tr[87] = [$r, S2];
Tr[119] = [$r, S2];
function aP(e, t, n) {
  const r = this;
  let a, i;
  return o;
  function o(f) {
    return !Ec(f) || !I2.call(r, r.previous) || Af(r.events) ? n(f) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), s(f));
  }
  function s(f) {
    return Ec(f) ? (e.consume(f), s) : f === 64 ? (e.consume(f), u) : n(f);
  }
  function u(f) {
    return f === 46 ? e.check(
      nP,
      c,
      l
    )(f) : f === 45 || f === 95 || fn(f) ? (i = !0, e.consume(f), u) : c(f);
  }
  function l(f) {
    return e.consume(f), a = !0, u;
  }
  function c(f) {
    return i && a && gn(r.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(f)) : n(f);
  }
}
function iP(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    return o !== 87 && o !== 119 || !N2.call(r, r.previous) || Af(r.events) ? n(o) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(
      tP,
      e.attempt(b2, e.attempt(y2, i), n),
      n
    )(o));
  }
  function i(o) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(o);
  }
}
function oP(e, t, n) {
  const r = this;
  let a = "", i = !1;
  return o;
  function o(f) {
    return (f === 72 || f === 104) && w2.call(r, r.previous) && !Af(r.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), a += String.fromCodePoint(f), e.consume(f), s) : n(f);
  }
  function s(f) {
    if (gn(f) && a.length < 5)
      return a += String.fromCodePoint(f), e.consume(f), s;
    if (f === 58) {
      const E = a.toLowerCase();
      if (E === "http" || E === "https")
        return e.consume(f), u;
    }
    return n(f);
  }
  function u(f) {
    return f === 47 ? (e.consume(f), i ? l : (i = !0, u)) : n(f);
  }
  function l(f) {
    return f === null || Do(f) || kt(f) || Da(f) || Xo(f) ? n(f) : e.attempt(b2, e.attempt(y2, c), n)(f);
  }
  function c(f) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(f);
  }
}
function sP(e, t, n) {
  let r = 0;
  return a;
  function a(o) {
    return (o === 87 || o === 119) && r < 3 ? (r++, e.consume(o), a) : o === 46 && r === 3 ? (e.consume(o), i) : n(o);
  }
  function i(o) {
    return o === null ? n(o) : t(o);
  }
}
function uP(e, t, n) {
  let r, a, i;
  return o;
  function o(l) {
    return l === 46 || l === 95 ? e.check(D2, u, s)(l) : l === null || kt(l) || Da(l) || l !== 45 && Xo(l) ? u(l) : (i = !0, e.consume(l), o);
  }
  function s(l) {
    return l === 95 ? r = !0 : (a = r, r = void 0), e.consume(l), o;
  }
  function u(l) {
    return a || r || !i ? n(l) : t(l);
  }
}
function lP(e, t) {
  let n = 0, r = 0;
  return a;
  function a(o) {
    return o === 40 ? (n++, e.consume(o), a) : o === 41 && r < n ? i(o) : o === 33 || o === 34 || o === 38 || o === 39 || o === 41 || o === 42 || o === 44 || o === 46 || o === 58 || o === 59 || o === 60 || o === 63 || o === 93 || o === 95 || o === 126 ? e.check(D2, t, i)(o) : o === null || kt(o) || Da(o) ? t(o) : (e.consume(o), a);
  }
  function i(o) {
    return o === 41 && r++, e.consume(o), a;
  }
}
function cP(e, t, n) {
  return r;
  function r(s) {
    return s === 33 || s === 34 || s === 39 || s === 41 || s === 42 || s === 44 || s === 46 || s === 58 || s === 59 || s === 63 || s === 95 || s === 126 ? (e.consume(s), r) : s === 38 ? (e.consume(s), i) : s === 93 ? (e.consume(s), a) : s === 60 || s === null || kt(s) || Da(s) ? t(s) : n(s);
  }
  function a(s) {
    return s === null || s === 40 || s === 91 || kt(s) || Da(s) ? t(s) : r(s);
  }
  function i(s) {
    return gn(s) ? o(s) : n(s);
  }
  function o(s) {
    return s === 59 ? (e.consume(s), r) : gn(s) ? (e.consume(s), o) : n(s);
  }
}
function fP(e, t, n) {
  return r;
  function r(i) {
    return e.consume(i), a;
  }
  function a(i) {
    return fn(i) ? n(i) : t(i);
  }
}
function N2(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || kt(e);
}
function w2(e) {
  return !gn(e);
}
function I2(e) {
  return !(e === 47 || Ec(e));
}
function Ec(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || fn(e);
}
function Af(e) {
  let t = e.length, n = !1;
  for (; t--; ) {
    const r = e[t][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const hP = {
  tokenize: AP,
  partial: !0
};
function dP() {
  return {
    document: {
      [91]: {
        tokenize: EP,
        continuation: {
          tokenize: TP
        },
        exit: vP
      }
    },
    text: {
      [91]: {
        tokenize: gP
      },
      [93]: {
        add: "after",
        tokenize: mP,
        resolveTo: pP
      }
    }
  };
}
function mP(e, t, n) {
  const r = this;
  let a = r.events.length;
  const i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o;
  for (; a--; ) {
    const u = r.events[a][1];
    if (u.type === "labelImage") {
      o = u;
      break;
    }
    if (u.type === "gfmFootnoteCall" || u.type === "labelLink" || u.type === "label" || u.type === "image" || u.type === "link")
      break;
  }
  return s;
  function s(u) {
    if (!o || !o._balanced)
      return n(u);
    const l = or(
      r.sliceSerialize({
        start: o.end,
        end: r.now()
      })
    );
    return l.codePointAt(0) !== 94 || !i.includes(l.slice(1)) ? n(u) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(u), e.exit("gfmFootnoteCallLabelMarker"), t(u));
  }
}
function pP(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n][1].type === "labelImage" && e[n][0] === "enter") {
      e[n][1];
      break;
    }
  e[n + 1][1].type = "data", e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[n + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, a = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[n + 3][1].end),
    end: Object.assign({}, e[n + 3][1].end)
  };
  a.end.column++, a.end.offset++, a.end._bufferIndex++;
  const i = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, a.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, o = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, i.start),
    end: Object.assign({}, i.end)
  }, s = [
    e[n + 1],
    e[n + 2],
    ["enter", r, t],
    e[n + 3],
    e[n + 4],
    ["enter", a, t],
    ["exit", a, t],
    ["enter", i, t],
    ["enter", o, t],
    ["exit", o, t],
    ["exit", i, t],
    e[e.length - 2],
    e[e.length - 1],
    ["exit", r, t]
  ];
  return e.splice(n, e.length - n + 1, ...s), e;
}
function gP(e, t, n) {
  const r = this, a = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let i = 0, o;
  return s;
  function s(f) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(f), e.exit("gfmFootnoteCallLabelMarker"), u;
  }
  function u(f) {
    return f !== 94 ? n(f) : (e.enter("gfmFootnoteCallMarker"), e.consume(f), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", l);
  }
  function l(f) {
    if (i > 999 || f === 93 && !o || f === null || f === 91 || kt(f))
      return n(f);
    if (f === 93) {
      e.exit("chunkString");
      const E = e.exit("gfmFootnoteCallString");
      return a.includes(or(r.sliceSerialize(E))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(f), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(f);
    }
    return kt(f) || (o = !0), i++, e.consume(f), f === 92 ? c : l;
  }
  function c(f) {
    return f === 91 || f === 92 || f === 93 ? (e.consume(f), i++, l) : l(f);
  }
}
function EP(e, t, n) {
  const r = this, a = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let i, o = 0, s;
  return u;
  function u(g) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(g), e.exit("gfmFootnoteDefinitionLabelMarker"), l;
  }
  function l(g) {
    return g === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(g), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", c) : n(g);
  }
  function c(g) {
    if (o > 999 || g === 93 && !s || g === null || g === 91 || kt(g))
      return n(g);
    if (g === 93) {
      e.exit("chunkString");
      const m = e.exit("gfmFootnoteDefinitionLabelString");
      return i = or(r.sliceSerialize(m)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(g), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), E;
    }
    return kt(g) || (s = !0), o++, e.consume(g), g === 92 ? f : c;
  }
  function f(g) {
    return g === 91 || g === 92 || g === 93 ? (e.consume(g), o++, c) : c(g);
  }
  function E(g) {
    return g === 58 ? (e.enter("definitionMarker"), e.consume(g), e.exit("definitionMarker"), a.includes(i) || a.push(i), rt(
      e,
      T,
      "gfmFootnoteDefinitionWhitespace"
    )) : n(g);
  }
  function T(g) {
    return t(g);
  }
}
function TP(e, t, n) {
  return e.check(T1, t, e.attempt(hP, t, n));
}
function vP(e) {
  e.exit("gfmFootnoteDefinition");
}
function AP(e, t, n) {
  const r = this;
  return rt(
    e,
    a,
    "gfmFootnoteDefinitionIndent",
    4 + 1
  );
  function a(i) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "gfmFootnoteDefinitionIndent" && o[2].sliceSerialize(o[1], !0).length === 4 ? t(i) : n(i);
  }
}
function CP(e) {
  let n = (e || {}).singleTilde;
  const r = {
    tokenize: i,
    resolveAll: a
  };
  return n == null && (n = !0), {
    text: {
      [126]: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function a(o, s) {
    let u = -1;
    for (; ++u < o.length; )
      if (o[u][0] === "enter" && o[u][1].type === "strikethroughSequenceTemporary" && o[u][1]._close) {
        let l = u;
        for (; l--; )
          if (o[l][0] === "exit" && o[l][1].type === "strikethroughSequenceTemporary" && o[l][1]._open && o[u][1].end.offset - o[u][1].start.offset === o[l][1].end.offset - o[l][1].start.offset) {
            o[u][1].type = "strikethroughSequence", o[l][1].type = "strikethroughSequence";
            const c = {
              type: "strikethrough",
              start: Object.assign({}, o[l][1].start),
              end: Object.assign({}, o[u][1].end)
            }, f = {
              type: "strikethroughText",
              start: Object.assign({}, o[l][1].end),
              end: Object.assign({}, o[u][1].start)
            }, E = [
              ["enter", c, s],
              ["enter", o[l][1], s],
              ["exit", o[l][1], s],
              ["enter", f, s]
            ], T = s.parser.constructs.insideSpan.null;
            T && Rn(
              E,
              E.length,
              0,
              Qo(T, o.slice(l + 1, u), s)
            ), Rn(E, E.length, 0, [
              ["exit", f, s],
              ["enter", o[u][1], s],
              ["exit", o[u][1], s],
              ["exit", c, s]
            ]), Rn(o, l - 1, u - l + 3, E), u = l + E.length - 2;
            break;
          }
      }
    for (u = -1; ++u < o.length; )
      o[u][1].type === "strikethroughSequenceTemporary" && (o[u][1].type = "data");
    return o;
  }
  function i(o, s, u) {
    const l = this.previous, c = this.events;
    let f = 0;
    return E;
    function E(g) {
      return l === 126 && c[c.length - 1][1].type !== "characterEscape" ? u(g) : (o.enter("strikethroughSequenceTemporary"), T(g));
    }
    function T(g) {
      const m = So(l);
      if (g === 126)
        return f > 1 ? u(g) : (o.consume(g), f++, T);
      if (f < 2 && !n)
        return u(g);
      const v = o.exit("strikethroughSequenceTemporary"), b = So(g);
      return v._open = !b || b === 2 && Boolean(m), v._close = !m || m === 2 && Boolean(b), s(g);
    }
  }
}
class _P {
  constructor() {
    this.map = [];
  }
  add(t, n, r) {
    bP(this, t, n, r);
  }
  consume(t) {
    if (this.map.sort((i, o) => i[0] - o[0]), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(t.slice(this.map[n][0] + this.map[n][1])), r.push(this.map[n][2]), t.length = this.map[n][0];
    r.push([...t]), t.length = 0;
    let a = r.pop();
    for (; a; )
      t.push(...a), a = r.pop();
    this.map.length = 0;
  }
}
function bP(e, t, n, r) {
  let a = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; a < e.map.length; ) {
      if (e.map[a][0] === t) {
        e.map[a][1] += n, e.map[a][2].push(...r);
        return;
      }
      a += 1;
    }
    e.map.push([t, n, r]);
  }
}
function yP(e, t) {
  let n = !1;
  const r = [];
  for (; t < e.length; ) {
    const a = e[t];
    if (n) {
      if (a[0] === "enter")
        a[1].type === "tableContent" && r.push(
          e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none"
        );
      else if (a[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const i = r.length - 1;
          r[i] = r[i] === "left" ? "center" : "right";
        }
      } else if (a[1].type === "tableDelimiterRow")
        break;
    } else
      a[0] === "enter" && a[1].type === "tableDelimiterRow" && (n = !0);
    t += 1;
  }
  return r;
}
const DP = {
  flow: {
    null: {
      tokenize: SP,
      resolveAll: OP
    }
  }
};
function SP(e, t, n) {
  const r = this;
  let a = 0, i = 0, o;
  return s;
  function s(w) {
    let Y = r.events.length - 1;
    for (; Y > -1; ) {
      const $ = r.events[Y][1].type;
      if ($ === "lineEnding" || $ === "linePrefix")
        Y--;
      else
        break;
    }
    const X = Y > -1 ? r.events[Y][1].type : null, H = X === "tableHead" || X === "tableRow" ? C : u;
    return H === C && r.parser.lazy[r.now().line] ? n(w) : H(w);
  }
  function u(w) {
    return e.enter("tableHead"), e.enter("tableRow"), l(w);
  }
  function l(w) {
    return w === 124 || (o = !0, i += 1), c(w);
  }
  function c(w) {
    return w === null ? n(w) : Be(w) ? i > 1 ? (i = 0, r.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(w), e.exit("lineEnding"), T) : n(w) : It(w) ? rt(e, c, "whitespace")(w) : (i += 1, o && (o = !1, a += 1), w === 124 ? (e.enter("tableCellDivider"), e.consume(w), e.exit("tableCellDivider"), o = !0, c) : (e.enter("data"), f(w)));
  }
  function f(w) {
    return w === null || w === 124 || kt(w) ? (e.exit("data"), c(w)) : (e.consume(w), w === 92 ? E : f);
  }
  function E(w) {
    return w === 92 || w === 124 ? (e.consume(w), f) : f(w);
  }
  function T(w) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(w) : (e.enter("tableDelimiterRow"), o = !1, It(w) ? rt(
      e,
      g,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(w) : g(w));
  }
  function g(w) {
    return w === 45 || w === 58 ? v(w) : w === 124 ? (o = !0, e.enter("tableCellDivider"), e.consume(w), e.exit("tableCellDivider"), m) : S(w);
  }
  function m(w) {
    return It(w) ? rt(e, v, "whitespace")(w) : v(w);
  }
  function v(w) {
    return w === 58 ? (i += 1, o = !0, e.enter("tableDelimiterMarker"), e.consume(w), e.exit("tableDelimiterMarker"), b) : w === 45 ? (i += 1, b(w)) : w === null || Be(w) ? B(w) : S(w);
  }
  function b(w) {
    return w === 45 ? (e.enter("tableDelimiterFiller"), y(w)) : S(w);
  }
  function y(w) {
    return w === 45 ? (e.consume(w), y) : w === 58 ? (o = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(w), e.exit("tableDelimiterMarker"), O) : (e.exit("tableDelimiterFiller"), O(w));
  }
  function O(w) {
    return It(w) ? rt(e, B, "whitespace")(w) : B(w);
  }
  function B(w) {
    return w === 124 ? g(w) : w === null || Be(w) ? !o || a !== i ? S(w) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(w)) : S(w);
  }
  function S(w) {
    return n(w);
  }
  function C(w) {
    return e.enter("tableRow"), I(w);
  }
  function I(w) {
    return w === 124 ? (e.enter("tableCellDivider"), e.consume(w), e.exit("tableCellDivider"), I) : w === null || Be(w) ? (e.exit("tableRow"), t(w)) : It(w) ? rt(e, I, "whitespace")(w) : (e.enter("data"), G(w));
  }
  function G(w) {
    return w === null || w === 124 || kt(w) ? (e.exit("data"), I(w)) : (e.consume(w), w === 92 ? V : G);
  }
  function V(w) {
    return w === 92 || w === 124 ? (e.consume(w), G) : G(w);
  }
}
function OP(e, t) {
  let n = -1, r = !0, a = 0, i = [0, 0, 0, 0], o = [0, 0, 0, 0], s = !1, u = 0, l, c, f;
  const E = new _P();
  for (; ++n < e.length; ) {
    const T = e[n], g = T[1];
    T[0] === "enter" ? g.type === "tableHead" ? (s = !1, u !== 0 && (M9(E, t, u, l, c), c = void 0, u = 0), l = {
      type: "table",
      start: Object.assign({}, g.start),
      end: Object.assign({}, g.end)
    }, E.add(n, 0, [["enter", l, t]])) : g.type === "tableRow" || g.type === "tableDelimiterRow" ? (r = !0, f = void 0, i = [0, 0, 0, 0], o = [0, n + 1, 0, 0], s && (s = !1, c = {
      type: "tableBody",
      start: Object.assign({}, g.start),
      end: Object.assign({}, g.end)
    }, E.add(n, 0, [["enter", c, t]])), a = g.type === "tableDelimiterRow" ? 2 : c ? 3 : 1) : a && (g.type === "data" || g.type === "tableDelimiterMarker" || g.type === "tableDelimiterFiller") ? (r = !1, o[2] === 0 && (i[1] !== 0 && (o[0] = o[1], f = eo(
      E,
      t,
      i,
      a,
      void 0,
      f
    ), i = [0, 0, 0, 0]), o[2] = n)) : g.type === "tableCellDivider" && (r ? r = !1 : (i[1] !== 0 && (o[0] = o[1], f = eo(
      E,
      t,
      i,
      a,
      void 0,
      f
    )), i = o, o = [i[1], n, 0, 0])) : g.type === "tableHead" ? (s = !0, u = n) : g.type === "tableRow" || g.type === "tableDelimiterRow" ? (u = n, i[1] !== 0 ? (o[0] = o[1], f = eo(
      E,
      t,
      i,
      a,
      n,
      f
    )) : o[1] !== 0 && (f = eo(E, t, o, a, n, f)), a = 0) : a && (g.type === "data" || g.type === "tableDelimiterMarker" || g.type === "tableDelimiterFiller") && (o[3] = n);
  }
  for (u !== 0 && M9(E, t, u, l, c), E.consume(t.events), n = -1; ++n < t.events.length; ) {
    const T = t.events[n];
    T[0] === "enter" && T[1].type === "table" && (T[1]._align = yP(t.events, n));
  }
  return e;
}
function eo(e, t, n, r, a, i) {
  const o = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", s = "tableContent";
  n[0] !== 0 && (i.end = Object.assign({}, Xa(t.events, n[0])), e.add(n[0], 0, [["exit", i, t]]));
  const u = Xa(t.events, n[1]);
  if (i = {
    type: o,
    start: Object.assign({}, u),
    end: Object.assign({}, u)
  }, e.add(n[1], 0, [["enter", i, t]]), n[2] !== 0) {
    const l = Xa(t.events, n[2]), c = Xa(t.events, n[3]), f = {
      type: s,
      start: Object.assign({}, l),
      end: Object.assign({}, c)
    };
    if (e.add(n[2], 0, [["enter", f, t]]), r !== 2) {
      const E = t.events[n[2]], T = t.events[n[3]];
      if (E[1].end = Object.assign({}, T[1].end), E[1].type = "chunkText", E[1].contentType = "text", n[3] > n[2] + 1) {
        const g = n[2] + 1, m = n[3] - n[2] - 1;
        e.add(g, m, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", f, t]]);
  }
  return a !== void 0 && (i.end = Object.assign({}, Xa(t.events, a)), e.add(a, 0, [["exit", i, t]]), i = void 0), i;
}
function M9(e, t, n, r, a) {
  const i = [], o = Xa(t.events, n);
  a && (a.end = Object.assign({}, o), i.push(["exit", a, t])), r.end = Object.assign({}, o), i.push(["exit", r, t]), e.add(n + 1, 0, i);
}
function Xa(e, t) {
  const n = e[t], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const NP = {
  tokenize: IP
}, wP = {
  text: {
    [91]: NP
  }
};
function IP(e, t, n) {
  const r = this;
  return a;
  function a(u) {
    return r.previous !== null || !r._gfmTasklistFirstContentOfListItem ? n(u) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), i);
  }
  function i(u) {
    return kt(u) ? (e.enter("taskListCheckValueUnchecked"), e.consume(u), e.exit("taskListCheckValueUnchecked"), o) : u === 88 || u === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(u), e.exit("taskListCheckValueChecked"), o) : n(u);
  }
  function o(u) {
    return u === 93 ? (e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), s) : n(u);
  }
  function s(u) {
    return Be(u) ? t(u) : It(u) ? e.check(
      {
        tokenize: RP
      },
      t,
      n
    )(u) : n(u);
  }
}
function RP(e, t, n) {
  return rt(e, r, "whitespace");
  function r(a) {
    return a === null ? n(a) : t(a);
  }
}
function MP(e) {
  return og([
    rP,
    dP(),
    CP(e),
    DP,
    wP
  ]);
}
function x9(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, a = n.indexOf(t);
  for (; a !== -1; )
    r++, a = n.indexOf(t, a + t.length);
  return r;
}
function xP(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const R2 = function(e) {
  if (e == null)
    return FP;
  if (typeof e == "string")
    return BP(e);
  if (typeof e == "object")
    return Array.isArray(e) ? kP(e) : PP(e);
  if (typeof e == "function")
    return us(e);
  throw new Error("Expected function, string, or object as test");
};
function kP(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = R2(e[n]);
  return us(r);
  function r(...a) {
    let i = -1;
    for (; ++i < t.length; )
      if (t[i].call(this, ...a))
        return !0;
    return !1;
  }
}
function PP(e) {
  return us(t);
  function t(n) {
    let r;
    for (r in e)
      if (n[r] !== e[r])
        return !1;
    return !0;
  }
}
function BP(e) {
  return us(t);
  function t(n) {
    return n && n.type === e;
  }
}
function us(e) {
  return t;
  function t(...n) {
    return Boolean(e.call(this, ...n));
  }
}
function FP() {
  return !0;
}
const LP = {}.hasOwnProperty, $P = function(e, t, n, r) {
  let a, i;
  typeof t == "string" || t instanceof RegExp ? (i = [[t, n]], a = r) : (i = t, a = n), a || (a = {});
  const o = R2(a.ignore || []), s = HP(i);
  let u = -1;
  for (; ++u < s.length; )
    Jo(e, "text", l);
  return e;
  function l(f, E) {
    let T = -1, g;
    for (; ++T < E.length; ) {
      const m = E[T];
      if (o(
        m,
        g ? g.children.indexOf(m) : void 0,
        g
      ))
        return;
      g = m;
    }
    if (g)
      return c(f, E);
  }
  function c(f, E) {
    const T = E[E.length - 1], g = s[u][0], m = s[u][1];
    let v = 0;
    const b = T.children.indexOf(f);
    let y = !1, O = [];
    g.lastIndex = 0;
    let B = g.exec(f.value);
    for (; B; ) {
      const S = B.index, C = {
        index: B.index,
        input: B.input,
        stack: [...E, f]
      };
      let I = m(...B, C);
      if (typeof I == "string" && (I = I.length > 0 ? { type: "text", value: I } : void 0), I !== !1 && (v !== S && O.push({
        type: "text",
        value: f.value.slice(v, S)
      }), Array.isArray(I) ? O.push(...I) : I && O.push(I), v = S + B[0].length, y = !0), !g.global)
        break;
      B = g.exec(f.value);
    }
    return y ? (v < f.value.length && O.push({ type: "text", value: f.value.slice(v) }), T.children.splice(b, 1, ...O)) : O = [f], b + O.length;
  }
};
function HP(e) {
  const t = [];
  if (typeof e != "object")
    throw new TypeError("Expected array or object as schema");
  if (Array.isArray(e)) {
    let n = -1;
    for (; ++n < e.length; )
      t.push([
        k9(e[n][0]),
        P9(e[n][1])
      ]);
  } else {
    let n;
    for (n in e)
      LP.call(e, n) && t.push([k9(n), P9(e[n])]);
  }
  return t;
}
function k9(e) {
  return typeof e == "string" ? new RegExp(xP(e), "g") : e;
}
function P9(e) {
  return typeof e == "function" ? e : () => e;
}
const Pu = "phrasing", Bu = ["autolink", "link", "image", "label"], UP = {
  transforms: [WP],
  enter: {
    literalAutolink: zP,
    literalAutolinkEmail: Fu,
    literalAutolinkHttp: Fu,
    literalAutolinkWww: Fu
  },
  exit: {
    literalAutolink: KP,
    literalAutolinkEmail: YP,
    literalAutolinkHttp: GP,
    literalAutolinkWww: VP
  }
}, jP = {
  unsafe: [
    {
      character: "@",
      before: "[+\\-.\\w]",
      after: "[\\-.\\w]",
      inConstruct: Pu,
      notInConstruct: Bu
    },
    {
      character: ".",
      before: "[Ww]",
      after: "[\\-.\\w]",
      inConstruct: Pu,
      notInConstruct: Bu
    },
    { character: ":", before: "[ps]", after: "\\/", inConstruct: Pu, notInConstruct: Bu }
  ]
};
function zP(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function Fu(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function GP(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function VP(e) {
  this.config.exit.data.call(this, e);
  const t = this.stack[this.stack.length - 1];
  t.url = "http://" + this.sliceSerialize(e);
}
function YP(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function KP(e) {
  this.exit(e);
}
function WP(e) {
  $P(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, qP],
      [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g, XP]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function qP(e, t, n, r, a) {
  let i = "";
  if (!M2(a) || (/^w/i.test(t) && (n = t + n, t = "", i = "http://"), !QP(n)))
    return !1;
  const o = ZP(n + r);
  if (!o[0])
    return !1;
  const s = {
    type: "link",
    title: null,
    url: i + t + o[0],
    children: [{ type: "text", value: t + o[0] }]
  };
  return o[1] ? [s, { type: "text", value: o[1] }] : s;
}
function XP(e, t, n, r) {
  return !M2(r, !0) || /[-\d_]$/.test(n) ? !1 : {
    type: "link",
    title: null,
    url: "mailto:" + t + "@" + n,
    children: [{ type: "text", value: t + "@" + n }]
  };
}
function QP(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function ZP(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let n = t[0], r = n.indexOf(")");
  const a = x9(e, "(");
  let i = x9(e, ")");
  for (; r !== -1 && a > i; )
    e += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), i++;
  return [e, n];
}
function M2(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || Da(n) || Xo(n)) && (!t || n !== 47);
}
function x2(e) {
  return e.label || !e.identifier ? e.label || "" : Eg(e.identifier);
}
function ta(e) {
  const t = e || {}, n = t.now || {};
  let r = t.lineShift || 0, a = n.line || 1, i = n.column || 1;
  return { move: u, current: o, shift: s };
  function o() {
    return { now: { line: a, column: i }, lineShift: r };
  }
  function s(l) {
    r += l;
  }
  function u(l = "") {
    const c = l.split(/\r?\n|\r/g), f = c[c.length - 1];
    return a += c.length - 1, i = c.length === 1 ? i + f.length : 1 + f.length + r, l;
  }
}
function k2(e, t, n) {
  const r = t.indexStack, a = e.children || [], i = ta(n), o = [];
  let s = -1;
  for (r.push(-1); ++s < a.length; ) {
    const l = a[s];
    r[r.length - 1] = s, o.push(
      i.move(
        t.handle(l, e, t, {
          before: `
`,
          after: `
`,
          ...i.current()
        })
      )
    ), l.type !== "list" && (t.bulletLastUsed = void 0), s < a.length - 1 && o.push(i.move(u(l, a[s + 1])));
  }
  return r.pop(), o.join("");
  function u(l, c) {
    let f = t.join.length;
    for (; f--; ) {
      const E = t.join[f](l, c, e, t);
      if (E === !0 || E === 1)
        break;
      if (typeof E == "number")
        return `
`.repeat(1 + E);
      if (E === !1)
        return `

<!---->

`;
    }
    return `

`;
  }
}
const JP = /\r?\n|\r/g;
function P2(e, t) {
  const n = [];
  let r = 0, a = 0, i;
  for (; i = JP.exec(e); )
    o(e.slice(r, i.index)), n.push(i[0]), r = i.index + i[0].length, a++;
  return o(e.slice(r)), n.join("");
  function o(s) {
    n.push(t(s, a, !s));
  }
}
function B2(e) {
  if (!e._compiled) {
    const t = (e.atBreak ? "[\\r\\n][\\t ]*" : "") + (e.before ? "(?:" + e.before + ")" : "");
    e._compiled = new RegExp(
      (t ? "(" + t + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(e.character) ? "\\" : "") + e.character + (e.after ? "(?:" + e.after + ")" : ""),
      "g"
    );
  }
  return e._compiled;
}
function eB(e, t) {
  return B9(e, t.inConstruct, !0) && !B9(e, t.notInConstruct, !1);
}
function B9(e, t, n) {
  if (!t)
    return n;
  typeof t == "string" && (t = [t]);
  let r = -1;
  for (; ++r < t.length; )
    if (e.includes(t[r]))
      return !0;
  return !1;
}
function F2(e, t, n) {
  const r = (n.before || "") + (t || "") + (n.after || ""), a = [], i = [], o = {};
  let s = -1;
  for (; ++s < e.unsafe.length; ) {
    const c = e.unsafe[s];
    if (!eB(e.stack, c))
      continue;
    const f = B2(c);
    let E;
    for (; E = f.exec(r); ) {
      const T = "before" in c || Boolean(c.atBreak), g = "after" in c, m = E.index + (T ? E[1].length : 0);
      a.includes(m) ? (o[m].before && !T && (o[m].before = !1), o[m].after && !g && (o[m].after = !1)) : (a.push(m), o[m] = { before: T, after: g });
    }
  }
  a.sort(tB);
  let u = n.before ? n.before.length : 0;
  const l = r.length - (n.after ? n.after.length : 0);
  for (s = -1; ++s < a.length; ) {
    const c = a[s];
    c < u || c >= l || c + 1 < l && a[s + 1] === c + 1 && o[c].after && !o[c + 1].before && !o[c + 1].after || a[s - 1] === c - 1 && o[c].before && !o[c - 1].before && !o[c - 1].after || (u !== c && i.push(F9(r.slice(u, c), "\\")), u = c, /[!-/:-@[-`{-~]/.test(r.charAt(c)) && (!n.encode || !n.encode.includes(r.charAt(c))) ? i.push("\\") : (i.push(
      "&#x" + r.charCodeAt(c).toString(16).toUpperCase() + ";"
    ), u++));
  }
  return i.push(F9(r.slice(u, l), n.after)), i.join("");
}
function tB(e, t) {
  return e - t;
}
function F9(e, t) {
  const n = /\\(?=[!-/:-@[-`{-~])/g, r = [], a = [], i = e + t;
  let o = -1, s = 0, u;
  for (; u = n.exec(i); )
    r.push(u.index);
  for (; ++o < r.length; )
    s !== r[o] && a.push(e.slice(s, r[o])), a.push("\\"), s = r[o];
  return a.push(e.slice(s)), a.join("");
}
L2.peek = hB;
function nB() {
  return {
    enter: {
      gfmFootnoteDefinition: aB,
      gfmFootnoteDefinitionLabelString: iB,
      gfmFootnoteCall: uB,
      gfmFootnoteCallString: lB
    },
    exit: {
      gfmFootnoteDefinition: sB,
      gfmFootnoteDefinitionLabelString: oB,
      gfmFootnoteCall: fB,
      gfmFootnoteCallString: cB
    }
  };
}
function rB() {
  return {
    unsafe: [{ character: "[", inConstruct: ["phrasing", "label", "reference"] }],
    handlers: { footnoteDefinition: dB, footnoteReference: L2 }
  };
}
function aB(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function iB() {
  this.buffer();
}
function oB(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.label = t, n.identifier = or(
    this.sliceSerialize(e)
  ).toLowerCase();
}
function sB(e) {
  this.exit(e);
}
function uB(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function lB() {
  this.buffer();
}
function cB(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.label = t, n.identifier = or(
    this.sliceSerialize(e)
  ).toLowerCase();
}
function fB(e) {
  this.exit(e);
}
function L2(e, t, n, r) {
  const a = ta(r);
  let i = a.move("[^");
  const o = n.enter("footnoteReference"), s = n.enter("reference");
  return i += a.move(
    F2(n, x2(e), {
      ...a.current(),
      before: i,
      after: "]"
    })
  ), s(), o(), i += a.move("]"), i;
}
function hB() {
  return "[";
}
function dB(e, t, n, r) {
  const a = ta(r);
  let i = a.move("[^");
  const o = n.enter("footnoteDefinition"), s = n.enter("label");
  return i += a.move(
    F2(n, x2(e), {
      ...a.current(),
      before: i,
      after: "]"
    })
  ), s(), i += a.move(
    "]:" + (e.children && e.children.length > 0 ? " " : "")
  ), a.shift(4), i += a.move(
    P2(k2(e, n, a.current()), mB)
  ), o(), i;
}
function mB(e, t, n) {
  return t === 0 ? e : (n ? "" : "    ") + e;
}
function $2(e, t, n) {
  const r = t.indexStack, a = e.children || [], i = [];
  let o = -1, s = n.before;
  r.push(-1);
  let u = ta(n);
  for (; ++o < a.length; ) {
    const l = a[o];
    let c;
    if (r[r.length - 1] = o, o + 1 < a.length) {
      let f = t.handle.handlers[a[o + 1].type];
      f && f.peek && (f = f.peek), c = f ? f(a[o + 1], e, t, {
        before: "",
        after: "",
        ...u.current()
      }).charAt(0) : "";
    } else
      c = n.after;
    i.length > 0 && (s === "\r" || s === `
`) && l.type === "html" && (i[i.length - 1] = i[i.length - 1].replace(
      /(\r?\n|\r)$/,
      " "
    ), s = " ", u = ta(n), u.move(i.join(""))), i.push(
      u.move(
        t.handle(l, e, t, {
          ...u.current(),
          before: s,
          after: c
        })
      )
    ), s = i[i.length - 1].slice(-1);
  }
  return r.pop(), i.join("");
}
const pB = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
H2.peek = AB;
const gB = {
  canContainEols: ["delete"],
  enter: { strikethrough: TB },
  exit: { strikethrough: vB }
}, EB = {
  unsafe: [
    {
      character: "~",
      inConstruct: "phrasing",
      notInConstruct: pB
    }
  ],
  handlers: { delete: H2 }
};
function TB(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function vB(e) {
  this.exit(e);
}
function H2(e, t, n, r) {
  const a = ta(r), i = n.enter("strikethrough");
  let o = a.move("~~");
  return o += $2(e, n, {
    ...a.current(),
    before: o,
    after: "~"
  }), o += a.move("~~"), i(), o;
}
function AB() {
  return "~";
}
U2.peek = CB;
function U2(e, t, n) {
  let r = e.value || "", a = "`", i = -1;
  for (; new RegExp("(^|[^`])" + a + "([^`]|$)").test(r); )
    a += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++i < n.unsafe.length; ) {
    const o = n.unsafe[i], s = B2(o);
    let u;
    if (!!o.atBreak)
      for (; u = s.exec(r); ) {
        let l = u.index;
        r.charCodeAt(l) === 10 && r.charCodeAt(l - 1) === 13 && l--, r = r.slice(0, l) + " " + r.slice(u.index + 1);
      }
  }
  return a + r + a;
}
function CB() {
  return "`";
}
function _B(e, t = {}) {
  const n = (t.align || []).concat(), r = t.stringLength || yB, a = [], i = [], o = [], s = [];
  let u = 0, l = -1;
  for (; ++l < e.length; ) {
    const g = [], m = [];
    let v = -1;
    for (e[l].length > u && (u = e[l].length); ++v < e[l].length; ) {
      const b = bB(e[l][v]);
      if (t.alignDelimiters !== !1) {
        const y = r(b);
        m[v] = y, (s[v] === void 0 || y > s[v]) && (s[v] = y);
      }
      g.push(b);
    }
    i[l] = g, o[l] = m;
  }
  let c = -1;
  if (typeof n == "object" && "length" in n)
    for (; ++c < u; )
      a[c] = L9(n[c]);
  else {
    const g = L9(n);
    for (; ++c < u; )
      a[c] = g;
  }
  c = -1;
  const f = [], E = [];
  for (; ++c < u; ) {
    const g = a[c];
    let m = "", v = "";
    g === 99 ? (m = ":", v = ":") : g === 108 ? m = ":" : g === 114 && (v = ":");
    let b = t.alignDelimiters === !1 ? 1 : Math.max(
      1,
      s[c] - m.length - v.length
    );
    const y = m + "-".repeat(b) + v;
    t.alignDelimiters !== !1 && (b = m.length + b + v.length, b > s[c] && (s[c] = b), E[c] = b), f[c] = y;
  }
  i.splice(1, 0, f), o.splice(1, 0, E), l = -1;
  const T = [];
  for (; ++l < i.length; ) {
    const g = i[l], m = o[l];
    c = -1;
    const v = [];
    for (; ++c < u; ) {
      const b = g[c] || "";
      let y = "", O = "";
      if (t.alignDelimiters !== !1) {
        const B = s[c] - (m[c] || 0), S = a[c];
        S === 114 ? y = " ".repeat(B) : S === 99 ? B % 2 ? (y = " ".repeat(B / 2 + 0.5), O = " ".repeat(B / 2 - 0.5)) : (y = " ".repeat(B / 2), O = y) : O = " ".repeat(B);
      }
      t.delimiterStart !== !1 && !c && v.push("|"), t.padding !== !1 && !(t.alignDelimiters === !1 && b === "") && (t.delimiterStart !== !1 || c) && v.push(" "), t.alignDelimiters !== !1 && v.push(y), v.push(b), t.alignDelimiters !== !1 && v.push(O), t.padding !== !1 && v.push(" "), (t.delimiterEnd !== !1 || c !== u - 1) && v.push("|");
    }
    T.push(
      t.delimiterEnd === !1 ? v.join("").replace(/ +$/, "") : v.join("")
    );
  }
  return T.join(`
`);
}
function bB(e) {
  return e == null ? "" : String(e);
}
function yB(e) {
  return e.length;
}
function L9(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
const DB = {
  enter: {
    table: SB,
    tableData: $9,
    tableHeader: $9,
    tableRow: NB
  },
  exit: {
    codeText: wB,
    table: OB,
    tableData: Lu,
    tableHeader: Lu,
    tableRow: Lu
  }
};
function SB(e) {
  const t = e._align;
  this.enter(
    {
      type: "table",
      align: t.map((n) => n === "none" ? null : n),
      children: []
    },
    e
  ), this.setData("inTable", !0);
}
function OB(e) {
  this.exit(e), this.setData("inTable");
}
function NB(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function Lu(e) {
  this.exit(e);
}
function $9(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function wB(e) {
  let t = this.resume();
  this.getData("inTable") && (t = t.replace(/\\([\\|])/g, IB));
  const n = this.stack[this.stack.length - 1];
  n.value = t, this.exit(e);
}
function IB(e, t) {
  return t === "|" ? t : e;
}
function RB(e) {
  const t = e || {}, n = t.tableCellPadding, r = t.tablePipeAlign, a = t.stringLength, i = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      { atBreak: !0, character: "|", after: "[	 :-]" },
      { character: "|", inConstruct: "tableCell" },
      { atBreak: !0, character: ":", after: "-" },
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      table: o,
      tableRow: s,
      tableCell: u,
      inlineCode: E
    }
  };
  function o(T, g, m, v) {
    return l(
      c(T, m, v),
      T.align
    );
  }
  function s(T, g, m, v) {
    const b = f(T, m, v), y = l([b]);
    return y.slice(0, y.indexOf(`
`));
  }
  function u(T, g, m, v) {
    const b = m.enter("tableCell"), y = m.enter("phrasing"), O = $2(T, m, {
      ...v,
      before: i,
      after: i
    });
    return y(), b(), O;
  }
  function l(T, g) {
    return _B(T, {
      align: g,
      alignDelimiters: r,
      padding: n,
      stringLength: a
    });
  }
  function c(T, g, m) {
    const v = T.children;
    let b = -1;
    const y = [], O = g.enter("table");
    for (; ++b < v.length; )
      y[b] = f(
        v[b],
        g,
        m
      );
    return O(), y;
  }
  function f(T, g, m) {
    const v = T.children;
    let b = -1;
    const y = [], O = g.enter("tableRow");
    for (; ++b < v.length; )
      y[b] = u(
        v[b],
        T,
        g,
        m
      );
    return O(), y;
  }
  function E(T, g, m) {
    let v = U2(T, g, m);
    return m.stack.includes("tableCell") && (v = v.replace(/\|/g, "\\$&")), v;
  }
}
function MB(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function xB(e) {
  const t = e.options.listItemIndent || "tab";
  if (t === 1 || t === "1")
    return "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function kB(e, t, n, r) {
  const a = xB(n);
  let i = n.bulletCurrent || MB(n);
  t && t.type === "list" && t.ordered && (i = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + i);
  let o = i.length + 1;
  (a === "tab" || a === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (o = Math.ceil(o / 4) * 4);
  const s = ta(r);
  s.move(i + " ".repeat(o - i.length)), s.shift(o);
  const u = n.enter("listItem"), l = P2(
    k2(e, n, s.current()),
    c
  );
  return u(), l;
  function c(f, E, T) {
    return E ? (T ? "" : " ".repeat(o)) + f : (T ? i : i + " ".repeat(o - i.length)) + f;
  }
}
const PB = {
  exit: {
    taskListCheckValueChecked: H9,
    taskListCheckValueUnchecked: H9,
    paragraph: FB
  }
}, BB = {
  unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
  handlers: { listItem: LB }
};
function H9(e) {
  const t = this.stack[this.stack.length - 2];
  t.checked = e.type === "taskListCheckValueChecked";
}
function FB(e) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = this.stack[this.stack.length - 1], r = n.children[0];
    if (r && r.type === "text") {
      const a = t.children;
      let i = -1, o;
      for (; ++i < a.length; ) {
        const s = a[i];
        if (s.type === "paragraph") {
          o = s;
          break;
        }
      }
      o === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(e);
}
function LB(e, t, n, r) {
  const a = e.children[0], i = typeof e.checked == "boolean" && a && a.type === "paragraph", o = "[" + (e.checked ? "x" : " ") + "] ", s = ta(r);
  i && s.move(o);
  let u = kB(e, t, n, {
    ...r,
    ...s.current()
  });
  return i && (u = u.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, l)), u;
  function l(c) {
    return c + o;
  }
}
function $B() {
  return [
    UP,
    nB(),
    gB,
    DB,
    PB
  ];
}
function HB(e) {
  return {
    extensions: [
      jP,
      rB(),
      EB,
      RB(e),
      BB
    ]
  };
}
function UB(e = {}) {
  const t = this.data();
  n("micromarkExtensions", MP(e)), n("fromMarkdownExtensions", $B()), n("toMarkdownExtensions", HB(e));
  function n(r, a) {
    (t[r] ? t[r] : t[r] = []).push(a);
  }
}
const j2 = Me(jg, {
  blockquote: {
    marginLeft: 0,
    paddingLeft: "$4",
    borderLeft: "3px solid $medGrey"
  },
  code: {
    color: "#e83e8c",
    whiteSpace: "pre-wrap"
  },
  p: {
    marginTop: 0,
    whiteSpace: "pre-wrap"
  },
  "img,video": {
    maxWidth: "100%",
    borderRadius: "$2",
    marginBottom: "$4"
  },
  "ol,ul": {
    paddingInlineStart: "$5"
  },
  "> *:first-child, blockquote>:first-child": {
    marginTop: 0
  },
  "> *:last-child, blockquote>:last-child": {
    marginBottom: 0
  }
});
j2.defaultProps = {
  rehypePlugins: [eP],
  remarkPlugins: [UB],
  linkTarget: "_blank"
};
const jB = ({
  text: e
}) => /* @__PURE__ */ me(di, {
  from: "system",
  children: /* @__PURE__ */ me(j2, {
    children: typeof e == "string" ? e : CO(e)
  })
}), ls = Lt(Pt.FEEDBACK), zB = Me(ls("div"), {
  display: "inline-flex",
  alignItems: "center",
  boxSizing: "border-box",
  marginTop: "8.5px"
}), GB = Me(ls("div", "description"), {
  color: "$darkGrey",
  marginRight: 4,
  lineHeight: 17,
  typo: {
    size: 12
  }
}), VB = Me(ls("div", "buttons"), {
  display: "flex",
  gap: 4
}), U9 = Me(ls("button", "button"), {
  display: "inline-flex",
  backgroundColor: "transparent",
  border: 0,
  borderRadius: "$round",
  width: 24,
  height: 24,
  padding: 0,
  margin: 0,
  cursor: "pointer",
  variants: {
    active: {
      false: {
        color: "rgb(115 115 118 / 85%)",
        "&:hover": {
          color: "rgb(115 115 118 / 100%)"
        }
      },
      true: {
        color: "$white",
        backgroundColor: "$primary"
      }
    },
    orientation: {
      positive: {
        transform: "none"
      },
      negative: {
        transform: "rotate(180deg)"
      }
    }
  },
  defaultVariants: {
    active: !1,
    orientation: "positive"
  }
}), YB = ({
  question: e = "Was this helpful?",
  onClick: t,
  ...n
}) => {
  const [r, a] = pn.useState(null), i = (o) => {
    o !== r && (t(o), a(o));
  };
  return /* @__PURE__ */ Rt(zB, {
    ...n,
    children: [/* @__PURE__ */ me(GB, {
      children: e
    }), /* @__PURE__ */ Rt(VB, {
      children: [/* @__PURE__ */ me(U9, {
        orientation: "positive",
        active: r === Yi.POSITIVE,
        onClick: () => i(Yi.POSITIVE),
        children: /* @__PURE__ */ me(ql, {
          width: "24px",
          height: "24px"
        })
      }), /* @__PURE__ */ me(U9, {
        orientation: "negative",
        active: r === Yi.NEGATIVE,
        onClick: () => i(Yi.NEGATIVE),
        children: /* @__PURE__ */ me(ql, {
          width: "24px",
          height: "24px"
        })
      })]
    })]
  });
}, KB = () => {
  const e = xo(Ko);
  return Rr(() => {
    e.setStatus(Ir.ENDED);
  }, []), null;
}, z2 = ({
  avatar: e,
  feedback: t,
  timestamp: n,
  message: r,
  withImage: a,
  children: i
}) => {
  const o = Mr(null), s = Mr(null);
  return !i && (r == null ? void 0 : r.type) === wn.END ? /* @__PURE__ */ me(KB, {}) : /* @__PURE__ */ Rt(ri, {
    children: [/* @__PURE__ */ me(Qp, {
      ref: s
    }), /* @__PURE__ */ Rt(pO, {
      ref: o,
      withImage: a,
      scrollable: (r == null ? void 0 : r.type) === wn.CAROUSEL,
      children: [/* @__PURE__ */ me(ea, {
        avatar: e
      }), /* @__PURE__ */ Rt(Zp, {
        children: [i != null ? i : Wc(r).with({
          type: wn.TEXT
        }, ({
          text: u
        }) => /* @__PURE__ */ me(jB, {
          text: u
        })).with({
          type: wn.IMAGE
        }, ({
          url: u
        }) => /* @__PURE__ */ me(Mc, {
          image: u
        })).with({
          type: wn.CARD
        }, (u) => /* @__PURE__ */ me(kc, {
          ...co(u, ["type"])
        })).with({
          type: wn.CAROUSEL
        }, (u) => /* @__PURE__ */ me(Ky, {
          ...co(u, ["type"]),
          containerRef: o,
          controlsRef: s
        })).otherwise(() => null), t && /* @__PURE__ */ me(YB, {
          ...t
        })]
      }), /* @__PURE__ */ me(ya, {
        value: n
      })]
    })]
  });
}, WB = ({
  feedback: e,
  avatar: t,
  timestamp: n,
  messages: r,
  actions: a = [],
  isLast: i,
  Message: o = z2
}) => {
  const s = xo(Ko), {
    showIndicator: u,
    visibleMessages: l,
    complete: c
  } = iO({
    messages: r,
    isLast: i
  });
  return Ip([u, c, l.length]), !r.length && !a.length ? null : /* @__PURE__ */ Rt(ri, {
    children: [l.map((f, E) => /* @__PURE__ */ me(o, {
      message: f,
      withImage: !u && E === l.length - 1,
      feedback: c && !u && E === l.length - 1 ? e : void 0,
      avatar: t,
      timestamp: n
    }, E)), i && c && !!a.length && /* @__PURE__ */ me(Xp, {
      children: a.map(({
        name: f,
        request: E
      }, T) => /* @__PURE__ */ me(Vn, {
        variant: "secondary",
        onClick: () => s == null ? void 0 : s.send(f, E),
        children: f
      }, T))
    }), u && /* @__PURE__ */ me(Jp, {
      avatar: t
    })]
  });
}, ar = Object.assign(WB, {
  Message: wn,
  Container: Qc,
  Controls: Qp,
  List: Zp,
  Actions: Xp,
  Indicator: Jp,
  SystemMessage: z2
}), G2 = Lt(Pt.TOOLTIP), V2 = Me(G2(Vn.Reset, "button"), {
  height: "$md",
  border: "1px solid $medGrey",
  borderTopColor: "rgba(223,223,223,0.5)",
  borderRadius: "$1",
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  typo: { weight: "$2" },
  color: "$primary",
  backgroundColor: "#fbfbfb"
}), Y2 = Me(G2("div"), {
  display: "inline-flex",
  flexDirection: "column",
  variants: {
    withAction: {
      true: {
        boxShadow: "0 1px 2px $shadow2",
        [`& ${di.Debug.Container}`]: {
          boxShadow: "none",
          borderBottom: 0,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }
}), qB = ({
  label: e,
  onClick: t,
  children: n,
  ...r
}) => /* @__PURE__ */ Rt(Y2, {
  withAction: !!e,
  children: [/* @__PURE__ */ me(di.Debug, {
    ...r,
    children: n
  }), e && /* @__PURE__ */ me(V2, {
    onClick: t,
    children: e
  })]
}), K2 = Object.assign(qB, {
  Button: V2,
  Container: Y2
}), Cf = Lt(Pt.USER_RESPONSE), W2 = Me(Cf("aside", "debug"), {
  typo: { size: "12px", height: "17px" },
  color: "$darkGrey",
  marginTop: "$2"
}), q2 = Me(Cf("div"), {
  display: "flex",
  flexDirection: "column",
  flexShrink: 0,
  alignItems: "flex-end",
  [`& ${di.Container}`]: {
    maxWidth: 282
  },
  [`& > ${K2.Container}`]: {
    marginTop: "$1"
  }
}), X2 = Me(Cf("div", "row"), {
  display: "flex",
  width: "100%",
  alignItems: "center",
  [`& ${ya.Container}`]: {
    flexGrow: 1,
    marginRight: 8,
    textAlign: "end",
    opacity: "0%",
    trans: ["opacity"]
  },
  [`&:hover ${ya.Container}`]: {
    opacity: "100%"
  }
}), XB = ({
  message: e,
  timestamp: t,
  debug: n
}) => {
  var r, a;
  return Ip(), /* @__PURE__ */ Rt(q2, {
    children: [/* @__PURE__ */ Rt(X2, {
      children: [/* @__PURE__ */ me(ya, {
        value: t
      }), /* @__PURE__ */ me(di, {
        from: "user",
        children: e
      })]
    }), n && /* @__PURE__ */ Rt(ri, {
      children: [/* @__PURE__ */ me(W2, {
        children: n.message
      }), n.reason && /* @__PURE__ */ me(K2, {
        label: (r = n.action) == null ? void 0 : r.label,
        onClick: (a = n.action) == null ? void 0 : a.onClick,
        orientation: "right",
        children: n.reason
      })]
    })]
  });
}, Zr = Object.assign(XB, {
  Container: q2,
  Debug: W2,
  Row: X2
}), $u = 10, QB = 12, Q2 = ({ distance: e = QB, duration: t, delay: n }) => ({
  opacity: 0,
  animation: [q9, lv(e)].map((r) => `${r} ${t}ms ease-out ${n}ms forwards`).join(", ")
}), Ai = Lt(Pt.CHAT), Mo = Me(Ai("div", "overlay"), {
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: "$shadow12"
}), Tc = Me(Ai("article"), {
  position: "relative",
  display: "flex",
  overflow: "hidden",
  flexDirection: "column",
  backgroundColor: "$white",
  [`& > ${Sp}`]: {
    margin: "auto"
  },
  [`& ${Dp.Container}`]: {
    animation: `${q9} 150ms ease forwards`
  },
  [`& ${_p.Container}`]: {
    ...Q2({ duration: 300, delay: 300 })
  },
  [`& ${Mo}`]: {
    opacity: 0,
    pointerEvents: "none",
    trans: ["opacity"]
  },
  [`& ${no.Container}`]: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    boxSizing: "border-box",
    paddingBottom: `calc($3 + ${$u}px)`,
    transition: `transform 320ms cubic-bezier(0.45, 1.29, 0.64, 1), ${t5(["box-shadow"], 300)}`,
    transform: `translateY(calc(100% + ${$u}px))`
  },
  variants: {
    withPrompt: {
      true: {
        [`& ${Mo}`]: {
          opacity: 1,
          zIndex: 2,
          pointerEvents: "auto"
        },
        [`& ${no.Container}`]: {
          zIndex: 3,
          transform: `translateY(${$u}px)`
        }
      },
      false: {
        [`& ${no.Container}`]: {
          boxShadow: "none"
        }
      }
    }
  }
}), Z2 = {
  display: "flex",
  justifyContent: "center",
  typo: { size: 12 },
  color: "$darkGrey"
}, _f = Me(Ai("div", "status"), {
  ...Z2
}), ZB = Me(Ai("span", "session-time"), {
  ...Z2,
  paddingBottom: "$3"
}), J2 = Me(Ai("main", "dialog"), {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  overflowY: "scroll",
  overflowX: "hidden",
  paddingBottom: "$3",
  [`
    & ${Zr.Container},
    & ${ar.List},
    & ${ar.Actions},
    & ${X5.Container}
  `]: {
    ...Q2({ duration: 150, delay: 0 })
  },
  [`
    & > ${Zr.Container},
    & > ${ar.Container}
  `]: {
    padding: "0 $5"
  },
  [`& > ${ar.Actions}`]: {
    padding: "0 $5 0 54px"
  },
  [`& ${ar.Container}`]: {
    marginBottom: "$1",
    "&:last-of-type": {
      marginBottom: 0
    }
  },
  [`& ${Zr.Container} + ${Zr.Container}`]: {
    marginTop: "$1"
  },
  [`
    & ${ar.Container} + ${Zr.Container},
    & ${ar.Actions} + ${Zr.Container},
    & ${Zr.Container} + ${ar.Controls} + ${ar.Container}
  `]: {
    marginTop: "$5"
  },
  [`& ${ya.Container}`]: { width: 50 },
  [`& ${_f}`]: {
    marginTop: "$3",
    marginBottom: 8
  }
}), e4 = Me(Ai("div", "spacer"), {
  flexGrow: 1
}), JB = ({
  hasEnded: e,
  title: t,
  image: n,
  avatar: r,
  description: a,
  startTime: i,
  isLoading: o,
  withWatermark: s,
  onMinimize: u,
  onEnd: l,
  onStart: c,
  onSend: f,
  children: E
}) => {
  const T = rD(i), g = Mr(null), [m, v] = En(!1), b = (O) => {
    e ? l == null || l(O) : v(!0);
  }, y = () => v(!1);
  return o ? /* @__PURE__ */ me(Tc, {
    children: /* @__PURE__ */ me(Sp, {})
  }) : /* @__PURE__ */ Rt(Tc, {
    withPrompt: m,
    children: [/* @__PURE__ */ me(Dp, {
      title: t,
      image: n,
      actions: [{
        svg: "minus",
        onClick: u
      }, {
        svg: "close",
        onClick: b
      }]
    }), /* @__PURE__ */ me(J2, {
      ref: g,
      children: /* @__PURE__ */ Rt(Py, {
        target: g,
        children: [/* @__PURE__ */ me(X5, {
          title: t,
          avatar: r,
          description: a
        }), /* @__PURE__ */ me(e4, {}), !!T && /* @__PURE__ */ me(ZB, {
          children: T
        }), E, e && /* @__PURE__ */ me(_f, {
          children: "You have ended the chat"
        })]
      })
    }), /* @__PURE__ */ me(_p, {
      withWatermark: s,
      hasEnded: e,
      onStart: c,
      onSend: f
    }), /* @__PURE__ */ me(Mo, {}), /* @__PURE__ */ me(no, {
      accept: {
        label: "End Chat",
        type: "warn",
        onClick: dp(l, y)
      },
      cancel: {
        label: "Cancel",
        onClick: y
      }
    })]
  });
}, t4 = Object.assign(R8(JB), {
  Container: Tc,
  Dialog: J2,
  Overlay: Mo,
  Spacer: e4,
  Status: _f
}), eF = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzYgMzYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPGcgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGgKICAgICAgICAgICAgZD0iTTE4LjAwMDA1MzMsNyBDMjQuNjI2NjMyOSw3IDMwLDExLjQ3ODkzMTIgMzAsMTYuOTk3NjkzMSBDMzAsMjIuNTE2MzYxNyAyNC42MjY2MzI5LDI2Ljk5NTMwNjIgMTguMDAwMDUzMywyNi45OTUzMDYyIEMxNy4xMjMzNTEsMjYuOTk3MTcyNCAxNi4yNDgzODEyLDI2LjkxNjkyNzEgMTUuMzg2NjA2LDI2Ljc1NTM2OTkgQzE0LjA0MDQxODgsMjcuNzQzMTA3OCAxMi41MzE1MTI1LDI4LjQ4NzMxMDIgMTAuOTI4NDA1MywyOC45NTQxMTk3IEMxMC40NTgzNDczLDI5LjA5MDM1MDIgOS45NTM0MTA0NywyOC45MTY2NjMgOS42NjY2MDk2NSwyOC41MTk5NjgyIEM5LjM3OTgyMjE2LDI4LjEyMzQwNjggOS4zNzI5NzE2OCwyNy41ODk0MTUyIDkuNjQ5NTIzNDIsMjcuMTg1NTIyNCBDMTAuMTUwNTU1MiwyNi41MTcyOTk4IDEwLjU1MTU4ODYsMjUuNzc5NjI4OSAxMC44NDAwMDIsMjQuOTk1NzAzNiBDNy45MzY1Mjg2LDIzLjM2MjQwMzggNi4xMDAxNTgzOCwyMC4zMjc4NzU5IDYsMTYuOTk3NjkzMSBDNiwxMS40Nzg5MTc5IDExLjM3MzMyNzEsNyAxOC4wMDAwNTMzLDcgWiBNMTguMDAwMDUzMywxOC4wMDIwOTMyIEwxNC4wMDAwODg5LDE4LjAwMjA5MzIgTDEzLjg2NDQ1MTEsMTguMDExMjE5NiBDMTMuMzc2NTUzMSwxOC4wNzc0MTg2IDEzLjAwMDUwNDIsMTguNDk1NzAxMiAxMy4wMDA1MDQyLDE5LjAwMTgyNzkgQzEzLjAwMDUwNDIsMTkuNTUzOTY2MSAxMy40NDgwMzM1LDIwLjAwMTU2MjUgMTQuMDAwMDg4OSwyMC4wMDE1NjI1IEwxOC4wMDAwNTMzLDIwLjAwMTU2MjUgTDE4LjEzNTY5MSwxOS45OTI0MzYxIEMxOC42MjM1ODksMTkuOTI2MjM3MSAxOC45OTk2Mzc5LDE5LjUwNzk1NDUgMTguOTk5NjM3OSwxOS4wMDE4Mjc5IEMxOC45OTk2Mzc5LDE4LjQ0OTY4OTYgMTguNTUyMTA4NywxOC4wMDIwOTMyIDE4LjAwMDA1MzMsMTguMDAyMDkzMiBaIE0yMi4wMDAxMjQ0LDE0LjAwMTUxNSBMMTQuMDAwMDg4OSwxNC4wMDE1MTUgTDEzLjg2NDQ1MTEsMTQuMDEwNjQxNCBDMTMuMzc2NTUzMSwxNC4wNzY4NDA0IDEzLjAwMDUwNDIsMTQuNDk1MTIzIDEzLjAwMDUwNDIsMTUuMDAxMjQ5NyBDMTMuMDAwNTA0MiwxNS41NTMzODc5IDEzLjQ0ODAzMzUsMTYuMDAwOTg0MyAxNC4wMDAwODg5LDE2LjAwMDk4NDMgTDIyLjAwMDEyNDQsMTYuMDAwOTg0MyBMMjIuMTM1NzYyMSwxNS45OTE4NTc5IEMyMi42MjM2NjAxLDE1LjkyNTY1ODkgMjIuOTk5NzA5LDE1LjUwNzM3NjQgMjIuOTk5NzA5LDE1LjAwMTI0OTcgQzIyLjk5OTcwOSwxNC40NDkxMTE1IDIyLjU1MjE3OTcsMTQuMDAxNTE1IDIyLjAwMDEyNDQsMTQuMDAxNTE1IFoiCiAgICAgICAgICAgIGZpbGw9IiNmZmZmZmYiPjwvcGF0aD4KICAgIDwvZz4KPC9zdmc+", tF = Lt(Pt.LAUNCHER), nF = Me(tF("button"), {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "$round",
  backgroundColor: "$primary",
  trans: ["background-color", "box-shadow"],
  height: "$xl",
  width: "$xl",
  border: "1px solid $shadow4",
  boxShadow: "0 1px 6px $shadow6, 0 2px 24px $shadow8",
  "&:focus": {
    outline: 0
  },
  "&:hover": {
    cursor: "pointer",
    backgroundColor: "$darkPrimary"
  },
  "& > img": {
    width: "$sm",
    height: "$sm"
  },
  padding: 0,
  margin: 0
}), n4 = ({
  image: e,
  onClick: t
}) => /* @__PURE__ */ me(nF, {
  onClick: t,
  children: /* @__PURE__ */ me("img", {
    src: e || eF,
    alt: "launch"
  })
}), rF = 380, aF = 800, bf = Lt(Pt.WIDGET), i1 = Me(bf("div", "chat"), {
  width: rF,
  overflow: "hidden",
  borderRadius: "$2",
  boxShadow: "0 2px 48px rgba(19,33,68,0.16), 0 0 0 1px $shadow4",
  height: "90%",
  maxHeight: aF,
  "@mobile": {
    position: "fixed",
    height: "unset",
    maxHeight: "unset",
    width: "unset",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    borderRadius: 0,
    boxShadow: "none"
  }
}), o1 = Me(bf("div", "launcher"), {}), j9 = {
  opacity: 1,
  pointerEvents: "auto",
  transform: "translateY(0%)",
  transition: "transform 300ms cubic-bezier(0, 0.95, 0.1, 1), opacity 150ms linear"
}, z9 = {
  opacity: 0,
  pointerEvents: "none",
  transform: "translateY(100%)",
  transition: "transform 300ms cubic-bezier(0.85, 0, 0.6, 1), opacity 150ms linear"
}, r4 = Me(bf("div"), {
  position: "fixed",
  inset: 0,
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  pointerEvents: "none",
  zIndex: 1e4,
  [`
    & > ${o1},
    & > ${i1}
  `]: {
    position: "absolute"
  },
  variants: {
    withChat: {
      true: {
        [`& > ${i1}`]: {
          ...j9
        },
        [`& > ${o1}`]: {
          ...z9
        }
      },
      false: {
        [`& > ${i1}`]: {
          ...z9
        },
        [`& > ${o1}`]: {
          ...j9
        }
      }
    },
    isHidden: {
      true: {
        display: "none"
      }
    }
  }
}), iF = ({
  children: e,
  chatAPI: t,
  sendMessage: n,
  assistant: r
}) => {
  var g;
  const [a, i] = En(!1), [o, s] = En(!1), u = ii(() => window.matchMedia("(max-width: 768px)").matches, []), l = n5(r);
  s1(jn.CLOSE, () => i(!1)), s1(jn.OPEN, () => i(!0));
  const c = pn.useCallback(() => n({
    type: jn.OPEN
  }), []), f = pn.useCallback(() => n({
    type: jn.CLOSE
  }), []);
  Rr(() => {
    if (!!bc(t))
      return Object.assign(t, {
        open: c,
        close: f,
        hide: () => s(!0),
        show: () => s(!1),
        interact: (m) => n({
          type: jn.INTERACT,
          payload: m
        })
      }), () => {
        Object.assign(t, {
          open: xi,
          hide: xi,
          show: xi,
          close: xi,
          interact: xi
        });
      };
  }, []);
  const E = (g = r == null ? void 0 : r.position) != null ? g : Po.ChatPosition.RIGHT, T = {
    bottom: r == null ? void 0 : r.spacing.bottom,
    [E]: r == null ? void 0 : r.spacing.side
  };
  return /* @__PURE__ */ Rt(r4, {
    withChat: a,
    isHidden: o,
    className: l,
    children: [!!r && /* @__PURE__ */ me(o1, {
      style: T,
      children: /* @__PURE__ */ me(n4, {
        onClick: c,
        image: r.launcher
      })
    }), /* @__PURE__ */ me(i1, {
      style: u ? {} : T,
      children: e
    })]
  });
}, pF = Object.assign(iF, {
  Launcher: n4,
  Container: r4,
  ChatContainer: i1,
  LauncherContainer: o1
});
const a4 = Me("div", {
  height: "100%",
  [`& ${t4.Container}`]: {
    height: "100%"
  }
}), vc = (e) => {
  const t = JSON.stringify(e);
  window.postMessage(t), window.parent.postMessage(t, "*");
}, oF = ({
  assistant: e,
  versionID: t,
  verify: n,
  user: r,
  url: a,
  session: i
}) => {
  const o = pa(() => vc({
    type: jn.CLOSE
  }), []), s = pa((T) => vc({
    type: jn.SAVE_SESSION,
    payload: T
  }), []), u = rO({
    versionID: t,
    verify: n,
    url: a,
    user: r,
    session: i,
    saveSession: s
  }, [n.projectID]);
  s1(jn.INTERACT, ({
    payload: T
  }) => u.interact(T)), s1(jn.OPEN, async () => {
    u.isStatus(Ir.IDLE) && await l();
  });
  const l = async () => {
    await u.launch();
  }, c = pa(() => {
    u.setStatus(Ir.ENDED), o();
  }, []), f = n5(e), E = pa((T) => {
    const g = u.session.turns[T - 1];
    return (g == null ? void 0 : g.type) === ti.USER ? g : null;
  }, [u.session.turns]);
  return /* @__PURE__ */ me(By, {
    ...u,
    children: /* @__PURE__ */ me(a4, {
      className: f,
      children: /* @__PURE__ */ Rt(t4, {
        title: e.title,
        description: e.description,
        image: e.image,
        avatar: e.avatar,
        withWatermark: e.watermark,
        startTime: u.session.startTime,
        hasEnded: u.isStatus(Ir.ENDED),
        isLoading: !u.session.turns.length,
        onStart: l,
        onEnd: c,
        onSend: u.reply,
        onMinimize: o,
        children: [u.session.turns.map((T, g) => Wc(T).with({
          type: ti.USER
        }, ({
          id: m,
          ...v
        }) => /* @__PURE__ */ Ac(Zr, {
          ...co(v, ["type"]),
          key: m
        })).with({
          type: ti.SYSTEM
        }, ({
          id: m,
          ...v
        }) => /* @__PURE__ */ me(ar, {
          ...co(v, ["type"]),
          feedback: e.feedback ? {
            onClick: (b) => {
              u.feedback(b, v.messages, E(g));
            }
          } : void 0,
          avatar: e.avatar,
          isLast: g === u.session.turns.length - 1
        }, m)).exhaustive()), u.indicator && /* @__PURE__ */ me(ar.Indicator, {
          avatar: e.avatar
        })]
      })
    })
  });
}, gF = Object.assign(oF, {
  sendMessage: vc,
  Container: a4
}), EF = Po.ChatPersistence, TF = Po.ChatPosition;
export {
  X5 as AssistantInfo,
  mF as AutoScrollConsumer,
  xc as AutoScrollContext,
  Py as AutoScrollProvider,
  ea as Avatar,
  Xl as Bubble,
  Vn as Button,
  kc as Card,
  Ky as Carousel,
  t4 as Chat,
  qy as ChatInput,
  EF as ChatPersistence,
  TF as ChatPosition,
  pF as ChatWidget,
  gF as ChatWindow,
  Yi as FeedbackName,
  _p as Footer,
  Dp as Header,
  zn as Icon,
  Mc as Image,
  Xi as Input,
  n4 as Launcher,
  dF as Listeners,
  Sp as Loader,
  j2 as Markdown,
  di as Message,
  hF as PostMessage,
  no as Prompt,
  Ko as RuntimeAPIContext,
  By as RuntimeAPIProvider,
  Ir as SessionStatus,
  ar as SystemResponse,
  jB as Text,
  ya as Timestamp,
  K2 as Tooltip,
  ti as TurnType,
  uO as TypingIndicator,
  Zr as UserResponse,
  dp as chain,
  lF as config,
  dv as createCustomTheme,
  t5 as createTransition,
  mo as cuid,
  q9 as fadeIn,
  fF as isEnumValue,
  bc as isObject,
  cF as keyframes,
  xi as noop,
  sv as pulse,
  uv as rotate,
  lv as shift,
  Me as styled,
  X9 as textOverflowStyles,
  Ip as useAutoScroll,
  aD as useDidUpdateEffect,
  rO as useRuntime,
  eO as useStateRef,
  n5 as useTheme
};
